// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family:
    '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',
    'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: auto;
}

body[data-lock-scrolling] {
  overflow-y: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

/* Common class */
.full-width {
  width: 100%;
}

.align-center {
  text-align: center;
}

.flex-align-center {
  display: flex;
  justify-content: center;
}

.clear {
  clear: both;
  display: block;
}

.card-title-green {
  color: var(--p-action-primary);
}

.text-disable {
  color: #8c9196;
}

.background-addon-unlock {
  background: #fff5ea;
  border: 1px solid #e1b878;
  border-radius: 4px;
}

.icon-warning .Polaris-Icon svg {
  fill: #ff9b10;
}

.btn-highlight button {
  animation: wiggle 4s 2s infinite;
}

.Polaris-Scrollable--hasBottomShadow {
  box-shadow: unset !important;
}

.hyperlink {
  position: relative;
  color: var(--p-interactive);
  cursor: pointer;
}

.hyperlink:has(img) {
  padding-right: 18px;
}

.hyperlink img {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

@keyframes wiggle {
  5%,
  50% {
    transform: scale(1);
  }

  10% {
    transform: scale(0.9);
    box-shadow:
      5px 5px 20px rgb(221, 221, 221),
      -5px -5px 20px rgb(244, 244, 244);
  }

  15% {
    transform: scale(1.15);
    box-shadow:
      5px 5px 20px rgb(192, 191, 191),
      -5px -5px 20px rgb(209, 208, 208);
  }

  20% {
    transform: scale(1.15) rotate(-5deg);
  }

  25% {
    transform: scale(1.15) rotate(5deg);
    box-shadow:
      5px 5px 20px rgb(186, 226, 201),
      -5px -5px 20px rgb(186, 226, 201);
  }

  30% {
    transform: scale(1.15) rotate(-3deg);
  }

  35% {
    transform: scale(1.15) rotate(2deg);
    box-shadow:
      5px 5px 20px rgb(140, 187, 157),
      -5px -5px 20px rgb(140, 187, 157);
  }

  40% {
    transform: scale(1.15) rotate(0);
    box-shadow:
      5px 5px 20px rgb(140, 187, 157),
      -5px -5px 20px rgb(140, 187, 157);
  }
}

.recommendation-collapse .Polaris-DataTable__Cell--status .Polaris-Tooltip-TooltipOverlay__Content {
  max-width: 21rem;
}

.card-title {
  margin: 0.25rem 0 1.5rem;
}

.backdrop-custom {
  position: fixed;
  z-index: -1;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  background-color: rgba(0, 0, 0, 0.2);
  animation: var(--p-keyframes-fade-in) var(--p-duration-200) 1 forwards;
  opacity: 0;
}

.datetime-picker-input {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-self: center;
  width: 100%;
}

.datetime-picker-input > div {
  width: 50%;
}

/* Css for product tour */
.custom-btn-tour {
  position: relative;
  position: static;
  min-width: 64px;
  height: 36px;
  font-size: 0.875rem;
  border-radius: 4px;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 5px;
  font-weight: 500;
}

.custom-btn-action {
  background-color: #008060;
  border-color: transparent;
  color: white;
}

.custom-btn-tour:hover,
.custom-btn-action:hover {
  cursor: pointer;
}

.custom-btn-learn-more {
  border: 0.0625rem solid rgb(202, 200, 200);
  background: #ffffff;
  min-width: 105px;
  margin-right: 10px !important;
}

.custom-btn-back {
  border: 0.0625rem solid rgb(202, 200, 200);
  background: #ffffff;
}

.product-tour-step0 div[data-tour-elem='controls'],
.product-tour-step1 div[data-tour-elem='controls'],
.product-tour div[data-tour-elem='controls'] {
  margin-top: 0px !important;
  width: max-content;
  margin-left: auto;
  margin-right: 8px;
}

.product-tour-step0 div[data-tour-elem='controls'] > button,
.product-tour-step1 div[data-tour-elem='controls'] > button,
.product-tour div[data-tour-elem='controls'] > button {
  margin-right: 3px;
  margin-left: 3px;
}

.product-tour-step0,
.product-tour-step1,
.product-tour {
  --reactour-accent: #5cb7b7;
  line-height: 1.3;
  color: rgb(132 85 144 / 11%);
}

.product-tour-step0 .reactour__close,
.product-tour-step1 .reactour__close,
.product-tour .reactour__close {
  width: 12px;
  height: 25px;
}

#___reactour rect {
  color: #202123;
}

.heading-tour {
  font-size: 20px;
  line-height: 28px;
  color: #202223;
  padding: 16px 20px;
  font-weight: normal;
}

.heading_tour_list {
  border-bottom: 1px solid #e5e5e5;
}

.content-tour {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  padding: 16px;
  color: #202223;
}

.word-break {
  word-break: break-word;
  word-wrap: break-word;
}

/* --------------------- */

.Polaris-Page {
  max-width: 984px;
}

.beta0323Title {
  color: #d9730d;
}

.card-title-uppercase {
  margin: 1.5rem 0;
  text-transform: uppercase;
}

.BC-Button__Dismiss {
  position: absolute;
  right: 1rem;
  top: 1rem;
}

.section-title {
  margin: 1.5rem auto 1.25rem;
}

.sortableHelper {
  z-index: 99999999 !important;
}

.sortableHelper .BC-Select__multi-value {
  cursor: grabbing !important;
  pointer-events: fill;
}

.inline-warning .Polaris-InlineError {
  color: #f2711c;
  fill: #f2711c;
}

.inline-info {
  margin-top: 10px;
}

.inline-info-blue {
  color: var(--p-interactive);
}

.align-middle {
  margin-top: auto;
  margin-bottom: auto;
}

.BC-Popover__Button {
  display: flex;
  justify-content: flex-end;
}

.BC-Popover__Button_spaceBetween {
  justify-content: space-between;
}

.badge-dangerous .Polaris-Badge--statusWarning {
  background-color: #de3618 !important;
  color: #ffffff;
  border: 2px solid #efefef;
}

ul.dashed {
  list-style-type: none;
  margin: 0;
  padding-left: 0;
}

ul.dashed > li:before {
  content: '-';
  margin-right: 5px;
}

ul.four-cols {
  list-style-type: none;
  margin: 0 2.5rem;
  padding-left: 0;
  display: flex;
}

ul.four-cols li {
  flex: 1 1 25%;
  text-align: center;
}

ul.four-cols li p {
  margin: 0.75rem 3.125rem 0.25rem;
}

ul.four-cols li:first-child p,
ul.four-cols li:last-child p {
  margin: 0.75rem 1.25rem 0.25rem;
}

.modal-title .Polaris-DisplayText {
  font-weight: 600;
}

.modal-title span {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
}

.send-request-text {
  margin-top: 1.25rem;
}

.send-request-text button {
  padding-top: 0rem;
}

/* banner */
.pfs-plan-search-banner {
  position: relative;
  width: 100%;
  height: auto;
  border-radius: 12px;
  padding: 12px 8px;
}

.pfs-plan-search-banner--warning {
  background: #fffbf3;
}

.pfs-plan-search-banner--warning .plan-search-banner-actions .Polaris-Button--disabled {
  background-color: rgb(243, 242, 242) !important;
}

.pfs-plan-search-banner--warning .plan-search-banner-actions .Polaris-Button {
  border-radius: 4px;
  background: var(--decorative-surface-one, #ffc96b);
  box-shadow:
    0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset,
    0px 1px 0px 0px rgba(0, 0, 0, 0.08);
  margin-top: 16px;
  padding: 8px !important;
  width: 100%;
}

.plan-search-banner-actions .action .Polaris-Button__Text {
  display: flex;
  gap: 4px;
  align-items: center;
}

.Polaris-Badge {
  border-radius: 8px;
  padding: 2px 8px;
}

.Polaris-Badge--statusSuccess {
  background-color: #cdfee1;
  color: #0c5132;
}

.Polaris-Badge--statusCritical {
  background-color: #fedad9;
  color: #8e1f0b;
}

.Polaris-Badge--statusWarning {
  background-color: #fff2d9;
}

.BC-Page__ProductPerformanceRanking .test-your-search .Polaris-Icon,
.intro-new-product-performance-ranking .Polaris-Icon,
.addon-standard-search li .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  max-width: 16px;
}

.intro-new-product-performance-ranking a,
.addon-standard-search li a {
  color: #2c6ecb;
  margin-right: 4px;
}

.BC-Page__ProductPerformanceRanking .test-your-search .Polaris-Icon svg,
.intro-new-product-performance-ranking .Polaris-Icon svg,
.addon-standard-search li .Polaris-Icon svg {
  fill: #2c6ecb;
}

.plan-search-banner-infos .title {
  position: relative;
  z-index: 10;
}

.plan-search-banner-child {
  z-index: 10;
}

.pfs-plan-search-banner .imageTop {
  position: absolute;
  top: 12px;
  right: 8px;
}

.pfs-plan-search-banner .imageTop img {
  max-width: 24px;
}

.plan-search-banner-child {
  position: relative;
  z-index: 10;
}

.pfs-plan-search-banner .imageBottom img {
  position: absolute;
  bottom: 0;
  max-width: 116px;
  right: 0;
  z-index: 1;
  height: auto;
}

.plan-search-banner-infos .title {
  display: flex;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

/*  */
.pfs-app-banner {
  position: relative;
  padding: 20px 20px 0 20px;
  width: 100%;
  height: auto;
  border-radius: 8px;
  display: flex;
  gap: 20px;
}

.pfs-banner-dismiss {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 12;
}

.pfs-app-banner--success {
  background-color: #f7fdfc;
}

.pfs-app-banner--warning {
  background-color: #fffbf3;
}

.pfs-app-banner--info {
  background-color: #ebf9fc;
}

.pfs-app-banner .title {
  display: flex;
  gap: 6px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.pfs-banner-detail {
  margin-top: 4px;
  display: flex;
  gap: 20px;
}

.pfs-banner-infos {
  width: 100%;
}

.pfs-banner-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 20px;
  padding-right: 10px;
  gap: 20px;
}

.pfs-banner-actions {
  bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.pfs-banner-actions .secondary-action {
  text-decoration: underline;
  height: 100%;
  padding: 2px 5px;
}

.pfs-banner-actions .Polaris-Button__Text {
  display: flex;
  gap: 4px;
  align-items: center;
}

.pfs-app-banner--warning .primary-action .Polaris-Button--disabled {
  background-color: rgb(243, 242, 242) !important;
}

.pfs-app-banner--warning .primary-action .Polaris-Button {
  border-radius: 4px;
  background: var(--decorative-surface-one, #ffc96b);
  box-shadow:
    0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset,
    0px 1px 0px 0px rgba(0, 0, 0, 0.08);
  margin-top: 16px;
  padding: 8px !important;
}

.pfs-banner-actions .secondary-action:hover {
  cursor: pointer;
}

.pfs-banner-actions .Polaris-Button {
  background: none;
}

.banner-success--hasOutline,
.pfs-app-banner--success .pfs-banner-actions .Polaris-Button {
  border: 1px solid #95c9b4;
}

.banner-warning--hasOutline,
.pfs-app-banner--warning .pfs-banner-actions .Polaris-Button {
  border: 1px solid #e1b878;
}

.banner-info--hasOutline,
.pfs-app-banner--info .pfs-banner-actions .Polaris-Button {
  border: 1px solid #98c6cd;
}

.pfs-banner-dismiss .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.pfs-banner-detail .image {
  width: 30%;
  z-index: 10;
  max-width: 240px;
  margin-left: auto;
}

.pfs-app-banner .backgroundImage {
  z-index: 9;
  bottom: 0;
  right: 0;
  position: absolute;
}

.pfs-app-banner .backgroundImage img {
  max-width: 140px;
  height: auto;
  position: absolute;
  bottom: 0;
  right: 0;
}

.pfs-banner-detail .image img {
  width: 100%;
  height: auto;
}

.BC-PriceChangeNotificationBanner {
  display: flex;
  width: 100%;
  padding: 14px 48px;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  background: var(--Banner-Background-color-error-bg, #fff5ea);
  position: relative;
}

.BC-PriceChangeNotificationBanner .content {
  display: flex;
  gap: 8px;
}

.BC-PriceChangeNotificationBanner .Polaris-Button .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.BC-PriceChangeNotificationBanner a {
  cursor: pointer;
}

.trial-banner,
.promote-banner,
.incident-banner {
  display: flex;
  width: 100%;
  padding: 14px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  background: var(--Banner-Background-color-warning-bg, #fffbf3);
  position: relative;
}

.promote-banner .Polaris-Button,
.incident-banner .incident-dismiss .Polaris-Button {
  position: absolute;
  top: 14px;
  right: 20px;
}

.promote-banner .Polaris-Button .Polaris-Icon,
.incident-banner .Polaris-Button .Polaris-Icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
}

.promote-banner .Polaris-Button .Polaris-Icon svg,
.incident-banner .Polaris-Button .Polaris-Icon svg {
  width: 16px;
  height: 16px;
}

.BC-PriceChangeNotificationBanner a,
.trial-banner a,
.promote-banner a,
.incident-banner a {
  color: #2c6ecb;
  text-decoration: underline;
}

.promote-banner a:hover,
.incident-banner a:hover {
  cursor: pointer;
}

.trial-banner.trial-banner_EndToDay {
  background: #ff8d58;
  color: #ffffff;
}

.trial-banner.trial-banner_Ended {
  background: #ff5951;
  color: #ffffff;
}

.trial-banner.trial-banner_EndToDay a,
.trial-banner.trial-banner_Ended a {
  color: #ffffff;
  font-weight: 600;
}

.recommendation-popover-inline button,
.recommendation-popover-inline {
  display: flex;
  align-items: center;
  gap: 3px;
}

.recommendation-popover-inline button .Polaris-Icon {
  padding: 2px;
}

.BC-Page--child .Polaris-Header-Title > div {
  display: flex;
  gap: 16px;
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  align-items: center;
}

.BC-Page--heading > div button,
.BC-Page--child .Polaris-Header-Title > div button {
  background-color: unset;
}

.BC-Page--child .BC-Page__Title--Help {
  margin-left: 54px;
}

.BC-Page--heading {
  display: flex;
  gap: 16px;
}

.Polaris-Header-Title h1,
.BC-Page--heading h1 {
  font-size: 28px;
  line-height: 32px;
  font-weight: 600;
}

/* Checkbox slider status */
.BC-Toggle-Switch {
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
}

.BC-Toggle-Switch .Polaris-Labelled__LabelWrapper {
  display: inline-flex;
  margin: unset;
}

.BC-Toggle-Switch .Polaris-Labelled__LabelWrapper .tooltip {
  margin-top: 4px;
}

.BC-Toggle-Switch .Polaris-Labelled__LabelWrapper .tooltip.disabled {
  cursor: not-allowed;
}

.BC-Toggle-Switch .Polaris-Labelled__LabelWrapper .tooltip.disabled svg {
  fill: #babec3;
}

.BC-Toggle-Switch .Polaris-Labelled__LabelWrapper .Polaris-Label__Text.disabled {
  color: #8c9196;
  cursor: not-allowed;
}

.BC-Checkbox-Status {
  position: relative;
  display: inline-block;
  width: 34px;
  min-width: 34px;
  height: 16px;
  margin-top: 2px;
  margin-right: 1rem;
}

.BC-Checkbox-Status input {
  opacity: 0;
  width: 0;
  height: 0;
}

.BC-Checkbox-Status span {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 8px;
  background-color: var(--p-surface-neutral);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.BC-Checkbox-Status span:before {
  position: absolute;
  content: '';
  height: 16px;
  width: 16px;
  left: 0;
  bottom: 0;
  border-radius: 8px;
  background-color: var(--p-icon);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.BC-Checkbox-Status input:checked + span {
  background-color: var(--p-surface-success);
}

.BC-Checkbox-Status input:checked + span:before {
  background-color: var(--p-border-success);
  left: 2px;
}

.BC-Checkbox-Status input:disabled + span {
  background-color: var(--p-surface-neutral-disabled);
  cursor: not-allowed;
}

.BC-Checkbox-Status input:disabled + span:before {
  background-color: var(--p-icon-disabled);
}

.BC-Checkbox-Status input:focus + span {
  box-shadow: 0 0 1px var(--p-surface-success-subdued-pressed);
}

.BC-Checkbox-Status input:checked + span:before {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

/* ------- */
/* Popup pre launch promotion before release 04/2023 */
.PFS-Pre-launch-Modal {
  background-image: url('https://cdn.boostcommerce.io/assets/common/popup-pre-launch-background.png');
  background-repeat: no-repeat;
  background-position-y: bottom;
  background-size: contain;
  min-height: 482px;
  padding-bottom: 28px;
  position: relative;
}

.PFS-Pre-launch-Modal .action {
  width: 100%;
  position: absolute;
  bottom: 28px;
  display: flex;
  justify-content: center;
}

.PFS-Pre-launch-Modal .promotion-content {
  text-align: center;
  color: hsl(0, 0%, 100%);
  margin-top: 46%;
}

.PFS-Pre-launch-Modal .closeBtn {
  text-align: right;
}

.PFS-Pre-launch-Modal .closeBtn .Polaris-Button {
  margin-top: 18px;
  margin-right: 18px;
}

.PFS-Pre-launch-Modal .closeBtn .Polaris-Icon svg {
  fill: #ffffff;
}

.PFS-Pre-launch-Modal .promotion-content p:first-child {
  font-weight: 600;
  font-size: 22px;
  line-height: 33px;
}

.PFS-Pre-launch-Modal .promotion-content p:last-child {
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
}

.PFS-Pre-launch-Modal .action .Polaris-Button {
  background: linear-gradient(94.17deg, #ff005c 2.45%, #ff5c00 100%);
  box-shadow: 0px 4px 24px rgba(255, 48, 0, 0.4);
  border-radius: 4px;
}

/* ----------------- */

/* Popup BFCM23 promotion */
.Polaris-Modal-Dialog__Modal:has(.PFS-BFCM23-Popup) {
  max-width: 912px;
  height: 532px;
}

@media (max-width: 950px) or (max-height: 595px) {
  .Polaris-Modal-Dialog__Modal:has(.PFS-BFCM23-Popup) {
    height: 432px !important;
    max-width: 741px !important;
  }
}

@media (max-width: 785px) or (max-height: 493px) {
  .Polaris-Modal-Dialog__Modal:has(.PFS-BFCM23-Popup) {
    height: 332px !important;
    max-width: 570px !important;
  }
}

.PFS-BFCM23-Popup {
  background-image: url('https://cdn.boostcommerce.io/assets/dashboard-v3/bfcm23-in-app-popup.png');
  background-repeat: no-repeat;
  background-position-y: bottom;
  background-size: contain;
  height: 100%;
  width: 100%;
  padding-bottom: 2px;
  position: relative;
}

.PFS-BFCM23-Popup .action:hover {
  cursor: pointer;
}

.PFS-BFCM23-Popup .action {
  width: 80%;
  height: 35%;
  position: absolute;
  top: 22%;
  left: 10%;
  display: flex;
  justify-content: center;
}

.PFS-BFCM23-Popup .promotion-content {
  text-align: center;
  color: hsl(0, 0%, 100%);
  margin-top: 46%;
}

.PFS-BFCM23-Popup .closeBtn {
  text-align: right;
}

.PFS-BFCM23-Popup .closeBtn .Polaris-Button {
  margin-top: 18px;
  margin-right: 18px;
}

.PFS-BFCM23-Popup .closeBtn .Polaris-Icon svg {
  fill: #ffffff;
}

.PFS-BFCM23-Popup .promotion-content p:first-child {
  font-weight: 600;
  font-size: 22px;
  line-height: 33px;
}

.PFS-BFCM23-Popup .promotion-content p:last-child {
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
}

.PFS-BFCM23-Popup .action .Polaris-Button {
  background: linear-gradient(94.17deg, #ff005c 2.45%, #ff5c00 100%);
  box-shadow: 0px 4px 24px rgba(255, 48, 0, 0.4);
  border-radius: 4px;
}

/* ----------------- */
.BC-Page__Integration .Polaris-Stack--alignmentBaseline {
  align-items: center;
}

.BC-Page__Integration .Polaris-Stack__Item--fill {
  max-width: 240px;
}

.BC-Page__Integration .Polaris-Stack__Item:last-child {
  margin-left: auto;
}

.BC-Page__Integration .BC-Filter-Type .Polaris-Button {
  padding-right: 12px;
}

.BC-Page__Integration .BC-Filter-Type .Polaris-Button .Polaris-Button__Text {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
}

.BC-Page__Integration .BC-Filter-Type .Polaris-Button .Polaris-Icon {
  margin: 0;
}

.BC-Filter-Type__List {
  padding: 8px;
}

.BC-Filter-Type__List .Polaris-ChoiceList__ChoiceItem .Polaris-Choice {
  padding: 8px;
  width: 100%;
}

.BC-Filter-Type__List .Polaris-ChoiceList__ChoiceItem .Polaris-Choice:hover {
  background-color: #f6f6f7;
}

.BC-Filter-Status__List {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}

.BC-Page__Integration .BC-Checkbox-Status {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 28px;
}

.BC-Page__Integration .BC-Checkbox-Status span {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 15px;
  background-color: var(--p-surface-neutral);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.BC-Page__Integration .BC-Checkbox-Status span:before {
  position: absolute;
  content: '';
  height: 28px;
  width: 28px;
  left: 0;
  bottom: 0;
  border-radius: 15px;
  background-color: var(--p-icon);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.BC-Page__Integration .BC-Checkbox-Status input:checked + span:before {
  background-color: var(--p-border-success);
  left: 16px;
}

.BC-Page .Polaris-Page > div:not(.Polaris-Page-Header) > .Polaris-Layout > .Polaris-Layout__Section,
.BC-Page
  .Polaris-Page
  > div:not(.Polaris-Page-Header)
  > form
  > .Polaris-Layout
  > .Polaris-Layout__Section {
  margin-top: 0;
}

.BC-Page
  .Polaris-Page
  > div:not(.Polaris-Page-Header)
  > .Polaris-Layout
  > .Polaris-Layout__Section:not(:first-child)
  > *:first-child,
.BC-Page
  .Polaris-Page
  > div:not(.Polaris-Page-Header)
  > form
  > .Polaris-Layout
  > .Polaris-Layout__Section:not(:first-child)
  > *:first-child {
  margin-top: 1.5rem;
}

.BC-Page__SearchPageDisplay
  .Polaris-Page
  > div:not(.Polaris-Page-Header)
  > .Polaris-Layout
  > .Polaris-Layout__Section:not(:first-child)
  > *:first-child,
.BC-Page__MerchandisingV2
  .Polaris-Page
  > div:not(.Polaris-Page-Header)
  > .Polaris-Layout
  > .Polaris-Layout__Section:not(:first-child)
  > *:first-child {
  margin-top: 8px;
}

.BC-Page__MerchandisingV2 .Polaris-Tabs__Wrapper {
  padding: unset;
}

.BC-Page
  .Polaris-Page
  > div:not(.Polaris-Page-Header)
  > .Polaris-Layout
  > .Polaris-Layout__Section:not(:first-child)
  > .BC-Container__Notifications,
.BC-Page
  .Polaris-Page
  > div:not(.Polaris-Page-Header)
  > .Polaris-Layout
  > .Polaris-Layout__Section:not(:first-child)
  > #BC-onboardingArticles__Wrapper,
.BC-Page
  .Polaris-Page
  > div:not(.Polaris-Page-Header)
  > form
  > .Polaris-Layout
  > .Polaris-Layout__Section:not(:first-child)
  > .BC-Container__Notifications {
  margin-top: 0;
}

#BC-onboardingArticles__Wrapper > *:first-child {
  margin-top: 1.5rem;
}

.BC-Container__Notifications > *:first-child {
  margin-top: 1.5rem;
}

.BC-Container__Notifications > *:not(:first-child) {
  margin-top: 1.25rem;
}

.BC-Page__StandardSearch
  .tab-children
  .Polaris-Page
  > div:not(.Polaris-Page-Header)
  > .Polaris-Layout,
.BC-Page__Synonym .Polaris-Page > div:not(.Polaris-Page-Header) > .Polaris-Layout,
.BC-Page__AdvancedSearch
  .tab-children
  .Polaris-Page
  > div:not(.Polaris-Page-Header)
  > .Polaris-Layout,
.BC-Page__StopWords .Polaris-Page > div:not(.Polaris-Page-Header) > .Polaris-Layout {
  margin-top: 0 !important;
}

/* Main menu */
.BC_MainMenu_Wrapper {
  position: -webkit-sticky;
  /* Safari */
  position: sticky;
  background-color: #f4f6f8;
  top: 0;
  z-index: 518;
  box-shadow: inset 0px -1px 0px var(--p-divider);
}

.BC_MainMenu {
  display: table;
  margin: 0 auto;
  padding: 0;
  max-width: 65rem;
  width: 100%;
}

.BC_MainMenu > li.menuItem {
  text-align: center;
  color: #637381;
  font-size: 14px;
  border: none;
  padding: 17px 0;
  list-style-type: none;
  cursor: pointer;
  display: table-cell;
  min-width: 4rem;
}

.BC_MainMenu a {
  text-decoration: none;
  color: inherit;
}

.BC_MainMenu > li.menuItem > a {
  margin: -17px 0;
  padding: 17px 0;
  display: block;
}

.BC_MainMenu > li.menuItem.active {
  border-bottom: solid 3px var(--p-action-primary);
  color: var(--p-action-primary);
  background-color: var(--p-background-selected);
}

.BC_MainMenu > li.menuItem.active .dropbtn,
.BC_MainMenu > li.menuItem.active > a {
  font-weight: 700;
}

.BC_MainMenu > li.menuItem.hovered,
.BC_MainMenu > li.menuItem:hover {
  color: var(--p-action-primary);
  background-color: white;
}

.BC_MainMenu .dropbtn {
  display: inline-flex;
}

#menu-search-test-your-search {
  display: flex;
}

#menu-search-test-your-search .Polaris-ActionList__Suffix {
  margin-left: 4px;
}

.BC_MainMenu .dropbtn .Polaris-Icon svg {
  fill: #637381;
}

.BC_MainMenu > li.menuItem.active .dropbtn .Polaris-Icon svg {
  fill: var(--p-action-primary);
}

.BC_MainMenu > li.menuItem:hover .dropbtn .Polaris-Icon svg,
.BC_MainMenu > li.menuItem.hovered .dropbtn .Polaris-Icon svg {
  fill: var(--p-action-primary);
}

.BC_MainMenu .Polaris-Badge {
  margin-left: 0.3125rem;
}

.BC_MainMenu .Polaris-Icon + .Polaris-Badge {
  margin-left: 0;
}

.BC_MainMenu .dropdown {
  position: relative;
  display: inline-block;
}

.BC_MainMenu .dropdown-content {
  display: none;
  position: absolute;
  background-color: #ffffff;
  min-width: 185px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  top: 54px;
  /*left: -25px;*/
}

.BC_MainMenu > li.menuItem.menu-merchandising .dropdown-content,
.BC_MainMenu .dropdown.menu-tool .dropdown-content {
  /*left: -10px;*/
  min-width: 216px;
}

.BC_MainMenu > li.menuItem.menu-tool .dropdown-content {
  right: 0;
}

.BC_MainMenu .dropdown-content a {
  color: #212b36;
  padding: 10px 0 10px 16px;
  text-decoration: none;
  display: block;
  text-align: left;
  border-left: solid 2px transparent;
}

.BC_MainMenu .dropdown-content a:hover {
  background-color: rgba(223, 227, 232, 0.3);
  border-left: solid 2px var(--p-action-primary);
}

.BC_MainMenu .dropdown-content a.active {
  background-color: rgba(223, 227, 232, 0.3);
  border-left: solid 2px var(--p-action-primary);
  font-weight: 600;
}

.BC_MainMenu .dropdown:hover .dropdown-content {
  display: block;
}

@media (min-width: 30.625em) {
  .BC_MainMenu {
    padding: 0 1.25rem;
  }
}

@media (min-width: 46.5em) {
  .BC_MainMenu {
    padding: 0 2rem;
  }
}

.BC-Search__WarningBannerUpgrade .Polaris-Banner p .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  max-width: 16px;
}

.BC-Search__WarningBannerUpgrade .Polaris-Banner p a {
  color: #2c6ecb;
  margin-right: 4px;
}

.BC-Search__WarningBannerUpgrade .Polaris-Banner p .Polaris-Icon svg {
  fill: #2c6ecb;
}

/* New feature onboarding */

.PFS-New-Feature-Onboard .Polaris-Page {
  background: #ffffff;
  box-shadow:
    0px 2px 1px rgba(0, 0, 0, 0.05),
    0px 0px 1px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  width: 100%;
  max-width: 1120px;
  height: 100%;
  margin: 24px auto;
  padding: unset;
}

.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content {
  padding-top: 1px;
}

.PFS-New-Feature-Onboard--one .Polaris-Page {
  padding: 40px;
}

/*@media (max-width: 47.9em) {
  .Polaris-Page-Header__Title > div {
    width: calc(100% - 0.5rem);
  }
}*/

.PFS-New-Feature-Onboard--one .Polaris-Page .Polaris-Page__Content > div {
  justify-content: center;
  display: flex;
  align-items: center;
}

.PFS-New-Feature-Onboard--one .Polaris-Page .Polaris-Page__Content .title {
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;

  text-align: center;
  color: #008060;
  margin-top: 5%;
}

.PFS-New-Feature-Onboard--one .Polaris-Page .Polaris-Page__Content .subtitle {
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  margin-top: 12px;
}

.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .advanced-list {
  margin-top: 32px;
  display: grid;
  gap: 16px;
  align-items: center;
}

.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .advanced-list .element-advanced {
  gap: 11px;
  display: flex;
}

.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .advanced-list .element-advanced p {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}

.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content > div:first-child img,
.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content > div > img {
  max-width: 392px;
  max-height: 160px;
  width: auto;
  height: auto;
}

.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .element-advanced img {
  max-width: 24px;
  max-height: 24px;
}

.PFS-New-Feature-Onboard--one .Polaris-Page .Polaris-Page__Content .sub-action {
  margin-top: 32px;
  margin-bottom: 12px;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
}

.PFS-New-Feature-Onboard--two .Polaris-Page .Polaris-Page__Content > div:first-child,
.PFS-New-Feature-Onboard--four .Polaris-Page .Polaris-Page__Content > div:first-child {
  margin: 24px 56px 20px;
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;
  text-align: center;
}

.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .feature-list {
  display: inline-flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 56px;
}

.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .feature-list .feature-card {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  gap: 12px;
  margin-top: 12px;
  max-width: 48%;
  background: #f6f6f7;
  border-radius: 8px;
}

.PFS-New-Feature-Onboard
  .Polaris-Page
  .Polaris-Page__Content
  .feature-list
  .feature-card
  > div:first-child {
  max-width: 32px;
  max-height: 32px;
}

.PFS-New-Feature-Onboard
  .Polaris-Page
  .Polaris-Page__Content
  .feature-list
  .feature-card
  p:first-child {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
}

.PFS-New-Feature-Onboard
  .Polaris-Page
  .Polaris-Page__Content
  .feature-list
  .feature-card
  p:last-child {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin-top: 6px;
}

.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .actions .step-action-circle {
  display: inline-flex;
  gap: 6px;
  align-items: center;
}

.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .actions .circle-active {
  width: 10px !important;
  height: 10px !important;
  background: #008060 !important;
}

.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .actions .circle {
  width: 6px;
  height: 6px;
  background: #c9ccd0;
  border-radius: 50%;
}

.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .actions .circle:hover {
  cursor: pointer;
}

.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .actions {
  padding: 24px 56px;
  display: flex;
  justify-content: space-between;
}

.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .actions .action-btn {
  display: flex;
  gap: 12px;
}

.PFS-New-Feature-Onboard--three .Polaris-Page .Polaris-Page__Content > div:first-child {
  margin: 40px 56px 0;
  font-weight: 600;
  font-size: 28px;
  text-align: center;
  line-height: 32px;
}

.PFS-New-Feature-Onboard--three .Polaris-Page .Polaris-Page__Content .content-step {
  margin: 40px 56px;
  display: flex;
  justify-content: space-between;
  gap: 64px;
}

.PFS-New-Feature-Onboard--three .Polaris-Page .Polaris-Page__Content .content-step .advanced-list {
  width: 452px;
}

.PFS-New-Feature-Onboard--three .Polaris-Page .Polaris-Page__Content .divider {
  margin: unset;
}

.PFS-New-Feature-Onboard--three
  .Polaris-Page
  .Polaris-Page__Content
  .content-step
  > div:first-child
  > img {
  width: 492px;
  max-height: 332px;
}

.PFS-New-Feature-Onboard--five .Polaris-Page {
  padding: 40px 56px 56px;
  text-align: center;
}

.PFS-New-Feature-Onboard--five .Polaris-Page .Polaris-Page__Content > div:first-child {
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;
  color: #008060;
}

.PFS-New-Feature-Onboard--five .Polaris-Page img {
  width: 100%;
  height: 100%;
  margin: 24px 0;
}

@media (max-height: 680px) {
  .PFS-New-Feature-Onboard--five .Polaris-Page img {
    max-height: 402px;
  }
}

.PFS-New-Feature-Onboard--five .Polaris-Page .Polaris-Page__Content .action-last-step {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
}

/* Date picker */
.datePicker .date-select .Polaris-Button {
  padding: 0.4375rem 0.5rem;
}

.datePicker .date-select .Polaris-Button__Content {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.datePicker .date-select .Polaris-Button__Content .Polaris-Button__Icon {
  -webkit-order: 1;
  -ms-flex-order: 1;
  order: 1;
}

.datePicker .date-select .Polaris-Button__Content .Polaris-Button__Text {
  -webkit-order: 0;
  -ms-flex-order: 0;
  order: 0;
  margin-top: 2px;
}

.datePicker .date-select-picker {
  display: flex;
  align-items: center;
}

.analytics-select-popover .Polaris-Button {
  width: 100%;
}

.analytics-select-popover .Polaris-Button .Polaris-Button__Content {
  justify-content: unset !important;
}

.analytics-select-popover .Polaris-Button .Polaris-Button__Content .Polaris-Button__Text {
  width: 100%;
  display: flex;
  justify-content: space-between !important;
  align-items: center;
}

.analytics-select-popover .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  margin-right: 0px;
}

.date-select .subdued-icon .Polaris-Icon svg {
  fill: var(--p-icon-subdued);
}

/* Update Polaris component */
.Polaris-Page,
.Polaris-Card {
  position: relative;
}

.Polaris-Card {
  overflow: visible;
}

.Polaris-Layout__Section:empty,
.Polaris-Layout__Section.empty {
  margin: 0;
}

.Polaris-ProgressBar--sizeMedium {
  height: 1.75rem;
}

.Polaris-ProgressBar__Indicator {
  position: relative;
}

.Polaris-ProgressBar__Label {
  left: 50%;
  width: auto !important;
  height: auto !important;
  clip: auto !important;
  color: white;
  margin: 4px 5px !important;
  clip-path: none !important;
  transform: scaleX(calc(1 / var(--pc-progress-bar-percent)));
}

.Polaris-Modal-Header--titleHidden .Polaris-Modal-CloseButton {
  display: none;
}

.Polaris-Tooltip__Wrapper {
  max-height: inherit;
}

.Polaris-Tooltip__Content {
  max-width: inherit;
  max-height: inherit;
}

.Polaris-InlineError {
  margin-top: 10px;
}

.BC-Page-Variants-Display .Polaris-InlineError {
  margin-bottom: 10px;
}

.Polaris-Tabs .Polaris-Tabs__Tab:focus,
.Polaris-Tabs__Title:after {
  box-shadow: none !important;
}

.Polaris-Choice {
  padding: 0;
}

.Polaris-ButtonGroup__Item {
  margin-left: 1.25rem;
}

.Polaris-Banner__Content .Polaris-ButtonGroup__Item {
  margin-left: 0.5rem;
}

.Polaris-InlineError .Polaris-InlineError__Icon {
  display: none;
}

.titleMetadata {
  display: inline-flex;
}

.title-Icon-Merchandising-Rule {
  margin-left: 8px;
}

.titleMetadata .Polaris-Icon {
  height: 1rem;
  width: 1rem;
}

.titleMetadata button {
  padding: 0;
  border: none;
  cursor: pointer;
  background: none;
  vertical-align: middle;
}

.Polaris-Popover__PopoverOverlay {
  z-index: 520;
}

.Polaris-Popover__Content {
  max-width: 100% !important;
  max-height: 32.5rem;
}

/*.Polaris-Modal-Dialog__Container .Polaris-Scrollable--vertical .Polaris-DataTable__ScrollContainer {
  overflow-x: visible;
}*/

/* Another layout*/
.BC-AnotherLayout .Polaris-Page {
  max-width: 51.5625rem;
}

.BC-AnotherLayoutV3 .Polaris-Page {
  max-width: 69.3rem;
}

.BC-AnotherLayoutV3 .Polaris-Layout__Section:empty {
  margin-top: 0;
}

.BC-AnotherLayoutV3.V2 .Polaris-Layout__Section:first-child:empty {
  margin-top: 10px;
}

.BC-AnotherLayoutV3 .Polaris-Layout__Section,
.BC-AnotherLayout .Polaris-Layout__Section {
  flex: 2 2 22.5rem;
  margin-top: 1.5rem;
}

.BC-AnotherLayoutV3 .Polaris-Layout__Section--oneThird,
.BC-AnotherLayout .Polaris-Layout__Section--oneThird {
  flex: 1 1 13.75rem;
}

.BC-AnotherLayoutV3 .Polaris-Layout__Section--secondary,
.BC-AnotherLayout .Polaris-Layout__Section--secondary {
  flex: 1 1 16.25rem;
}

.BC-AnotherLayoutV3 .Polaris-Page-Header__RightAlign,
.BC-AnotherLayout .Polaris-Page-Header__RightAlign {
  align-items: center;
}

.BC-AnotherLayout .enableTAE a:visited {
  color: var(--p-interactive);
}

.BC-Page__Installation__Option2 .Polaris-ChoiceList__Title {
  margin-bottom: 12px;
}

.BC-Page__Installation__Option2 .Polaris-ChoiceList__Choices li:not(:first-child) {
  margin-top: 12px;
}

/* Another layout v3*/

.BC-AnotherLayoutV3
  .BC-Page__FirstColumn
  .Polaris-Layout__Section:first-child:empty
  + .Polaris-Layout__Section:nth-child(2) {
  margin-top: 14px;
}

.BC-AnotherLayoutV3
  .BC-Page__FirstColumn
  .Polaris-Layout__Section:first-child:empty
  + .Polaris-Layout__Section:nth-child(2):empty
  + .Polaris-Layout__Section:nth-child(3) {
  margin-top: 0px;
}

/* install page */
.text-installation,
.preview-not-available {
  color: #637381;
}

.Polaris-Card .select-layout-button {
  margin-top: 1.25rem;
}

/*@media (max-width: 47.9em) {
  .Polaris-Page-Header__Title > div {
    width: calc(100% - 0.5rem);
  }
}*/

/* Slideshow */

.carousel .slide {
  background-color: transparent;
}

.migration-slideshow,
.slideshow {
  margin: 0.25rem 1.25rem;
}

/*.carousel .control-prev.control-arrow:before {
  background-image: url("data:image/svg+xml,%3Csvg width='17' height='30' viewBox='0 0 17 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.585786 13.5858C-0.195262 14.3668 -0.195262 15.6332 0.585786 16.4142L13.3137 29.1421C14.0948 29.9232 15.3611 29.9232 16.1421 29.1421C16.9232 28.3611 16.9232 27.0948 16.1421 26.3137L4.82843 15L16.1421 3.68629C16.9232 2.90524 16.9232 1.63891 16.1421 0.857865C15.3611 0.0768166 14.0948 0.0768164 13.3137 0.857865L0.585786 13.5858ZM4.5 13L2 13L2 17L4.5 17L4.5 13Z' fill='%23C4CDD5' fill-opacity='0.5'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  border: none;
  width: 30px;
  height: 30px;
}

.carousel .control-next.control-arrow:before {
  background-image: url("data:image/svg+xml,%3Csvg width='18' height='30' viewBox='0 0 18 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.9142 13.5858C17.6953 14.3668 17.6953 15.6332 16.9142 16.4142L4.18629 29.1421C3.40524 29.9232 2.13891 29.9232 1.35787 29.1421C0.576817 28.3611 0.576817 27.0948 1.35787 26.3137L12.6716 15L1.35786 3.68629C0.576815 2.90524 0.576814 1.63891 1.35786 0.857865C2.13891 0.0768166 3.40524 0.0768164 4.18629 0.857865L16.9142 13.5858ZM13 13L15.5 13L15.5 17L13 17L13 13Z' fill='%23C4CDD5' fill-opacity='0.5'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  border: none;
  width: 30px;
  height: 30px;
}

.slideshow .carousel.carousel-slider:hover .control-arrow {
  background: none;
  opacity: 1;
  filter: alpha(opacity=100);
}
*/

.migration-slideshow .carousel .control-dots .dot,
.slideshow .carousel .control-dots .dot {
  background-color: #c4cdd5;
  width: 6px;
  height: 6px;
  box-shadow: none;
  margin: 0 6px;
}

.slideshow .carousel .control-dots .dot:first-child {
  display: none;
}

.carousel .control-dots .dot:focus {
  outline: none;
}

.carousel .control-dots .dot.selected {
  background-color: var(--p-action-primary);
}

/*.slideshow .carousel ul.slider {
  height: auto !important;
}

.slideshow .carousel ul.slider,
.slideshow .carousel .slider-wrapper {
  height: auto !important;
}*/

.migration-slideshow .carousel .slide,
.slideshow .carousel .slide {
  max-height: 1px;
}

.migration-slideshow .carousel .slide.selected,
.slideshow .carousel .slide.selected {
  max-height: 100%;
}

.migration-slideshow .carousel .slide img,
.slideshow .carousel .slide img {
  width: 372px;
  max-width: 100%;
}

.migration-slideshow .slideshow-button,
.slideshow .slideshow-button {
  margin: 1.5rem 2.5rem 0 2.5rem;
  text-align: center;
}

.migration-slideshow .slideshow-button button,
.slideshow .slideshow-button button {
  min-width: 6.75rem;
}

.migration-slideshow .slideshow-image-content,
.slideshow .slideshow-image-content {
  margin: 2.875rem 2.5rem 0 2.5rem;
}

.migration-slideshow .carousel .control-dots,
.slideshow .carousel .control-dots {
  top: 265px;
  padding-left: 0;
}

.migration-slideshow .content-line,
.slideshow .content-line {
  display: block;
}

@media (max-width: 514px) {
  .migration-slideshow .carousel .slide img,
  .slideshow .carousel .slide img {
    width: 260px;
  }

  .migration-slideshow .carousel .control-dots,
  .slideshow .carousel .control-dots {
    top: 200px;
  }

  .migration-slideshow .content-line,
  .slideshow .content-line {
    display: inline;
  }

  .migration-slideshow .slideshow-button,
  .slideshow .slideshow-button {
    margin: 1.5rem 0 0 0;
  }

  .migration-slideshow .slideshow-image-content,
  .slideshow .slideshow-image-content {
    margin: 2.875rem 0 0 0;
  }
}

/** progress step **/
/* .step-progress-initializing {
  position: absolute;
  top: 45px;
  right: -15px;
} */

.step-progress-container {
  width: 240px;
}

/* @media (max-width: 47.9em) {
  .step-progress-initializing {
    position: static;
    margin: 0.625rem 0 0 -2.8125rem;
    max-width: calc(100% + 5.625rem);
  }
} */

.step-progress-container ul {
  margin: 0;
  padding: 0;
}

.step-progress-container .progressbar li {
  list-style-type: none;
  width: 31%;
  float: left;
  font-size: 0;
  position: relative;
  text-align: center;
  color: #c4cdd5;
  line-height: 1;
}

.step-progress-container .progressbar li:first-child {
  width: 6%;
}

.step-progress-container .progressbar li:before {
  width: 15px;
  height: 15px;
  content: '';
  color: white;
  font-size: 16px;
  line-height: 12px;
  border: 1px solid #c4cdd5;
  display: block;
  text-align: center;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  background-color: white;
  margin-bottom: 0;
  margin-right: 0;
}

.step-progress-container .progressbar li:after {
  width: 61px;
  height: 1px;
  content: '';
  position: absolute;
  background-color: #c4cdd5;
  top: 7px;
  left: 0;
  z-index: 1;
}

.step-progress-container .progressbar li:first-child:after {
  content: none;
}

.step-progress-container .progressbar li.active {
  color: var(--p-action-primary);
}

.step-progress-container .progressbar li.active:before {
  border-color: var(--p-action-primary);
  background-color: var(--p-action-primary);
  content: '\\2713';
  font-size: 0.625rem;
  font-weight: 900;
}

.step-progress-container .progressbar li.active.activating:before {
  content: '';
}

.step-progress-container .progressbar li.active:not(.activating) + li:after {
  background-color: var(--p-action-primary);
}

.step-progress-upgrade .step-progress-container .progressbar li:after {
  width: 85px;
}

.step-progress-upgrade .step-progress-container {
  width: 300px;
}

.step-progress-upgrade .step-progress-container .progressbar li {
  width: 33%;
}

.step-progress-initializing .step-progress-container {
  width: 300px;
}

.step-progress-initializing .step-progress-container .progressbar li {
  width: 20%;
}

.step-progress-initializing .progressbar li:after {
  width: 45px;
}

@media (max-width: 47.9em) {
  .step-progress-upgrade {
    position: static;
    margin: 0.625rem 0 0 -2.8125rem;
    max-width: calc(100% + 5.625rem);
  }
}

.step-progress-setup {
  position: absolute;
  top: 20px;
  right: 20px;
}

/* @media (max-width: 47.9em) {
  .step-progress-setup {
    position: static;
    margin: 0.625rem 0 0 -2.8125rem;
    max-width: calc(100% + 5.625rem);
  }
} */

.step-progress-setup .step-progress-container {
  width: 176px;
}

.step-progress-setup .step-progress-container .progressbar {
  counter-reset: step;
}

.step-progress-setup .step-progress-container .progressbar li {
  width: calc(100% / 2);
}

.step-progress-setup .step-progress-container .progressbar li:before {
  content: counter(step);
  counter-increment: step;
  width: 24px;
  height: 24px;
  font-size: 0.875rem;
  padding-top: 5px;
  font-weight: 600;
  color: #c4cdd5;
}

.step-progress-setup .step-progress-container .progressbar li.active.activating:before {
  content: counter(step);
  counter-increment: step;
}

.step-progress-setup .step-progress-container .progressbar li.active:before {
  content: '\\2713';
  color: white;
}

.step-progress-setup .step-progress-container .progressbar li:after {
  top: 12px;
  width: 64px;
}

/* Custom package
*/
.BC-Select__ValueContainer {
  flex: 1 1 0%;
}

.BC-Select__ValueContainerInner {
  display: flex;
  flex-wrap: wrap;
}

.BC-Illustration-Image__Notification {
  width: 100%;
}

.BC-Benefit_Referral_Image {
  width: 100%;
  cursor: pointer;
}

/*
  Custom css Dashboard
 */
.BC-Page__Dashboard .Polaris-Card__Header,
.BC-Page__FilterTree-Item .Polaris-Card__Header,
.BC-Page__FilterTree-Management .Polaris-Card__Header,
.BC-Page__Theme-Setup .Polaris-Card__Header,
.BC-Page__Merge-Value .Polaris-Card__Header,
.BC-Page__SuggestionDictionary .Polaris-Card__Header,
.BC-Page__Synonym .Polaris-Card__Header,
.BC-Page__ProductRanking .Polaris-Card__Header,
.BC-Page__Merchandising .Polaris-Card__Header,
.BC-Page__Merchandising-Rule .Polaris-Card__Header,
.BC-Page__Metafield .Polaris-Card__Header,
.BC-Page__Product-Visibility .Polaris-Card__Header,
.BC-Page__Q1-Beta-Features .Polaris-Card__Header,
.BC-OnboardingChecklist__OnPage .Polaris-Card__Header,
.BC-OnboardingChecklist__OnSetupPage .Polaris-Card__Header,
.BC-BC-Page__MerchandisingV2 .Polaris-Card__Header,
.BC-Page__Sync .Polaris-Card__Header,
.BC-Page__ShopifyIntegration .Polaris-Card__Header,
.BC-Page__CustomSorting .Polaris-Card__Header,
.BC-Page__Language-Setting .Polaris-Card__Header,
.BC-Page__RecommendationNewWidgetItem .Polaris-Card__Header,
.BC-Page__RecommendationWidgetItem .Polaris-Card__Header,
.BC-Page__SearchAnalytics__SearchTerms .Polaris-Card__Header,
.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-Card__Header,
.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-Card__Header,
.BC-Page__SearchAnalytics__SearchesWithoutResults .Polaris-Card__Header,
.BC-Page__SearchAnalytics__ProductPerformance .Polaris-Card__Header,
.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-Card__Header,
.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-Card__Header,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-Card__Header,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-Card__Header,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-Card__Header,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-Card__Header,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-Card__Header,
.BC-Page__Language-Setting .Polaris-Card__Header,
.BC-Page__Language-Setting .Polaris-Card__Header,
.BC-Page__SubscriptionV3 .Polaris-Card__Header {
  padding-bottom: 1rem;
  padding-top: 1rem;
  border-bottom: 0.0625rem solid var(--p-divider);
}

.BC-Page__Merge-Value .Polaris-Card__Section {
  padding-top: 20px;
}

.BC-Page__Dashboard .BC-Paragraph__Dashboard {
  line-height: 1.5rem;
}

.BC-Page__Dashboard .BC-Iframe-Container__Wrapper {
  display: flex;
  justify-content: center;
}

.BC-Page__Dashboard .BC-Iframe-Container__Center {
  width: 70%;
}

.BC-Iframe-Container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
}

.BC-Iframe-Container img {
  cursor: pointer;
}

.BC-Iframe-Container img:focus {
  cursor: pointed;
}

.BC-Page
  .Polaris-Page
  > div:not(.Polaris-Page-Header)
  > .Polaris-Layout
  > .Polaris-Layout__Section:not(:first-child) {
  margin-top: 0;
}

.BC-Welcome__Dashboard {
  margin-bottom: -1.5rem;
}

.BC-Welcome__Dashboard .Polaris-Layout {
  align-items: flex-end;
}

.BC-Welcome__Dashboard button {
  margin-top: 0.5625rem;
  margin-bottom: 1.25rem;
  width: fit-content;
}

.BC-Welcome__Dashboard img {
  width: 243px;
  margin-left: auto;
}

.BC-Welcome__Dashboard .Polaris-DisplayText--sizeSmall {
  font-size: 1.125rem;
}

.BC-Welcome__Image {
  width: 243px;
  max-width: 100%;
}

.BC-Iframe-Container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.BC-Feedback-Card__Dashboard .Polaris-Card {
  background-color: transparent;
}

.BC-Button-Notice .Polaris-ButtonGroup__Item,
.BC-Feedback-Card__Dashboard .Polaris-ButtonGroup__Item {
  margin-left: 0.5rem;
}

.BC-Button-Notice .Polaris-Caption {
  color: var(--p-text-subdued);
}

.BC-Illustration-Image__Dashboard {
  display: none;
}

.BC-Illustration-Image__Dashboard > div {
  margin: auto;
}

.menuBox .Polaris-Card__Section {
  padding: 1rem;
}

.BC-Page__Dashboard .menuBox .Polaris-Card,
.BC-Page__Dashboard .menuBox .Polaris-Card-Hover {
  box-shadow: none;
}

.BC-Menu__Dashboard .Polaris-Layout,
.BC-Menu__Dashboard .Polaris-Layout__Section--secondary,
.BC-HelpCenter__Dashboard .Polaris-Layout,
.BC-HelpCenter__Dashboard .Polaris-Layout__Section--secondary {
  margin: 0;
}

.BC-Review__Dashboard .Polaris-Layout__Section,
.BC-Email__Dashboard .Polaris-Layout__Section,
.BC-SyncHookStatus__Dashboard .Polaris-Layout__Section,
.BC-Feedback__Dashboard .Polaris-Layout__Section,
.BC-Sync__Content .Polaris-Layout__Section {
  flex: 2 2 28.75rem;
}

.BC-Review__Dashboard .Polaris-Layout__Section .Polaris-TextContainer,
.BC-Email__Dashboard .Polaris-Layout__Section .Polaris-TextContainer,
.BC-SyncHookStatus__Dashboard .Polaris-Layout__Section .Polaris-TextContainer,
.BC-Feedback__Dashboard .Polaris-Layout__Section .Polaris-TextContainer {
  margin-right: -1.25rem;
}

.BC-Review__Dashboard .Polaris-Layout__Section--secondary,
.BC-Email__Dashboard .Polaris-Layout__Section--secondary,
.BC-SyncHookStatus__Dashboard .Polaris-Layout__Section--secondary,
.BC-Feedback__Dashboard .Polaris-Layout__Section--secondary {
  flex: 1 1 15rem;
  text-align: right;
  padding-right: 25px;
}

.BC-Sync__Content .Polaris-Layout__Section--secondary {
  flex: 0 1 15rem;
  text-align: right;
}

.BC-Review__Dashboard .BC-Illustration-Image__Dashboard img,
.BC-SyncHookStatus__Dashboard .BC-Illustration-Image__Dashboard img,
.BC-Feedback__Dashboard .BC-Illustration-Image__Dashboard img,
.BC-Sync__Content .BC-Illustration-Image__Dashboard img,
.BC-Merchandising__TryNewVersion .BC-Illustration-Image__Dashboard img {
  width: 150px;
  max-width: 100%;
}

.BC-Email__Dashboard .BC-Illustration-Image__Dashboard img {
  width: 52%;
}

.BC-Email__Dashboard .Polaris-Layout__Section .Polaris-FormLayout .Polaris-FormLayout__Item {
  max-width: none;
}

.BC-Email__Dashboard .Polaris-Layout__Section .Polaris-FormLayout {
  width: 118%;
}

.BC-Language-Setting__Content .BC-Illustration-Image__Dashboard img {
  max-width: 265px;
}

.BC-SyncHookStatus__Dashboard .Polaris-Card__Header .tooltip,
.BC-Sync__Content .Polaris-Card__Header .tooltip {
  margin-top: 7px;
}

.BC-SyncHookStatus__Dashboard .recent-sync {
  margin-top: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.BC-SyncHookStatus__Dashboard .completed-icon {
  width: 14px;
  height: 14px;
  display: block;
  margin-right: 0.3125rem;
  padding: 0;
}

.BC-SyncHookStatus__Dashboard .Polaris-Layout__Section {
  margin-top: 1.25rem;
}

.BC-KnowledgeBase__Dashboard .Polaris-Layout__Section--oneThird:not(:first-child) {
  margin-left: 0.875rem;
}

a.BC-Link__Dashboard {
  text-decoration: none;
}

.BC-Link__Dashboard:hover .menuContent > *:first-child {
  color: var(--p-interactive-hovered);
}

.BC-ThemeSetup__DashboardV3 .Polaris-CalloutCard__Image,
.BC-CalloutCard-ThemeSetup__Dashboard .Polaris-CalloutCard__Image,
.BC-CalloutCard-ExpReviewRating__Dashboard .Polaris-CalloutCard__Image {
  width: auto;
}

.BC-ThemeSetup__DashboardV3 .Polaris-Card__Section,
.BC-CalloutCard-ThemeSetup__Dashboard .Polaris-Card__Section {
  margin: auto;
}

.BC-CalloutCard-ExpReviewRating__Dashboard .Polaris-Card__Section {
  padding: 1rem 1.25rem;
}

.BC-ThemeSetup__DashboardV3 .layoutCols,
.BC-CalloutCard-ThemeSetup__Dashboard .layoutCols {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
}

.BC-CalloutCard-ExpReviewRating__Dashboard .layoutCols {
  width: 242px;
  display: flex;
}

.BC-CalloutCard-ExpReviewRating__Dashboard .layoutCols.submitted {
  padding-top: 0.75rem;
}

.BC-CalloutCard-ExpReviewRating__Dashboard .layoutCols.lowRating {
  width: 332px;
  display: flex;
}

.BC-CalloutCard-ThemeSetup__Dashboard .Polaris-TextStyle--variationStrong,
.BC-CalloutCard-ExpReviewRating__Dashboard .Polaris-TextStyle--variationStrong {
  font-weight: 500;
  font-size: 0.9375rem;
  line-height: 1.25rem;
}

.BC-CalloutCard-ThemeSetup__Dashboard .theme-status-text,
.BC-CalloutCard-ExpReviewRating__Dashboard .theme-status-text {
  font-weight: 600;
  margin-bottom: auto;
}

.BC-Page__Dashboard .knowledgeBox .Polaris-Card__Section {
  padding: 0.75rem 1rem 1rem;
  min-height: 3.75rem;
}

.knowledgeBox button {
  padding: 0;
  border: none;
  cursor: pointer;
  background: white;
}

.knowledgeBox .Polaris-Caption {
  text-align: left;
}

.BC-Page__Dashboard .menuIconImg {
  float: left;
  padding: 10px;
  background-color: #f4f6f8;
}

.BC-Page__Dashboard .menuIconImg.hover {
  background-color: var(--p-divider);
}

.BC-Page__Dashboard .menuContent {
  display: grid;
  padding-left: 1.25rem;
}

.BC-Page__Dashboard .BC-HelpCenter__Dashboard .menuContent {
  padding-left: 0.5rem;
}

.BC-Page__Dashboard .BC-HelpCenter__Dashboard .Polaris-Layout .Polaris-Layout__Section {
  margin-left: 0;
}

.BC-Page__Dashboard .BC-HelpCenter__Dashboard .Polaris-Layout .Polaris-Layout__Section:last-child {
  margin-right: 0.375rem;
}

.BC-Page__Dashboard .BC-HelpCenter__Dashboard .Polaris-Layout .Polaris-Card__Section {
  padding: 1rem;
  padding-right: 0;
}

.BC-Page__Dashboard .menuContent .Polaris-TextStyle--variationStrong {
  color: var(--p-interactive);
}

.BC-Page__Dashboard .guideBox img {
  width: 100%;
}

.BC-Page__Dashboard .guideBox .Polaris-TextStyle--variationStrong {
  padding: 0.625rem;
  display: inline-block;
  margin-top: -5px;
}

.BC-CalloutCard-Subscription__Dashboard {
  text-align: center;
}

.BC-CalloutCard-Subscription__Dashboard .Polaris-Card {
  display: flex;
}

.BC-CalloutCard-Subscription__Dashboard .Polaris-Card .Polaris-Card__Section {
  padding-top: 0;
  padding-bottom: 0;
  margin: auto;
}

.BC-CalloutCard-Subscription__Dashboard .Polaris-Badge {
  padding: 0 1.25rem;
  margin-top: 6px;
}

.BC-CalloutCard-Subscription__Dashboard .Polaris-Button {
  margin-top: 0;
}

.BC-CalloutCard-Subscription__Dashboard p {
  margin: 8px 0;
}

.BC-CalloutCard-Subscription__Dashboard .subscribe__bottom .upgrade {
  padding: 0 1.125rem;
}

.BC-Page__Dashboard .knowledgeBox .guide {
  text-align: left;
  color: #212b36;
}

/* Custom style notification */
/* Class exceededPlanNotice is getting from notification in DB */
/* .BC-Page__Dashboard .notification:not(:first-child) {
  margin-top: 1.25rem;
} */

.BC-Page__Dashboard .notification.exceededPlanNotice .Polaris-Banner__SecondaryAction {
  color: var(--p-interactive);
  font-weight: 600;
}

.BC-Page__Dashboard .notification.exceededPlanNotice .Polaris-Banner__Text::after {
  border: none;
}

/*-------Dashboard v3------------*/

.BC-Page__DashboardV3 .Polaris-Page__Content {
  display: inline-flex;
  width: 100%;
  padding-top: 12px;
}

.BC-Page__DashboardV3 .BC-Page__FirstColumn {
  width: 72%;
  height: 100%;
}

.BC-Page__DashboardV3 .BC-Page__SecondColumn {
  width: 28%;
  height: 100%;
}

.BC-Page__DashboardV3 .BC-Page__FirstColumn .Polaris-Layout {
  padding-right: calc(var(--p-space-5) * 1) !important;
}

.BC-Page__DashboardV3 .notification .BC-Notification_Dismiss {
  position: absolute;
  right: 20px;
  color: #6d7175;
  cursor: pointer;
}

.BC-Page__DashboardV3
  .notification
  .BC-Notification_Dismiss.BC-Notification_Dismiss_WithoutActionButton {
  bottom: 55px;
}

.BC-Page__DashboardV3
  .BC-Notifications_DashboardV3
  .notification-item
  .BC-Notification_Dismiss.BC-Notification_Dismiss_WithoutActionButton {
  bottom: 25px;
}

.BC-Page__DashboardV3 .notification .BC-Notification_Dismiss_WithActionButton {
  bottom: 65px;
}

.BC-Page__DashboardV3
  .BC-Notifications_DashboardV3
  .notification-item
  .BC-Notification_Dismiss_WithActionButton {
  bottom: 35px;
}

.BC-CrossSellUpSell__DashboardV3 .Polaris-Heading,
.BC-RecommendedApps__DashboardV3 .Polaris-Heading,
.BC-QuickStartGuide__DashboardV3 .Polaris-Heading .BC-SyncHookStatus__DashboardV3 .Polaris-Heading,
.BC-ChangeLogs__Dashboard .Polaris-Heading,
.BC-Subscription__DashboardV3 .Polaris-Heading,
.BC-ThemeSetup__DashboardV3 .Polaris-Heading,
.BC-OptionInEmail__DashboardV3 .option-email-content .Polaris-Heading,
.BC-Support-Feature__DashboardV3 .section .Polaris-Heading,
.BC-AppInsight__DashboardV3 .Polaris-Heading {
  font-size: 20px;
  line-height: 28px;
}

.BC-OptionInEmail__DashboardV3 .option-email-content > p,
.BC-Support-Feature__DashboardV3 .section > p {
  margin-top: 8px;
  color: #6d7175;
  font-size: 14px;
  line-height: 20px;
}

.BC-Welcome__DashboardV3 .Polaris-DisplayText--sizeSmall {
  font-size: 16px;
  line-height: 24px;
  margin-top: 8px;
}

.BC-Welcome__DashboardV3 .Polaris-Layout {
  display: inherit;
}

.BC-Notifications_DashboardV3 {
  width: 100%;
  height: auto;
}

.small-screen {
  margin-top: -30px;
}

.BC-Notifications_DashboardV3 .notification .Polaris-Banner .Polaris-Banner__ContentWrapper {
  margin-bottom: 40px;
}

.BC-Notifications_DashboardV3 .notification-item .Polaris-Banner .Polaris-Banner__ContentWrapper {
  margin-bottom: 0px;
}

.BC-Notifications_DashboardV3 .notification {
  width: 100%;
  height: auto;
}

.BC-Notifications_DashboardV3 .notification .link-add-new a {
  color: #202223;
}

.BC-Notifications_DashboardV3 .BC-Carousel {
  position: relative;
  height: auto;
}

.BC-Notifications_DashboardV3 .BC-Carousel .carousel-controls {
  position: absolute;
  bottom: 20px;
  left: 45px;
}

.BC-Notifications_DashboardV3 .carousel-item {
  width: 100%;
  height: fit-content;
}

.BC-Notifications_DashboardV4 .Polaris-Card__Section {
  padding: 16px;
}

.BC-Notifications_DashboardV4 .Polaris-Card__Section .carousel-cards {
  margin-bottom: 0;
}

.BC-Notifications_DashboardV4 .Polaris-Card__Section .carousel-item {
  width: 100%;
  padding-left: 1px;
}

/* installation status */
.BC-InstallationStatus__Dashboard {
  display: flex;
  padding: 20px;
  gap: 10px;
  background: #f1f8f5;
  border: 1px solid #95c9b4;
  border-radius: 8px;
}

.BC-InstallationStatus__Popup {
  display: flex;
  padding: 20px;
  gap: 10px;
  background: #fff;
  border-radius: 8px;
  position: fixed;
  width: 360px;
  bottom: 180px;
  right: 40px;
  z-index: 521;
  box-shadow:
    0 26px 80px 0 rgba(0, 0, 0, 0.2),
    0 0 2px 0 rgba(0, 0, 0, 0.2);
}

.BC-InstallationStatus__Popup .icon-status,
.BC-InstallationStatus__Dashboard .icon-status {
  margin-top: 4px;
}

.BC-InstallationStatus__Popup .info-status .Polaris-Icon,
.BC-InstallationStatus__Dashboard .info-status .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  width: 1rem;
  height: 1.2rem;
  margin-left: 4px;
}

.BC-InstallationStatus__Popup .info-status .action-list a,
.BC-InstallationStatus__Popup .info-status a,
.BC-InstallationStatus__Dashboard .info-status .action-list a,
.BC-InstallationStatus__Dashboard .info-status a {
  color: #2c6ecb !important;
}

.BC-InstallationStatus__Popup .info-status .action-list a,
.BC-InstallationStatus__Dashboard .info-status .action-list a {
  margin-left: 4px;
}

.BC-InstallationStatus__Popup .info-status .action-list > p,
.BC-InstallationStatus__Dashboard .info-status .action-list > p {
  color: #6d7175;
  margin-left: auto;
  display: flex;
  align-items: center;
}

.BC-InstallationStatus__Popup .info-status .action-list .Polaris-Icon svg,
.BC-InstallationStatus__Popup .info-status .content .Polaris-Icon svg,
.BC-InstallationStatus__Dashboard .info-status .action-list .Polaris-Icon svg,
.BC-InstallationStatus__Dashboard .info-status .content .Polaris-Icon svg {
  fill: #2c6ecb;
}

.BC-InstallationStatus__Popup .info-status > div:first-child,
.BC-InstallationStatus__Dashboard .info-status > div:first-child {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #008060;
  display: flex;
  justify-content: space-between;
}

.BC-InstallationStatus__Popup .info-status .content {
  display: grid;
  gap: 20px;
  margin: 10px 30px 20px 0;
}

.BC-InstallationStatus__Dashboard .info-status .content {
  display: grid;
  gap: 20px;
  margin: 10px 0 20px 0;
}

.BC-InstallationStatus__Popup .info-status .action-list,
.BC-InstallationStatus__Dashboard .info-status .action-list {
  display: flex;
  gap: 10px;
}

.BC-InstallationStatus__ChildPage {
  display: flex;
  padding: 10px;
  gap: 10px;
  background: #f1f8f5;
  border: 1px solid #95c9b4;
  border-radius: 6px;
}

.BC-InstallationStatus__ChildPage .icon-status {
  margin-top: 5px;
}

.BC-InstallationStatus__ChildPage .info-status .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  width: 1rem;
  height: 1.2rem;
  margin-left: 4px;
}

.BC-InstallationStatus__ChildPage .info-status > div:first-child {
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  color: #008060;
  display: flex;
  justify-content: space-between;
}

/* =============== */

.BC-SendRequestReport__Form .Polaris-FormLayout__Item:first-child {
  padding-top: 20px;
}

.BC-SendRequestReport__Form
  .Polaris-FormLayout__Item
  .Polaris-ChoiceList
  .Polaris-ChoiceList__Choices {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 12px;
}

/* quick start guide */
.BC-QuickStartGuide__DashboardV3 .heading {
  display: flex;
  justify-content: space-between;
  margin-bottom: 17px;
}

.BC-QuickStartGuide__DashboardV3 .progress-bar {
  display: flex;
  gap: 7px;
  align-items: center;
}

.BC-QuickStartGuide__DashboardV3 .progress-bar .progress {
  width: 100%;
}

.BC-QuickStartGuide__DashboardV3 .progress-bar .progress .Polaris-ProgressBar--colorCritical {
  --pc-progress-bar-background: var(--p-surface-neutral);
  --pc-progress-bar-indicator: #b98900;
}

.BC-QuickStartGuide__DashboardV3 .progress-bar > p {
  min-width: 94px;
}

.BC-QuickStartGuide__DashboardV3 .detail-guide {
  display: flex;
  gap: 9px;
  margin-bottom: 20px;
  margin-top: 8px;
}

.BC-QuickStartGuide__DashboardV3 .detail-guide img,
.BC-QuickStartGuide__DashboardV3 .detail-guide .Polaris-Icon {
  margin-top: 4px;
  min-width: 18px;
  min-height: 18px;
}

.BC-QuickStartGuide__DashboardV3 .detail-guide .content p,
.BC-QuickStartGuide__DashboardV3 .sub-action {
  color: #6d7175;
}

.BC-QuickStartGuide__DashboardV3 .sub-action {
  min-width: 31px;
  min-height: 22px;
  display: flex;
}

.BC-QuickStartGuide__DashboardV3 .sub-action:hover {
  cursor: pointer;
  color: #4e5053;
}

.BC-QuickStartGuide__DashboardV3 .detail-guide .content .Polaris-TextStyle--variationStrong {
  margin-bottom: 4px;
}

.BC-QuickStartGuide__DashboardV3 .action-list {
  display: flex;
  gap: 30px;
  align-items: center;
}

/* banners marketing */
.BC-CampaignCarousel__DashboardV3 {
  height: 100%;
  position: relative;
}

.BC-CampaignCarousel__DashboardV3 .BC-Carousel {
  position: relative;
}

.BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-item {
  width: 100%;
  border-radius: 8px;
  background-repeat: no-repeat !important;
  background-position: left top !important;
  background-size: 100% !important;
  position: relative;
}

.BC-CampaignCarousel__DashboardV3 .carousel-item.carousel-item-custom-freemium .banner {
  padding: 10px 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}

.BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-item.carousel-item-custom-freemium > div {
  width: 100%;
  height: 100%;
  background-position: right;
  background-size: 320px 130px;
  background-repeat: no-repeat;
  padding: 20px 10px;
}

.BC-CampaignCarousel__DashboardV3
  .BC-Carousel
  .carousel-item.carousel-item-custom-freemium
  .action {
  display: flex;
  align-items: center;
}

.BC-CampaignCarousel__DashboardV3
  .BC-Carousel
  .carousel-item.carousel-item-custom-freemium
  .action
  .Polaris-Button {
  position: unset !important;
  background: var(--decorative-surface-one, #ffc96b);
  font-weight: 500;
  margin-right: 0.75rem;
  align-items: center;
  border: unset;
}

.BC-CampaignCarousel__DashboardV3
  .BC-Carousel
  .carousel-item.carousel-item-custom-freemium
  .action
  .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
}

.BC-CampaignCarousel__DashboardV3 .carousel-item.carousel-item-custom-freemium .banner > span {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0px;
}

.BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-item > div {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 30px 20px 10px 10px;
}

.BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-item .Polaris-Button {
  position: absolute;
  right: 20px;
  top: 15px;
}

.BC-CampaignCarousel__DashboardV3 .Polaris-Button--plain.Polaris-Button--iconOnly svg:hover,
.BC-CampaignCarousel__DashboardV3 .Polaris-Button--plain.Polaris-Button--iconOnly svg {
  fill: white;
}

.BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-controls {
  justify-content: center;
  position: absolute;
  width: 100%;
  bottom: 10px;
}

.BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-cards {
  margin: 0 !important;
  min-height: 130px;
}

@media (max-width: 1040px) {
  .BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-cards {
    min-height: 127px;
  }
}

@media (max-width: 1040px) {
  .BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-cards {
    min-height: 127px;
  }
}

@media (max-width: 980px) {
  .BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-cards {
    min-height: 119px;
  }
}

@media (max-width: 820px) {
  .BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-cards {
    min-height: 111px;
  }
}

.BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-controls .carousel-pagination--active div {
  width: 10px;
  height: 10px;
}

.BC-CampaignCarousel__DashboardV3 .BC-Carousel .banner {
  width: 100%;
  height: 100%;
}

.BC-CampaignCarousel__DashboardV3 .BC-Carousel .banner:hover,
.BC-CampaignBanner__DashboardV4:hover {
  cursor: pointer;
}

.BC-CampaignBanner__DashboardV4 {
  display: flex;
  align-items: center;
  position: relative;
  box-shadow:
    0px 0px 1px 0px #00000040,
    0px 2px 1px 0px #0000000d;
  border-radius: 8px;
  background-color: #fff;
}

.BC-CampaignBanner__DashboardV4 .close {
  cursor: pointer;
  position: absolute;
  top: 16px;
  right: 14px;
}

.BC-CampaignBanner__DashboardV4__Content {
  padding: 24px 20px;
}

.BC-ChangeLogs__Dashboard .BC-ChangeLogs__Dashboard__ChangelogWrapper {
  max-height: 280px;
  overflow-y: auto;
}

.BC-ChangeLogs__Dashboard .btn-view-all .Polaris-Button {
  padding: 0;
}

.BC-ChangeLogs__Dashboard .btn-view-all .Polaris-Button .Polaris-Button__Text {
  width: 100%;
  display: block;
}

.BC-ChangeLogs__Dashboard .btn-view-all .Polaris-Link {
  color: #202223;
  font-weight: 600;
  height: 36px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.BC-ChangeLogs__Dashboard__Changelog {
  padding: 12px;
  background-color: #fafbfb;
  border-radius: 4px;
}

.BC-ChangeLogs__Dashboard .changelog-tag {
  padding: 2px 8px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 12px;
  margin-bottom: 8px;
  display: inline-block;
}

.BC-ChangeLogs__Dashboard__Changelog > ul {
  margin: 0;
}

.BC-ChangeLogs__Dashboard .changelog-tag.changelog-tag--new {
  background-color: #e0f0ff;
  color: #00527c;
}

.BC-ChangeLogs__Dashboard .changelog-tag.changelog-tag--improve {
  background-color: #cdfee1;
  color: #00527c;
}

.BC-ChangeLogs__Dashboard .changelog-tag.changelog-tag--fixed {
  background-color: #ffd6a4;
  color: #5e4200;
}

/* cross sell up sell */

.BC-Carousel .carousel-cards {
  position: relative;
  display: flex;
  overflow: hidden;
  gap: 20px;
  scroll-snap-type: x mandatory;
  list-style: none;
  padding-left: 0px;
}

.BC-Carousel .carousel-item {
  flex-shrink: 0;
}

.BC-Carousel .carousel-controls {
  display: flex;
  align-items: center;
}

.BC-Carousel .carousel-controls button {
  background: unset !important;
  border: unset !important;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.BC-Carousel .carousel-controls .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
}

.BC-Carousel .carousel-pagination-btn--active,
.BC-Carousel .carousel-btn--disabled {
  opacity: 0.3;
}

.BC-Carousel .carousel-pagination--active div {
  background: #007f5f !important;
}

.BC-Carousel .carousel-pagination div {
  width: 6px;
  height: 6px;
  background: #8c9196;
  border-radius: 100%;
}

.BC-Carousel .carousel-pagination .Polaris-Icon {
  width: 6px;
  height: 7px;
}

.BC-Carousel {
  position: relative;
}

.BC-Carousel .slide-controls .Polaris-Icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 0px;
  background: #0000001a;
  margin-top: 73%;
}

.BC-Carousel .slide-controls > div {
  position: absolute;
  top: 0;
  height: 100%;
  width: 200px;
}

.BC-Carousel .slide-controls > div:hover {
  cursor: pointer;
}

.BC-Carousel .slide-controls .btn-next {
  right: 0;
}

.BC-Carousel .slide-controls .btn-next .Polaris-Icon {
  margin-right: 0;
}

.BC-Carousel .slide-controls .btn-prev {
  left: 0;
}

.BC-Carousel .slide-controls .btn-prev .Polaris-Icon {
  margin-left: 0;
}

.BC-Carousel .slide-controls .Polaris-Icon svg {
  fill: #575959;
  min-height: 16px;
  min-width: 16px;
}

.BC-CrossSellUpSell__DashboardV3 .feature-list {
  margin-top: 20px;
}

.BC-CrossSellUpSell__DashboardV3 .feature-list .card {
  padding: 20px;
  width: 330px;
  min-height: 228px;
  position: relative;
  border-radius: 4px;
}

.BC-CrossSellUpSell__DashboardV3 .feature-list .card h2 {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin: 8px 0;
}

.BC-CrossSellUpSell__DashboardV3 .feature-list .card h1 {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  margin: 8px 0;
}

.BC-CrossSellUpSell__DashboardV3 .feature-list .card .Polaris-TextStyle--variationSubdued {
  margin-bottom: 16px;
}

.BC-CrossSellUpSell__DashboardV3 .feature-list .card-addon {
  background-image: url('https://cdn.boostcommerce.io/assets/dashboard-v3/addon-background.png');
  background-size: 330px 228px;
}

.BC-CrossSellUpSell__DashboardV3 .feature-list .card-feature {
  background-image: url('https://cdn.boostcommerce.io/assets/dashboard-v3/feature-background.png');
  background-size: 330px 228px;
}

.BC-CrossSellUpSell__DashboardV3 .feature-list .card-other {
  background-image: url('https://cdn.boostcommerce.io/assets/dashboard-v3/other-background.png');
  background-size: 330px 228px;
}

.BC-CrossSellUpSell__DashboardV3 .feature-list .card-addon .Polaris-Button {
  background: #ffc96b;
  box-shadow:
    0px 1px 0px rgba(0, 0, 0, 0.08),
    inset 0px -1px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.BC-CrossSellUpSell__DashboardV3 .feature-list .card-addon .Polaris-Button--disabled {
  box-shadow: unset;
  background: #f3eee5;
}

.BC-CrossSellUpSell__DashboardV3 .feature-list .card-addon .sub-text {
  line-height: 20px;
  margin-top: 4px;
  color: #d72c0d;
}

.BC-CrossSellUpSell__DashboardV3 .card .Polaris-Button {
  position: absolute;
  bottom: 20px;
}

.BC-CrossSellUpSell__DashboardV3 .card .Polaris-Badge > span {
  display: flex;
  width: 100%;
  gap: 8px;
  padding: 0 5px;
  justify-content: center;
}

.BC-CrossSellUpSell__DashboardV3 .card .Polaris-Badge .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  width: 1rem;
  height: 1rem;
}

.BC-CrossSellUpSell__DashboardV3 .card .Polaris-Badge--statusWarning .Polaris-Icon svg {
  fill: #f48d32;
}

.BC-CrossSellUpSell__DashboardV3 .card .Polaris-Badge {
  min-height: 24px;
  max-width: 97px;
}

.BC-CrossSellUpSell__DashboardV3 .card .Polaris-Badge--statusWarning {
  background: #ffebd3;
}

.BC-CrossSellUpSell__DashboardV3 .card .Polaris-Badge--statusInfo {
  background: #e5effd;
}

.BC-CrossSellUpSell__DashboardV3 .card .Polaris-Badge--statusInfo .Polaris-Icon svg {
  fill: #2c6ecb;
}

/* sync */
.BC-SyncHookStatus__DashboardV3 .Polaris-Heading {
  margin-bottom: 18px;
}

.BC-SyncHookStatus__DashboardV3 .Polaris-Card .Polaris-ProgressBar .Polaris-ProgressBar__Label {
  color: var(--pc-progress-bar-indicator);
  text-indent: -9999px;
}

.BC-SyncHookStatus__DashboardV3 .Polaris-Card .Polaris-ProgressBar--sizeMedium {
  height: 6px;
}

.BC-SyncHookStatus__DashboardV3 .Polaris-Card .progress-caption {
  margin-top: 20px;
}

.BC-SyncHookStatus__DashboardV3 .Polaris-Card .progress-status {
  margin-top: 16px;
  display: grid;
}

.BC-SyncHookStatus__DashboardV3 .Polaris-Card .progress-status > strong {
  margin-bottom: 8px;
}

.BC-SyncHookStatus__DashboardV3 .Polaris-Card .progress-step-status {
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  margin-top: 8px;
  display: flex;
  gap: 5px;
}

.BC-SyncHookStatus__DashboardV3 .Polaris-Card .progress-step-status img {
  margin-top: 3px;
}

/* subscription status */
.BC-ThemeSetup__DashboardV3 .Polaris-Card,
.BC-Subscription__DashboardV3 .Polaris-Card {
  height: 230px;
}

.BC-Subscription__DashboardV3 .Polaris-Card .Polaris-Card__Section {
  display: flex;
}

.BC-Subscription__DashboardV3 .Polaris-Card .img {
  max-width: 200px;
}

.BC-Subscription__DashboardV3 .Polaris-Card .current-package {
  margin-top: 14px;
  height: 24px;
}

.BC-Subscription__DashboardV3 .Polaris-Card .current-package .Polaris-TextStyle--variationStrong {
  font-size: 16px;
  line-height: 24px;
  margin-right: 8px;
}

.BC-Subscription__DashboardV3 .Polaris-Card .current-package .Polaris-Badge {
  height: 100%;
  min-width: 96px;
}

.BC-Subscription__DashboardV3 .Polaris-Card .Polaris-Badge--statusNew span {
  font-weight: 400;
}

.BC-Subscription__DashboardV3 .Polaris-Card .current-package .Polaris-Badge span {
  margin: auto;
}

.BC-Subscription__DashboardV3 .Polaris-Card .subscribe__bottom {
  margin-top: 14px;
}

.BC-Subscription__DashboardV3 .subscribe__action {
  position: absolute;
  bottom: 23px;
  display: flex;
  gap: 10px;
  align-items: center;
}

.BC-Subscription__DashboardV3 .subscribe-money-back {
  color: #d72c0d;
}

@media (max-width: 768px) {
  .BC-ThemeSetup__DashboardV3 .Polaris-Card,
  .BC-Subscription__DashboardV3 .Polaris-Card {
    height: unset;
  }

  .BC-Subscription__DashboardV3 .Polaris-Card .Polaris-Card__Section {
    flex-direction: column;
  }
}

/* change logs */
.BC-ChangeLogs__Dashboard .date {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-top: 20px;
}

.BC-ChangeLogs__Dashboard .list-badge {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  margin: 8px 0 18px 0;
}

.BC-ChangeLogs__Dashboard .list-badge .Polaris-Badge {
  font-size: 12px;
  font-weight: 400;
}

.BC-ChangeLogs__Dashboard .detail-logs ul {
  margin-top: 6px;
  font-size: 14px;
  line-height: 20px;
  padding-left: 20px;
}

.BC-ChangeLogs__Dashboard .Polaris-Button {
  width: 100%;
}

/* Theme status */
.BC-ThemeSetup__DashboardV3 .Polaris-Card .Polaris-Card__Section {
  padding: unset;
}

.BC-ThemeSetup__DashboardV3 .Polaris-Card .Polaris-Card__Section .layoutCols .firstCol {
  padding: 32px 20px;
  display: grid;
  gap: 20px;
}

.BC-ThemeSetup__DashboardV3
  .Polaris-Card
  .Polaris-Card__Section
  .layoutCols
  .firstCol
  .content-status {
  min-height: 100px;
  font-size: 14px;
  line-height: 20px;
}

.BC-ThemeSetup__DashboardV3 .secondCol {
  max-width: 140px;
}

/* recommended apps */
.BC-RecommendedApps__DashboardV3 .Polaris-Card__Section > .Polaris-TextStyle--variationSubdued {
  line-height: 20px;
  margin-top: 8px;
}

.BC-RecommendedApps__DashboardV3 .apps-recommended {
  max-width: 256px;
  min-height: 464px;
}

.BC-RecommendedApps__DashboardV3 .app-detail {
  margin-top: 20px;
  background: #fafbfb;
  border-radius: 4px;
  padding: 16px;
  min-height: 240px;
}

.BC-RecommendedApps__DashboardV3 .app-detail .Polaris-Link {
  display: flex;
  gap: 12px;
  color: black;
  text-decoration: none;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
}

.BC-RecommendedApps__DashboardV3 .app-detail img {
  max-width: 40px;
  max-height: 40px;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.07);
  border-radius: 8px;
}

.BC-RecommendedApps__DashboardV3 .app-detail:last-child {
  margin-bottom: 20px;
}

.BC-RecommendedApps__DashboardV3 .app-detail .description {
  margin: 12px 0;
}

.BC-RecommendedApps__DashboardV3 .app-detail .rating {
  margin-bottom: 4px;
}

.BC-RecommendedApps__DashboardV3 .app-detail .rating .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  margin-right: 4px;
  width: 14px;
  height: 16px;
}

.BC-RecommendedApps__DashboardV3 .app-detail .rating .Polaris-Icon svg {
  fill: #f48d32;
}

/* Support feature block*/
.BC-Support-Feature__DashboardV3 .Polaris-Card .Polaris-Card__Section {
  padding: unset;
}

.BC-Support-Feature__DashboardV3 .Polaris-Card .section {
  border-bottom: 1px solid #e1e3e5;
  padding: 20px;
}

.BC-Support-Feature__DashboardV3 .section > .action-list {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  flex-direction: row;
  gap: 20px;
}

.BC-Support-Feature__DashboardV3 .section > .action-list-mini {
  display: grid;
}

.BC-Support-Feature__DashboardV3 .section > .action-list .card-action {
  display: flex;
  gap: 12px;
  background: #fafbfb;
  border-radius: 4px;
  align-items: center;
  padding: 20px;
  min-height: 60px;
  width: 100%;
  max-width: 226px;
}

.PFS_MainMenu_Wrapper {
  width: 100%;
}

.BC-Support-Feature__DashboardV3 .section > .action-list .card-action:hover {
  cursor: pointer;
  background-color: #f0f8f8;
}

/* START: Custom for dashboard v4 */
.BC-AnotherLayoutV3.V2 .small-screen {
  margin-top: 0;
}

.BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .Polaris-Page {
  padding: 0;
}

.BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .Polaris-Page__Content {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 0;
}

.PFS_MainMenu:has(.PFS_MainMenu--Mini) {
  display: none;
}

.PFS_MainMenu--Mini {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.PFS_MainMenu--Mini .left {
  display: flex;
  align-items: center;
  opacity: 0.7;
  width: 50px;
  justify-content: center;
}

.PFS_MainMenu--Mini .right {
  display: flex;
}

.Polaris-PositionedOverlay:has(.menu-mobile) {
  left: 10px !important;
}

.Polaris-PositionedOverlay:has(.menu-mobile) .Polaris-Popover__Content {
  min-height: 220px;
}

.menu-mobile {
  padding: 10px;
}

.menu-mobile .main-item {
  display: flex;
  text-align: left;
}

.menu-mobile .main-item .Polaris-Icon {
  margin: 0;
  margin-right: 4px;
}

.menu-mobile .main-item .Polaris-Icon svg {
  fill: #5c5f62;
}

.BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .BC-Page__FirstColumn {
  margin: 0;
  width: unset;
  display: flex;
  flex-direction: column;
  max-width: calc(100% - 320px - 20px);
  position: sticky;
  top: 50px;
  height: 100%;
}

.BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .BC-Page__SecondColumn {
  width: unset;
  width: 320px;
}

.BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .Polaris-Page__Content .Polaris-Layout {
  margin-left: 0;
  margin-top: 0;
}

@media screen and (max-width: 1050px) {
  .BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .Polaris-Page {
    padding: 0 30px;
  }
}

@media screen and (max-width: 940px) {
  .BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .Polaris-Page__Content {
    display: flex;
    flex-direction: column;
  }

  .BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .BC-Page__FirstColumn {
    width: 100%;
    max-width: 100%;
  }

  .BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .BC-Page__SecondColumn {
    width: 100%;
    display: flex;
    max-height: unset !important;
    overflow: unset !important;
  }

  .PFS_MainMenu .menuItem .main-item {
    text-wrap: nowrap;
  }
}

@media screen and (max-width: 820px) {
  .PFS_MainMenu_Wrapper {
    width: 100%;
  }

  .PFS_MainMenu_Wrapper .menu-features .menuItem {
    display: flex;
    justify-content: flex-start;
    max-width: 115px;
    overflow: hidden;
  }
}

@media screen and (max-width: 768px) {
  .PFS_MainMenu_Wrapper {
    width: 100%;
  }

  .PFS_MainMenu_Wrapper .menu-features,
  .PFS_MainMenu_Wrapper .menu-settings {
    display: flex;
    flex-direction: column;
  }

  .PFS_MainMenu_Wrapper .menu-features .menuItem,
  .PFS_MainMenu_Wrapper .menu-settings .menuItem {
    display: flex;
    justify-content: flex-start;
    max-width: 300px;
  }

  .PFS_MainMenu {
    display: none !important;
  }

  .PFS_MainMenu:has(.PFS_MainMenu--Mini) {
    display: block !important;
  }
}

.BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .BC-Page__FirstColumn .Polaris-Layout,
.BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .BC-Page__SecondColumn .Polaris-Layout {
  width: 100%;
  margin: 0;
}

.BC-AnotherLayoutV3.V2 .Polaris-Layout__Section {
  max-width: calc(100% - var(--p-space-6));
  max-width: unset;
}

.BC-AnotherLayoutV3.V2 .BC-Notifications_DashboardV3 ul {
  margin: 0;
}

.BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .BC-Page__FirstColumn .Polaris-Layout {
  padding: unset !important;
}

.BC-AnotherLayoutV3.V2 .Polaris-Layout__Section {
  margin-left: 0;
}

.BC-HelpAndSupport__DashboardV3 .Polaris-Button,
.BC-ResourceCenter__DashboardV3 .Polaris-Button {
  width: 140px;
  padding: 0;
}

.BC-HelpAndSupport__DashboardV3 .Polaris-Button .Polaris-Button__Text,
.BC-ResourceCenter__DashboardV3 .Polaris-Button .Polaris-Button__Text {
  align-items: center;
  display: flex;
  gap: 10px;
}

/* Option in email */
.BC-OptionInEmail__DashboardV3 .Polaris-Card .Polaris-Card__Section {
  display: flex;
  width: 100%;
}

.BC-OptionInEmail__DashboardV3 .Polaris-Card .Polaris-Card__Section .option-email-content {
  width: 100%;
}

.BC-OptionInEmail__DashboardV3 .Polaris-Card .Polaris-Card__Section > div:first-child {
  padding: 20px 20px 20px 0;
  width: 100%;
}

.BC-OptionInEmail__DashboardV3 .Polaris-Card .Polaris-Card__Section > div .option-input {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 20px;
  width: 100%;
}

.BC-OptionInEmail__DashboardV3 .Polaris-Card .Polaris-Card__Section > div .option-input > div {
  flex: 40% 1;
}

.BC-OptionInEmail__DashboardV3
  .Polaris-Card
  .Polaris-Card__Section
  > div
  .option-input
  > *:not(:first-child) {
  margin-top: unset;
}

.BC-OptionInEmail__DashboardV3 .Polaris-Card .Polaris-Card__Section .background-image {
  margin-left: 20px;
  width: 57%;
  height: auto;
}

.BC-OptionInEmail__DashboardV3 .Polaris-Card .Polaris-Card__Section .background-image img {
  width: 100%;
  height: 100%;
}

.BC-AppInsight__DashboardV3 .Polaris-Card__Header .header-action {
  display: flex;
  align-items: center;
  gap: 15px;
}

.BC-AppInsight__DashboardV3 .Polaris-Card__Header .BC-Analytics__Filter {
  margin: 0;
}

.BC-AppInsight__DashboardV3 .Polaris-Card__Header .BC-Analytics__Filter .tooltip {
  display: none;
}

.BC-AppInsight__DashboardV3 .Polaris-Card__Section {
  padding: 15px;
}

.BC-AppInsight__DashboardV3 .content .list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
}

@media screen and (max-width: 764px) {
  .BC-AppInsight__DashboardV3 .content .list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 460px) {
  .BC-AppInsight__DashboardV3 .content .list {
    grid-template-columns: 1fr;
  }
}

.BC-AppInsight__DashboardV3 .content .list .item {
  display: flex;
  min-height: 90px;
  background: #fafbfb;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  padding: 16px;
}

.BC-AppInsight__DashboardV3 .content .list .item.item--ai-insight {
  flex-wrap: nowrap;
  background: linear-gradient(321.74deg, #e3fffa -3.64%, #d0ffd3 91.45%);
  justify-content: space-between;
}

.BC-AppInsight__DashboardV3 .content .list .item.item--ai-insight .blue-star {
  margin-right: 4px;
}

.BC-AppInsight__DashboardV3 .content .list .item.item--ai-insight .tag-AI {
  background: #42ffd026;
  border-radius: 50%;
  padding: 3px 8px;
  max-width: max-content;
}

.BC-AppInsight__DashboardV3 .content .list .item .title {
  display: flex;
  align-items: center;
  gap: 8px;
  width: calc(100% - 60px);
}

.BC-AppInsight__DashboardV3 .content .list .item.item--ai-insight .title {
  width: auto;
}

.BC-AppInsight__DashboardV3 .content .list .item .title p {
  font-weight: 600;
  font-size: 14px;
  color: #202223;
  display: inline-block;
  border-bottom: 3px dotted #bcbcbc;
}

.BC-AppInsight__DashboardV3 .content .list .item .img {
  width: 58px;
  display: flex;
}

.BC-AppInsight__DashboardV3 .content .list .item .value-wrapper {
  display: flex;
  align-items: baseline;
  margin-top: 12px;
}

.BC-AppInsight__DashboardV3 .content .list .item .value {
  font-weight: 600;
  font-size: 28px;
  margin-right: 10px;
  color: #202223;
}

.BC-AppInsight__DashboardV3 .content .list .item .percent-change {
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.BC-AppInsight__DashboardV3 .content .list .item .percent-change.up,
.BC-AppInsight__DashboardV3 .content .list .item .percent-change.up svg path {
  color: #008060;
  fill: #008060;
}

.BC-AppInsight__DashboardV3 .content .list .item .percent-change.down,
.BC-AppInsight__DashboardV3 .content .list .item .percent-change.down svg path {
  color: #d72c0d;
  fill: #d72c0d;
}

/* END: Custom for dashboard v4 */

/* .Polaris-Layout {
  border: 1px solid red;
}
.Polaris-Page {
  border: 1px solid blue;

} */
/*-------End Dashboard v3------------*/

.priceBox .subscribe-money-back,
.BC-CalloutCard-Subscription__Dashboard .subscribeBox .subscribe__bottom .subscribe-money-back {
  color: rgb(222, 54, 24);
  margin-top: 10px;
  font-style: italic;
}

.exceededPlanNotification .Polaris-Banner__Text::after {
  border: none;
}

.BC-Transition-enter {
  opacity: 0.01;
}

.BC-Transition-enter-active {
  opacity: 1;
  transition: opacity 500ms ease-out;
}

.BC-Transition-exit {
  opacity: 1;
}

.BC-Transition-exit-active {
  opacity: 0.01;
  transition: opacity 300ms ease-out;
}

.BC-Block-Dismiss--Right-Menu {
  position: absolute;
  right: 20px;
  top: 20px;
}

.BC-CalloutCard-ThemeSetup__Dashboard .firstCol .Polaris-Button,
.BC-CalloutCard-ExpReviewRating__Dashboard .firstCol .Polaris-Button {
  margin-top: 1rem;
  width: fit-content;
}

.subscribeBox .Polaris-TextContainer p {
  font-size: 12px;
  line-height: 1rem;
  margin-top: 0;
}

.subscribeBox .Polaris-TextContainer {
  min-height: 122px;
  display: flex;
  flex-wrap: wrap;
  text-align: center;
}

.subscribeBox .Polaris-TextContainer .Polaris-Heading {
  width: 100%;
}

.subscribeBox .Polaris-TextContainer .subscribe_badge,
.subscribeBox .Polaris-TextContainer .subscribe_dangerous,
.subscribeBox .Polaris-TextContainer .subscribe_warning {
  margin: 4px auto;
}

.subscribeBox .Polaris-TextContainer .subscribe_badge span.Polaris-Badge,
.subscribeBox .Polaris-TextContainer .subscribe_dangerous span.Polaris-Badge,
.subscribeBox .Polaris-TextContainer .subscribe_warning span.Polaris-Badge {
  margin-left: 4px;
  height: 1.5rem;
}

.subscribeBox .Polaris-TextContainer .subscribe_dangerous span.Polaris-Badge {
  background-color: #de3618;
  color: #ffff;
}

.subscribeBox .Polaris-TextContainer .subscribe_warning span.Polaris-Badge {
  /* background-color: #FFC453; */
  color: #202223;
}

.subscribeBox .Polaris-TextContainer .subscribe_badge span.Polaris-Badge:first-child,
.subscribeBox .Polaris-TextContainer .subscribe_dangerous span.Polaris-Badge:first-child,
.subscribeBox .Polaris-TextContainer .subscribe_warning span.Polaris-Badge:first-child {
  margin-left: 0;
}

.subscribeBox .Polaris-TextContainer .subscribe__bottom {
  align-self: flex-end;
  width: 100%;
  margin-top: 0;
}

.BC-Illustration-Image__Dashboard.BC-Remove-Image__Dashboard img {
  width: 373px;
  max-width: 100%;
}

/* ExpReviewRating */
#BC-UnsubscribeModal-Backdrop,
#BC-ExpReviewRatingModal-Backdrop {
  position: fixed;
  z-index: 519;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: rgba(33, 43, 54, 0.4);
}

#BC-UnsubscribeModal-Content,
#BC-ExpReviewRatingModal-Content {
  position: relative;
  width: 436px;
  min-height: 244px;
}

#BC-UnsubscribeModal-Content.success .Polaris-Card {
  background-image: url('https://cdn.boostcommerce.io/assets/dashboard/expReviewRating/modal/bg_Feedback.png');
  background-repeat: no-repeat;
  background-position-y: 50px;
  background-position-x: right;
  background-size: 164px auto;
}

#BC-ExpReviewRatingModal-FloatingButton {
  border-radius: 50%;
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 110px;
  right: 40px;
  z-index: 521;
}

@media (max-height: 740px) {
  #BC-ExpReviewRatingModal-FloatingButton {
    bottom: 80px;
    right: 20px;
  }
}

#BC-ExpReviewRatingModal-Button {
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
  padding: 0;
  background: none;
  border: none;
  min-width: unset;
  min-height: unset;
  cursor: pointer;
  z-index: 521;
}

#BC-UnsubscribeModal-Content .topImage,
#BC-ExpReviewRatingModal-Content .topImage {
  position: absolute;
  top: -22px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 520;
}

#BC-UnsubscribeModal-Content .topImage img,
#BC-ExpReviewRatingModal-Content .topImage img {
  width: 72px;
  height: 72px;
}

#BC-UnsubscribeModal-Content .Polaris-Card,
#BC-ExpReviewRatingModal-Content .Polaris-Card {
  padding-top: 1.875rem;
}

#BC-UnsubscribeModal-Content .Polaris-Card .Polaris-FormLayout .Polaris-FormLayout__Item textarea {
  max-height: 200px;
}

#BC-ExpReviewRatingModal-Content .rating .Polaris-Card .Polaris-Card__Section {
  padding: 1.25rem 3.75rem;
}

#BC-ExpReviewRatingModal-Content .rating .Polaris-Card {
  background-image: url('https://cdn.boostcommerce.io/assets/dashboard/expReviewRating/modal/bg.png');
  background-repeat: no-repeat;
  background-position-y: bottom;
  background-size: contain;
}

#BC-ExpReviewRatingModal-Content .submitted .Polaris-Card {
  background-image: url('https://cdn.boostcommerce.io/assets/dashboard/expReviewRating/modal/bg_Feedback.png');
  background-repeat: no-repeat;
  background-position-y: center;
  background-position-x: right;
  background-size: 168px auto;
}

#BC-ExpReviewRatingModal-Content .submitted-best-rating .Polaris-Card {
  background-image: url('https://cdn.boostcommerce.io/assets/dashboard/expReviewRating/modal/bg_Feedback.png');
  background-repeat: no-repeat;
  background-position-y: 100px;
  background-position-x: right;
  background-size: 168px auto;
}

#BC-ExpReviewRatingModal-Content .ratingLayout {
  text-align: center;
}

#BC-ExpReviewRatingModal-Content .ratingLayout p,
#BC-ExpReviewRatingModal-Content .ratingLayout .rating-star {
  padding-bottom: 1.5rem;
}

#BC-ExpReviewRatingModal-Content .submittedMessage {
  width: 21.875rem;
}

#BC-ExpReviewRatingModal-Content .Polaris-ChoiceList__Choices li:not(:first-child) {
  margin-top: 12px;
}

#BC-ExpReviewRatingModal-Content .Polaris-TextField--multiline > .Polaris-TextField__Input {
  max-height: 106px;
}

/* New language launch */
.BC-NewLanguageNotification__Wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-end;
}

.BC-NewLanguageNotification__Wrapper .BC-NewLanguageNotification__Content {
  -webkit-flex: 1 1 20rem;
  flex: 1 1 20rem;
}

.BC-NewLanguageNotification__Wrapper .BC-NewLanguageNotification__Content {
  margin: 1.25rem;
}

.BC-NewLanguageNotification__Wrapper .BC-NewLanguageNotification__Content .Polaris-TextContainer p {
  margin-top: 0.5rem;
}

.BC-NewLanguageNotification__Wrapper
  .BC-NewLanguageNotification__Content
  .Polaris-TextContainer
  .Polaris-ButtonGroup
  .Polaris-ButtonGroup__Item {
  margin-left: 0.5rem;
}

.BC-NewLanguageNotification__Wrapper .BC-NewLanguageNotification__Image {
  -webkit-flex: 1 1 25rem;
  flex: 1 1 25rem;
}

.BC-NewLanguageNotification__Wrapper img.BC-Illustration-Image__Dashboard {
  width: 326px;
  max-width: 100%;
}

/* Checklist onboarding */
.BC-OnboardingChecklist__OnPage {
  position: relative;
  max-width: 62.375rem;
  width: 100%;
  margin: 0 auto;
  padding: 0;
}

.BC-OnboardingChecklist__OnPage .BC-OnboardingChecklist {
  margin-top: 2.5rem;
}

.BC-OnboardingChecklist__OnPage .BC-OnboardingChecklist {
  background: #ffffff;
  box-shadow:
    0px 0px 0px rgba(63, 63, 68, 0.05),
    0px 1px 3px rgba(63, 63, 68, 0.15);
  border-radius: 3px;
}

.BC-Page__FilterTree-Management
  .BC-OnboardingChecklist__OnPage
  .Polaris-Card__Header
  + .Polaris-Card__Section,
.BC-Page__SuggestionDictionary .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
.BC-Page__Synonym .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
.BC-Page__ProductRanking .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
.BC-Page__Merchandising .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
.BC-Page__MerchandisingV2 .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
.BC-Page__Metafield .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
.BC-Page__CustomRangeSlider .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
.BC-Page__SwatchSettings .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
.BC-Page__CustomSorting .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
.BC-Page__Product-Visibility .BC-OnboardingChecklist__OnPage .Polaris-Card__Section {
  padding: 1rem;
}

@media (min-width: 30.625em) {
  .BC-OnboardingChecklist__OnPage .BC-OnboardingChecklist {
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .BC-Page__FilterTree-Management
    .BC-OnboardingChecklist__OnPage
    .Polaris-Card__Header
    + .Polaris-Card__Section,
  .BC-Page__SuggestionDictionary .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
  .BC-Page__Synonym .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
  .BC-Page__ProductRanking .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
  .BC-Page__Merchandising .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
  .BC-Page__MerchandisingV2 .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
  .BC-Page__Metafield .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
  .BC-Page__CustomRangeSlider .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
  .BC-Page__SwatchSettings .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
  .BC-Page__CustomSorting .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,
  .BC-Page__Product-Visibility .BC-OnboardingChecklist__OnPage .Polaris-Card__Section {
    padding: 1.25rem;
  }
}

@media (min-width: 46.5em) {
  .BC-OnboardingChecklist__OnPage .BC-OnboardingChecklist {
    margin-left: 2rem;
    margin-right: 2rem;
  }
}

.BC-OnboardingChecklist .Polaris-Card,
.BC-OnboardingArticles .Polaris-Card {
  border: 2px solid var(--p-decorative-one-surface);
}

.BC-OnboardingChecklist .Polaris-Card__Header {
  border-bottom: none;
}

.BC-OnboardingChecklist .Polaris-Card__Header,
.BC-OnboardingArticles .Polaris-Card__Header {
  background-color: var(--p-surface-warning-subdued);
}

.BC-OnboardingChecklist .Polaris-Card__Header,
.BC-OnboardingArticles .Polaris-Card__Header {
  border-bottom: 0.125rem solid var(--p-decorative-one-surface);
}

.BC-OnboardingChecklist.active .Polaris-Card {
  border-bottom: 0.125rem solid var(--p-decorative-one-surface);
}

.BC-OnboardingChecklist .Polaris-Card {
  border-bottom: 0rem solid var(--p-decorative-one-surface);
  transition: border-bottom 0.5s ease-in;
}

.BC-OnboardingChecklist .Polaris-ProgressBar__Indicator {
  background-color: var(--p-action-primary);
}

.BC-OnboardingChecklist .BC_Card-Header .Polaris-Heading .icon,
.BC-Finish-trial .icon {
  width: 16px;
  margin-left: 5px;
}

.BC-OnboardingChecklist .BC_Card-Header,
.BC-OnboardingChecklist .checklist .checklist-item {
  display: flex;
  justify-content: space-between;
}

.BC-OnboardingChecklist .BC_Card-Header .progress-bar {
  display: flex;
  margin-top: 3px;
}

.BC-OnboardingChecklist .BC_Card-Header .progress-bar .Polaris-TextStyle--variationStrong {
  min-width: 40px;
}

.BC-OnboardingChecklist .BC_Card-Header .progress-bar .progress {
  width: 13.75rem;
  margin: 6px 20px 0px 10px;
}

.BC-OnboardingChecklist .checklist .checklist-item {
  margin-top: 1.5625rem;
}

.BC-OnboardingChecklist .checklist .checklist-item:first-child {
  margin-top: 0rem;
}

.BC-OnboardingChecklist .checklist .checklist-item .item-description {
  display: flex;
  align-items: center;
}

.BC-OnboardingChecklist .checklist .checklist-item .item-description.completed p {
  text-decoration: line-through;
}

.BC-OnboardingChecklist .checklist .checklist-item .item-description .completed-icon,
.BC-OnboardingChecklist .checklist .checklist-item .item-description .un-completed-icon,
.BC-OnboardingChecklist .checklist-item-style_04 .step-icon {
  width: 26px;
  height: 26px;
  background-color: #919eab;
  color: white;
  border-radius: 50%;
  display: block;
  margin-right: 0.75rem;
}

.BC-OnboardingChecklist .checklist .checklist-item .item-description .completed-icon {
  width: 26px;
  height: 26px;
  padding: 0;
  margin-right: 0.75rem;
}

.BC-OnboardingChecklist
  .checklist
  .checklist-item-style_01.current
  .item-description
  .un-completed-icon,
.BC-OnboardingChecklist
  .checklist
  .checklist-item-style_03.current
  .item-description
  .un-completed-icon,
.BC-OnboardingChecklist .checklist-item-style_04.current .step-icon {
  background-color: var(--p-action-primary);
}

.BC-OnboardingChecklist .checklist .checklist-item-style_02 .item-description .un-completed-icon {
  background-color: #ffffff;
  border: 2px solid #c4cdd5;
}

.BC-OnboardingChecklist .checklist .checklist-item-style_03 .item-description .tooltip {
  margin-top: 4px;
}

.BC-OnboardingChecklist
  .checklist
  .checklist-item-style_03
  .item-description
  .Polaris-TextStyle--variationStrong {
  font-weight: 500;
}

.BC-OnboardingChecklist .checklist .checklist-item .item-description .un-completed-icon,
.BC-OnboardingChecklist .checklist-item-style_04 .step-icon {
  padding: 4px 9px;
  font-weight: 500;
}

.BC-OnboardingChecklist .checklist .checklist-item .completed-icon .Polaris-Icon {
  width: 1.625rem;
  height: 1.625rem;
}

.BC-OnboardingChecklist .checklist .checklist-item.current .item-description p {
  font-weight: 600;
}

.BC-OnboardingChecklist
  .checklist
  .checklist-item.checklist-item-style_03.current
  .item-description
  p {
  color: var(--p-action-primary);
}

.BC-OnboardingChecklist .checklist .checklist-item .item-action {
  display: none;
}

.BC-OnboardingChecklist .checklist .checklist-item .item-action button {
  min-width: 7.5rem;
}

.BC-OnboardingChecklist .checklist .checklist-item .item-action .Polaris-Button__Text {
  font-weight: 600;
}

.BC-OnboardingChecklist .checklist .checklist-item.current .item-action {
  display: block;
}

.BC-OnboardingChecklist .action-checklist {
  margin-top: 1.25rem;
}

.BC-OnboardingChecklist .action-checklist .action-skip {
  text-align: right;
}

.BC-OnboardingChecklist .action-checklist .action-skip .Polaris-Button__Text {
  color: #919eab;
}

.BC-OnboardingChecklist .Polaris-Button--plain.Polaris-Button--pressed,
.BC-OnboardingChecklist .Polaris-Button--plain:hover,
.BC-OnboardingChecklist .Polaris-Button--plain:focus,
.BC-OnboardingChecklist .Polaris-Button--plain:active,
.BC-OnboardingChecklist .Polaris-Button--monochrome.Polaris-Button--plain .Polaris-Button__Text {
  text-decoration: none;
}

.BC-OnboardingChecklist .checklist .checklist-item.checklist-item-style_04 {
  display: block;
}

.BC-OnboardingChecklist .checklist .checklist-item.checklist-item-style_04 .item-description {
  flex: 1 1 15.625rem;
  align-items: baseline;
}

.BC-OnboardingChecklist .checklist .checklist-item.checklist-item-style_04 .item-video {
  flex: 1 1 28.125rem;
}

.BC-OnboardingChecklist
  .checklist
  .checklist-item.checklist-item-style_04.current
  .item-description
  .step-title {
  color: var(--p-action-primary);
}

.BC-OnboardingChecklist
  .checklist
  .checklist-item.checklist-item-style_04.current
  .item-description
  p {
  font-weight: 400;
}

.BC-OnboardingChecklist .checklist-content > .Polaris-Layout > .Polaris-Layout__Section:last-child,
.BC-OnboardingArticles
  .BC-Article4__Content
  > .Polaris-Layout
  > .Polaris-Layout__Section:last-child {
  display: block;
}

.BC-OnboardingChecklist .checklist-content .checklist .BC-Checklist-Video__Wrapper,
.BC-OnboardingArticles .BC-Article4__Content .article-content .BC-Article-Video__Wrapper {
  display: none;
}

.BC-OnboardingChecklist .BC-Checklist-Video__Wrapper .BC-Checklist-Video__Container,
.BC-OnboardingArticles .BC-Article4__Content .BC-Article-Video__Container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
}

.BC-OnboardingChecklist .BC-Checklist-Video__Wrapper .BC-Checklist-Video__Container img,
.BC-OnboardingArticles .BC-Article4__Content .BC-Article-Video__Container img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

@media (max-width: 46.5em) {
  .BC-OnboardingChecklist
    .checklist-content
    > .Polaris-Layout
    > .Polaris-Layout__Section:last-child,
  .BC-OnboardingArticles
    .BC-Article4__Content
    > .Polaris-Layout
    > .Polaris-Layout__Section:last-child {
    display: none;
  }

  .BC-OnboardingChecklist .checklist-content .checklist .BC-Checklist-Video__Wrapper,
  .BC-OnboardingArticles .BC-Article4__Content .article-content .BC-Article-Video__Wrapper {
    display: block;
    margin-top: 1.25rem;
  }
}

.BC-OnboardingArticles .BC-Article4__Content .article-content {
  margin-top: 1.375rem;
}

.BC-OnboardingArticles .BC-Article4__Content .article-content:first-child {
  margin-top: 0;
}

/* Onboarding transition */
.BC-OnboardingChecklist .transition-enter {
  transform: translateY(-1.25rem);
  opacity: 0;
  visibility: hidden;
  z-index: -1;
}

.BC-OnboardingChecklist .transition-enter-active {
  transform: translateY(0%);
  opacity: 1;
  visibility: visible;
  z-index: 1;
  transition: all 0.3s ease-in;
}

.BC-OnboardingChecklist .transition-exit {
  transform: translateY(0);
  opacity: 1;
  z-index: 1;
  visibility: visible;
}

.BC-OnboardingChecklist .transition-exit-active {
  transform: translateY(-1.25rem);
  opacity: 0;
  visibility: hidden;
  z-index: -1;
  transition: all 0.3s ease-out;
}

.BC-OnboardingChecklist .item-transition {
  overflow: hidden;
}

.BC-OnboardingChecklist .segment,
.BC-OnboardingArticles .segment {
  margin-top: 1.25rem;
}

.BC-PreOnboardingChecklist .icon .Polaris-Icon {
  width: 4rem;
  height: 4rem;
  padding: 1rem;
  background-color: #ebf5fa;
}

.BC-PreOnboardingChecklist .name {
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 700;
  margin-top: 0.75rem;
}

.BC-PreOnboardingChecklist .description {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: #212b36;
  margin: 0.25rem 3.125rem 0 3.125rem;
}

.BC-PreOnboardingChecklist button.Polaris-Button {
  margin-top: 1.25rem;
  margin-bottom: 0.5rem;
  padding: 0.5rem 2.5rem;
}

/* .BC-PreOnboardingChecklist button.Polaris-Button:hover {
  background: linear-gradient(to bottom, #6371c7, #5563c1);
  border-color: #3f4eae;
  box-shadow: inset 0 1px 0 0 #6774c8, 0 1px 0 0 rgb(22 29 37 / 5%), 0 0 0 0 transparent;
  color: white;
} */

.BC-OnboardingArticles .list-feature {
  display: flex;
  align-items: center;
  margin-top: 1.375rem;
}

.BC-OnboardingArticles .list-feature.current .title {
  color: var(--p-action-primary);
}

.BC-OnboardingArticles .list-feature:first-child {
  margin-top: 0;
}

.BC-OnboardingArticles .list-feature .icon,
.BC-OnboardingArticles .BC-Article4__Content .list-feature > button {
  margin-right: 0.75rem;
}

.BC-OnboardingArticles .BC-Article4__Content .list-feature {
  align-items: end;
}

.BC-OnboardingArticles .BC-Article4__Content .list-feature.not-current .Polaris-Icon {
  transform: rotate(90deg);
}

/* Recommended Apps block */
.BC_RecommendedApps-Sliders .title {
  display: flex;
  align-items: center;
  padding: 0 12px 12px 0;
}

.BC_AddonList-Sliders .title .icon,
.BC_RecommendedApps-Sliders .title .icon {
  display: block;
  height: 64px;
  width: 64px;
  margin: auto;
  filter: drop-shadow(0px 4px 24px rgba(0, 0, 0, 0.07));
}

.BC_RecommendedApps-Sliders .title .name {
  margin-left: 12px;
}

.BC_RecommendedApps-Sliders .title .name .Polaris-Link-Content {
  color: black;
  text-decoration: none;
  font-size: 16px;
  line-height: 24px;
}

.BC_RecommendedApps-Sliders .description {
  clear: both;
  padding-right: 10px;
}

.BC_RecommendedApps-Sliders {
  position: inherit;
}

.BC_AddonList-Sliders .react-multiple-carousel__arrow,
.BC_RecommendedApps-Sliders .react-multiple-carousel__arrow {
  min-width: 28px;
  min-height: 28px;
  background: rgba(0, 0, 0, 0.2);
  z-index: 517;
}

.BC_AddonList-Sliders .react-multiple-carousel__arrow--left,
.BC_RecommendedApps-Sliders .react-multiple-carousel__arrow--left {
  left: -10px;
}

.BC_AddonList-Sliders .react-multiple-carousel__arrow--left::before,
.BC_RecommendedApps-Sliders .react-multiple-carousel__arrow--left::before {
  content: '\\e822';
  margin-left: -2px;
}

.BC_AddonList-Sliders .react-multiple-carousel__arrow--right,
.BC_RecommendedApps-Sliders .react-multiple-carousel__arrow--right {
  right: -10px;
}

.BC_RecommendedApps-Sliders .react-multiple-carousel__arrow--right::before {
  content: '\\e823';
}

.BC_RecommendedApps-Sliders_Dot-list {
  margin-top: 12px;
  position: relative;
}

.BC_RecommendedApps-Sliders_Dot-list .react-multi-carousel-dot button {
  border: none;
}

.BC_RecommendedApps-Sliders_Dot-list .react-multi-carousel-dot button {
  background: #d9d9d9;
}

.BC_RecommendedApps-Sliders_Dot-list .react-multi-carousel-dot--active button {
  background: var(--p-text-success);
}

/* Filter tree page */
.BC-Page__FilterTree-Item .Polaris-Page-Header__TitleAndRollup {
  align-items: center;
}

.BC-Page__FilterTree-Item .Polaris-Page-Header__MainContent > .Polaris-Page-Header__PrimaryAction {
  display: none;
}

.BC-Page__FilterTree-Item
  .Polaris-Page-Header__MainContent
  > .Polaris-Page-Header__TitleAndActions {
  display: flex;
  justify-content: space-between;
}

.BC-Page__FilterTree-Item
  .Polaris-Page-Header__MainContent
  > .Polaris-Page-Header__TitleAndActions
  > div {
  flex: 2 2 22.5rem;
}

.BC-Page__FilterTree-Item
  .Polaris-Page-Header__MainContent
  > .Polaris-Page-Header__TitleAndActions
  .Polaris-Page-Header__Actions {
  flex: 1 1 13.75rem;
  justify-content: flex-end;
  align-items: baseline;
}

.BC-Page__FilterTree-Item .Polaris-Page-Header__PrimaryAction {
  display: block;
}

.BC-Page__FilterTree-Item
  .Polaris-Page-Header__Header--hasRollup
  .Polaris-Page-Header__SecondaryActions {
  justify-content: flex-end;
  margin-right: 1.25rem;
}

.BC-Page__FilterTree-Item .Polaris-Header-Action {
  border: 0.0625rem solid #c4cdd5;
  box-shadow: 0 1px 0 0 rgba(22, 29, 37, 0.05);
  border-radius: 3px;
}

.BC-Page__FilterTree-Item .Polaris-FormLayout,
.BC-Page__Merchandising .Polaris-FormLayout,
.BC-Page__Metafield .Polaris-FormLayout,
.BC-Page__Product-Visibility .Polaris-FormLayout,
.BC-Page__SwatchSettings .Polaris-FormLayout {
  margin-top: -1.25rem;
}

.BC-Page__FilterTree-Item .Polaris-FormLayout__Item,
.BC-Page__Merchandising-Rule .Polaris-FormLayout__Item {
  margin-top: 1.25rem;
}

.BC-Page__FilterTree-Item .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing,
.BC-Page__Merchandising-Rule .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {
  justify-content: flex-end;
}

.BC-Page__FilterTree-Item .Polaris-Card .Polaris-Button__Content,
.BC-Page__Merge-Value .Polaris-Card .Polaris-Button__Content {
  font-weight: 600;
}

.BC-DataTable__FilterOptions .Polaris-DataTable__Table,
.BC-DataTable__InstantSearchDisplay .Polaris-DataTable__Table {
  table-layout: fixed;
}

.BC-DataTable__FilterOptions .Polaris-DataTable__Cell,
.BC-DataTable__MergeValuesOptions .Polaris-DataTable__Cell,
.BC-DataTable__MergeValues .Polaris-DataTable__Cell,
.BC-DataTable__InstantSearchDisplay .Polaris-DataTable__Cell,
.BC-DataTable__SearchSettings .Polaris-DataTable__Cell {
  padding: 1.0625rem 0.625rem 1.0625rem 1.25rem;
  /* border-bottom: 0.0625rem solid var(--p-divider); */
  vertical-align: middle;
  word-wrap: break-word;
  white-space: inherit;
}

.BC-DataTable__SearchSettings thead tr .Polaris-DataTable__Cell {
  border-bottom: 0.0625rem solid var(--p-divider);
  height: 63px;
  font-weight: 600;
  font-size: 14px;
}

.BC-DataTable__SearchSettings .Polaris-DataTable__Cell-toggle {
  width: 8%;
}

.BC-DataTable__SearchSettings .Polaris-DataTable__Cell-searchField {
  width: 48%;
}

.BC-DataTable__SearchSettings .Polaris-DataTable__Cell-searchWeight {
  width: 44%;
}

.BC-DataTable__SearchSettings .Polaris-DataTable__Cell-searchWeight .Polaris-Select {
  width: 90%;
}

.BC-DataTable__FilterOptions .Polaris-DataTable__TableRow:last-child .Polaris-DataTable__Cell,
.BC-DataTable__MergeValuesOptions .Polaris-DataTable__TableRow:last-child .Polaris-DataTable__Cell,
.BC-DataTable__MergeValues .Polaris-DataTable__TableRow:last-child .Polaris-DataTable__Cell {
  border-bottom: none;
}

.BC-DataTable__FilterOptions .Polaris-DataTable__Cell--header,
.BC-DataTable__MergeValuesOptions .Polaris-DataTable__Cell--header,
.BC-DataTable__MergeValues .Polaris-DataTable__Cell--header,
.BC-DataTable__InstantSearchDisplay .Polaris-DataTable__Cell--header {
  border-bottom: 0.0625rem solid var(--p-divider);
  padding: 1.125rem 0.625rem 1.125rem 1.25rem;
  font-weight: 500;
}

.BC-DataTable__FilterOptions .Polaris-DataTable__Cell:first-child {
  width: 48px;
}

.BC-DataTable__FilterOptions .Polaris-DataTable__Cell:nth-child(2) {
  width: 100px;
}

.BC-DataTable__FilterOptions .Polaris-DataTable__Cell:nth-child(3) {
  width: 157px;
  word-break: break-word;
}

.BC-DataTable__FilterOptions .Polaris-DataTable__Cell:nth-child(4) {
  width: 145px;
}

.BC-DataTable__FilterOptions .Polaris-DataTable__Cell:nth-child(5) {
  width: 164px;
}

.BC-DataTable__FilterOptions .Polaris-DataTable__Cell:nth-child(6) {
  width: 228px;
  white-space: pre-wrap;
}

.BC-DataTable__FilterOptions .Polaris-DataTable__Cell:last-child {
  width: 92px;
  padding-right: 1.25rem;
  padding-left: 0.625rem;
}

.BC-DataTable__FilterOptions th.Polaris-DataTable__Cell:last-child {
  padding: 0;
  text-align: center;
}

.BC-DataTable__FilterOptions .Polaris-DataTable__Cell.EmptyCell,
.BC-DataTable__MergeValuesOptions .Polaris-DataTable__Cell.EmptyCell,
.BC-DataTable__MergeValues .Polaris-DataTable__Cell.EmptyCell,
.BC-Page__Merchandising .Polaris-DataTable__Cell.EmptyCell,
.BC-Page__Metafield .Polaris-DataTable__Cell.EmptyCell,
.BC-Page__Product-Visibility .Polaris-DataTable__Cell.EmptyCell {
  width: 0px;
}

.Polaris-DataTable__Cell-Action .Polaris-Button--iconOnly {
  padding: 0.325rem;
  min-height: 1.875rem;
}

.Polaris-DataTable__Cell-Action .Polaris-Icon {
  width: 1.05rem;
  height: 1.05rem;
}

.Polaris-DataTable__Cell-Action .Polaris-ButtonGroup--segmented {
  justify-content: flex-end;
}

.BC-EmptyOption__FilterTree,
.BC-EmptyTheme__ThemeSetup,
.BC-EmptyOption__Filter-Setting,
.BC-EmptyOption__SuggestionDictionary,
.BC-EmptyOption__StopWords,
.BC-EmptyOption__Synonym,
.BC-EmptyOption__ProductRanking,
.BC-EmptyRules__Merchandising,
.BC-EmptyRules__MerchandisingV2,
.BC-EmptySearch__RecommendationWidget,
.BC-EmptySearch__ABTestingCampaign,
.BC-EmptyRules__Metafield,
.BC-EmptyRules__CustomRangeSlider,
.BC-EmptyRules__Product-Visibility,
.BC-EmptyOption__IgnoreIPs,
.BC-EmptySwatch,
.BC-EmptyRules__CustomSorting,
.BC-EmptyOption__Sync,
.BC-EmptyOption__Translation {
  text-align: center;
  margin: 1.5rem;
}

.BC-EmptySearch__Integration {
  text-align: center;
  margin: 1.5rem 0;
  padding-top: 1.5rem;
}

.BC-Page__Integration .Polaris-Tabs__Panel .BC-EmptySearch__Integration .Polaris-Button {
  width: auto;
}

.BC-EmptyOption__FilterTree img,
.BC-EmptyTheme__ThemeSetup img,
.BC-EmptyOption__Filter-Setting img,
.BC-EmptyOption__SuggestionDictionary img,
.BC-EmptyOption__StopWords img,
.BC-EmptyOption__Synonym img,
.BC-EmptyOption__ProductRanking img,
.BC-EmptySearch__RecommendationWidget img,
.BC-EmptySearch__Integration img,
.BC-EmptySearch__ABTestingCampaign img,
.BC-EmptyOption__IgnoreIPs img,
.BC-EmptySwatch img,
.BC-EmptyOption__Sync img,
.BC-EmptyOption__Translation img {
  width: 45px;
  height: 40px;
  margin-bottom: 12px;
}

.BC-Modal__OptionFilter .Polaris-Layout__Section--secondary {
  margin-left: 0;
}

.BC-Modal__OptionFilter .Polaris-FormLayout__Item {
  margin-top: 1.25rem;
}

.BC-Modal__OptionFilter .Polaris-FormLayout + .Polaris-FormLayout {
  margin-top: 0;
}

.BC-DataTable__ManualValues .Polaris-DataTable__ScrollContainer {
  overflow-x: initial;
}

.BC-Modal__OptionFilter .Polaris-Select__Content {
  min-height: 2.125rem;
  padding: 0.3125rem 0.4375rem 0.3125rem 0.4375rem;
}

.BC-Modal__OptionFilter .Polaris-TextField__Input {
  padding: 0.3125rem 0.4375rem;
}

.BC-Modal__OptionFilter .noMetafield {
  margin-top: 0.25rem;
}

.BC-Modal__OptionFilter .locationWarning {
  margin-top: -1rem;
}

.BC-DataTable__ManualValues button,
.List_MultiLevelTags .action button,
.MultiLevelTag_ButtonAdd button {
  color: var(--p-action-primary);
  border-color: var(--p-action-primary);
}

.BC-DataTable__ManualValues button:hover,
.List_MultiLevelTags .action button:hover,
.MultiLevelTag_ButtonAdd button:hover {
  border-color: var(--p-action-primary);
}

.BC-DataTable__ManualValues button svg,
.List_MultiLevelTags .action button svg,
.MultiLevelTag_ButtonAdd button svg {
  fill: var(--p-action-primary);
}

.BC-DataTable__ManualValues .Polaris-DataTable__Table {
  table-layout: fixed;
}

.BC-DataTable__ManualValues .Polaris-DataTable__Cell {
  padding: 8px 5px;
  border: none !important;
}

.BC-DataTable__ManualValues tbody {
  vertical-align: top;
}

.BC-DataTable__ManualValues .Polaris-DataTable__Cell--header {
  border: none;
  padding: 0 5px 8px 5px;
}

.BC-DataTable__ManualValues .Polaris-DataTable__Cell:first-child {
  width: 30px;
}

.BC-DataTable__ManualValues .Polaris-DataTable__Cell:first-child .Polaris-Icon {
  margin-top: 8px;
}

.BC-DataTable__ManualValues .Polaris-DataTable__Cell:nth-child(2) {
  width: 190px;
}

.BC-DataTable__ManualValues .Polaris-DataTable__Cell:nth-child(3) {
  width: auto;
}

.BC-DataTable__ManualValues .Polaris-DataTable__Cell:nth-child(4) {
  width: 40px;
  padding-right: 0;
}

.BC-DataTable__ManualValues .Polaris-DataTable__Cell button {
  padding-top: 0.46875rem;
  padding-bottom: 0.46875rem;
}

.BC-DataTable__ManualValues .button-add {
  padding-top: 8px;
  display: flex;
  justify-content: flex-end;
}

.BC-DataTable__ManualValues .button-add .Polaris-Icon {
  width: 0.8125rem;
  height: 0.8125rem;
}

/* Price list values*/
.BC-Modal__OptionFilter .price-values > div {
  margin-bottom: 0.5rem;
}

.BC-Modal__OptionFilter .price-values > div.Polaris-Labelled__LabelWrapper {
  margin-bottom: 0.75rem;
}

.BC-List__Values .priceItem {
  margin-bottom: 9px;
}

.BC-List__Values .priceItem:last-child {
  margin-top: 16px;
  margin-bottom: 0;
}

.BC-List__Values .priceItem .fromPrice,
.BC-List__Values .priceItem .toPrice,
.BC-List__Values .priceItem .button {
  display: inline-flex;
  vertical-align: middle;
}

.BC-List__Values .priceItem .fromPrice span:first-child {
  min-width: 4.0625rem;
}

.BC-List__Values .priceItem .fromPrice span:last-child {
  min-width: 6.25rem;
  text-align: center;
  font-weight: bold;
}

.BC-List__Values .priceItem .toPrice {
  margin-right: 1.5rem;
}

.BC-List__Values .priceItem .toPrice span {
  min-width: 4.0625rem;
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
}

.BC-List__Values .priceItem .toPrice input {
  text-align: center;
  max-width: 100px;
  font-weight: bold;
}

.BC-List__Values .priceItem .button button i {
  margin: 0 !important;
}

.BC-List__Values .priceItem .button .Polaris-Icon {
  width: 1.05rem;
  height: 1.05rem;
}

.BC-List__Values .priceItem .button button {
  border-color: var(--p-action-primary);
}

.BC-List__Values .priceItem .button button svg {
  fill: var(--p-action-primary);
}

/*Filter tree*/
.BC-Page__FilterTree-Management .Polaris-Layout__Section,
.BC-Page__SuggestionDictionary .Polaris-Layout__Section,
.BC-Page__Synonym .Polaris-Layout__Section,
.BC-Page__ProductRanking .Polaris-Layout__Section,
.BC-Page__Merchandising .Polaris-Layout__Section,
.BC-Page__Metafield .Polaris-Layout__Section,
.BC-Page__CustomRangeSlider .Polaris-Layout__Section,
.BC-Page__Product-Visibility .Polaris-Layout__Section,
.BC-Page__SwatchSettings .Polaris-Layout__Section,
.BC-Page__CustomSorting .Polaris-Layout__Section {
  margin-top: 1.5rem;
}

.BC-Page__FilterTree-Management .Polaris-Card__Header + .Polaris-Card__Section,
.BC-Page__SuggestionDictionary .Polaris-Card__Section,
.BC-Page__Synonym .Polaris-Card__Section,
.BC-Page__ProductRanking .Polaris-Card__Section,
.BC-Page__Merchandising .Polaris-Card__Section,
.BC-Page__MerchandisingV2 .Polaris-Card__Section + .Polaris-Card__Section,
.BC-Page__Metafield .Polaris-Card__Section,
.BC-Page__CustomRangeSlider .Polaris-Card__Section,
.BC-Page__Product-Visibility .Polaris-Card__Section,
.BC-Page__SwatchSettings .Polaris-Card__Section,
.BC-Page__SearchAnalytics__SearchTerms .Polaris-Card__Section,
.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-Card__Section,
.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-Card__Section,
.BC-Page__SearchAnalytics__ProductPerformance .Polaris-Card__Section,
.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-Card__Section,
.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-Card__Section,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-Card__Section,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-Card__Section,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-Card__Section,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-Card__Section,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-Card__Section,
.BC-Page__CustomSorting #sort-by-options .Polaris-Card__Section {
  padding: 0;
}

.BC-Page__Redirect .BC-QuickStartGuide__DashboardV3 .Polaris-Card__Section,
.BC-Page__Synonym .BC-QuickStartGuide__DashboardV3 .Polaris-Card__Section,
.BC-Page__SuggestionDictionary .BC-QuickStartGuide__DashboardV3 .Polaris-Card__Section,
.BC-Page__SwatchSettings .BC-QuickStartGuide__DashboardV3 .Polaris-Card__Section,
.BC-Page__CustomRangeSlider .BC-QuickStartGuide__DashboardV3 .Polaris-Card__Section,
.BC-Page__Metafield .BC-QuickStartGuide__DashboardV3 .Polaris-Card__Section {
  padding: var(--p-space-5);
}

/*.BC-Page__FilterTree-Management .Polaris-DataTable--collapsed .Polaris-DataTable__ScrollContainer {
  margin-left: 5.9375rem;
}

.BC-Page__FilterTree-Management .Polaris-DataTable__Cell--fixed {
  width: 5.9375rem;
}

.BC-Page__FilterTree-Management .Polaris-DataTable__Cell--truncated {
  max-width: 5.9375rem;
}*/

.BC-Page__FilterTree-Management .Polaris-DataTable__Cell,
.BC-Page__Merchandising .Polaris-DataTable__Cell,
.BC-Page__Metafield .Polaris-DataTable__Cell,
.BC-Page__CustomRangeSlider .Polaris-DataTable__Cell,
.BC-Page__Product-Visibility .Polaris-DataTable__Cell,
.BC-Page__SwatchSettings .Polaris-DataTable__Cell,
.BC-Page__CustomSorting .Polaris-DataTable__Cell {
  padding: 1.25rem;
  white-space: normal;
  vertical-align: middle;
}

.BC-Page__FilterTree-Management .Polaris-DataTable__Cell:first-child {
  width: 15%;
}

.BC-Page__FilterTree-Management .Polaris-DataTable__Cell:nth-child(2) {
  width: 25%;
}

.BC-Page__FilterTree-Management .Polaris-DataTable__Cell:nth-child(2) .cell-locked {
  color: var(--p-text-disabled);
}

.BC-Page__FilterTree-Management .Polaris-DataTable__Cell:last-child {
  width: 90px;
}

.BC-Page__FilterTree-Management .Polaris-DataTable__Cell--header,
.BC-Page__SuggestionDictionary .Polaris-DataTable__Cell--header,
.BC-Page__Synonym .Polaris-DataTable__Cell--header,
.BC-Page__ProductRanking .Polaris-DataTable__Cell--header,
.BC-Page__Merchandising .Polaris-DataTable__Cell--header,
.BC-Page__Metafield .Polaris-DataTable__Cell--header,
.BC-Page__CustomRangeSlider .Polaris-DataTable__Cell--header,
.BC-Page__Product-Visibility .Polaris-DataTable__Cell--header,
.BC-Page__SwatchSettings .Polaris-DataTable__Cell--header,
.BC-Page__CustomSorting .Polaris-DataTable__Cell--header,
.BC-Sync__Content .Polaris-DataTable__Cell--header {
  padding: 1.125rem;
  font-weight: 500;
  border-bottom: 0.0625rem solid var(--p-divider);
}

.BC-Page__FilterTree-Management .Polaris-DataTable__Cell ul.collections,
.BC-Page__Merchandising .Polaris-DataTable__Cell ul.collections,
.BC-Page__Metafield .Polaris-DataTable__Cell ul.appliesTo,
.BC-Page__CustomRangeSlider .Polaris-DataTable__Cell ul.appliesTo,
.BC-Page__Product-Visibility .Polaris-DataTable__Cell ul.appliesTo {
  list-style: none;
  display: contents;
}

.BC-Page__FilterTree-Management .Polaris-DataTable__Cell ul.collections li,
.BC-Page__Merchandising .Polaris-DataTable__Cell ul.collections li,
.BC-Page__Metafield .Polaris-DataTable__Cell ul.appliesTo li,
.BC-Page__CustomRangeSlider .Polaris-DataTable__Cell ul.appliesTo li,
.BC-Page__Product-Visibility .Polaris-DataTable__Cell ul.appliesTo li {
  display: inline-flex;
}

.BC-Page__FilterTree-Management .Polaris-DataTable__Cell ul.collections li > span:first-child,
.BC-Page__Merchandising .Polaris-DataTable__Cell ul.collections li > span:first-child,
.BC-Page__Metafield .Polaris-DataTable__Cell ul.appliesTo li > span:first-child,
.BC-Page__CustomRangeSlider .Polaris-DataTable__Cell ul.appliesTo li > span:first-child,
.BC-Page__Product-Visibility .Polaris-DataTable__Cell ul.appliesTo li > span:first-child {
  padding: 2px 6px;
  margin: 0 0 2px 2px;
  font-size: 0.75rem;
  line-height: 18px;
  color: #637381;
  background-color: #f4f6f8;
  border-radius: 3px;
  display: inline;
  float: left;
}

.BC-Page__FilterTree-Management .Polaris-Button__Content .Polaris-Icon {
  width: 1.05rem;
  height: 1.05rem;
}

.BC-Page__FilterTree-Management .Polaris-DataTable__TableRow .Polaris-Button {
  min-height: 0;
  min-width: 0;
}

.BC-Page__FilterTree-Management .Polaris-Button .Polaris-Button__Text .clone {
  display: flex;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__TableRow .Polaris-Button--sizeSlim,
.BC-Page__FilterTree-Management .Polaris-DataTable__TableRow .Polaris-Button--sizeSlim {
  padding: 6px;
}

.BC-Page__FilterTree-Management .Polaris-DataTable__TableRow .Polaris-Button--iconOnly {
  padding-bottom: 6px;
}

.BC-Page__FilterTree-Management .Polaris-DataTable tbody > tr:first-child th:hover {
  background: unset;
}

.exceed-feature-notify {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 16px;
  background: #fffbf3;
  border-radius: 8px;
  min-height: 56px;
  align-items: center;
}

.exceed-feature-notify.premium-locked-banner {
  margin-bottom: 10px;
}

.exceed-feature-notify > div {
  display: flex;
  gap: 6px;
}

.exceed-feature-notify .Polaris-Button {
  background: #ffc96b;
  box-shadow: 0px -1px 0px 0px #00000033 inset;
  border: unset;
  height: 36px;
  padding: 8px 16px 8px 16px;
  min-width: 112px;
}

.exceed-feature-notify .Polaris-Link .Polaris-Icon {
  margin: 0;
  vertical-align: top;
  display: inline-flex;
  width: 16px;
  height: 16px;
  margin-left: 2px;
}

.Polaris-DataTable__Cell--firstColumn:has(.exceed-feature-notify):hover {
  background: unset;
}

/*Tooltip*/
.tooltip {
  margin-top: 5px;
  margin-left: 4px;
  display: inline-flex;
  vertical-align: top;
}

.Polaris-DataTable__Cell--header .tooltip {
  margin-top: 4px;
}

.Polaris-Tooltip-TooltipOverlay__Content2 {
  white-space: 'normal' !important;
}

.Polaris-Tooltip__Content,
.Polaris-Tooltip-TooltipOverlay__Content {
  max-width: 25rem;
  white-space: normal;
  word-wrap: break-word;
}

.tooltip .Polaris-Icon {
  width: 0.75rem;
  height: 0.75rem;
}

.BC-Page__FilterTree-Management
  .Polaris-ButtonGroup--segmented
  .Polaris-ButtonGroup__Item
  .cloneFilter
  button:first-child {
  border-radius: 0;
}

.BC-Page__MerchandisingV2
  .Polaris-ButtonGroup--segmented
  .Polaris-ButtonGroup__Item
  .cloneFilter
  button:first-child {
  border-radius: 0;
}

.BC-Page__MerchandisingV2 .Polaris-ButtonGroup--segmented .Polaris-Button .clone {
  display: flex;
}

.BC-Page__MerchandisingV2 .Polaris-Page-Header__PrimaryActionWrapper .Polaris-Button__Text {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.BC-Page__MerchandisingV2 .pagination .Polaris-Button__Text {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

/* button.Polaris-ActionList__Item {
  min-height: 1.25rem;
  padding: 0.25rem 1.125rem;
} */

.BC-Page__FilterTree-Management .Polaris-Stack > .Polaris-Stack__Item .search {
  position: absolute;
  right: 1.25rem;
  top: 0.78125rem;
  width: 14.125rem;
}

.BC-Page__Synonym .Polaris-Stack > .Polaris-Stack__Item .search {
  position: absolute;
  right: 1.25rem;
  top: 0.65625rem;
  width: 14.125rem;
}

/*Filter tree*/
.BC-Page__FilterTree-Management .Polaris-DataTable__Cell {
  padding: 1.25rem 1.25rem 1.25rem 1.25rem;
}

.BC-Page__FilterTree-Management .pagination,
.BC-Page__SuggestionDictionary .pagination,
.BC-Page__Synonym .pagination,
.BC-Page__ProductRanking .pagination,
.BC-Page__Merchandising .pagination,
.BC-Page__MerchandisingV2 .pagination,
.BC-Page__SwatchSettings .pagination,
.BC-Page__Sync .pagination,
.BC-Page__ManualRecommendationManagement .pagination {
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
  position: relative;
  margin-bottom: 1.25rem;
}

.BC-Page__FilterTree-Management .collectionsMore,
.BC-Page__Merchandising .collectionsMore {
  font-size: 0.75rem;
  padding-left: 6px;
}

.BC-Page__FilterTree-Management .collectionsMore .Polaris-Icon,
.BC-Page__Merchandising .collectionsMore .Polaris-Icon {
  display: inline-flex;
  width: 0.75rem;
  height: 0.75rem;
  vertical-align: middle;
}

.BC-Page__FilterTree-Management .collectionsMore .text,
.BC-Page__Merchandising .collectionsMore .text {
  padding-left: 2px;
  vertical-align: middle;
}

.BC-Page__FilterTree-Management .Polaris-Card + .Polaris-Card {
  margin-top: 1.5rem;
}

.BC-Page__FilterTree-Management .infoBanner .Polaris-Banner--withinPage,
.BC-Page__FilterTree-Item .infoBanner .Polaris-Banner--withinPage,
.BC-Page__Translation .Polaris-Banner--withinPage {
  padding: 1.25rem;
}

.BC-Page__Translation textarea {
  resize: none;
  overflow-y: scroll;
  line-height: 1.4375rem;
}

.BC-Page__Translation textarea[rows='2'] {
  max-height: 58px;
}

.BC-Page__Translation textarea[rows='3'] {
  max-height: 82px;
}

.BC-Page__Translation textarea[rows='4'] {
  max-height: 106px;
}

.BC-Page__Translation textarea[rows='5'] {
  max-height: 130px;
}

.BC-Page__Translation textarea[rows='6'] {
  max-height: 154px;
}

.BC-Page__Translation textarea::-webkit-scrollbar {
  width: 8px;
}

.BC-Page__Translation textarea::-webkit-scrollbar-thumb {
  background: #cccccc;
  border-radius: 4px;
}

.BC-Page__Translation .search-result--withIcon {
  display: inline-flex;
}

.BC-Page__Translation .search-result--withIcon .Polaris-Icon {
  width: 0.75rem;
  height: 0.75rem;
  margin-top: 4px;
  margin-left: 5px;
}

.BC-Page__Translation .spinner-loading {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.BC-Page__FilterTree-Management .infoBanner .Polaris-Banner__Content,
.BC-Page__FilterTree-Item .infoBanner .Polaris-Banner__Content {
  padding-top: 0.375rem;
  padding-bottom: 0;
}

.BC-Page__FilterTree-Management .infoBanner p:not(:first-child),
.BC-Page__FilterTree-Item .infoBanner p:not(:first-child) {
  padding-top: 1.25rem;
}

/* Preview filter tree */
.BC-Modal__OptionFilter .Polaris-Tabs__Panel {
  min-height: 360px;
  max-height: 503px;
  overflow-x: auto;
}

.BC-Modal__OptionFilter .tabs .Polaris-Card__Header {
  position: absolute;
  right: 0;
  top: -5px;
}

.BC-Modal__OptionFilter .previewPanel .Polaris-Card {
  width: 100%;
  box-shadow: none;
  background: inherit;
}

.BC-Modal__OptionFilter .previewPanel .Polaris-Card .Polaris-Card__Header,
.BC-Page__Filter-Settings .right .Polaris-Card .Polaris-Card__Header,
.BC-Page__Layout-Settings .previewPanel .Polaris-Card .Polaris-Card__Header {
  border-bottom: 0.0625rem solid var(--p-divider);
  padding-top: 0.9375rem;
  padding-bottom: 0.9375rem;
}

.BC-Modal__OptionFilter .previewPanel .Polaris-Card .Polaris-Heading,
.BC-Page__Layout-Settings .previewPanel .Polaris-Card .Polaris-Heading {
  text-align: center;
  font-size: 0.875rem;
  font-weight: 400;
}

.BC-Modal__OptionFilter .previewPanel .Polaris-Card__Section {
  display: inline-flex;
  width: 100%;
}

.BC-Modal__OptionFilter .previewPanel .device,
.BC-Modal__OptionFilter .previewPanel .layout {
  width: 50%;
  text-align: center;
}

.BC-Modal__OptionFilter .previewPanel .device > div,
.BC-Modal__OptionFilter .previewPanel .layout > div {
  margin-top: 6px;
  margin-bottom: 3px;
}

.BC-Modal__OptionFilter .previewPanel .device > div > span,
.BC-Modal__OptionFilter .previewPanel .layout > div > span {
  display: flex;
}

.BC-Modal__OptionFilter .previewPanel .device > div > span:focus,
.BC-Modal__OptionFilter .previewPanel .layout > div > span:focus {
  outline: none;
}

.BC-Modal__OptionFilter .previewPanel .device > div > span .icon:hover,
.BC-Modal__OptionFilter .previewPanel .layout > div > span .icon:hover {
  cursor: pointer;
}

.BC-Modal__OptionFilter .previewPanel .icons {
  display: inline-flex;
}

.BC-Modal__OptionFilter .previewPanel .icons .active {
  border: 2px solid var(--p-action-primary);
}

.BC-Modal__OptionFilter .previewPanel .icon.first {
  margin-right: 1.5rem;
}

.BC-Modal__OptionFilter .previewPanel .icon {
  border: 2px solid #919eab;
  border-radius: 3px;
  padding: 8px 10px;
}

.BC-Modal__OptionFilter .previewPanel .message {
  color: #687381;
  padding: 0.625rem 1.25rem 1.25rem 1.25rem;
}

.BC-Modal__OptionFilter .previewPanel .previewSoon {
  color: #919eab;
  padding: 0.625rem 1.25rem 1.25rem 1.25rem;
}

.BC-Modal__OptionFilter .previewPanel .filterTree {
  margin: 0 1.25rem 1.25rem 1.25rem;
  border: 1px solid #c4cdd5;
  border-radius: 3px;
  height: 301px;
  max-height: 362px;
}

.BC-Modal__OptionFilter .previewPanel .explanProductNumbers {
  margin: 1.25rem;
  color: #637381;
}

.BC-Modal__OptionFilter .groupFields > div {
  margin-top: 1.25rem;
}

/*Review ratings*/
.BC-Modal__OptionFilter .reviewRatings-subtext {
  margin-top: -0.9375rem;
}

.BC-Modal__OptionFilter .colorPickerBox {
  width: 130px;
}

.BC-Modal__OptionFilter .selectedColor {
  background-color: #fff;
  z-index: 417;
  width: 25px;
  height: 25px;
  margin-right: 0;
  border: 1px solid #c4cdd5;
  border-radius: 3px;
  margin-right: 0.3125rem;
}

.BC-Page__Filter-Settings .selectedColor,
.BC-Page__Layout-Settings .selectedColor,
.BC-Default-Theme-Settings .selectedColor {
  background-color: #fff;
  z-index: 417;
  width: 25px;
  height: 25px;
  margin-right: 0;
  border: 1px solid #c4cdd5;
  border-radius: 3px;
  margin-left: 0.75rem;
}

.BC-Modal__OptionFilter .checkboxWithTextfield {
  display: inline-flex;
  width: 100%;
}

.BC-Modal__OptionFilter .checkboxWithTextfield .checkbox {
  width: 27%;
}

.BC-Modal__OptionFilter .checkboxWithTextfield .checkbox .Polaris-Choice {
  padding-top: 0.5rem;
}

.BC-Modal__OptionFilter .checkboxWithTextfield .textfield {
  width: 100%;
}

.BC-Modal__OptionFilter .tabs .Polaris-Card {
  border-radius: unset;
  border-bottom: none !important;
}

.BC-Modal__OptionFilter .actions {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding: 16px;
}

.BC-Modal__OptionFilter .actions .Polaris-Link {
  padding: 8px 16px 8px 16px;
  gap: 10px;
  border-radius: 4px 0px 0px 0px;
  border: 1px solid rgba(186, 191, 195, 1);
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.05);
  color: rgba(32, 34, 35, 1);
  text-decoration: none;
}

.BC-Modal__OptionFilter .analytics-select-popover .Polaris-Button {
  padding: 0.3125rem 0.4375rem 0.3125rem 0.4375rem;
}

.BC-Modal__OptionFilter .actions .upgrade-button {
  background: #ffc96b;
  border: unset;
  font-weight: 500;
  box-shadow: 0px 1px 0px 0px #00000014;
}

.BC-Modal__OptionFilter .actions .upgrade-button:hover {
  background: #f6bf61;
}

.BC-Modal__OptionFilter .actions-general {
  margin-top: 16px;
  border-top: 1px solid #e1e3e5;
}

.reviewRatingsPicker {
  padding: 0.3125rem;
}

/* Filter settings */
.BC-Page__Filter-Settings .headingStyle {
  font-size: 1.75rem;
  line-height: 2rem;
  font-weight: 600;
  margin-top: 2.5rem;
  padding-top: 2.5rem;
  padding-bottom: 1.5rem;
  border-top: 1px solid var(--p-divider);
}

.BC-Page__Theme-Setup .headingWrapper {
  padding-top: 2.5rem;
  padding-bottom: 1.5rem;
  border-top: 1px solid var(--p-divider);
  display: flex;
  align-items: baseline;
}

.BC-Page__Theme-Setup .headingStyle {
  font-size: 1.75rem;
  line-height: 2rem;
  font-weight: 600;
  margin-right: 0.5rem;
}

.BC-Page__Filter-Settings .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing,
.BC-Page-Variants-Display .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {
  justify-content: flex-end;
}

.BC-Page__Filter-Settings
  .Polaris-PageActions
  .Polaris-Stack--distributionEqualSpacing
  > .Polaris-Stack__Item,
.BC-Page__Translation
  .Polaris-PageActions
  .Polaris-Stack--distributionEqualSpacing
  > .Polaris-Stack__Item {
  margin-left: 1rem;
}

.BC-Page__Filter-Settings .styleBox .Polaris-Card__Section {
  padding: 0;
}

.BC-Page__Filter-Settings .styleBox .tabs .Polaris-Card__Section {
  padding: 1rem;
}

.BC-Page__Filter-Settings .Polaris-Tabs__Title {
  min-width: auto;
}

.BC-Page__Filter-Settings .styleBox .Polaris-Card__Section {
  padding: 0;
}

.BC-Page__Filter-Settings .displayBox {
  margin-top: 40px;
}

.BC-Page__Filter-Settings .BC-GuideBanner {
  margin-top: 24px !important;
}

.BC-Page__Filter-Settings .displayBox .Polaris-Stack {
  margin-top: -1.75rem;
}

.BC-Page__Filter-Settings .displayBox .Polaris-Stack__Item {
  margin-top: 0.75rem;
  margin-bottom: 0.25rem;
}

.BC-Page__Filter-Settings .displayBox .BC-Button-ClearCache {
  border-top: 0.0625rem solid var(--p-divider);
  padding: 1.25rem 0 0.25rem 0;
}

.BC-Page__Filter-Settings .displayBox .BC-Select__control {
  -webkit-align-items: start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: start;
  padding: 3px 0;
}

.BC-Page__Filter-Settings .tabs .Polaris-Card__Section,
.BC-Page__Filter-Settings .right .Polaris-Card .Polaris-Card__Section {
  padding: 1rem;
}

.BC-Page__Filter-Settings .style-tabs .left .Polaris-Card__Section {
  padding: 1rem 1rem 1.5rem 1rem;
  min-height: 480px;
}

.BC-Page__Filter-Settings .style-tabs .Polaris-Layout,
.BC-Page__Filter-Settings .style-tabs .Polaris-Layout__Section {
  margin-top: 0;
  margin-left: 0;
}

.BC-Page__Filter-Settings .style-tabs .right .Polaris-Card {
  box-shadow: none;
  background: inherit;
}

.BC-Page__Filter-Settings .right .Polaris-Card .Polaris-Card__Header .Polaris-Heading {
  line-height: 1.375rem;
}

.BC-Page__Filter-Settings .right .previewPanel .Polaris-Heading {
  font-size: 0.875rem;
  font-weight: 400;
  text-align: center;
}

.BC-Page__Filter-Settings .right .previewPanel .content {
  text-align: center;
  display: inline-block;
}

.BC-Page__Filter-Settings .right .previewPanel ul.list {
  list-style: none;
  text-align: left;
  margin-block-start: 1.5rem;
  padding-inline-start: 0;
}

.BC-Page__Filter-Settings .right .previewPanel ul.list li:first-child {
  display: inline-flex;
  margin-left: -0.625rem;
}

.BC-Page__Filter-Settings .right .previewPanel .mobileButton {
  text-align: center;
  margin: 1.5rem 2.1875rem 0 2.1875rem;
}

.BC-Page__Filter-Settings .right .previewPanel .mobileButton button {
  width: 100%;
  border: none;
  padding: 10px 0;
  cursor: pointer;
  background-color: #000;
  color: #fff;
  text-transform: uppercase;
}

.BC-Page__Filter-Settings .left .fontFamily-note {
  color: #617985;
  margin-top: -0.5rem;
}

/* Filter layout*/
.BC-Page__Filter-Layout .Polaris-PageActions {
  border-top: none;
}

.BC-Page__Filter-Layout .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {
  justify-content: flex-end;
}

.BC-Page__Filter-Layout
  .Polaris-PageActions
  .Polaris-Stack--distributionEqualSpacing
  > .Polaris-Stack__Item {
  margin-left: 1rem;
}

.BC-Page__Filter-Layout .tabs .Polaris-Tabs__Panel {
  margin-top: 1.5rem;
}

.BC-Page__Filter-Layout .tabs .BC_FilterLayout-Vertical .Polaris-Card__Section,
.BC-Page__Filter-Layout .tabs .BC_FilterLayout-Horizontal .Polaris-Card__Section,
.BC-Page__Filter-Layout .tabs .BC_FilterLayout-Mobile .Polaris-Card__Section {
  text-align: center;
}

.BC-Page__Filter-Layout .tabs .layout-style {
  margin-top: 1rem;
}

.BC-Page__Filter-Layout .tabs .layout-style > div {
  margin-top: 1rem;
}

.BC-Page__Filter-Layout .BC_FilterLayout-Desktop .box img,
.BC-Page__Filter-Layout .BC_FilterLayout-Vertical .box img,
.BC-Page__Filter-Layout .BC_FilterLayout-Horizontal .box img {
  width: 100%;
  max-height: 10.625rem;
}

.BC-Page__Filter-Layout .BC_FilterLayout-Mobile .box img {
  width: 5rem;
  height: 10.625rem;
}

.BC-Page__Filter-Layout .layout-oneFour .Polaris-Layout__Section--oneThird {
  flex: 1 1 11.25rem;
}

.BC-Page__Filter-Layout .layout-oneFour .Polaris-Card__Section {
  padding: 0.75rem;
}

.BC-Page__Filter-Layout .layout-oneFour .BC_FilterLayout-Desktop .Polaris-Choice {
  min-height: 2.5rem;
}

/* Subscription */
.BC-Page__Subscription .planStatus {
  padding: 0.75rem;
}

.BC-Page__Subscription .planStatus .top {
  display: flex;
}

.BC-Page__Subscription .planStatus .bottom {
  padding-top: 1.5625rem;
  text-align: center;
}

.BC-Page__Subscription .planStatus .status {
  width: 50%;
  text-align: center;
  border-right: 1px solid var(--p-divider);
}

.BC-Page__Subscription .planStatus .status .title {
  display: inline-block;
  min-width: 87px;
  margin: auto;
}

.BC-Page__Subscription .planStatus .status .Polaris-Badge {
  padding: 0.125rem 0.625rem;
  min-width: 107px;
}

.BC-Page__Subscription .planStatus .status .Polaris-Badge--statusWarning,
.subscribeBox .Polaris-TextContainer .subscribe_warning .Polaris-Badge--statusWarning {
  background-color: #ffc453;
}

.BC-Page__Subscription .planStatus .status .Polaris-Badge__Content {
  margin: auto;
}

.BC-Page__Subscription .planStatus .status > div,
.BC-Page__Subscription .planStatus .productCount > div {
  font-size: 1rem;
  font-weight: 700;
  padding-bottom: 0.5rem;
}

.BC-Page__Subscription .planStatus .productCount {
  width: 50%;
  text-align: center;
  float: right;
}

.BC-Page__Subscription .planStatus .productCount .count {
  font-size: 1.625rem;
}

.BC-Page__Subscription .priceBox {
  text-align: center;
  padding: 3rem 0 0.25rem 0;
}

.BC-Page__Subscription .priceBox .price-information {
  padding-left: 5.5rem;
  margin-bottom: 2.5rem;
  text-align: left;
  -moz-column-count: 2;
  -moz-column-gap: 20px;
  -webkit-column-count: 2;
  -webkit-column-gap: 20px;
  column-count: 2;
  column-gap: 20px;
}

.BC-Page__Subscription .priceBox .price-information > div {
  display: inline-flex;
}

.BC-Page__Subscription .priceBox .price-information .icon-check {
  display: inline-block;
  margin-right: 0.625rem;
}

.BC-Page__Subscription .priceBox .price {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--p-action-primary);
  letter-spacing: 2px;
}

.BC-Page__Subscription .priceBox .priceLarge {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--p-action-primary);
  letter-spacing: 2px;
  padding-bottom: 6px;
}

.BC-Page__Subscription .priceBox .price .unit {
  font-size: 1.5625rem;
  font-weight: 500;
}

.BC-Page__Subscription .priceBox .discountCode {
  display: inline-flex;
  padding-top: 1rem;
}

.BC-Page__Subscription
  .priceBox
  .discountCode
  .Polaris-Connected
  .Polaris-Connected__Item--primary {
  width: 13.75rem;
}

.BC-Page__Subscription .priceBox .applied {
  padding-top: 8px;
  color: #008060;
}

.BC-Page__Subscription .priceBox .error {
  color: #de3618;
}

.BC-Page__Subscription .priceBox .description {
  padding: 1rem;
}

.BC-Page__Subscription .priceBox .warning {
  color: #de3618;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.BC-Page__Subscription .priceBox .warning:empty {
  padding-top: 2.25rem;
}

.BC-Page__Subscription .Polaris-Layout__Section:last-child {
  color: #31373d;
}

.BC-Page__Subscription .priceSlider {
  margin: 3.625rem 2.125rem 1.875rem 2.125rem;
}

.BC-Page__Subscription .textSetupComplete:first-child {
  margin-top: 0.6875rem;
}

.BC-Page__Subscription .textSetupComplete {
  color: #212b36;
  margin-top: 1rem;
}

.BC-Page__Subscription .textSetupComplete:last-child {
  margin-top: 1.5rem;
}

.BC-Page__Subscription .noUiButton {
  display: inline-flex;
  margin-top: 5px;
  margin-left: 1px;
}

.BC-Page__Subscription .noUiMaxProductLabel {
  margin-top: -38px;
  position: absolute;
  right: -40px;
  font-size: 14px;
}

.BC-Page__Subscription .noUi-active {
  box-shadow: none;
}

.BC-Page__Subscription .noUiButton .Polaris-Icon {
  width: 0.9375rem;
  height: 0.9375rem;
}

.BC-Page__Subscription .noUiButton .Polaris-Icon:last-child {
  margin-left: -7px;
}

.BC-Page__Subscription .information-pricing-V2 {
  padding: 0 0.75rem;
}

.BC-Page__Subscription .information-pricing-V2 p {
  margin: 1.25rem 0;
}

.BC-Page__Subscription .information-pricing-V2 .btn-show {
  text-align: center;
  margin: 0.75rem;
}

.BC-Page__Subscription .BC_DataTable_Plans {
  border: 0.0625rem solid #d8e6ff;
  background: #f9fbff;
}

.BC-Page__Subscription .BC_DataTable_Plans table {
  table-layout: fixed;
}

.BC-Page__Subscription .BC_DataTable_Plans .Polaris-DataTable__Cell {
  border-right: 0.0625rem solid #d8e6ff;
  border-bottom: 0.0625rem solid #d8e6ff;
  font-weight: 500;
  text-align: center;
  white-space: normal;
  padding: 1rem 1.5rem;
}

.BC-Page__Subscription .BC_DataTable_Plans tr .Polaris-DataTable__Cell:first-child {
  padding-right: 0;
}

.BC-Page__Subscription .BC_DataTable_Plans .Polaris-DataTable__Cell.Column__5 {
  width: 132px;
}

.BC-Page__Subscription .BC_DataTable_Plans .Polaris-DataTable__Cell.Column__1 {
  width: 664px;
}

.BC-Page__Subscription .BC_DataTable_Plans .Polaris-DataTable__Cell:first-child {
  width: 268px;
}

.BC-Page__Subscription .BC_DataTable_Plans .Polaris-DataTable__Cell.left-title,
.BC-Page__Subscription .BC_DataTable_Plans .Polaris-DataTable__Cell.content-description,
.BC-Page__Subscription .BC_DataTable_Plans .row-heading .Polaris-DataTable__Cell {
  text-align: left;
}

.BC-Page__Subscription .BC_DataTable_Plans .row-without-border .Polaris-DataTable__Cell,
.BC-Page__Subscription .BC_DataTable_Plans tr .Polaris-DataTable__Cell:last-child {
  border-right: none;
}

.BC-Page__Subscription .BC_DataTable_Plans .row-heading td.Polaris-DataTable__Cell {
  background: #d8e6ff;
  padding: 1.125rem 1.5rem;
}

.BC-Page__Subscription .BC_DataTable_Plans .row-heading button,
.BC-Page__Subscription .BC_DataTable_Plans .left-title button {
  color: inherit;
  text-decoration: none;
}

.BC-Page__Subscription .BC_DataTable_Plans .row-heading button:active .Polaris-Button__Content,
.BC-Page__Subscription .BC_DataTable_Plans .left-title button:active .Polaris-Button__Content {
  background: none;
}

.BC-Page__Subscription
  .BC_DataTable_Plans
  .row-heading
  .Polaris-Button__DisclosureIcon
  .Polaris-Icon__Svg,
.BC-Page__Subscription
  .BC_DataTable_Plans
  .left-title
  .Polaris-Button__DisclosureIcon
  .Polaris-Icon__Svg {
  fill: inherit;
}

.BC-Page__Subscription .BC_DataTable_Plans .row-heading .Polaris-Button__Text {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
}

.BC-Page__Subscription .BC_DataTable_Plans th.Polaris-DataTable__Cell {
  border-right: 0.0625rem solid #ffffff;
  background: #d8e6ff;
  font-size: 16px;
  font-weight: bold;
  line-height: 22px;
  padding: 0.625rem;
}

.BC-Page__Subscription .BC_DataTable_Plans th.Polaris-DataTable__Cell:last-child {
  padding: 0.625rem 1rem;
}

.BC-Page__Subscription .BC_DataTable_Plans .Polaris-Icon--colorGreen {
  margin-left: auto;
}

.BC-Page__Subscription .BC_DataTable_Plans .Polaris-DataTable__Cell.content-description {
  font-size: 12px;
  font-weight: normal;
}

.BC-Page__Subscription .BC_DataTable_Plans .Polaris-DataTable__Cell.content-description > span {
  display: block;
}

.BC-Page__Subscription
  .BC_DataTable_Plans
  .Polaris-DataTable__Cell.content-description
  > span:before {
  content: '-';
  margin-right: 5px;
}

.BC-Page__Subscription .BC_DataTable_Plans .Polaris-Badge {
  background-color: #d8e6ff;
  color: #2459b4;
  border: none;
  padding: 0 0.3125rem;
  font-size: 10px;
  font-weight: 600;
  margin-left: 4px;
}

.BC-Page__Subscription .BC_DataTable_Plans .icon-minus .Polaris-Icon {
  width: 0.75rem;
  padding-top: 0.3125rem;
}

/*Transition*/
.BC-Page__Subscription .BC_DataTable_Plans .transition-enter {
  transform: translateY(-1.25rem);
  opacity: 0;
  visibility: hidden;
  z-index: -1;
}

.BC-Page__Subscription .BC_DataTable_Plans .transition-enter-active {
  transform: translateY(0%);
  opacity: 1;
  visibility: visible;
  z-index: 1;
  transition: all 0.3s ease-in-out;
}

.BC-Page__Subscription .BC_DataTable_Plans .transition-exit {
  transform: translateY(0);
  opacity: 1;
  z-index: 1;
  visibility: visible;
}

.BC-Page__Subscription .BC_DataTable_Plans .transition-exit-active {
  transform: translateY(-1.25rem);
  opacity: 0;
  visibility: hidden;
  z-index: -1;
  transition: all 0.3s ease-in-out 0s;
}

.BC-Page__Subscription .BC_DataTable_Plans .item-transition {
  overflow: hidden;
}

/*.BC-Page__Subscription .reviews-slideshow .brand .Polaris-Layout {
  margin: 1.25rem 0;
}

.BC-Page__Subscription .reviews-slideshow .brand .Polaris-Layout .Polaris-Layout__Section {
  margin: auto;
}

.BC-Page__Subscription .reviews-slideshow {
  padding-bottom: 0.625rem;
}

.BC-Page__Subscription .reviews-slideshow .review img.icon {
  max-width: 100%;
  width: 238px;
}

.BC-Page__Subscription .reviews-slideshow .review-content {
  text-align: left;
  margin: 0.625rem 1.25rem 0.625rem 0;
}

.BC-Page__Subscription .reviews-slideshow .review .icon-quote {
  width: 1.875rem;
}

.BC-Page__Subscription .reviews-slideshow .review .close-quote {
  text-align: right;
}

.BC-Page__Subscription .reviews-slideshow .review .review-by:before {
  content: ' ';
  width: 2.5rem;
  display: block;
  border-top: solid 4px #ff3300;
  margin-bottom: 12px;
}

.BC-Page__Subscription .reviews-slideshow .review .review-by {
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 1.875rem;
}

.BC-Page__Subscription .reviews-slideshow .carousel .control-dots .dot.selected {
  background-color: #ff3300;
}

.BC-Page__Subscription .reviews-slideshow .carousel .control-dots .dot {
  box-shadow: none;
  opacity: 1;
  background-color: #e4e4e9;
}

.BC-Page__Subscription .reviews-slideshow .slideshow-button {
  position: absolute;
  bottom: 1.25rem;
  right: 1.25rem;
}

.BC-Page__Subscription .reviews-slideshow .slideshow-button button {
  margin-left: -4px;
  margin-right: -4px;
}

.BC-Page__Subscription .reviews-slideshow .slideshow-button button:active {
  background: none;
}*/

.BC-Page__Subscription .brand {
  margin-top: 2.5rem;
  margin-bottom: 1.875rem;
}

.BC-Page__Subscription .brand .Polaris-Heading,
.BC-Page__Subscription .review .title .Polaris-Heading,
.BC-Page__Subscription .questions .title .Polaris-Heading {
  font-weight: bold;
  font-size: 28px;
  line-height: 36px;
}

.BC-Page__Subscription .brand .brand-items {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0.25rem 0;
}

.BC-Page__Subscription .review {
  margin-top: 4.3125rem;
  margin-bottom: 2.75rem;
}

.BC-Page__Subscription .review .title {
  margin-bottom: 1.75rem;
}

.BC-Page__Subscription .review .Polaris-Layout__Section--oneThird {
  flex: 1 1 21.875rem;
}

.BC-Page__Subscription .review .utilities {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  text-align: center;
  margin: 1.5rem auto;
}

.BC-Page__Subscription .review .Polaris-Layout__Section .utilities:first-child {
  margin-top: 0;
}

.BC-Page__Subscription .review .Polaris-Layout__Section .utilities:last-child {
  margin-bottom: 0;
}

.BC-Page__Subscription .review .utilities > div {
  text-align: center;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
}

.BC-Page__Subscription .review .utilities .Polaris-Heading {
  margin-top: 1.25rem;
  margin-bottom: 1.5rem;
}

.BC-Page__Subscription .review .Polaris-Card + .Polaris-Card {
  margin-top: 1.5rem;
}

.BC-Page__Subscription .review .review-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.25rem;
}

.BC-Page__Subscription .review .review-content {
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 0.25rem;
}

.BC-Page__Subscription .questions {
  margin-top: 3.75rem;
  margin-bottom: 1.25rem;
}

.BC-Page__Subscription .questions .Polaris-Card__Header {
  padding-bottom: 1rem;
  padding-top: 1rem;
}

.BC-Page__Subscription .questions .Polaris-Card__Header .Polaris-Stack {
  flex-wrap: unset;
}

.BC-Page__Subscription .questions .Polaris-Card__Section {
  padding-top: 0;
}

.BC-Page__Subscription .questions .answer p + p {
  margin-top: 1.25rem;
}

.BC-Page__Subscription .questions .answer p {
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  overflow-wrap: break-word;
}

.BC-Page__Subscription .transition-enter {
  transform: translateY(-1.25rem);
  opacity: 0;
  visibility: hidden;
  z-index: -1;
}

.BC-Page__Subscription .transition-enter-active {
  transform: translateY(0%);
  opacity: 1;
  visibility: visible;
  z-index: 1;
  transition: all 0.6s ease-in;
}

.BC-Page__Subscription .transition-exit {
  transform: translateY(0);
  opacity: 1;
  z-index: 1;
  visibility: visible;
}

.BC-Page__Subscription .transition-exit-active {
  transform: translateY(-1.25rem);
  opacity: 0;
  visibility: hidden;
  z-index: -1;
  transition: all 0.3s ease-out;
}

.BC-Page__Subscription .item-transition {
  overflow: hidden;
}

/* Price slider */
.priceSlider .noUi-horizontal {
  height: 4px !important;
}

.priceSlider .noUi-target {
  background: var(--p-divider) !important;
  border: 0 !important;
  box-shadow: none !important;
}

.priceSlider .noUi-connect {
  background: var(--p-action-primary) !important;
}

.priceSlider .noUi-marker-horizontal.noUi-marker-large:first-child {
  margin-left: 0;
  width: 12px;
  border-radius: 50%;
  background: var(--p-action-primary);
  margin-top: -18px;
}

.priceSlider .noUi-marker-large-last {
  position: absolute;
  margin-left: -12px !important;
  width: 12px !important;
  border-radius: 50%;
  border: 1px solid #637381;
  margin-top: -18px !important;
  background: #fff !important;
}

.priceSlider .noUi-marker-horizontal.noUi-marker:first-child,
.priceSlider .noUi-marker-large-last {
  height: 12px !important;
}

.priceSlider .noUi-marker-horizontal.noUi-marker-large {
  height: 8px !important;
}

.priceSlider .noUi-marker-horizontal.noUi-marker {
  height: 8px !important;
  background: var(--p-action-primary);
  margin-top: -16px;
}

.priceSlider .noUi-value-horizontal {
  font-size: 14px;
  margin-top: -8px;
  margin-left: 5px;
  color: #637381;
}

html:not([dir='rtl']) .priceSlider .noUi-horizontal .noUi-handle {
  right: -11px !important;
}

.priceSlider .noUi-horizontal .noUi-handle {
  width: 24px !important;
  height: 24px !important;
  top: -10px !important;
  border-radius: 50%;
  background: var(--p-action-primary);
  box-shadow: none;
  border: none;
}

.priceSlider .noUi-handle:after,
.priceSlider .noUi-handle:before {
  width: 0 !important;
}

.priceSlider .noUi-value-horizontal:last-child {
  left: 100% !important;
}

.priceSlider .noUi-handle-lower {
  outline: none;
}

/* Subscription v3*/
.subscribe-status-modal--success,
.subscribe-status-modal--error {
  display: inline-flex;
  vertical-align: top;
}

.subscribe-status-modal--success .Polaris-Icon,
.subscribe-status-modal--error .Polaris-Icon {
  margin-right: 5px;
}

.subscribe-status-modal--error {
  color: #d72c0d;
}

.subscribe-status-modal--error .Polaris-Icon svg {
  fill: #d72c0d;
}

.subscribe-status-modal--success {
  color: #008060;
}

.subscribe-status-modal--success .Polaris-Icon svg {
  fill: #008060;
}

.BC-Page__SubscriptionV3 .sub-info-page {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 24px;
}

.BC-Page__SubscriptionV3 .sub-info-page img {
  width: 14px;
  height: 14px;
}

.BC-Page__SubscriptionV3 .sub-info-page a {
  text-decoration: none;
  color: #6d7175;
}

.BC-Page__SubscriptionV3-Package .planStatus,
.BC-Page__SubscriptionV3 .planStatus {
  padding: 0.75rem;
}

.BC-Page__SubscriptionV3-Package .planStatus .top,
.BC-Page__SubscriptionV3 .planStatus .top {
  display: flex;
}

.BC-Page__SubscriptionV3-Package .planStatus .bottom,
.BC-Page__SubscriptionV3 .planStatus .bottom {
  padding-top: 1.5625rem;
  text-align: center;
}

.BC-Page__SubscriptionV3-Package .planStatus .status,
.BC-Page__SubscriptionV3 .planStatus .status {
  width: 50%;
  text-align: center;
  border-right: 1px solid var(--p-divider);
}

.BC-Page__SubscriptionV3-Package .planStatus .status .title,
.BC-Page__SubscriptionV3 .planStatus .status .title {
  display: inline-block;
  min-width: 87px;
  margin: auto;
  font-size: 14px;
  line-height: 20px;
}

.BC-Page__SubscriptionV3-Package .planStatus .status .Polaris-Badge,
.BC-Page__SubscriptionV3 .planStatus .status .Polaris-Badge {
  padding: 0.125rem 0.625rem;
  min-width: 96px;
  min-height: 24px;
}

.BC-Page__SubscriptionV3-Package .planStatus .status .Polaris-Badge--statusWarning,
.BC-Page__SubscriptionV3 .planStatus .status .Polaris-Badge--statusWarning,
.subscribeBox .Polaris-TextContainer .subscribe_warning .Polaris-Badge--statusWarning {
  background-color: #ffc453;
}

.BC-Page__SubscriptionV3-Package .planStatus .status .Polaris-Badge__Content,
.BC-Page__SubscriptionV3 .planStatus .status .Polaris-Badge__Content {
  margin: auto;
}

.BC-Page__SubscriptionV3 .planStatus .Polaris-Stack {
  margin-top: 0;
}

.BC-Page__SubscriptionV3 .planStatus .Polaris-Stack .Polaris-Stack__Item:first-child strong,
.BC-Page__SubscriptionV3 .planStatus .cost-breakdown {
  display: flex;
  justify-content: center;
}

.BC-Page__SubscriptionV3 .planStatus .cost-breakdown .Polaris-Icon {
  height: 1rem;
  width: 1rem;
  margin: 3px 0 0 3px;
}

.BC-Page__SubscriptionV3 .planStatus .cost-breakdown {
  color: #2c6ecb;
}

.BC-Page__SubscriptionV3 .planStatus .Polaris-Stack .Polaris-Stack__Item:last-child .discount-info {
  background: #fafbfb;
  border-radius: 8px;
  margin: 10px -16px 0 -16px;
  padding: 16px;
}

.cost-breakdown-modal .discount-info {
  background: #fafbfb;
  border-radius: 8px;
  margin-top: 10px;
  padding: 16px;
}

.cost-breakdown-modal .price-change-breakdown {
  margin-top: 16px;
}

.cost-breakdown-modal .price-change-breakdown__header,
.cost-breakdown-modal .price-change-breakdown__info {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
}

.cost-breakdown-modal .price-change-breakdown__header p,
.cost-breakdown-modal .price-change-breakdown__info p {
  margin: 0;
}

.cost-breakdown-modal .price-change-breakdown__amount {
  flex: 0 0 auto;
  font-weight: 600;
}

.cost-breakdown-modal .price-change-breakdown__details {
  margin-top: 4px;
  padding-left: 20px;
}

.cost-breakdown-modal .price-change-breakdown__info p:last-child {
  text-align: right;
}

.cost-breakdown-modal .code .Polaris-Button {
  position: absolute;
  top: 0rem;
  right: -1.3rem;
}

.BC-Page__SubscriptionV3
  .planStatus
  .Polaris-Stack
  .Polaris-Stack__Item:last-child
  .Polaris-TextContainer {
  margin-top: 24px;
  padding: 0 28px;
}

.divider {
  border-bottom: 1px solid var(--p-divider);
  margin-top: 24px;
}

.BC-Page__SubscriptionV3
  .planStatus
  .Polaris-Stack
  .Polaris-Stack__Item:last-child
  .Polaris-TextContainer
  .total-bill,
.cost-breakdown-modal .total-bill {
  display: flex;
  justify-content: space-between;
}

.cost-breakdown-modal .total-bill {
  margin-top: 16px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.cost-breakdown-modal .plan-status-action {
  margin-top: 8px;
}

.BC-Page__SubscriptionV3 .planStatus .Polaris-Stack .Polaris-Stack__Item:last-child ul,
.cost-breakdown-modal .discount-info ul,
.cost-breakdown-modal div div ul {
  padding-left: 20px;
  margin-top: 4px;
}

.BC-Page__SubscriptionV3 .planStatus .cost-breakdown .Polaris-Icon svg {
  fill: #2c6ecb;
}

.BC-Page__SubscriptionV3-Package .planStatus .status > div,
.BC-Page__SubscriptionV3 .planStatus .status > div,
.BC-Page__SubscriptionV3-Package .planStatus .productCount > div,
.BC-Page__SubscriptionV3 .planStatus .productCount > div {
  font-size: 1rem;
  font-weight: 700;
  padding-bottom: 0.5rem;
}

.BC-Page__SubscriptionV3-Package .planStatus .productCount,
.BC-Page__SubscriptionV3 .planStatus .productCount {
  width: 50%;
  text-align: center;
  float: right;
}

.BC-Page__SubscriptionV3-Package .planStatus .productCount .count {
  font-weight: 600;
  font-size: 26px;
  line-height: 32px;
}

.plan-status-action {
  display: flex;
  justify-content: flex-end;
}

.BC-Page__SubscriptionV3-Package > .Polaris-Page .card-title-uppercase {
  margin-bottom: 24px;
}

.BC-Page__SubscriptionV3-Package .plan-notice-status {
  margin-top: 8px;
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
}

.BC-Page__SubscriptionV3 .planStatus .productCount .count {
  font-size: 1.625rem;
}

.BC-Page__SubscriptionV3 .planStatus .discountCode .Polaris-Connected .Polaris-Connected__Item {
  --p-focused: none;
}

.BC-Page__SubscriptionV3 .planStatus .error {
  color: #de3618;
  padding-top: 8px;
}

.BC-Page__SubscriptionV3
  .subscription-plan
  .Polaris-Card
  .Polaris-Card__Section
  .package-infos
  .package-content {
  margin: 20px 0;
  display: flex;
  width: 70%;
  justify-content: space-between;
}

.BC-Page__SubscriptionV3
  .subscription-plan
  .Polaris-Card
  .Polaris-Card__Section
  .package-infos
  .package-content
  ul {
  padding-left: 32px;
}

.BC-Page__SubscriptionV3
  .subscription-plan
  .Polaris-Card
  .Polaris-Card__Section
  .package-infos
  .package-title {
  display: flex;
  height: 100%;
  height: 64px;
  background-color: #f1f8f5;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  border-radius: 8px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}

.BC-Page__SubscriptionV3
  .subscription-plan
  .Polaris-Card
  .Polaris-Card__Section
  .package-infos
  .package-title
  > div:first-child
  .Polaris-Badge {
  margin-left: 6px;
  height: 20px;
}

.BC-Page__SubscriptionV3-Package .planStatus .Polaris-Badge--statusAttention,
.BC-Page__SubscriptionV3 .subscription-plan .planStatus .Polaris-Badge--statusAttention {
  background-color: #ffd79d;
}

.BC-Page__SubscriptionV3 .subscription-plan .Polaris-Card .Polaris-Card__Section .addon-infos {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
}

.BC-Page__SubscriptionV3
  .subscription-plan
  .Polaris-Card
  .Polaris-Card__Section
  .addon-infos
  .addon-card {
  width: 285px;
  min-height: 172px;
  background: #f1f8f5;
  border-radius: 8px;
  padding: 20px;
}

.review-addon-modal .addon-info .Polaris-TextStyle--variationStrong,
.review-package-modal .package-info .Polaris-TextStyle--variationStrong,
.review-addon-modal .addon-billing .total,
.review-package-modal .package-billing .total,
.BC-Page__SubscriptionV3
  .planStatus
  .Polaris-Stack
  .Polaris-Stack__Item:last-child
  .Polaris-TextContainer
  .Polaris-TextStyle--variationStrong,
.BC-Page__SubscriptionV3 .planStatus .Polaris-Stack .Polaris-Stack__Item:first-child strong,
.BC-Page__SubscriptionV3
  .subscription-plan
  .Polaris-Card
  .Polaris-Card__Section
  .addon-infos
  .addon-card
  div
  > .Polaris-TextStyle--variationStrong,
.BC-Page__SubscriptionV3
  .subscription-plan
  .Polaris-Card
  .Polaris-Card__Section
  .addon-infos
  .addon-card
  > .Polaris-TextStyle--variationStrong {
  font-size: 16px;
  line-height: 24px;
}

.BC-Page__SubscriptionV3
  .subscription-plan
  .Polaris-Card
  .Polaris-Card__Section
  .addon-infos
  .addon-card {
  position: relative;
}

.BC-Page__SubscriptionV3
  .subscription-plan
  .Polaris-Card
  .Polaris-Card__Section
  .addon-infos
  .addon-card
  > .Polaris-TextStyle--variationStrong {
  position: absolute;
  bottom: 20px;
}

.BC-Page__SubscriptionV3
  .subscription-plan
  .Polaris-Card
  .Polaris-Card__Section
  .addon-infos
  .addon-card
  .Polaris-Button--iconOnly {
  padding-right: 0px;
}

.addon-infos .addon-card > ul {
  margin-bottom: 36px;
  margin-top: 8px;
  padding-left: 20px;
}

/* Subscription v3 - plan summary */
.BC-Page__SubscriptionV3 .BC-planSummary {
  display: flex;
  gap: 40px;
}

.BC-Page__SubscriptionV3 .BC-planSummary .status .bottom {
  font-size: 12px;
  line-height: 16px;
  margin-top: 7px;
}

.BC-Page__SubscriptionV3 .BC-planSummary .status {
  padding-right: 20px;
  width: 50%;
}

.BC-Page__SubscriptionV3 .BC-planSummary > .status > div > .Polaris-TextStyle--variationStrong,
.BC-Page__SubscriptionV3 .BC-planSummary > div > .Polaris-TextStyle--variationStrong {
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
}

.BC-Page__SubscriptionV3 .BC-planSummary .status > div:first-child {
  display: flex;
  gap: 8px;
  text-align: center;
  align-items: center;
}

.BC-Page__SubscriptionV3 .BC-planSummary .productCount {
  width: 24%;
}

.BC-Page__SubscriptionV3 .BC-planSummary .count {
  margin-top: 7px;
  font-size: 28px;
  font-weight: 600;
  line-height: 32px;
}

.BC-Page__SubscriptionV3 .BC-planSummary .invoiceTotal .cost {
  color: var(--interactive-default, #2c6ecb);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  padding: 2px 0;
  margin-top: 4px;
}

.BC-Page__SubscriptionV3 .BC-planSummary .invoiceTotal .cost:hover {
  cursor: pointer;
}

.BC-Page__SubscriptionV3 .BC-planSummary .invoiceTotal {
  width: 30%;
}

.BC-Page__SubscriptionV3 .Polaris-Card__Section .planSummary-addon .title {
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.BC-Page__SubscriptionV3 .Polaris-Card__Section .planSummary-addon .addon-item {
  padding: 8px 16px 8px 4px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.BC-Page__SubscriptionV3 .Polaris-Card__Section .planSummary-addon .addon-item > div:first-child {
  width: 29%;
}

.BC-Page__SubscriptionV3 .Polaris-Card__Section .planSummary-addon .addon-item > div:nth-child(2) {
  width: 10%;
}

.BC-Page__SubscriptionV3
  .Polaris-Card__Section
  .planSummary-addon
  .addon-item
  > div
  .Polaris-Badge--statusNew {
  font-weight: 400 !important;
  background-color: #f1f2f3;
}

.BC-Page__SubscriptionV3 .Polaris-Card__Section .planSummary-addon .addon-item > div:nth-child(3) {
  width: 10%;
}

.BC-Page__SubscriptionV3 .Polaris-Card__Section .planSummary-addon .addon-item > div:nth-child(4) {
  color: var(--text-subdued, #6d7175);
}

.BC-Page__SubscriptionV3 .Polaris-Card__Section .planSummary-addon .addon-item .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
}

.cost-breakdown-modal div div .Polaris-TextStyle--variationStrong {
  font-size: 16px;
  line-height: 24px;
}

.cost-breakdown-modal div div .error {
  color: var(--text-critical, #d72c0d);
  margin-top: 4px;
}

#BC-UnsubscribeModal-Content .Polaris-Card .Polaris-FormLayout .Polaris-FormLayout__Item ul li {
  margin-top: 10px;
}

#BC-UnsubscribeModal-Content .Polaris-Card .Polaris-Button {
  margin-top: 20px;
}

.BC-Page__SubscriptionV3-Package .packages > div {
  max-width: 1170px;
  min-height: 778px;
  margin-top: 40px !important;
  margin: auto;
  padding: 38px 24px 24px 24px;
  background: #ffffff;
  border-radius: 8px;
}

.BC-Page__SubscriptionV3 .packages > div {
  min-height: 584px;
  margin: auto;
  background: #ffffff;
  border-radius: 8px;
}

.BC-Page__SubscriptionV3 .packages > div > div:first-child {
  gap: 20px;
}

.BC-Page__SubscriptionV3 .packages > div > div:first-child,
.BC-Page__SubscriptionV3-Package .packages > div > div:first-child {
  display: flex;
  justify-content: space-between;
}

.BC-Page__SubscriptionV3 .packages > div > p,
.BC-Page__SubscriptionV3-Package .packages > div > p {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.BC-Page__SubscriptionV3 .packages > div > p span,
.BC-Page__SubscriptionV3-Package .packages > div > p span {
  margin-left: 4px;
}

.BC-Page__SubscriptionV3 .packages div div .Polaris-Card {
  margin-top: 0;
  padding: 20px 16px;
  min-height: 544px;
  width: 100%;
}

.BC-Page__SubscriptionV3-Package .packages div div .Polaris-Card {
  width: 358px;
  min-height: 664px;
  margin-top: 0;
  padding: 40px 32px;
}

.BC-Page__SubscriptionV3 .packages div div .Polaris-Card:nth-child(2),
.BC-Page__SubscriptionV3-Package .packages div div .Polaris-Card:nth-child(2) {
  position: relative;
}

.BC-Page__SubscriptionV3 .packages div div .Polaris-Card .most-popular {
  width: 100px;
  height: 20px;
  background: #008060;
  border-radius: 20px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  position: absolute;
  top: -10px;
  left: 33%;
}

.BC-Page__SubscriptionV3-Package .packages div div .Polaris-Card .most-popular {
  width: 147px;
  height: 28px;
  background: #008060;
  border-radius: 20px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  position: absolute;
  top: -15px;
  left: 30%;
}

.BC-Page__SubscriptionV3-Package .packages div div .Polaris-Card > div:nth-child(2) {
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
}

.BC-Page__SubscriptionV3 .packages div div .Polaris-Card > div:nth-child(2) {
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  margin-top: 9px;
}

.BC-Page__SubscriptionV3 .packages div div .Polaris-Card .package-name {
  margin-top: unset !important;
}

.BC-Page__SubscriptionV3-Package .packages div div .Polaris-Card .price {
  margin-top: 0 !important;
}

.BC-Page__SubscriptionV3-Package .packages div div .Polaris-Card > div:not(:first-child) {
  margin-top: 24px;
}

.BC-Page__SubscriptionV3 .packages div div .Polaris-Card > div:not(:first-child) {
  margin-top: 16px;
}

.BC-Page__SubscriptionV3 .packages div div .Polaris-Card > div:nth-child(3),
.BC-Page__SubscriptionV3-Package .packages div div .Polaris-Card > div:nth-child(3) {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: var(--text-subdued, #6d7175);
}

.BC-Page__SubscriptionV3-Package .packages div div .Polaris-Card > div:nth-child(3) {
  margin-bottom: 24px;
  margin-top: 8px;
}

.BC-Page__SubscriptionV3 .packages div div .Polaris-Card > div:nth-child(3) {
  margin-top: 0;
  font-size: 12px;
  line-height: 16px;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card .price {
  font-size: 28px;
  font-weight: 600;
  line-height: 32px;
  text-align: center;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card .price span {
  font-size: 16px !important;
  font-weight: 600;
  line-height: 24px !important;
}

.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card > div:nth-child(4) {
  font-weight: 600;
  font-size: 36px;
  line-height: 48px;
  text-align: center;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card > div:nth-child(4) span,
.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card > div:nth-child(4) span {
  font-size: 24px;
  line-height: 32px;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card > div:nth-child(5),
.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card > div:nth-child(5) {
  display: flex;
  justify-content: center;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card > div:nth-child(5) > div {
  width: 45%;
}

.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card > div:nth-child(5) > div {
  width: 75%;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card > div:nth-child(5) div .Polaris-Icon,
.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card > div:nth-child(5) div .Polaris-Icon {
  width: 2rem;
  height: 1.5rem;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card > div:nth-child(5) .Polaris-Button,
.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card > div:nth-child(5) .Polaris-Button {
  width: 100%;
}

.BC-Page__SubscriptionV3
  .packages
  div
  .Polaris-Card
  > div:nth-child(5)
  .Polaris-Button
  .Polaris-Button__Content,
.BC-Page__SubscriptionV3-Package
  .packages
  div
  .Polaris-Card
  > div:nth-child(5)
  .Polaris-Button
  .Polaris-Button__Content {
  display: flex;
  justify-content: space-between;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card > div:nth-child(5) p,
.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card > div:nth-child(5) p {
  display: flex;
  align-items: center;
  margin-left: 16px;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card > div:nth-child(5) p {
  margin-left: 8px;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card:nth-child(2),
.BC-Page__SubscriptionV3-Package .packages div .package-suggest-card {
  background: #f1f8f5;
  border: 1px solid #008060;
  border-radius: 4px;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card {
  border: 1px solid var(--border-subdued, #c9cccf);
  box-shadow: none;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card .package-action .Polaris-Button {
  width: 100%;
  border: 1px solid #008060;
  border-radius: 4px;
  height: 44px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
}

.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card .package-action .Polaris-Button {
  width: 100%;
  border: 1px solid #008060;
  border-radius: 4px;
  height: 56px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
}

.BC-Page__SubscriptionV3
  .packages
  div
  .Polaris-Card:not(:nth-child(2))
  .package-action
  .Polaris-Button,
.BC-Page__SubscriptionV3-Package
  .packages
  div
  .Polaris-Card:not(.package-suggest-card)
  .package-action
  .Polaris-Button {
  color: #008060;
  background: #ffffff;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card .package-action .Polaris-Button--disabled,
.BC-Page__SubscriptionV3-Package
  .packages
  div
  .Polaris-Card
  .package-action
  .Polaris-Button--disabled {
  border: 1px solid rgb(165, 164, 164);
}

.BC-Page__SubscriptionV3
  .packages
  div
  .Polaris-Card:not(:nth-child(2))
  .package-action
  .Polaris-Button--disabled,
.BC-Page__SubscriptionV3-Package
  .packages
  div
  .Polaris-Card:not(.package-suggest-card)
  .package-action
  .Polaris-Button--disabled {
  background: var(--p-action-primary-disabled);
  color: var(--p-text-disabled);
}

.BC-Page__SubscriptionV3
  .packages
  div
  .Polaris-Card:not(:nth-child(2))
  .package-action
  .Polaris-Button:hover,
.BC-Page__SubscriptionV3-Package
  .packages
  div
  .Polaris-Card:not(.package-suggest-card)
  .package-action
  .Polaris-Button:hover {
  background: #f1f8f5 !important;
  box-shadow: #f1f8f5 !important;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card .question-title,
.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card .question-title {
  font-weight: 600;
  font-size: 16px !important;
  line-height: 28px !important;
}

.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card .advances-package {
  margin: 0;
  margin-top: 0 !important;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card .advances-package .advance-line {
  margin-top: 16px;
  display: flex;
  gap: 8px;
}

.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card .advances-package .advance-line {
  margin-top: 16px;
  display: flex;
  gap: 12px;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card .advances-package .advance-line .Polaris-Icon,
.BC-Page__SubscriptionV3-Package
  .packages
  div
  .Polaris-Card
  .advances-package
  .advance-line
  .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  margin-left: 0px;
  margin-right: 0px;
  max-width: 14px;
}

.BC-Page__SubscriptionV3
  .packages
  div
  .Polaris-Card
  .advances-package
  .advance-line
  .Polaris-Icon
  svg,
.BC-Page__SubscriptionV3-Package
  .packages
  div
  .Polaris-Card
  .advances-package
  .advance-line
  .Polaris-Icon
  svg {
  fill: #5e8e3e;
}

.BC-Page__SubscriptionV3 .packages .compare-package {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 12px 160px;
  gap: 66px;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--border-neutral-subdued, #babfc3);
  background: var(--surface-neutral-subdued, #f6f6f7);
}

.BC-Page__SubscriptionV3 .packages .compare-package p:first-child {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}

.BC-Page__SubscriptionV3 .packages .compare-package p:last-child {
  font-size: 14px;
  line-height: 20px;
}

.BC-Page__SubscriptionV3 .packages .compare-package .Polaris-Button {
  background: var(--surface-neutral-subdued, #f6f6f7);
}

.BC-Page__SubscriptionV3-Package .extend-addons {
  display: flex;
  margin-top: 40px !important;
  margin: auto;
  justify-content: center;
  height: 76px;
  letter-spacing: 1px;
}

.BC-Page__SubscriptionV3-Package .extend-addons > div {
  background: #f1f8f5;
  display: flex;
  padding: 32px;
  gap: 24px;
  border-radius: 8px;
  align-items: center;
}

.BC-Page__SubscriptionV3-Package .extend-addons p {
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
}

.review-addon-modal,
.review-package-modal {
  display: flex;
  max-height: 680px;
  min-height: 624px;
}

.review-addon-modal .review-addon,
.review-package-modal .review-package {
  width: 65%;
}

.review-addon-modal .review-addon,
.review-package-modal .review-package .Polaris-Scrollable {
  padding: 20px;
  height: 100%;
}

.review-package-modal .review-package .Polaris-Scrollable > div:first-child {
  font-size: 20px;
  line-height: 28px;
}

.review-package-modal .review-package .Polaris-Scrollable .link {
  color: #2c6ecb;
  cursor: pointer;
}

.review-package-modal .review-package .Polaris-Scrollable .link .Polaris-Icon svg {
  fill: #2c6ecb;
}

.review-package-modal .review-package .Polaris-Scrollable > div:not(:first-child) {
  margin-top: 20px;
}

.review-package-modal .review-package .Polaris-Scrollable .selected {
  border: 1px solid #2c6ecb !important;
}

.review-package-modal
  .review-package
  .Polaris-ChoiceList
  .Polaris-ChoiceList__ChoiceItem
  .Polaris-Choice__Label {
  font-weight: 600;
}

.review-package-modal .review-package .Polaris-ChoiceList .Polaris-ChoiceList__ChoiceItem {
  padding: 12px 28px 16px 17px;
  width: 100%;
  height: auto;
  border: 1px solid #dfe3e8;
  border-radius: 8px;
  margin-top: 20px;
}

.review-package-modal .review-package .explore-addon-card > div {
  margin-top: 8px;
}

.review-package-modal .review-package .explore-addon-card .Polaris-Select {
  width: 36%;
}

.review-package-modal .review-package .explore-addon-card .addon-card-price {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
}

.review-addon-modal .addon-billing,
.review-package-modal .package-billing {
  padding: 20px;
  width: 340px;
  background: white;
  border-radius: 8px;
}

.review-addon-modal .addon-billing .billing-title,
.review-package-modal .package-billing .billing-title {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  margin-bottom: 32px;
}

.review-package-modal .package-billing .package-info div > div:nth-child(2) {
  margin-top: 8px !important;
}

.review-package-modal .discount-breakdown {
  margin-right: 15px;
  float: right;
  color: #008060;
  font-weight: var(--p-font-weight-semibold);
}

.review-addon-modal .addon-billing .discount-code-info .discount-applied > div:nth-child(4),
.review-package-modal .package-billing .discount-code-info .discount-applied > div:nth-child(4),
.review-addon-modal .addon-billing > .Polaris-Button,
.review-addon-modal .addon-billing .total,
.review-addon-modal .addon-billing .discount-code-info,
.review-package-modal .package-billing > .Polaris-Button,
.review-package-modal .package-billing .total,
.review-package-modal .package-billing .discount-code-info {
  margin-top: 20px;
}

.cost-breakdown-modal .code,
.BC-Page__SubscriptionV3
  .planStatus
  .Polaris-Stack
  .Polaris-Stack__Item:last-child
  .Polaris-TextContainer
  .code,
.review-addon-modal .addon-billing .discount-code-info .discount-applied .code div,
.review-package-modal .package-billing .discount-code-info .discount-applied .code div {
  display: flex;
  background: #f1f8f5;
  border-radius: 4px;
  margin-top: 4px;
  width: auto;
  padding: 5px;
  height: 24px;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.cost-breakdown-modal .code .Polaris-Icon,
.BC-Page__SubscriptionV3
  .planStatus
  .Polaris-Stack
  .Polaris-Stack__Item:last-child
  .Polaris-TextContainer
  .code
  .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  margin-left: 8px;
  width: 16px;
  height: 18px;
  cursor: pointer;
}

.review-addon-modal .review-addon a,
.review-package-modal .review-package a {
  text-decoration: none;
  color: #2c6ecb;
}

.review-addon-modal .review-addon .Polaris-Icon,
.review-package-modal .review-package .Polaris-Icon,
.review-addon-modal .addon-billing .discount-code-info .discount-applied .Polaris-Icon,
.review-package-modal .package-billing .discount-code-info .discount-applied .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
}

.review-addon-modal .review-addon a .Polaris-Icon svg,
.review-package-modal .review-package a .Polaris-Icon svg,
.review-addon-modal
  .addon-billing
  .discount-code-info
  .discount-applied
  > div:nth-child(4)
  .Polaris-Icon
  svg,
.review-package-modal
  .package-billing
  .discount-code-info
  .discount-applied
  > div:nth-child(4)
  .Polaris-Icon
  svg {
  fill: #2c6ecb;
}

.review-package-modal .Polaris-Icon {
  margin: unset !important;
}

.review-addon-modal .addon-billing .discount-code-info .discount-applied .code div .Polaris-Icon,
.review-package-modal
  .package-billing
  .discount-code-info
  .discount-applied
  .code
  div
  .Polaris-Icon {
  width: 15px;
  height: 13px;
  margin-left: 8px;
  cursor: pointer;
  margin-right: unset;
}

.review-addon-modal .addon-billing .discount-code-info .discount-applied .code,
.review-package-modal .package-billing .discount-code-info .discount-applied .code {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.review-addon-modal
  .addon-billing
  .discount-code-info
  .discount-applied
  .code
  .Polaris-Button--iconOnly,
.review-package-modal
  .package-billing
  .discount-code-info
  .discount-applied
  .code
  .Polaris-Button--iconOnly {
  top: 8px !important;
  right: 8px !important;
}

.review-addon-modal .addon-billing .discount-code-info .discount-applied > div:nth-child(3),
.review-package-modal .package-billing .discount-code-info .discount-applied > div:nth-child(3) {
  color: #6d7175;
  margin-top: 8px;
  font-size: 12px;
}

.review-addon-modal
  .addon-billing
  .discount-code-info
  .discount-applied
  .code
  .Polaris-TextStyle--variationStrong,
.review-package-modal
  .package-billing
  .discount-code-info
  .discount-applied
  .code
  .Polaris-TextStyle--variationStrong {
  color: #008060;
  margin-right: 10px;
}

.review-addon-modal .addon-billing > .Polaris-Button,
.review-package-modal .package-billing > .Polaris-Button {
  width: 100%;
}

.review-addon-modal .addon-billing .total,
.review-addon-modal .addon-billing .package-info div div,
.review-package-modal .package-billing .total,
.review-package-modal .package-billing .package-info div.detail-bill {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.review-package-modal .package-billing .package-info div.detail-bill .detail-bill-addon {
  display: flex;
}

.review-package-modal .package-billing .package-info div .Polaris-Select {
  width: 60%;
  margin-bottom: 5px;
}

.review-package-modal .package-billing .discount-code-info > p,
.review-addon-modal .addon-billing .discount-code-info > p {
  color: #2c6ecb;
  cursor: pointer;
}

.review-package-modal .package-billing .discount-code-info .error,
.review-addon-modal .addon-billing .discount-code-info .error {
  color: #de3618;
  line-height: 20px;
  margin-top: 4px;
}

/* addon-review modal */

.review-addon-modal .review-addon > div:not(:first-child) {
  margin-top: 20px;
}

.review-addon-modal .review-addon > div:first-child > p {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
}

.review-addon-modal .addon-billing .addon-info,
.review-addon-modal .review-addon > div:nth-child(3),
.review-addon-modal .review-addon > div:first-child {
  display: flex;
  justify-content: space-between;
}

.review-addon-modal .addon-billing .addon-info {
  align-items: center;
}

.review-addon-modal .review-addon > div:nth-child(2) .addon-visualMerchandising {
  display: grid;
  gap: 8px;
}

.review-addon-modal .review-addon > div:nth-child(2) > div > div {
  flex: 40%;
}

.review-addon-modal .review-addon > div:nth-child(2) {
  width: 100%;
  padding: 20px;
  background: #fafbfb;
  border-radius: 8px;
}

.review-addon-modal .review-addon > div:nth-child(2) > div {
  margin-top: 16px;
}

.review-addon-modal .review-addon > div:nth-child(2) > div.addon-aiPowerSearch {
  display: block;
}

.review-addon-modal .review-addon > div:nth-child(2) > div.addon-aiPowerSearch > div {
  margin-bottom: 8px;
}

.review-addon-modal .review-addon > div:nth-child(2) div div div span.sub-addon-title {
  font-size: 16px;
  line-height: 24px;
  margin-left: 2px;
}

.review-addon-modal .review-addon > div:nth-child(2) div div div span.sub-addon-new {
  margin-left: 4px;
}

.review-addon-modal .review-addon > div:nth-child(2) div div > p {
  font-size: 12px;
  line-height: 16px;
  margin-left: 18px;
}

.review-addon-modal .review-addon > div:nth-child(2) .Polaris-Icon {
  fill: #008060;
  height: 1.5rem;
  width: 1rem;
}

.review-addon-modal .review-addon > div:nth-child(3) > div {
  flex: 1 1 1;
  text-align: center;
}

.review-addon-modal .review-addon > div:nth-child(3) > div img {
  margin: auto;
}

.review-addon-modal .review-addon > div:nth-child(4) ul {
  margin-top: 4px;
  padding-left: 24px;
}

.review-addon-modal .addon-billing .Polaris-Select {
  width: 60%;
}

.review-addon-modal .addon-billing .sub-addon-info {
  font-size: 12px;
  line-height: 16px;
  color: #6d7175;
  margin-top: 4px;
}

.review-addon-modal .addon-billing .describe-button {
  width: 85%;
  margin: auto;
  text-align: center;
  margin-top: 8px;
}

.review-addon-modal .review-addon .Polaris-Icon {
  margin-top: 0 !important;
}

.review-addon-modal .review-addon .Polaris-Icon svg {
  max-width: none;
  max-height: none;
  width: auto;
}

.review-addon-modal .addon-modal-highlight {
  background-image: url('https://cdn.boostcommerce.io/assets/common/background-warning-mini.png');
  background-repeat: no-repeat;
  background-position-y: bottom;
  background-size: contain;
  border-radius: 8px;
  padding: 8px;
  margin-top: -20px;
  margin-bottom: 20px;
}

.review-addon-modal .addon-modal-highlight ul {
  margin: 0;
  padding-left: 20px;
}

.review-addon-modal .addon-modal-highlight ul .Polaris-Icon {
  margin: unset;
  display: inline-flex;
  vertical-align: top;
}

/* end  */
.BC-Page__SubscriptionV3 .textSetupComplete:first-child {
  margin-top: 0.6875rem;
}

.BC-Page__SubscriptionV3 .textSetupComplete {
  color: #212b36;
  margin-top: 1rem;
}

.BC-Page__SubscriptionV3 .textSetupComplete:last-child {
  margin-top: 1.5rem;
}

.BC-Page__SubscriptionV3 .noUiButton {
  display: inline-flex;
  margin-top: 5px;
  margin-left: 1px;
}

.BC-Page__SubscriptionV3 .noUiMaxProductLabel {
  margin-top: -38px;
  position: absolute;
  right: -40px;
  font-size: 14px;
}

.BC-Page__SubscriptionV3 .noUi-active {
  box-shadow: none;
}

.BC-Page__Subscription .noUiButton .Polaris-Icon {
  width: 0.9375rem;
  height: 0.9375rem;
}

.BC-Page__SubscriptionV3 .noUiButton .Polaris-Icon:last-child {
  margin-left: -7px;
}

.BC-Page__SubscriptionV3 .information-pricing-V2 {
  padding: 0 0.75rem;
}

.BC-Page__SubscriptionV3 .information-pricing-V2 p {
  margin: 1.25rem 0;
}

.BC-Page__SubscriptionV3 .information-pricing-V2 .btn-show {
  text-align: center;
  margin: 0.75rem;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans {
  border: 0.0625rem solid #d8e6ff;
  background: #f9fbff;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans table {
  table-layout: fixed;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-DataTable__Cell {
  border-right: 0.0625rem solid #d8e6ff;
  border-bottom: 0.0625rem solid #d8e6ff;
  font-weight: 500;
  text-align: center;
  white-space: normal;
  padding: 1rem 1.5rem;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans tr .Polaris-DataTable__Cell:first-child {
  padding-right: 0;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-DataTable__Cell.Column__5 {
  width: 132px;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-DataTable__Cell.Column__1 {
  width: 664px;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-DataTable__Cell:first-child {
  width: 268px;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-DataTable__Cell.left-title,
.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-DataTable__Cell.content-description,
.BC-Page__SubscriptionV3 .BC_DataTable_Plans .row-heading .Polaris-DataTable__Cell {
  text-align: left;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans .row-without-border .Polaris-DataTable__Cell,
.BC-Page__SubscriptionV3 .BC_DataTable_Plans tr .Polaris-DataTable__Cell:last-child {
  border-right: none;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans .row-heading td.Polaris-DataTable__Cell {
  background: #d8e6ff;
  padding: 1.125rem 1.5rem;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans .row-heading button,
.BC-Page__SubscriptionV3 .BC_DataTable_Plans .left-title button {
  color: inherit;
  text-decoration: none;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans .row-heading button:active .Polaris-Button__Content,
.BC-Page__SubscriptionV3 .BC_DataTable_Plans .left-title button:active .Polaris-Button__Content {
  background: none;
}

.BC-Page__SubscriptionV3
  .BC_DataTable_Plans
  .row-heading
  .Polaris-Button__DisclosureIcon
  .Polaris-Icon__Svg,
.BC-Page__SubscriptionV3
  .BC_DataTable_Plans
  .left-title
  .Polaris-Button__DisclosureIcon
  .Polaris-Icon__Svg {
  fill: inherit;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans .row-heading .Polaris-Button__Text {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans th.Polaris-DataTable__Cell {
  border-right: 0.0625rem solid #ffffff;
  background: #d8e6ff;
  font-size: 16px;
  font-weight: bold;
  line-height: 22px;
  padding: 0.625rem;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans th.Polaris-DataTable__Cell:last-child {
  padding: 0.625rem 1rem;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-Icon--colorGreen {
  margin-left: auto;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-DataTable__Cell.content-description {
  font-size: 12px;
  font-weight: normal;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-DataTable__Cell.content-description > span {
  display: block;
}

.BC-Page__SubscriptionV3
  .BC_DataTable_Plans
  .Polaris-DataTable__Cell.content-description
  > span:before {
  content: '-';
  margin-right: 5px;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-Badge {
  background-color: #d8e6ff;
  color: #2459b4;
  border: none;
  padding: 0 0.3125rem;
  font-size: 10px;
  font-weight: 600;
  margin-left: 4px;
}

.BC-Page__SubscriptionV3 .BC_DataTable_Plans .icon-minus .Polaris-Icon {
  width: 0.75rem;
  padding-top: 0.3125rem;
}

.plan-review-brand {
  margin-top: 2.5rem;
  margin-bottom: 1.875rem;
}

.BC-Page__SubscriptionV3-Package .card-title-uppercase .Polaris-Heading,
.BC-Page__SubscriptionV3-Addon .card-title-uppercase .Polaris-Heading,
.BC-Page__SubscriptionV3 .addon-card-preview .card-title-uppercase .Polaris-Heading,
.BC-Page__SubscriptionV3 .review .title .Polaris-Heading,
.BC-Page__SubscriptionV3 .questions .title .Polaris-Heading {
  font-weight: bold;
  font-size: 28px;
  line-height: 36px;
}

.BC-Page__SubscriptionV3-Addon .card-title-uppercase p {
  text-transform: none !important;
}

.BC-Page__SubscriptionV3-Package .Polaris-FullscreenBar,
.BC-Page__SubscriptionV3-Addon .Polaris-FullscreenBar {
  z-index: 518;
}

.BC-Page__SubscriptionV3 .addon-card-preview > .Polaris-Card {
  min-height: 510px;
}

.BC-Page__SubscriptionV3 .addon-card-preview .Polaris-Card .Polaris-Card__Section .Polaris-Card {
  max-width: 264px;
  margin-top: unset;
}

.BC-Page__SubscriptionV3
  .addon-card-preview
  .Polaris-Card
  .Polaris-Card
  .addon-card-detail
  .addon-price {
  align-items: unset;
  margin-top: 8px;
}

.Polaris-Card .addon-card-detail .addon-price {
  font-size: 24px;
  font-weight: 500;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  min-height: 36px;
}

.Polaris-Card .addon-card-detail .addon-price > span,
.Polaris-Card .addon-card-detail .addon-price > div {
  flex: 40% 1;
}

.BC-Page__SubscriptionV3-Addon .Polaris-FullscreenBar div {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-weight: 700;
  font-size: 28px;
  line-height: 36px;
}

.BC-Page__SubscriptionV3-Addon .addons-list .Polaris-Card {
  max-width: 363px;
  /* max-height: 400px; */
  height: max-content;
  margin-top: unset;
}

.BC-Page__SubscriptionV3-Addon .addons-list .Polaris-Card .addon-card-detail,
.BC-Page__SubscriptionV3 .addon-card-preview .Polaris-Card .Polaris-Card .addon-card-detail {
  margin: 8px 16px 16px 16px;
}

.BC-Page__SubscriptionV3-Addon .addons-list .Polaris-Card .addon-card-detail {
  min-height: 200px;
}

.BC-Page__SubscriptionV3-Addon .addons-list .Polaris-Card .addon-card-detail button {
  position: absolute;
  bottom: 0px;
}

.BC-Page__SubscriptionV3-Addon .addons-list .Polaris-Card .addon-card-detail ul,
.BC-Page__SubscriptionV3 .addon-card-preview .Polaris-Card .Polaris-Card .addon-card-detail ul {
  padding-left: 24px;
  margin: 8px 0 16px 0;
}

.BC-Page__SubscriptionV3 .addon-card-preview .Polaris-Card .Polaris-Card .addon-card-detail {
  min-height: 295px;
}

.BC-Page__SubscriptionV3-Addon .addons-list .Polaris-Card .addon-card-detail,
.BC-Page__SubscriptionV3 .addon-card-preview .Polaris-Card .Polaris-Card .addon-card-detail {
  position: relative;
}

.BC-Page__SubscriptionV3 .addon-card-preview .Polaris-Card .Polaris-Card .addon-card-detail button {
  width: 100%;
  position: absolute;
  bottom: 20px;
}

.BC-Page__SubscriptionV3
  .addon-card-preview
  .Polaris-Card
  .Polaris-Card
  .addon-card-detail
  .Polaris-Select {
  max-width: 70%;
  margin-top: 8px;
}

.BC-Page__SubscriptionV3-Addon .addons-list .Polaris-Card .addon-card-detail button {
  margin-top: 8px;
  min-width: 45%;
}

.BC-Page__SubscriptionV3-Addon .addons-list {
  background: #ffffff;
  border-radius: 0px 0px 8px 8px;
  max-width: 1170px;
  /* max-height: 440px; */
  padding: 20px;
  margin-top: 40px !important;
  margin: auto;
  display: flex;
  gap: 20px;
}

.BC_AddonList-Sliders {
  position: inherit;
  min-height: 443px;
  padding-bottom: 1px;
}

.BC_AddonList-Sliders ul li {
  /* width: 284px !important; */
  padding-right: 19px;
  margin-right: 1px;
  margin-left: 1px;
}

.subscriptionV3-questions .title .Polaris-Heading,
.plan-review-brand .Polaris-Heading {
  font-size: 28px;
  font-weight: 600;
  line-height: 32px;
}

.BC-Page__SubscriptionV3 .subscriptionV3-questions .Polaris-Card__Header {
  border-bottom: unset !important;
}

.plan-review-brand .brand-items {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  margin: 16px 0;
}

.BC-Page__SubscriptionV3 .review {
  margin-top: 4.3125rem;
  margin-bottom: 2.75rem;
}

.BC-Page__SubscriptionV3 .review .title {
  margin-bottom: 1.75rem;
}

.BC-Page__SubscriptionV3 .review .Polaris-Layout__Section--oneThird {
  flex: 1 1 21.875rem;
}

.BC-Page__SubscriptionV3 .review .utilities {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  text-align: center;
  margin: 1.5rem auto;
}

.BC-Page__SubscriptionV3 .review .Polaris-Layout__Section .utilities:first-child {
  margin-top: 0;
}

.BC-Page__SubscriptionV3 .review .Polaris-Layout__Section .utilities:last-child {
  margin-bottom: 0;
}

.BC-Page__SubscriptionV3 .review .utilities > div {
  text-align: center;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
}

.BC-Page__SubscriptionV3 .review .utilities .Polaris-Heading {
  margin-top: 1.25rem;
  margin-bottom: 1.5rem;
}

.BC-Page__SubscriptionV3 .review .Polaris-Card + .Polaris-Card {
  margin-top: 1.5rem;
}

.BC-Page__SubscriptionV3 .review .review-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.25rem;
}

.BC-Page__SubscriptionV3 .review .review-content {
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 0.25rem;
}

.subscriptionV3-questions {
  margin-top: 3.75rem;
  margin-bottom: 1.25rem;
}

.subscriptionV3-questions .Polaris-Card__Header {
  padding-bottom: 1rem;
  padding-top: 1rem;
}

.subscriptionV3-questions .Polaris-Card__Header .Polaris-Stack {
  flex-wrap: unset;
}

.subscriptionV3-questions
  .Polaris-Card__Header
  .Polaris-Stack
  .Polaris-Stack__Item
  .rotate-icon
  .Polaris-Icon {
  transform: rotate(90deg);
}

.subscriptionV3-questions .Polaris-Card__Section {
  padding-top: 0;
}

.subscriptionV3-questions .answer p + p {
  margin-top: 1.25rem;
}

.subscriptionV3-questions .answer p {
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  overflow-wrap: break-word;
}

.BC-Page__SubscriptionV3-Package .transition-enter {
  transform: translateY(-1.25rem);
  opacity: 0;
  visibility: hidden;
  z-index: -1;
}

.BC-Page__SubscriptionV3-Package .transition-enter-active {
  transform: translateY(0%);
  opacity: 1;
  visibility: visible;
  z-index: 1;
  transition: all 0.6s ease-in;
}

.BC-Page__SubscriptionV3-Package .transition-exit {
  transform: translateY(0);
  opacity: 1;
  z-index: 1;
  visibility: visible;
}

.BC-Page__SubscriptionV3-Package .transition-exit-active {
  transform: translateY(-1.25rem);
  opacity: 0;
  visibility: hidden;
  z-index: -1;
  transition: all 0.3s ease-out;
}

.BC-Page__SubscriptionV3-Package .item-transition {
  overflow: hidden;
}

/* Package comparison page */
.BC-Page__Package-Comparison .title-bar,
.BC-Page__Package-ComparisonV4 .title-bar {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.BC-Page__Package-Comparison .choose-product-number,
.BC-Page__Package-ComparisonV4 .choose-product-number {
  font-size: 20px;
}

.BC-Page__Package-Comparison .choose-product-number .select-product,
.BC-Page__Package-ComparisonV4 .choose-product-number .select-product {
  margin: 0 auto;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
}

.BC-Page__Package-Comparison .choose-product-number .select-product .Polaris-Select,
.BC-Page__Package-ComparisonV4 .choose-product-number .select-product .Polaris-Select {
  width: 150px;
}

.BC-Page__Package-ComparisonV4 .Polaris-Heading,
.BC-Page__Package-Comparison .Polaris-Heading {
  font-size: 36px;
  font-weight: 600;
  line-height: 44px;
  margin: 40px auto;
}

.package-comparison-table {
  border-top: 0.03rem solid var(--neutral-n-30, #e4e4e9);
  width: 80%;
  border-radius: 4px;
  background: var(--neutral-white, #fff);
  margin: 24px auto;
}

.package-comparison-table .price {
  font-size: 28px;
  font-weight: 600;
  line-height: 32px;
  text-align: center;
}

.BC-Page__Package-ComparisonV4 .package-comparison-table .price > span:first-child {
  font-size: 36px !important;
  font-weight: 600 !important;
  line-height: 40px !important;
  text-align: center;
}

.package-comparison-table .row .package-tag {
  width: 100%;
  height: 24px;
  padding: 4px 43px 4px 43px;
  gap: 4px;
  border-radius: 8px 8px 0px 0px;
  border: 1px 0px 1px 1px;
  position: absolute;
  top: -24px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
}

.BC-Page__Package-ComparisonV4 .package-comparison-table {
  margin-top: 64px;
}

.package-comparison-table .column-package {
  position: relative;
}

.package-comparison-table .column-package--success {
  background-color: #f1f8f5;
}

.package-comparison-table .row .package-tag-subdued {
  background: #e4e5e7;
}

.package-comparison-table .row .package-tag-success {
  background: #008060;
  color: #ffffff;
}

.BC-Page__Package-ComparisonV4 .package-comparison-table .price span:last-child {
  font-size: 12px !important;
  font-weight: 600;
  color: #6d7175;
  line-height: 16px !important;
}

.package-comparison-table .price span {
  font-size: 16px !important;
  font-weight: 600;
  line-height: 24px !important;
}

.package-comparison-table .row {
  width: 100%;
  height: auto;
  display: flex;
  margin-top: 0px;
}

.package-comparison-table .feature-collapse .action-collapse,
.package-comparison-table .row {
  border-left: 0.03rem solid var(--neutral-n-30, #e4e4e9);
  border-bottom: 0.03rem solid var(--neutral-n-30, #e4e4e9);
}

.package-comparison-table .row .column {
  height: auto;
  padding: 12px 24px;
}

.package-comparison-table .row-header .column {
  padding: 28px 24px !important;
  display: grid;
  gap: 20px;
  align-items: center;
  text-align: center;
}

.package-comparison-table .row-header .column p {
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
}

.package-comparison-table .row .column {
  height: auto;
  border-right: 1px solid var(--neutral-n-30, #e4e4e9);
}

.package-comparison-table .row .column:first-child {
  width: 40%;
}

.package-comparison-table .row .column:not(:first-child) {
  width: 24%;
}

.package-comparison-table .row .column p .Polaris-Icon {
  margin: unset;
}

.package-comparison-table .minus-icon-value svg {
  fill: #babec3 !important;
}

.package-comparison-table .addon-badge .Polaris-Badge {
  background: #ffebd3;
  height: 24px;
}

.package-comparison-table .addon-badge .Polaris-Icon {
  width: 12px !important;
  height: 12px !important;
}

.package-comparison-table .addon-badge .Polaris-Icon svg {
  fill: #f48d32;
}

.package-comparison-table .feature-collapse .action-collapse:hover {
  cursor: pointer;
}

.package-comparison-table .feature-collapse {
  width: 100%;
}

.package-comparison-table .feature-collapse .row .column:not(:first-child) {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.package-comparison-table .feature-collapse .row .column > .Polaris-Icon {
  width: 20px;
  height: 20px;
}

.package-comparison-table .feature-collapse .row .column .Polaris-Badge--statusWarning span {
  display: flex;
  justify-content: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}

.package-comparison-table
  .feature-collapse
  .row
  .column
  .Polaris-Badge--statusWarning
  .Polaris-Icon {
  width: 8px;
  height: 8px;
  display: inline-flex;
  vertical-align: top;
}

.package-comparison-table .feature-collapse .row .column .Polaris-Badge--statusNew {
  background: var(--neutral-n-40, #a1a3ad);
  color: var(--neutral-white, #fff);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.package-comparison-table .feature-collapse .row .column ul {
  padding-left: 20px;
  margin-top: 4px;
  margin-bottom: 0px;
}

.package-comparison-table .feature-collapse .action-collapse {
  width: 100%;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  background: var(--neutral-bg-grey, #f7f7f7);
  align-items: center;
  border-right: 0.03rem solid var(--neutral-n-30, #e4e4e9);
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
}

.package-comparison-table .feature-collapse .action-collapse .collapse-down {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

/* ---------------------- */

/* Theme setup */
.BC-Page__Theme-Setup .BC-Container__Notifications > *:first-child {
  margin-top: 2.5rem;
}

.BC-Page__Theme-Setup .theme-status-text,
.BC-Page__Theme-Setup .theme-item-left .Polaris-TextStyle--variationStrong {
  font-size: 1rem;
  line-height: 1.25rem;
}

.BC-Page__Theme-Setup .Polaris-ResourceList-Item {
  cursor: inherit;
}

.BC-Page__Theme-Setup .Polaris-ResourceList__ResourceListWrapper {
  margin: -1rem;
}

.BC-Page__Theme-Setup .theme-item {
  display: flex;
  justify-content: space-between;
}

.BC-Page__Theme-Setup .theme-item-left .Polaris-Badge {
  line-height: 1rem;
}

.BC-Page__Theme-Setup .theme-item-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.BC-Page__Theme-Setup .theme-item-right .Theme__ActionMenu .Polaris-Button {
  padding-left: 8px;
  padding-right: 8px;
}

.BC-Page__Theme-Setup .theme-item-right .Polaris-ButtonGroup__Item {
  margin-left: 10px;
}

@media screen and (max-width: 767px) {
  .BC-Page__Theme-Setup .theme-item-right .Polaris-ButtonGroup {
    justify-content: right;
  }
}

.BC-Page__Theme-Setup .clone-setting-loading .Polaris-Button {
  width: 122px;
}

.BC-Page__Theme-Setup .BC-Page__Text {
  margin-bottom: 1.25rem;
}

.BC-Page__Theme-Setup .BC-Page__Text:last-child {
  margin-bottom: 0;
}

.BC-Page__Theme-Setup .BC-Page__Bottom-Text {
  margin-top: 1.5rem;
}

.BC-Page__Theme-Setup .BC-Page__Text .Polaris-Button__Text,
.BC-Page__Theme-Setup .BC-Page__Bottom-Text .Polaris-Button__Text,
.BC-Page__Layout-Switch .BC-Page__Text .Polaris-Button__Text {
  font-weight: 600;
}

.BC-Page__Theme-Setup .BC-Theme-Setup_Form {
  padding-top: 0.25rem;
}

.BC-Page__Theme-Setup .BC-Theme-Setup_Form .Polaris-ChoiceList__ChoiceChildren {
  display: inline-block;
  vertical-align: top;
  padding-left: 0.625rem;
}

.BC-Page__Theme-Setup .BC-Theme-Setup_Form .BC-Theme-Setup_Form-Item > div.title,
.BC-Page__Theme-Upgrade .BC-Theme-Upgrade_Form .BC-Theme-Upgrade_Form-Item > div.title,
.BC-Page__Theme-Revert .BC-Theme-Revert_Form .BC-Theme-Revert_Form-Item > div.title,
.BC-Page__Layout-Switch .BC-Layout-Switch_Form .BC-Layout-Switch_Form-Item > div.title {
  padding-bottom: 0.5625rem;
}

.BC-Page__Theme-Setup .Polaris-Page-Header__Title {
  align-items: center;
}

.BC-Page__Theme-Setup .Polaris-Header-Title__TitleMetadata .toggle-button-show {
  margin-left: 0.625rem;
  color: var(--p-action-primary);
}

.BC-Page__Theme-Setup .show-hide-content-wraper {
  overflow: hidden;
  padding: 1px;
}

/* START: new theme setup 02.2023 */

.img-new-tab {
  margin: 0 2px;
  cursor: pointer;
}

.img-new-tab.no-underline a,
.img-new-tab.no-underline button {
  text-decoration: none;
}

.img-new-tab span.Polaris-Icon {
  vertical-align: middle;
  display: inline-block;
  padding-bottom: 2px;
  width: 16px;
  height: 16px;
  margin-top: 2px !important;
}

.icon-inline {
  margin: 0 2px;
  cursor: pointer;
}

.icon-inline span.Polaris-Icon {
  vertical-align: middle;
  display: inline-block;
  padding-bottom: 2px;
}

.BC-Page__Theme-Setup .ThemeSetupScreenSetup.isSettingUp .Polaris-Breadcrumbs__Breadcrumb {
  opacity: 0.5;
  cursor: not-allowed;
}

.BC-Page__Theme-Setup .BC-Theme-Setup_Form .Polaris-SkeletonDisplayText__DisplayText {
  max-width: 480px;
  height: 37px;
}

.BC-Page__Theme-Setup
  .BC-Theme-Setup_Form.BC-Theme-Setup_Form-V2
  .Polaris-SkeletonDisplayText__DisplayText {
  max-width: 100%;
}

.BC-Page__Theme-Setup
  .BC-Theme-Setup_Form.BC-Theme-Setup_Form-V2
  .Polaris-ChoiceList__ChoiceChildren
  a {
  display: inline-flex;
  gap: 10px;
}

.BC-Page__Theme-Setup .BC-Theme-Setup_Form .select-theme-refresh {
  height: 20px;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
}

.BC-Page__Theme-Setup .BC-Theme-Setup_Form .select-theme-refresh.refreshing {
  animation: rotation 2s infinite linear;
}

.BC-Page__Theme-Setup .theme-setup-heading .Polaris-Stack {
  align-items: center;
}

.BC-Page__Theme-Setup .theme-setup-heading .Polaris-Stack button {
  width: 36px;
}

.BC-Page__Theme-Setup .Polaris-Stack {
  align-items: center;
}

.BC-Page__Theme-Setup .theme-setup-menu {
  display: flex;
  flex-direction: row-reverse;
}

.BC-Page__Theme-Setup .theme-setup-menu .theme-setup-menu-action button:last-child {
  margin-left: 16px;
}

.BC-Page__Theme-Setup .select-theme {
  width: 520px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.BC-Page__Theme-Setup .select-theme-warning {
  margin-top: 12px;
  color: #916a00;
}

.theme-turbo-warning {
  display: flex;
  padding: 10px 0;
}

.theme-turbo-warning .icon {
  padding: 2px 4px 4px 0px;
}

.theme-turbo-warning {
  font-size: 14px;
  color: #916a00;
}

.theme-turbo-warning.theme-turbo-warning--default {
  color: rgb(32, 34, 35);
}

.theme-turbo-warning .content {
  padding-left: 4px;
}

.theme-turbo-warning .title {
  font-weight: 600;
}

.theme-turbo-warning ul {
  margin: 6px 0;
  margin-block-start: 0;
  padding-inline-start: 26px;
}

.theme-turbo-warning .Polaris-Button.Polaris-Button--primary {
  background: #b98900;
  margin-top: 0;
}

.theme-turbo-warning .Polaris-Button.Polaris-Button--primary:hover {
  background: #8f6901;
}

.theme-turbo-warning .Polaris-Banner--statusWarning {
  background: #fff5ea;
  border-color: #e1b878;
  padding: 8px;
  margin-bottom: 10px;
}

.theme-turbo-warning .Polaris-Banner--statusWarning .Polaris-Banner__Ribbon {
  display: none;
}

.theme-turbo-warning .warning-inTurbo-live-themes {
  margin-bottom: 8px;
}

.theme-turbo-warning .warning-inTurbo-live-themes .Polaris-Link {
  display: inline-flex;
  align-items: center;
  color: #2c6ecb !important;
  gap: 2px;
  text-decoration: none;
}

.theme-turbo-warning .warning-inTurbo-live-themes .Polaris-Link .Polaris-Icon {
  margin: 0;
  width: 16px;
  height: 16px;
  fill: #2c6ecb;
}

.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide {
  margin-top: 25px;
  border-bottom: 1px solid #e1e3e5;
  padding-bottom: 25px;
}

.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide,
.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .p1,
.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .p2 {
  display: flex;
  gap: 10px;
}

.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .p2 .line {
  border-left: 1px solid var(--p-interactive);
}

.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide {
  justify-content: space-between;
  padding-right: 30px;
}

.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .Polaris-Link {
  display: inline-flex;
  text-decoration: none;
  align-items: center;
  gap: 4px;
}

.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .Polaris-Link:hover {
  text-decoration: underline;
}

.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .Polaris-Link img {
}

.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .Polaris-Link .Polaris-Icon {
  width: 1rem;
  height: 1rem;
}

.BC-Page__Theme-Setup .select-theme > div {
  width: 480px;
}

@media screen and (max-width: 1024px) {
  .BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide {
    flex-direction: column;
  }
}

@media screen and (max-width: 768px) {
  .BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide,
  .BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .p2 {
    flex-direction: column;
    gap: 4px;
  }

  .BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .p2 .Polaris-Icon {
    margin: unset;
  }
}

.BC-Page__Theme-Setup .select-theme .BC-Select__control--is-disabled .BC-Select__single-value {
  color: var(--p-text-subdued) !important;
}

.BC-Page__Theme-Setup .feature-installed-info {
  color: #008060;
  margin-bottom: 10px;
}

.BC-Page__Theme-Setup .list-features-select > div {
  margin-bottom: 12px;
}

.BC-Page__Theme-Setup .select-recommedation-wrapper {
  /* border: 1px solid red;; */
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 15px;
  margin-top: -15px;
}

.BC-Page__Theme-Setup .select-recommedation-wrapper div:nth-child(2) {
  width: 356px;
}

.BC-Page__Theme-Setup .ListRecommendationWidgets {
  border: 1px solid #ccc;
  border-radius: 6px;
  margin-bottom: 10px;
  min-height: 222px;
  padding: 17px;
}

.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .heading {
  font-weight: bold;
}

.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .heading,
.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .row {
  display: flex;
  padding: 12px 0;
}

.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .data {
  max-height: 400px;
  overflow-y: auto;
}

.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .heading div:nth-child(1),
.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .row div:nth-child(1) {
  width: 30px;
  display: flex;
  align-items: flex-start;
}

.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .heading div:nth-child(2),
.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .row div:nth-child(2) {
  width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .heading div:nth-child(3),
.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .row div:nth-child(3) {
  flex: 1;
  max-width: 379px;
}

.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .heading div:nth-child(4),
.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .row div:nth-child(4) {
  width: 230px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .row div:nth-child(4) img {
  cursor: pointer;
}

.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .data {
  height: 100%;
}

.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .empty {
  height: 190px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

@media screen and (max-width: 768px) {
  .BC-Page__Theme-Setup .ListRecommendationWidgets {
    overflow-y: auto;
  }

  .BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper {
    min-width: 800px;
  }

  .BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .heading div:nth-child(3),
  .BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .row div:nth-child(3) {
    flex: 1;
    min-width: 300px;
  }
}

.BC-Page__Theme-Setup .select-recommedation-widget .add-widget-action {
  text-align: right;
}

.BC-Page__Theme-Setup .select-recommedation-widget .add-widget-action p {
  color: #2c6ecb;
  font-weight: 600;
  cursor: pointer;
}

.BC-Page__Theme-Setup .theme-setup-v3-complete div.content {
  margin-bottom: 12px;
}

.BC-Page__Theme-Setup .theme-setup-v3-complete .theme-setup-v3-complete-action button {
  margin-right: 10px;
}

.BC-Page__Theme-Setup .theme-setup-v3-complete .theme-setup-v3-complete-action u {
  cursor: pointer;
}

.BC-Page__Theme-Setup .theme-settup-upgrade-running {
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 10px;
  background: #f1f8f5;
  border: 1px solid #95c9b4;
  border-radius: 8px;
}

.BC-Page__Theme-Setup .theme-settup-upgrade-running .title {
  display: flex;
  align-items: center;
  padding: 0px;
  gap: 10px;
}

.BC-Page__Theme-Setup .running {
  animation: rotation 2s infinite linear;
}

.BC-Page__Theme-Setup .theme-settup-upgrade-running .title span {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #008060;
}

.BC-Page__Theme-Setup .theme-info {
  display: flex;
}

.BC-Page__Theme-Setup .theme-info .Polaris-Icon {
  margin: 0;
  margin-right: 2px;
}

.BC-Page__Theme-Setup .theme-info .Polaris-TextStyle--variationWarning {
  margin-right: 4px;
}

/* END: new theme setup 02.2023 */

.BC-Page__Theme-Setup .show-hide-content {
  -webkit-transition-property:
    opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    margin-top 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  /* Safari */
  transition:
    opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    margin-top 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

#BC-Button__Theme-Setup-Refresh {
  display: flex;
  align-items: center;
}

#BC-Button__Theme-Setup-Refresh > *:not(:first-child) {
  margin-left: 0.1875rem;
}

#BC-Button__Theme-Setup-Refresh .Polaris-Icon {
  width: 0.75rem;
  height: 0.75rem;
}

/* Theme revert */
/* Layout switch */
.BC-Page__Theme-Revert .Polaris-Banner__Content,
.BC-Page__Layout-Switch .Polaris-Banner__Content,
.BC-Page__StopWords .Polaris-Banner__Content {
  padding: 0.5rem 0;
}

.BC-Page__Theme-Revert .Polaris-Banner__Content a,
.BC-Page__Layout-Switch .Polaris-Banner__Content a {
  font-weight: 600;
}

.BC-Theme-Revert_Form-Item.second,
.BC-Layout-Switch_Form-Item.second {
  padding-top: 0.5625rem;
}

.BC-Page__Layout-Switch .BC-Layout-Switch_Form .Polaris-ChoiceList__ChoiceChildren {
  display: inline-block;
  vertical-align: top;
  padding-left: 0.625rem;
}

/* Page successs */
.BC-Page_Success .Polaris-Banner__Content {
  padding-top: 0.6875rem;
}

/* Translation */
.BC-Page__Translation .search {
  padding: 1rem 1rem 0.75rem;
}

.BC-Page__Translation .recommendation .translate-by-widget-type {
  color: #202223;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 24px;
  margin-top: 10px;
}

.BC-Page__Translation .tabContent .Polaris-Stack__Item {
  width: 48%;
  display: inline-block;
  /* margin-bottom: auto; */
}

.BC-Page__Translation .tabContent .Polaris-Stack__Item:last-child {
  width: 47%;
  float: right;
}

.BC-Page__Translation .tabContent .first .Polaris-Stack__Item {
  margin-top: 0;
}

.BC-Page__Translation .tabContent .Polaris-Labelled__LabelWrapper {
  margin-top: 1.25rem;
}

.BC-Page__Translation .tabContent .tab-section {
  margin-bottom: 35px;
}

.BC-Page__Translation .tabContent .tab-section:last-child {
  margin-bottom: 0;
}

.BC-Page__Translation .tabContent .tab-section__title {
  margin-top: 5px;
  margin-bottom: 15px;
  font-weight: 600;
  font-size: 16px;
}

.BC-Page__Translation .tabContent .tab-section__title--collapse {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.BC-Page__Translation
  .Polaris-Page
  > div:not(.Polaris-Page-Header)
  > .Polaris-Layout
  > .Polaris-Layout__Section:not(:first-child)
  > .languages {
  margin-top: 0.5rem;
}

.BC-Page__Translation .languages .Polaris-Button {
  min-width: 148px;
}

.BC-Page__Translation .languages .Polaris-Button__Text {
  display: inline-flex;
}

.BC-Page__Translation .languages .Polaris-Button svg {
  fill: #31373d;
  margin-right: 6px;
}

.BC-Page__Translation .BC-Page__Button .Polaris-Button,
.BC-Page__Translation .Polaris-PageActions .Polaris-Button {
  width: 136px;
}

.languageItem {
  width: 122px;
}

.BC-Page__Translation .tabContent #basic-collapsible {
  padding: 0 4px;
}

.BC-Page__Translation .Polaris-Tabs__Wrapper .Polaris-Tabs__Title {
  padding: 0.75rem !important;
}

.BC-Page__Translation .feature-table {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
}

.BC-Page__Translation .feature-table__header {
  display: grid;
  grid-template-columns: 1fr 284px;
}
.BC-Page__Translation .feature-table .Polaris-Card {
  box-shadow: 0px -1px 0px 0px #e1e3e5 inset;
  border: 1px solid #e1e3e5;
}

.BC-Page__Translation .feature-table .Polaris-Card .Polaris-Card__Section {
  padding: 16px;
  box-shadow: 0px -1px 0px 0px #e1e3e5 inset;
}

.BC-Page__Translation .feature-table .feature-table__section {
  background: #fafbfb;
  color: #6d7175;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  vertical-align: middle;
  text-transform: uppercase;
  padding: 16px;
  box-shadow: 0px -1px 0px 0px #e1e3e5 inset;
}

.BC-Page__Translation .feature-table .feature-table__row {
  display: grid;
  grid-template-columns: 1fr 252px;
  padding: 16px 32px;
  box-shadow: 0px -1px 0px 0px #e1e3e5 inset;
}

.BC-Page__Translation .feature-table .feature-table__row .feature-table__row-name {
  font-weight: 500;
}

.BC-Page__Translation .feature-table .feature-table__row .Polaris-Button--plain {
  max-width: max-content;
  margin: 0 auto;
  padding: 0;
  min-height: 0;
}

.BC-Page__Translation-Feature .BC-Page__Translation-Feature__Header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.BC-Page__Translation-Feature .languages .Polaris-Button__Text {
  display: inline-flex;
  gap: 8px;
  align-items: center;
}

.BC-Page__Translation-Feature .BC-TranslationFeatureTab {
  padding: 16px;
}

.BC-Page__Translation-Feature .BC-TranslationFeatureTab .tabContent .tab-section__body {
  display: flex;
  gap: 16px;
  flex-direction: column;
}

.BC-Page__Translation-Feature .BC-TranslationFeatureTab .tabContent .spinner-loading {
  min-height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.BC-Page__Translation-Feature .BC-TranslationFeatureTab .Polaris-Stack .Polaris-Stack__Item {
  flex: 1;
}

.BC-Page__Translation-Feature .BC-TranslationFeatureTab .tab-section__title {
  margin-top: 5px;
  margin-bottom: 15px;
  font-weight: 600;
  font-size: 16px;
}
.BC-Page__Translation-Feature
  .BC-TranslationFeatureTab
  .tab-section__title.tab-section__title--collapse {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.BC-Page__Translation-Feature .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {
  justify-content: flex-end;
}

.BC-Page__Translation-Feature
  .Polaris-PageActions
  .Polaris-Stack--distributionEqualSpacing
  .Polaris-Stack__Item {
  margin-left: 1rem;
}

/* Default layout settings */
.BC-Page__Layout-Settings .tabs .Polaris-Card__Section {
  padding: 0rem;
}

.BC-Page__Layout-Settings .tabs .Polaris-Layout {
  margin-top: 0rem;
  margin-left: -0.625rem;
  margin-right: -0.625rem;
}

.BC-Page__Layout-Settings .tabs.tabs-with-preview .Polaris-Layout {
  margin-left: 0rem;
  margin-right: 0rem;
}

.BC-Page__Layout-Settings .tabs .Polaris-Layout .Polaris-Layout__Section {
  margin-top: 0rem;
  margin-left: 0rem;
}

.BC-Page__Layout-Settings .tabs.tabs-with-preview .Polaris-Layout .Polaris-Layout__Section {
  flex: 2 2 35rem;
}

.BC-Page__Layout-Settings
  .tabs.tabs-with-preview
  .Polaris-Layout__Section.Polaris-Layout__Section--secondary {
  margin-left: 0;
  flex: 2 2 23.375rem;
}

.BC-Page__Layout-Settings .tabs .tab-content .Polaris-Card__Section {
  padding: 1rem 1rem 1.5rem 1rem;
}

.BC-Page__Layout-Settings .tabs.tabs-with-preview .tab-content .Polaris-Card__Section {
  min-height: 480px;
}

.BC-Page__Layout-Settings .previewPanel .Polaris-Card .Polaris-Heading {
  line-height: 1.375rem;
}

.BC-Page__Layout-Settings .Polaris-FormLayout__Item {
  margin-top: 1.5625rem;
}

.BC-Page__Layout-Settings .groupFields {
  margin-top: 0.75rem;
}

.BC-Page__Layout-Settings .groupFields > div {
  margin-top: 0.25rem;
}

.BC-Page__Layout-Settings .groupFields > div.Polaris-Stack:first-child .Polaris-Stack__Item {
  margin-top: 0rem;
}

.BC-Page__Layout-Settings .quick-view-group .groupFields {
  padding-bottom: 1.5rem;
  border-bottom: 0.0625rem solid var(--p-divider);
}

.BC-Page__Layout-Settings .add-to-card-group {
  padding-bottom: 0.25rem;
}

.BC-Page__Layout-Settings .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing,
.BC-Page__Translation .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {
  justify-content: flex-end;
}

.BC-Page__Layout-Settings
  .Polaris-PageActions
  .Polaris-Stack--distributionEqualSpacing
  > .Polaris-Stack__Item,
.BC-Page-Variants-Display
  .Polaris-PageActions
  .Polaris-Stack--distributionEqualSpacing
  > .Polaris-Stack__Item {
  margin-left: 1rem;
}

.BC-Page-Variants-Display .noSupportISW {
  padding-top: 25px;
  display: flex;
}

.BC-Page-Variants-Display .noSupportISW .icon {
  margin: 2px 10px 0 0;
  width: 1rem;
  height: 1rem;
}

.BC-Page-Variants-Display .noSupportISW .text {
  color: #d72c0d;
  margin: 0 5px 0 0;
}

.variantDisplayInfos .image {
  max-height: 112px;
}

.variantDisplayInfos .title {
  font-size: 20px;
}

.action-group-detail-merchandising .Polaris-Stack > .Polaris-Stack__Item {
  margin-left: 8px;
}

.BC-Page__Layout-Settings .tabs .previewPanel .Polaris-Card {
  box-shadow: none;
  background: inherit;
}

.BC-Page__Layout-Settings .tabs .previewPanel .item-center {
  display: flex;
  justify-content: center;
  margin-top: 1.5625rem;
}

.BC-Page__Layout-Settings .Polaris-PageActions {
  padding-top: 1.5rem;
}

/* Quick view & cart settings */

.BC-Page__QuickView-Cart-Settings .content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  margin: 0;
}

.BC-Page__QuickView-Cart-Settings .content-settings {
  flex: 1 1 35rem;
  min-width: 0;
  border-right: 0.0625rem solid var(--p-divider);
  min-height: 550px;
}

.BC-Page__QuickView-Cart-Settings .preview {
  flex: 1 1 23.125rem;
}

.BC-Page__QuickView-Cart-Settings .content-settings {
  padding: 1rem 1.25rem 2.5rem;
}

.BC-Page__QuickView-Cart-Settings .content .Polaris-Card__Section {
  padding: 0rem;
}

.BC-Page__QuickView-Cart-Settings .content .Polaris-Layout {
  margin-top: 0rem;
  margin-left: 0rem;
  margin-right: 0rem;
}

.BC-Page__QuickView-Cart-Settings .content .content-settings .Polaris-Card__Section {
  padding: 1rem 1rem 1.5rem 1rem;
}

.BC-Page__QuickView-Cart-Settings .previewPanel .Polaris-Card .Polaris-Heading {
  line-height: 1.375rem;
}

.BC-Page__QuickView-Cart-Settings .Polaris-FormLayout .Polaris-FormLayout__Item {
  margin-top: 1.5625rem;
}

.BC-Page__QuickView-Cart-Settings .Polaris-FormLayout .Polaris-FormLayout__Item:first-child {
  margin-top: 1.25rem;
}

.BC-Page__QuickView-Cart-Settings .groupFields {
  margin-top: 0.75rem;
  padding-left: 3.125rem;
}

.BC-Page__QuickView-Cart-Settings .groupFields > .groupFields-label:first-child {
  margin-top: 0.75rem;
}

.BC-Page__QuickView-Cart-Settings .groupFields .groupFields-label {
  margin-top: 1.5rem;
}

.BC-Page__QuickView-Cart-Settings
  .groupFields
  .groupFields-label
  .Polaris-Button
  .Polaris-Button__Content
  .Polaris-Button__Icon {
  order: -1;
  margin-left: -5px;
  margin-right: 5px;
}

.BC-Page__QuickView-Cart-Settings .groupFields .groupFields-content > div {
  margin-top: 0.25rem;
}

.BC-Page__QuickView-Cart-Settings .groupFields .groupFields-content > div:first-child {
  margin-top: -0.5rem;
}

.BC-Page__QuickView-Cart-Settings .groupFields .groupFields-content .Polaris-Stack--vertical {
  flex-wrap: nowrap;
}

.BC-Page__QuickView-Cart-Settings .selectedColor {
  background-color: #fff;
  z-index: 417;
  width: 25px;
  height: 25px;
  margin-right: 0;
  border: 1px solid #c4cdd5;
  border-radius: 3px;
  margin-left: 0.75rem;
}

.BC-Page__QuickView-Cart-Settings .quick-view-group .groupFields {
  padding-bottom: 1.5rem;
  border-bottom: 0.0625rem solid var(--p-divider);
}

.BC-Page__QuickView-Cart-Settings .add-to-card-group {
  padding-bottom: 0.25rem;
}

.BC-Page__QuickView-Cart-Settings .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {
  justify-content: flex-end;
}

.BC-Page__QuickView-Cart-Settings
  .Polaris-PageActions
  .Polaris-Stack--distributionEqualSpacing
  > .Polaris-Stack__Item {
  margin-left: 1rem;
}

.BC-Page__QuickView-Cart-Settings .content .previewPanel .Polaris-Card {
  box-shadow: none;
  background: inherit;
}

.BC-Page__QuickView-Cart-Settings .content .previewPanel .Polaris-Card .Polaris-Heading {
  text-align: center;
}

.BC-Page__QuickView-Cart-Settings .content .previewPanel .item-center {
  display: flex;
  justify-content: center;
  margin-top: 1.5625rem;
}

.BC-Page__QuickView-Cart-Settings .Polaris-PageActions {
  padding-top: 1.5rem;
}

.BC-Page__QuickView-Cart-Settings .render-choice-flex-3 ul {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  margin-left: -1rem;
}

.BC-Page__QuickView-Cart-Settings .render-choice-flex-3 ul li {
  max-width: 100%;
  flex: 1 0 100%;
  padding-left: 1rem;
}

@media screen and (min-width: 1200px) {
  .BC-Page__QuickView-Cart-Settings .render-choice-flex-3 ul li {
    flex: 0 1 33.33%;
  }
}

.BC-Page__QuickView-Cart-Settings .render-choice-with-tooltip .extraTooltipClass {
  width: 276px;
  padding: 8px;
}

.BC-Page__QuickView-Cart-Settings .render-choice-with-tooltip .extraTooltipClass img {
  width: 100%;
}

/* Merge value */
.BC-Page__Merge-Value .Polaris-DisplayText .Polaris-Button__Content {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
}

.BC-Page__Merge-Value .BC-Custom__ButtonMore .Polaris-Button {
  vertical-align: middle;
}

.BC-Page__Merge-Value .BC-Custom__ButtonMore .Polaris-Button__Text {
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
}

.BC-Page__Merge-Value .BC-Custom__ButtonMore .Polaris-Button__Icon .Polaris-Icon {
  width: 0.8rem;
  height: 0.8rem;
}

.BC-Page__Merge-Value .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {
  justify-content: flex-end;
}

.BC-Page__Merge-Value
  .Polaris-PageActions
  .Polaris-Stack--distributionEqualSpacing
  .Polaris-Stack__Item {
  margin-left: 1rem;
}

.BC-DataTable__MergeValuesOptions,
.BC-DataTable__MergeValues {
  margin: -1rem;
}

.BC-DataTable__MergeValuesOptions .Polaris-DataTable__Cell:first-child {
  min-width: 100px;
  width: 50%;
}

.BC-DataTable__MergeValuesOptions .Polaris-DataTable__Cell:nth-child(2) {
  min-width: 430px;
  width: 40%;
}

.BC-DataTable__MergeValuesOptions .Polaris-DataTable__Cell:last-child {
  min-width: 90px;
  width: 10%;
  padding-right: 1.25rem;
  padding-left: 0.625rem;
}

/* .BC-DataTable__MergeValues button {
  color: var(--p-action-primary);
  border-color: var(--p-action-primary);
}

.BC-DataTable__MergeValues button:hover {
  border-color: var(--p-action-primary);
}

.BC-DataTable__MergeValues button svg {
  fill: var(--p-action-primary);
} */

.BC-DataTable__MergeValues tbody {
  vertical-align: top;
}

.BC-DataTable__MergeValues .Polaris-DataTable__Cell:first-child {
  width: 10%;
}

.BC-DataTable__MergeValues .Polaris-DataTable__Cell:nth-child(2) {
  min-width: 169px;
  width: 20%;
}

.BC-DataTable__MergeValues .Polaris-DataTable__Cell:nth-child(4) {
  min-width: 90px;
  width: 10%;
  padding-right: 1.25rem;
  padding-left: 0.625rem;
}

.BC-DataTable__MergeValues .Polaris-DataTable__Cell button {
  padding-top: 0.46875rem;
  padding-bottom: 0.46875rem;
}

.BC-DataTable__MergeValues .button-add {
  padding-top: 8px;
  display: flex;
  justify-content: flex-end;
}

.BC-DataTable__MergeValues .button-add .Polaris-Icon {
  width: 0.8125rem;
  height: 0.8125rem;
}

/* Integration tool */
.BC-Page__Integration .Polaris-Layout__Section:last-child {
  margin-top: 0.5rem;
}

.BC-Page__Integration .Polaris-Tabs li:first-child > button {
  padding-left: 0;
}

.BC-Page__Integration .tabContent .item {
  margin-top: 1.5rem;
  background: #fff;
  width: 300px;
  text-align: center;
  border-radius: 3px;
  box-shadow:
    0 0 0 1px rgba(63, 63, 68, 0.05),
    0 1px 3px 0 rgba(63, 63, 68, 0.15);
  float: left;
  min-height: 390px;
  position: relative;
}

.BC-Page__Integration .tabContent .item .Polaris-Badge {
  position: absolute;
  top: 10px;
  right: 16px;
  color: #616161;
  font-size: 12px;
  font-weight: 500;
}

.BC-Page__Integration .tabContent .middle {
  margin-right: 1.5rem;
  margin-left: 1.5rem;
}

.BC-Page__Integration .tabContent .icon {
  width: 70px;
  margin: 24px 0 22px;
  border-radius: 8px;
}

.BC-Page__Integration .tabContent .icon--attentive {
  width: 80px;
  border-radius: 50%;
  margin: 19px 0 17px;
  /* box-shadow: 0px 4px 24px 0px #00000012; */
}

.BC-Page__Integration .tabContent .integration {
  margin-top: -8px;
  margin-bottom: 22px;
}

.BC-Page__Integration .tabContent .name {
  font-size: 1rem;
  font-weight: 700;
  margin-top: -10px;
  padding-bottom: 8px;
}

.BC-Page__Integration .tabContent .description {
  min-height: 60px;
  font-size: 14px;
  color: #637381;
  padding: 0.5rem 1.25rem 0.75rem 1.25rem;
}

.BC-Page__Integration .tabContent .instruction {
  font-size: 0.75rem;
  color: #637381;
  line-height: 1rem;
  padding: 0.75rem 1.25rem 1.5rem 1.25rem;
}

.BC-Page__Integration .BC-Checkbox-Status {
  margin: 0.75rem 0 1.5rem 0;
}

.BC-Page__Integration .tabContent form {
  padding: 0 1.25rem 0.5rem 1.25rem;
}

.BC-Page__Integration .Polaris-Tabs__Panel .Polaris-Button {
  margin-bottom: 1.5rem;
  width: 120px;
}

.BC-Page__Integration .Polaris-Tabs__Panel .btn-configure {
  margin: 24px 0;
}

.BC-Page__Integration .Polaris-Tabs__Panel .btn-configure .Polaris-Button {
  width: auto;
  margin-bottom: 0;
}

.BC-Page__Integration .Polaris-Tabs__Panel .integrateGemPages .Polaris-Button {
  width: 255px;
}

/* Search settings*/
.BC-Page__SearchSettings .Polaris-FormLayout .Polaris-FormLayout__Item {
  margin-top: 1.25rem;
}

.BC-Page__SearchSettings .Polaris-DataTable.BC-DataTable__SearchSettings {
  margin: 0 -1.25rem;
}

.BC-Page__SearchSettings
  .Polaris-Page
  .Polaris-Tabs__Wrapper
  .Polaris-Tabs__TabContainer
  .Polaris-Badge--statusWarning {
  margin-left: 4px;
}

.BC-DataTable__SearchSettings .Polaris-DataTable__Cell.Polaris-DataTable__Cell--firstColumn {
  width: 60px;
  padding: 0rem 1.25rem;
}

.BC-Page__SearchSettings .range-slider-input {
  display: flex;
  margin-top: 1rem;
}

.BC-Page__SearchSettings .range-slider-input > div:first-child {
  width: 18.375rem;
}

.BC-Page__SearchSettings .range-slider-input > div:last-child {
  margin-left: 1rem;
  width: 5rem;
}

.BC-Page__SearchSettings .range-slider-input .Polaris-RangeSlider-SingleThumb__InputWrapper {
  height: 2.1875rem;
}

.BC-Page__SearchSettings
  .range-slider-input
  .Polaris-RangeSlider-SingleThumb__Input::-webkit-slider-thumb {
  width: 1.0625rem;
  height: 1.0625rem;
  margin-top: -0.4375rem;
}

.BC-Page__SearchSettings .range-slider-input .Polaris-TextField__Segment:first-child {
  margin-top: 1px;
}

.BC-Page__SearchSettings .advanced .heading {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;
}

.BC-Page__SearchSettings .advanced .heading.searchTerm {
  padding-bottom: 0.3125rem;
}

.BC-Page__SearchSettings .advanced .heading.fuzzy {
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  padding-bottom: 0.3125rem;
  border-top: 1px solid #dfe3e8;
}

/* margin-top: 1.25rem;
padding-top: 1.25rem;
padding-bottom: 0.3125rem;
border-top: 1px solid #DFE3E8; */

.BC-Page__SearchSettings .fuzzySearchSetting {
  margin-top: -0.625rem;
}

.BC-Page__SearchSettings .fuzzySearchSetting .Polaris-ChoiceList__Choices li {
  padding: 0.4375rem 0 0.25rem 0;
}

/* Instant search display */

.BC-Page__InstantSearchDisplay .Polaris-DisplayText .Polaris-Button__Content {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
}

.BC-Page__InstantSearchDisplay .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing,
.BC-Page__SearchSettings .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing,
.BC-Page__SearchPageDisplay .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {
  justify-content: flex-end;
}

.BC-Page__SearchPageDisplay textarea {
  line-height: 1.4375rem;
}

.BC-Page__InstantSearchDisplay
  .Polaris-PageActions
  .Polaris-Stack--distributionEqualSpacing
  .Polaris-Stack__Item,
.BC-Page__SearchSettings
  .Polaris-PageActions
  .Polaris-Stack--distributionEqualSpacing
  .Polaris-Stack__Item,
.BC-Page__SearchPageDisplay
  .Polaris-PageActions
  .Polaris-Stack--distributionEqualSpacing
  .Polaris-Stack__Item {
  margin-left: 1rem;
}

.BC-Page__InstantSearchDisplay .Polaris-Layout {
  margin-top: 1rem;
}

.BC-Page__InstantSearchDisplay .layoutSettings {
  padding-bottom: 2.5rem;
  border-bottom: 1px solid var(--p-divider);
}

.BC-Page__InstantSearchDisplay .headingStyle {
  display: flex;
  font-size: 1.75rem;
  line-height: 2rem;
  font-weight: 600;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .Polaris-Layout {
  align-items: stretch;
}

.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .Polaris-Layout .Polaris-Card {
  min-height: 100%;
  height: 100%;
}

.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .layout-image img {
  width: 100%;
  min-height: 170px;
}

.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .layout-style,
.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .layout-type,
.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .layout-position,
.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .layout-products-per-row {
  margin-bottom: 1.125rem;
  text-align: center;
}

.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .layout-style {
  margin: 0.875rem;
}

.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .layout-products-per-row {
  margin-bottom: 0rem;
}

.BC-Page__InstantSearchDisplay .headingStyle .headingText {
  margin-right: 0.5rem;
}

.BC-Page__InstantSearchDisplay .BC-Page__Fields > div,
.BC-Page__SearchSettings .BC-Page__Fields > div {
  margin-top: 1.5rem;
}

.BC-Page__SearchPageDisplay .BC-Page__Fields > div {
  margin-top: 8px;
}

/* .BC-Page__SearchPageDisplay .BC-Page__Fields .textArea-align-center textarea {
  text-align: center !important;
} */

.BC-Page__InstantSearchDisplay .BC-Page__Fields > div.tabs {
  margin: 1.25rem -1rem -1rem;
  border-top: 0.0625rem solid var(--p-divider);
}

.BC-Page__InstantSearchDisplay .titleStyle .Polaris-Label__Text,
.BC-Page__SearchSettings .titleStyle .Polaris-Label__Text {
  font-size: 1.0625rem;
  font-weight: 600;
  line-height: 1.5rem;
}

.BC-Page__InstantSearchDisplay .groupFields > div:first-child {
  margin-top: -0.75rem;
}

.BC-Page__InstantSearchDisplay .groupFields > div {
  margin-top: 0.5rem;
}

.BC-Page__InstantSearchDisplay .groupFields .groupFields-item {
  margin-top: 1.5rem;
}

.BC-Page__InstantSearchDisplay
  .groupFields
  .groupFields-item
  .BC-Toggle-Switch
  .Polaris-Label__Text {
  font-weight: 500;
}

.BC-Page__InstantSearchDisplay .groupFields .groupFields-item .Polaris-FormLayout {
  margin-top: 1rem;
}

.BC-Page__InstantSearchDisplay
  .groupFields
  .Polaris-Stack--distributionFillEvenly
  .Polaris-Stack__Item {
  flex: 1 0;
}

.BC-DataTable__InstantSearchDisplay {
  padding-top: 0.375rem;
}

.BC-DataTable__InstantSearchDisplay .Polaris-DataTable__Cell:first-child {
  width: 20px;
  padding: 0rem;
}

.BC-DataTable__InstantSearchDisplay .Polaris-DataTable__Cell:nth-child(2) {
  width: 100px;
}

.BC-DataTable__InstantSearchDisplay .Polaris-DataTable__Cell:nth-child(3) {
  width: 484px;
}

.BC-DataTable__InstantSearchDisplay .Polaris-DataTable__Cell:last-child {
  width: 290px;
  overflow: hidden;
  padding-right: 0rem;
  padding-left: 0.625rem;
  text-align: center;
}

.BC-Page__InstantSearchDisplay div.tabs .scopedSuggestionWrap .groupFields > div:first-child {
  margin-top: 0;
}

.BC-Page__InstantSearchDisplay div.tabs .scopedSuggestionWrap .groupFields .Polaris-Select {
  width: 180px;
}

.BC-Page__InstantSearchDisplay div.tabs .scopedSuggestionWrap {
  border-top: 1px solid #e1e3e5;
  margin-top: 20px;
}

.BC-Page__InstantSearchDisplay div.tabs .titleStyle {
  margin-top: 2.25rem;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__SearchTerm {
  margin-top: 1.4375rem;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__Product {
  margin-top: 0.625rem;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__SearchTerm .empty-term {
  margin: 1.875rem auto 0.375rem 0;
  text-align: center;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__SearchTerm .Polaris-DataTable__Cell {
  padding: 1.0625rem;
  /* border-bottom: 1px solid var(--p-divider); */
}

.BC-Page__InstantSearchDisplay .BC-DataTable__SearchTerm .Polaris-DataTable__Cell:first-child {
  width: 20px;
  padding: 0rem;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__SearchTerm .Polaris-DataTable__Cell:nth-child(2) {
  width: auto;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__SearchTerm .Polaris-DataTable__Cell:nth-child(3) {
  width: 50px;
  text-align: right;
  padding-right: 0.375rem;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__Product .empty-product {
  margin: 0.625rem auto 1.875rem;
  text-align: center;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__Product .addProducts {
  border-top: 1px solid var(--p-divider);
  padding-top: 0.875rem;
  text-align: right;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__Product .addProducts .Polaris-Button__Text {
  font-weight: 500;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__Product .addProducts button {
  text-decoration: none;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__Product .Polaris-DataTable__Cell {
  padding: 0.875rem 0.78125rem;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__Product tbody .Polaris-DataTable__Cell {
  border-top: 1px solid var(--p-divider);
  border-bottom: none;
  white-space: normal;
}

.BC-Page__InstantSearchDisplay
  .BC-DataTable__Product
  tbody
  tr:first-child
  .Polaris-DataTable__Cell {
  border-top: none;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__Product .Polaris-DataTable__Cell:first-child {
  width: 20px;
  padding: 0rem;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__Product .Polaris-DataTable__Cell:nth-child(2) {
  width: 50px;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__Product .Polaris-DataTable__Cell:nth-child(3) {
  width: auto;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__Product .Polaris-DataTable__Cell:nth-child(4) {
  width: 50px;
  text-align: right;
  padding-right: 0.375rem;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__Product .Polaris-DataTable__Cell .product-image,
.BC-DataTable__Product-Options .Polaris-DataTable__Cell .product-image {
  width: 40px;
  padding-bottom: 40px;
  position: relative;
  border: 1px solid var(--p-divider);
  box-sizing: border-box;
}

.BC-Page__InstantSearchDisplay
  .BC-DataTable__Product
  .Polaris-DataTable__Cell
  .product-image.no-image,
.BC-DataTable__Product-Options .Polaris-DataTable__Cell .product-image.no-image {
  background-color: #f9fafb;
}

.BC-Page__InstantSearchDisplay .BC-DataTable__Product .Polaris-DataTable__Cell .product-image img,
.BC-DataTable__Product-Options .Polaris-DataTable__Cell .product-image img {
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

/* standard search - isw */
.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .Polaris-Layout__Section:nth-child(2) {
  display: grid;
  gap: 24px;
  width: 100%;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .Polaris-Layout__Section
  div
  .Polaris-Card__Header
  > div
  .titleMetadata
  .Polaris-Icon {
  width: 14px;
  height: 14px;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .Polaris-Layout__Section
  div
  .Polaris-Card__Header
  > div
  > div {
  width: auto;
  display: flex;
  gap: 8px;
  align-items: center;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .Polaris-Layout__Section:nth-child(2)
  .layoutSettings {
  padding-bottom: unset;
  border-bottom: none;
}

.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .Polaris-Layout__Section .Polaris-Card {
  box-shadow: none;
  border-radius: 8px;
  border: 1px solid var(--border-divider, #e1e3e5);
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .Polaris-Layout__Section
  div
  .Polaris-Card__Header
  > div {
  display: flex;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  gap: 8px;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .layoutSettings
  > .Polaris-Card
  > .Polaris-Card__Section {
  padding-top: 16px;
}

.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .layoutSettings .styleBox {
  display: flex;
  align-items: stretch;
}

.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .layoutSettings .styleBox > div {
  flex: 1 1 0;
  width: 0;
  margin-top: unset;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .layoutSettings
  .styleBox
  .Polaris-Card
  > .Polaris-Card__Section {
  padding: 12px;
}

.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .layoutSettings .styleBox .Polaris-Card {
  border: none;
  height: 100%;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .layoutSettings
  .styleBox
  .Polaris-Card:hover {
  cursor: pointer;
  border: 1px solid var(--border-divider, #e1e3e5);
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .layoutSettings
  .styleBox
  .layout-selected
  .Polaris-Card {
  border: 1px solid #2c6ecb;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .layoutSettings
  .styleBox
  .layout-image
  img {
  width: 100%;
  height: auto;
}

.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .layoutSettings .styleBox .layout-settings {
  margin-top: 12px;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .layoutSettings
  .styleBox
  .layout-settings
  > div {
  margin-top: 16px;
  text-align: center;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .layoutSettings
  .styleBox
  .layout-settings
  .Polaris-Choice {
  width: 100%;
  justify-content: center;
}

.BC-Page__SearchControl .sub-title,
.BC-Page__StandardSearch .ref-to-test-search {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.BC-Page__SearchControl .sub-title > span > p:hover,
.BC-Page__StandardSearch .ref-to-test-search > span > span:hover,
.BC-Page__StandardSearch .ref-to-test-search > span > p:hover {
  cursor: pointer;
  color: var(--Interactive-Default, #1d65ca);
}

.BC-Page__SearchControl .sub-title > span > p,
.BC-Page__StandardSearch .ref-to-test-search > span > span,
.BC-Page__StandardSearch .ref-to-test-search > span > p {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
  color: var(--Interactive-Default, #2c6ecb) !important;
  margin-right: 20px;
}

.BC-Page__SearchControl .BC-Page.SearchControl__Content.BC-Page__Fields__Status .toggle-status {
  border: 1px solid var(--border-divider, #e1e3e5);
  border-radius: 8px;
  box-shadow: none;
  padding: 20px;
  display: flex;
  margin-top: 16px;
  margin-bottom: 20px;
}

.BC-Page__SearchControl .BC-BaseBanner {
  margin-bottom: 0;
}

.BC-Page__StandardSearch .groupFields .render-choice-2 {
  padding-bottom: unset;
}

.BC-Page__StandardSearch .groupFields .render-choice-2 .Polaris-ChoiceList__ChoiceChildren {
  margin-bottom: 3px;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .isw-with-results
  .groupFields
  .groupFields-item-scope,
.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .groupFields-item .Polaris-Stack__Item,
.BC-Page__StandardSearch .groupFields .render-choice-2 li:not(:first-child),
.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .BC-DataTable__SearchTerm,
.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .isw-with-results
  .groupFields
  .product-suggestion,
.BC-Page__StandardSearch .isw-with-results .scopedSuggestionWrap .groupFields,
.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .isw-with-results > div:last-child > div,
.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .groupFields .groupFields-item {
  margin-top: 16px !important;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .groupFields
  .radioButtonGroup
  .Polaris-Button,
.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .groupFields
  .radioButtonGroup
  .Polaris-TextField {
  max-height: 30px;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .groupFields
  .radioButtonGroup
  .Polaris-Button {
  padding: 5px 12px;
  min-height: 30px;
}

.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .empty-product,
.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .empty-term {
  margin: 40px auto 16px 0;
  color: #6d7175;
}

.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .isw-with-results > div:last-child {
  margin-top: 16px;
  border-top: 1px solid #e1e3e5;
  margin: 20px -20px 0;
  padding: 16px 20px 0;
}

.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .isw-with-results > div > p,
.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .isw-with-results
  .Polaris-FormLayout__Item
  > p {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .isw-with-results > div > label,
.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .isw-with-results
  .groupFields-item-scope
  > p:first-child,
.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .isw-with-results
  .Polaris-FormLayout__Item
  > .BC-Toggle-Switch {
  margin-top: 4px;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .isw-with-results
  .Polaris-FormLayout__Item
  .BC-Toggle-Switch
  label {
  font-weight: 600;
  font-style: normal;
}

.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .groupFields > div {
  margin-top: unset;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .isw-with-results
  .groupFields
  .groupFields-item {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .isw-with-results
  .groupFields
  .groupFields-item
  .Polaris-Select__Content {
  text-align: center;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .isw-with-results
  .groupFields
  .groupFields-item
  > div {
  flex: 48% 1;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .groupFields
  .Polaris-Stack--distributionFillEvenly
  .Polaris-Stack__Item {
  margin-top: 12px;
}

.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay div.tabs .scopedSuggestionWrap {
  border-top: unset;
  margin-top: 16px;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  div.tabs
  .scopedSuggestionWrap
  .groupFields
  .Polaris-Select {
  width: 286px;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .isw-with-results
  > div:last-child
  .Polaris-Icon {
  display: inline-flex;
}

.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .block-order {
  display: flex;
  gap: 16px;
  align-items: center;
}

.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .block-icon {
  display: flex;
  align-items: center;
}

.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .content-order .BC-Draggable__Container {
  display: grid;
  gap: 16px;
}

.search-results-tab .BC-Draggable__Container .BC-Draggable__Tag,
.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .BC-Draggable__Container
  .BC-Draggable__Tag {
  padding: 4px 0px 4px 8px;
}

.search-results-tab .BC-Draggable__Container .BC-Draggable__Tag button,
.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .BC-Draggable__Container
  .BC-Draggable__Tag
  button {
  width: 20px;
  height: 20px;
}

.search-results-tab .BC-Draggable__Container .BC-Draggable__Tag button .Polaris-Icon svg,
.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .BC-Draggable__Container
  .BC-Draggable__Tag
  button
  .Polaris-Icon
  svg {
  fill: #5c5f62;
}

/*  */

.BC-DataTable__Product-Options .Polaris-DataTable__Cell:first-child {
  width: 20px;
  padding: 0rem;
  padding-right: 0.3125rem;
}

.BC-DataTable__Product-Options .Polaris-DataTable__Cell:nth-child(2) {
  width: 50px;
}

.BC-DataTable__Product-Options .Polaris-DataTable__Cell:nth-child(3) {
  width: auto;
}

.search-product-suggestion {
  margin-bottom: 0.625rem;
}

#infiniteScroll_Wrapper_Modal {
  height: calc(100vh - 18.125rem);
  overflow-y: auto;
  margin-right: -1.25rem;
  padding-right: 1.25rem;
}

#infiniteScroll_Wrapper_ModalSelectProduct {
  height: calc(100vh - 21.625rem);
  overflow-y: auto;
  max-height: 500px;
}

/* Search fields*/
.BC-Page__SearchFields .Polaris-FormLayout .Polaris-FormLayout__Item {
  margin-top: 1.25rem;
}

.BC-Page__SearchFields .BC-Page__Fields > div {
  margin-top: 1.5rem;
}

.Polaris-FormLayout__Item
  .search-fields-footer
  .Polaris-Button__Content
  .Polaris-Button__Icon
  .Polaris-Icon
  svg,
.BC-Page__Theme-Setup
  .external-link
  .Polaris-Button__Content
  .Polaris-Button__Icon
  .Polaris-Icon
  svg,
.Polaris-Layout .external-link .Polaris-Button__Content .Polaris-Button__Icon .Polaris-Icon svg {
  fill: var(--p-interactive) !important;
  width: 20px;
  height: auto;
}

/* Search page display */
.isw-banner-custom-actions {
  margin-top: 16px;
}

.isw-banner-custom-actions .Polaris-Button__Text {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BC-Page__SearchPageDisplay .BC-Toggle-Switch label {
  font-weight: 600;
}

.BC-Page__SearchPageDisplay .groupFields > div {
  margin-top: 1.25rem;
}

.BC-Page__SearchPageDisplay .groupFields > div:first-child {
  margin-top: 1rem;
}

.BC-Page__SearchPageDisplay .groupFields .radioButtonGroup {
  padding: 1.5rem 1rem 0.3125rem;
  border: 1px solid #c4cdd5;
  border-radius: 3px;
  box-shadow: inset 0px 1px 2px rgba(102, 113, 123, 0.21);
}

.BC-Page__SearchPageDisplay .groupFields .radioButtonGroup li:not(:first-child) {
  margin-top: 1.4375rem;
}

.BC-Page__InstantSearchDisplay .groupFields .radioButtonGroup {
  padding: 1.5rem 1rem 1.5rem;
  border: 1px solid #c4cdd5;
  border-radius: 3px;
  box-shadow: inset 0px 1px 2px rgba(102, 113, 123, 0.21);
}

.BC-Page__InstantSearchDisplay .groupFields .radioButtonGroup li:not(:first-child) {
  margin-top: 1.4375rem;
}

.BC-Page__SearchPageDisplay .BC-DataTable__SearchTerm .empty-term {
  margin: 1.875rem auto 1.125rem 0;
  text-align: center;
}

.BC-Page__SearchPageDisplay .BC-DataTable__SearchTerm .Polaris-DataTable__Cell:first-child {
  width: 20px;
  padding: 0rem;
}

.BC-Page__SearchPageDisplay .BC-DataTable__SearchTerm .Polaris-DataTable__Cell:nth-child(2) {
  width: auto;
}

.BC-Page__SearchPageDisplay .BC-DataTable__SearchTerm .Polaris-DataTable__Cell:nth-child(3) {
  width: 50px;
  text-align: right;
  padding-right: 0.375rem;
}

.BC-Page__SearchPageDisplay .BC-DataTable__Product {
  margin-top: -0.625rem;
  margin-bottom: 0.6875rem;
}

.BC-Page__SearchPageDisplay .BC-DataTable__Product .empty-product {
  margin: 1.4375rem auto 1.875rem;
  text-align: center;
}

.BC-Page__SearchPageDisplay .BC-DataTable__Product .addProducts {
  border-top: 1px solid var(--p-divider);
  padding-top: 0.875rem;
  text-align: right;
}

.BC-Page__SearchPageDisplay .BC-DataTable__Product .addProducts .Polaris-Button__Text {
  font-weight: 500;
}

.BC-Page__SearchPageDisplay .BC-DataTable__Product .addProducts button {
  text-decoration: none;
}

.BC-Page__SearchPageDisplay .BC-DataTable__Product .Polaris-DataTable__Cell {
  padding: 0.875rem 0.78125rem;
}

.BC-Page__SearchPageDisplay .BC-DataTable__Product tbody .Polaris-DataTable__Cell {
  border-top: 1px solid var(--p-divider);
  border-bottom: none;
  white-space: normal;
}

.BC-Page__SearchPageDisplay .BC-DataTable__Product tbody tr:first-child .Polaris-DataTable__Cell {
  border-top: none;
}

.BC-Page__SearchPageDisplay .BC-DataTable__Product .Polaris-DataTable__Cell:first-child {
  width: 20px;
  padding: 0rem;
}

.BC-Page__SearchPageDisplay .BC-DataTable__Product .Polaris-DataTable__Cell:nth-child(2) {
  width: 50px;
}

.BC-Page__SearchPageDisplay .BC-DataTable__Product .Polaris-DataTable__Cell:nth-child(3) {
  width: auto;
}

.BC-Page__SearchPageDisplay .BC-DataTable__Product .Polaris-DataTable__Cell:nth-child(4) {
  width: 50px;
  text-align: right;
  padding-right: 0.375rem;
}

.BC-Page__SearchPageDisplay .BC-DataTable__Product .Polaris-DataTable__Cell .product-image,
.BC-DataTable__Product-Options .Polaris-DataTable__Cell .product-image {
  width: 40px;
  padding-bottom: 40px;
  position: relative;
  border: 1px solid var(--p-divider);
  box-sizing: border-box;
}

.BC-Page__SearchPageDisplay .BC-DataTable__Product .Polaris-DataTable__Cell .product-image.no-image,
.BC-DataTable__Product-Options .Polaris-DataTable__Cell .product-image.no-image {
  background-color: #f9fafb;
}

.BC-Page__SearchPageDisplay .BC-DataTable__Product .Polaris-DataTable__Cell .product-image img,
.BC-DataTable__Product-Options .Polaris-DataTable__Cell .product-image img {
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.BC-Page__SearchPageDisplay .BC-Page__Fields .groupFields .groupFields-flex-2 {
  display: flex;
  flex-wrap: wrap;
  gap: 1.375rem;
}

.BC-Page__SearchPageDisplay .BC-Page__Fields .groupFields .groupFields-flex-2 > div {
  flex: 48%;
}

.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-Page__Fields
  .search-results-tab
  .layout-custom
  .Polaris-Button {
  margin-top: 8px;
  padding: 5px 8px;
  border: 1px solid var(--border-default, #8c9196);
}

.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-Page__Fields
  .search-results-tab
  .layout-custom
  .Polaris-Button__Text {
  display: flex;
  align-items: center;
  gap: 4px;
}

.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-Page__Fields
  .search-results-tab
  .layout-custom
  > p:nth-child(2) {
  margin-top: 4px;
  line-height: 20px;
}

.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-Page__Fields
  .search-results-tab
  .layout-custom
  .Polaris-Button
  .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  width: 20px;
  height: 20px;
}

.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-Page__Fields
  .search-results-tab
  .Polaris-Banner {
  margin-top: 24px;
  padding: 20px 40px 20px 20px;
  border-radius: 8px;
}

.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-Page__Fields
  .search-results-tab
  .Polaris-Banner
  .Polaris-Banner__Dismiss {
  top: 20px;
  right: 20px;
}

.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-Page__Fields
  .search-results-tab
  .Polaris-Banner
  .Polaris-Banner__Ribbon {
  flex: unset;
  padding-right: unset;
  visibility: hidden;
  width: 0px;
}

.BC-Page__StandardSearch .BC-Page__SearchSettings .Polaris-Tabs__Panel .Polaris-Card__Section,
.BC-Page__StandardSearch .BC-Page__SearchPageDisplay .Polaris-Tabs__Panel .Polaris-Card__Section {
  padding: 0;
}

.BC-Page__StandardSearch .BC-Page__SearchPageDisplay .groupFields .radioButtonGroup {
  padding: 20px !important;
}

.BC-Page__StandardSearch .BC-Page__SearchPageDisplay .BC-DataTable__Product {
  margin-top: 16px;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .BC-DataTable__Product
  .Polaris-DataTable__Cell:nth-child(4),
.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .BC-DataTable__SearchTerm
  .Polaris-DataTable__Cell:nth-child(3) {
  width: 50px;
  text-align: center;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .BC-DataTable__Product
  .Polaris-DataTable__Cell:nth-child(4)
  .Polaris-Button,
.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .BC-DataTable__SearchTerm
  .Polaris-DataTable__Cell:nth-child(3)
  .Polaris-Button {
  width: 30px;
  min-width: unset;
  padding: 0;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .BC-DataTable__Product
  .Polaris-DataTable__Cell:nth-child(4)
  .Polaris-Button
  .Polaris-Button__Icon,
.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .BC-DataTable__SearchTerm
  .Polaris-DataTable__Cell:nth-child(3)
  .Polaris-Button
  .Polaris-Button__Icon {
  display: flex;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .BC-DataTable__Product
  .Polaris-DataTable__Cell:nth-child(1)
  .Polaris-Icon__Svg,
.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .BC-DataTable__SearchTerm
  .Polaris-DataTable__Cell:nth-child(1)
  .Polaris-Icon__Svg,
.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-DataTable__Product
  .Polaris-DataTable__Cell:nth-child(1)
  .Polaris-Icon__Svg,
.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-DataTable__SearchTerm
  .Polaris-DataTable__Cell:nth-child(1)
  .Polaris-Icon__Svg {
  fill: #5c5f62;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .BC-DataTable__SearchTerm
  .BC__SearchTermSuggestion-Add
  .Polaris-Stack__Item:nth-child(1),
.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-DataTable__SearchTerm
  .BC__SearchTermSuggestion-Add
  .Polaris-Stack__Item:nth-child(1) {
  width: 300px;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .BC-DataTable__SearchTerm
  .BC__SearchTermSuggestion-Add
  .Polaris-Stack__Item:nth-child(1)
  .Polaris-TextField,
.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-DataTable__SearchTerm
  .BC__SearchTermSuggestion-Add
  .Polaris-Stack__Item:nth-child(1)
  .Polaris-TextField {
  height: 30px;
}

.BC-Page__StandardSearch
  .BC-Page__InstantSearchDisplay
  .BC-DataTable__SearchTerm
  .BC__SearchTermSuggestion-Add
  .Polaris-Stack__Item:nth-child(2)
  .Polaris-Button,
.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-DataTable__SearchTerm
  .BC__SearchTermSuggestion-Add
  .Polaris-Stack__Item:nth-child(2)
  .Polaris-Button {
  padding: 10px;
  width: 100%;
  height: 30px;
  display: flex;
  min-height: unset;
}

/* Search page display */

/* Suggestion dictionary */
.BC-Page__SuggestionDictionary .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty,
.BC-Page__Merchandising .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty,
.BC-Page__Metafield .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty,
.BC-Page__CustomRangeSlider .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty,
.BC-Page__Product-Visibility .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty,
.BC-Page__SwatchSettings .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty,
.BC-Page__CustomSorting .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty {
  height: 20px;
}

.BC-Page__SuggestionDictionary .Polaris-DataTable__Cell {
  padding: 0.75rem 0.78125rem;
}

.BC-Page__SuggestionDictionary .Polaris-DataTable__Cell:first-child {
  width: 180px;
  padding-left: 1.25rem;
}

/*.BC-Page__SuggestionDictionary .Polaris-DataTable__Cell:nth-child(2) {
  width: 25%;
}*/

.BC-Page__SuggestionDictionary .Polaris-DataTable__Cell:last-child {
  width: 142px;
  padding-right: 1.25rem;
}

.BC-Page__SuggestionDictionary .newSuggestion .Polaris-DataTable__Cell:first-child,
.BC-Page__SuggestionDictionary .editSuggestion .Polaris-DataTable__Cell:nth-child(2) {
  width: 75%;
}

.BC-Page__SuggestionDictionary .newSuggestion .Polaris-DataTable__Cell:last-child,
.BC-Page__SuggestionDictionary .editSuggestion .Polaris-DataTable__Cell:last-child {
  width: 76px;
  text-align: right;
  padding-right: 1.25rem;
}

.BC-Page__SuggestionDictionary .Polaris-DataTable__Cell .BC-Checkbox-Status {
  margin-top: 4px;
}

.BC-Page__SuggestionDictionary .ImportExportActionsGroup {
  display: inline-flex;
  color: #637381;
}

.BC-Page__SuggestionDictionary .ImportExportActionsGroup .action {
  display: inline-flex;
  cursor: pointer;
}

.BC-Page__SuggestionDictionary .ImportExportActionsGroup .action:last-child {
  margin-left: 1.4375rem;
}

.BC-Page__SuggestionDictionary .ImportExportActionsGroup .action .Polaris-Icon {
  margin-right: 3px;
}

.BC-Page__SuggestionDictionary .addMoreSuggestion {
  padding: 0.75rem 1.25rem 0.75rem 0.75rem;
  padding-right: 16px;
  text-align: right;
}

.BC-Page__SuggestionDictionary .addMoreSuggestion .Polaris-Button,
.BC-Page__SuggestionDictionary .newSuggestion .Polaris-DataTable__Cell .Polaris-Button {
  width: 36px;
}

.BC-Page__SuggestionDictionary .addMoreSuggestion .Polaris-Button__Text,
.BC-Page__SuggestionDictionary .newSuggestion .Polaris-DataTable__Cell .Polaris-Button__Text {
  font-weight: 700;
}

.BC-Page__SuggestionDictionary .editSuggestion .Polaris-DataTable__Cell:last-child,
.BC-Page__SuggestionDictionary .editRedirect .Polaris-DataTable__Cell:last-child {
  text-align: center;
}

.BC-Page__SuggestionDictionary .editSuggestion .Polaris-DataTable__Cell .Polaris-Choice__Control,
.BC-Page__SuggestionDictionary .editRedirect .Polaris-DataTable__Cell .Polaris-Choice__Control {
  margin-top: 10px;
  margin-right: 0;
}

.BC-Page__SuggestionDictionary .actionsGroup,
.BC-Page__Merchandising .actionsGroup,
.BC-Page__MerchandisingV2 .actionsGroup {
  position: absolute;
  right: 0px;
  top: 0px;
}

.BC-Page__SuggestionDictionary
  .BC-Page__Button-HasBreadcrumb
  .Polaris-Stack__Item:last-child
  .Polaris-Button,
.BC-Page__SuggestionDictionary .actionsGroup .Polaris-Stack__Item:last-child .Polaris-Button,
.BC-Page__Merchandising .actionsGroup .Polaris-Stack__Item:last-child .Polaris-Button {
  padding: 0.4375rem 0.625rem;
}

/* Redirect */
.BC-Page__Redirect .editRedirect .Polaris-DataTable__Cell:first-child {
  width: 9%;
}

.BC-Page__Redirect .newRedirect .Polaris-DataTable__Cell:first-child,
.BC-Page__Redirect .editRedirect .Polaris-DataTable__Cell:nth-child(2) {
  width: 340px;
}

.BC-Page__Redirect .newRedirect .Polaris-DataTable__Cell:nth-child(2),
.BC-Page__Redirect .editRedirect .Polaris-DataTable__Cell:nth-child(3) {
  width: auto;
}

.BC-Page__Redirect .newRedirect .Polaris-DataTable__Cell:last-child,
.BC-Page__Redirect .editRedirect .Polaris-DataTable__Cell:last-child {
  width: 68px;
}

.BC-Page__Redirect .Polaris-DataTable__Cell:last-child {
  width: auto;
}

.BC-Page__Merchandising .noRules .Polaris-DataTable__Cell:last-child {
  width: 9%;
}

.BC-Page__Redirect .Polaris-DataTable__Cell:first-child {
  width: 120px;
}

.BC-Page__Redirect .Polaris-DataTable__Cell:nth-child(2) {
  width: 240px;
}

.BC-Page__Redirect-New .addMoreSuggestion .Polaris-Button {
  padding: 0;
}

.BC-Page__Redirect-New .addMoreSuggestion .Polaris-Button .Polaris-Button__Text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.BC-Page__Redirect .newRedirect .Polaris-DataTable__Cell:last-child .Polaris-Button {
  width: 36px;
  padding: 0;
}

.BC-Page__Redirect
  .newRedirect
  .Polaris-DataTable__Cell:last-child
  .Polaris-Button
  .Polaris-Button__Text {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Dropzone */
.dropzone .Polaris-DropZone--sizeExtraLarge {
  min-height: 40px;
}

.Polaris-Icon--colorGreen {
  margin-left: 0;
}

/* Synonym */
.BC-Page__Synonym .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty {
  height: 20px;
}

.BC-EmptyOption__Synonym {
  padding-top: 1.875rem;
  padding-bottom: 1.5rem;
}

.BC-EmptyOption__AISynonym .title {
  font-size: 16px;
  font-weight: 600;
  color: #202223;
}

.BC-EmptyOption__AISynonym .content {
  font-size: 14px;
  font-weight: 400;
  color: #6d7175;
  margin-top: 5px;
}

.BC-Page__Synonym .Polaris-DataTable__Cell {
  padding: 1.25rem 0.78125rem;
}

.BC-Page__Synonym .listSynonyms.empty thead tr {
  display: flex;
  justify-content: space-between;
  border-bottom: 0.0625rem solid var(--p-divider);
}

.BC-Page__Synonym .listSynonyms.empty .Polaris-DataTable__Cell {
  border-bottom: none;
}

.BC-Page__Synonym .listSynonyms .Polaris-DataTable__Cell:first-child,
.BC-Page__Synonym .editSynonyms .Polaris-DataTable__Cell:first-child {
  width: 9%;
  padding-left: 1.25rem;
}

.BC-Page__Synonym .listSynonyms .Polaris-DataTable__Cell:nth-child(2) {
  width: 25%;
}

.BC-Page__Synonym .listSynonyms .Polaris-DataTable__Cell .disabled {
  color: #8c9196;
}

.BC-Page__Synonym .listSynonyms .Polaris-DataTable__Cell:nth-child(3) {
  width: 78px;
  text-align: center;
}

.BC-Page__Synonym .listSynonyms .Polaris-DataTable__Cell:last-child {
  padding-right: 1.25rem;
}

.BC-Page__Synonym .listSynonyms .synonyms {
  display: flex;
  flex-wrap: wrap;
}

.BC-Page__Synonym .listSynonyms .synonym-item {
  padding: 2px 6px;
  background: #f4f6f8;
  border-radius: 3px;
  margin-right: 2px;
  margin-top: 4px;
  color: #637381;
}

.BC-Page__Synonym .newSynonyms .Polaris-DataTable__Cell:first-child,
.BC-Page__Synonym .editSynonyms .Polaris-DataTable__Cell:nth-child(2) {
  width: 25%;
}

.BC-Page__Synonym .newSynonyms .Polaris-DataTable__Cell:nth-child(2),
.BC-Page__Synonym .editSynonyms .Polaris-DataTable__Cell:nth-child(3) {
  width: 78px;
}

.BC-Page__Synonym .editSynonyms .Polaris-DataTable__Cell:nth-child(5),
.BC-Page__Synonym .newSynonyms .Polaris-DataTable__Cell:nth-child(4) {
  width: 100px;
  text-align: center;
}

.BC-Page__Synonym .newSynonyms .Polaris-DataTable__Cell:last-child,
.BC-Page__Synonym .editSynonyms .Polaris-DataTable__Cell:last-child {
  width: 76px;
  text-align: center;
}

.BC-Page__Synonym .Polaris-DataTable__Cell .BC-Checkbox-Status {
  margin-top: 4px;
}

.BC-Page__Synonym .ImportExportActionsGroup {
  display: inline-flex;
  color: #637381;
}

.BC-Page__Synonym .ImportExportActionsGroup .action {
  display: inline-flex;
  cursor: pointer;
}

.BC-Page__Synonym .ImportExportActionsGroup .action:last-child {
  margin-left: 1.4375rem;
}

.BC-Page__Synonym .ImportExportActionsGroup .action .Polaris-Icon {
  margin-right: 3px;
}

.BC-Page__Synonym .addMoreSynonyms {
  padding: 1.25rem;
  text-align: right;
}

.BC-Page__SuggestionDictionary .editSuggestion .Polaris-Button,
.BC-Page__Synonym .addMoreSynonyms .Polaris-Button,
.BC-Page__Synonym .editSynonyms .Polaris-DataTable__Cell .Polaris-Button,
.BC-Page__Synonym .newSynonyms .Polaris-DataTable__Cell .Polaris-Button {
  width: 36px;
}

.BC-Page__Synonym .addMoreSynonyms .Polaris-Button__Text,
.BC-Page__Synonym .newSynonyms .Polaris-DataTable__Cell .Polaris-Button__Text {
  font-weight: 700;
}

.BC-Page__Synonym .editSynonyms .Polaris-DataTable__Cell:last-child {
  text-align: center;
}

.BC-Page__Synonym .newSynonyms .Polaris-DataTable__Cell .Polaris-Choice__Control,
.BC-Page__Synonym .editSynonyms .Polaris-DataTable__Cell .Polaris-Choice__Control {
  margin-top: 10px;
  margin-right: 0;
}

.BC-Page__Synonym .actionsGroup {
  position: absolute;
  right: 0px;
  top: 0px;
}

.BC-Page__Synonym .actionsGroup--height {
  height: 36px;
}

.BC-Page__Synonym .BC-Page__Button-HasBreadcrumb .Polaris-Stack__Item:last-child .Polaris-Button,
.BC-Page__Synonym .actionsGroup .Polaris-Stack__Item:last-child .Polaris-Button {
  padding: 0.4375rem 0.625rem;
}

.BC-Page__Synonym .Polaris-Tabs__Wrapper {
  padding: 0 0 1.5rem;
}

.BC-Page__Synonym .editSynonymModel .Polaris-DataTable__Cell--header {
  border-bottom: 0;
  padding-bottom: 0;
}

.BC-Page__Synonym .editSynonymModel .Polaris-DataTable__Cell--firstColum {
  padding-left: 0;
}

.BC-Page__Synonym .actionIcon .Polaris-Icon {
  width: 1rem;
  height: 1rem;
  cursor: pointer;
}

.BC-Page__Synonym .Polaris-Tabs__Wrapper .Polaris-Tabs__TabContainer .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  margin-right: 2px;
  height: 1.2rem;
  width: 1rem;
}

.BC-Page__Synonym
  .tab-AIsynonym-disabled
  .Polaris-Tabs
  .Polaris-Tabs__TabContainer:nth-child(2)
  button
  p {
  color: var(--p-text-disabled);
}

.BC-Page__Synonym
  .tab-AIsynonym-disabled
  .Polaris-Tabs
  .Polaris-Tabs__TabContainer:nth-child(2)
  button
  span::before {
  bottom: unset;
  content: unset;
  box-shadow: none;
  transition: none;
  border-radius: none;
  height: 0px;
}

.BC-Page__Synonym .manual-synonym-suggest--ai {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #e1e3e5;
  padding: 0 20px;
  height: 56px;
  background-color: white;
}

.BC-Page__Synonym .manual-synonym-suggest--ai .Polaris-Link {
  text-decoration: none;
}

.BC-Page__Synonym .manual-synonym-suggest--ai .manual-synonym-suggest--ai-title {
  font-size: 16px !important;
}

.BC-Page__Synonym .manual-synonym-suggest--ai .manual-synonym-suggest--ai-title .Polaris-Badge {
  margin-left: 10px;
  font-size: 12px;
}

.BC-Page__Synonym .manual-synonym-suggest--ai .manual-synonym-suggest--ai-title .Polaris-Badge-Pip {
  --pc-pip-size: 7px;
}

.BC-Page__Synonym .manual-synonym-banner--unlock {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background-color: #fffbf3;
  border-radius: 8px;
}

.BC-Page__Synonym .unlock-button {
  border-radius: 4px;
  background: var(--decorative-surface-one, #ffc96b);
  box-shadow:
    0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset,
    0px 1px 0px 0px rgba(0, 0, 0, 0.08);
  width: 99px;
  font-weight: 500;
}

.BC-Page__Synonym .unlock-button .Polaris-Icon svg {
  fill: #1a1c1d;
}

.SynonymTable__Header .Polaris-Stack__Item {
  width: 100%;
}

.SynonymTable__Header .Polaris-Stack__Item--fill {
  display: none;
}

.SynonymTable__Header .premium-warning-restore {
  min-height: 104px !important;
}

/* Merchandising */
.BC-Merchandising__TryNewVersion
  .Polaris-Banner
  .Polaris-Banner__ContentWrapper
  .Polaris-Banner__Content
  > p:first-child
  a {
  color: #2c6ecb;
  text-decoration: none;
}

.BC-Merchandising__TryNewVersion
  .Polaris-Banner
  .Polaris-Banner__ContentWrapper
  .Polaris-Banner__Content
  > p:first-child
  .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
}

.BC-Merchandising__TryNewVersion
  .Polaris-Banner
  .Polaris-Banner__ContentWrapper
  .Polaris-Banner__Content
  ul {
  margin: 0px;
  padding-left: 20px;
}

.BC-Merchandising__TryNewVersion .Polaris-Layout__Section {
  flex: 2 2 41.25rem;
}

.BC-Merchandising__TryNewVersion .Polaris-Layout__Section--secondary {
  flex: 1 1 12.5rem;
  text-align: right;
}

.BC-Page__Merchandising .BC-EmptyRules__Merchandising .Polaris-Button--primary,
.BC-Page__Metafield .BC-EmptyRules__Metafield .Polaris-Button--primary,
.BC-Page__Product-Visibility .BC-EmptyRules__Product-Visibility .Polaris-Button--primary {
  width: 167px;
}

.BC-Page__Merchandising .Polaris-Stack > .Polaris-Stack__Item .search {
  position: absolute;
  right: 20px;
  top: 10px;
  width: 18.75rem;
}

.BC-Page__Merchandising .Polaris-Stack > .Polaris-Stack__Item .search .Polaris-TextField__Input {
  font-size: 0.75rem;
}

.BC-Page__Merchandising .noRules .Polaris-DataTable__Cell:not(:first-child) {
  text-align: center;
}

.BC-Page__Merchandising .Polaris-DataTable__Cell:first-child {
  width: 5%;
  padding-left: 1.25rem;
  padding-right: 0;
}

.BC-Page__Merchandising .Polaris-DataTable__Cell:nth-child(2) {
  width: 10%;
  padding-left: 0.9375rem;
}

.BC-Page__Merchandising .Polaris-DataTable__Cell:nth-child(3) {
  width: 25%;
}

/*.BC-Page__Merchandising .Polaris-DataTable__Cell:nth-child(4) {
  width: 30%;
}*/

.BC-Page__Merchandising .Polaris-DataTable__Cell:nth-child(5) {
  width: 12%;
}

.BC-Page__Merchandising .Polaris-DataTable__Cell:nth-child(6) {
  width: 111px;
  text-align: center;
}

.BC-Page__Merchandising .hasRules .Polaris-DataTable .Polaris-DataTable__TableRow {
  background-color: #fff;
}

.BC-EmptyRules__Merchandising img,
.BC-EmptyRules__Metafield img,
.BC-EmptyRules__CustomRangeSlider img,
.BC-EmptyRules__CustomSorting img,
.BC-EmptyRules__Product-Visibility img {
  width: 50px;
}

.BC-Page__Merchandising .BC-Page__Button-HasBreadcrumb .Polaris-Button,
.BC-Page__Merchandising .Polaris-PageActions .Polaris-Button {
  width: 68px;
}

.BC-Page__Merchandising-Rule .Polaris-Page-Header .Polaris-Header-Title__SubTitle {
  font-size: 20px;
  line-height: 28px;
  color: #637381;
}

.BC-Page__Merchandising-Rule-DateRange {
  color: rgb(118, 118, 118);
}

.datePicker .date-select .Polaris-Button svg {
  fill: var(--p-icon-subdued);
}

.BC-Page__Merchandising-Rule .conditions legend {
  float: left;
}

.BC-Page__Merchandising-Rule .conditions .Polaris-ChoiceList ul li:first-child {
  float: left;
  padding: 0 1.25rem;
}

.BC-Page__Merchandising-Rule
  .conditions
  .Polaris-DataTable__Table
  .Polaris-DataTable__Cell--firstColumn {
  padding: 0 !important;
  width: 0%;
  /* Fix issue tooltip showed in the first column by adding an empty column*/
}

.BC-Page__Merchandising-Rule
  .conditions
  .Polaris-DataTable__Table
  .Polaris-DataTable__Cell--header {
  padding-bottom: 0;
  border-bottom: 0;
}

.BC-Page__Merchandising-Rule
  .conditions
  .Polaris-DataTable__Table
  .Polaris-DataTable__TableRow
  .Polaris-DataTable__Cell {
  padding: 1.5625rem 0.6875rem;
}

.BC-Page__Merchandising-Rule
  .conditions
  .Polaris-DataTable__Table
  .Polaris-DataTable__TableRow:first-child
  .Polaris-DataTable__Cell {
  padding-top: 0.8125rem;
}

.BC-Page__Merchandising-Rule
  .conditions
  .Polaris-DataTable__Table
  .Polaris-DataTable__TableRow
  .Polaris-DataTable__Cell:last-child {
  width: 36px;
  padding-right: 1px !important;
}

.BC-Page__Merchandising-Rule
  .conditions
  .Polaris-DataTable__Table
  .Polaris-DataTable__Cell:nth-child(2) {
  padding-left: 0 !important;
  width: 28%;
}

.BC-Page__Merchandising-Rule
  .conditions
  .Polaris-DataTable__Table
  .Polaris-DataTable__Cell:nth-child(3) {
  width: 40%;
}

.BC-Page__Merchandising-Rule
  .conditions
  .Polaris-DataTable__Table
  .Polaris-DataTable__Cell:nth-child(4) {
  max-width: 240px;
}

.BC-Page__Merchandising-Rule .conditions .Polaris-DataTable__TableRow .Polaris-Button--iconOnly {
  padding: 0.625rem;
}

.BC-Page__Merchandising-Rule .conditions .Polaris-DataTable__TableRow .Polaris-Icon {
  width: 0.875rem;
  height: 0.875rem;
}

.BC-Page__Merchandising-Rule .addNewCondition {
  text-align: right;
  padding-top: 1.25rem;
  border-top: 0.0625rem solid var(--p-divider);
}

.BC-Page__Merchandising-Rule
  .Polaris-PageActions
  .Polaris-Stack--spacingTight
  > .Polaris-Stack__Item {
  margin-top: 0.75rem;
  margin-left: 1rem;
}

.field-error-text {
  margin-top: 10px;
  color: var(--p-critical-text, #bf0711);
}

.in-collection-search-lock .action,
.premium-lock-card .action {
  margin-top: 1rem;
  display: flex;
  align-items: center;
}

.premium-lock-card .content-list > div {
  margin-top: 0.75rem;
  display: flex;
  align-items: flex-start;
}

.premium-lock-card .content-list img {
  margin-right: 0.25rem;
}

.in-collection-search-lock .Polaris-Button,
.premium-lock-card .Polaris-Button {
  background: var(--decorative-surface-one, #ffc96b);
  box-shadow:
    0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset,
    0px 1px 0px 0px rgba(0, 0, 0, 0.08);
  font-weight: 500;
  margin-right: 0.75rem;
  align-items: center;
  gap: 4px;
  border: unset;
}

.in-collection-search-lock .Polaris-Button .Polaris-Icon svg,
.premium-lock-card .Polaris-Button .Polaris-Icon svg {
  fill: var(--p-icon-hovered);
}

.upgrade-plan-analytic .Polaris-Link .Polaris-Icon,
.in-collection-search-lock .action a .Polaris-Icon,
.premium-lock-card .action a .Polaris-Icon {
  vertical-align: middle;
  display: inline-block;
}

.upgrade-plan-analytic {
  display: flex;
  gap: 8px;
  align-items: center;
}

.upgrade-plan-analytic .Polaris-Badge {
  background: #fff2d9;
  color: #ff3345;
  font-weight: 600;
  padding: 4px;
  border-radius: 4px;
}

.upgrade-plan-analytic .Polaris-Badge > span:last-child {
  display: flex;
  gap: 4px;
  align-items: center;
}

.upgrade-plan-analytic .Polaris-Link {
  text-decoration: none;
}

.premium-lock-card .Polaris-Grid-Cell > img {
  width: 100%;
}

.in-collection-search-lock {
  text-align: center;
  margin: 40px 100px;
}

.in-collection-search-lock img {
  width: 30%;
  height: auto;
}

.in-collection-search-lock .content {
  margin-top: 16px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.in-collection-search-lock > p {
  color: #6d7175;
  margin-top: 4px;
}

.in-collection-search-lock .action {
  width: 100%;
  justify-content: center;
}

/* Merchandising V2 */

.BC-Page__MerchandisingV2 .Polaris-Card .premium-lock-card .Polaris-Icon,
.collection-action-locked .Polaris-Icon,
.BC-Page__MerchandisingV2 .Polaris-Tabs__Wrapper .Polaris-Tabs__TabContainer .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  margin-right: 2px;
  height: 20px;
  width: 20px;
}

.collection-action-locked {
  color: #8c9196;
}

.collection-action-locked .Polaris-Icon svg {
  fill: var(--p-icon-disabled);
}

#PolarisPortalsContainer .Polaris-Tooltip-TooltipOverlay {
  pointer-events: auto;
}

.link-tooltip {
  color: #1f5199;
}

.link-tooltip:hover {
  cursor: pointer;
  text-decoration: underline;
}

.collection-action-locked .Polaris-Icon,
.action-locked .Polaris-Icon {
  margin-left: 2px;
  margin-right: 0 !important;
}

.premium-warning-restore {
  display: flex;
  margin-bottom: 17px;
  padding: 16px;
  gap: 16px;
}

.PFS-scope-suggestion-locked {
  width: 100%;
  margin-top: 16px;
}

.premium-iws-card {
  min-height: 144px;
  border-radius: 8px;
  padding: 20px;
  position: relative;
  background: #fffbf3;
}

.premium-iws-card .Polaris-TextStyle--variationStrong {
  font-size: 16px;
}

.premium-iws-card--trial {
  border: 1px solid #e1b878;
  background-color: #fff5ea;
}

.premium-iws-card--trial > .Polaris-Button svg {
  fill: var(--p-icon-warning);
}

.premium-iws-card > .unlock-button {
  width: fit-content;
  background: #fff5ea;
  margin-top: 12px;
  border: 1px solid #e1b878;
  border-radius: 4px;
  padding: 8px 16px 8px 12px;
  font-weight: 500;
}

.premium-warning-restore > .Polaris-Button {
  align-items: baseline !important;
}

.premium-iws-card > .unlock-button .Polaris-Icon {
  width: 20px;
  height: 20px;
}

.premium-warning-restore > .Polaris-Button .Polaris-Icon {
  height: 1rem;
  width: 1rem;
}

.premium-warning-restore .Polaris-Icon {
  margin: 0;
  min-width: 2%;
}

.unlock-button:hover {
  cursor: pointer;
}

.premium-iws-card > .Polaris-Button .Polaris-Icon {
  margin-right: 7px;
}

.premium-iws-card div .unlock-button,
.premium-warning-restore div .unlock-button {
  background: #fff5ea;
  border: 1px solid #e1b878;
  font-weight: 500;
}

.BC-Page__StandardSearch
  .BC-Page__Synonym
  .unlock-button-disabled
  .Polaris-Banner__Button
  .Polaris-Icon
  svg,
.enhance-ai-search-banner-disabled .Polaris-Banner__Button .Polaris-Icon svg,
.premium-iws-card > .unlock-button-disabled .Polaris-Icon svg,
.premium-lock-card .unlock-button-disabled .Polaris-Icon svg {
  fill: var(--p-icon);
}

.BC-Page__StandardSearch .BC-Page__Synonym .unlock-button-disabled .Polaris-Banner__Button,
.enhance-ai-search-banner-disabled .Polaris-Banner__Button,
.premium-card-lock > div .unlock-button-disabled,
.premium-iws-card > .unlock-button-disabled,
.premium-lock-card .unlock-button-disabled,
.premium-warning-restore div .unlock-button-disabled {
  background: #f7f3ef !important;
  border: 1px solid #d1d1d1;
  font-weight: 500;
  color: gray !important;
}

.BC-Page__StandardSearch .BC-Page__Synonym .unlock-button-disabled .Polaris-Banner__Button:hover,
.enhance-ai-search-banner-disabled .Polaris-Banner__Button:hover,
.premium-card-lock > div .unlock-button-disabled:hover,
.premium-iws-card > .unlock-button-disabled:hover,
.premium-warning-restore div .unlock-button-disabled:hover {
  cursor: unset;
}

.breakLine {
  border-top: 0.0625rem solid var(--p-divider);
}

.BC-Page-Variants-Display .Polaris-Page .Polaris-Layout .Polaris-Card,
.BC-Page__MerchandisingV2 .Polaris-Card {
  position: relative;
}

.merchandisingV2Infos .image {
  max-height: 132px;
}

.premium-card-lock {
  width: 100%;
  height: 100%;
  opacity: 2.5;
  position: absolute;
  background: white;
  z-index: 21;
  background: linear-gradient(0, #ffffff 39.69%, rgba(255, 255, 255, 0.7) 100%);
  backdrop-filter: blur(1.5px);
  border-radius: 8px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

.premium-lock-card .Polaris-Card {
  padding: 1.25rem 0rem;
}

.premium-lock-card .Polaris-Card__Section {
  padding: 1.25rem 2rem;
  border: none;
}

.premium-lock-card .Polaris-Grid-Cell {
  margin-top: auto;
  margin-bottom: auto;
}

.premium-lock-card p.title {
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;
  margin-bottom: 0.25rem;
}

.premium-lock-card p.title img {
  margin-right: 0.25rem;
}

.pfs-freemium-card-lock .action,
.search-control-lock-banner .action,
.pfs-feature-lock-media-card .action .pfs-feature-lock-card .action,
.premium-lock-card .action {
  margin-top: 1rem;
  display: flex;
  align-items: center;
}

.premium-lock-card .content-list > div {
  margin-top: 0.75rem;
  display: flex;
  align-items: flex-start;
}

.premium-lock-card .content-list img {
  margin-right: 0.25rem;
}

.freemiumAnalyticBanner .Polaris-Button,
.pfs-freemium-card-lock .action .Polaris-Button,
.search-control-lock-banner .action .Polaris-Button,
.pfs-feature-lock-media-card .Polaris-Button,
.pfs-feature-lock-card .Polaris-Button,
.premium-lock-card .Polaris-Button {
  background: var(--decorative-surface-one, #ffc96b);
  box-shadow:
    0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset,
    0px 1px 0px 0px rgba(0, 0, 0, 0.08);
  font-weight: 500;
  margin-right: 0.75rem;
  align-items: center;
  gap: 4px;
  border: unset;
}

.freemiumAnalyticBanner .Polaris-Button .Polaris-Button__Text {
  font-weight: 500;
}

.freemiumAnalyticBanner .Polaris-Button {
  margin-right: unset;
}

.pfs-freemium-card-lock .action .Polaris-Button .Polaris-Icon svg,
.search-control-lock-banner .action .Polaris-Button .Polaris-Icon svg,
.pfs-feature-lock-media-card .Polaris-Button .Polaris-Icon svg,
.pfs-feature-lock-card .Polaris-Button .Polaris-Icon svg,
.premium-lock-card .Polaris-Button .Polaris-Icon svg {
  fill: var(--p-icon-hovered);
}

.search-control-lock-banner .action .Polaris-Button .Polaris-Icon,
.option-premium-lock .Polaris-Link .Polaris-Icon,
.pfs-feature-lock-media-card .action a .Polaris-Icon,
.pfs-feature-lock-card .action a .Polaris-Icon,
.premium-lock-card .action a .Polaris-Icon {
  vertical-align: middle;
  display: inline-block;
}

.premium-lock-card .Polaris-Grid-Cell > img {
  width: 100%;
}

.pfs-feature-lock-card {
  text-align: center;
  margin: 40px 100px;
}

.pfs-feature-lock-media-card .content {
  display: inline;
  font-size: 28px;
  font-weight: 600;
  line-height: 32px;
}

.pfs-feature-lock-media-card .content img {
  margin-right: 4px;
}

.pfs-feature-lock-card img {
  width: 30%;
  height: auto;
}

.pfs-feature-lock-card .content {
  margin-top: 16px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.pfs-feature-lock-card > p {
  color: #6d7175;
  margin-top: 4px;
}

.pfs-feature-lock-card .action {
  width: 100%;
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pfs-feature-lock-card .Polaris-Icon {
  margin: unset;
}

.pfs-feature-lock-card .Polaris-Link {
  display: flex;
  gap: 4px;
}

.pfs-feature-lock-media-card {
  padding: 24px;
  border-radius: 8px 0px 0px 0px;
  background: #ffffff;
}

.pfs-feature-lock-media-card > p {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #202223;
  margin-top: 6px;
}

.search-control-lock-banner .action,
.pfs-feature-lock-media-card .action {
  margin-top: 16px;
  display: flex;
  align-items: center;
}

.pfs-feature-lock-media-card .media {
  margin-top: 32px;
  width: 100%;
}

.pfs-feature-lock-media-card .media iframe {
  width: 100%;
  min-height: 400px;
  border: unset;
  border-radius: 8px;
}

.pfs-feature-lock-media-card .media img {
  width: 100%;
  height: auto;
}

.option-premium-lock {
  display: flex;
  gap: 8px;
  align-items: center;
}

.option-premium-lock .Polaris-Badge {
  background: #fff2d9;
  color: #ff3345;
  font-weight: 600;
  padding: 4px;
  border-radius: 4px;
}

.option-premium-lock .Polaris-Badge > span:last-child {
  display: flex;
  gap: 4px;
  align-items: center;
}

.option-premium-lock .Polaris-Link {
  text-decoration: none;
}

.pfs-advanced-settings-lock {
  width: 100%;
  height: 100%;
  text-align: center;
  padding: 84px 134px 64px;
}

.pfs-advanced-settings-lock img {
  min-width: 160px;
  min-height: 100px;
  width: 160px;
  height: 100px;
}

.pfs-advanced-settings-lock .content {
  display: grid;
  gap: 4px;
  align-items: center;
  justify-content: center;
}

.pfs-advanced-settings-lock .heading {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.pfs-advanced-settings-lock .text {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #69696b;
  max-width: 431px;
}

.pfs-freemium-card-lock .action .Polaris-Icon,
.search-control-lock-banner .action .Polaris-Icon {
  display: inline-block;
  vertical-align: top;
}

.search-control-lock-banner .action .Polaris-Link {
  color: #000;
}

.pfs-freemium-card-lock {
  background: rgba(255, 255, 255, 1);
  width: 100%;
  height: auto;
  padding: 40px 32px 32px 32px;
  border-radius: 8px 0px 0px 0px;
  display: grid;
  gap: 40px;
}

.pfs-freemium-card-lock .row {
  display: flex;
  width: 100%;
  gap: 48px;
  align-items: center;
}

.pfs-freemium-card-lock .heading {
  font-size: 28px;
  font-weight: 600;
  line-height: 32px;
}

.pfs-freemium-card-lock .heading img {
  margin-right: 4px;
}

.pfs-freemium-card-lock .content > p {
  margin-top: 8px;
}

.pfs-freemium-card-lock .content ul {
  margin-top: 8px;
  padding-left: 24px;
}

.pfs-freemium-card-lock .row > div {
  width: 50%;
}

.pfs-freemium-card-lock .row .media img {
  width: 100%;
  height: auto;
}

.pfs-freemium-card-lock .row .media iframe {
  width: 100%;
  height: auto;
  min-height: 240px;
  border: unset;
}

.textfield-with-prefix {
  width: 100%;
}

.textfield-with-prefix .Polaris-TextField__Prefix {
  background: #f1f2f3;
  height: 2.084rem !important;
  width: 25%;
  display: flex;
  align-items: center;
  margin-left: 1px;
  color: #202223;
  justify-content: center;
}

.textfield-with-prefix .Polaris-TextField__Prefix + .Polaris-TextField__Input {
  padding-left: 8px;
}

.select-with-prefix {
  width: 92%;
}

.select-with-prefix .select-wrapper {
  display: flex;
  align-items: center;
  border: var(--p-border-width-1) solid var(--p-border-subdued);
  border-radius: var(--p-border-radius-1);
}

.select-with-prefix .select-wrapper > div:last-child {
  width: 100%;
}

.select-with-prefix .select-prefix {
  background: #f1f2f3;
  height: 2.084rem !important;
  width: 90px;
  display: flex;
  align-items: center;
  margin-left: 1px;
  color: #202223;
  justify-content: center;
}

.select-with-prefix .Polaris-Select .Polaris-Select__Backdrop {
  border: none;
}

.textfield-with-icon {
  display: flex;
  align-items: center;
  border: var(--p-border-width-1) solid var(--p-border-subdued);
  border-radius: var(--p-border-radius-1);
  border-top-color: var(--p-border-shadow);
  background-color: #fff;
}

.textfield-with-icon .Polaris-TextField__Backdrop {
  border: none;
}

.textfield-with-icon .Polaris-TextField__Input:focus ~ .Polaris-TextField__Backdrop::after {
  box-shadow: none;
}

.textfield-with-icon--img {
  display: flex;
}

.textfield-with-icon img {
  margin-right: 6px;
  cursor: pointer;
}

.set-rule-strategies .Polaris-FormLayout {
  margin-top: 1rem;
}

.merchandising-rule-strategy .card-add-field-attribute .add-field-attribute {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.merchandising-rule-strategy .card-add-field-attribute .banner-card-section {
  margin-top: 20px;
}

.merchandising-rule-strategy
  .card-add-field-attribute
  .add-field-attribute
  .Polaris-Badge--statusInfo {
  color: #00527c;
  background: #e0f0ff;
  border-radius: 8px;
}

.set-rule-conditions .apply-same-rule-queries {
  margin-left: 15px;
}

.set-rule-conditions .apply-same-rule-queries p,
.add-field-attribute p {
  color: #2c6ecb;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.set-rule-conditions .apply-same-rule-queries span {
  margin: auto 10px auto 0;
}

.set-rule-conditions .apply-same-rule-queries .Polaris-Icon--colorBase svg,
.add-field-attribute .Polaris-Icon--colorBase svg {
  fill: #2c6ecb;
}

.BC-Page__StandardSearch .default-text-style,
.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .card-section .default-text-style {
  font-weight: 400 !important;
}

.BC-Page__MerchandisingV2-Rule
  .Polaris-Page
  .Polaris-Page-Header
  .Polaris-Page-Header__Row
  .Polaris-Page-Header__TitleWrapper {
  width: calc(100% - 350px);
}

.BC-Page__MerchandisingV2-Rule
  .Polaris-Page
  .Polaris-Page__Content
  .Polaris-Layout__Section--secondary
  .Polaris-Card
  form,
.BC-MerchandisingV2-Rule-save-modal,
.BC-Management-Widget .Polaris-Card__Section .searchField .Polaris-Connected {
  --p-focused: none !important;
}

.pfs-link {
  color: #2c6ecb;
  margin-right: 4px;
  text-decoration: underline;
}

.pfs-link:hover {
  cursor: pointer;
}

.pfs-link .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  max-width: 16px;
  margin-left: 2px;
}

.pfs-link .Polaris-Icon svg {
  fill: #2c6ecb;
}

/* end-region Merchandising rule end */
.BC-DataTable__PinProducts .Polaris-DataTable__TableRow .Polaris-DataTable__Cell {
  border-top: none;
  padding: 10px 1px 10px 10px;
}

.BC-DataTable__PinProducts .Polaris-DataTable__TableRow:first-child .Polaris-DataTable__Cell {
  border-top: none;
  padding: 0px 10px;
}

.BC-DataTable__PinProducts .Polaris-DataTable__Cell:first-child {
  width: 20px;
  padding-left: 0 !important;
}

.BC-DataTable__PinProducts .Polaris-DataTable__TableRow:nth-child(2) .Polaris-DataTable__Cell {
  padding: 4px 1px 10px 10px;
}

.BC-DataTable__PinProducts .Polaris-DataTable__Cell:nth-child(2) {
  width: 53px;
  vertical-align: baseline;
}

.BC-Page__PinProductModal .Polaris-Modal-Section:first-child {
  padding: 1rem 1.25rem;
}

.BC-Page__PinProductModal .Polaris-Modal-CloseButton:focus::after {
  box-shadow: none;
}

.BC-Page__PinProductModal .Polaris-Icon__Svg {
  fill: var(--p-text);
}

.BC-DataTable__PinProducts .position-number {
  width: 100%;
  text-align: center;
  border: 1px solid var(--p-border-subdued);
  border-radius: 4px;
  margin: 0;
  padding: 0.4375rem 0rem;
  background: #f1f2f3;
}

.BC-Select_SingleValue-Product .BC-Select__single-value .product-image,
.BC-Select_Option-Product .BC-Select__option .product-image {
  min-width: 35px !important;
  padding-bottom: 28px;
  float: left;
  position: relative;
  border: 1px solid #d2d5d8;
  border-radius: 4px;
  box-sizing: border-box;
  margin-right: 8px;
  background: #ffffff;
}

.BC-Select_SingleValue-Product .BC-Select__single-value .product-image img,
.BC-Select_Option-Product .BC-Select__option .product-image img {
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.BC-Select_SingleValue-Product .BC-Select__single-value label,
.BC-Select_Option-Product.BC-Select_Merchandising-Pin .BC-Select__option .product-detail {
  display: grid;
  vertical-align: middle;
  line-height: 30px;
}

/* ─── Pin Slots Panel (pin-tags-table) ──────────────────────────────────────── */

/* PositionMultiSelect & TagMultiSelect shared activator */
.psp-multi-activator {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 7px 8px;
  background: #fff;
  border-radius: 0 4px 4px 0;
  min-height: 36px;
  gap: 6px;
  overflow: hidden;
}

.psp-multi-activator__text {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #202223;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.psp-multi-activator--placeholder .psp-multi-activator__text {
  color: #6d7175;
}

.psp-multi-activator__icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.psp-multi-activator__icon .Polaris-Icon--colorSubdued svg {
  fill: #5c5f62;
}

.psp-position-popover {
  padding: 8px;
  max-height: 240px;
  overflow-y: auto;
  min-width: 152px;
}

/* TagMultiSelect popover */
.psp-tag-popover {
  width: 260px;
}

.psp-tag-popover__search {
  padding: 8px 8px 4px;
  border-bottom: 1px solid #e1e3e5;
}

.psp-tag-popover__search .Polaris-TextField {
  border-radius: 4px;
}

.psp-tag-popover__list {
  padding: 4px 0;
  max-height: 220px;
  overflow-y: auto;
}

.psp-tag-popover__empty {
  padding: 8px 12px;
  color: #6d7175;
  font-size: 13px;
}

.psp-position-checkbox {
  padding: 8px;
}

/* table-row helper */
.psp-table-row {
  display: flex;
  border: 1px solid #babfc3;
  border-radius: 4px;
  margin-top: 8px;
}

.psp-item-card .Polaris-Select__Backdrop {
  border: none;
  border-radius: 0 4px 4px 0;
}

.psp-item-card .Polaris-Select__SelectedOption {
  color: #202223;
}

/* Placeholder state: dim the "select value" text */
.psp-select-wrap {
  width: 100%;
}

.psp-select-wrap--placeholder .Polaris-Select__SelectedOption {
  color: #6d7175;
}

.psp-table-row__label {
  width: 80px;
  min-width: 80px;
  padding: 0 8px;
  background: #f6f6f7;
  font-size: 14px;
  color: #202223;
  display: flex;
  align-items: center;
  border-right: 1px solid #e1e3e5;
  border-radius: 4px 0 0 4px;
}

.psp-table-row__value {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.psp-table-row__value .Polaris-Select__Input {
  cursor: pointer;
}

.psp-table-row__value .Polaris-Select .Polaris-Select__Content {
  padding: 7px 8px;
}

.psp-table-row__value .Polaris-Select--disabled .Polaris-Select__Content {
  opacity: 0.6;
}

.psp-table-row__value .Polaris-Select--disabled .Polaris-Select__Input {
  pointer-events: none;
}

/* description paragraphs */
.psp-desc-1 {
  margin-bottom: 12px;
  font-size: 14px;
}

.psp-desc-2 {
  margin-bottom: 16px;
  font-size: 14px;
}

/* product tag content */
.psp-tag-content {
}

.psp-tag-content .css-ewu0nz-control,
.psp-tag-content .Polaris-Select__Backdrop {
  border: none;
  border-radius: 0 4px 4px 0;
}

.psp-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 8px 28px 8px 24px;
  justify-content: end;
}

.psp-pill {
  display: inline-block;
  padding: 2px 10px;
  background: #e8e8e8;
  border-radius: 8px;
  font-size: 12px;
  line-height: 16px;
  color: #616161;
}

/* product item content */
.psp-item-content {
  margin-top: 8px;
}

.psp-add-product .Polaris-Button {
  padding-top: 16px;
  padding-bottom: 0;
}

.psp-product-item-block {
  margin-bottom: 16px;
}

.psp-item-card {
  margin-bottom: 8px;
}

.psp-item-product-row {
  display: flex;
  align-items: center;
}

.psp-item-product-selector {
  flex: 1;
  min-width: 0;
}

.psp-item-delete-btn {
  padding: 0 8px;
  flex-shrink: 0;
}

.psp-item-sub-rows,
.psp-inner-table {
  position: relative;
  margin: 6px 28px 6px 24px;
}

.psp-item-sub-rows::before,
.psp-inner-table::before {
  content: '';
  position: absolute;
  left: -12px;
  top: -8px;
  width: 1px;
  height: calc(100% - 10px);
  background: #babfc4;
}

.psp-item-sub-rows .psp-item-product-row,
.psp-item-sub-rows .psp-table-row,
.psp-inner-table .psp-table-row {
  position: relative;
}

.psp-item-sub-rows .psp-item-product-row::before,
.psp-item-sub-rows .psp-table-row::before,
.psp-inner-table .psp-table-row::before {
  content: '';
  position: absolute;
  left: -12px;
  top: 50%;
  width: 12px;
  height: 1px;
  background: #babfc4;
}

/* lock UI */
.psp-lock-desc-2 {
  margin-bottom: 20px;
  font-size: 14px;
}

.psp-lock-img {
  text-align: center;
  margin-bottom: 20px;
}

.psp-lock-img img {
  max-width: 180px;
}

.psp-lock-card {
  text-align: center;
  padding: 12px;
}

.psp-lock-card h3 {
  font-size: 16px;
  font-weight: 600;
  color: #202223;
  margin-bottom: 8px;
}

.psp-lock-card__subtitle {
  font-size: 14px;
  color: #6d7175;
  margin-bottom: 24px;
}

.psp-lock-card__cta {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

.psp-lock-card__cta .Polaris-Link {
  display: inline-flex;
  align-items: center;
}

.psp-lock-btn {
  background: linear-gradient(91.21deg, #c830e1 1.04%, #fe4a25 131.05%);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0px 5.45px 19.3px 0px #eb452666;
}

/* group card */
.psp-group-card {
  margin-bottom: 20px;
  border: 1px solid #e1e3e5;
  border-radius: 8px;
}

.psp-group-header {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #e1e3e5;
}

.psp-drag-handle {
  margin-right: 8px;
  cursor: grab;
  line-height: 0;
}

.psp-group-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  min-width: 20px;
  border-radius: 4px;
  background: #ffffff;
  color: #6d7175;
  font-size: 11px;
  font-weight: 600;
  margin-right: 8px;
  border: 1px solid #c9cccf;
}

.psp-group-label {
  flex: 1;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  text-transform: uppercase;
  color: #6d7175;
}

.psp-group-body {
  padding: 16px 12px;
  background: #f6f6f7;
  border-radius: 0 0 8px 8px;
}

.psp-slot-type-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.psp-slot-type-select {
  flex: 1;
}

.psp-slot-type-select .Polaris-Select__Input {
  cursor: pointer;
}

.psp-add-group {
  margin-top: 12px;
}

.BC-Select_Option-Product.BC-Select_Merchandising-Attribute .BC-Select__option .product-detail {
  display: grid;
  vertical-align: middle;
}

.BC-Select_Option-Product.BC-Select_Merchandising-Attribute .BC-Select__option .product-image {
  margin-top: 4px;
}

.BC-Select_Option-Product.BC-Select_Merchandising-Attribute
  .BC-Select__option:not(.BC-Select__option--is-selected)
  .product-detail
  p {
  /* color: var(--p-text-subdued); - Do not understand outside body */
  color: #6d7175;
}

/* Welcome new feature modal */
.welcome-new-feature {
  text-align: center;
  padding: 0 20px;
}

.welcome-new-feature .welcome-content {
  transition: 750ms ease-in;
}

.welcome-new-feature h1 {
  font-weight: 600 !important;
  font-size: 28px !important;
  line-height: 32px !important;
}

.welcome-new-feature h2 {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  width: 70%;
  margin: 10px auto;
}

.welcome-new-feature img {
  width: 100%;
  height: auto;
  margin: 10px 0;
}

.welcome-new-feature .action-sliders .dot-slider {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #c9ccd0;
  cursor: pointer;
}

.welcome-new-feature .action-sliders .active {
  width: 10px !important;
  height: 10px !important;
  border-radius: 50%;
  background-color: #007f5f;
}

.welcome-new-feature .action-sliders {
  display: flex;
  justify-content: center;
  gap: 8px;
  align-items: center;
  margin: 6px 0;
}

.welcome-new-feature .action {
  margin: 18px 0 29px 0;
}

.welcome-new-feature .action button {
  animation: wiggle 4s 2s infinite;
}

.welcome-new-feature .closeBtn {
  text-align: right;
}

.welcome-new-feature .closeBtn button {
  border: none;
  background-color: #fff;
  cursor: pointer;
  padding-right: 0px;
  margin-top: 1.25rem;
}

.Polaris-Modal__BodyWrapper .Polaris-Heading {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}

.BC-Page__MerchandisingV2-Rule
  .Polaris-Scrollable
  .Polaris-Layout
  .Polaris-Layout__Section
  .Polaris-Card__Section
  .Polaris-Label
  .Polaris-Label__Text,
.BC-Page__MerchandisingV2-Rule
  .Polaris-Scrollable
  .Polaris-Layout
  .Polaris-Layout__Section
  .Polaris-Card__Section
  .Polaris-Connected
  .Polaris-TextField
  .Polaris-TextField__Input,
.BC-Page__Merchandising-Rule-DateRange,
.Polaris-Modal__BodyWrapper .condition-scope-layout p,
.Polaris-Modal__BodyWrapper .condition-scope-layout .Polaris-FormLayout,
.Polaris-Modal__BodyWrapper .condition-scope-layout .Polaris-FormLayout .Polaris-Choice__Label,
.Polaris-Modal__BodyWrapper .condition-scope-layout .Polaris-FormLayout .Polaris-Label__Text,
.Polaris-Modal__BodyWrapper .condition-scope-layout .Polaris-FormLayout .BC-Select__value-container,
.Polaris-Modal__BodyWrapper .Condition-Modal-Pick-apply-rule .Polaris-Choice__Label,
.BC-Page__MerchandisingV2-Rule .consequence-detail-content p {
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
}

.BC-Select__value-container--has-value div {
  color: #202223 !important;
}

.ai-based-primary-algorithm
  .BC-Select__control--is-disabled
  .BC-Select__value-container--has-value
  div {
  color: rgb(153, 153, 153) !important;
}

.BC-Select__control--is-focused:visited {
  border-bottom: 1px solid rgba(69, 143, 255, 1) !important;
}

.BC-Select__control--is-focused:focus-visible {
  border-bottom: 1px solid rgba(69, 143, 255, 1) !important;
}

.default-text-style {
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
}

.intro-new-version-modal {
  padding: 20px;
}

.focus-outline-hidden {
  --p-focused: unset !important;
}

.intro-new-version-modal h2 {
  font-size: 20px;
  margin-bottom: 8px;
  line-height: 32px;
}

.intro-new-version-modal .Polaris-TextContainer > *:not(:first-child) {
  margin-top: 0;
}

.Condition-Modal-Pick-apply-rule .Polaris-Choice {
  margin-right: 1.1875rem;
}

.MerchandiseV2-Condition-Modal-Search-Box {
  padding-top: 0.625rem;
  display: flex;
  justify-content: space-between;
}

.MerchandiseV2-Condition-Modal-Search-Box p {
  margin-bottom: 4px;
}

.MerchandiseV2-Condition-Modal-Search-Box .Search-box_Section {
  width: 37%;
}

.MerchandiseV2-Condition-Modal-Search-Box .Search-box_Section_two {
  width: 61%;
}

.MerchandiseV2-Rule-Condition-List {
  display: flex;
  justify-content: space-between;
  width: 110%;
  margin: 0.0625rem -0.625rem -0.625rem -0.625rem;
  background: none;
  padding: 0rem 0.625rem 0.625rem 0.625rem;
}

.MerchandiseV2-Rule-Condition-List .Condition-List_Section_two,
.Condition-Detail-Title .Condition-Title_Section_two {
  display: none;
}

.MerchandiseV2-Rule-Condition-List:hover,
.BC-Page__MerchandisingV2-Rule .condition-hover-all-content:hover {
  background: #f6f6f7;
}

.MerchandiseV2-Rule-Condition-List:hover .Condition-List_Section_two,
.BC-Page__MerchandisingV2-Rule
  .condition-hover-all-content:hover
  .Condition-Detail-Title
  .Condition-Title_Section_two {
  display: flex;
}

.MerchandiseV2-Rule-Condition-List .Condition-List_Section {
  width: 85%;
}

.MerchandiseV2-Rule-Condition-List .Condition-List_Section_two {
  width: 15%;
}

.Condition-Heading-Title {
  width: 100%;
}

.Condition-Detail-Title {
  display: flex;
  width: 100%;
  align-items: center;
}

.Condition-Detail-Title .Condition-Title_Section {
  width: 85%;
}

.Condition-Detail-Title .Condition-Title_Section_two {
  width: 15%;
}

.Condition-Detail-Title .Condition-Title_Section_two .Polaris-Icon {
  margin-right: 0.1875rem;
}

.MerchandiseV2-Rule-Condition-List .Condition-List_Section_two .Polaris-Icon,
.MerchandiseV2-Rule-Condition-List .Condition-Collection_Section_two .Polaris-Icon {
  margin-right: 0.3125rem;
  width: 1.25rem;
  height: 1.25rem;
}

.MerchandiseV2-Condition-Modal-Search-Box .Search-box_Section_second {
  display: flex;
  width: 61%;
}

.mt-3 {
  margin-top: 0.625rem;
}

.mt-5 {
  margin-top: 0.9375rem;
}

.pb-3 {
  padding-bottom: 0.625rem;
}

.Condition-Modal-Icon-delete {
  margin-top: 1.875rem;
  margin-left: 0.625rem;
}

.Condition-Modal-Icon-delete:hover,
.apply-same-rule-queries p:hover,
.add-field-attribute p:hover,
.Condition-Detail-Title .Condition-Title_Section_two .Polaris-Icon:hover,
.MerchandiseV2-Rule-Condition-List .Condition-List_Section_two .Polaris-Icon:hover,
.MerchandiseV2-Rule-Condition-List .Condition-Collection_Section_two .Polaris-Icon:hover {
  cursor: pointer;
}

.Collection-Add-Query-Filter {
  display: flex;
}

.Collection-Add-Query-Filter .Collection-Add-Query-Filter-Action span,
.BC-Page__MerchandisingV2-Rule .consequence-add-button {
  margin: 0.125rem 0 auto 0;
}

.Collection-Add-Query-Filter .Collection-Add-Query-Filter-Action .Polaris-Icon,
.Collection-Add-Query-Filter .tooltip .Polaris-Icon {
  height: 1.25rem;
}

.Collection-Add-Query-Filter .tooltip .Polaris-Icon,
.consequences-detail .tooltip .Polaris-Icon {
  margin-top: 2px;
  margin-left: 4px;
}

.Collection-Add-Query-Filter .Collection-Add-Query-Filter-Action .Polaris-Icon--colorBase svg {
  size: 0.875rem;
}

/* Recommendation */
/* Recommendation Widget */
.BC-Page__RecommendationWidgetManagement .RecommendationWidgetHighlightInfo.pfs-app-banner {
  padding: 0.75rem;
}

.BC-Page__RecommendationWidgetManagement .RecommendationWidgetHighlightInfo .pfs-banner-content {
  padding: 0;
}

.BC-Page__RecommendationWidgetManagement
  .RecommendationWidgetHighlightInfo
  .pfs-banner-content
  > p {
  display: flex;
  justify-content: center;
}

.BC-Page__RecommendationWidgetManagement .Polaris-Page {
  max-width: 936px;
  padding: 0;
}

.BC-Page__RecommendationWidgetManagement .Polaris-PageActions {
  border-top: none;
}

.BC-Page__RecommendationWidgetManagement .BC-Container__Notifications a .Polaris-Icon {
  display: inline-block;
}

.BC-Page__RecommendationWidgetManagement
  .BC-Container__Notifications
  a
  .Polaris-Icon
  .Polaris-Icon__Svg {
  margin-top: 5px;
}

.BC-Page__RecommendationWidgetManagement
  .BC-Container__Notifications
  .Polaris-Banner
  .Polaris-Link--monochrome {
  color: var(--p-interactive);
}

.BC-Page__RecommendationWidgetManagement .BC-Filters {
  position: relative;
}

.BC-Page__RecommendationWidgetManagement .BC-Filters .BC-Filters-ConnectedFilterControl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 0.75rem;
  border-bottom: var(--p-border-divider);
}

.BC-Page__RecommendationWidgetManagement .BC-Filters .Polaris-Tabs__Wrapper {
  border-bottom: none;
}

.BC-Page__RecommendationWidgetManagement
  .BC-Filters
  .BC-Filters-ConnectedFilterControl__LeftContainer {
  flex: 1 1 auto;
}

.BC-Page__RecommendationWidgetManagement
  .BC-Filters
  .BC-Filters-ConnectedFilterControl__RightContainer {
  flex: 2 1 auto;
  display: flex;
  align-items: center;
}

.BC-Page__RecommendationWidgetManagement
  .BC-Filters
  .BC-Filters-ConnectedFilterControl__RightContainer
  > div {
  margin-right: 0.5rem;
}

.BC-Page__RecommendationWidgetManagement
  .BC-Filters
  .BC-Filters-ConnectedFilterControl__RightContainer
  .action {
  padding: 0 0.5rem;
}

.BC-Page__RecommendationWidgetManagement
  .BC-Filters
  .BC-Filters-ConnectedFilterControl__RightContainer
  .action
  button {
  margin-top: 0;
  margin-bottom: 0;
}

.BC-Page__RecommendationWidgetManagement
  .BC-Filters
  .BC-Filters-ConnectedFilterControl__RightContainer
  .search {
  flex: 2 1 auto;
}

.BC-Page__RecommendationWidgetManagement
  .BC-Filters
  .BC-Filters-ConnectedFilterControl__RightContainer
  .filter {
  border-right: var(--p-border-divider);
}

.BC-Page__RecommendationWidgetManagement .BC-Filters .BC-Filters__TagsContainer,
.BC-Page__RecommendationWidgetManagement .BC-Filters .BC-Filters__Warning {
  padding: 1rem 1rem 0;
}

.BC-Management-Widget table {
  table-layout: fixed;
}

.BC-Management-Widget .Polaris-Card__Section:first-child {
  padding: 16px;
}

.BC-Popover__Recommendation-Filters-Options {
  width: 276px;
}

.BC-Management-Widget .BC-Filters__Warning .Polaris-InlineError .Polaris-InlineError__Icon {
  display: block;
}

.recommendation-actions-dashboard {
  width: 100%;
  margin-left: auto;
}

.BC-Page__RecommendationWidgetManagement
  .Polaris-Page
  .Polaris-PageActions
  .Polaris-Stack
  .Polaris-Stack__Item {
  margin-top: 24px;
}

.BC-Management-Widget .no-widget-recommendation {
  background-color: #fafbfb;
  height: 112px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #6d7175;
}

.recommendation-widget-table {
  margin-bottom: 1rem;
}

.recommendation-widget-table .page-type {
  display: flex;
  padding: 1rem 0;
  cursor: pointer;
}

.recommendation-widget-table.not-active .page-type-collapse-icon .Polaris-Icon {
  transform: rotate(90deg);
}

.recommendation-widget-table .page-type-title {
  font-weight: 600;
  display: flex;
}

.recommendation-widget-table .page-type-title .Polaris-Icon {
  margin: 0 0.5rem 0 0.25rem;
}

.recommendation-widget-table .Polaris-DataTable__Cell--actions div {
  display: flex;
  justify-content: space-around;
}

.recommendation-widget-table thead {
  background: var(--surface-subdued, #fafbfb);
}

.recommendation-widget-table thead tr td {
  border-top: 1px solid var(--border-divider, #e1e3e5);
  border-bottom: 1px solid var(--border-divider, #e1e3e5);
}

.recommendation-widget-table thead tr td:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-left: 1px solid var(--border-divider, #e1e3e5);
}

.recommendation-widget-table thead tr td:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-right: 1px solid var(--border-divider, #e1e3e5);
}

.recommendation-widget-table table tr td.Polaris-DataTable__Cell--actions {
  padding-left: 0;
  padding-right: 0;
}

.recommendation-widget-table .btn-launch button {
  margin-left: 0.75rem;
  color: var(--p-action-primary);
  border-color: var(--p-action-primary);
}

.recommendation-widget-table .btn-launch button:hover {
  border-color: var(--p-action-primary);
}

.recommendation-widget-table .group_btn button svg {
  fill: var(--p-icon);
}

.recommendation-widget-table .recommendation-collapse .Polaris-DataTable__Cell--name .Polaris-Link {
  word-break: break-word;
}

.BC-Management-Widget .Polaris-DataTable__Table .Polaris-DataTable__Cell--type .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  margin-right: 5px;
  height: 1.2rem;
  width: 1rem;
}

.Polaris-DataTable__Cell--name button,
.Polaris-DataTable__Cell--displayOn p,
.Polaris-DataTable__Cell--type p {
  white-space: break-spaces;
  word-wrap: break-word;
}

.Polaris-DataTable__Cell--displayOn p {
  text-align: center;
}

.recommendation-translation {
  display: flex;
}

.list-widgets {
  position: relative;
}

.list-widgets .overlay-actions {
  position: absolute;
  width: 16%;
  right: 12px;
  height: 47%;
  border-radius: 8px;
}

.list-widgets .widget-by-type {
  width: 97.5%;
  height: 47%;
  left: 12px;
  top: 12px;
  border-radius: 8px;
  position: absolute;
}

.recommendationAddonLockBanner .image img,
.recommendationAddonLockBanner .image {
  max-height: 112px;
  max-width: 240px;
  width: 100%;
}

.recommendationAddonLockBanner .pfs-banner-detail {
  gap: unset;
  justify-content: space-between;
}

/* recommendation-widget-tour */
.widgets-tour {
  border-radius: 8px;
  box-shadow:
    0px 26px 80px 0px rgba(0, 0, 0, 0.2),
    0px 0px 1px 0px rgba(0, 0, 0, 0.2);
}

.widgets-tour .actions-tour {
  margin-top: 8px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media only screen and (max-height: 800px) and (max-width: 1440px) {
  .product-tour-step0 {
    top: -13% !important;
    left: -30% !important;
  }
}

@media only screen and (max-height: 785px) {
  .product-tour-step0 {
    top: -17% !important;
  }
}

@media only screen and (max-height: 630px) {
  .product-tour-step0 {
    top: -14% !important;
  }
}

@media only screen and (max-width: 1014px) {
  .product-tour-step0 {
    left: -25% !important;
  }
}

@media only screen and (max-width: 820px) {
  .product-tour-step0 {
    left: -17%;
  }
}

.widgets-tour .actions-tour .count {
  color: #6d7175;
}

.widgets-tour .actions-tour .actions {
  display: flex;
  gap: 14px;
}

.widgets-tour .heading-tour {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* end tour */

.recommendation-translation .not-active .page-type-collapse-icon .Polaris-Icon {
  transform: rotate(90deg);
}

.recommendation-translation .recommendation-translation-collapse {
  display: flex;
  cursor: pointer;
  height: 30px;
  font-weight: 550;
}

.BC-Page__RecommendationWidgetItem .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {
  justify-content: flex-end;
}

.BC-Page__RecommendationWidgetItem .general-items .recommendation-type--select {
  display: flex;
}

.BC-Page__RecommendationWidgetItem .general-items .recommendation-type--select .Polaris-Choice {
  padding-top: 2px;
}

.BC-Page__RecommendationWidgetItem .general-items .Polaris-Heading {
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
}

.BC-Page__RecommendationWidgetItem .general-items .button-large .Polaris-Button {
  padding: 12px 16px 14px;
}

.BC-Page__RecommendationWidgetItem .not-plus-on-checkout-page img {
  width: 160px;
  max-width: 160px;
  height: auto;
}

.BC-Page__RecommendationWidgetItem .not-plus-on-checkout-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 70px 32px;
}

.BC-Page__RecommendationWidgetItem .not-plus-on-checkout-page .content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  align-items: center;
}

.BC-Page__RecommendationWidgetItem .not-plus-on-checkout-page .content > p:first-child {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #202223;
}

.BC-Page__RecommendationWidgetItem .not-plus-on-checkout-page .content > p:last-child {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #6d7175;
}

.BC-Page__RecommendationWidgetItem
  .general-items
  .button-large
  .Polaris-Button__Text
  .btn-title-content {
  font-size: var(--p-font-size-5);
  line-height: 1.5rem;
  font-weight: 600;
}

.BC-Page__RecommendationWidgetItem .general-items .btn-title-type {
  display: flex;
  align-items: center;
  gap: 5px !important;
}

.BC-Page__RecommendationWidgetItem .general-items .btn-title-type .btn-title-content {
  font-size: 20px !important;
  line-height: 28px !important;
}

.BC-Page__RecommendationWidgetItem .general-items .button-large .Polaris-Button:hover,
.BC-Page__RecommendationWidgetItem .general-items .button-large.isSelected .Polaris-Button {
  border: 1px solid var(--interactive-hovered, #1f5199);
  background: var(--surface-selected-pressed, #e5effd);
}

.BC-Page__RecommendationWidgetItem .general-items .button-large .Polaris-Button__Text .btn-content {
  font-weight: var(--p-font-weight-regular);
  line-height: 1.25rem;
}

.BC-Page__RecommendationWidgetItem
  .general-items
  .button-large
  .Polaris-Button__Text
  .btn-content
  .Polaris-TextStyle--variationSubdued {
  color: #202223;
}

.widget-page-type .button-large .Polaris-Button {
  padding: 12px 4px 14px !important;
}

.BC-Page__RecommendationNewWidgetItem .page-items .widget-page-type {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.BC-Page__RecommendationNewWidgetItem .page-items .widget-page-type > div {
  width: calc(20% - 12px);
}

.BC-Page__RecommendationNewWidgetItem .page-items .Polaris-Button {
  border: 1px solid transparent;
  box-shadow: none;
  background: #fafbfb;
}

.BC-Page__RecommendationNewWidgetItem .page-items .btn-title .btn-title-icon .Polaris-Icon {
  width: 2.75rem;
  height: 2.75rem;
  padding: 0.75rem;
  border-radius: 44px;
  margin-bottom: 0.75rem;
  background: var(--surface-selected-pressed, #e5effd);
}

.BC-Page__RecommendationNewWidgetItem
  .page-items
  .Polaris-Button:hover
  .btn-title
  .btn-title-icon
  .Polaris-Icon,
.BC-Page__RecommendationNewWidgetItem
  .page-items
  .isSelected
  .Polaris-Button
  .btn-title
  .btn-title-icon
  .Polaris-Icon {
  background: var(--icon-interactive, #2c6ecb);
}

.BC-Page__RecommendationNewWidgetItem .page-items .btn-title .btn-title-icon .Polaris-Icon svg {
  fill: var(--icon-interactive, #2c6ecb);
}

.BC-Page__RecommendationNewWidgetItem
  .page-items
  .Polaris-Button:hover
  .btn-title
  .btn-title-icon
  .Polaris-Icon
  svg,
.BC-Page__RecommendationNewWidgetItem
  .page-items
  .isSelected
  .Polaris-Button
  .btn-title
  .btn-title-icon
  .Polaris-Icon
  svg {
  fill: var(--p-background, #f6f6f7);
}

.BC-Page__RecommendationWidgetItem .type-items .Polaris-Grid-Cell > div {
  height: 100%;
}

.BC-Page__RecommendationWidgetItem .type-items .Polaris-Button {
  height: 100%;
  align-items: flex-start;
  border: 1px solid transparent;
  background: #fafbfb;
  box-shadow: none;
}

.BC-Page__RecommendationWidgetItem .type-items .Polaris-Button:hover,
.BC-Page__RecommendationWidgetItem .type-items .isSelected .Polaris-Button {
  border: 1px solid var(--border-subdued, #c9cccf);
}

.BC-Page__RecommendationNewWidgetItem .type-items .Polaris-Button__Text {
  text-align: left;
}

.BC-Page__RecommendationNewWidgetItem .type-items .Polaris-Button__Text .btn-title,
.BC-Page__RecommendationWidgetItem .widget-based-section .Polaris-Button__Text .btn-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0.25rem;
}

.BC-Page__RecommendationNewWidgetItem
  .type-items
  .Polaris-Button.Polaris-Button--disabled
  .btn-content
  .Polaris-TextStyle--variationSubdued {
  color: #6d7175;
}

.BC-Page__RecommendationNewWidgetItem .type-items .decorative .Polaris-Badge {
  background: var(--surface-warning-subdued-pressed, #ffebd3);
}

.BC-Page__RecommendationNewWidgetItem .type-items .decorative .Polaris-Icon {
  width: unset;
}

.BC-Page__RecommendationNewWidgetItem .type-items .decorative .Polaris-Badge .badge-with-icon {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.BC-Page__RecommendationNewWidgetItem
  .type-items
  .decorative
  .Polaris-Badge
  .badge-with-icon
  .Polaris-Icon,
.BC-Page__RecommendationWidgetItem
  .widget-based-section
  .Polaris-Button__Text
  .btn-title-icon
  .Polaris-Icon {
  width: 1rem;
  height: 1rem;
  margin-right: 0.25rem;
}

.BC-Page__RecommendationNewWidgetItem .type-items .decorative,
.BC-Page__RecommendationNewWidgetItem .type-items .btn-title-icon {
  margin-left: 6px;
}

.BC-Page__RecommendationNewWidgetItem .type-items .disabled .Polaris-Button__Text .btn-title,
.BC-Page__RecommendationNewWidgetItem
  .type-items
  .disabled
  .Polaris-Button__Text
  .btn-content
  .Polaris-TextStyle--variationSubdued {
  color: #8c9196;
}

.BC-Page__RecommendationNewWidgetItem .type-items .disabled .decorative .Polaris-Badge {
  background: #fdf3e7;
}

.BC-Page__RecommendationNewWidgetItem .type-items .disabled .decorative .badge-with-icon {
  color: #8d8e8f;
}

.BC-Page__RecommendationNewWidgetItem .type-items .disabled .decorative svg rect {
  fill: rgb(205, 113, 92);
}

.BC-Page__RecommendationNewWidgetItem .type-items .disabled .decorative svg path {
  fill: #c6117c8a;
}

.BC-Page__RecommendationNewWidgetItem .type-items .disabled .decorative .Polaris-Icon {
  width: unset;
}

.BC-Page__RecommendationNewWidgetItem .type-items .disabled .btn-title-icon svg rect {
  fill: #cff1f7;
}

.BC-Page__RecommendationNewWidgetItem .type-items .disabled .btn-title-icon svg path {
  fill: #7dcdd3;
}

.BC-Page__RecommendationNewWidgetItem .btn-inline--recommendation-lock {
  margin-top: 5px;
  margin-left: 28px;
  color: #2c6ecb;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  gap: 4px;
  align-items: center;
  line-height: 20px;
}

.BC-Page__RecommendationNewWidgetItem .btn-inline--recommendation-lock .img-crown {
  padding: 2px 4px 2px 4px;
  border-radius: 4px 0px 0px 0px;
  background: rgba(255, 242, 217, 1);
  max-width: 22px;
  height: 18px;
  display: flex;
  align-items: center;
}

.BC-Page__RecommendationNewWidgetItem .btn-inline--recommendation-lock .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  align-items: center;
  margin: unset;
}

.BC-Page__RecommendationNewWidgetItem .btn-inline--recommendation-lock .Polaris-Icon svg {
  fill: var(--p-interactive);
}

.BC-Page__RecommendationNewWidgetItem .type-items .Polaris-Button__Text .btn-title .Polaris-Badge {
  margin-left: 4px;
}

.BC-Page__RecommendationNewWidgetItem
  .type-items
  .Polaris-Button__Text
  .btn-title
  .Polaris-Badge--statusInfo {
  background: #e0f0ff;
  color: #00527c;
  flex-shrink: 0;
}

.BC-Page__RecommendationWidgetItem .Polaris-Card__Section a .Polaris-Icon,
.BC-Page__RecommendationWidgetItem button.Polaris-Link .Polaris-Icon {
  display: inline-block;
}

.BC-Page__RecommendationWidgetItem .Polaris-Card__Section a .Polaris-Icon .Polaris-Icon__Svg,
.BC-Page__RecommendationWidgetItem button.Polaris-Link .Polaris-Icon .Polaris-Icon__Svg {
  margin-top: 4px;
}

.BC-Page__RecommendationWidgetItem .setup-content .setup-content-title {
  position: relative;
  padding-bottom: 1.25rem;
}

.BC-Page__RecommendationWidgetItem .setup-content .setup-content-title .help-doc {
  position: absolute;
  top: 0;
  right: 0;
}

.BC-Page__RecommendationWidgetItem .setup-content .setup-content-title .help-doc-content {
  display: inline-flex;
}

.BC-Page__RecommendationWidgetItem .setup-content .setup-content-title .sub-title {
  margin-top: 0.75rem;
}

.BC-Page__RecommendationWidgetItem .setup-content .setup-content-title .sub-title > * {
  margin-right: 0.5rem;
}

.BC-Page__RecommendationWidgetItem .setup-content .setup-cart-drawer-step {
  list-style-type: disc;
  padding-left: 1.25rem;
  margin-top: 4px;
}

.BC-Page__RecommendationWidgetItem .setup-content .setup-cart-drawer-step svg {
  fill: #5c5f62;
  width: 15px;
  height: 16px;
}

.BC-Page__RecommendationWidgetItem .widget-based-section .button-large .Polaris-Button {
  align-items: baseline;
  min-height: 110px;
  background: var(--surface-default, #fff);
}

.BC-Page__RecommendationWidgetItem .widget-based-section .button-large .Polaris-Button:hover,
.BC-Page__RecommendationWidgetItem .widget-based-section .isSelected .Polaris-Button {
  border: 1px solid var(--icon-interactive, #2c6ecb);
  background: var(--surface-selected-pressed, #e5effd);
}

.BC-Page__RecommendationWidgetItem
  .widget-based-section
  .button-large
  .Polaris-Button__Text
  .btn-title {
  justify-content: center;
}

.BC-Page__RecommendationWidgetItem
  .widget-based-section
  .button-large
  .Polaris-Button__Text
  .btn-content {
  padding: 0 2.5rem;
}

.BC-Page__RecommendationWidgetItem .widget-details-block {
  border-radius: 8px;
  border: 1px solid var(--border-divider, #e1e3e5);
  padding: 1.25rem;
}

.BC-Page__RecommendationWidgetItem .widget-details-block .field-title {
  font-size: var(--p-font-size-5);
  font-weight: 600;
  line-height: 24px;
}

.BC-Page__RecommendationWidgetItem .widget-details-block .field-helper {
  font-size: var(--p-font-size-3);
  line-height: 20px;
  margin-bottom: 0.5rem;
}

.BC-Page__RecommendationWidgetItem
  .widget-based-section
  .widget-details-block
  .ai-base-algorithm
  > *:not(:first-child) {
  margin-top: 1.5rem;
}

.BC-Page__RecommendationWidgetItem .setup-content .extra-fields .BC-Draggable__Container {
  margin-top: 1rem;
  margin-left: 1rem;
}

.BC-Page__RecommendationWidgetItem .setup-content .extra-fields .BC-Draggable__Container > div {
  background-color: #ffffff;
}

.BC-Page__RecommendationWidgetItem
  .setup-content
  .extra-fields
  .Polaris-ChoiceList__Choices
  li:not(:first-child) {
  margin-top: 8px;
  /* make the margin between choice smaller - Design */
}

.BC-Page__RecommendationWidgetItem
  .setup-content
  .extra-fields
  .Polaris-ChoiceList__Choices
  li:not(:first-child) {
  margin-top: 0.75rem;
  /* make the margin between choice smaller - Design */
}

.BC-Page__RecommendationWidgetItem .extra-fields .rule-based-item {
  display: flex;
  margin-bottom: 1rem;
}

.BC-Page__RecommendationWidgetItem .extra-fields .rule-based-item .rule-based-item_draggable {
  margin-right: 1rem;
}

.BC-Page__RecommendationWidgetItem .extra-fields .rule-based-item .rule-based-item_details {
  flex: 1 1 auto;
}

.BC-Page__RecommendationWidgetItem
  .extra-fields
  .rule-based-item
  .rule-based-item_details
  .rule-based-item_groupFields {
  margin-top: 0.75rem;
  margin-left: 3.265rem;
  margin-right: 0.25rem;
}

.BC-Page__RecommendationWidgetItem
  .extra-fields
  .rule-based-item
  .rule-based-item_details
  .rule-based-item_field {
  margin-top: 0.75rem;
}

.BC-Page__RecommendationWidgetItem
  .extra-fields
  .rule-based-item
  .rule-based-item_details
  .rule-based-item_subField {
  margin-top: 0.75rem;
  margin-left: 1rem;
}

.BC-Page__RecommendationWidgetItem
  .extra-fields
  .rule-based-item
  .rule-based-item_details
  .rule-based-item_filterRow {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  margin-top: 0.75rem;
}

.BC-Page__RecommendationWidgetItem
  .extra-fields
  .rule-based-item
  .rule-based-item_details
  .rule-based-item_filterRow
  > *:first-child {
  flex: 0 0 240px;
  min-width: 0;
}

.BC-Page__RecommendationWidgetItem
  .extra-fields
  .rule-based-item
  .rule-based-item_details
  .rule-based-item_filterRow
  > *:last-child {
  flex: 1 1 auto;
  min-width: 0;
}

.BC-Page__RecommendationWidgetItem
  .extra-fields
  .rule-based-item
  .rule-based-item_details
  .rule-based-item_filterRow
  .Polaris-Popover__Anchor {
  display: block;
  width: 100%;
}

.BC-Page__RecommendationWidgetItem
  .setup-content
  .extra-fields
  .rule-based-item_filterRow
  .BC-Draggable__Container {
  margin-top: 2px;
  margin-left: 0;
}

.BC-Page__RecommendationWidgetItem
  .setup-content
  .extra-fields
  .rule-based-item_filterRow
  .Polaris-Tag.BC-Draggable__Tag {
  margin-right: 8px;
}

.BC-Page__RecommendationWidgetItem .extra-fields .rule-based-item .note {
  margin-top: 0.25rem;
}

.BC-Page__RecommendationWidgetItem .extra-fields .ai-based-primary-algorithm-helper-text {
  margin-top: 5px;
}

.BC-Page__RecommendationWidgetItem .setup-content .tab-content {
  padding-top: 1.25rem;
}

.BC-Page__RecommendationWidgetItem .setup-content .tab-content .tab-content-title {
  padding-bottom: 1.25rem;
}

.BC-Page__RecommendationWidgetItem .setup-content .tab-content .tab-content-content > div {
  margin-bottom: 1rem;
}

.BC-Page__RecommendationWidgetItem .setup-content .tab-content .tab-content-content .action {
  margin-top: 1rem;
  margin-bottom: 0.75rem;
}

.BC-Page__RecommendationWidgetItem
  .setup-content
  .tab-content
  .tab-content-content
  .action
  .non-action {
  display: inline-flex;
}

.BC-Page__RecommendationWidgetItem
  .setup-content
  .tab-content
  .tab-content-content
  .action
  .non-action
  .Polaris-Icon {
  margin-right: 0.5rem;
}

.BC-Page__RecommendationWidgetItem .widget-rule-group {
  border-radius: 8px;
  border: 1px solid var(--border-divider, #e1e3e5);
  background: var(--surface-default, #fff);
  margin-bottom: 0.75rem;
}

.BC-Page__RecommendationWidgetItem .widget-rule-group .rule-group-title {
  display: flex;
  padding: 12px;
  padding-left: 16px;
  justify-content: space-between;
  align-items: center;
}

.BC-Page__RecommendationWidgetItem .widget-rule-group .rule-group-title.active {
  border-bottom: 1px dashed #e1e3e5;
}

.BC-Page__RecommendationWidgetItem .widget-rule-group .rule-group-title .title {
  color: var(--text-subdued, #6d7175);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}

.BC-Page__RecommendationWidgetItem .widget-rule-group .rule-group-title .title .number {
  border-radius: 4px;
  border: 1px solid var(--border-subdued, #c9cccf);
  font-size: 12px;
  padding: 2px 6px;
  display: flex;
  align-items: center;
  max-height: 20px;
}

.BC-Page__RecommendationWidgetItem
  .widget-rule-group
  .action
  .Polaris-Button--plain.Polaris-Button--iconOnly
  svg {
  fill: var(--p-icon-subdued);
}

.BC-Page__RecommendationWidgetItem
  .widget-rule-group
  .action
  .Polaris-Button--plain.Polaris-Button--iconOnly:hover
  svg {
  fill: var(--p-icon-hovered);
}

.BC-Page__RecommendationWidgetItem .widget-rule-group .rule-group-block {
  border-radius: 6px;
  margin: 1rem;
  padding: 0.75rem;
  background: var(--background-default, #f6f6f7);
}

.BC-Page__RecommendationWidgetItem .rule-group-block .field-title {
  font-size: var(--p-font-size-3);
  font-weight: 600;
  line-height: 20px;
}

.BC-Page__RecommendationWidgetItem .rule-group-block .field-helper {
  font-size: var(--p-font-size-3);
  line-height: 20px;
  margin-bottom: 0.5rem;
  color: var(--text-subdued, #6d7175);
}

.BC-Page__RecommendationWidgetItem .widgetItem-rule-attributes {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.BC-Page__RecommendationWidgetItem .widgetItem-rule-attributes > div {
  padding-left: 4px;
}

.BC-Page__RecommendationWidgetItem .widgetItem-rule-attributes .add-action p {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #2c6ecb;
  font-weight: 500;
}

.BC-Page__RecommendationWidgetItem .rule-group-block .field-array-content {
  display: flex;
  gap: 12px;
}

.BC-Page__RecommendationWidgetItem
  .rule-group-block
  .field-array-content
  .Polaris-Popover__PopoverOverlay {
  width: 659px !important;
}

.BC-Page__RecommendationWidgetItem .rule-group-block .field-array-content .action {
  margin-top: 9px;
}

.BC-Page__RecommendationWidgetItem .rule-group-block .field-array-content .connect-right {
  margin-right: 12px;
  margin-top: 9px;
}

.BC-Page__RecommendationWidgetItem .rule-group-block .field-array-content .main {
  width: 100%;
}

.BC-Page__RecommendationWidgetItem .rule-group-block .field-array-content .main .header {
  display: flex;
  gap: 12px;
  width: 100%;
}

.BC-Page__RecommendationWidgetItem
  .rule-group-block
  .field-array-content
  .main
  .header
  > :first-child {
  width: 32%;
  min-width: 240px;
}

.BC-Page__RecommendationWidgetItem
  .rule-group-block
  .field-array-content
  .main
  .header
  > :nth-child(2) {
  width: 16%;
}

.BC-Page__RecommendationWidgetItem
  .rule-group-block
  .field-array-content
  .main
  .header
  > :last-child {
  width: 100%;
}

.BC-Page__RecommendationWidgetItem
  .rule-group-block
  .field-array-content
  .main
  .header
  .Polaris-TextField__Input:focus
  ~ .Polaris-TextField__Backdrop::after {
  box-shadow: none;
}

.BC-Page__RecommendationWidgetItem
  .rule-group-block
  .field-array-content
  .reviews-io-warning-block {
  background-color: #fff5ea;
  border: 1px solid #e1b878;
  padding: 8px 12px;
  border-radius: 4px;
  margin-top: 6px;
}

.BC-Page__RecommendationWidgetItem .field-array-content .reviews-io-warning-block .Polaris-Icon {
  padding: 2px;
}

.BC-Page__RecommendationWidgetItem .rule-group-block .Polaris-Badge {
  min-width: 45px;
  justify-content: center;
  font-weight: 500;
}

.BC-Page__RecommendationWidgetItem .rule-group-block .Polaris-Badge--statusWarning {
  background: #ffea8a;
}

.BC-Page__RecommendationWidgetItem .rule-group-block .Polaris-Badge--statusInfo {
  background: #e0f0ff;
  color: #00527c;
}

.BC-Page__RecommendationWidgetItem .rule-group-block .Polaris-Badge--statusNew {
  color: #616161;
}

.BC-Page__RecommendationWidgetItem .rule-group-block .content-list {
  padding: 0;
  border-radius: 8px;
  border: 1px dashed var(--border-divider, #e1e3e5);
  background: var(--surface-default, #fff);
}

.BC-Page__RecommendationWidgetItem .rule-group-block .product-list {
  list-style-type: none;
  margin: 0.75rem 0 0;
}

.BC-Page__RecommendationWidgetItem .rule-group-list {
  margin: unset;
  padding: unset;
  list-style-type: none;
}

.BC-Page__RecommendationWidgetItem .rule-group-block .product-list.consequence-list {
  margin: 0.5rem 0 0;
}

.BC-Page__RecommendationWidgetItem .rule-group-block .product-list .product-item {
  padding: 0.5rem 1rem;
  background: var(--surface-default, #fff);
  /* Divider/Bottom */
  box-shadow: 0px -1px 0px 0px #e1e3e5 inset;
}

.BC-Page__RecommendationWidgetItem .rule-group-block .product-list .product-item:last-child {
  /* Divider/Bottom */
  box-shadow: none;
}

.BC-Page__RecommendationWidgetItem
  .rule-group-block
  .product-list.condition-list
  .product-item
  .Polaris-Stack__Item:nth-child(2),
.BC-Page__RecommendationWidgetItem
  .rule-group-block
  .product-list.consequence-list
  .product-item
  .Polaris-Stack__Item:nth-child(3) {
  padding: 0.5rem 1rem;
  flex: 1 1;
}

.BC-Page__RecommendationWidgetItem .rule-group-block .collection-list {
  padding: 0.75rem 0.75rem 0.25rem;
  margin: 0.75rem 0 0;
}

.BC-Page__RecommendationWidgetItem .rule-group-block .collection-list .BC-Custom__Tag {
  margin: 0 0.75rem 0.5rem 0;
  height: 1.5rem;
  min-height: 1.5rem;
  line-height: var(--p-line-height-1);
}

.BC-Page__SelectProductModal .list-available {
  padding: 0;
  list-style-type: none;
}

.BC-Page__SelectProductModal .list-available .Polaris-SkeletonDisplayText__DisplayText {
  max-width: 100%;
}

.BC-Page__SelectProductModal .list-available li {
  margin-bottom: 0.75rem;
}

.BC-Page__SelectProductModal .list-available li:last-child {
  margin-bottom: 0;
}

.BC-Page__SelectProductModal .list-available .BC-ProductItem .BC-ProductItem__Checkbox {
  display: flex;
  position: relative;
  top: 1px;
}

.BC-Page__SelectProductModal
  .list-available
  .BC-ProductItem
  .BC-ProductItem__Checkbox
  .Polaris-Choice__Control {
  margin-right: 0;
}

.BC-Page__SelectProductModal .list-available .BC-ProductItem .Polaris-Stack__Item:nth-child(3) {
  flex: 1;
}

.ProductModal__Variants-Options li {
  display: flex;
  justify-content: space-between;
}

.ProductModal__Variants-Options .list-available {
  padding-right: 10px;
}

.ProductModal__Variants-Options .list-available .variant {
  padding-left: 28px;
  margin-bottom: 12px;
}

.ProductModal__Variants-Options .list-available .variant li {
  padding: 10px 0;
}

.ProductModal__Variants-Options .list-available .variant .BC-ProductItem__Checkbox {
  display: flex;
  position: relative;
  top: 1px;
}

.ProductModal__Variants-Options .list-available .BC-ProductItem__Checkbox .Polaris-Choice__Control {
  margin-right: 0;
}

.BC-SelectedProductsField .product-list .product-item {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 8px;
}

.BC-SelectedProductsField .product-list .product-item .product-item__Thumbnail {
  display: flex;
  align-items: center;
  gap: 6px;
}

.BC-Widget-Editor-Page .range-slider-input .Polaris-Connected {
  width: 100%;
}

.BC-Widget-Editor-Page .range-slider-input .Polaris-Connected > div:first-child {
  width: 77%;
}

.BC-Widget-Editor-Page .range-slider-input .Polaris-Connected > div:last-child {
  width: 23%;
}

.BC-Widget-Editor-Page .range-slider-input .Polaris-Connected > div:last-child input {
  text-align: center;
  font-weight: 700;
}

.BC-Widget-Editor-Page .selectedColor {
  z-index: 417;
  width: 25px;
  height: 25px;
  margin-right: 0;
  border: 1px solid #c4cdd5;
  border-radius: 3px;
  margin-left: 0.75rem;
}

.BC-Widget-Editor-Page .selectedColor:hover {
  cursor: pointer;
}

.widget-visual-editor .visual-editor-body {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.widget-visual-editor .visual-editor-body .visual-editor-settings {
  isolation: isolate;
  width: 300px;
  height: calc(100vh - 61px);
  background: #ffffff;
  border-right: 1px solid #e1e3e5;
  border-left: 1px solid #e1e3e5;
  overflow-y: auto;
}

.widget-visual-editor .visual-editor-body .visual-editor-settings .card-section {
  box-shadow: inset 0px -1px 0px #e1e3e5;
  padding: 16px 20px;
  margin: 0;
}

.widget-visual-editor
  .visual-editor-body
  .visual-editor-settings
  .card-section
  .widget-layout-settings
  .Polaris-Banner {
  padding: 12px;
}

.widget-visual-editor .visual-editor-body .visual-editor-settings .card-section:last-child {
  box-shadow: unset;
}

.widget-visual-editor
  .visual-editor-body
  .visual-editor-settings
  .card-section
  .title-line
  .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  margin-right: 0.5rem;
  border-radius: 4px;
  border: 1px solid var(--border-subdued, #c9cccf);
}

.widget-visual-editor .visual-editor-body .visual-editor-settings .card-section .sub-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.widget-visual-editor .visual-editor-body .visual-editor-settings .card-section .sub-title > * {
  margin-right: 0.5rem;
  display: inline;
}

.widget-visual-editor .visual-editor-body .visual-editor-settings .widget-id {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.widget-visual-editor .visual-editor-body .visual-editor-settings .edit-sections {
  margin-top: 1rem;
}

.widget-visual-editor .visual-editor-body .visual-editor-settings .btn-section {
  margin-bottom: 0.5rem;
  margin-left: -20px;
  margin-right: -20px;
}

.widget-visual-editor .edit-sections .btn-section .Polaris-Button {
  padding-left: 20px;
}

.widget-visual-editor .edit-sections .btn-section .Polaris-Button,
.widget-visual-editor .edit-sections .btn-section .Polaris-Button__Text {
  text-decoration: none;
}

.widget-visual-editor .edit-sections .Polaris-Button .Polaris-Icon {
  color: var(--p-icon, #5c5f62);
}

.widget-visual-editor .edit-sections .active .Polaris-Button {
  background: var(--surface-primary-selected, #f1f8f5);
}

.widget-visual-editor .edit-sections .active .Polaris-Button .Polaris-Icon,
.widget-visual-editor .edit-sections .active .Polaris-Button .Polaris-Button__Text {
  color: var(--p-action-primary, #008060);
}

.widget-visual-editor .visual-editor-body .visual-editor-settings .card-section p {
  color: #6d7175;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  margin-top: 2px;
  margin-bottom: 1px;
}

.external-link {
  display: -webkit-inline-flex;
  display: inline-flex;
  vertical-align: top;
}

.external-link .Polaris-Button__Content .Polaris-Button__Icon .Polaris-Icon svg {
  fill: var(--p-interactive) !important;
  width: 20px;
  height: auto;
}

.title-bold-normal {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  padding: 20px 20px !important;
}

.widget-title-settings .default-settings-widget {
  padding-top: 12px;
  color: #6d7175;
}

.widget-visual-editor .visual-editor-body .visual-editor-preview-wrapper {
  width: calc(100% - 600px);
}

.widget-visual-editor .visual-editor-body .cart-drawer-preview-container {
  height: calc(100% - 105px);
}

.widget-visual-editor .visual-editor-preview-header {
  box-shadow: inset 0px -1px 0px #e1e3e5;
  background: #ffffff;
  padding: 11px;
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.widget-visual-editor .visual-editor-preview-header div p {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}

.widget-visual-editor .visual-editor-preview-header .select-theme-preview {
  display: inline-block;
  width: 80%;
}

.widget-visual-editor .visual-editor-preview-header .theme-preview {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  gap: 10px;
  width: 35%;
  align-items: center;
}

.widget-visual-editor .visual-editor-preview-header .theme-preview .theme-preview-label {
  padding-right: 20px;
}

.widget-visual-editor .visual-editor-preview-header .theme-preview .theme-preview-label span {
  margin-top: 10px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}

.widget-visual-editor .visual-editor-preview {
  margin: 2rem 22px;
  text-align: left;
  /* display: flex;
  justify-content: center;
  position: sticky;
  top: 15%; */
}

.widget-visual-grid .visual-editor-preview {
  width: 60%;
  min-width: 444px;
  margin: 2rem auto;
}

.widget-visual-grid .visual-editor-preview .recommendation-note {
  display: flex;
  justify-content: center;
  gap: 3px;
  color: #6d7175;
}

.widget-visual-editor .visual-editor-body .recommendation-bundle,
.widget-visual-editor .visual-editor-body .recommendation-carousel,
.widget-visual-editor .visual-editor-body .recommendation-bundle-body {
  width: 100%;
  margin: auto;
}

.widget-visual-editor .visual-editor-body .recommendation-title,
.widget-visual-editor .visual-editor-body .recommendation-title-left {
  margin: 40px 0;
  display: flex;
}

.widget-visual-editor .visual-editor-body .checkout-preview .recommendation-title {
  margin-top: 0;
  margin-bottom: 16px;
}

.widget-visual-editor .visual-editor-body .checkout-preview {
  padding: 38px;
}

.widget-visual-editor .visual-editor-body .checkout-preview .recommendation-title-left {
  margin-top: 0;
  margin-bottom: 16px;
}

.widget-visual-editor .visual-editor-body .checkout-preview .recommendation-title-text {
  font-weight: 500;
  font-size: medium;
}

.widget-visual-editor .visual-editor-body .recommendation-title-left::before {
  width: 3%;
  position: relative;
  border-top: 1px solid #d2d5d8;
  transform: translateY(50%);
  content: '';
}

.widget-visual-editor .visual-editor-body .recommendation-title-left::after {
  width: 97%;
  position: relative;
  border-top: 1px solid #d2d5d8;
  transform: translateY(50%);
  content: '';
}

.widget-visual-editor .visual-editor-body .recommendation-title::before {
  width: 50%;
  position: relative;
  border-top: 1px solid #d2d5d8;
  transform: translateY(50%);
  content: '';
}

.widget-visual-editor .visual-editor-body .recommendation-title::after {
  width: 50%;
  position: relative;
  border-top: 1px solid #d2d5d8;
  transform: translateY(50%);
  content: '';
}

.widget-visual-editor .visual-editor-body .recommendation-title-text {
  padding: 0 48px;
  flex: 0 0 auto;
  text-align: center;
  word-break: break-word;
  line-height: 1.2;
}

.widget-visual-editor .visual-editor-body .recommendation-title-text-left {
  padding: 0 48px 0 0;
  flex: 0 0 auto;
  text-align: left;
  word-break: break-word;
  line-height: 1.2;
  font-weight: 500;
}

.widget-visual-editor .visual-editor-body .product-items {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.widget-visual-editor .visual-editor-body .product-items .product-image-wrapper {
  outline: none;
  position: relative;
  display: block;
  margin: 0 0 0 8px;
  min-width: calc(100% / 5 - 5px);
  word-break: break-word;
  line-height: 1.2;
  /* display: flex;
  justify-content: center;
  flex-direction: column; */
}

.widget-visual-editor .visual-editor-body .product-items .product-images {
  display: flex;
  width: 100%;
  /* height: 100%; */
  justify-content: center;
}

.widget-visual-editor .visual-editor-body .product-items .product-image-wrapper img[alt='plus'] {
  width: 6%;
  display: flex;
}

.widget-visual-editor .visual-editor-body .product-items .product-items-wrapper {
  max-width: 100%;
  outline: none;
  position: relative;
  display: flex;
}

.widget-visual-editor .visual-editor-body .product-items .product-image-card {
  max-width: calc(100% - 100% / 5 - 5px);
  outline: none;
  position: relative;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding-bottom: 0.5rem;
}

.widget-visual-editor .visual-editor-body .product-items .product-image-card .product-image {
  max-width: calc(100%-10px);
  min-width: calc(100% - 100% / 5 - 5px);
  display: flex;
  margin: 0 8px 0 0;
  border-radius: 4px;
  overflow: hidden;
  align-items: center;
}

.widget-visual-editor
  .visual-editor-body
  .product-items
  .product-image-card
  .product-image--has-border {
  border: 1px solid #222;
}

.widget-visual-editor .visual-editor-body .product-items .product-image-card .product-image--blur {
  opacity: 0.5;
}

.widget-visual-editor .visual-editor-body .product-items .product-image-img {
  position: relative;
  display: block;
  max-width: 100%;
}

.widget-visual-editor .visual-editor-body .product-grid-items {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 16px;
}

.widget-visual-editor .visual-editor-body .product-grid-card-item {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid #e1e3e5;
  padding: 16px;
  width: 100%;
}

.widget-visual-editor .visual-editor-body .product-grid-card-item .product-image {
  width: 64px;
  height: 64px;
  min-width: 64px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e1e3e5;
  display: flex;
  background-color: #ffffff;
  justify-content: center;
}

.widget-visual-editor .visual-editor-body .product-grid-card-item .product-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.widget-visual-editor .visual-editor-body .product-grid-card-item .product-info .Polaris-Select {
  pointer-events: none;
  cursor: not-allowed;
}

.widget-visual-editor .visual-editor-body .product-grid-card-item .product-info .product-price {
  color: #1e5ea1;
  font-weight: 500;
  font-size: 12px;
}

.widget-visual-editor .visual-editor-body .product-grid-card-item .product-image img {
  width: 100%;
  height: 100%;
  max-width: 64px;
  object-fit: contain;
}

.widget-visual-editor .visual-editor-body .product-grid-card-item .product-actions button {
  border: 1px solid #dedede;
  border-radius: 8px;
  background-color: unset;
  padding: 10px 14px;
  color: #1e5ea1;
  font-weight: 700;
}

.widget-visual-editor .visual-editor-body .recommendation-bundle {
  background: #ffffff;
  border-radius: 8px;
  padding: 0px 32px 40px;
  flex-direction: column;
  display: flex;
  height: 92%;
  overflow: auto;
}

.widget-visual-editor .visual-editor-body .recommendation-bundle-body .cart {
  outline: none;
  display: block;
  position: relative;
  width: 156px;
  margin-left: 10px;
}

.widget-visual-editor .visual-editor-body .recommendation-bundle-body .total {
  width: 150px;
  margin-bottom: 10px;
  text-align: center;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #222222;
}

.widget-visual-editor .visual-editor-body .recommendation-bundle-body .total span {
  font-family: 'SF Pro Text';
  font-weight: 600;
  font-style: normal;
  font-size: 16px;
  line-height: 20px;
  color: #222222;
}

.widget-visual-editor .visual-editor-body .recommendation-bundle-body .add-to-cart {
  width: 150px;
  font-size: 16px;
  padding: 10px 10px;
  background-color: #000000;
  color: #fff;
  border: none;
  cursor: pointer;
  border-radius: 80px;
  min-width: 110px;
  max-width: 220px;
}

.widget-visual-editor .visual-editor-body .recommendation-bundle-body .item-detail-preview {
  display: block;
  margin-top: 1rem;
}

.widget-visual-editor .visual-editor-body .recommendation-bundle-body .label {
  font-family: 'SF Pro Text';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #202223;
  flex: none;
  order: 0;
  flex-grow: 0;
  word-break: break-word;
  line-height: 1.2;
}

.widget-visual-editor .visual-editor-body .recommendation-bundle-body .checkbox-container {
  display: flex;
  align-items: center;
}

.widget-visual-editor
  .visual-editor-body
  .recommendation-bundle-body
  .checkbox-container
  .Polaris-Checkbox__Backdrop::before {
  background-color: #202223;
}

.widget-visual-editor .visual-editor-body .recommendation-bundle-body .label-container {
  display: flex;
  align-items: center;
  flex: 1;
}

.widget-visual-editor .visual-editor-body .recommendation-bundle-body .label-wrapper {
  align-items: center;
  white-space: pre-wrap;
}

.widget-visual-editor .visual-editor-body .recommendation-bundle-body .details-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.widget-visual-editor .visual-editor-body .recommendation-bundle-body .item-detail-price {
  font-family: 'SF Pro Text';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #202223;
  flex: none;
}

.boost-sd__recommendation .boost-sd__recommendation-title .boost-sd__recommendation-title-text {
  line-height: 1.2;
}

.recommendation-carousel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.visual-editor-preview-wrapper
  .visual-editor-preview
  .recommendation-carousel
  .recommendation-carousel-body {
  width: 100%;
  text-align: center;
}

.visual-editor-preview-wrapper .visual-editor-preview .recommendation-note {
  padding-top: 1rem;
  padding-left: 1rem;
  text-align: left;
}

.visual-editor-preview-wrapper .visual-editor-preview .recommendation-carousel .boost-sd__dots {
  margin-bottom: 10px;
}

.visual-editor-preview-wrapper
  .visual-editor-preview
  .recommendation-carousel
  .Polaris-Button--iconOnly {
  vertical-align: middle;
}

.visual-editor-preview-wrapper .visual-editor-preview .recommendation-carousel .Polaris-Icon svg {
  fill: var(--p-interactive) !important;
  width: 20px;
  /* vertical-align: middle; */
}

.visual-editor-preview-wrapper .visual-editor-preview .recommendation-missing-template {
  margin-bottom: 16px;
}

.visual-editor-preview-wrapper
  .visual-editor-preview
  .recommendation-missing-template
  .Polaris-Banner {
  border: 0;
  background-color: #fff5ea80;
  box-shadow: none;
}

.visual-editor-preview-wrapper
  .visual-editor-preview
  .recommendation-missing-template
  .Polaris-Banner
  .Polaris-Link {
  color: #2c6ecb;
}

.code {
  font-family: Monaco;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  background: #f5f5f5;
  padding: 0.75rem 1rem;
  margin: 0.5rem 0;
  position: relative;
}

.code .Polaris-Button {
  position: absolute;
  top: 0.75rem;
  right: 1rem;
}

.code .Polaris-Button--plain.Polaris-Button--iconOnly svg,
.copy .Polaris-Button--plain.Polaris-Button--iconOnly svg {
  fill: var(--p-icon-subdued);
}

.code .Polaris-Button--plain.Polaris-Button--iconOnly:hover svg,
.copy .Polaris-Button--plain.Polaris-Button--iconOnly:hover svg {
  fill: var(--p-icon-hovered);
}

.copy button.Polaris-Button--plain.Polaris-Button--iconOnly {
  margin: 0 0 0 2px;
  padding: 0;
  min-width: auto;
  min-height: auto;
}

.copy .Polaris-Icon {
  width: 12px;
  height: 12px;
}

/* Recommendation Widget End */

/* Recommendation General Settings */
.BC-Page__RecommendationGeneralSettings .Polaris-Page {
  max-width: 936px !important;
  padding: 0;
}

.BC-Page__RecommendationGeneralSettings .general-settings-banner {
  background-color: #f7fdfc;
  width: 100%;
  min-height: 160px;
  border-radius: 8px;
  display: inline-flex;
}

.BC-Page__RecommendationGeneralSettings .general-settings-banner .banner-title {
  color: var(--Text-Default, #202223);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}

.BC-Page__RecommendationGeneralSettings .general-settings-banner .banner-content-body {
  color: var(--Text-Default, #202223);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 142.857% */
}

.BC-Page__RecommendationGeneralSettings .general-settings-banner .banner-left {
  width: calc(100% - 336px);
}

.BC-Page__RecommendationGeneralSettings .general-settings-banner .banner-left .banner-content {
  margin: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.BC-Page__RecommendationGeneralSettings .general-settings-banner .banner-left .Polaris-Button {
  border-color: #95c9b4;
  background-color: #f7fdfc;
}

.BC-Page__RecommendationGeneralSettings .general-settings-banner .banner-right {
  float: right;
}

.BC-Page__RecommendationGeneralSettings .general-settings-banner .banner-right .banner-dismiss {
  margin-top: 20px;
  margin-left: 280px;
  cursor: pointer;
}

.BC-Page__RecommendationGeneralSettings .general-settings-banner .banner-right .banner-image {
  background-image: url('https://cdn.boostcommerce.io/assets/recommendation/recommend-general-settings.png');
  background-size: 100%;
  width: 336px;
  height: 112px;
  margin-top: 8px;
}

.BC-Page__RecommendationGeneralSettings
  .Polaris-FormLayout
  .BC-Toggle-Switch
  .BC-Toggle-HelperText {
  color: #6d7175;
}

.BC-Page__RecommendationGeneralSettings .Polaris-FormLayout .BC-RecomendGeneralSetting_TextButton {
  color: #2c6ecb;
  float: right;
  cursor: pointer;
}

.BC-Page__RecommendationGeneralSettings .Polaris-FormLayout .BC-RecomendGeneralSetting_ProductList {
  margin-top: 10px;
  border: 1px solid #e1e3e5;
  border-radius: 4px;
  text-align: center;
  padding: 16px;
}

.BC-RecomendGeneralSetting_ProductList-NoProduct {
  color: #6d7175;
}

.BC-Page__RecommendationGeneralSettings .section-divider {
  margin-top: 20px;
  border-top: 1px solid #e1e3e5;
}

.BC-Page__RecommendationGeneralSettings .footer {
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
  position: relative;
  margin-bottom: 1.25rem;
}

.BC-Page__RecommendationGeneralSettings .footer .BC-Page__Button {
  position: absolute;
  top: 0;
  right: 0;
}

.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options {
  margin-top: 0.375rem;
}

.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options .list-available {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options
  .list-available
  .Polaris-SkeletonDisplayText__DisplayText {
  max-width: 100%;
}

.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options .list-available li {
  margin-bottom: 0.75rem;
}

.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options
  .list-available
  li:last-child {
  margin-bottom: 0;
}

.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options
  .list-available
  .BC-ProductItem
  .BC-ProductItem__Checkbox {
  display: flex;
  position: relative;
  top: 1px;
}

.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options
  .list-available
  .BC-ProductItem
  .product-image {
  margin-right: 2px;
}

.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options
  .list-available
  .BC-ProductItem
  .BC-ProductItem__Checkbox
  .Polaris-Choice__Control {
  margin-right: 0;
}

.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options
  .list-available
  .BC-ProductItem
  .Polaris-Stack__Item:nth-child(3) {
  flex: 1;
  margin-right: 2px;
}

.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options
  .BC-ProductItem
  .BC-ProductItem__title {
  flex: 1 1 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options
  .BC-ProductItem
  .BC-ProductItem__badge {
  margin-left: auto;
  min-width: 100px;
  margin-right: 10px;
}

.BC-Page__RecommendationGeneralSettings .BC-SubSettings {
  margin-top: 20px;
}

.BC-Page__RecommendationGeneralSettings .BC-SubSettings .Polaris-Card {
  box-shadow: none !important;
}

.BC-Page__RecommendationGeneralSettings .BC-SubSettings .SubSettings__description {
  color: var(--Text-Subdued, #6d7175);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 142.857% */
}

.BC-RecomendGeneralSetting_ProductList .ProductsList {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.BC-RecomendGeneralSetting_ProductList .ProductsList .ProductsList__item {
  display: flex;
  height: 56px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  padding-bottom: 5px;
  padding-top: 5px;
  width: 100%;
  background-color: #fff;
}

.BC-RecomendGeneralSetting_ProductList .ProductsList li {
  border-bottom: 1px solid #e1e3e5;
}

.BC-RecomendGeneralSetting_ProductList .ProductsList li:last-child {
  border-bottom: 0px;
}

.BC-RecomendGeneralSetting_ProductList .ProductsList .ProductsList__item-thumbnail {
  display: flex;
  position: relative;
  margin-right: 8px;
}

.BC-RecomendGeneralSetting_ProductList .ProductsList .ProductsList__item-title {
  flex: 1 1 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.BC-RecomendGeneralSetting_ProductList .ProductsList .ProductsList__item-title .Polaris-Link {
  margin-left: 3px;
  text-align: left;
}

.BC-RecomendGeneralSetting_ProductList .ProductsList .ProductsList__item-action {
  display: flex;
  width: 30px;
  height: 30px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border-radius: 4px;
  border: 1px solid var(--border-neutral-subdued, #babfc3);
  background: var(--action-secondary-default, #fff);
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.05);
}

.BC-RecomendGeneralSetting_ProductList .ProductsList .ProductsList__item-title .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  margin: 0;
}

.BC-RecomendGeneralSetting_ProductList .ProductsList .ProductsList__item-draggable {
  margin-right: 5px;
}

.BC-Page__RecommendationGeneralSettings .ProductsList__note-wrapper {
  margin-top: 5px;
}

.BC-Page__RecommendationGeneralSettings .ProductsList__note-dragAndDrop {
  color: var(--text-subdued, #6d7175);
  /* Desktop/Body */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 142.857% */
}

.BC-Page__RecommendationGeneralSettings .ProductsList__note-strong {
  color: var(--text-critical, #d72c0d);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  /* 142.857% */
}

.BC-Page__RecommendationGeneralSettings .ProductsList__note-content {
  color: var(--text-default, #202223);
  /* Desktop/Body */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.BC-Page__RecommendationGeneralSettings .ProductsList__note-highlight {
  color: var(--text-default, #202223);
  /* Desktop/Body */
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

.BC-Page__RecommendationGeneralSettings .ProductsList__note-default {
  color: var(--Text-Default, #202223);

  /* Desktop/Body */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.BC-Page__RecommendationGeneralSettings
  .Polaris-FormLayout
  .BC-RecomendGeneralSetting_TextButton-disable {
  color: var(--icon-disabled, #babec3);
  text-align: right;

  /* Desktop/Body */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 142.857% */
  float: right;
  cursor: pointer;
}

/* Recommendation End */
.BC-Page__RW-StepGuide .fullscreen-bar {
  display: flex;
  width: 100%;
  height: auto;
  align-items: center;
  text-align: center;
  justify-content: flex-end;
  padding-right: 16px;
}

.BC-Page__RW-StepGuide .section01 {
  margin-top: 36px;
  padding: 24px;
}

.BC-Page__RW-StepGuide .section02 {
  margin-top: 24px;
  padding: 24px;
}

.BC-Page__RW-StepGuide .section02 > p {
  margin-bottom: 8px;
}

.BC-Page__RW-StepGuide .section01 > .Polaris-Heading {
  font-size: 28px;
  line-height: 32px;
  margin-bottom: 4px;
}

.BC-Page__RW-StepGuide .section01 .online-store-v2 > .Polaris-Heading {
  font-size: 20px;
  line-height: 28px;
}

.BC-Page__RW-StepGuide .section01 .step-guide {
  margin-top: 16px;
  /* display: flex;
  justify-content: space-between;
  gap: 82px;
  line-height: 20px; */
}

.BC-Page__RW-StepGuide .section01 .online-store-v1 > div {
  margin-top: 16px;
}

.BC-Page__RW-StepGuide .section01 .online-store-v1 .step02 img {
  width: 100%;
  border-radius: 8px;
  margin-top: 8px;
}

.BC-Page__RW-StepGuide .section01 .Polaris-Tabs__Panel .content > div {
  margin-top: 4px;
}

.BC-Page__RW-StepGuide .section01 .step-guide .BC-Iframe-Container {
  width: 360px;
  height: 110px;
}

.BC-Page__RW-StepGuide .section01 .step-guide .BC-Iframe-Container iframe {
  border-radius: 4px;
}

.BC-Page__RW-StepGuide .section01 .step01 .content > p .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  margin: 0;
}

.BC-Page__RW-StepGuide .section01 .step01 .content > p {
  color: var(--p-text-success);
  display: flex;
  gap: 8px;
  margin-top: 12px;
  font-size: 15px;
}

.BC-Page__RW-StepGuide .section01 .Polaris-Banner {
  margin-top: 8px;
}

.BC-Page__RW-StepGuide .section01 .step-guide .content .Polaris-Button {
  margin-top: 16px;
  margin-bottom: 0.75rem;
}

.BC-Page__RW-StepGuide .section01 .content .html-placeholder input,
.BC-Page__RW-StepGuide .section01 .content .html-placeholder textarea,
.BC-Page__RecommendationWidgetItem .html-placeholder input,
.BC-Page__RecommendationWidgetItem .html-placeholder textarea,
.BC-PreOrderItem__Placement .html-placeholder input,
.BC-PreOrderItem__Placement .html-placeholder textarea {
  font-size: 0.75rem;
  padding: 12px;
  height: max-content !important;
}

.BC-Page__RW-StepGuide .section01 .content .html-placeholder .Polaris-Button--plain svg,
.BC-Page__RecommendationWidgetItem .html-placeholder .Polaris-Button--plain svg,
.BC-PreOrderItem__Placement .html-placeholder .Polaris-Button--plain svg {
  fill: #8c9196;
}

.Polaris-Button--plain.Polaris-Button--iconOnly:hover svg {
  fill: rgba(92, 95, 98, 1);
}

.BC-Page__RW-StepGuide .section01 .content .html-placeholder .Polaris-TextField,
.BC-Page__RecommendationWidgetItem .html-placeholder .Polaris-TextField,
.BC-PreOrderItem__Placement .html-placeholder .Polaris-TextField {
  margin-top: 4px;
  align-items: unset;
}

.BC-Page__RW-StepGuide
  .section01
  .content
  .html-placeholder
  .Polaris-TextField
  .Polaris-TextField__Suffix,
.BC-Page__RecommendationWidgetItem .html-placeholder .Polaris-TextField .Polaris-TextField__Suffix,
.BC-PreOrderItem__Placement .html-placeholder .Polaris-TextField .Polaris-TextField__Suffix {
  margin: unset;
  padding: 5px 4px;
}

.BC-Page__RW-StepGuide
  .section01
  .content
  .html-placeholder
  .Polaris-TextField
  .Polaris-TextField__Suffix
  .Polaris-Button--plain,
.BC-Page__RecommendationWidgetItem
  .html-placeholder
  .Polaris-TextField
  .Polaris-TextField__Suffix
  .Polaris-Button--plain,
.BC-PreOrderItem__Placement
  .html-placeholder
  .Polaris-TextField
  .Polaris-TextField__Suffix
  .Polaris-Button--plain {
  margin: unset;
}

.BC-Page__RW-StepGuide .section01 .content .html-placeholder .Polaris-TextField__Input:disabled,
.BC-Page__RecommendationWidgetItem .html-placeholder .Polaris-TextField__Input:disabled,
.BC-PreOrderItem__Placement .html-placeholder .Polaris-TextField__Input:disabled {
  -webkit-text-fill-color: #202223 !important;
  font-family: Monaco;
}

.BC-Page__RW-StepGuide
  .section01
  .content
  .html-placeholder
  .Polaris-TextField--disabled
  > .Polaris-TextField__Backdrop,
.BC-Page__RecommendationWidgetItem
  .html-placeholder
  .Polaris-TextField--disabled
  > .Polaris-TextField__Backdrop,
.BC-PreOrderItem__Placement
  .html-placeholder
  .Polaris-TextField--disabled
  > .Polaris-TextField__Backdrop {
  background-color: #f5f5f5;
  border: 1px solid #d0d0d0;
}

.BC-Page__RW-StepGuide .section01 .content table,
.BC-Page__RecommendationWidgetItem .content table,
.BC-PreOrderItem__Placement .content table {
  margin-top: 1rem;
}

.BC-Page__RW-StepGuide .section01 .content table,
.BC-Page__RW-StepGuide .section01 .content tr,
.BC-Page__RecommendationWidgetItem .content table,
.BC-Page__RecommendationWidgetItem .content tr,
.BC-PreOrderItem__Placement .content table,
.BC-PreOrderItem__Placement .content tr {
  border: 1px solid #e1e3e5;
  border-collapse: collapse;
  text-align: left;
  width: 20rem;
}

.BC-PreOrderItem__Placement .content table.file-name {
  width: 28rem;
}

.BC-Page__RW-StepGuide .section01 .content th,
.BC-Page__RW-StepGuide .section01 .content td,
.BC-Page__RecommendationWidgetItem .content th,
.BC-Page__RecommendationWidgetItem .content td,
.BC-PreOrderItem__Placement .content th,
.BC-PreOrderItem__Placement .content td {
  padding: 0.5rem 1rem;
}

.BC-Page__RW-StepGuide .section01 .content tbody tr td:nth-child(2),
.BC-Page__RecommendationWidgetItem .content tbody tr td:nth-child(2),
.BC-PreOrderItem__Placement .content tbody tr td:nth-child(2) {
  color: var(--p-text-critical);
}

.BC-Page__RW-StepGuide .section02 > .Polaris-Heading {
  font-size: 20px;
  line-height: 28px;
}

.BC-Page__RW-StepGuide .section02 .useful {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.BC-Page__RW-StepGuide .section02 .useful .card-action {
  display: flex;
  gap: 12px;
  background: #fafbfb;
  border-radius: 4px;
  align-items: center;
  padding: 20px;
  min-height: 60px;
  width: 100%;
}

.BC-Page__RW-StepGuide .section02 .useful .card-action:hover {
  cursor: pointer;
  background-color: #f0f8f8;
}

.BC-Page__RW-StepGuide .tab-content .tab-content-title {
  padding-bottom: 1.25rem;
}

.BC-Page__RW-StepGuide .tab-content .tab-content-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.BC-Page__RW-StepGuide .tab-content .tab-content-content .action {
  margin-top: 16px;
}

.BC-Page__RW-StepGuide .tab-content .tab-content-content .action .non-action {
  display: inline-flex;
}

.BC-Page__RW-StepGuide .tab-content .tab-content-content .action .non-action .Polaris-Icon {
  margin-right: 0.5rem;
}

.BC-Page__RW-StepGuide .tab-content .setup-cart-drawer-step {
  list-style-type: disc;
  padding-left: 1.25rem;
  margin-top: 4px;
}

.BC-Page__RW-StepGuide .tab-content .setup-cart-drawer-step svg {
  fill: #5c5f62;
  width: 15px;
  height: 16px;
}

/* Recommendation Grant Permission Notif */

.BC-Container__Notifications__GrantPermissionBanner {
  color: var(--p-text);
}

.BC-Page__RecommendationWidgetManagement
  .BC-Container__Notifications
  .BC-Container__Notifications__GrantPermissionBanner
  .Polaris-Banner__Heading {
  margin-bottom: 4px;
}

.BC-Page__RecommendationWidgetManagement
  .BC-Container__Notifications
  .BC-Container__Notifications__GrantPermissionBanner
  .Polaris-List__Item {
  margin-bottom: 0;
}

/* Recommendation Grant Permission Notif End */

/* Manual Recommendation */
.BC-Page__ManualRecommendationManagement .searchField {
  width: 50%;
  margin-left: auto;
}

.BC-Page__ManualRecommendationManagement .pagination .BC-Page__Button {
  position: absolute;
  top: 0;
  right: 0;
}

.BC-Page__ManualRecommendationManagement .pagination .Polaris-ButtonGroup__Item {
  margin-left: 0.75rem;
}

.BC-Page__ManualRecommendationManagement .BC-Container__Notifications .Polaris-List__Item {
  margin-bottom: 0.125rem;
}

.BC-Page__ManualRecommendationManagement
  .BC-Container__Notifications
  .Polaris-Banner
  .Polaris-Banner__ContentWrapper
  a
  .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  max-width: 16px;
  margin-left: 2px;
  margin-right: 2px;
}

/* .BC-Page__ManualRecommendationManagement .BC-Container__Notifications .Polaris-Banner
  .Polaris-Banner__ContentWrapper a .Polaris-Icon .Polaris-Icon__Svg {
  margin-top: 5px;
} */

.BC-Page__ManualRecommendationManagement
  .BC-Container__Notifications
  .Polaris-Banner
  .Polaris-Banner__ContentWrapper
  .manual-external-link
  .Polaris-Link--monochrome {
  color: var(--p-interactive);
}

.BC-Page__ManualType .Polaris-Card > .Polaris-Card__Section:nth-child(2) {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
}

.BC-Page__ManualType__ComingSoon {
  padding-top: 2.5rem;
  padding-bottom: 1.25rem;
}

.BC-Page__ManualType__NoRecommendation {
  padding: 1.5rem 0 0.25rem;
}

.BC-Page__ManualType__NoSearchResult {
  padding: 0.25em 0;
}

.BC-Page__ManualType .tabs .Polaris-Tabs__Panel .Polaris-Card__Section {
  padding: 0;
}

.BC-Page__ManualType__HandPickedProduct .Polaris-DataTable th.Polaris-DataTable__Cell:first-child {
  width: 76px;
}

.BC-Page__ManualType__HandPickedProduct
  .Polaris-DataTable
  .Polaris-DataTable__TableRow
  .Polaris-DataTable__Cell:first-child {
  padding: 0.5rem 1rem 0.5rem 1.25rem;
}

.BC-Page__ManualType__HandPickedProduct .Polaris-DataTable th.Polaris-DataTable__Cell:nth-child(2) {
  width: 249px;
}

.BC-Page__ManualType__HandPickedProduct .Polaris-DataTable th.Polaris-DataTable__Cell:nth-child(2),
.BC-Page__ManualType__HandPickedProduct
  .Polaris-DataTable
  .Polaris-DataTable__TableRow
  .Polaris-DataTable__Cell:nth-child(2) {
  padding: 0.5rem 1rem 0.5rem 0;
}

.BC-Page__ManualType__HandPickedProduct
  .Polaris-DataTable
  .Polaris-DataTable__TableRow
  .Polaris-DataTable__Cell:nth-child(3) {
  padding: 0.5rem 0 0.5rem 1rem;
}

.BC-Page__ManualType__HandPickedProduct .Polaris-DataTable th.Polaris-DataTable__Cell:last-child {
  width: 92px;
  text-align: center;
}

.BC-Page__ManualType__HandPickedProduct
  .Polaris-DataTable
  .Polaris-DataTable__TableRow
  .Polaris-DataTable__Cell:last-child {
  padding: 0.5rem 1.25rem 0.5rem 1rem;
}

.BC-Page__ManualType__RecommendationProduct__items {
  margin-left: 0.5rem;
}

.BC-Page__ManualType__HandPickedProduct__ButtonGroups {
  position: relative;
  top: 3px;
}

.BC-Page__ManualType__HandPickedProduct__SourceProduct {
  max-width: 309px;
  white-space: initial;
}

.BC-Page__ManualType__HandPickedProduct .BC-Page__ManualType__HandPickedProduct__ColumnTitle {
  font-weight: 500;
}

.BC-Page__ManualType__SearchResult__Loading {
  padding: 1rem 1rem 0.5rem 1rem;
}

.BC-Page__ManualType__SearchResult__Loading .Polaris-SkeletonDisplayText__DisplayText {
  margin-bottom: 0.5rem;
  max-width: 100%;
}

.BC-Page__ManualType__SearchResult__Loading .Polaris-SkeletonDisplayText__DisplayText:last-child {
  margin-bottom: 0;
}

.BC-Page__ManualType__SearchResult .BC-Page__ManualType__SearchResult__Title {
  padding: 1.25rem 1.25rem 0.5rem;
}

.BC-Page__ManualType__SearchResult .Polaris-Card__Section {
  margin-bottom: 0.5rem;
  max-height: 670px;
  overflow: auto;
}

.BC-Page__ManualType__SearchResult .Polaris-Card__Section:last-child {
  margin-bottom: 0;
}

.BC-Page__ManualType__SearchResult .BC-Page__ManualType__SearchResult__Empty {
  padding: 2.75rem;
  padding-bottom: 1.5rem;
}

/* Manual Recommendation End */

/* Manual Recommendation New Item */
.BC-Page__ManualRecommendationNew .BC-Page__ManualRecommendationNew__SourceProduct {
  margin-top: 1.5rem;
}

.BC-Page__ManualRecommendationNew__SourceProduct .Polaris-Card__Header,
.BC-Page__ManualRecommendationNew__RecommendProduct .Polaris-Card__Header {
  padding-bottom: 1rem;
  border-bottom: 1px solid #e1e3e5;
}

.BC-Page__ManualRecommendationNew__SourceProduct .Polaris-Card__Section,
.BC-Page__ManualRecommendationNew__RecommendProduct .Polaris-Card__Section {
  padding: 0;
  padding-bottom: 0.5rem;
}

.BC-Page__ManualRecommendationNew__SourceProduct
  .BC-Page__ManualRecommendationNew__SourceProduct__List,
.BC-Page__ManualRecommendationNew__RecommendProduct
  .BC-Page__ManualRecommendationNew__RecommendProduct__List {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.BC-Page__ManualRecommendationNew__SourceProduct
  .BC-Page__ManualRecommendationNew__SourceProduct__List
  li,
.BC-Page__ManualRecommendationNew__RecommendProduct
  .BC-Page__ManualRecommendationNew__RecommendProduct__List
  li {
  background-color: #fff;
  padding: 0.5rem 1rem;
  transition: background-color 200ms cubic-bezier(0.42, 0, 0.58, 1);
  box-shadow: inset 0px -1px 0px #e1e3e5;
}

.BC-Page__ManualRecommendationNew__SourceProduct
  .BC-Page__ManualRecommendationNew__SourceProduct__List
  li:last-child,
.BC-Page__ManualRecommendationNew__RecommendProduct
  .BC-Page__ManualRecommendationNew__RecommendProduct__List
  li:last-child {
  box-shadow: none;
}

.BC-Page__ManualRecommendationNew__SourceProduct
  .BC-Page__ManualRecommendationNew__SourceProduct__List
  li:hover,
.BC-Page__ManualRecommendationNew__RecommendProduct
  .BC-Page__ManualRecommendationNew__RecommendProduct__List
  li:hover {
  background-color: rgb(246, 246, 247);
}

.BC-Page__ManualRecommendationNew__SourceProduct__Skeleton,
.BC-Page__ManualRecommendationNew__RecommendProduct__Skeleton {
  padding: 1rem 1.25rem;
}

.BC-Page__ManualRecommendationNew__SourceProduct__Skeleton
  .Polaris-SkeletonDisplayText__DisplayText,
.BC-Page__ManualRecommendationNew__RecommendProduct__Skeleton
  .Polaris-SkeletonDisplayText__DisplayText {
  max-width: 100%;
}

.BC-Page__ManualRecommendation__SourceProductItem .Polaris-Stack__Item:nth-child(2) {
  padding: 0.5rem 1rem;
  flex: 1;
}

.BC-Page__ManualRecommendation__RecommendProductItem .Polaris-Stack__Item:nth-child(3) {
  padding: 0.5rem 1rem;
  flex: 1;
}

.BC-Page__ManualRecommendation__SourceProductItem__Action,
.BC-Page__ManualRecommendation__RecommendProductItem__Action {
  position: relative;
  top: 3px;
}

.BC-Page__ManualRecommendationNew
  .BC-Page__ManualRecommendationNew__SourceProduct
  .BC-Page__ManualRecommendationNew__NoProduct {
  padding: 3rem 0 2.5rem;
}

.BC-Page__ManualRecommendationNew
  .BC-Page__ManualRecommendationNew__RecommendProduct
  .BC-Page__ManualRecommendationNew__NoProduct {
  padding: 3rem 0 2.5rem;
}

.BC-Page__ManualRecommendationNew__RecommendProduct .titleMetadata {
  width: 12px;
  height: 12px;
}

.BC-Page__ManualRecommendationNew__RecommendProduct .titleMetadata svg {
  width: 12px;
}

.BC-Page__ManualRecommendationNew .BC-Page__Button .Polaris-ButtonGroup__Item {
  margin-left: 1rem;
}

.BC-Page__SelectProductModal .Polaris-Modal-Section:first-child {
  padding: 1rem 1.25rem;
}

.BC-Page__SelectProductModal__Header .Polaris-Modal-CloseButton:focus::after {
  box-shadow: none;
}

.BC-Page__SelectProductModal__Header .Polaris-Icon__Svg {
  fill: var(--p-text);
}

.BC-Page__ManualRecommendationNew__SelectProductModal__Description {
  margin-bottom: 1.4rem;
}

.BC-Page__ManualRecommendationNew__SelectProductModal__Product-Options {
  margin-top: 0.375rem;
}

.BC-Page__ManualRecommendationNew__SelectProductModal__Product-Options .list-available {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.BC-Page__ManualRecommendationNew__SelectProductModal__Product-Options
  .list-available
  .Polaris-SkeletonDisplayText__DisplayText {
  max-width: 100%;
}

.BC-Page__ManualRecommendationNew__SelectProductModal__Product-Options .list-available li {
  margin-bottom: 0.75rem;
}

.BC-Page__ManualRecommendationNew__SelectProductModal__Product-Options
  .list-available
  li:last-child {
  margin-bottom: 0;
}

.BC-Page__ManualRecommendationNew__SelectProductModal__Product-Options
  .list-available
  .BC-ProductItem
  .BC-ProductItem__Checkbox {
  display: flex;
  position: relative;
  top: 1px;
}

.BC-Page__ManualRecommendationNew__SelectProductModal__Product-Options
  .list-available
  .BC-ProductItem
  .BC-ProductItem__Checkbox
  .Polaris-Choice__Control {
  margin-right: 0;
}

.BC-Page__ManualRecommendationNew__SelectProductModal__Product-Options
  .list-available
  .BC-ProductItem
  .Polaris-Stack__Item:nth-child(3) {
  flex: 1;
}

/* Manual Recommendation New Item End */

/* Filter option - Multi level tags */
.List_MultiLevelTags .BC-Draggable {
  background-color: #ffffff;
}

.List_MultiLevelTags .BC-Draggable.dragging {
  padding-right: 10px;
  border: 1px solid var(--p-divider);
}

.List_MultiLevelTags .rowTag {
  display: flex;
  padding-top: 0.4375rem;
  padding-bottom: 0.4375rem;
}

.List_MultiLevelTags .rowTag .dragIcon {
  width: 25px;
  margin-top: 5px;
}

.List_MultiLevelTags .rowTag .dragShowHideBtn {
  width: 27px;
  margin-top: 6px;
}

.List_MultiLevelTags .rowTag .dragSelectTag {
  width: 45%;
  padding-right: 0.625rem;
}

.List_MultiLevelTags .rowTag .dragDisplayName {
  width: 40%;
  padding-right: 0.625rem;
}

.List_MultiLevelTags .rowTag .action {
  width: auto;
}

.MultiLevelTag_ButtonAdd {
  padding-top: 0.4375rem;
}

.List_MultiLevelTags .Polaris-Button,
.MultiLevelTag_ButtonAdd .Polaris-Button {
  min-height: 2.125rem;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
}

.List_MultiLevelTags .buttonAdd {
  padding-top: 0.4375rem;
}

.List_MultiLevelTags .subTagBox1,
.List_MultiLevelTags .buttonAddSubTag1 {
  margin-left: 1.4375rem;
}

.List_MultiLevelTags .buttonAddSubTag1 {
  margin: 0 0 0.4375rem 1.4375rem;
  padding: 0.4375rem 0 0.875rem 0;
  border-bottom: 1px solid var(--p-divider);
}

.List_MultiLevelTags .buttonAddSubTag1 .Polaris-Icon,
.MultiLevelTag_ButtonAdd .Polaris-Icon,
.List_MultiLevelTags .rowTag .action .Polaris-Icon {
  height: 0.9375rem;
  width: 0.9375rem;
}

.List_MultiLevelTags .dragShowHideBtn button svg {
  fill: #212b36;
}

.List_MultiLevelTags .dragShowHideBtn .Polaris-Button--disabled svg {
  fill: #fff;
}

.List_MultiLevelTags .BC-Button_Select .Polaris-Button {
  min-height: 2.375rem;
}

.List_MultiLevelTags .BC-Button_Select .Polaris-Button {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.List_MultiLevelTags .BC-Button_Select .Polaris-Button__Content {
  justify-content: space-between;
  flex-direction: row-reverse;
  color: #202223;
  font-weight: var(--p-font-weight-regular);
}

.List_MultiLevelTags .BC-Button_Select .Polaris-Button__Content .Polaris-Button__Text {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.List_MultiLevelTags .BC-Button_Select .Polaris-Button__Content .Polaris-Button__Icon svg {
  fill: #cccccc;
}

/* Update media screen */
@media (max-width: 30.625em) {
  .BC-Page__Dashboard .Polaris-Card__Header,
  .BC-Page__FilterTree-Item .Polaris-Card__Header,
  .BC-Page__FilterTree-Management .Polaris-Card__Header,
  .BC-Page__Theme-Setup .Polaris-Card__Header,
  .BC-Page__Merge-Value .Polaris-Card__Header,
  .BC-Page__SuggestionDictionary .Polaris-Card__Header,
  .BC-Page__Synonym .Polaris-Card__Header,
  .BC-Page_ProductRanking .Polaris-Card__Header,
  .BC-Page__Merchandising .Polaris-Card__Header,
  .BC-Page__Merchandising-Rule .Polaris-Card__Header,
  .BC-OnboardingChecklist__OnPage .Polaris-Card__Header {
    padding-bottom: 1rem;
    padding-top: 1rem;
  }

  .BC-Welcome__Dashboard {
    padding: 1rem 1rem 0;
  }

  .BC-Page__Dashboard .BC-Iframe-Container__Center {
    width: 100%;
  }

  .BC-Review__Dashboard .BC-Email__Dashboard .Polaris-Layout__Section,
  .BC-Feedback__Dashboard .Polaris-Layout__Section {
    order: 1;
    margin-top: 0.625rem;
  }

  .BC-Review__Dashboard .BC-Email__Dashboard .Polaris-Layout__Section--secondary,
  .BC-Feedback__Dashboard .Polaris-Layout__Section--secondary {
    order: 0;
    margin-bottom: 0;
    margin-top: 1rem;
  }

  .BC-HelpCenter__Dashboard .Polaris-Layout__Section--secondary:not(:first-child),
  .BC-Menu__Dashboard .Polaris-Layout__Section--secondary:not(:first-child) {
    margin-top: 0;
  }

  .BC-KnowledgeBase__Dashboard .Polaris-Layout__Section:not(:first-child) {
    display: none;
  }

  .BC-SyncHookStatus__Dashboard .Polaris-Layout__Section--secondary {
    margin: 0;
  }

  .BC-Menu__Dashboard
    .Polaris-Layout__Section:first-child
    .BC-Link__Dashboard:first-child
    .menuBox
    .Polaris-Card__Section,
  .BC-HelpCenter__Dashboard
    .Polaris-Layout__Section:first-child
    .BC-Link__Dashboard:first-child
    .menuBox
    .Polaris-Card__Section {
    padding-top: 0px;
  }

  .BC-Menu__Dashboard .menuBox .Polaris-Card__Section,
  .BC-HelpCenter__Dashboard .menuBox .Polaris-Card__Section {
    padding-bottom: 0px;
  }

  .BC-ThemeSetup__DashboardV3,
  .BC-CalloutCard-ThemeSetup__Dashboard,
  .BC-CalloutCard-ExpReviewRating__Dashboard {
    text-align: center;
  }

  .BC-ThemeSetup__DashboardV3 .firstCol .Polaris-Button,
  .BC-CalloutCard-ThemeSetup__Dashboard .firstCol .Polaris-Button,
  .BC-CalloutCard-ExpReviewRating__Dashboard .firstCol .Polaris-Button {
    margin-top: 1rem;
  }

  .BC-Page__FilterTree-Item .BC-Page__Text {
    padding: 1.5rem 1rem 0;
  }

  .BC-Page__FilterTree-Management .BC-Page__Text {
    padding: 0 1rem;
  }
}

/* Stop words */
.BC-EmptyOption__StopWords {
  margin-top: 3.75rem;
  margin-bottom: 2.5rem;
}

.BC-Page__StopWords .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {
  justify-content: flex-end;
}

.BC-Page__StopWords
  .Polaris-PageActions
  .Polaris-Stack--distributionEqualSpacing
  .Polaris-Stack__Item {
  margin-left: 1rem;
}

.BC-Page__StopWords .ImportExportActionsGroup {
  display: inline-flex;
  color: #637381;
}

.BC-Page__StopWords .ImportExportActionsGroup .action {
  display: inline-flex;
  cursor: pointer;
}

.BC-Page__StopWords .ImportExportActionsGroup .action:last-child {
  margin-left: 1.4375rem;
}

.BC-Page__StopWords .ImportExportActionsGroup .action .Polaris-Icon {
  margin-right: 3px;
}

.BC__StopWords-Search {
  display: flex;
  justify-content: flex-end;
  margin: -0.35rem 0;
  width: 272px;
}

.BC__StopWords-Search > div {
  width: 100%;
}

.BC__StopWords-Search .Polaris-Icon--colorInk svg {
  fill: #212b36;
}

.BC__StopWords-List {
  display: flex;
  list-style-type: none;
  flex-wrap: wrap;
  margin: 1.375rem -0.8125rem 0 -0.8125rem;
  -webkit-padding-start: 0;
  padding-inline-start: 0;
}

.BC__StopWords-Item {
  flex: 0 0 10rem;
  background-color: #f4f6f8;
  display: flex;
  padding-left: 0.75rem;
  margin: 0.625rem 0.75rem;
  align-items: center;
  border-radius: 5px;
}

.BC__StopWords-Item.is-new {
  background-color: #d7f2ff;
}

.BC__StopWords-Item.is-new .BC__StopWords--Value .Polaris-TextStyle--variationSubdued {
  color: #084e8a;
}

.BC__StopWords-Item.is-new
  .BC__StopWords--Remove
  .Polaris-Button--plain.Polaris-Button--iconOnly
  svg {
  fill: #084e8a;
}

.BC__StopWords-Item.is-new
  .BC__StopWords--Remove
  .Polaris-Button--plain.Polaris-Button--iconOnly:hover
  svg,
.BC__StopWords-Item.is-new
  .BC__StopWords--Remove
  .Polaris-Button--plain.Polaris-Button--iconOnly:active
  svg {
  fill: #212b36;
}

.BC__StopWords--Remove {
  margin-left: auto;
  line-height: 0;
}

.BC__StopWords--Remove .Polaris-Icon {
  width: 21px;
  height: 21px;
}

.BC__StopWords--Remove .Polaris-Button--plain.Polaris-Button--iconOnly {
  margin: 0;
  margin-left: 0.75rem;
  min-width: 0;
  min-height: 0;
  height: 28px;
  padding: 0 0.25rem;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.BC__StopWords--Remove:hover .Polaris-Button--plain.Polaris-Button--iconOnly {
  background-color: #c4cdd5;
}

.BC__StopWords-Item.is-new
  .BC__StopWords--Remove:hover
  .Polaris-Button--plain.Polaris-Button--iconOnly {
  background-color: #b4e0fa;
}

.BC__StopWords--Value {
}

.BC__StopWords--Value .Polaris-Caption {
  font-size: 0.75rem;
  line-height: 21px;
  height: 22px;
}

/* Product ranking */
.BC-Page__ProductRanking .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty {
  height: 20px;
}

.BC-Page__ProductRanking .Polaris-Stack > .Polaris-Stack__Item .search {
  position: absolute;
  right: 20px;
  top: 10px;
  width: 16.375rem;
}

.BC-Page__ProductRanking .Polaris-Stack > .Polaris-Stack__Item .search .Polaris-TextField__Input {
  font-size: 0.75rem;
}

.BC-Page__ProductRanking .Polaris-DataTable__Cell {
  padding: 0.9375rem 0.78125rem;
}

.BC-Page__ProductRanking tbody .Polaris-DataTable__Cell {
  border-top: 1px solid var(--p-divider);
  border-bottom: none;
  white-space: normal;
}

.BC-Page__ProductRanking tbody tr:first-child .Polaris-DataTable__Cell {
  border-top: none;
}

.BC-Page__ProductRanking .Polaris-DataTable__Cell.sortable-heading {
  cursor: pointer;
}

.BC-Page__ProductRanking .Polaris-DataTable__Cell.sortable-heading:hover {
  color: var(--p-action-primary);
}

.BC-Page__ProductRanking .Polaris-DataTable__Cell.sortable-heading > span {
  display: inline-flex;
}

.BC-Page__ProductRanking tbody.list-available tr:nth-child(odd) .Polaris-DataTable__Cell {
  padding: 0.4375rem 0.78125rem;
}

.BC-Page__ProductRanking
  tbody.list-available
  tr:nth-child(odd)
  .Polaris-DataTable__Cell:first-child {
  width: 3.125rem;
  padding-left: 1.25rem;
  padding-right: 0.5rem;
}

.BC-Page__ProductRanking .Polaris-DataTable__Cell .product-image {
  width: 50px;
  padding-bottom: 50px;
  position: relative;
  border: 1px solid var(--p-divider);
  box-sizing: border-box;
}

.BC-Page__ProductRanking .Polaris-DataTable__Cell .product-image.no-image {
  background-color: #f9fafb;
}

.BC-Page__ProductRanking .Polaris-DataTable__Cell .product-image img {
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.BC-Page__ProductRanking tr:nth-child(odd) .Polaris-DataTable__Cell:nth-child(3) {
  width: 20%;
}

.BC-Page__ProductRanking tr:nth-child(odd) .Polaris-DataTable__Cell:nth-child(4) {
  width: 34%;
  padding-right: 1.25rem !important;
}

.BC-Page__ProductRanking tr:nth-child(even) .Polaris-DataTable__Cell {
  padding-top: 0rem;
  border-top: none;
}

.BC-Page__ProductRanking tr:nth-child(even) .Polaris-DataTable__Cell:first-child {
  padding-left: 1.25rem;
}

.BC-Page__ProductRanking tr:nth-child(even) .Polaris-DataTable__Cell:last-child {
  padding-right: 1.25rem;
}

.BC-Page__ProductRanking .bottom {
  display: block;
  margin-top: 1.5rem;
  position: relative;
}

.BC-Page__ProductRanking .actionsGroup {
  position: absolute;
  right: 0px;
  top: 0px;
}

.BC-EmptyOption__ProductRanking,
.BC-EmptySearch__RecommendationWidget,
.BC-EmptySearch__Integration,
.BC-EmptySearch__ABTestingCampaign {
  padding-top: 1.875rem;
  padding-bottom: 1.5rem;
}

/* Analytics */
.BC-Analytics__Tabs .Polaris-Tabs__Tab:first-child {
  padding-left: 0;
}

.action-locked--analytics {
  display: flex;
  gap: 8px;
}

.BC-Analytics__Total {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
}

.BC-Analytics__Total .section {
  flex: 1 1 19.375rem;
  min-width: 0;
  max-width: 100%;
  border: 1px solid;
  padding: 1.5rem;
  text-align: center;
}

.BC-Analytics__Total .section > p {
  margin-bottom: 0.25rem;
  font-size: 1.625rem;
}

.BC-Analytics__Total .section > span {
  font-size: 0.75rem;
}

.BC-Analytics__Total,
.BC-Analytics__Total .section {
  border-style: solid;
  border-color: #c4cdd5;
}

.BC-Analytics__Total {
  border-width: 1px 0 0 1px;
  -webkit-border: 4px;
  -webkit-border: 4px;
  -moz-border: 4px;
  -moz-border: 4px;
  border-radius: 4px;
}

.BC-Analytics__Total .section {
  border-width: 0 1px 1px 0;
}

@media screen and (min-width: 995px) {
  .BC-Analytics__Total .section:first-child {
    -webkit-border-top-left-radius: 4px;
    -webkit-border-bottom-left-radius: 4px;
    -moz-border-radius-topleft: 4px;
    -moz-border-radius-bottomleft: 4px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .BC-Analytics__Total .section:last-child {
    -webkit-border-top-right-radius: 4px;
    -webkit-border-bottom-right-radius: 4px;
    -moz-border-radius-topright: 4px;
    -moz-border-radius-bottomright: 4px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

@media screen and (max-width: 994px) {
  .BC-Analytics__Total .section:first-child {
    -webkit-border-top-left-radius: 4px;
    -webkit-border-top-right-radius: 4px;
    -moz-border-radius-topleft: 4px;
    -moz-border-radius-topright: 4px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .BC-Analytics__Total .section:last-child {
    -webkit-border-bottom-right-radius: 4px;
    -webkit-border-bottom-left-radius: 4px;
    -moz-border-radius-bottomright: 4px;
    -moz-border-radius-bottomleft: 4px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
}

.BC-Analytics__Filter {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin: 24px 0;
  gap: 16px;
}

.BC-Analytics__Filter.BC-Analytics__Filter--turbo {
  margin: 0;
}

.BC-Analytics__Filter.BC-Analytics__Filter--turbo > .Polaris-Stack {
  order: 2;
}

.BC-Analytics__Filter div.filter-collection {
  flex: 0 1 12.5rem;
  min-width: 0;
}

.BC-Analytics__Filter .separator {
  margin: auto 0.75rem;
}

.BC-Analytics__Filter .Polaris-Button__Text {
  font-weight: 400;
}

.BC-Analytics__Filter .date-select-picker button {
  padding: 0 1.25rem 0 1.5rem;
}

.BC-Analytics__Filter .date-select-picker .Polaris-Button__Text {
  margin-left: 0.75rem;
}

.BC-Analytics__Filter .date-select-picker .compare-time {
  margin-left: 0.5rem;
}

.BC-Analytics__Filter .freemium-export-locked {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}

.BC-Analytics__Filter .freemium-export-locked:hover {
  cursor: pointer;
}

.BC-Analytics__Filter .freemium-export-locked > div {
  background: rgba(255, 242, 217, 1);
  padding: 0px 1px 0px 1px;
  border-radius: 4px 0px 0px 0px;
}

.BC-Analytics__Filter .freemium-export-locked span {
  color: rgba(44, 110, 203, 1);
  font-weight: 500;
}

.open-link-text .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
}

.open-link-text:hover {
  text-decoration: underline;
}

.BC-Analytics__Export-Modal .Polaris-Button__Text {
  font-weight: 400;
}

.BC-Analytics__Export-Modal .Polaris-ChoiceList__Choices {
  display: flex;
}

.BC-Analytics__Export-Modal .Polaris-ChoiceList__Choices li {
  margin-right: 1.25rem;
}

.BC-Analytics__Export-Modal .default-text-style {
  font-weight: normal !important;
}

.BC-Page__Analytics .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {
  justify-content: flex-end;
}

.BC-Page__Analytics .Polaris-DataTable__Cell .sortable-heading {
  cursor: pointer;
  display: inline-flex;
}

.BC-Page__Analytics .spinner-loading {
  text-align: center;
}

.BC-Page__Analytics .analytic-empty {
  text-align: center;
  color: var(--p-text-subdued);
}

.BC-Page__Analytics .Polaris-Page .Polaris-Card .Polaris-Heading {
  border-bottom: 2px dotted #c4cdd5;
  display: inline;
}

.BC-Page__Analytics .Polaris-Page .Polaris-Card .Polaris-Card__Header .Polaris-Stack {
  flex-wrap: inherit;
}

.BC-Page__Analytics
  .Polaris-Page
  .Polaris-Card
  .Polaris-Card__Header
  .Polaris-Stack
  .Polaris-Stack__Item--fill {
  margin-right: 1.5rem;
}

.BC-Page__Analytics .content-compact-title {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  padding-bottom: 0.5rem;
}

.BC-Page__Analytics .content-compact-content {
  display: flex;
}

.BC-Page__Analytics .content-compact-content .content-compact-content-item {
  flex: 1 1 50%;
}

.BC-Page__Analytics .content-compact-content .content-compact-content-item.first {
  margin-right: 2.5rem;
}

.BC-Page__Analytics .content-compact-content table {
  counter-reset: serial-number;
}

.BC-Page__Analytics .content-compact-content table .item-first-col > div,
.BC-Page__Analytics .content table .item-first-col .range + div {
  overflow: hidden;
}

.BC-Page__Analytics .content table .item-first-col .range {
  float: left;
  margin-right: 5px;
  float: left;
}

.BC-Page__Analytics .content-compact-content table .item-options > div {
  overflow: hidden;
}

.BC-Page__Analytics .content table .item-options .filter-option {
  margin-top: 10px;
}

.BC-Page__Analytics .content table .item-first-col .option {
  margin-top: 10px;
}

.BC-Page__Analytics .content table .item-first-col .option:first-child {
  margin-top: 0;
}

.BC-Page__Analytics .item-value {
  color: #43467f;
  margin-left: 0.625rem;
  display: inline-block;
  font-weight: 500;
}

.BC-Page__Analytics .content table td {
  word-break: break-all;
  vertical-align: top;
}

.BC-Page__Analytics .content-compact-content td {
  padding-bottom: 0.75rem;
}

.BC-Page__Analytics .content-compact-content .item-percentage,
.BC-Page__Analytics .content-compact-content .item-total {
  width: 20%;
  text-align: right;
}

.BC-Page__Analytics .content-detail .item-percentage,
.BC-Page__Analytics .content-detail .item-total {
  width: 20%;
  text-align: center;
}

.BC-Page__Analytics .content-compact-content .item-percentage .Polaris-Icon,
.BC-Page__Analytics .content-detail td.item-percentage .Polaris-Icon {
  display: inline-block;
  width: 0.6875rem;
  height: 0.6875rem;
}

.BC-Page__Analytics .Polaris-DataTable__Cell--header {
  font-weight: 500;
}

.BC-Page__Analytics .content-detail .Polaris-DataTable__Cell {
  padding: 0.875rem 0rem 0.875rem 0;
  border-bottom: 0.0625rem solid var(--p-divider);
  vertical-align: middle;
  word-wrap: break-word;
  white-space: inherit;
}

.BC-Page__Analytics .content-detail tr:last-child .Polaris-DataTable__Cell {
  border-bottom: none;
}

.BC-Page__Analytics .content-detail .pagination {
  text-align: center;
}

.BC-Page__Analytics .content-detail .item-total.item-1 {
  background-color: var(--p-action-primary);
  color: #ffffff;
}

.BC-Page__Analytics .content-detail .item-total.item-2 {
  background-color: rgba(180, 224, 250, 0.9);
}

.BC-Page__Analytics .content-detail .item-total.item-3 {
  background-color: rgba(235, 245, 250, 0.8);
}

.BC-Analytics__Tabs .summary {
  line-height: 2rem;
}

.BC-Analytics__Tabs .summary .total {
  font-size: 1.75rem;
  font-weight: 600;
}

.BC-Analytics__Tabs .summary .percentChange {
  float: right;
  font-size: 1.75rem;
}

.BC-Analytics__Tabs .summary .percentChange.up {
  color: var(--p-action-primary);
}

.BC-Analytics__Tabs .summary .percentChange.down {
  color: #de3618;
}

.BC-Analytics__Tabs .summary .percentChange .Polaris-Icon {
  height: 1.5625rem;
  width: 1.5625rem;
}

.BC-Analytics__Tabs .Polaris-Card .Polaris-Card__Header .Polaris-ButtonGroup__Item {
  margin-left: 1rem;
}

.BC-Analytics__Tabs .Polaris-Card .Polaris-Card__Header .Polaris-Button--plain {
  padding-left: 0;
}

.BC-Page__Analytics .BC-Analytics__Settings {
  margin-top: 1.5rem;
}

.BC-Page__Analytics .BC-Analytics__Settings .field-title .Polaris-Label .Polaris-Label__Text {
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.BC-Page__Analytics .Polaris-Page .BC-Analytics__Settings .Polaris-Card .Polaris-Card__Header {
  padding-bottom: 1.125rem;
  padding-top: 1.125rem;
  border-bottom: 0.0625rem solid var(--p-divider);
}

.BC-Page__Analytics .Polaris-Page .BC-Analytics__Settings .Polaris-Card .Polaris-Heading {
  border-bottom: none;
}

.BC-Page
  .BC-Page__SearchAnalytics__SearchesWithoutResults
  .Polaris-SkeletonDisplayText__DisplayText {
  max-width: unset;
}

.BC-Page .BC-Page__SearchAnalytics__SearchesWithoutResults .Polaris-Card__Header,
.BC-Page .BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-Card__Header,
.BC-Page .BC-Page__SearchAnalytics__SearchTerms .Polaris-Card__Header {
  padding-left: 1rem;
}

.BC-Page .BC-Page__SearchAnalytics__SearchesWithoutResults .Polaris-Card__Section {
  padding: 0;
}

.BC-Page .BC-Page__SearchAnalytics__SearchesWithoutResults thead th.Polaris-DataTable__Cell {
  font-weight: 600;
}

.BC-Page
  .BC-Page__SearchAnalytics__SearchesWithoutResults
  thead
  th.Polaris-DataTable__Cell
  .Polaris-DataTable__Heading {
  font-weight: 600;
}

.BC-Page .BC-Page__SearchAnalytics__SearchesWithoutResults tbody .Polaris-DataTable__Cell {
  padding: var(--p-space-2) var(--p-space-4);
  vertical-align: middle;
}

.BC-Page
  .BC-Page__SearchAnalytics__SearchesWithoutResults
  tbody
  .Polaris-DataTable__Cell:first-child {
  width: 400px;
}

.BC-Page
  .BC-Page__SearchAnalytics__SearchesWithoutResults
  tbody
  .Polaris-DataTable__Cell
  .Polaris-DataTable__TooltipContent {
  white-space: normal;
}

.BC-Page__SearchAnalytics__SearchesWithoutResults .Polaris-DataTable__Icon--custom,
.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Icon--custom,
.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Icon--custom,
.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Icon--custom {
  display: flex;
  align-self: flex-end;
}

.BC-Page__SearchAnalytics__SearchesWithoutResults .Polaris-DataTable__Icon {
  display: none;
}

.BC-Page__SearchAnalytics__SearchesWithoutResults
  .Polaris-DataTable__Cell--sorted
  .Polaris-DataTable__Icon--custom
  .Polaris-Icon__Svg,
.BC-Page__SearchAnalytics__SearchesWithoutClicks
  .Polaris-DataTable__Cell--sorted
  .Polaris-DataTable__Icon--custom
  .Polaris-Icon__Svg,
.BC-Page__SearchAnalytics__SearchTerms
  .Polaris-DataTable__Cell--sorted
  .Polaris-DataTable__Icon--custom
  .Polaris-Icon__Svg,
.BC-Page__SearchAnalytics__SearchTermDetail
  .Polaris-DataTable__Cell--sorted
  .Polaris-DataTable__Icon--custom
  .Polaris-Icon__Svg {
  fill: var(--p-action-primary) !important;
}

.BC-Page__SearchAnalytics__SearchesWithoutResults__Pagination {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.BC-Page__SearchAnalytics__SearchesWithoutResults__Pagination .Polaris-ButtonGroup__Item {
  margin-left: 0.75rem;
}

.BC-Page__SearchAnalytics__SearchesWithoutResults__Pagination .Polaris-Button {
  background-color: #fff;
}

.BC-Page__SearchAnalytics__SearchTerms .BC-Link__Dashboard {
  color: #2c6ecb;
}

.BC__IgnoreIPs-List {
  display: flex;
  list-style-type: none;
  flex-wrap: wrap;
  margin: 1.375rem -0.8125rem 0 -0.8125rem;
  -webkit-padding-start: 0;
  padding-inline-start: 0;
}

.BC__IgnoreIPs-Item {
  flex: 0 0 10rem;
  background-color: #f4f6f8;
  display: flex;
  padding-left: 0.75rem;
  margin: 0.625rem 0.75rem;
  align-items: center;
  border-radius: 5px;
}

.BC__IgnoreIPs-Item.is-new {
  background-color: #d7f2ff;
}

.BC__IgnoreIPs-Item.is-new .BC__IgnoreIPs--Value .Polaris-TextStyle--variationSubdued {
  color: #084e8a;
}

.BC__IgnoreIPs-Item.is-new
  .BC__IgnoreIPs--Remove
  .Polaris-Button--plain.Polaris-Button--iconOnly
  svg {
  fill: #084e8a;
}

.BC__IgnoreIPs-Item.is-new
  .BC__IgnoreIPs--Remove
  .Polaris-Button--plain.Polaris-Button--iconOnly:hover
  svg,
.BC__IgnoreIPs-Item.is-new
  .BC__IgnoreIPs--Remove
  .Polaris-Button--plain.Polaris-Button--iconOnly:active
  svg {
  fill: #212b36;
}

.BC__IgnoreIPs--Remove {
  margin-left: auto;
  line-height: 0;
}

.BC__IgnoreIPs--Remove .Polaris-Icon {
  width: 21px;
  height: 21px;
}

.BC__IgnoreIPs--Remove .Polaris-Button--plain.Polaris-Button--iconOnly {
  margin: 0;
  margin-left: 0.75rem;
  min-width: 0;
  min-height: 0;
  height: 28px;
  padding: 0 0.25rem;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.BC__IgnoreIPs--Remove:hover .Polaris-Button--plain.Polaris-Button--iconOnly {
  background-color: #c4cdd5;
}

.BC__IgnoreIPs-Item.is-new
  .BC__IgnoreIPs--Remove:hover
  .Polaris-Button--plain.Polaris-Button--iconOnly {
  background-color: #b4e0fa;
}

.BC__IgnoreIPs--Value .Polaris-Caption {
  font-size: 0.75rem;
  line-height: 21px;
  height: 22px;
}

.BC-chart .Polaris-Heading,
.BC-analytics-table .Polaris-Heading,
.BC-chart-table .Polaris-Heading,
.BC-chart-impact .Polaris-Heading,
.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-Heading,
.BC-Page__SearchAnalytics__SearchesWithoutResults .Polaris-Heading,
.BC-Page__SearchAnalytics__SearchTerms .Polaris-Heading,
.BC-Page__SearchAnalytics__ProductPerformance .Polaris-Heading,
.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-Heading,
.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-Heading,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-Heading,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-Heading,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-Heading,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-Heading,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-Heading,
.BC-Page__AnalyticSettings .Polaris-Heading {
  border-bottom: 3px dotted #dfe3e8;
  display: inline-block;
}

.BC-chart-table .BC-chart .Polaris-Heading,
.BC-chart-table .BC-analytics-table .Polaris-Heading {
  border-bottom: none;
}

.BC-chart--transparent .Polaris-Card {
  background: transparent;
  box-shadow: none;
}

.BC-chart .Polaris-Card__Section {
  padding-top: 12px;
}

.BC-chart .BC-chart__overall,
.BC-chart-table .BC-chart__overall,
.BC-chart-impact .BC-chart__overall,
.BC-chart-impact .BC-chart-impact__extraData__overall {
  display: flex;
  align-items: baseline;
}

.BC-chart .BC-chart__total,
.BC-chart-table .BC-chart__total,
.BC-chart-impact .BC-chart__total {
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;
  color: #202223;
}

.BC-chart-impact .BC-chart-impact__extraData__total {
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
}

.BC-Page__AppImpact .total-metrics .BC-chart__percent-growth {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #202223;
  display: flex;
  align-items: center;
}

.BC-chart .BC-chart__percent-growth,
.BC-chart-table .BC-chart__percent-growth,
.BC-chart-impact .BC-chart__percent-growth,
.BC-chart-impact .BC-chart-impact__percent-growth {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #202223;
  margin-left: 12px;
  display: flex;
  align-items: center;
}

.BC-Page__AppImpact .total-metrics .BC-chart__percent-growth .Polaris-Icon {
  margin: unset;
}

.BC-Page__AppImpact .total-metrics .BC-chart__percent-growth--up,
.BC-chart .BC-chart__percent-growth--up,
.BC-chart-table .BC-chart__percent-growth--up,
.BC-chart-impact .BC-chart__percent-growth--up,
.BC-chart-impact .BC-chart-impact__percent-growth--up {
  color: #008060;
}

.BC-Page__AppImpact .total-metrics .BC-chart__percent-growth--up svg path,
.BC-chart .BC-chart__percent-growth--up svg path,
.BC-chart-table .BC-chart__percent-growth--up svg path,
.BC-chart-impact .BC-chart__percent-growth--up svg path,
.BC-chart-impact .BC-chart-impact__percent-growth--up {
  fill: #008060;
}

.BC-Page__AppImpact .total-metrics .BC-chart__percent-growth--down,
.BC-chart .BC-chart__percent-growth--down,
.BC-chart-table .BC-chart__percent-growth--down,
.BC-chart-impact .BC-chart__percent-growth--down,
.BC-chart-impact .BC-chart-impact__percent-growth--down {
  color: #d72c0d;
}

.BC-Page__AppImpact .total-metrics .BC-chart__percent-growth--down svg path,
.BC-chart .BC-chart__percent-growth--down svg path,
.BC-chart-table .BC-chart__percent-growth--down svg path,
.BC-chart-impact .BC-chart__percent-growth--down svg path,
.BC-chart-impact .BC-chart-impact__percent-growth--down svg path {
  fill: #d72c0d;
}

.BC-chart-impact__extraData__wrapper {
  padding-top: 36px;
}

.BC-chart-impact__extraData {
  margin-bottom: 32px;
}

.BC-chart-impact__extraData:last-child {
  margin-bottom: 0;
}

.BC-chart-impact__extraData__title {
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-transform: uppercase;
  color: #202223;
  padding-bottom: 2px;
  margin-bottom: 10px;
  border-bottom: 1px dashed #dfe3e8;
  display: inline-block;
}

.BC-chart .custom-tooltip .custom-tooltip-title {
  padding: 8px 10px;
  background: #eceff1;
  border-bottom: 1px solid #ddd;
  font-size: 12px;
  font-weight: 500;
  color: #202223;
}

.BC-chart .custom-tooltip .custom-tooltip-series-group {
  text-align: left;
  justify-content: left;
  align-items: center;
  padding: 8px 10px;
  order: 1;
  display: flex;
}

.BC-chart .custom-tooltip-marker {
  margin-right: 6px;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  position: relative;
  top: 0;
}

.BC-chart .custom-tooltip-text {
  flex-grow: 1;
}

.BC-chart .custom-tooltip-y-group {
  display: flex;
  justify-content: space-between;
}

.BC-chart .custom-tooltip-text-y-label {
  color: #202223;
  font-weight: 400;
  font-size: 13px;
  margin-right: 2.25rem;
  line-height: 16px;
}

.BC-chart .custom-tooltip-text-y-value {
  color: #202223;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
}

.BC-chart .apexcharts-legend-marker {
  top: 1px !important;
}

.BC-analytics-table .Polaris-DataTable {
  border: 1px solid #e1e3e5;
  border-radius: 6px;
}

.BC-analytics-table--transparent .Polaris-Card {
  background: transparent;
  box-shadow: none;
}

.BC-analytics-table .Polaris-DataTable__Cell--header {
  font-weight: 500;
}

.BC-analytics-table--small .Polaris-DataTable__Cell {
  padding: var(--p-space-3) var(--p-space-4);
}

.BC-table-product-performance .BC-analytics-table tbody .Polaris-DataTable__Cell {
  padding: var(--p-space-2) var(--p-space-4);
  vertical-align: middle;
}

.BC-table-product-performance .BC-analytics-table .Polaris-DataTable__Cell--firstColumn {
  width: 56px;
}

.BC-table-product-performance .BC-analytics-table tr td:nth-child(2) {
  width: 56px;
  padding-right: 0;
}

.BC-table-product-performance .BC-analytics-table tr td:nth-child(2) .Polaris-Thumbnail {
  margin-left: auto;
}

.BC-table-product-performance .BC-analytics-table tr td:nth-child(3) {
  white-space: normal;
}

.BC-table-product-performance .BC-analytics-table tr td:nth-child(4) {
  width: 160px;
}

.BC-chart-table .Polaris-Card__Section,
.BC-chart-impact .Polaris-Card__Section {
  padding-top: var(--p-space-3);
}

.BC-chart-table .BC-chart--transparent .Polaris-Heading,
.BC-chart-table .BC-analytics-table--transparent .Polaris-Heading {
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-transform: uppercase;
}

.BC-chart-table .BC-chart__overall {
  margin-bottom: var(--p-space-6);
}

.BC-chart-impact .BC-chart__overall {
  margin-bottom: var(--p-space-4);
}

.BC-chart-table .BC-chart .Polaris-Card__Header,
.BC-chart-table .BC-analytics-table .Polaris-Card__Header,
.BC-chart-impact .BC-chart .Polaris-Card__Header {
  padding: 0;
}

.BC-chart-table .BC-chart .Polaris-Card__Section,
.BC-chart-table .BC-analytics-table .Polaris-Card__Section,
.BC-chart-impact .BC-chart .Polaris-Card__Section {
  padding: var(--p-space-4) 0 0;
}

.BC-chart-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

/* In App */

.BC-Page__Q1-Beta-Features .featureBox .Polaris-Card,
.BC-Page__Q1-Beta-Features .featureBox .Polaris-Card-Hover {
  box-shadow: none;
}

.BC-Page__Q1-Beta-Features .featureIconImg {
  float: left;
}

.BC-Page__Q1-Beta-Features .feature .featureBox {
  padding: 1.25rem;
}

.BC-Page__Q1-Beta-Features .featureIconImg .Polaris-Icon {
  width: 24px;
  height: 24px;
}

.BC-Page__Q1-Beta-Features .featureContent {
  display: grid;
  padding-left: 1.25rem;
}

.BC-Page__Q1-Beta-Features .BC-Image__Q1-Beta-Features {
  width: 100%;
}

.BC-Page__Q1-Beta-Features .Polaris-List {
  line-height: 24px;
}

.BC-Page__Q1-Beta-Features .Polaris-Layout__Section--oneThird {
  flex: 1 1 21.25rem;
  margin-top: 2rem;
  align-self: flex-end;
}

.BC-Autocomplete__TextContainer .Polaris-TextContainer .Polaris-Stack {
  margin-top: -0.5rem;
}

.BC-Autocomplete__Wrapper {
  position: relative;
}

.BC-Autocomplete__Wrapper .BC-Autocomplete__Backdrop {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 50;
}

.BC-Draggable__Container,
.BC-Custom__Container {
  padding: grid;
  overflow: auto;
  white-space: normal;
  margin-top: 0.25rem;
}

.BC-Autocomplete__TextContainer .BC-Draggable__Container {
  max-height: 200px;
}

.BC-Autocomplete__TextContainer .BC-Draggable__Container::-webkit-scrollbar {
  width: 8px;
}

.BC-Autocomplete__TextContainer .BC-Draggable__Container::-webkit-scrollbar-track {
  background: #ebebeb;
  border-radius: 4px;
}

.BC-Autocomplete__TextContainer .BC-Draggable__Container::-webkit-scrollbar-thumb {
  background: #cccccc;
  border-radius: 4px;
}

.BC-Draggable__Tag,
.BC-Custom__Tag {
  margin: 0 0.25rem 0.25rem 0;
  height: 1.375rem;
  min-height: 1.375rem;
  font-size: 0.75rem;
}

.BC-Draggable__Tag {
  cursor: grab;
}

.BC-Draggable__Tag:active {
  cursor: grabbing;
}

.BC-Draggable__Tag.sortableHelper {
  cursor: grabbing !important;
  pointer-events: fill;
  display: none;
}

.BC-Draggable__Tag.sortableHelper.isDragging {
  display: block;
}

.BC-Draggable__Tag .Polaris-Tag__Button {
  width: 1.5625rem;
  height: 1.5625rem;
  margin-left: 0;
  cursor: inherit;
}

.BC-Draggable__Tag .Polaris-Tag__Button:hover,
.BC-Custom__Tag .Polaris-Tag__Button:hover {
  background: none;
}

.BC-Draggable__Tag .Polaris-Tag__Button .Polaris-Icon {
  width: 0.9375rem;
  height: 0.9375rem;
}

.BC-Draggable__Tag button svg {
  fill: #212b36;
}

.BC-Custom__Container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.BC-Custom__ButtonMore .Polaris-Button {
  min-height: 1.25rem;
  padding: 0 0.5rem;
  margin: 0 -0.5rem;
}

/* Metafield */
.BC-Page__Metafield .Polaris-DataTable__Cell:first-child {
  width: 30%;
}

.BC-Page__Metafield .Polaris-DataTable__Cell:nth-child(2) {
  width: 30%;
}

.BC-Page__Metafield .addNew {
  padding: 1.25rem;
  border-top: 0.0625rem solid var(--p-divider);
  text-align: right;
}

.BC-Page__Metafield .addNew .Polaris-Button__Text {
  font-weight: 600;
}

.BC-Modal__Metafield .Polaris-FormLayout__Item .appliesTo_Name {
  margin-bottom: 5px;
}

.BC-Modal__Metafield .analytics-select-popover button {
  margin-top: 5px;
}

.BC-Modal__Metafield .switch-input-mode {
  margin-top: 5px;
}

.BC-Page__Metafield .BC-Page__Bottom-Text {
  margin-top: 1.5rem;
}

.BC-Modal__Metafield .error-message {
  display: inline-flex;
}

.BC-Modal__Metafield .error-message span:first-child {
  margin-right: 5px;
}

.Polaris-ActionList__Actions:has(.metafield-modal-popover-item) li:first-child {
  background-color: #f1f1f1;
}

.Polaris-ActionList__Actions:has(.metafield-modal-popover-item) li:first-child p {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  color: #616161;
}

.BC-Page__Metafield .Polaris-List .Polaris-List__Item,
.BC-Page__Dashboard .notification .Polaris-List .Polaris-List__Item {
  margin-bottom: 0;
}

.BC-Page__Metafield .BC-BaseBanner {
  margin-bottom: 0;
}

.BC-Page__Dashboard .liveThemeV2Banner .Polaris-List {
  list-style-type: '- ';
  list-style-position: inside;
  padding-left: 0;
}

.BC-Page__Dashboard .liveThemeV2Banner .Polaris-List__Item {
  margin: 0;
}

.BC-Page__Dashboard .liveThemeV2Banner .Polaris-Banner {
  padding-right: 16px;
}

#BC-Banner__LiveThemeV2Info ul {
  margin: 0;
  padding-left: 0.625rem;
  padding-right: 0;
  list-style-type: '- ';
}

#BC-Banner__LiveThemeV2Info ul > li::marker {
  font-weight: 600;
}

/* Custom range slider */
.BC-Page__CustomRangeSlider .Polaris-DataTable__Cell:first-child {
  width: 40%;
}

.BC-Page__CustomRangeSlider .addNew {
  padding: 1.25rem;
  border-top: 0.0625rem solid var(--p-divider);
  text-align: right;
}

.BC-Page__CustomRangeSlider .addNew .Polaris-Button__Text {
  font-weight: 600;
}

.BC-Modal__CustomRangeSlider .Polaris-FormLayout__Item:last-child {
  margin-top: 5px;
}

.BC-Page__CustomRangeSlider .BC-Page__Bottom-Text {
  margin-top: 1.5rem;
}

.BC-Modal__CustomRangeSlider .groupFields > div {
  margin-top: 1.25rem;
}

.BC-Page__CustomRangeSlider .Polaris-TextStyle--variationCode {
  font-size: 12px;
}

/* Product visibility */
.BC-Page__Product-Visibility .Polaris-DataTable__Cell:first-child {
  width: 42%;
}

.BC-Page__Product-Visibility .Polaris-DataTable__Cell:nth-child(2) {
  width: 44%;
}

.BC-Page__Product-Visibility .addNew {
  text-align: right;
  padding: 1.25rem;
  border-top: 0.0625rem solid var(--p-divider);
}

.BC-Page__Product-Visibility .addNew .Polaris-Button__Text {
  font-weight: 600;
}

.BC-Product-Visibility .Polaris-FormLayout__Item:last-child {
  margin-top: 5px;
}

.BC-Page__Product-Visibility .BC-Page__Bottom-Text {
  margin-top: 1.5rem;
}

.BC-Page__Product-Visibility .Polaris-List .Polaris-List__Item {
  margin-bottom: 0;
}

/* Custom sorting */
.BC-Page__CustomSorting .Polaris-PageActions {
  border-top: none;
}

.BC-Page__CustomSorting .addNew {
  padding: 1.25rem;
  border-top: 0.0625rem solid var(--p-divider);
  text-align: right;
}

.BC-Page__CustomSorting .addNew .Polaris-Button__Text {
  font-weight: 600;
}

.BC-Page__CustomSorting .BC-Page__Bottom-Text {
  margin-top: 1.5rem;
}

.BC-Modal__CustomSorting .groupFields > div {
  margin-top: 1.25rem;
}

.BC-Page__CustomSorting .groupFields .groupFields-item {
  margin-top: 1.5rem;
}

.BC-Page__CustomSorting .groupFields .groupFields-item .groupFields-item-child {
  margin-top: 8px;
  margin-left: 1.8125rem;
}

.BC-Page__CustomSorting .Polaris-TextStyle--variationCode {
  font-size: 12px;
}

.BC-Page__CustomSorting .Polaris-DataTable__Cell:first-child {
  width: 5%;
  padding-left: 1.25rem;
  padding-right: 0;
}

.BC-Page__CustomSorting .Polaris-DataTable__Cell:nth-child(2) {
  width: 10%;
  padding-left: 0.9375rem;
}

.BC-Page__CustomSorting .Polaris-DataTable__Cell:nth-child(3) {
  width: 25%;
}

.BC-Page__CustomSorting .Polaris-DataTable__Cell:nth-child(4) {
  width: 25%;
}

.BC-Page__CustomSorting .Polaris-DataTable__Cell:nth-child(5) {
  width: 25%;
}

.BC-Page__CustomSorting .Polaris-DataTable__Cell:nth-child(6) {
  width: 111px;
  text-align: center;
}

.BC-Page__CustomSorting .Polaris-DataTable__TableRow--disabled .label-disabled {
  display: flex;
  color: rgba(189, 193, 204, 1);
  gap: 4px;
}

.BC-Page__CustomSorting .Polaris-DataTable__TableRow--disabled .label-disabled .Polaris-Badge {
  background: rgba(255, 242, 217, 1);
  color: rgba(255, 51, 69, 1);
  border-radius: 4px;
  font-weight: 600;
  opacity: 50%;
}

.BC-Page__CustomSorting
  .Polaris-DataTable__TableRow--disabled
  .Polaris-DataTable__Cell:nth-child(4) {
  color: rgba(140, 145, 150, 1);
}

.BC-Page__CustomSorting
  .Polaris-DataTable__TableRow--disabled
  .Polaris-DataTable__Cell:nth-child(4)
  .Polaris-Icon
  svg {
  fill: rgba(186, 190, 195, 1);
}

.BC-Page__CustomSorting
  .Polaris-DataTable__TableRow--disabled
  .Polaris-DataTable__Cell-Action
  .Polaris-Button__Text {
  display: flex;
  gap: 4px;
}

.BC-Page__CustomSorting
  .Polaris-DataTable__TableRow--disabled
  .Polaris-DataTable__Cell-Action
  button {
  padding: 5px 12px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: rgba(32, 34, 35, 1);
}

.BC-Page__CustomSorting
  .Polaris-DataTable__TableRow--disabled
  .Polaris-DataTable__Cell:first-child
  .Polaris-Icon
  svg {
  fill: rgba(186, 190, 195, 1);
}

.BC-Page__CustomSorting
  .Polaris-DataTable__TableRow--disabled
  .label-disabled
  .Polaris-Badge
  > span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.BC-Page__CustomSorting .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {
  justify-content: flex-end;
}

.BC-Page__CustomSorting
  .Polaris-PageActions
  .Polaris-Stack--distributionEqualSpacing
  > .Polaris-Stack__Item {
  margin-left: 1rem;
}

.BC-Page__CustomSorting .BC-DataTable__CollectionDefaultSort {
  padding: 0 1.25rem;
  border: 1px solid var(--p-divider);
}

.BC-Page__CustomSorting .BC-DataTable__CollectionDefaultSort .Polaris-DataTable__Cell:first-child {
  width: 150px;
}

.BC-Page__CustomSorting .BC-DataTable__CollectionDefaultSort .Polaris-DataTable__Cell:nth-child(2) {
  width: auto;
}

.BC-Page__CustomSorting .BC-DataTable__CollectionDefaultSort .Polaris-DataTable__Cell:last-child {
  width: 110px;
}

.BC-Page__CustomSorting .BC-DataTable__CollectionDefaultSort .collections {
  overflow: auto;
  white-space: normal;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.BC-Page__CustomSorting .BC-DataTable__CollectionDefaultSort .collections {
}

/* Feedback at the bottom*/
.BC-Page__Analytics,
.BC-Page__FilterTree-Management,
.BC-Page__Integration,
.BC-Page__Product-Visibility,
.BC-Page__Metafield,
.BC-Page__CustomRangeSlider,
.BC-Page__CustomSorting {
  margin-bottom: 2.5rem;
}

.BC-Page__Page__Redirect-New,
.BC-Page__Merchandising .noRules {
  margin-bottom: 1.25rem;
}

.BC-Bottom__Feedback {
  display: flex;
  justify-content: center;
  padding-bottom: 5rem;
  margin-top: 4rem;
}

.BC-Bottom__Feedback > div.feedback {
  display: flex;
  align-items: center;
  padding: 12px 23px 12px 12px;
  box-sizing: border-box;
  border-radius: 31px;
}

.BC-Bottom__Feedback
  > div.feedback
  .Polaris-Button--plain
  > .Polaris-Button__Content
  .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  height: 0.9rem;
  width: 1rem;
}

.BC-Bottom__Feedback .icon {
  margin-right: 3px;
  padding: 7px;
  border-radius: 50%;
}

.BC-Bottom__Feedback .icon .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.BC-Bottom__Feedback .icon .Polaris-Icon svg {
  fill: #00a0ac;
}

/* Landing page */
.BC-Page__Landing-Page .Polaris-Card__Header {
  padding-bottom: 1.125rem;
  padding-top: 1.125rem;
  border-bottom: 0.0625rem solid var(--p-divider);
}

.BC-Page__Landing-Page .feature {
  padding-bottom: 1.25rem;
}

.BC-Page__Landing-Page .feature .Polaris-Layout,
.BC-Page__Landing-Page .feature .Polaris-Layout .Polaris-Layout__Section {
  margin-top: 0;
}

.BC-Page__Landing-Page .feature .featureBox {
  padding: 1.25rem 1.25rem 0 1.25rem;
}

.BC-Page__Landing-Page .featureIconImg {
  float: left;
}

.BC-Page__Landing-Page .featureIconImg .Polaris-Icon {
  width: 24px;
  height: 24px;
}

.BC-Page__Landing-Page .featureContent {
  display: grid;
  padding-left: 1.25rem;
}

.BC-Page__Landing-Page .BC-Image__Landing-Page {
  width: 100%;
}

.BC-Page__Landing-Page .summary {
  margin-top: 1.5rem;
}

.BC-Page__Landing-Page .summary p {
  font-size: 1rem;
}

.BC-Page__Landing-Page .summary .Polaris-List {
  line-height: 24px;
  font-size: 1rem;
}

.BC-Page__Landing-Page .summary .Polaris-List__Item {
  margin-bottom: 0rem;
}

.BC-Page__Landing-Page .Polaris-Layout__Section--oneThird {
  flex: 1 1 21.25rem;
  margin-top: 2rem;
  align-self: flex-end;
}

.BC-Page__Landing-Page .feature .Polaris-Heading {
  font-size: 0.875rem;
}

/* Theme upgrade */
.BC-Page__Theme-Upgrade .upgrade-progress {
  display: flex;
  align-items: center;
}

.BC-Page__Theme-Upgrade .upgrade-progress .Polaris-ProgressBar {
  width: 12.5rem;
}

.BC-Page__Theme-Upgrade .upgrade-progress .upgrade-inline-text {
  margin-left: 16px;
}

.BC-Page__Theme-Upgrade .tooltip {
  margin: 0;
  vertical-align: baseline;
}

.BC-Page__Theme-Upgrade .RenderSelect2__Wrapper {
  width: 358px;
}

.BC-Page__Theme-Upgrade .Polaris-SkeletonDisplayText__DisplayText {
  max-width: unset;
}

.BC-Page__Theme-Upgrade__Option2 .Polaris-ChoiceList__Title {
  margin-bottom: 12px;
}

.BC-Page__Theme-Upgrade__Option2 .Polaris-ChoiceList__Choices li:not(:first-child) {
  margin-top: 12px;
}

.BC-Page__Theme-Upgrade
  .Polaris-Page
  > div:not(.Polaris-Page-Header)
  > .Polaris-Layout
  > .Polaris-Layout__Section
  > .Polaris-Card {
  margin-top: 1.5rem;
}

.BC-Page__Theme-Upgrade .Polaris-Page-Header__RightAlign,
.BC-Page_Success .Polaris-Page-Header__RightAlign {
  display: flex;
  align-items: center;
}

@media (max-width: 400px) {
  .BC-Page__Theme-Upgrade .RenderSelect2__Wrapper {
    width: 220px;
  }
}

/* Swatch settings */
.BC-Page__SwatchSettings
  .Polaris-Page
  .Polaris-Card
  .Polaris-Card__Header
  .Polaris-Stack
  .Polaris-Stack__Item--fill {
  display: none;
}

.BC-Page__SwatchSettings
  .Polaris-Page
  .Polaris-Card
  .Polaris-Card__Header
  .Polaris-Stack
  .Polaris-Stack__Item {
  width: 100%;
}

.BC-Page__SwatchSettings .search {
  display: flex;
  min-width: 262px;
}

.BC-Page__SwatchSettings .search > div:first-child {
  width: calc(100% - 165px);
}

.BC-Page__SwatchSettings .searchOption {
  margin-top: -0.625rem;
}

.BC-Page__SwatchSettings .searchOption .item {
  display: inline-flex;
  background-color: #e4e5e7;
  padding: 4px 8px;
  border-radius: 2px;
  font-weight: 500;
}

.BC-Page__SwatchSettings .searchOption .item .value {
  padding-right: 0.75rem;
}

.BC-Page__SwatchSettings .Polaris-DataTable__Cell {
  padding: 0.9375rem 0.78125rem;
}

.BC-Page__SwatchSettings tbody .Polaris-DataTable__Cell {
  border-top: 1px solid var(--p-divider);
  border-bottom: none;
  white-space: normal;
}

.BC-Page__SwatchSettings tbody tr:first-child .Polaris-DataTable__Cell {
  border-top: none;
}

.BC-Page__SwatchSettings .Polaris-DataTable__Cell.sortable-heading,
.BC-Page__SwatchSettings .searchOption .item .remove {
  cursor: pointer;
}

.BC-Page__SwatchSettings .Polaris-DataTable__Cell.sortable-heading:hover {
  color: var(--p-action-primary);
}

.BC-Page__SwatchSettings .Polaris-DataTable__Cell.sortable-heading > span {
  display: inline-flex;
}

.BC-Page__SwatchSettings .Polaris-DataTable__Cell:first-child {
  width: 5%;
  padding-left: 1.25rem;
  padding-right: 0;
}

.BC-Page__SwatchSettings .Polaris-DataTable__Cell:nth-child(2) {
  width: 25%;
  padding-left: 0.9375rem;
  word-break: break-word;
}

.BC-Page__SwatchSettings .Polaris-DataTable__Cell:nth-child(3) {
  width: 25%;
}

.BC-Page__SwatchSettings .actionsGroup {
  position: absolute;
  right: 0px;
  top: 0px;
}

.BC-Page__SwatchSettings .swatch-color {
  width: 31px;
  height: 32px;
  border: 1px solid var(--p-divider);
}

.BC-Page__SwatchSettings .Polaris-TextField__Input {
  padding-right: 0.6875rem;
}

.BC-Page__SwatchSettings .selectedColor {
  background-color: #fff;
  z-index: 417;
  width: 25px;
  height: 25px;
  margin-right: 0;
  border-radius: 3px;
  margin-left: 0.75rem;
}

.BC-EmptySwatch {
  margin: 2.5rem 0;
}

.BC-Page__SwatchSettings .colorCode .Polaris-Stack .Polaris-Stack__Item {
  max-width: calc(50% - 1rem);
}

.swatchActionList {
  margin-left: 0.625rem;
  margin-right: 0.9375rem;
}

.swatchActionList .Polaris-Button {
  width: 168px;
}

.Polaris-ActionList__Title {
  font-size: 0.875rem;
  font-weight: normal;
  text-transform: none;
}

.Polaris-ActionList__Actions {
  border-top: none;
}

/* Sync page */
.BC-Page__SyncOverview .Polaris-Page-Header__Row .Polaris-Button--primary {
  background-color: #ffff !important;
  border: 1px solid #babfc3;
  color: #000;
}

.BC-Page__Sync .did-you-know .Polaris-List__Item {
  margin-bottom: 0;
}

.BC-Page__Sync .unlock-addon {
  width: fit-content;
  height: 40px;
  padding: 10px 12px;
}

.BC-Page__Sync .unlock-addon:hover {
  cursor: pointer;
  background-color: #fcecdb;
}

.BC-Page__Sync .unlock-addon .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
}

.BC-Sync__Content .Polaris-TextContainer > * {
  margin-top: 1.25rem;
}

.BC-Sync__Content .sync-select {
  max-width: 100%;
}

.BC-Sync__Content .sync-select div .Polaris-Select {
  min-width: 465px;
  margin-right: 16px;
}

.BC-Sync__Content .progress-status {
  display: flex;
  align-items: center;
  margin-right: -1.25rem;
}

.BC-Sync__Content .progress-bar {
  flex-basis: 40%;
  margin-right: 0.5rem;
}

.BC-Sync__Content .progress-name {
  margin-top: 12px;
}

.BC-Sync__Content .step-name {
  font-size: 12px;
  line-height: 18px;
}

.BC-Sync__Content .step-name .tooltip {
  margin-left: 2px;
  margin-right: 7px;
  margin-top: 4px;
}

.BC-Sync__Content .progress-step-item {
  margin: 1.25rem 0;
}

.BC-Sync__Content .progress-step-item .Polaris-Icon {
  float: left;
  margin-right: 8px;
}

.BC-Sync__Content .button-sync {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.BC-Sync__Content .button-sync div.button {
  min-width: 13.125rem;
}

.BC-Sync__Content .button-sync button {
  max-height: 2.25rem;
}

.BC-Sync__Content .button-sync .Polaris-Caption {
  margin-left: 1rem;
  /* color: var(--p-interactive); */
  font-size: 12px;
  line-height: 18px;
}

.BC-Sync__Content .special-sync-banner {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0.5rem;
  box-shadow:
    0px 0px 0px rgba(63, 63, 68, 0.05),
    0px 1px 3px rgba(63, 63, 68, 0.15);
  border-radius: 4px;
}

.BC-Sync__Content .special-sync-error {
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #fcf1cd;
}

.BC-Sync__Content .special-sync-success {
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #e3f1df;
}

.BC-Sync__Content .special-sync-banner span {
  margin-left: 0.9375rem;
}

.BC-Sync__Content .recent-sync {
  margin-top: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.BC-Sync__Content .completed-icon {
  width: 14px;
  height: 14px;
  margin-right: 0.3125rem;
  padding: 0;
}

.BC-Sync__Content .groupFields-flex-2 {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  margin-left: -1rem;
}

.BC-Sync__Content .groupFields-flex-2 > div {
  max-width: 100%;
  flex: 1 0 100%;
  padding-left: 1rem;
}

.BC-Sync__Content .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {
  justify-content: flex-end;
}

/* time select */
.time-select .BC-Select__control .Select__Prefix {
  margin-left: 0.75rem;
}

.time-select .BC-Select__control .Select__Prefix svg {
  fill: var(--p-icon);
}

.time-select .BC-Select__control.BC-Select__control--is-disabled .Select__Prefix svg {
  fill: var(--p-icon-disabled);
}

.BC-Sync__Content .Polaris-Badge--statusCritical .status-icon {
  background: var(--p-icon-critical);
}

.BC-Sync__Content .Polaris-Badge--statusSuccess .status-icon {
  background: var(--p-icon-success);
}

@media screen and (min-width: 1200px) {
  .BC-Sync__Content .groupFields-flex-2 > div {
    flex: 0 1 50%;
  }
}

/* Language setting page*/
.BC-Language-Setting__Content .language-setting-select {
  max-width: 164px;
}

/* Support ticket form */
.BC-Dropzone-Box {
  padding-top: 1.25rem;
}

.BC-Dropzone-ChooseFiles {
  padding-bottom: 0.9375rem;
}

.BC-Dropzone-Box .tooltip {
  margin-top: 9px;
  margin-left: 5px;
  display: -webkit-inline-flex;
  display: inline-flex;
  vertical-align: top;
}

.search-fields-footer .external-link,
.BC-Page__Theme-Setup .external-link,
.BC-AnotherLayout .external-link {
  display: -webkit-inline-flex;
  display: inline-flex;
  margin-left: -5px;
  vertical-align: top;
}

.BC-SupportTicket__Form .BC-Dropzone-Box {
  padding-top: 0.1875rem;
}

.BC-SupportTicket__Form .BC-Dropzone-ChooseFiles {
  padding-bottom: 0;
}

.BC-SupportTicket__Form .attachFiles .Polaris-Button--sizeSlim {
  margin-left: 0.9375rem;
}

.BC-SupportTicket__Form .Polaris-DropZone__Container {
  cursor: default;
  padding: 0.625rem;
}

.BC-SupportTicket__Form
  .Polaris-DropZone__Container
  .Polaris-Stack
  > .Polaris-Stack__Item
  .Polaris-Stack__Item:nth-child(2) {
  width: 400px;
}

.BC-SupportTicket__Form .Polaris-DropZone::after {
  content: '';
  position: absolute;
  z-index: 29;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 0.0625rem dashed #ccc;
  border-radius: 3px;
  pointer-events: none;
}

/* DefaultThemeSettings_Dropzone .Polaris-DropZone::after {
  content: '';
  position: absolute;
  z-index: 29;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 0.0625rem dashed #fafbfb;
  border-radius: 3px;
  pointer-events: none;
} */

.BC-DefaultThemeSettings_Dropzone .Polaris-DropZone--hasOutline {
  background-color: #fafbfb;
}

@media (max-width: 46.5em) {
  /* Override 2 columns for translation page*/
  .BC-Page__Translation .tabContent .Polaris-Stack__Item,
  .BC-Page__Translation .tabContent .Polaris-Stack__Item:last-child {
    width: 100%;
    float: none;
  }
}

/* Typeform survey */
.button-feedback-survey {
  position: fixed;
  top: calc(50% - 250px);
  right: 0;
  transition: width 300ms ease-out;
  width: 0;
}

.button-feedback-survey a {
  box-sizing: border-box;
  position: absolute;
  top: 300px;
  width: 200px;
  height: 48px;
  padding: 0 20px;
  margin: 0;
  cursor: pointer;
  background: #fa6b05;
  border-radius: 4px 4px 0px 0px;
  box-shadow:
    0px 2px 12px rgba(0, 0, 0, 0.06),
    0px 2px 4px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transform: rotate(-90deg);
  transform-origin: bottom left;
  color: white;
  text-decoration: none;
  z-index: 9999;
}

.button-feedback-survey a .icon {
  width: 32px;
  position: relative;
  text-align: center;
  transform: rotate(90deg) scale(0.85);
  left: -8px;
}

.button-feedback-survey a .text {
  text-decoration: none;
  font-size: 18px;
  font-family: Helvetica, Arial, sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Default theme settings */
.BC-Default-Theme-Settings .groupFields-label {
  margin-bottom: -10px;
}

.BC-Default-Theme-Settings .groupFields-content > div {
  margin-top: 1rem;
}

.BC-Default-Theme-Settings .groupFields-content > div:first-child {
  margin-top: 0rem;
}

.BC-Default-Theme-Settings
  .groupFields-label
  .Polaris-Button
  .Polaris-Button__Content
  .Polaris-Button__Icon {
  order: -1;
  margin-left: -5px;
  margin-right: 5px;
}

.BC-Default-Theme-Settings .previewPanel .title {
  border-bottom: 0.0625rem solid var(--p-divider);
  padding-top: 1rem;
  padding-bottom: 0.75rem;
}

.BC-Default-Theme-Settings .previewPanel .Polaris-Labelled__LabelWrapper {
  justify-content: center;
}

.BC-Default-Theme-Settings .previewPanel .device {
  margin: 1.25rem auto;
  text-align: center;
}

.BC-Default-Theme-Settings .previewPanel .device > div > span {
  display: flex;
}

.BC-Default-Theme-Settings .previewPanel .device > div > span:focus {
  outline: none;
}

.BC-Default-Theme-Settings .previewPanel .device > div > span .icon:hover {
  cursor: pointer;
}

.BC-Default-Theme-Settings .previewPanel .icons {
  display: inline-flex;
}

.BC-Default-Theme-Settings .previewPanel .icons .active {
  border: 2px solid var(--p-action-primary);
}

.BC-Default-Theme-Settings .previewPanel .icon.first {
  margin-right: 1.5rem;
}

.BC-Default-Theme-Settings .previewPanel .icon {
  border: 2px solid #919eab;
  border-radius: 3px;
  padding: 8px 10px;
}

.BC-Default-Theme-Settings .previewPanel .preview-content {
  padding: 0 1.25rem;
}

.BC-Default-Theme-Settings .BC-Default-Theme-Settings__General,
.BC-Default-Theme-Settings .BC-Default-Theme-Settings__ProductItem {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  margin: 0;
}

.BC-Default-Theme-Settings .BC-Default-Theme-Settings__General > div,
.BC-Default-Theme-Settings .BC-Default-Theme-Settings__ProductItem > div {
  width: calc(100% - 1.25rem);
  flex: 2 2 30rem;
}

.BC-Default-Theme-Settings .BC-Default-Theme-Settings__General > div {
  height: 43.75rem;
  overflow-y: auto;
}

.BC-Default-Theme-Settings .BC-Default-Theme-Settings__ProductItem .settings-content-tab {
  height: 43.75rem;
  overflow-y: auto;
}

.BC-Default-Theme-Settings .BC-Default-Theme-Settings__General .settings-content {
  flex: 1 1 13.75rem;
  min-width: 0;
  border-right: 0.0625rem solid var(--p-divider);
}

.BC-Default-Theme-Settings .BC-Default-Theme-Settings__ProductItem .settings-content {
  flex: 1 1 35.75rem;
  min-width: 0;
  border-right: 0.0625rem solid var(--p-divider);
}

.BC-Default-Theme-Settings .BC-Default-Theme-Settings__ProductItem .preview.product-tab {
  flex: 1 1 22.625rem;
}

.BC-Default-Theme-Settings
  .BC-Default-Theme-Settings__ProductItem
  .settings-content.product-list-tab {
  flex: 1 1 26.75rem;
}

.BC-Default-Theme-Settings .BC-Default-Theme-Settings__General .settings-content,
.BC-Default-Theme-Settings .BC-Default-Theme-Settings__ProductItem .settings-content-tab {
  padding: 1rem 1.25rem 2.5rem;
}

.BC-Default-Theme-Settings .BC-Default-Theme-Settings__General .settings-content::-webkit-scrollbar,
.BC-Default-Theme-Settings
  .BC-Default-Theme-Settings__ProductItem
  .settings-content-tab::-webkit-scrollbar {
  width: 8px;
}

.BC-Default-Theme-Settings
  .BC-Default-Theme-Settings__General
  .settings-content::-webkit-scrollbar-track,
.BC-Default-Theme-Settings
  .BC-Default-Theme-Settings__ProductItem
  .settings-content-tab::-webkit-scrollbar-track {
  background: #ebebeb;
}

.BC-Default-Theme-Settings
  .BC-Default-Theme-Settings__General
  .settings-content::-webkit-scrollbar-thumb,
.BC-Default-Theme-Settings
  .BC-Default-Theme-Settings__ProductItem
  .settings-content-tab::-webkit-scrollbar-thumb {
  background: #cccccc;
  border-radius: 4px;
}

.BC-Default-Theme-Settings .BC-Default-Theme-Settings__General .settings-content ul li {
  margin-bottom: 0.75rem;
}

.BC-Default-Theme-Settings .BC-Default-Theme-Settings__General .settings-content ul li:last-child {
  margin-bottom: 0rem;
}

.BC-Default-Theme-Settings .breakLine {
  border-top: 1px solid var(--p-divider);
}

.BC-Default-Theme-Settings .groupFields-content .Polaris-Stack--vertical {
  flex-wrap: nowrap;
}

.BC-Default-Theme-Settings .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {
  justify-content: flex-end;
}

.BC-Default-Theme-Settings .Polaris-FormLayout .Polaris-FormLayout__Item {
  margin-top: 1.25rem;
}

.BC-Default-Theme-Settings
  .Polaris-FormLayout
  .Polaris-FormLayout__Item
  .Polaris-Labelled__LabelWrapper {
  margin-bottom: 0;
}

.BC-Default-Theme-Settings .Polaris-FormLayout .Polaris-ChoiceList__Choices {
  margin-bottom: -0.25rem;
}

.BC-Default-Theme-Settings .Polaris-FormLayout .Polaris-Choice__Label .Polaris-Label {
  padding-bottom: 0rem;
}

.BC-Default-Theme-Settings .Polaris-FormLayout .Polaris-Label {
  padding-bottom: 0.25rem;
}

.BC-Default-Theme-Settings .Polaris-FormLayout .Polaris-Button .Polaris-Label {
  padding-bottom: 0;
}

.BC-Default-Theme-Settings
  .Polaris-FormLayout
  .Polaris-Button
  .tooltip
  .Polaris-Icon--colorBase
  svg {
  fill: var(--p-icon);
}

.BC-Default-Theme-Settings .Polaris-FormLayout .sectionLabel .Polaris-Label {
  padding-bottom: 0.5rem;
}

.BC-Default-Theme-Settings .groupFields-flex-2,
.BC-Default-Theme-Settings .render-choice-flex-3 ul {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  margin-left: -1rem;
}

.BC-Default-Theme-Settings .groupFields-flex-2 > div,
.BC-Default-Theme-Settings .render-choice-flex-3 ul li {
  max-width: 100%;
  flex: 1 0 100%;
  padding-left: 1rem;
}

@media screen and (min-width: 1200px) {
  .BC-Default-Theme-Settings .groupFields-flex-2 > div {
    flex: 0 1 50%;
  }

  .BC-Default-Theme-Settings .render-choice-flex-3 ul li {
    flex: 0 1 33.33%;
  }
}

.BC-Default-Theme-Settings .range-slider-input .Polaris-Connected > div:first-child,
.BC-Widget-Editor-Page .range-slider-input .Polaris-Connected > div:first-child {
  align-self: center;
}

.BC-Default-Theme-Settings .range-slider-input .Polaris-Connected > div:last-child {
  margin-left: 0.375rem;
  width: 4.5rem;
  max-width: 4.5rem;
}

.BC-Default-Theme-Settings .range-slider-input .Polaris-Connected > div:first-child {
  width: 288px;
}

.BC-Default-Theme-Settings
  .groupFields-flex-2
  .range-slider-input
  .Polaris-Connected
  > div:last-child {
  width: 4rem;
  max-width: 4rem;
}

.BC-Default-Theme-Settings
  .groupFields-flex-2
  .range-slider-input
  .Polaris-Connected
  > div:first-child {
  width: 180px;
}

.BC-Default-Theme-Settings .subText {
  margin-top: 6px;
}

.BC-Default-Theme-Settings #product-item-tab .Polaris-Layout__Section--oneThird {
  flex: 1 1 20.875rem;
}

@media (min-width: 30.625em) {
  .BC-Illustration-Image__Dashboard {
    display: block;
  }

  .BC-Page__Dashboard .menuBox .Polaris-Card {
    box-shadow: none;
    min-height: 5.75rem;
  }

  .BC-Page__Dashboard .menuBox .Polaris-Card-Hover {
    background-color: #f4f6f8;
    min-height: 5.75rem;
    box-shadow: none;
  }

  .BC-Page__Dashboard .BC-Iframe-Container__Wrapper {
    margin-bottom: 0.75rem;
    margin-top: 1.375rem;
  }

  .BC-ThemeSetup__DashboardV3 .Polaris-Card,
  .BC-CalloutCard-ThemeSetup__Dashboard .Polaris-Card,
  .BC-CalloutCard-Subscription__Dashboard .Polaris-Card,
  .BC-CalloutCard-ExpReviewRating__Dashboard .Polaris-Card {
    min-height: 162px;
  }

  .BC-CalloutCard-ThemeSetup__Dashboard .firstCol {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding-right: 1rem;
  }

  .BC-ThemeSetup__DashboardV3 .secondCol,
  .BC-CalloutCard-ThemeSetup__Dashboard .secondCol {
    display: flex;
    justify-self: flex-end;
  }

  .BC-CalloutCard-ExpReviewRating__Dashboard .secondCol {
    position: absolute;
    left: 257px;
    top: 0.75rem;
  }

  .BC-CalloutCard-ExpReviewRating__Dashboard .secondCol.lowRating {
    position: absolute;
    left: 257px;
  }

  .BC-ThemeSetup__DashboardV3 .secondCol img {
    width: 140px;
  }

  .BC-CalloutCard-ThemeSetup__Dashboard .secondCol img {
    width: 148px;
  }

  .BC-CalloutCard-ExpReviewRating__Dashboard .firstCol {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding-right: 0.375rem;
  }

  .BC-CalloutCard-ExpReviewRating__Dashboard .secondCol img {
    width: 164px;
  }

  .BC-CalloutCard-ExpReviewRating__Dashboard .Polaris-FormLayout .Polaris-TextField textarea {
    height: 60px !important;
  }

  .BC-CalloutCard-ExpReviewRating__Dashboard .Polaris-TextContainer > *:not(:first-child) {
    margin-top: 9px;
  }

  /* Filter tree page */
  .BC-Page__FilterTree-Item .Polaris-Page-Header__Actions {
    margin-top: 0;
  }

  .BC-DataTable__FilterOptions {
    margin: -1.25rem;
  }

  /* Filter tree page: Action on page header */
  .BC-Page__FilterTree-Item .Polaris-Header-Title__TitleAndSubtitleWrapper {
    max-width: 85%;
  }

  .BC-Page__FilterTree-Item .Polaris-Header-Title__TitleAndSubtitleWrapper:empty {
    margin-top: 2rem;
  }

  /* Theme setup */
  .BC-Page__Theme-Setup .Polaris-ResourceList__ResourceListWrapper {
    margin: -1.25rem;
  }

  /* Merge values */
  .BC-DataTable__MergeValuesOptions,
  .BC-DataTable__MergeValues {
    margin: -1.25rem;
  }

  /* Instant search display */
  .BC-Page__InstantSearchDisplay .BC-Page__Fields,
  .BC-Page__SearchSettings .BC-Page__Fields {
    margin-top: -1.25rem;
  }

  .BC-Page__InstantSearchDisplay .BC-Page__Fields > div.tabs {
    margin: 1.25rem -1.25rem -1.25rem;
  }

  /* Stop word */
  .BC__StopWords-Add .Polaris-Stack .Polaris-Stack__Item:first-child {
    flex: 0 0 21.5rem;
  }

  /* In app */
  .BC-Page__Q1-Beta-Features .featureBox .Polaris-Card {
    box-shadow: none;
    min-height: 100px;
  }

  .BC-Page__Q1-Beta-Features .featureBox .Polaris-Card-Hover {
    background-color: #f4f6f8;
    min-height: 100px;
    box-shadow: none;
  }

  .BC-Page__Q1-Beta-Features .feature {
    display: table;
  }

  .BC-Page__Q1-Beta-Features .feature .featureBox {
    display: table-cell;
    width: 50%;
  }

  .BC-Analytics__Total .section {
    padding: 1rem;
  }

  /* Search setting */

  .BC-Page__SearchSettings .btn-reset {
    position: absolute;
    right: 1.25rem;
    top: 1.0625rem;
  }

  /* Custom sorting */
  .BC-Page__CustomSorting .addNew.top {
    position: absolute;
    right: 1.25rem;
    top: 1.0625rem;
    border-top: none;
    padding: 0;
  }

  /* Translation */
  .BC-Page__Translation .search {
    padding: 1.25rem 1.25rem 0.75rem;
  }
}

@media (min-width: 29.0625rem) {
  .BC-Page__Button-HasBreadcrumb {
    top: 2.875rem;
  }
}

/* Custom cuss for Preview filte tree*/
.bc-sf-filter-preview-inner {
  padding: 1.5rem;
  height: 300px;
}

#bc-sf-filter-tree:not(.bc-sf-filter-tree-mobile-open) {
  display: inherit !important;
}

.bc-sf-filter-preview-inner:not(.bc-sf-filter-mobile-wrapper) #bc-sf-filter-tree {
  display: block;
}

#bc-sf-filter-tree .bc-sf-filter-option-block .bc-sf-filter-block-title {
  position: relative;
  overflow: inherit;
}

.bc-sf-filter-mobile-wrapper #bc-sf-filter-tree {
  display: none;
}

.bc-sf-filter-mobile-wrapper #bc-sf-filter-tree-mobile,
.bc-sf-filter-mobile-wrapper
  .bc-sf-filter-block-content
  .bc-sf-filter-option-range-slider.no-ruler
  .noUi-marker-normal {
  display: block !important;
}

#bc-sf-filter-tree.hide {
  display: none !important;
}

#bc-sf-filter-tree-h .bc-sf-filter-option-block .bc-sf-filter-block-content {
  position: inherit;
  width: 900px;
}

.bc-sf-filter-block-content .noUi-connect {
  width: auto !important;
}

.bc-sf-filter-block-content .noUi-horizontal .noUi-origin {
  z-index: 5;
}

#bc-sf-filter-tree .bc-sf-filter-option-block .bc-sf-filter-block-content ul li a,
#bc-sf-filter-tree-h .bc-sf-filter-option-block .bc-sf-filter-block-content ul li a,
#bc-sf-filter-tree-h .bc-sf-filter-option-block .bc-sf-filter-block-title a {
  color: #3d4246;
}

#bc-sf-filter-tree-h .bc-sf-filter-option-block .bc-sf-filter-block-title a {
  display: inline-block;
  padding-top: 7px;
  margin-bottom: 5px;
  font-weight: 700;
}

#bc-sf-filter-tree-h .bc-sf-filter-option-single-list,
#bc-sf-filter-block-content-my-tag {
  width: 100% !important;
}

.bc-sf-filter-option-block-sub_category h3 {
  font-size: 1.25em;
}

.bc-sf-filter-option-block-sub_category .bc-sf-filter-option-single-list ul {
  padding-left: 1.25rem;
}

.previewPanel .overflow-vertical {
  overflow-x: hidden;
  overflow-y: auto;
}

.previewPanel .overflow-horizontal {
  overflow-x: auto;
  overflow-y: auto;
}

#bc-sf-filter-tree-h .bc-sf-filter-option-view-more,
#bc-sf-filter-tree-h .bc-sf-filter-option-view-less {
  display: none;
}

.bc-sf-filter-tooltip-wrapper {
  z-index: 9999;
}

.bc-sf-filter-option-view-less,
.bc-sf-filter-option-view-more {
  color: #3d4246;
}

.bc-sf-filter-option-block .bc-sf-filter-block-content .bc-sf-filter-option-swatch li a {
  position: relative;
}

.bc-sf-filter-option-swatch-image {
  z-index: 10;
  position: relative;
}

.bc-sf-filter-option-swatch-image + span {
  content: '';
  background-image: url('https://cdn.boostcommerce.io/assets/filter-tree/bc-sf-filter-no-image-2.png');
  display: block !important;
  width: 30px;
  height: 30px;
  position: absolute;
  top: 0;
  left: 0px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-size: cover;
  border-radius: 50%;
  z-index: 5;
}

.bc-sf-filter-option-block
  .bc-sf-filter-block-content
  .bc-sf-filter-option-swatch
  li
  a:hover
  .bc-sf-filter-option-swatch-image
  + span {
  border: 2px solid #000;
}

.bc-sf-filter-option-block
  .bc-sf-filter-block-content
  .bc-sf-filter-option-box
  li
  .bc-sf-filter-option-amount {
  margin: 0;
}

#bc-sf-filter-tree
  .bc-sf-filter-option-block[data-show-more-type*='scrollbar']
  .bc-sf-filter-block-content {
  max-height: 220px;
}

.bc-sf-filter-option-show-search-box {
  padding: 10px;
  width: 100%;
  border: 1px solid #e3e3e3;
  height: 30px;
  line-height: 30px;
}

.bc-sf-filter-option-block[data-show-search-box-pc='true']
  .bc-sf-filter-option-show-search-box-wrapper,
.bc-sf-filter-option-block[data-show-search-box-mobile='true']
  .bc-sf-filter-option-show-search-box-wrapper {
  margin-top: 15px;
}

@media (min-width: 40em) {
  .BC-Page__Merge-Value .Polaris-DisplayText .Polaris-Button__Content {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .Polaris-SkeletonDisplayText--sizeSmall {
    height: 1.5rem;
  }

  .Polaris-Header-Title {
    font-size: 1.75rem;
  }
}

@media (max-width: 56.5em) {
  /* Override 2 columns for translation page*/
  .BC-Page__Translation .Polaris-Stack__Item {
    margin-left: 0.9375rem;
  }
}

@media (min-width: 48em) {
  .Polaris-DataTable__TableRow.hover .Polaris-DataTable__Cell {
    background: #f9fafb;
    background: var(--p-surface-hovered, #f9fafb);
  }
}

@media (max-width: 48.0525em) {
  .Polaris-Modal-Dialog__Modal {
    bottom: 0;
    max-height: calc(100vh - 100px);
    margin-bottom: 85px;
  }
}

/* PFSN-3806 */
.Polaris-Popover--measuring .Polaris-Popover__Content {
  display: flex !important;
}

/* Youtube modal */
#youtubeModal-Backdrop {
  position: fixed;
  z-index: 519;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: rgba(33, 43, 54, 0.4);
}

#youtubeModal-Content {
  position: relative;
  display: flex;
  background-color: black;
}

#youtubeModal-Button {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  padding: 0;
  background: none;
  border: none;
  min-width: unset;
  min-height: unset;
  cursor: pointer;
}

#youtubeModal-Button img {
  width: 28px;
  height: auto;
}

/* Polaris V6 */
.Polaris-Header-Title__TitleWithMetadataWrapper {
  align-items: baseline;
}

.cardTitle {
  display: flex;
  align-items: baseline;
}

.Polaris-Badge--statusInfo {
  font-size: 0.75rem;
}

.subscribe_badge .Polaris-Badge--statusInfo,
.planStatus .Polaris-Badge--statusInfo {
  font-size: 13px;
  font-weight: 400;
  color: var(--p-text);
}

.Container--flexHorizontal {
  display: flex;
  flex-direction: row;
}

.Container--flexVertical {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.Polaris-Page-Header {
  padding-top: 2.5rem;
}

.Polaris-Icon--colorWhite svg {
  fill: white;
}

.BC-Page__Verify-Setup .Polaris-Card__Header {
  padding: 1.5rem 1.5rem 0;
}

.BC-Page__Verify-Setup .Polaris-Card__Section {
  padding: 1.5rem;
}

.BC-Page__Verify-Setup .Polaris-Stack > .Polaris-Stack__Item {
  display: flex;
}

.BC-Page__Verify-Setup .Polaris-Stack > .Polaris-Stack__Item:not(:first-child) {
  margin-top: 1.5rem;
}

.BC-Page__Verify-Setup .Polaris-FormLayout__Item:not(:first-child) {
  margin-top: 1.5rem;
}

.BC-page_Demographic .Polaris-Card__Header {
  padding: 1.5rem 1.5rem 0;
}

.BC-page_Demographic .Polaris-FormLayout__Item:not(:first-child) {
  margin-top: 1.5rem;
}

.BC-page_Demographic .Polaris-Card__Section {
  padding: 1.5rem;
}

.BC-page_Demographic .Polaris-Card__Footer {
  padding: 0 1.5rem 1.5rem;
}

.SelectIndustries .SelectIndustries__value-container {
  /* custom-select-kind-service: select */
  min-height: 56px;
  padding-top: 10px;
  padding-bottom: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.SelectIndustries .SelectIndustries__control {
  /* custom-select-kind-service: border when not focus */
  border: 1px solid #a1a3ad !important;
  border-radius: 8px !important;
}

.SelectIndustries .SelectIndustries__control--menu-is-open {
  /* custom-select-kind-service: border when focus */
  border-color: #ff3000 !important;
  box-shadow: 0 0 0 1px #ff3000 !important;
}

.SelectIndustries .SelectIndustries__menu-list > div {
  /* custom-select-kind-service: item of list */
  height: 40px;
  padding: 0 10px 0 5px;
}

.SelectIndustries .SelectIndustries__menu-list .tag-wrapper {
  /* custom-select-kind-service: label when show popover */
  display: flex;
  height: 40px;
  align-items: center;
  padding-left: 5px;
}

.SelectIndustries .SelectIndustries__option {
  /* custom-select-kind-service: remove bg when use key up or down */
  background: unset !important;
}

.SelectIndustries .SelectIndustries__option--is-focused .tag-wrapper,
.SelectIndustries .SelectIndustries__option:hover .tag-wrapper {
  /* custom-select-kind-service: mouse on item */
  background: #ffefeb;
  cursor: pointer;
  border-radius: 4px;
}

.SelectIndustries .SelectIndustries__multi-value {
  /* custom-select-kind-service: tag selected */
  padding: 6px 8px;
  gap: 8px;
  background: #f1f2f3;
  border-radius: 4px;
  font-weight: 400;
  font-size: 16px;
}

.SelectIndustries .SelectIndustries__multi-value .SelectIndustries__multi-value__remove:hover {
  /* custom-select-kind-service: tag icon remove selected */
  background: none;
}

.SelectIndustries .SelectIndustries__multi-value .SelectIndustries__multi-value__remove svg {
  /* custom-select-kind-service: tag icon remove */
  fill: white;
  border-radius: 50%;
  background: #5c5f62;
  cursor: pointer;
}

.SelectIndustries .SelectIndustries__indicators {
  /* custom-select-kind-service: hide action */
  display: none !important;
}

.SelectRevenue .SelectRevenue__control {
  border-radius: 8px;
  cursor: pointer;
}

.SelectRevenue .SelectRevenue__value-container {
  height: 48px;
}

.SelectRevenue .SelectRevenue__placeholder {
  color: #292929;
}

.SelectRevenue .SelectRevenue__control--is-focused {
  border-color: #ff3000 !important;
  box-shadow: 0 0 0 1px #ff3000 !important;
}

.SelectRevenue .SelectRevenue__indicators {
  display: none;
}

.SelectRevenueWrapper {
  position: relative;
}

.SelectRevenueWrapper .down-icon {
  width: 30px;
  height: 30px;
  position: absolute;
  right: 10px;
  top: 10px;
}

.SelectRevenueWrapper .down-icon .Polaris-Icon {
  width: 30px;
  height: 30px;
}

.SelectRevenue .SelectRevenue__menu-list > div {
  /* custom-select-kind-service: item of list */
  height: 40px;
  padding: 0 10px 0 5px;
}

.SelectRevenue .SelectRevenue__menu-list .tag-wrapper {
  /* custom-select-kind-service: label when show popover */
  display: flex;
  height: 40px;
  align-items: center;
  padding-left: 5px;
}

.SelectRevenue .SelectRevenue__option--is-focused {
  /* custom-select-kind-service: remove bg when use key up or down */
  background: unset !important;
}

.SelectRevenue .tag-wrapper {
  border-radius: 4px;
}

.SelectRevenue .SelectRevenue__option--is-focused .tag-wrapper,
.SelectRevenue .SelectRevenue__option:hover .tag-wrapper {
  /* custom-select-kind-service: mouse on item */
  background: #ffefeb;
  cursor: pointer;
  border-radius: 4px;
}

.SelectRevenue .SelectRevenue__option--is-selected .tag-wrapper {
  background-color: #ff8366 !important;
}

.SelectRevenue .SelectRevenue__option.SelectRevenue__option--is-selected:hover .tag-wrapper {
  background-color: #f16243 !important;
}

.SelectRevenue .SelectRevenue__option.SelectRevenue__option--is-selected {
  background: none !important;
}

.feedback-form .Polaris-ChoiceList__Title {
  margin-bottom: 0.5rem;
}

body:has(* .ModalRedirect) .Polaris-Modal-Dialog__Modal .Polaris-Modal-CloseButton {
  display: none;
}

.feedback-form .Polaris-ChoiceList__Title {
  margin-bottom: 0.5rem;
}

.feedback-form .Polaris-ChoiceList__Choices > li:not(:last-child) > .Polaris-Choice > * {
  margin-bottom: 0.75rem;
}

.BC-Welcome__Dashboard .Polaris-Layout__Section {
  margin-top: 1rem;
}

#BC-Container__Empty {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#BC-Container__Empty img {
  width: 9.25rem;
}

#BC-Container__Empty .Polaris-EmptyState__ImageContainer {
  padding-bottom: 2rem;
}

/* Fix language */
.BC__Lang-en .BC-Page__Subscription .BC_DataTable_Plans th.Polaris-DataTable__Cell:last-child {
  padding: 0.625rem 2.25rem;
}

/* React tooltip */
.extraTooltipClass {
  pointer-events: auto !important;
  padding: 0 !important;
  font-size: inherit !important;
  opacity: 1 !important;
}

.extraTooltipClass:hover {
  visibility: visible !important;
  opacity: 1 !important;
}

.extraTooltipClass::after,
.extraTooltipClass::before {
  content: none !important;
}

.extraTooltipClass.place-top {
  margin-top: -5px !important;
}

.select-with-tooltip-option > span {
  display: block;
  margin: -8px -12px;
  padding: 8px 12px;
}

.select-with-tooltip-option .extraTooltipClass {
  width: 198px;
  padding: 8px;
  margin-left: 20px !important;
}

.select-with-tooltip-option .extraTooltipClass img {
  width: 100%;
}

.visual-editor-right-panel .extraTooltipClass {
  width: 198px;
  padding: 8px;
  margin-left: 20px !important;
}

.visual-editor-right-panel .extraTooltipClass img {
  width: 100%;
}

.proceedUpdatePermissionBtn .Polaris-Link {
  color: white !important;
}

.render-choice-2 {
  padding-bottom: 1.1875rem;
}

.render-choice-2 .Polaris-ChoiceList__Choices li {
  display: flex;
}

.render-choice-2 .Polaris-ChoiceList__Choices .Polaris-ChoiceList__ChoiceChildren {
  padding: 0;
}

.ReactCollapse--collapse {
  transition: height 300ms;
}

.BC-Page__SearchAnalytics .BC-Page__Search_ActionSearchTermDetail {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

/* Revert theme survey flow v2 */
.BC-Page__SearchAnalytics .BC-Page__Search_ActionSearchTermDetail__Title {
  margin-right: 10px;
}

/**/

.BC-Page__SearchAnalytics .BC-Page__Search_ActionSearchTermDetail {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.BC-Page__SearchAnalytics .BC-Page__Search_ActionSearchTermDetail__Title {
  margin-right: 10px;
}

.BC-Page__SearchAnalytics .BC-Page__SearchAnalytics__SearchTermDetail__Pagination {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
}

.BC-Page__SearchAnalytics .BC-Page__SearchAnalytics__SearchTermDetail__Pagination > div.empty {
  width: 200px;
}

.BC-Page__SearchAnalytics .BC-Page__SearchAnalytics__ProductPerformance__Pagination {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.BC-Page__CollectionAnalytics .BC-Page__CollectionAnalytics__CollectionPerformance__Pagination,
.BC-Page__CollectionAnalytics .BC-Page__CollectionAnalytics__FilterOptionValue__Pagination,
.BC-Page__CollectionAnalytics
  .BC-Page__CollectionAnalytics__FilterOptionValueCombination__Pagination,
.BC-Page__RecommendationAnalytics .BC-Page__RecommendationAnalytics__Top__Page__Pagination,
.BC-Page__RecommendationAnalytics .BC-Page__RecommendationAnalytics__Top__Widget__Pagination,
.BC-Page__RecommendationAnalytics .BC-Page__RecommendationAnalytics__Top__Product__Pagination,
.BC-Page__PreOrderAnalytics .BC-Page__PreOrderAnalytics__Top__Product__Pagination,
.BC-Page__PreOrderAnalytics .BC-Page__PreOrderAnalytics__Top__Product__Pagination {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.BC-Page__SearchAnalytics .BC-Page__Search_ActionSearchTermDetail .Polaris-Button {
  margin-right: 10px;
  width: 40px;
}

.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Cell--header {
  font-weight: 500 !important;
  border-bottom: 0.0625rem solid var(--p-divider);
}

.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Cell--header {
  font-weight: 500 !important;
  border-bottom: 0.0625rem solid var(--p-divider);
}

.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Cell--header div {
  font-weight: 500;
}

.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Cell {
  vertical-align: middle;
}

.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Cell:first-child {
  width: 60%;
}

.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Cell:nth-child(2) {
  width: 20%;
}

.BC-Page__SearchAnalytics__SearchTerms thead .Polaris-DataTable__Cell:last-child {
  text-align: right;
}

.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Cell--header div {
  font-weight: 500;
}

.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Cell {
  vertical-align: middle;
}

.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Cell:first-child {
  width: 60%;
}

.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Cell:nth-child(2) {
  width: 20%;
  text-align: end;
}

.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Cell:nth-child(3) {
  width: 20%;
  text-align: end;
}

.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Cell:nth-child(3) {
  width: 20%;
  text-align: end;
}

.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Icon > .Polaris-Icon {
  display: none;
}

.BC-Page__SearchAnalytics__SearchTerms .header-with-sortable {
  display: flex;
}

.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Navigation {
  display: none;
}

.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Navigation {
  display: none;
}

.BC-Page__SearchAnalytics__SearchTermDetail .product-image {
  width: 40px;
  height: 40px;
  padding-bottom: 40px;
  position: relative;
  border: 1px solid var(--p-divider);
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
}

.BC-Page__SearchAnalytics__SearchTermDetail .product-image img,
.BC-Page__SearchAnalytics__ProductPerformance .product-image img,
.BC-Page__SearchAnalytics__ProductPerformance .product-image img {
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  border-radius: 4px;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Heading:focus,
:hover {
  outline: none;
}

.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Cell--header {
  font-weight: 500 !important;
  border-bottom: 0.0625rem solid var(--p-divider);
}

.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Cell--header div {
  font-weight: 500;
}

.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Cell {
  vertical-align: middle;
}

.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Cell:first-child {
  width: 48px;
  padding-right: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Cell:nth-child(2) {
  width: 60%;
  padding-left: 0.5rem;
}

.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Cell:nth-child(2) button {
  margin-left: 0;
  padding-left: 0;
}

.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Icon > .Polaris-Icon {
  display: none;
}

.BC-Page__SearchAnalytics__SearchTermDetail .header-with-sortable {
  display: flex;
}

.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Heading:focus,
:hover {
  outline: none;
}

.BC-Page__SearchAnalytics__SearchTermDetail__DidYouKnow .did-you-know p {
  margin-bottom: 10px;
}

.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Icon > .Polaris-Icon {
  display: none;
}

.BC-Page__SearchAnalytics__SearchesWithoutClicks .header-with-sortable {
  display: flex;
}

.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Heading:focus,
:hover {
  outline: none;
}

.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Navigation {
  display: none;
}

.BC-Page__SearchAnalytics__ProductPerformance .Polaris-Card__Footer {
  padding-top: 15px;
  border-top: var(--p-border-divider);
}

.BC-Page__SearchAnalytics__ProductPerformance .action-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 16px;
  height: 64px;
}

.BC-Page__SearchAnalytics__ProductPerformance .cell-value-table {
  text-align: right;
}

.BC-Page__SearchAnalytics__ProductPerformance .product-image {
  width: 40px;
  height: 40px;
  padding-bottom: 40px;
  position: relative;
  border: 1px solid var(--p-divider);
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
}

.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Cell--header {
  font-weight: 500 !important;
  border-bottom: 0.0625rem solid var(--p-divider);
}

.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Cell--header div {
  font-weight: 500;
}

.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Cell {
  vertical-align: middle;
}

.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Cell:first-child {
  width: 48px;
  padding-right: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Cell:nth-child(2) {
  width: 60%;
  padding-left: 0.5rem;
  max-width: 200px;
}

.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Cell:nth-child(2) > div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Cell:nth-child(2) button {
  margin-left: 0;
  padding-left: 0;
}

.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Cell:nth-child(2) button {
  margin-left: 0;
  padding-left: 0;
}

.BC-Page__SearchAnalytics__ProductPerformance th.Polaris-DataTable__Cell:last-child > div {
  text-align: right;
  display: block;
}

.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Icon > .Polaris-Icon {
  display: none;
}

.BC-Page__SearchAnalytics__ProductPerformance .header-with-sortable {
  display: flex;
}

.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Heading:focus,
:hover {
  outline: none;
}

.BC-Page__SearchAnalytics__ProductPerformance__DidYouKnow .did-you-know p {
  margin-bottom: 10px;
}

/* Collection analytic */

.CollectionAnalyticActionList button.Polaris-Button {
  width: 100%;
}

.CollectionAnalyticActionList button.Polaris-Button .Polaris-Button__Content {
  /* Style for export collection modal when choose collection */
  display: flex;
  justify-content: space-between;
}

.CollectionAnalyticActionList__Search {
  margin: 10px 10px 0;
}

.CollectionAnalyticActionList__Popup {
  width: 420px;
  height: 314px;
}

.CollectionAnalyticActionList__Popup .Polaris-ActionList__Item.Polaris-ActionList--active::before {
  background-color: #008060;
}

.CollectionAnalyticActionList__Popup .Polaris-ActionList__Item.Polaris-ActionList--active {
  background-color: #f1f8f5;
}

.CollectionAnalyticActionList__Popup .Polaris-ActionList__Suffix {
  display: none;
}

.CollectionAnalyticActionList__Popup .Polaris-TextField {
  --p-focused: #008060;
}

.BC-Page__SearchAnalytics__SearchTerms .Polaris-TextStyle--variationSubdued,
.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-TextStyle--variationSubdued,
.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-TextStyle--variationSubdued,
.BC-Page__SearchAnalytics__SearchesWithoutResults .Polaris-TextStyle--variationSubdued,
.BC-Page__SearchAnalytics__ProductPerformance .Polaris-TextStyle--variationSubdued,
.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-TextStyle--variationSubdued,
.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-TextStyle--variationSubdued,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-TextStyle--variationSubdued,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-TextStyle--variationSubdued,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-TextStyle--variationSubdued,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-TextStyle--variationSubdued,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-TextStyle--variationSubdued {
  color: black;
}

.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Navigation,
.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Navigation,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-DataTable__Navigation {
  display: none;
}

/* .BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Navigation,
.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Navigation,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-DataTable__Navigation,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Navigation,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Navigation,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Navigation {
  display: none;
} */

.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-Card__Footer,
.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-Card__Footer,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-Card__Footer,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-Card__Footer,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-Card__Footer,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-Card__Footer,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-Card__Footer {
  padding-top: 15px;
  border-top: var(--p-border-divider);
}

.BC-Page__CollectionAnalytics__CollectionPerformance .action-header,
.BC-Page__CollectionAnalytics__FilterOptionValue .action-header,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .action-header,
.BC-Page__RecommendationAnalytics__Top__Page .action-header,
.BC-Page__RecommendationAnalytics__Top__Widget .action-header,
.BC-Page__RecommendationAnalytics__Top__Product .action-header,
.BC-Page__PreOrderAnalytics__Top__Product .action-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 16px;
  height: 64px;
}

.BC-Page__CollectionAnalytics__CollectionPerformance .cell-value-table,
.BC-Page__CollectionAnalytics__FilterOptionValue .cell-value-table,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .cell-value-table,
.BC-Page__RecommendationAnalytics__Top__Page .cell-value-table,
.BC-Page__RecommendationAnalytics__Top__Widget .cell-value-table,
.BC-Page__RecommendationAnalytics__Top__Product .cell-value-table,
.BC-Page__PreOrderAnalytics__Top__Product .cell-value-table {
  text-align: right;
}

.BC-Page__CollectionAnalytics__CollectionPerformance .product-image,
.BC-Page__CollectionAnalytics__FilterOptionValue .product-image,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .product-image,
.BC-Page__RecommendationAnalytics__Top__Page .product-image,
.BC-Page__RecommendationAnalytics__Top__Widget .product-image,
.BC-Page__RecommendationAnalytics__Top__Product .product-image {
  width: 40px;
  height: 40px;
  padding-bottom: 40px;
  position: relative;
  border: 1px solid var(--p-divider);
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
}

.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Cell--header,
.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Cell--header,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-DataTable__Cell--header,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell--header,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell--header,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell--header,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell--header {
  font-weight: 500 !important;
  border-bottom: 0.0625rem solid var(--p-divider);
}

.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Cell--header div,
.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Cell--header div,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-DataTable__Cell--header div,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell--header div,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell--header div,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell--header div,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell--header div {
  font-weight: 500;
}

.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Cell,
.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Cell,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-DataTable__Cell,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell {
  vertical-align: middle;
}

.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Cell:first-child,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell:first-child,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell:first-child,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell:first-child,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:first-child {
  width: 60%;
  padding-right: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Cell:first-child,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-DataTable__Cell:first-child,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell:first-child,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell:first-child,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell:first-child,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:first-child {
  width: 80%;
  padding-right: 0.5rem;
}

.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Cell:last-child,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-DataTable__Cell:last-child,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell:last-child,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell:last-child,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell:last-child,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:last-child {
  text-align: right;
}

.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Cell:nth-child(2) > div,
.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Cell:nth-child(2) > div,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination
  .Polaris-DataTable__Cell:nth-child(2)
  > div,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell:nth-child(2) > div,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell:nth-child(2) > div,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(2) > div,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(2) > div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Cell:nth-child(2) button,
.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Cell:nth-child(2) button,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination
  .Polaris-DataTable__Cell:nth-child(2)
  button,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell:nth-child(2) button,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell:nth-child(2) button,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(2) button,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(2) button {
  margin-left: 0;
  padding-left: 0;
}

.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Cell:nth-child(2) button,
.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Cell:nth-child(2) button,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination
  .Polaris-DataTable__Cell:nth-child(2)
  button,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell:nth-child(2) button,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell:nth-child(2) button,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(2) button,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(2) button {
  margin-left: 0;
  padding-left: 0;
}

.BC-Page__CollectionAnalytics__CollectionPerformance th.Polaris-DataTable__Cell:last-child > div,
.BC-Page__CollectionAnalytics__FilterOptionValue th.Polaris-DataTable__Cell:last-child > div,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination
  th.Polaris-DataTable__Cell:last-child
  > div,
.BC-Page__RecommendationAnalytics__Top__Page th.Polaris-DataTable__Cell:last-child > div,
.BC-Page__RecommendationAnalytics__Top__Widget th.Polaris-DataTable__Cell:last-child > div,
.BC-Page__RecommendationAnalytics__Top__Product th.Polaris-DataTable__Cell:last-child > div,
.BC-Page__PreOrderAnalytics__Top__Product th.Polaris-DataTable__Cell:last-child > div {
  text-align: right;
  display: block;
}

.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Icon > .Polaris-Icon,
.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Icon > .Polaris-Icon,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination
  .Polaris-DataTable__Icon
  > .Polaris-Icon,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Icon > .Polaris-Icon,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Icon > .Polaris-Icon,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Icon > .Polaris-Icon,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Icon > .Polaris-Icon {
  display: none;
}

.BC-Page__CollectionAnalytics__CollectionPerformance .header-with-sortable,
.BC-Page__CollectionAnalytics__FilterOptionValue .header-with-sortable,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .header-with-sortable,
.BC-Page__RecommendationAnalytics__Top__Page .header-with-sortable,
.BC-Page__RecommendationAnalytics__Top__Widget .header-with-sortable,
.BC-Page__RecommendationAnalytics__Top__Product .header-with-sortable,
.BC-Page__PreOrderAnalytics__Top__Product .header-with-sortable {
  display: flex;
}

.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Heading:focus,
:hover,
.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Heading:focus,
:hover,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-DataTable__Heading:focus,
:hover,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Heading:focus,
:hover,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Heading:focus,
:hover,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Heading:focus,
:hover,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Heading:focus,
:hover {
  outline: none;
}

.BC-Page__CollectionAnalytics__CollectionPerformance__DidYouKnow .did-you-know p,
.BC-Page__CollectionAnalytics__FilterOptionValue__DidYouKnow .did-you-know p,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination__DidYouKnow .did-you-know p,
.BC-Page__RecommendationAnalytics__Top__Page .did-you-know p,
.BC-Page__RecommendationAnalytics__Top__Widget .did-you-know p,
.BC-Page__RecommendationAnalytics__Top__Product .did-you-know p,
.BC-Page__PreOrderAnalytics__Top__Product .did-you-know p {
  margin-bottom: 10px;
}

.BC-Page__CollectionAnalytics__Overview .filter-option,
.BC-Page__CollectionAnalytics__FilterOptionValue .filter-option,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .filter-option,
.BC-Page__RecommendationAnalytics__Top__Page .filter-option,
.BC-Page__RecommendationAnalytics__Top__Widget .filter-option,
.BC-Page__RecommendationAnalytics__Top__Product .filter-option,
.BC-Page__PreOrderAnalytics__Top__Product .filter-option {
  display: flex;
  margin: 2.5px auto;
}

.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable--hoverable:has(.cell-highlight) {
  background: var(--p-surface-hovered) !important;
}

.BC-Page__RecommendationAnalytics__Top__Widget
  .Polaris-DataTable--hoverable
  th:has(.cell-highlight) {
  background: var(--p-surface-hovered) !important;
}

.BC-Page__CollectionAnalytics__Overview .filter-option.filter-option-small-table {
  max-width: 250px;
  margin: 0;
}

.BC-Page__CollectionAnalytics__Overview
  .filter-option.filter-option-small-table
  .filter-option-value {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.BC-Page__CollectionAnalytics__Overview .filter-option .filter-option-label,
.BC-Page__CollectionAnalytics__FilterOptionValue .filter-option .filter-option-label,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .filter-option .filter-option-label,
.BC-Page__RecommendationAnalytics__Top__Page .filter-option .filter-option-label,
.BC-Page__RecommendationAnalytics__Top__Widget .filter-option .filter-option-label,
.BC-Page__RecommendationAnalytics__Top__Product .filter-option .filter-option-label,
.BC-Page__PreOrderAnalytics__Top__Product .filter-option .filter-option-label {
  min-width: var(--width);
}

.BC-Page__CollectionAnalytics__FilterOptionValueCombination .filter-option .filter-option-label {
  margin-right: 6px;
}

.BC-Page__CollectionAnalytics__Overview .filter-option .filter-option-value,
.BC-Page__CollectionAnalytics__FilterOptionValue .filter-option .filter-option-value,
.BC-Page__CollectionAnalytics__FilterOptionValueCombination .filter-option .filter-option-value,
.BC-Page__RecommendationAnalytics__Top__Page .filter-option .filter-option-value,
.BC-Page__RecommendationAnalytics__Top__Widget .filter-option .filter-option-value,
.BC-Page__RecommendationAnalytics__Top__Product .filter-option .filter-option-value,
.BC-Page__PreOrderAnalytics__Top__Product .filter-option .filter-option-value {
  font-weight: 600;
  color: #008060;
}

.BC-Page__CollectionAnalytics__Overview
  .BC-analytics-table--small
  .Polaris-DataTable__Cell:first-child {
  width: 60px;
}

.BC-Page__CollectionAnalytics__Overview
  .BC-analytics-table--small
  td.Polaris-DataTable__Cell:last-child {
  justify-items: center;
  position: relative;
}

.BC-Page__CollectionAnalytics__Overview
  .BC-analytics-table--small
  td.Polaris-DataTable__Cell:last-child
  .total-click {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
  padding-right: var(--p-space-4);
}

/* Collection: collection performance END */

.BC-analytics-table__ProductPerformance .Polaris-DataTable__Cell {
  vertical-align: middle;
}

.BC-analytics-table__ProductPerformance .Polaris-DataTable__Cell:first-child {
  width: 50px;
}

.BC-analytics-table__ProductPerformance .Polaris-DataTable__Cell:nth-child(2) {
  width: 40px;
  padding: var(--p-space-1);
}

.BC-analytics-table__ProductPerformance .Polaris-DataTable__Cell:last-child {
  text-align: right;
  width: 200px;
}

.BC-analytics-table__ProductPerformance .product-image {
  width: 40px;
  height: 40px;
  padding-bottom: 40px;
  position: relative;
  border: 1px solid var(--p-divider);
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
}

.BC-analytics-table__ProductPerformance .product-image img {
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  border-radius: 4px;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

/* START: Recommendation analytics v2 */
.BC-Page__RecommendationAnalytics .Polaris-Page-Header {
  padding-bottom: 0;
}

.BC-Page__RecommendationAnalytics .BC-Page__RecommendationAnalytics--Help {
  display: flex;
  gap: 2px;
  margin-bottom: var(--p-space-4);
  color: #6d7175;
  font-size: 12px;
}

.BC-Page__RecommendationAnalytics .BC-Page__RecommendationAnalytics--Help .line {
  margin: 0 6px;
  opacity: 0.5;
}

.BC-Page__RecommendationAnalytics .BC-Page__RecommendationAnalytics--Help span {
  cursor: pointer;
}

.BC-Page__RecommendationAnalytics .BC-Page__RecommendationAnalytics--Help svg {
  width: 16px;
  height: 16px;
}

.BC-Page__RecommendationAnalytics__Overview .Table__Recommendation__Top--Page .Polaris-Card,
.BC-Page__RecommendationAnalytics__Overview .Table__Recommendation__Top--Widget .Polaris-Card,
.BC-Page__RecommendationAnalytics__Overview .Table__Recommendation__Top--Product .Polaris-Card {
  min-height: 313px;
}

.BC-Page__RecommendationAnalytics__Overview
  .Table__Recommendation__Top--Page
  .Polaris-DataTable__Cell:first-child {
  /* 120px is width of Total revenue */
  max-width: calc(260px - max(var(--maxCharacter) * 10px, 120px));
  padding-right: 2px;
}

.BC-Page__RecommendationAnalytics__Overview
  .Table__Recommendation__Top--Widget
  .Polaris-DataTable__Cell:first-child {
  /* 120px is width of Total revenue */
  max-width: calc(260px - max(var(--maxCharacter) * 12px, 140px));
  padding-right: 2px;
}

.BC-Page__RecommendationAnalytics__Overview
  .Table__Recommendation__Top--Product
  .Polaris-DataTable__Cell:first-child {
  /* 120px is width of Total revenue */
  max-width: calc(260px - max(var(--maxCharacter) * 10px, 120px));
  padding-right: 2px;
}

.BC-Page__RecommendationAnalytics__Top__Page .Polaris-Card > .Polaris-DataTable--condensed,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-Card > .Polaris-DataTable--condensed,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-Card > .Polaris-DataTable--condensed,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-Card > .Polaris-DataTable--condensed {
  display: flex;
  flex-direction: column-reverse;
}

.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Navigation,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Navigation,
.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Navigation,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Navigation {
  height: 50px;
  padding: 0;
  padding-right: var(--p-space-4);
  border-top: var(--p-border-divider);
}

.BC-Page__RecommendationAnalytics__Top__Page
  .Polaris-DataTable__Table
  thead
  tr:first-child
  th:first-child,
.BC-Page__RecommendationAnalytics__Top__Widget
  .Polaris-DataTable__Table
  thead
  tr:first-child
  th:first-child {
  text-align: center;
}

.BC-Page__RecommendationAnalytics__Top__Page
  .Polaris-DataTable__Table
  thead
  tr:first-child
  th:nth-child(2)
  .Polaris-DataTable__Icon--custom,
.BC-Page__RecommendationAnalytics__Top__Page
  .Polaris-DataTable__Table
  thead
  tr:first-child
  th:nth-child(3)
  .Polaris-DataTable__Icon--custom,
.BC-Page__RecommendationAnalytics__Top__Page
  .Polaris-DataTable__Table
  thead
  tr:first-child
  th:nth-child(4)
  .Polaris-DataTable__Icon--custom,
.BC-Page__RecommendationAnalytics__Top__Widget
  .Polaris-DataTable__Table
  thead
  tr:first-child
  th:nth-child(2)
  .Polaris-DataTable__Icon--custom,
.BC-Page__RecommendationAnalytics__Top__Widget
  .Polaris-DataTable__Table
  thead
  tr:first-child
  th:nth-child(3)
  .Polaris-DataTable__Icon--custom,
.BC-Page__RecommendationAnalytics__Top__Widget
  .Polaris-DataTable__Table
  thead
  tr:first-child
  th:nth-child(4)
  .Polaris-DataTable__Icon--custom {
  text-align: center;
  display: none;
}

.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Heading,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Heading {
  padding-top: 0;
  padding-bottom: 0;
}

.BC-Page__RecommendationAnalytics__Top__Page
  table
  thead
  tr:nth-child(2)
  .Polaris-DataTable__Heading,
.BC-Page__RecommendationAnalytics__Top__Widget
  table
  thead
  tr:nth-child(2)
  .Polaris-DataTable__Heading,
.BC-Page__RecommendationAnalytics__Top__Product
  table
  thead
  tr:nth-child(1)
  .Polaris-DataTable__Heading,
.BC-Page__PreOrderAnalytics__Top__Product table thead tr:nth-child(1) .Polaris-DataTable__Heading {
  padding-right: 0;
}

.BC-Page__RecommendationAnalytics__Top__Page
  .Polaris-DataTable__Navigation
  .Polaris-DataTable__Pip:nth-child(2),
.BC-Page__RecommendationAnalytics__Top__Page
  .Polaris-DataTable__Navigation
  .Polaris-DataTable__Pip:nth-child(3),
.BC-Page__RecommendationAnalytics__Top__Page
  .Polaris-DataTable__Navigation
  .Polaris-DataTable__Pip:nth-child(4),
.BC-Page__RecommendationAnalytics__Top__Page
  .Polaris-DataTable__Navigation
  .Polaris-DataTable__Pip:nth-child(5),
.BC-Page__RecommendationAnalytics__Top__Widget
  .Polaris-DataTable__Navigation
  .Polaris-DataTable__Pip:nth-child(2),
.BC-Page__RecommendationAnalytics__Top__Widget
  .Polaris-DataTable__Navigation
  .Polaris-DataTable__Pip:nth-child(3),
.BC-Page__RecommendationAnalytics__Top__Widget
  .Polaris-DataTable__Navigation
  .Polaris-DataTable__Pip:nth-child(4),
.BC-Page__RecommendationAnalytics__Top__Widget
  .Polaris-DataTable__Navigation
  .Polaris-DataTable__Pip:nth-child(5) {
  display: none;
}

.BC-Page__RecommendationAnalytics__Top__Page
  .Polaris-DataTable__Table
  thead
  tr:first-child
  th:nth-child(2),
.BC-Page__RecommendationAnalytics__Top__Widget
  .Polaris-DataTable__Table
  thead
  tr:first-child
  th:nth-child(2) {
  padding-top: 10px;
  padding-bottom: 10px;
}

.BC-Page__RecommendationAnalytics__Top__Page
  .Polaris-DataTable__Table
  thead
  tr:first-child
  th:first-child,
.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Table tbody tr th:first-child,
.BC-Page__RecommendationAnalytics__Top__Widget
  .Polaris-DataTable__Table
  thead
  tr:first-child
  th:first-child,
.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Table tbody tr th:first-child {
  position: sticky;
  left: 0;
  z-index: 2;
  background: white;
}

.BC-Page__RecommendationAnalytics__Top__Widget
  .Polaris-DataTable__Table
  thead
  tr:first-child
  th:last-child,
.BC-Page__RecommendationAnalytics__Top__Widget
  .Polaris-DataTable__Table
  tbody
  .Polaris-DataTable__Cell:last-child,
.BC-Page__RecommendationAnalytics__Top__Page
  .Polaris-DataTable__Table
  thead
  tr:first-child
  th:last-child,
.BC-Page__RecommendationAnalytics__Top__Page
  .Polaris-DataTable__Table
  tbody
  .Polaris-DataTable__Cell:last-child {
  position: sticky;
  right: 0;
  z-index: 2;
  background: white;
}

.BC-Page__RecommendationAnalytics__Top__Widget
  .Polaris-DataTable__Table
  tbody
  .Polaris-DataTable__Cell:last-child
  .Polaris-Button {
  padding: 8px;
}

.BC-Page__RecommendationAnalytics__Top__Page tbody .Polaris-DataTable__TableRow:hover th,
.BC-Page__RecommendationAnalytics__Top__Widget tbody .Polaris-DataTable__TableRow:hover th,
.BC-Page__RecommendationAnalytics__Top__Page tbody .Polaris-DataTable__TableRow:hover td,
.BC-Page__RecommendationAnalytics__Top__Widget tbody .Polaris-DataTable__TableRow:hover td {
  background: var(--p-surface-hovered) !important;
}

.BC-Page__RecommendationAnalytics__Top__Product .product-image img,
.BC-Page__PreOrderAnalytics__Top__Product .product-image img {
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  border-radius: 4px;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell:first-child,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:first-child {
  width: 48px;
  padding-right: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:first-child {
  min-width: 300px;
}

.BC-Page__PreOrderAnalytics__Top__Product
  .BC-Page__PreOrders-Table
  .Polaris-DataTable__Cell:first-child {
  min-width: 110px;
  padding-right: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.BC-Page__PreOrderAnalytics__Top__Product
  .BC-Page__PreOrders-Table
  .Polaris-DataTable__Cell:nth-child(1) {
  text-align: left;
}

.BC-Page__PreOrderAnalytics__Top__Product
  .BC-Page__PreOrders-Table
  .Polaris-DataTable__Cell:nth-child(2) {
  max-width: 200px;
  width: 180px;
  padding-left: 0.5rem;
}

.BC-Page__PreOrderAnalytics__Top__Product
  .BC-Page__PreOrders-Table
  .Polaris-DataTable__Cell:nth-child(3) {
  max-width: 200px;
  width: 180px;
  padding-left: 0.5rem;
}

.BC-Page__PreOrderAnalytics__Top__Product
  .BC-Page__PreOrders-Table
  .Polaris-DataTable__Cell:nth-child(4) {
  max-width: 120px;
  width: 120px;
  padding-left: 0.5rem;
}

.BC-Page__PreOrderAnalytics__Top__Product
  .BC-Page__PreOrders-Table
  .Polaris-DataTable__Cell:nth-child(5) {
  max-width: 280px;
  width: 280px;
  padding-left: 0.5rem;
}

.BC-Page__PreOrderAnalytics__Top__Product
  .BC-Page__PreOrders-Table
  .Polaris-DataTable__Cell:nth-child(2)
  > div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.BC-Page__PreOrderAnalytics__Top__Product
  .BC-Page__PreOrders-Table
  .Polaris-DataTable__Cell:nth-child(2)
  button {
  margin-left: 0;
  padding-left: 0;
}

.BC-Page__PreOrderAnalytics__Top__Product
  .BC-Page__PreOrders-Table
  .Polaris-DataTable__Cell:last-child {
  text-align: right;
}

.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(2),
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(2) {
  width: 60%;
  padding-left: 0.5rem;
  max-width: 160px;
}

.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(1) a {
  text-decoration: none;
}

.BC-Page__PreOrderAnalytics__Top__Product
  .Polaris-DataTable__Cell:nth-child(2)
  .Polaris-SkeletonDisplayText__DisplayText,
.BC-Page__PreOrderAnalytics__Top__Product
  .Polaris-DataTable__Cell:nth-child(3)
  .Polaris-SkeletonDisplayText__DisplayText,
.BC-Page__PreOrderAnalytics__Top__Product
  .Polaris-DataTable__Cell:nth-child(4)
  .Polaris-SkeletonDisplayText__DisplayText {
  float: right;
  min-width: 80px;
}

.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Navigation,
.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Navigation {
  display: none;
}

.BC-Page__PreOrderAnalytics__Top__Product .pre-orders-date-picker {
  margin: 24px 0;
}

.BC-Page__PreOrderAnalytics__Top__Product
  .pre-orders-date-picker
  .date-select-picker
  .Polaris-Button__Text {
  margin-left: 0.75rem;
}

.BC-Page__PreOrderAnalytics__Top__Product .pre-orders-date-picker .Polaris-Button__Text {
  font-weight: 400;
}

.BC-Page__PreOrderAnalytics__Top__Product .Polaris-Button--plain svg {
  fill: var(--p-icon);
}

#PolarisPortalsContainer .Polaris-Link {
  text-decoration: none;
}

#PolarisPortalsContainer .Polaris-Icon {
  margin: unset;
  display: inline-flex;
  vertical-align: top;
}

.BC-Page__RecommendationAnalytics__Top__Page
  .header-with-sortable[aria-sort='ascending']
  .Polaris-Icon,
.BC-Page__RecommendationAnalytics__Top__Widget
  .header-with-sortable[aria-sort='ascending']
  .Polaris-Icon {
  transform: rotate(180deg);
}

/* END: Recommendation analytics v2 */

/* Recommended features in ANALYTICS */
.BC-Analytic--RecommendedFeatures {
  display: flex;
  gap: 20px;
}

.BC-Analytic--RecommendedFeatures .feature {
  max-width: 332px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.BC-Analytic--RecommendedFeatures .feature .content > p:first-child {
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  margin-bottom: 4px;
}

.BC-Analytic--RecommendedFeatures .feature .Polaris-Button {
  width: 100%;
  padding: 13px;
  font-weight: 500;
}

.BC-Analytic--RecommendedFeatures .action-locked {
  background-color: #ffc96b;
  display: flex;
  justify-content: center;
  gap: 2px;
  box-shadow: 0px -1px 0px 0px #00000033 inset;
  padding: 12px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
}

/* START: Analytic settings */

.BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Action {
  display: flex;
  justify-content: flex-start;
  gap: 30px;
}

.BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Action .Polaris-TextField__Input {
  width: 430px;
}

@media (max-width: 640px) {
  .BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Action {
    flex-direction: column;
  }

  .BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Action .Polaris-TextField__Input {
    width: 100%;
  }
}

.BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__List {
  padding-bottom: 10px;
  padding-top: 30px;
  display: grid;
  gap: 10px 10px;
  grid-template-columns: repeat(auto-fill, minmax(194px, 1fr));
}

.BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Item {
  height: 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 12px;
  background: #f6f6f7;
  border-radius: 4px;
  max-width: 194px;
}

.BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Item:hover {
  background-color: #ecf6f1;
  cursor: pointer;
}

.BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Item .remove {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 4px;
}

.BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Item .remove .Polaris-Icon {
  width: 12px;
  height: 12px;
}

.BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Item .remove:hover {
  background-color: #aee9d1;
  border-radius: 2px;
}

.BC-Page__AnalyticSettings
  .BC-Page__AnalyticSettings__IPs__Item
  .remove:hover
  .Polaris-Icon--colorBase
  svg {
}

.BC-Page__AnalyticSettings .loading {
  animation: spinner 0.8s linear infinite;
  border: 2px solid #ccc;
  border-right-color: transparent;
  border-radius: 100%;
  display: inline-block;
  overflow: hidden;
  text-indent: -9999px;
  width: 15px;
  height: 15px;
  vertical-align: middle;
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* END: Analytic settings */

/* Revert theme survey flow v2 */

.revert-theme-all-feature-choosing-heading {
  margin-bottom: 30px;
  position: relative;
}

.revert-theme-all-feature-choosing-heading .heading {
  font-weight: 400;
  font-size: 20px;
  margin-bottom: 12px;
}

.revert-theme-all-feature-choosing-heading .hint {
  font-weight: 400;
  font-size: 14px;
  color: #6d7175;
}

.revert-theme-all-feature-choosing-heading .close {
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}

.revert-theme-all-feature-choosing-content {
  display: flex;
  border: 1px solid #e1e3e5;
  border-radius: 2px;
}

.revert-theme-all-feature-choosing-content .manual-uninstallation {
  border-right: 1px solid #e1e3e5;
}

.revert-theme-all-feature-choosing-content .manual-uninstallation,
.revert-theme-all-feature-choosing-content .automatic-uninstallation {
  display: flex;
  padding: 28px 24px;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
}

.revert-theme-all-feature-choosing-content .manual-uninstallation .content .title,
.revert-theme-all-feature-choosing-content .automatic-uninstallation .content .title {
  font-weight: 500;
  font-size: 20px;
  color: #202223;
  margin-bottom: 16px;
}

.revert-theme-all-feature-choosing-content .manual-uninstallation p,
.revert-theme-all-feature-choosing-content .automatic-uninstallation p {
  margin-bottom: 20px;
}

.modal-content-revert-survey .default-text-style {
  font-weight: 400 !important;
}

.modal-footer-clone-setting .Polaris-Stack__Item--custom .Polaris-ButtonGroup__Item {
  margin-left: 1rem;
}

.modal-content-clone-setting .clone-result {
  display: flex;
  column-gap: 12px;
  align-self: stretch;
  justify-content: space-between;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.react-select-clone-setting__menu-list {
  max-height: 250px !important;
  border-radius: 8px;
  padding: 8px !important;
}

.react-select-clone-setting__option {
  border-radius: 4px;
}

.react-select-clone-setting__option .type-theme {
  margin-bottom: 2px;
  font-size: 12px;
  color: #6d7175;
}

.react-select-clone-setting__option.react-select-clone-setting__option--is-selected p {
  color: #fff;
}

@media screen and (max-height: 800px) {
  .react-select-clone-setting__menu-list {
    max-height: 200px !important;
  }
}

@media screen and (max-height: 600px) {
  .react-select-clone-setting__menu-list {
    max-height: 150px !important;
  }
}

/* END: Revert theme survey flow v2 */

.colorPickerItem {
  display: flex;
  align-items: flex-start;
  column-gap: 10px;
  margin-bottom: 8px;
}

.colorPickerItem:last-child {
  margin-bottom: 0;
}

.colorPickerItem__box-color {
  width: 40px;
  height: 40px;
  border: 1px solid #6d7175;
  border-radius: 2px;
  cursor: pointer;
}

.colorPickerItem__box-color img {
  width: 100%;
  height: 100%;
}

.colorPickerItem .Polaris-Labelled__LabelWrapper {
  display: block;
  margin-bottom: 0;
}

.colorPickerItem .Polaris-Labelled__LabelWrapper .Polaris-Label {
  margin-bottom: 4px;
}

.colorPickerItem .Polaris-Labelled__LabelWrapper .Polaris-Color {
  color: #6d7175;
}

.colorPickerItem.disabled {
  color: #8c9196;
}

.colorPickerItem.disabled .colorPickerItem__box-color {
  cursor: not-allowed;
  opacity: 0.2;
}

.colorPickerItem.disabled .Polaris-Color {
  color: #8c9196;
}

.radio-button-2 {
  flex-grow: 1;
  flex-basis: 0;
}

.radio-button-2 input {
  display: none;
}

.radio-button-2 .Polaris-Button {
  width: 100%;
}

.radio-button-2.disabled .Polaris-Button {
  background: #fafbfb;
  color: #8c9196;
  box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.05);
  cursor: not-allowed;
}

.radio-button-2 .Polaris-Button .Polaris-Button__Text {
  font-weight: 400;
}

.radio-button-2 .Polaris-Button.checked {
  background: #008060;
  color: #fff;
}

.radio-button-2.disabled .Polaris-Button.checked {
  background: #f1f1f1;
  color: #8c9196;
}

.radio-button-2 .Polaris-Button.checked .Polaris-Icon__Svg {
  fill: #fff;
}

.radio-button-2 .Polaris-Button.checked .Polaris-Icon__Svg path {
  fill: #fff;
}

.BC-ThemeSetting-Editor-Page.theme-setting-visual-editor
  ~ #PolarisPortalsContainer
  .Polaris-Modal-Footer
  .Polaris-Stack__Item--custom
  .Polaris-ButtonGroup {
  justify-content: flex-end;
}

.BC-ThemeSetting-Editor-Page.theme-setting-visual-editor
  ~ #PolarisPortalsContainer
  .Polaris-Modal-Footer
  .Polaris-Stack__Item--custom
  .Polaris-ButtonGroup__Item {
  margin-left: 1rem;
}

@media (max-width: 1700px) {
  .BC-ThemeSetting-Editor-Page.theme-setting-visual-editor
    ~ #PolarisPortalsContainer
    .Polaris-Popover__Content {
    max-height: 300px;
  }
}

.BC-ThemeSetting-Editor-Page.theme-setting-visual-editor
  ~ #PolarisPortalsContainer
  .Polaris-Popover__PopoverOverlay {
  z-index: 1000;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .visual-editor-preview__overlay.no-padding {
  padding: 0;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .visual-editor-preview__overlay
  .ajax-cart {
  display: flex;
  flex-direction: column;
  position: absolute;
  background: #ffffff;
}

.ajax-cart--popup {
  left: 50%;
  transform: translate(-50%, 0);
  width: 732px;
  max-height: min(640px, calc(100% - 60px - 60px));
}

.ajax-cart--popup .ajax-cart__header {
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16.775px 24.4px;
  border-bottom: 0.7625px solid #e8e9eb;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.02em;
  color: #0f0f0f;
}

.ajax-cart--popup .ajax-cart__header .close-popup-btn {
  position: absolute;
  top: 22px;
  right: 22px;
}

.ajax-cart--popup .ajax-cart__cart {
  height: 378.2px;
  overflow: auto;
  padding: 24.4px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.ajax-cart--popup .ajax-cart__cart .product-item {
  display: flex;
  flex-direction: row;
  gap: 12.2px;
}

.ajax-cart--popup .ajax-cart__cart .product-item .product-item__media {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ajax-cart--popup .ajax-cart__cart .product-item .product-item__media .product-item__single-photo {
  width: 73.2px;
  height: 97.6px;
  object-fit: cover;
  object-position: center;
}

.ajax-cart--popup .ajax-cart__cart .product-item .product-item__information-inner {
  display: flex;
  flex-direction: row;
  gap: 24.4px;
  align-items: center;
}

.ajax-cart--popup
  .ajax-cart__cart
  .product-item
  .product-item__information-wrapper
  .close-popup-btn {
  display: none;
}

.ajax-cart--popup .ajax-cart__cart .product-item .product-item__information {
  display: flex;
  flex-direction: column;
  gap: 6.1px;
  width: 158.6px;
}

.ajax-cart--popup
  .ajax-cart__cart
  .product-item
  .product-item__information
  .product-item__delete-btn
  > span {
  margin: 0;
}

.ajax-cart--popup
  .ajax-cart__cart
  .product-item
  .product-item__information
  .product-item__delete-btn {
  display: flex;
  justify-content: flex-start;
}

.ajax-cart--popup
  .ajax-cart__cart
  .product-item
  .product-item__name
  .product-item__delete-btn
  .Polaris-Icon {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
}

.ajax-cart--popup
  .ajax-cart__cart
  .product-item
  .product-item__name
  .product-item__delete-btn
  .Polaris-Icon__Svg {
  width: 24px;
  height: 24px;
}

.ajax-cart--popup .ajax-cart__cart .product-item .product-item__first-price {
  width: 122px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.ajax-cart--popup .ajax-cart__cart .product-item .product-item__second-price {
  width: 122px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.ajax-cart--popup .ajax-cart__cart .product-item .product-item__third-price {
  display: none;
}

.ajax-cart--popup .ajax-cart__cart .product-item .product-item__name {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #222222;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.ajax-cart--popup .ajax-cart__cart .product-item .product-item__options {
  display: flex;
  flex-direction: column;
  gap: 6.1px;
}

.ajax-cart--popup .ajax-cart__cart .product-item .product-item__options .product-option {
  display: flex;
  flex-direction: row;
  gap: 3px;
}

.ajax-cart--popup
  .ajax-cart__cart
  .product-item
  .product-item__options
  .product-option
  .product-option__label {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #222222;
}

.ajax-cart--popup
  .ajax-cart__cart
  .product-item
  .product-item__options
  .product-option
  .product-option__value {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #222222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ajax-cart--popup .ajax-cart__footer {
  width: 100%;
  height: 112px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0px 24.4px 18.3px;
  border-top: 0.7625px solid #e8e9eb;
}

.ajax-cart--popup .ajax-cart__cart .product-item .product-item__quantity-counter {
  display: flex;
  align-items: center;
}

.ajax-cart--popup
  .ajax-cart__cart
  .product-item
  .product-item__quantity-counter
  .quantity-counter__counter {
  width: 122px;
  height: 29.2px;
  border: 0.7625px solid #ebebeb;
  border-radius: 30.5px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.ajax-cart--popup .ajax-cart__footer .ajax-cart__sub-total {
  display: flex;
  flex-direction: row;
  gap: 6.1px;
  padding: 10.6px 0;
}

.ajax-cart--popup .ajax-cart__footer .ajax-cart__sub-total .text {
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
}

.ajax-cart--popup .ajax-cart__footer .ajax-cart__sub-total .price {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.02em;
  color: #0f0f0f;
}

.ajax-cart--popup .ajax-cart__footer .ajax-cart__buttons {
  display: flex;
  flex-direction: row;
  gap: 12.2px;
}

.ajax-cart--popup .ajax-cart__footer .ajax-cart__buttons .button-item:hover {
  cursor: pointer;
}

.ajax-cart--popup .ajax-cart__footer .ajax-cart__buttons .button-item {
  width: 152.5px;
  min-height: 34.3px;
  padding: 9.15px 15.25px;
  border: 0.7625px solid #4e4e4e;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ajax-cart--popup .ajax-cart__footer .ajax-cart__buttons .button-item.button-item--rounded {
  border-radius: 61px;
}

.ajax-cart--popup.full {
  left: 50%;
  transform: translate(-50%, 0);
  width: 960px;
  max-height: min(640px, calc(100% - 60px - 60px));
}

.ajax-cart--popup.full .ajax-cart__header {
  width: 100%;
  height: 72px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 22px 32px;
  border-bottom: 1px solid #e8e9eb;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.02em;
  color: #0f0f0f;
}

.ajax-cart--popup.full .ajax-cart__header .close-popup-btn {
  position: absolute;
  top: 28.5px;
  right: 28.5px;
}

.ajax-cart--popup.full .ajax-cart__cart {
  height: 496px;
  overflow: auto;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.ajax-cart--popup.full .ajax-cart__cart .product-item {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__media {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ajax-cart--popup.full
  .ajax-cart__cart
  .product-item
  .product-item__media
  .product-item__single-photo {
  width: 98px;
  height: 128px;
  object-fit: cover;
  object-position: center;
}

.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__information-inner {
  display: flex;
  flex-direction: row;
  gap: 32px;
}

/* .ajax-cart--side .ajax-cart__cart .product-item .product-item__information-wrapper .product-item__name .product-item__delete-btn{
  display: none;
} */
.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__information {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 208px;
}

.ajax-cart--popup.full
  .ajax-cart__cart
  .product-item
  .product-item__information
  .product-item__delete-btn
  > span {
  margin: 0;
}

.ajax-cart--popup.full
  .ajax-cart__cart
  .product-item
  .product-item__information
  .product-item__delete-btn {
  display: flex;
  justify-content: flex-start;
}

.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__first-price {
  width: 160px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__second-price {
  width: 160px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__third-price {
  display: none;
}

.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__name {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #222222;
}

.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__options .product-option {
  display: flex;
  flex-direction: row;
  gap: 4px;
}

.ajax-cart--popup.full
  .ajax-cart__cart
  .product-item
  .product-item__options
  .product-option
  .product-option__label {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #222222;
}

.ajax-cart--popup.full
  .ajax-cart__cart
  .product-item
  .product-item__options
  .product-option
  .product-option__value {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #222222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ajax-cart--popup.full .ajax-cart__footer {
  width: 100%;
  height: 132px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0px 32px 24px;
  border-top: 1px solid #e8e9eb;
}

.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__quantity-counter {
  display: flex;
  align-items: center;
}

.ajax-cart--popup.full
  .ajax-cart__cart
  .product-item
  .product-item__quantity-counter
  .quantity-counter__counter {
  width: 160px;
  height: 38px;
  border: 1px solid #ebebeb;
  border-radius: 40px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.ajax-cart--popup.full .ajax-cart__footer .ajax-cart__sub-total {
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 14px 0;
}

.ajax-cart--popup.full .ajax-cart__footer .ajax-cart__sub-total .text {
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
}

.ajax-cart--popup.full .ajax-cart__footer .ajax-cart__sub-total .price {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.02em;
  color: #0f0f0f;
}

.ajax-cart--popup.full .ajax-cart__footer .ajax-cart__buttons {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.ajax-cart--popup.full .ajax-cart__footer .ajax-cart__buttons .button-item:hover {
  cursor: pointer;
}

.ajax-cart--popup.full .ajax-cart__footer .ajax-cart__buttons .button-item {
  width: 200px;
  min-height: 44px;
  padding: 12px 20px;
  border: 1px solid #4e4e4e;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ajax-cart--popup.full .ajax-cart__footer .ajax-cart__buttons .button-item.button-item--rounded {
  border-radius: 80px;
}

.ajax-cart--side {
  right: 0;
  width: 320px;
  height: 100%;
}

.ajax-cart--side .ajax-cart__header {
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid #e8e9eb;
  border-top: 1px solid #e8e9eb;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #0f0f0f;
}

.ajax-cart--side .ajax-cart__header .close-popup-btn {
  position: absolute;
  top: 15px;
  right: 15px;
}

.ajax-cart--side .ajax-cart__cart {
  height: calc(100% - 48px - 192px);
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ajax-cart__cart::-webkit-scrollbar {
  width: 8px;
}

.ajax-cart__cart::-webkit-scrollbar-track {
  background-color: #ffffff;
}

.ajax-cart__cart::-webkit-scrollbar-thumb {
  background: #cccccc;
  border-radius: 4px;
}

.ajax-cart--side .ajax-cart__cart .product-item {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.ajax-cart--side .ajax-cart__cart .product-item .product-item__media {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ajax-cart--side .ajax-cart__cart .product-item .product-item__media .product-item__single-photo {
  width: 96px;
  height: 128px;
  object-fit: cover;
  object-position: center;
}

.ajax-cart--side .ajax-cart__cart .product-item .product-item__information-inner {
  padding: 7px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
}

.ajax-cart--side
  .ajax-cart__cart
  .product-item
  .product-item__information-wrapper
  .close-popup-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  display: grid;
  place-items: center;
}

.ajax-cart--side
  .ajax-cart__cart
  .product-item
  .product-item__information-wrapper
  .Polaris-Icon__Svg {
  width: 24px;
  height: 24px;
  max-width: unset;
  max-height: unset;
}

.ajax-cart--side .ajax-cart__cart .product-item .product-item__information {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 176px;
}

.ajax-cart--side
  .ajax-cart__cart
  .product-item
  .product-item__information
  .product-item__delete-btn
  > span {
  margin: 0;
}

.ajax-cart--side
  .ajax-cart__cart
  .product-item
  .product-item__information
  .product-item__delete-btn {
  display: none;
}

.ajax-cart--side
  .ajax-cart__cart
  .product-item
  .product-item__name
  .product-item__delete-btn
  .Polaris-Icon {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
}

.ajax-cart--side .ajax-cart__cart .product-item .product-item__first-price {
  display: none;
}

.ajax-cart--side .ajax-cart__cart .product-item .product-item__second-price {
  display: none;
}

.ajax-cart--side .ajax-cart__cart .product-item .product-item__third-price {
  margin-left: auto;
  display: flex;
  gap: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #0f0f0f;
}

.ajax-cart--side .ajax-cart__cart .product-item .product-item__name {
  width: 100%;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #222222;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ajax-cart--side .ajax-cart__cart .product-item .product-item__options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ajax-cart--side .ajax-cart__cart .product-item .product-item__options .product-option {
  display: flex;
  flex-direction: row;
  gap: 4px;
}

.ajax-cart--side
  .ajax-cart__cart
  .product-item
  .product-item__options
  .product-option
  .product-option__label {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #222222;
}

.ajax-cart--side
  .ajax-cart__cart
  .product-item
  .product-item__options
  .product-option
  .product-option__value {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #222222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ajax-cart--side .ajax-cart__cart .product-item .product-item__quantity-counter {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-top: auto;
}

.ajax-cart--side
  .ajax-cart__cart
  .product-item
  .product-item__quantity-counter
  .quantity-counter__counter {
  width: 81px;
  height: 30px;
  border: 1px solid #ebebeb;
  border-radius: 40px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #222222;
}

.ajax-cart--side .ajax-cart__footer {
  width: 100%;
  height: 192px;
  border-top: 1px solid #e8e9eb;
}

.ajax-cart--side .ajax-cart__footer .ajax-cart__sub-total {
  display: flex;
  flex-direction: row;
  padding: 14px 16px;
  justify-content: space-between;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #0f0f0f;
}

.ajax-cart--side .ajax-cart__footer .ajax-cart__buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 16px 16px 16px;
}

.ajax-cart--side .ajax-cart__footer .ajax-cart__buttons .button-item:hover {
  cursor: pointer;
}

.ajax-cart--side .ajax-cart__footer .ajax-cart__buttons .button-item {
  min-width: 200px;
  min-height: 44px;
  padding: 12px 20px;
  border: 1px solid #4e4e4e;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ajax-cart--side .ajax-cart__footer .ajax-cart__buttons .button-item.button-item--rounded {
  border-radius: 80px;
}

.BC-Page__Title--Help {
  display: flex;
  gap: 20px;
  margin-bottom: var(--p-space-4);
  color: #6d7175;
  font-size: 12px;
}

.BC-Page__Title--Help__Item {
  display: flex;
  position: relative;
  align-items: center;
}

.BC-Page__Title--Help__Item::after {
  margin: 0 8px;
  position: absolute;
  display: inline-block;
  width: 1px;
  height: 12px;
  background: #e1e3e5;
  content: '';
  right: -20px;
  top: 4px;
}

.BC-Page__Title--Help__Item:last-child:after {
  display: none;
}

.BC-Page__Title--Help span {
  cursor: pointer;
}

.BC-Page__Title--Help span.img {
  width: auto;
  height: 11.2px;
  margin-right: 5px;
  display: inline-block;
  display: flex;
}

.BC-Page__Title--Help span:hover {
  color: black;
}

.BC-Page__Title--Help svg {
  width: 14px;
  height: 14px;
}

.BC-Page__Title--Help__Item .Polaris-Icon {
  display: flex;
  align-items: center;
}

.BC-CSATFeedback__Wrapper {
  position: fixed;
  top: 45%;
  right: -422px;

  display: flex;
  flex-direction: row;

  z-index: 520;
  transition: all 0.4s ease-in-out;
}

.BC-CSATFeedback__Wrapper.expanded {
  right: 0px;
}

.BC-CSATFeedback__Wrapper .StickyButton {
  background-color: #2c6ecb;
  padding: 10px 8px;
  border-radius: 4px 0 0 4px;

  display: flex;
  flex-direction: column;
  gap: 8px;

  height: min-content;
  margin-top: 24px;

  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */

  transition: all 0.1s ease-in-out;
}

.BC-CSATFeedback__Wrapper .StickyButton.clickable {
  cursor: pointer;
}

.BC-CSATFeedback__Wrapper .StickyButton.clickable:hover {
  box-shadow:
    rgba(0, 0, 0, 0.07) 0px 1px 2px,
    rgba(0, 0, 0, 0.07) 0px 2px 4px,
    rgba(0, 0, 0, 0.07) 0px 4px 8px,
    rgba(0, 0, 0, 0.07) 0px 8px 16px,
    rgba(0, 0, 0, 0.07) 0px 16px 32px,
    rgba(0, 0, 0, 0.07) 0px 32px 64px;
}

.BC-CSATFeedback__Wrapper .StickyButton .StickyButton__Title {
  color: white;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;

  writing-mode: vertical-rl;
  transform: rotate(180deg);
}

.BC-CSATFeedback__Wrapper .StickyButton .StickyButton__Icon {
  width: 100%;
}

.BC-CSATFeedback__Wrapper .FeedbackWidget {
  width: 422px;
  padding: 24px 20px;
  background-color: white;

  border-radius: 8px;
}

.BC-CSATFeedback__Wrapper .FeedbackWidget.visible {
  box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
}

.BC-CSATFeedback__Wrapper .FeedbackWidget .FeedbackWidget__CloseButton {
  position: absolute;
  top: 28px;
  right: 20px;

  cursor: pointer;
}

.FeedbackWidget .FeedbackWidget__Rating {
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
}

.FeedbackWidget .FeedbackWidget__Rating.center {
  text-align: center;
}

.FeedbackWidget .FeedbackWidget__Rating .Rating__Container {
  display: flex;
  flex-direction: column;
}

.FeedbackWidget .FeedbackWidget__Rating .Rating__Container.reverse {
  flex-direction: column-reverse;
  text-align: center;
  margin-top: 20px;
}

.FeedbackWidget .FeedbackWidget__Rating .Rating__Title {
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;

  color: #202223;
}

.FeedbackWidget .FeedbackWidget__Rating .Rating__Subtitle {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;

  margin-top: 4px;
  color: #6d7175;
}

.FeedbackWidget__Rating .Rating__Container.reverse .Rating__Subtitle {
  color: #202223;
}

.FeedbackWidget .FeedbackWidget__Rating .Rating__Stars {
  display: flex;
  flex-direction: row;
  gap: 8px;

  margin-top: 16px;
}

.FeedbackWidget .FeedbackWidget__Rating .Rating__Action {
  margin-top: 26px;

  display: flex;
  justify-content: flex-end;
}

.FeedbackWidget .FeedbackWidget__Rating .Rating__Action .Polaris-Button__Text {
  color: #6d7175;
}

.Rating__Stars .Star__Container {
  width: 89.5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  transition: all 0.12s ease-in-out;
}

.Rating__Stars:hover .Star__Container {
  filter: opacity(0.25);
}

.Rating__Stars .Star__Container:hover {
  filter: opacity(1);
}

.Rating__Stars .Star__Container img {
  transform: translateX(-5px);

  cursor: pointer;
}

.Rating__Stars .Star__Container .Star__Name {
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;

  color: #6d7175;
}

.FeedbackWidget__Feedback {
  display: flex;
  gap: 16px;
  flex-direction: column;
}

.FeedbackWidget__Feedback .Feedback__Title {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;

  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */

  color: #202223;
}

.FeedbackWidget__Feedback .Feedback__Textarea {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.FeedbackWidget__Feedback .Feedback__Textarea textarea:focus {
  outline: none !important;
}

.FeedbackWidget__Feedback .Feedback__Textarea textarea[rows='4'] {
  max-height: 106px;
}

.FeedbackWidget__Feedback .Feedback__Action {
  display: flex;
  gap: 8px;

  margin-top: 20px;
}

.FeedbackWidget .FeedbackWidget__GotIt {
  display: flex;
  flex-direction: column;
  gap: 16px;

  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
}

.FeedbackWidget .FeedbackWidget__GotIt .GotIt__Title {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;

  color: #202223;
}

.FeedbackWidget .FeedbackWidget__GotIt .GotIt__Subtitle {
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;

  color: #202223;
}

.FeedbackWidget .FeedbackWidget__GotIt .GotIt__Action {
  margin-top: 5px;
}

.FeedbackWidget .FeedbackWidget__GotIt .GotIt__Decor {
  position: absolute;
  bottom: 20px;
  right: 20px;
}

.Rating__Stars .Star__Container.Poor.animation {
  animation:
    star-appear 0.3s ease-out,
    star-jump 0.8s ease-out;
}

.Rating__Stars .Star__Container.Ok.animation {
  animation:
    star-appear 0.3s ease-out,
    star-jump 0.8s ease-out 0.1s;
}

.Rating__Stars .Star__Container.Good.animation {
  animation:
    star-appear 0.3s ease-out,
    star-jump 0.8s ease-out 0.2s;
}

.Rating__Stars .Star__Container.Excellent.animation {
  animation:
    star-appear 0.3s ease-out,
    star-jump 0.8s ease-out 0.3s;
}

@keyframes star-appear {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

@keyframes star-jump {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }

  40% {
    opacity: 0;
    transform: translateY(30px);
  }

  70% {
    opacity: 0.6;
    transform: translateY(-5px);
  }

  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

.modal-get-feedback-after-rating-5stars {
  display: flex;
  justify-content: center;
}

.modal-get-feedback-after-rating-5stars .left {
  display: 430px;
  text-align: center;
}

.modal-get-feedback-after-rating-5stars .left img {
  max-width: 416px;
}

.modal-get-feedback-after-rating-5stars .left .step-title {
  font-weight: 600;
  font-size: 24px;
  color: #008060;
}

.modal-get-feedback-after-rating-5stars .left .step-detail {
  font-weight: 400;
  font-size: 16px;
  color: #202223;
  margin: 10px;
}

.modal-get-feedback-after-rating-5stars .left .carousel {
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  width: 100px;
  margin: 20px auto;
}

.modal-get-feedback-after-rating-5stars .left .carousel .carousel-item {
  width: 6px;
  height: 6px;
  background: #c9ccd0;
  border-radius: 50%;
  cursor: pointer;
}

.modal-get-feedback-after-rating-5stars .left .carousel .carousel-item.active {
  width: 10px;
  height: 10px;
  background: #008060;
}

.modal-get-feedback-after-rating-5stars .right {
  width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 20px;
}

.modal-get-feedback-after-rating-5stars .right .title {
  font-weight: 600;
  font-size: 28px;
  color: #202223;
  line-height: 32px;
}

.modal-get-feedback-after-rating-5stars .right .description {
  font-weight: 400;
  font-size: 16px;
  color: #202223;
  line-height: 24px;
}

.modal-get-feedback-after-rating-5stars .right .action {
  display: flex;
  gap: 20px;
}

.modal-get-feedback-after-rating-5stars-all-set-wrapper {
  padding-top: 30px;
  padding-bottom: 60px;
}

.modal-get-feedback-after-rating-5stars-all-set {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: relative;
  background: white;
  border-radius: 0.5rem;
  /* box-shadow: var(--p-shadow-modal); */
  background-image: url('https://cdn.boostcommerce.io/assets/feedback-after-5-stars-rating/bg-all-set.png');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: bottom;
  padding: 10px;
  padding-top: 40px;
  background-origin: content-box;
}

.modal-get-feedback-after-rating-5stars-all-set .title {
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 20px;
}

.modal-get-feedback-after-rating-5stars-all-set .description {
  font-weight: 400;
  font-size: 14px;
  max-width: 400px;
  text-align: center;
  padding: 10px;
  padding-top: 0;
}

.modal-get-feedback-after-rating-5stars-all-set .smile {
  width: 70px;
  margin: 0 auto;
  height: 70px;
  border-radius: 50%;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -35px;
}

.Polaris-Modal-Dialog__Modal:has(.modal-get-feedback-after-rating-5stars-all-set) {
  width: 440px;
  background: transparent;
  box-shadow: unset;
}

.Polaris-Modal-Dialog__Modal.Polaris-Modal-Dialog--sizeLarge:has(
    .modal-get-feedback-after-rating-5stars
  ) {
  max-width: 912px !important;
}

.Polaris-Modal-Section:has(.modal-content-form-feedback-rating-5stars) {
  padding: 0;
}

.modal-content-form-feedback-rating-5stars .title-action {
  display: flex;
  justify-content: space-between;
  padding: var(--p-space-5);
  border-bottom: 1px solid #e1e3e5;
}

.modal-content-form-feedback-rating-5stars .title-action .title {
  font-size: 20px;
}

.modal-content-form-feedback-rating-5stars .title-action .close {
  cursor: pointer;
}

.modal-content-form-feedback-rating-5stars .content-action {
  padding: var(--p-space-5);
  padding-top: 0;
}

.modal-content-form-feedback-rating-5stars .content-action .Polaris-Labelled__LabelWrapper {
  margin-top: var(--p-space-4);
}

.notification-feedback-5stars .action {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.notification-feedback-5stars .action .Polaris-Button.Polaris-Button--outline {
  border: 1px solid #98c6cd;
}

.notification-feedback-5stars .action .Polaris-Button:hover {
  background: #b8e9ef;
}

.notification-feedback-5stars .dismiss {
  cursor: pointer;
}

.notification-feedback-5stars .Polaris-Icon {
  background-image: url('https://cdn.boostcommerce.io/assets/feedback-after-5-stars-rating/gift.svg');
  background-size: contain;
}

.notification-feedback-5stars .Polaris-Icon svg {
  display: none;
}

.whatsapp-modal {
  display: flex;
  position: relative;
}

.whatsapp-modal .close {
  position: absolute;
  top: 0;
  right: 0;
}

.whatsapp-modal .close button {
  border: none;
  width: 20px;
  height: 20px;
  padding: 8px;
}

.whatsapp-modal .whatsapp-modal__qr {
  display: flex;
  padding: 48px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 37.75px;
  min-width: 400px;
}

.whatsapp-modal .whatsapp-modal__qr .qr_header {
  display: flex;
  gap: 16px;
  align-items: center;
}

.whatsapp-modal .whatsapp-modal__qr .qr_header .qr-title {
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
  margin-bottom: 4px;
}

.whatsapp-modal .whatsapp-modal__qr .qr_header .qr-subtitle {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #6d7175;
}

.whatsapp-modal .whatsapp-modal__qr .qr-body .qr-wrapper {
  padding: 12px;
  background-image: url('https://cdn.boostcommerce.io/assets/dashboard-v3/bg-qr.png');
  background-repeat: no-repeat;
}

.whatsapp-modal .whatsapp-modal__qr .qr-footer .qr-note {
  line-height: 20px;
  color: #8c9196;
  text-align: center;
  max-width: 304px;
}

.whatsapp-modal .whatsapp-modal__content {
  display: flex;
  padding: 48px 32px;
  padding-right: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.whatsapp-modal .whatsapp-modal__content .title {
  font-size: 28px;
  font-weight: 600;
  line-height: 32px;
  margin-bottom: 24px;
}

.whatsapp-modal .whatsapp-modal__content .text {
  font-size: 16px;
  line-height: 24px;
}

.whatsapp-modal__action {
  margin-top: 32px;
  width: 100%;
}

.whatsapp-modal__action .Polaris-ButtonGroup__Item:first-child {
  margin-left: 8px;
}

.whatsapp-modal__action button {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20p;
}

/*VerticalTab*/
.BC_VerticalTab_Wrapper {
  display: flex;
}

.BC_VerticalTab_Wrapper .tab-items {
  border-right: 1px solid #e1e3e5;
  padding: 20px 0 20px 8px;
  width: 200px;
  flex-shrink: 0;
}

.BC_VerticalTab_Wrapper .tab-children {
  padding: 20px;
  flex-grow: 1;
  max-width: calc(100% - 200px);
}

.BC_VerticalTab_Wrapper .tab-selected {
  color: #347c84 !important;
  background-color: #f6f6f7;
  border-right: 2px solid #347c84;
  font-weight: 600 !important;
  border-radius: 4px 0 0 4px;
}

.BC_VerticalTab_Wrapper .tab-item {
  margin-right: 5px;
  padding: 12px 8px 12px 8px;
  font-weight: 400;
  color: #202223;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.BC_VerticalTab_Wrapper .tab-item:hover {
  background-color: #f1f2f3;
}

.BC_VerticalTab_Wrapper .tab-item .tab-name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.BC_VerticalTab_Wrapper .tab-item .Polaris-Badge {
  margin-left: 4px;
}

/*VerticalTab*/

/*StandardSearch*/
.BC-Page__StandardSearch .Polaris-Page {
  max-width: 1104px;
}

.BC-Page__StandardSearch .Polaris-Header-Title__SubTitle {
  color: #202223;
}

.BC-Page__StandardSearch .Polaris-Page-Header,
.BC-Page__StandardSearch
  .Polaris-Page
  > div
  > .Polaris-Layout
  > .Polaris-Layout__Section
  > .BC-Page
  > .Polaris-Card
  > .Polaris-Card__Section,
.BC-Page__AdvancedSearch
  .Polaris-Page
  .Polaris-Layout
  > .Polaris-Layout__Section
  > .Polaris-Card
  > .Polaris-Card__Section {
  padding: 0;
}

.BC-Page__StandardSearch .tab-children .Polaris-Header-Title {
  font-size: 20px;
}

.BC-Page__StandardSearch .Children-Card__Section {
  position: relative;
  overflow: visible;
}

.BC-Page__StandardSearch .Polaris-Page {
  padding: 0;
}

.BC-Page__StandardSearch .StandardSearch__Content {
  margin-top: 0px !important;
}

.BC-Page__StandardSearch > .Polaris-Page > .Polaris-Page-Header {
  margin-top: 2.5rem;
}

.BC-Page__StandardSearch .upgradeThemeBanner .image {
  max-height: 116px;
  width: 100%;
}

.BC-Page__StandardSearch .upgradeThemeBanner .image img {
  max-height: 116px;
  max-width: 240px;
}

.upgradeThemeBanner .pfs-banner-content ul {
  padding-left: 20px;
  margin: 0;
}

.tryNewVersionSearch {
  margin-bottom: 24px;
}

.tryNewVersionSearch .pfs-banner-content {
  width: 85% !important;
  padding-bottom: unset !important;
}

.tryNewVersionSearch .pfs-banner-detail {
  gap: unset;
}

.tryNewVersionSearch .image {
  max-width: 240px;
}

.tryNewVersionSearch .image img {
  max-width: 240px;
  max-height: 152px;
}

/*StandardSearch*/

/*StandardSearch - SearchResultPage*/

/*StandardSearch - InCollectionSettings*/
.searchResultPageInfo .image {
  max-height: 112px;
}

.searchSettingProcessingBanner {
  padding: 16px !important;
}

.searchSettingProcessingBanner .pfs-banner-content {
  padding: unset !important;
}

.searchSettingProcessingBanner .pfs-banner-detail {
  margin-top: unset;
}

.searchSettingProcessingBanner .pfs-banner-icon {
  height: 20px;
}

/*StandardSearch - InCollectionSettings*/
.BC-Page__StandardSearch
  .BC-Page__InCollectionSettings
  .BC-Container__Notifications
  > *:first-child {
  margin-top: 1rem;
}

.BC-Page__StandardSearch .BC-Page__InCollectionSettings .Children-Card__Section {
  margin-top: 2.5rem !important;
  padding: 8px 20px;
}

.BC-Page__InCollectionSettings .pfs-app-banner .image {
  max-height: 100px;
}

.BC-Page__InCollectionSettings .Polaris-Layout {
  margin-top: 1rem;
}

/*StandardSearch - InCollectionSettings*/

/*StandardSearch - RelevanceSettings*/
.BC-Page__StandardSearch .BC-Page__SearchSettings .Children-Card__Section {
  margin-top: 0 !important;
}

.BC-Page__StandardSearch .BC-Page__SearchSettings .Polaris-Tabs__Wrapper .Polaris-Tabs {
  margin-left: 20px;
}

.BC-Page__StandardSearch .BC-Page__SearchSettings .Polaris-Tabs__Panel .tab-content,
.BC-Page__StandardSearch .BC-Page__SearchPageDisplay .Polaris-Tabs__Panel .tab-content {
  padding-top: 1px;
  margin-top: 10px;
}

.BC-Page__StandardSearch .BC-Page__SearchSettings .Polaris-Tabs__Wrapper,
.BC-Page__StandardSearch .BC-Page__SearchPageDisplay .Polaris-Tabs__Wrapper {
  margin-left: -20px;
  margin-right: -20px;
  margin-bottom: 10px;
}

.BC-Page__StandardSearch .BC-Page__SearchSettings .Polaris-PageActions,
.BC-Page__StandardSearch .BC-Page__SearchPageDisplay .Polaris-PageActions {
  border-top: none;
}

.BC-Page__StandardSearch .BC-Page__SearchSettings .BC-DataTable__SearchSettings {
  margin-left: 0;
  margin-right: 0;
  border: 1px solid var(--p-divider);
  border-radius: 8px;
}

.relevanceSettingInfo .image {
  max-height: 112px;
}

.sync-v2-wrapper .Polaris-Layout__Section {
  margin-top: 1.5rem;
}

.sync-v2-wrapper .Polaris-Layout__Section .syncInfoBanner {
  margin-top: 0;
}

/* check if notification was dismisss */
.sync-v2-wrapper .Polaris-Layout__Section:has(.BC-Container__Notifications):not(:has(div > div)) {
  margin-top: 0;
}

.sync-v2-wrapper .sync-v2-wrapper-flex {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
}

.sync-v2-wrapper .sync-status {
  width: 320px;
  position: relative;
  height: auto;
}

.sync-v2-wrapper .sync-status .Polaris-Card {
  height: 100%;
}

.sync-v2-wrapper .sync-status .Polaris-Card .Polaris-Card__Section,
.sync-v2-wrapper .manual-sync .Polaris-Card .Polaris-Card__Section {
  min-height: 236px;
}

.sync-v2-wrapper .sync-status .Polaris-Card .Polaris-Card__Section {
  display: flex;
  align-items: flex-start;
}

.sync-v2-wrapper .sync-status:has(.content-center) .Polaris-Card .Polaris-Card__Section {
  display: block;
  align-items: center;
  position: relative;
}

.sync-v2-wrapper .sync-status .content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  z-index: 2;
  margin-top: 20%;
  width: 72%;
}

.sync-v2-wrapper .sync-status .content-v4 {
  width: 100%;
  margin-top: 16px !important;
}

.sync-v2-wrapper .sync-status .detail-sync-status {
  margin-bottom: 20px;
}

.sync-v2-wrapper .sync-status .detail-sync-status > div:first-child {
  width: calc(100% - 70px);
}

.sync-v2-wrapper .sync-status .detail-sync-status > p:last-child {
  color: #2c6ecb;
  text-decoration: underline;
}

.sync-v2-wrapper .sync-status .detail-sync-status > p:last-child:hover {
  cursor: pointer;
  text-decoration: none;
}

.sync-v2-wrapper .sync-status img {
  position: absolute;
  right: 0;
}

.sync-v2-wrapper .sync-status:has(.content-center) .content > div:not(:last-child) {
  width: calc(100% - 70px);
}

.sync-v2-wrapper .sync-status .Polaris-Card__Section {
  position: relative;
}

.sync-v2-wrapper .sync-status .Polaris-Card__Section img.bg {
  position: absolute;
  right: 0;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
}

.sync-v2-wrapper .sync-status img.loading {
  animation: rotation 8s infinite linear;
}

.sync-v2-wrapper .sync-status img.loading2 {
  animation: rotation 2s infinite linear;
}

.sync-v2-wrapper .sync-status .content .text-value {
  color: #008060;
  font-weight: 600;
}

.sync-v2-wrapper .sync-status .content .edit-schedule {
  text-decoration: underline;
  color: var(--p-interactive);
  cursor: pointer;
  margin-top: 10px;
}

.sync-v2-wrapper .sync-status .content .progress-sync {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sync-v2-wrapper .sync-status .content .progress-sync .label {
  font-weight: 600;
  font-size: 14px;
}

.sync-v2-wrapper .sync-status .content .progress-sync .Polaris-ProgressBar {
  height: 16px;
}

.sync-v2-wrapper
  .sync-status
  .content
  .progress-sync
  .Polaris-ProgressBar
  .Polaris-ProgressBar__Indicator {
  background-color: #008060;
}

.sync-v2-wrapper
  .sync-status
  .content
  .progress-sync.wait-retry
  .Polaris-ProgressBar
  .Polaris-ProgressBar__Indicator {
  background-color: #6d7175;
}

.sync-v2-wrapper .sync-status .content .progress-sync .Polaris-ProgressBar__Label {
  display: none;
}

.sync-v2-wrapper .sync-status .content .progress-sync .label-process {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.sync-v2-wrapper .manual-sync {
  width: 592px;
}

.sync-v2-wrapper .manual-sync .Polaris-Card {
  height: 100%;
}

@media screen and (min-width: 1024px) {
  .BC-Page__Sync .Polaris-Page {
    max-width: 58.5rem;
    padding: 0;
  }
}

@media screen and (max-width: 1024px) {
  .sync-v2-wrapper .sync-status {
    width: 34.18%;
  }

  .sync-v2-wrapper .manual-sync {
    width: 63.25%;
  }
}

@media screen and (max-width: 768px) {
  .sync-v2-wrapper .sync-v2-wrapper-flex {
    flex-direction: column;
    gap: 20px;
  }

  .sync-v2-wrapper .sync-status,
  .sync-v2-wrapper .manual-sync {
    width: 100%;
  }
}

.sync-v2-wrapper .manual-sync .description {
  color: #6d7175;
  margin-top: 10px;
  margin-bottom: 20px;
}

.sync-v2-wrapper .manual-sync .action {
  display: flex;
  gap: 15px;
}

.sync-v2-wrapper .sync-history .Polaris-DataTable thead tr th {
  padding: 1rem 1.125rem;
}

.sync-v2-wrapper .sync-history .Polaris-DataTable tbody tr th {
  padding: 1.125rem 1rem;
}

.sync-v2-wrapper .sync-history .Polaris-DataTable tbody tr td:last-child span {
  font-size: 12px !important;
}

.sync-v2-wrapper .sync-history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sync-v2-wrapper .sync-history-header .action {
  display: flex;
  gap: 10px;
  align-items: center;
}

.sync-v2-wrapper .sync-history-header .action .Polaris-Button {
  width: 160px;
}

.sync-v2-wrapper .sync-history-header .action .Polaris-Button .Polaris-Button__Content {
  justify-content: space-between;
}

.sync-history-trigger-popover .Polaris-ActionList__Actions {
  min-width: 170px !important;
}

.sync-v2-wrapper .syncInfoBanner {
  border: 1px solid #95c9b4;
  background: #f7fdfc !important;
}

.sync-v2-wrapper .sync-collections-priority {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.sync-v2-wrapper .sync-collections-priority .table {
  border: 1px solid #e1e3e5;
  border-radius: 8px;
}

.sync-v2-wrapper .sync-collections-priority .table .table-header .row {
  border-top: 0 !important;
}

.sync-v2-wrapper .sync-collections-priority .table .table-body {
}

.sync-v2-wrapper .sync-collections-priority .table .row {
  display: flex;
  border-top: 1px solid #e1e3e5;
  padding: 10px 14px;
  align-items: center;
  gap: 20px;
}

.sync-v2-wrapper .sync-collections-priority .has-collection-delete-border,
.sync-v2-wrapper .sync-collections-priority .has-collection-blank-border {
  position: relative;
}

.sync-v2-wrapper
  .sync-collections-priority
  .has-collection-delete-border
  .SelectCollection
  [class*='css-'][class*='-control'],
.sync-v2-wrapper
  .sync-collections-priority
  .has-collection-blank-border
  .SelectCollection
  [class*='css-'][class*='-control'] {
  border: 1px solid #d82c0d;
  border-radius: 6px;
  background-color: #fff4f4;
}

.sync-v2-wrapper
  .sync-collections-priority
  .has-collection-blank-border
  .SelectCollection
  [class*='css-'][class*='-control'] {
  border: 1px solid #1f5199;
  border-radius: 6px;
  background-color: var(--p-surface-selected);
}

.sync-v2-wrapper .sync-collections-priority .has-collection-delete-border .tooltip,
.sync-v2-wrapper .sync-collections-priority .has-collection-blank-border .tooltip {
  position: absolute;
  max-width: 268px;
  box-shadow: 0px 2px 10px 0px #0000001a;
  background: white;
  padding: 10px;
  border-radius: 4px;
  right: 0;
  bottom: 50px;
  z-index: 2;
  opacity: 0;
}

.sync-v2-wrapper .sync-collections-priority .has-collection-delete-border:hover .tooltip,
.sync-v2-wrapper .sync-collections-priority .has-collection-blank-border:hover .tooltip {
  opacity: 1;
}

.sync-v2-wrapper .sync-collections-priority .table .row .item:first-child {
  flex: 1;
}

.sync-v2-wrapper .sync-collections-priority .table .row .item:last-child {
  width: 50px;
  display: flex;
  justify-content: center;
}

.sync-v2-wrapper .sync-collections-priority .table .row.action {
  display: flex;
  justify-content: flex-end;
  padding: 16px 20px;
}

.sync-v2-wrapper .sync-collections-priority .table .row .add {
  cursor: pointer;
  color: #1f5199;
}

.sync-v2-wrapper .sync-collections-priority .table .row .add:hover {
  text-decoration: underline;
}

.sync-v2-wrapper .sync-collections-priority .table .row .add.disabled {
  color: #bdc1cc;
  cursor: not-allowed;
  text-decoration: none;
}

.sync-v2-wrapper .sync-collections-priority .table .Polaris-Button {
  width: 28px;
  height: 28px;
  min-width: 28px;
  min-height: 28px;
  padding: 0;
}

.sync-v2-wrapper .sync-collections-priority .note a {
  color: #2c6ecb;
  text-decoration: none;
}

.sync-v2-wrapper .sync-schedule form {
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sync-v2-wrapper .sync-schedule .sync-select .default-text-style {
  font-weight: 600 !important;
}

.sync-v2-wrapper .sync-schedule .sync-schedule-time .default-text-style {
  font-weight: 400 !important;
}

.sync-v2-wrapper .sync-schedule .BC-Select--is-disabled .BC-Select__value-container--has-value div {
  color: hsl(0, 0%, 60%) !important;
}

.sync-v2-wrapper .sync-schedule form .sync-schedule-time {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.sync-v2-wrapper .sync-schedule form .sync-schedule-time .item {
  width: 50%;
}

.sync-v2-wrapper .sync-schedule form .sync-schedule-action {
  display: flex;
  gap: 10px;
}

.BC-Page__StandardSearch .BC-Page__SearchPageDisplay .BC-DataTable__SearchTerm {
  margin-top: 16px;
}

.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-DataTable__Product
  .Polaris-DataTable__Cell:nth-child(4),
.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-DataTable__SearchTerm
  .Polaris-DataTable__Cell:nth-child(3) {
  width: 50px;
  text-align: center;
}

.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-DataTable__Product
  .Polaris-DataTable__Cell:nth-child(4)
  .Polaris-Button,
.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-DataTable__SearchTerm
  .Polaris-DataTable__Cell:nth-child(3)
  .Polaris-Button {
  width: 30px;
  min-width: unset;
  padding: 0;
}

.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-DataTable__Product
  .Polaris-DataTable__Cell:nth-child(4)
  .Polaris-Button
  .Polaris-Button__Icon,
.BC-Page__StandardSearch
  .BC-Page__SearchPageDisplay
  .BC-DataTable__SearchTerm
  .Polaris-DataTable__Cell:nth-child(3)
  .Polaris-Button
  .Polaris-Button__Icon {
  display: flex;
}

/*StandardSearch - RelevanceSettings*/

/*StandardSearch - ManualSynonym*/
.BC-Page__StandardSearch .BC-Page__Synonym {
  margin-bottom: 20px;
}

.BC-Page__StandardSearch .BC-Page__Synonym .banner-unlock-addon .action-locked {
  display: flex;
  gap: 4px;
  align-items: center;
  font-weight: 500;
}

.BC-Page__StandardSearch .BC-Page__Synonym .introduce-ai-synonym {
  box-shadow: none;
  border-radius: 8px;
  border: 1px solid var(--border-divider, #e1e3e5);
  padding: 20px;
  display: flex;
  justify-content: space-between;
}

.BC-Page__StandardSearch .BC-Page__Synonym .introduce-ai-synonym > div:first-child {
  display: flex;
  gap: 8px;
}

.BC-Page__StandardSearch .BC-Page__Synonym .introduce-ai-synonym > div:last-child {
  color: #2c6ecb;
}

.BC-Page__StandardSearch .BC-Page__Synonym .introduce-ai-synonym > div:last-child:hover {
  text-decoration: underline;
  cursor: pointer;
}

.manualSynonymInfos .image {
  max-height: 152px;
}

/*StandardSearch - ManualSynonym*/

/*StandardSearch - Stop Words*/
.BC-Page__StandardSearch .BC-Page.BC-Page__StopWords .Polaris-Card {
  box-shadow: none;
}

.BC-Page__StandardSearch .BC-Page.BC-Page__StopWords .Polaris-Card__Section {
  padding: var(--p-space-5);
  border: 1px solid var(--p-divider);
}

.BC-Page__StandardSearch .BC-Page.BC-Page__StopWords .BC-stop-words-list-wrapper {
  width: 100%;
}

.BC-Page__StandardSearch
  .BC-Page.BC-Page__StopWords
  .BC-stop-words-list-wrapper
  .Polaris-Card__Section:last-child {
  border-top: 0;
}

.BC-Page__StandardSearch .BC-Page.BC-Page__StopWords .Polaris-PageActions {
  border-top: 0;
}

.BC-Page__StandardSearch .BC-Page__Redirect .BC__Search-header,
.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .BC__Search-header,
.BC-Page__StandardSearch .BC-Page__StopWords .BC__Search-header {
  display: flex;
  justify-content: space-between;
  height: 15px;
  align-items: center;
}

.BC-Page__StandardSearch .BC-Page__StopWords .BC__StopWords-Search .Polaris-TextField {
  height: 30px;
}

.BC-Page__StandardSearch .BC__StopWords-Add .Polaris-Stack .Polaris-Stack__Item:first-child {
  flex: 0 0 211px;
}

.BC-Page__StopWords .pfs-app-banner .image {
  max-height: 116px;
}

.BC-Page__StandardSearch .BC-Page__StopWords .BC-Page__Title--Help {
  margin-bottom: 0;
}

/*StandardSearch - Redirects*/
.BC-Page__StandardSearch .BC-Page__Redirect .Polaris-Card .Polaris-Card__Section:nth-child(2) {
  padding-top: 0;
  border-top: none;
}

.BC-Page__StandardSearch .BC-Page.BC-Page__Redirect .Polaris-Card {
  box-shadow: none;
}

.BC-Page__StandardSearch .BC-Page.BC-Page__Redirect .Polaris-Card__Section {
  padding: var(--p-space-5);
  border: 1px solid var(--p-divider);
  margin: 0 -1px;
}

.BC-Page__StandardSearch .BC-Page__Redirect-New .Polaris-Card__Section {
  padding-bottom: 0 !important;
}

.BC-Page__StandardSearch .BC-Page.BC-Page__Redirect .Polaris-PageActions {
  border-top: 0;
}

.BC-Page__StandardSearch .BC-Page__Redirect .actionsGroup {
  position: static;
  margin-left: auto;
}

.BC-Page__StandardSearch .BC-Page__Redirect-New .addMoreSuggestion {
  border: 1px solid var(--p-divider);
  border-top: none;
  border-bottom-left-radius: var(--p-border-radius-2);
  border-bottom-right-radius: var(--p-border-radius-2);
  margin: 0 -1px;
}

.BC-Page__StandardSearch .BC-Page__Redirect-New .Polaris-DataTable__Table thead th {
  padding-top: 0;
  padding-bottom: var(--p-space-5);
}

.BC-Page__StandardSearch .BC-Page__Redirect .search .Polaris-TextField {
  height: 30px;
}

.BC-Page__StandardSearch .BC-Page__Redirect .list-header .Polaris-Stack__Item:nth-child(2) {
  width: 50%;
}

.BC-Page__StandardSearch .BC-Page__Redirect .Polaris-DataTable {
  margin: 0 -20px;
}

.BC-Page__StandardSearch .BC-Page__Redirect .newRedirect .Polaris-DataTable__Cell:first-child,
.BC-Page__StandardSearch .BC-Page__Redirect .editRedirect .Polaris-DataTable__Cell:nth-child(2) {
  width: 340px;
  padding-right: 0;
  padding-left: 16px;
}

.BC-Page__StandardSearch .BC-Page__Redirect .newRedirect .Polaris-DataTable__Cell:nth-child(2),
.BC-Page__StandardSearch .BC-Page__Redirect .editRedirect .Polaris-DataTable__Cell:nth-child(3) {
  padding-right: 0;
  padding-left: 16px;
  width: 456px;
}

.BC-Page__StandardSearch .BC-Page__Redirect .newRedirect .Polaris-DataTable__Cell:last-child,
.BC-Page__StandardSearch .BC-Page__Redirect .editRedirect .Polaris-DataTable__Cell:last-child {
  width: 68px;
  padding-right: 16px;
  padding-left: 16px;
}

.redirectsInfos .image {
  max-height: 172px;
}

/*StandardSearch - Redirects*/

/*StandardSearch - Suggestion dictionary*/
.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .search .Polaris-TextField {
  height: 30px;
}

.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .search {
  width: 55%;
  max-width: 424px;
}

.BC-Page__StandardSearch
  .BC-Page__SuggestionDictionary
  .Polaris-Card
  .Polaris-Card__Section:nth-child(2) {
  padding-top: 0;
  border-top: none;
}

.BC-Page__StandardSearch .BC-Page.BC-Page__SuggestionDictionary .Polaris-Card {
  box-shadow: none;
}

.BC-Page__StandardSearch .BC-Page.BC-Page__SuggestionDictionary .Polaris-Card__Section {
  padding: var(--p-space-5);
  border: 1px solid var(--p-divider);
}

.BC-Page__StandardSearch .BC-Page.BC-Page__SuggestionDictionary .Polaris-Card__Header {
  padding-top: 12px;
  margin: 0 -20px;
  padding-left: 36px;
}

.BC-Page__StandardSearch
  .BC-Page.BC-Page__SuggestionDictionary
  .Polaris-Card__Header
  .Polaris-Heading {
  font-size: 14px;
  font-weight: 600;
}

.BC-Page__StandardSearch
  .BC-Page.BC-Page__SuggestionDictionary
  .Polaris-Card__Header
  .Polaris-Stack__Item {
  margin: 0;
}

.BC-Page__StandardSearch .BC-Page.BC-Page__SuggestionDictionary .Polaris-PageActions {
  border-top: 0;
}

.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .actionsGroup {
  position: static;
  margin-left: auto;
}

.BC-Page__SuggestionDictionary .Polaris-Stack {
  align-items: center;
}

.BC-Page__StandardSearch
  .BC-Page__SuggestionDictionary
  .suggestion-list
  .Polaris-Card
  .Polaris-DataTable {
  margin: 0 -20px;
}

.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .suggestion-list .display-title {
  font-weight: 600;
  margin-bottom: 12px;
}

.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .suggestion-list .checkbox-label {
  display: flex;
  align-items: center;
  gap: 4px;
}

.BC-Page__StandardSearch
  .BC-Page__SuggestionDictionary
  .suggestion-list
  .checkbox-label
  .Polaris-Icon {
  width: 12px;
  height: 12px;
}

.BC-Page__StandardSearch
  .BC-Page__NewSuggestionDictionary
  .new-suggestion-wrap
  .Polaris-DataTable__Table {
  border-bottom: 1px solid var(--p-divider);
}

.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .new-suggestion-wrap {
  border: 1px solid var(--p-divider);
  border-radius: var(--p-border-radius-2);
}

.suggestionDictionaryInfos .image {
  max-height: 132px;
}

.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .BC-Page__Title--Help {
  margin-bottom: 0;
}

/*StandardSearch - Suggestion dictionary*/

/*StandardSearch - ISW */
.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .premium-iws-card {
  border: 1px solid #e1b878;
  background: #fff5ea;
}

.instantSearchWidgetInfo .image {
  max-height: 132px;
}

.iswWithResultTabCustomBanner {
  background-image: url('https://cdn.boostcommerce.io/assets/banners/background-banner-custom.png');
  background-repeat: no-repeat;
  background-position-y: bottom;
}

.iswWithResultTabCustomBanner .image img {
  max-height: 116px;
}

/*StandardSearch - ISW*/

/*AdvanceSearch - AI Synonym*/
.synonym-filter-popover .select-entity {
  padding-top: 10px;
  padding-bottom: 15px;
  border-bottom: 0.1rem solid var(--p-divider);
}

.synonym-filter-popover .action {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
}

.synonym-filter-popover .radio-group {
  padding-top: 10px;
  padding-bottom: 20px;
}

.synonym-filter-popover {
  padding: 20px;
}

.aiSynonymInfos .image {
  max-height: 136px;
}

.BC-Page__AdvancedSearch .tab-children .Polaris-Page-Header__Row {
  display: flex;
}

.BC-Page__AdvancedSearch .tab-children .BC-Page__Title--Help,
.BC-Page__StandardSearch .tab-children .BC-Page__Title--Help {
  margin-bottom: 0;
}

.BC-Page__AdvancedSearch_General .ai-status {
  margin-top: 16px;
}

.ai-search-update-status-warning ul li::marker {
  font-size: 0.7rem;
}

.ai-search-update-status-warning a {
  text-decoration: none;
}

.table-disabled {
  pointer-events: none;
  /* Disable all interactions */
  opacity: 0.5;
  /* Optional: Add opacity to show it's disabled */
}

.BC-Page__AdvancedSearch_General .toggle-status {
  border: 1px solid var(--border-divider, #e1e3e5);
  border-radius: 8px;
  box-shadow: none;
  padding: 20px;
  display: flex;
  margin-top: 16px;
  margin-bottom: 20px;
}

.premium-lock-advanced-search {
  width: 100%;
  height: auto;
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
}

.premium-lock-advanced-search .Polaris-Badge {
  background: rgba(255, 48, 0, 0.1);
  border-radius: 1000px;
  padding: 4px 10px;
  margin-bottom: 6px;
  align-items: center;
  text-align: center;
}

.premium-lock-advanced-search .Polaris-Badge span {
  display: flex;
  justify-content: space-between;
  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  align-items: center;
  text-align: center;
  font-size: 12px;
  gap: 2px;
}

.premium-lock-advanced-search .heading {
  font-size: 28px;
  font-weight: 600;
  line-height: 32px;
  display: flex;
  gap: 4px;
  align-items: center;
  margin-bottom: 6px;
}

.premium-lock-advanced-search .feature-list {
  margin-top: 24px;
}

.premium-lock-advanced-search .feature-list .BC-Carousel .carousel-cards {
  gap: 24px;
}

.premium-lock-advanced-search .feature-search-card {
  width: 332px;
  border-radius: 4px;
  min-height: 200px;
  padding-bottom: 20px;
}

.premium-lock-advanced-search .feature-search-card img {
  max-width: 332px;
  max-height: 200px;
}

.premium-lock-advanced-search .feature-search-card .content > div {
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  margin-top: 16px;
}

.premium-lock-advanced-search .feature-search-card .content > p {
  margin-top: 4px;
}

.premium-lock-advanced-search .carousel-controls {
  justify-content: center;
}

.premium-lock-advanced-search .carousel-controls .carousel-pagination > div {
  background: #d2d5d8;
}

.premium-lock-advanced-search .carousel-controls .carousel-pagination--active > div {
  background: #575959 !important;
}

.premium-lock-advanced-search .carousel-controls .carousel-pagination > div {
  width: 8px;
  height: 8px;
}

.premium-lock-advanced-search .BC-Carousel .carousel-controls button {
  padding: 4px;
}

.premium-lock-advanced-search .feature-list .BC-Carousel .carousel-cards {
}

/*AdvanceSearch - AI Synonym*/

.BC-Page__AdvancedSearch .Polaris-Header-Title__SubTitle {
  color: #202223;
}

.page-title-wrapper {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.BC-Page__AdvancedSearch .page-title-wrapper {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.BC-Page__AdvancedSearch .page-title-wrapper .Polaris-Badge {
  background: #ffebd3;
  border-radius: 1000px;
  background: rgba(255, 48, 0, 0.1);
  padding: 4px 10px;
}

.BC-Page__AdvancedSearch .page-title-wrapper .Polaris-Badge > span {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.BC-Page__AdvancedSearch .page-title-wrapper .Polaris-Badge > span span {
  text-align: center;
  font-weight: 600;
}

.BC-Page__AdvancedSearch .layout-wrapper > .Polaris-Layout {
  margin-top: 0;
}

.BC-Page__AdvancedSearch .BC-Container__Notifications .BC-Search__WarningBannerUpgrade {
  margin-top: 0;
  margin-bottom: 24px;
}

.BC-Page__StandardSearch
  > .Polaris-Page
  > div:not(.Polaris-Page-Header)
  > .Polaris-Layout
  > .Polaris-Layout__Section:first-child,
.BC-Page__AdvancedSearch .layout-wrapper > .Polaris-Layout > .Polaris-Layout__Section:first-child {
  margin-top: 24px !important;
}

.BC-Page__AdvancedSearch
  .layout-wrapper
  > .Polaris-Layout
  .Polaris-Layout__Section:not(:first-child) {
  margin-top: 0;
}

.BC-Page.AdvanceSearch__Content .incoming {
  display: flex;
  flex-direction: column;
  gap: 22px;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 240px;
}

.BC-Page.AdvanceSearch__Content .incoming p {
  font-size: 20px;
  line-height: 28px;
}

/* AdvanceSearch - Semantic */
.BC-Page .BC-Page__Semantic {
  position: relative;
  min-height: 550px;
}

.BC-Page .BC-Page__Semantic .Polaris-Layout {
  margin-top: 16px;
}

.advance-feature-layout-disable {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto;
  min-height: 250px;
}

.advance-feature-layout-disable p:first-child {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}

.advance-feature-layout-disable p:last-child {
  color: rgba(109, 113, 117, 1);
  font-size: 14px;
  margin-top: 8px;
}

.advance-feature-layout-disable .Polaris-Link {
  text-decoration: none;
}

.advance-feature-layout-disable .Polaris-Icon {
  margin: unset;
  display: inline-flex;
  vertical-align: top;
}

.BC-Page .BC-Page__Semantic .enable-semantic-search {
  height: 60px;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e1e3e5;
  margin-top: 16px;
}

.BC-Page .BC-Page__Semantic .BC-Container__Notifications {
  margin-bottom: -8px;
}

.BC-Page .BC-Page__Semantic .BC-Container__Notifications .Polaris-Banner__Content {
  padding: 0;
}

.BC-Page .BC-Page__Semantic .semantic-setting {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}

.BC-Page .BC-Page__Semantic .semantic-setting .content {
  width: 50%;
  display: inline-grid;
  gap: 4px;
}

.BC-Page .BC-Page__Semantic .title {
  font-weight: 600;
  font-size: 16px;
}

.BC-Page .BC-Page__Semantic .semantic-setting .setting-weight {
  width: 50%;
}

.BC-Page .BC-Page__Semantic .semantic-setting .Polaris-RangeSlider-SingleThumb__OutputBubble {
  width: 350px;
}

.BC-Page .BC-Page__Semantic .semantic-setting .Polaris-RangeSlider-SingleThumb__OutputText {
  text-transform: none;
  font-weight: 400;
  font-size: 14px;
}

.BC-Page .BC-Page__Semantic .semantic-simulator .content {
  margin-top: 20px;
  margin-bottom: 16px;
  display: inline-grid;
  gap: 4px;
}

.BC-Page .BC-Page__Semantic .semantic-simulator .product-list {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.BC-Page .BC-Page__Semantic .semantic-simulator .product-list .with-semantic,
.BC-Page .BC-Page__Semantic .semantic-simulator .product-list .without-semantic {
  width: 50%;
  border: 1px solid #e1e3e5;
  border-radius: 8px;
}

.BC-Page .BC-Page__Semantic .semantic-simulator .product-list .header {
  padding: 12px 16px 12px 16px;
  border-bottom: 1px solid #e1e3e5;
  display: flex;
  justify-content: space-between;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.BC-Page .BC-Page__Semantic .semantic-simulator .product-list .with-semantic .header {
  background-color: #fff5ea;
}

.BC-Page .BC-Page__Semantic .semantic-simulator .product-list .without-semantic .header {
  background-color: #e1e3e5;
}

.BC-Page .BC-Page__Semantic .semantic-simulator .product-list .BC-Component-ProductList {
  padding: 8px;
  max-height: 480px;
  overflow: auto;
}

.BC-Page .BC-Page__Semantic .divider {
  margin-top: 20px !important;
}

.Polaris-Frame-Toast {
  font-size: 16px;
}

/* AdvanceSearch - Semantic */

/* AdvanceSearch - Product performance ranking */
.BC-Page__ProductPerformanceRanking .Polaris-Layout__Section .Polaris-Card {
  padding: 20px;
  box-shadow: none;
  border-radius: 8px;
  border: 1px solid var(--border-divider, #e1e3e5);
}

.BC-Page__ProductPerformanceRanking .settings-infos {
  display: grid;
  gap: 12px;
}

.BC-Page__ProductPerformanceRanking .settings-infos .metric > span {
  font-size: 16px;
  line-height: 24px;
}

.BC-Page__ProductPerformanceRanking .settings-infos .note {
  margin-top: -4px;
}

.BC-Page__ProductPerformanceRanking .settings-infos .Polaris-Label__Text {
  font-weight: 600;
}

.BC-Page__ProductPerformanceRanking .metric .content {
  color: rgba(109, 113, 117, 1);
  margin-top: 4px;
}

.BC-Page__ProductPerformanceRanking .metric-box {
  border-style: solid;
  border-width: 1px;
  border-radius: 8px;
  height: 162px;
  margin-top: 15px;
  position: relative;
}

.BC-Page__ProductPerformanceRanking .metric-box .metric-box-content {
  padding: 16px;
}

.BC-Page__ProductPerformanceRanking .metric-box.metric-box-high {
  width: 41%;
  background-color: #f5fffd;
  border-color: #b6eadd;
  margin-right: 15px;
}

.BC-Page__ProductPerformanceRanking .metric-box.metric-box-medium {
  width: 28%;
  background-color: #f0f7ff;
  border-color: #b9d7f8;
  margin-right: 7.5px;
}

.BC-Page__ProductPerformanceRanking .metric-box.metric-box-low {
  width: 28%;
  background-color: #fafafb;
  border-color: #e1e3e5;
  margin-left: 7.5px;
}

.BC-Page__ProductPerformanceRanking .metric-box-text {
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  text-align: center;
  gap: 4px;
  height: 100%;
  padding: 2px 8px 2px 6px;
}

.BC-Page__ProductPerformanceRanking .metric-box-text.metric-box-text-high {
  background-color: #dafbf3;
}

.BC-Page__ProductPerformanceRanking .metric-box-text.metric-box-text-medium {
  background-color: #e4f7fa;
}

.BC-Page__ProductPerformanceRanking .metric-box-text.metric-box-text-low {
  background-color: #edeeef;
}

.BC-Page__ProductPerformanceRanking .metric-box-text .metric-box-text-level-high {
  color: #008060;
}

.BC-Page__ProductPerformanceRanking .metric-box-text .metric-box-text-level-medium {
  color: #2c6ecb;
}

.BC-Page__ProductPerformanceRanking .metric-box-text .metric-box-text-level-low {
  color: #6d7175;
}

.BC-Page__ProductPerformanceRanking .metric-box-description {
  color: #6d7175;
}

.BC-Page__ProductPerformanceRanking .metric-box-description-high {
  width: 70%;
  bottom: 15px;
  position: absolute;
}

.BC-Page__ProductPerformanceRanking .metric-box-description-medium {
  padding-right: 10px;
  bottom: 15px;
  position: absolute;
}

.BC-Page__ProductPerformanceRanking .metric-box-description-low {
  padding-right: 10px;
  bottom: 15px;
  position: absolute;
}

.BC-Page__ProductPerformanceRanking .metric-box-image-high {
  position: absolute;
  right: 10px;
  top: 10px;
}

.BC-Page__ProductPerformanceRanking .metric-box-image-medium {
  position: absolute;
  right: 5px;
  top: 5px;
}

.BC-Page__ProductPerformanceRanking .metric-box-image-low {
  position: absolute;
  right: 5px;
  top: 5px;
}

.BC-Page__ProductPerformanceRanking .weight-dot-high {
  background: #007f5f;
}

.BC-Page__ProductPerformanceRanking .weight-dot-medium {
  background: #2c6ecb;
}

.BC-Page__ProductPerformanceRanking .weight-dot-low {
  background: #5c5f62;
}

.BC-Page__ProductPerformanceRanking .weight-dot {
  border-radius: 50%;
  height: 8px;
  width: 8px;
}

.BC-Page__ProductPerformanceRanking .settings-infos .default-text-style > span:first-child {
  font-weight: 600 !important;
  line-height: 20px;
}

.BC-Page__ProductPerformanceRanking .settings-infos .default-text-style > span:first-child {
  font-weight: 600 !important;
  line-height: 20px;
}

.BC-Page__ProductPerformanceRanking .test-your-search {
  display: flex;
  position: relative;
  padding: 16px 20px;
  gap: 6px;
  align-items: center;
  background-color: #f2fbfd;
  border-radius: 8px;
}

.BC-Page__ProductPerformanceRanking .test-your-search .wave-background-img {
  position: absolute;
  bottom: 0;
  right: 0;
}

.BC-Page__ProductPerformanceRanking .test-your-search a {
  color: #2c6ecb;
  margin-right: 4px;
  text-decoration: none;
}

.BC-Page__ProductPerformanceRanking .test-your-search .Polaris-Icon {
  margin-left: 2px;
}

.BC-Page__ProductPerformanceRanking .product-preview {
  margin-top: 20px;
}

.BC-Page__ProductPerformanceRanking .product-preview .content > span {
  font-size: 16px;
  margin-bottom: 4px;
}

.BC-Page__ProductPerformanceRanking .product-preview > div:not(:first-child) {
  margin-top: 16px;
}

.BC-Page__ProductPerformanceRanking .BC-Component-ProductList .no-product {
  color: rgba(109, 113, 117, 1);
  padding: 16px;
}

/* End: AdvanceSearch - Product performance ranking */

#menu-search-advanced-search .Polaris-Badge--statusWarning {
  background-color: #ffebd3;
  font-size: 12px;
}

#menu-search-advanced-search .Polaris-ActionList__Suffix {
  margin-left: 4px;
  position: relative;
  top: 1px;
}

/* BFCM2023 css */
body:has(.BFCM23) #menu-tool-subscription {
  background: -webkit-linear-gradient(left, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);
  background: -o-linear-gradient(right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);
  background: -moz-linear-gradient(right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);
  background: linear-gradient(to right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

body:has(.BFCM23) #menu-tool-subscription .Polaris-Badge.Polaris-Badge--statusWarning {
  color: white;
  font-weight: bold;
  font-size: 12px;
  background: -webkit-linear-gradient(left, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);
  background: -o-linear-gradient(right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);
  background: -moz-linear-gradient(right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);
  background: linear-gradient(to right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);
  -webkit-text-fill-color: snow;
}

.BC-Subscription__DashboardV3--BFCM23 {
  position: relative;
}

.BC-Subscription__DashboardV3--BFCM23 .Polaris-Card {
  background: -webkit-linear-gradient(right, #d9e8ff, #ffffff, #ffeefc);
  background: -o-linear-gradient(left, #d9e8ff, #ffffff, #ffeefc);
  background: -moz-linear-gradient(left, #d9e8ff, #ffffff, #ffeefc);
  background: linear-gradient(to left, #d9e8ff, #ffffff, #ffeefc);
}

.BC-Subscription__DashboardV3--BFCM23 .t-sale {
  position: absolute;
  right: 10px;
  top: -10px;
  z-index: 1;
  width: 116px;
}

.BC-Subscription__DashboardV3--BFCM23 .t-semi {
  position: absolute;
  width: 18px;
  height: 36px;
  top: 55%;
  z-index: 1;
  background: rgba(246, 246, 247, 1);
  box-shadow: inset 0 0 2px 0 #c7c7c7;
}

.BC-Subscription__DashboardV3--BFCM23 .t-semi:after {
  position: absolute;
  width: 18px;
  height: 36px;
  top: 0;
  z-index: 2;
  background: rgba(246, 246, 247, 1);
  content: '';
  display: block;
}

.BC-Subscription__DashboardV3--BFCM23 .t-left {
  border-radius: 0 18px 18px 0;
  left: 0;
}

.BC-Subscription__DashboardV3--BFCM23 .t-right {
  border-radius: 18px 0px 0 18px;
  right: 0;
}

.BC-Subscription__DashboardV3--BFCM23 .t-left::after {
  border-radius: 0 18px 18px 0;
  left: -2px;
}

.BC-Subscription__DashboardV3--BFCM23 .t-right::after {
  border-radius: 18px 0px 0 18px;
  right: -2px;
}

.BC-Subscription__DashboardV3--BFCM23 .t-line {
  position: absolute;
  width: calc(100% - 36px);
  height: 1px;
  border-bottom: 1px dashed rgba(225, 227, 229, 1);
  top: calc(55% + 18px);
  left: 50%;
  z-index: 1;
  transform: translateX(-50%);
}

.BC-Subscription__DashboardV3--BFCM23 .Polaris-Button.Polaris-Button--primary,
.bfcm23-plan .Polaris-Button.Polaris-Button--primary {
  background: -webkit-linear-gradient(left, #ff00e6, #3f00c6, #224fda, #00aaf2, #00e4e4);
  background: -o-linear-gradient(right, #ff00e6, #3f00c6, #224fda, #00aaf2, #00e4e4);
  background: -moz-linear-gradient(right, #ff00e6, #3f00c6, #224fda, #00aaf2, #00e4e4);
  background: linear-gradient(to right, #ff00e6, #3f00c6, #224fda, #00aaf2, #00e4e4);
  -webkit-text-fill-color: snow;
}

.BC-Subscription__DashboardV3--BFCM23 .Polaris-Button.Polaris-Button--primary:hover,
.bfcm23-plan .Polaris-Button.Polaris-Button--primary:hover {
  background: -webkit-linear-gradient(left, #3f00c6, #3716cb, #00aaf2, #ff00e6);
  background: -o-linear-gradient(right, #3f00c6, #3716cb, #00aaf2, #ff00e6);
  background: -moz-linear-gradient(right, #3f00c6, #3716cb, #00aaf2, #ff00e6);
  background: linear-gradient(to right, #3f00c6, #3716cb, #00aaf2, #ff00e6);
  -webkit-text-fill-color: snow;
}

.BC-Subscription__DashboardV3--BFCM23 .Polaris-Button.Polaris-Button--primary .Polaris-Button__Text,
.bfcm23-plan .Polaris-Button.Polaris-Button--primary .Polaris-Button__Text {
  display: flex;
  align-items: center;
}

/* Css for banner dashboard */
.BC-CampaignCarousel__DashboardV3
  .BC-Carousel
  .carousel-item:has(.banner-bfcm23):has(.banner-plan) {
  background-image: url('https://cdn.boostcommerce.io/assets/common/BFCM-2023-banner-plan.png');
}

.BC-CampaignCarousel__DashboardV3
  .BC-Carousel
  .carousel-item:has(.banner-bfcm23):has(.banner-analytic) {
  background-image: url('https://cdn.boostcommerce.io/assets/common/BFCM-2023-banner-analytic.png');
}

.BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-item .banner-bfcm23 {
  /* This will make the div clickable */
  width: 100%;
  height: 100%;
}

.packages div div:has(.bfcm23-package) {
  padding-top: 70px;
}

.packages .Polaris-Card:has(.bfcm23-package) {
  position: relative;
  padding-top: 50px !important;
}

.packages .Polaris-Card:has(.bfcm23-package) .most-popular {
  top: 25px !important;
  z-index: 5;
}

/* Start: New pricing for expire/exceed */
.packages.packages--expire-exceed div .Polaris-Card {
  border: 1px solid var(--border-subdued, #c9cccf);
  box-shadow: none;
  border-radius: 8px !important;
}

.packages.packages--expire-exceed div div .Polaris-Card .package-tag {
  height: 20px;
  padding: 10px;
  border-radius: 20px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  position: absolute;
  top: -10px;
  left: 33%;
}

.packages.packages--expire-exceed div .Polaris-Card:nth-child(2) {
  border: 1px solid var(--border-subdued, #c9cccf);
  box-shadow: none;
  background: white;
}

.packages.packages--expire-exceed div .Polaris-Card:nth-child(2) .package-action .Polaris-Button {
  color: #008060;
}

.packages.packages--expire-exceed div div .Polaris-Card .package-tag.most-popular {
  background: #008060;
}

.packages.packages--expire-exceed div div .Polaris-Card .package-tag.current-plan {
  border: 1px solid #008060;
  background: white;
  color: #008060;
}

.packages.packages--expire-exceed div div .Polaris-Card .package-tag.recommended {
  background: #008060;
}

.packages.packages--expire-exceed
  div
  .Polaris-Card
  .package-action
  .Polaris-Button.Polaris-Button--primary {
  color: white;
  background: #008060;
}

.packages.packages--expire-exceed
  div
  .Polaris-Card
  .package-action
  .Polaris-Button.Polaris-Button--primary:hover {
  background: var(--pc-button-color-hover);
  color: var(--pc-button-text);
}

.packages.packages--expire-exceed
  div
  .Polaris-Card
  .package-action
  .Polaris-Button.Polaris-Button--disabled {
  background: white;
  color: var(--p-text-disabled);
  border-color: var(--border-subdued, #c9cccf);
}

.packages.packages--expire-exceed
  div
  .Polaris-Card
  .package-action
  .Polaris-Button.Polaris-Button--primary.Polaris-Button--disabled {
  background: var(--p-action-primary-disabled);
  color: var(--p-text-disabled);
  border-color: var(--p-action-primary-disabled);
}

.packages.packages--expire-exceed div .Polaris-Card {
  border-radius: 8px;
}

.packages.packages--expire-exceed div .Polaris-Card:has(.highlight),
.BC-Page__SubscriptionV3-Package
  .packages.packages--expire-exceed
  div
  .Polaris-Card:has(.highlight) {
  background: #f1f8f5;
  border: 1px solid #008060;
  border-radius: 8px;
}

.packages.packages--expire-exceed
  div
  .Polaris-Card:not(:nth-child(2))
  .package-action
  .Polaris-Button--primary:hover {
  background: var(--pc-button-color-hover) !important;
}

.compare-action {
  display: flex;
  background: #fffbf3;
  border-radius: 8px;
  padding: 12px 20px;
  margin-top: 20px;
  justify-content: space-between;
}

.compare-action .text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
}

.compare-action .Polaris-Button {
  background: #ffc96b;
}

.compare-action .Polaris-Button:hover {
  background: #ffd96b;
}

.packages.packages--expire-exceed > div > p span {
  text-decoration: none;
}

.BC-Page__SubscriptionV3 .DidYouKnowBannerExceeded {
  border: 1px solid #95c9b4;
  background: #f7fdfc;
}

.BC-Page__SubscriptionV3 .DidYouKnowBannerExceeded .image {
  margin-top: -20px;
  margin-bottom: -30px;
}

/* End: New pricing for expire/exceed */
.bfcm23-package {
  position: absolute;
  top: -32px;
  left: -1px;
  z-index: 3;
  width: calc(100% + 2px);
  height: 36px;
  margin-top: 0px !important;
}

.bfcm23-package .text-discount {
  width: 100%;
  background: -webkit-linear-gradient(left, #ff00e6, #3f00c6, #00aaf2, #00e4e4);
  background: -o-linear-gradient(right, #ff00e6, #3f00c6, #00aaf2, #00e4e4);
  background: -moz-linear-gradient(right, #ff00e6, #3f00c6, #00aaf2, #00e4e4);
  background: linear-gradient(to right, #ff00e6, #3f00c6, #00aaf2, #00e4e4);
  color: white;
  border-radius: 4px 4px 0 0;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}

.billing-title-code-bfcm23 {
  background: -webkit-linear-gradient(left, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);
  background: -o-linear-gradient(right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);
  background: -moz-linear-gradient(right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);
  background: linear-gradient(to right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-top: -5px;
}

.addon-card-preview .react-multi-carousel-item .Polaris-Card:has(.bfcm23-add-on-highlight) {
  background: -webkit-linear-gradient(
    right,
    rgba(217, 232, 255, 0.51),
    rgba(255, 255, 255, 0.62),
    rgba(255, 238, 252, 1)
  );
  background: -o-linear-gradient(
    left,
    rgba(217, 232, 255, 0.51),
    rgba(255, 255, 255, 0.62),
    rgba(255, 238, 252, 1)
  );
  background: -moz-linear-gradient(
    left,
    rgba(217, 232, 255, 0.51),
    rgba(255, 255, 255, 0.62),
    rgba(255, 238, 252, 1)
  );
  background: linear-gradient(
    to left,
    rgba(217, 232, 255, 0.51),
    rgba(255, 255, 255, 0.62),
    rgba(255, 238, 252, 1)
  );
}

.addon-card-preview
  .react-multi-carousel-item
  .Polaris-Card:has(.bfcm23-add-on-highlight)
  .bfcm23-add-on-highlight {
  position: relative;
}

.addon-card-preview
  .react-multi-carousel-item
  .Polaris-Card:has(.bfcm23-add-on-highlight)
  .bfcm23-add-on-highlight
  .offer-50 {
  position: absolute;
  top: -25px;
  right: -30px;
  z-index: 11;
}

.addon-card-preview
  .react-multi-carousel-item
  .Polaris-Card:has(.bfcm23-add-on-highlight)
  .bfcm23-add-on-highlight
  .Polaris-Button {
  background: linear-gradient(to right, #ff00e6, #3f00c6, #224fda, #00aaf2, #00e4e4);
  -webkit-text-fill-color: snow;
}

.addon-card-preview
  .react-multi-carousel-item
  .Polaris-Card:has(.bfcm23-add-on-highlight)
  .bfcm23-add-on-highlight
  .Polaris-Button:hover {
  background: -webkit-linear-gradient(left, #3f00c6, #3716cb, #00aaf2, #ff00e6);
  background: -o-linear-gradient(right, #3f00c6, #3716cb, #00aaf2, #ff00e6);
  background: -moz-linear-gradient(right, #3f00c6, #3716cb, #00aaf2, #ff00e6);
  background: linear-gradient(to right, #3f00c6, #3716cb, #00aaf2, #ff00e6);
  -webkit-text-fill-color: snow;
}

.addon-card-preview
  .react-multi-carousel-item
  .Polaris-Card:has(.bfcm23-add-on-highlight)
  .bfcm23-add-on-highlight
  .Polaris-Button
  .Polaris-Button__Text {
  display: flex;
  justify-content: center;
  align-items: center;
}

.review-addon-modal .addon-billing .discount-code-info .discount-applied .code.bfcm23,
.review-package-modal .package-billing .discount-code-info .discount-applied .code.bfcm23 {
  background: none;
  border: 0;
}

.review-addon-modal .addon-billing .discount-code-info .discount-applied .code.bfcm23 > div,
.review-package-modal .package-billing .discount-code-info .discount-applied .code.bfcm23 > div {
  display: flex;
  align-items: center;
}

.review-addon-modal
  .addon-billing
  .discount-code-info
  .discount-applied
  .code
  .Polaris-Button--iconOnly,
.review-package-modal
  .package-billing
  .discount-code-info
  .discount-applied
  .code
  .Polaris-Button--iconOnly {
  position: static;
}

.review-addon-modal
  .addon-billing
  .discount-code-info
  .discount-applied
  .code.bfcm23
  .Polaris-TextStyle--variationStrong,
.review-package-modal
  .package-billing
  .discount-code-info
  .discount-applied
  .code.bfcm23
  .Polaris-TextStyle--variationStrong {
  color: #008060;
  margin-right: 0;
}

.review-package-modal
  .review-package
  .Polaris-ChoiceList__ChoiceItem:has(input[aria-checked='true']) {
  border: 1px solid #2c6ecb;
}

.review-package-modal .package-option {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.review-package-modal .package-option .Polaris-Choice {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #c9cccf;
}

.review-package-modal .package-option .Polaris-Choice:has(input:checked) {
  border: 1px solid #007f5f;
}

.review-package-modal .package-option .Polaris-Choice .Polaris-Choice__Control {
  margin-right: 0;
}

.review-addon-modal:has(.review-addon-v2) {
  width: 980px;
  min-height: unset;
}

.review-addon-modal .review-addon-v2 {
  width: 640px;
  gap: 15px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-right: 1px solid #e1e3e5;
}

.review-addon-modal .review-addon-v2 .heading {
  height: 48px;
  position: relative;
}

.review-addon-modal .review-addon-v2 .heading .title {
  font-size: 20px;
  font-weight: 600;
}

.review-addon-modal .review-addon-v2 .heading .detail-wrap {
  width: auto;
  display: inline-block;
}

.review-addon-modal .review-addon-v2 .heading .detail {
  margin-top: 5px;
  display: flex;
  gap: 8px;
  width: auto;
  cursor: pointer;
  color: #6d7175;
  font-size: 12px;
}

.review-addon-modal .review-addon-v2 .heading .download {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 16px;
  font-size: 12px;
  background: #f6f6f7;
}

.review-addon-modal .review-addon-v2 .block {
  padding: 10px 15px;
  background: #f6f6f7;
  border-radius: 8px;
}

.review-addon-modal .review-addon-v2 .block .title {
  margin: 5px 0 10px 0;
}

.review-addon-modal .review-addon-v2 .block .list-addon-ui {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-auto-rows: auto;
  gap: 10px;
}

.review-addon-modal .review-addon-v2 .block .list-addon-ui > div {
  display: flex;
  justify-content: flex-start;
  gap: 4px;
  text-align: left;
}

.review-addon-modal .review-addon-v2 .block .list-addon-ui.has-2-col {
  grid-template-rows: repeat(2, auto);
  grid-template-columns: repeat(2, 1fr);
}

.review-addon-modal .review-addon-v2 .block .list-addon-ui.has-3-col {
  grid-template-rows: auto auto;
  grid-template-columns: repeat(3, 1fr);
}

.review-addon-modal .review-addon-v2 .block .list-addon-ui.has-1-col {
  grid-template-rows: auto auto;
  grid-template-columns: repeat(1, 1fr);
}

.review-addon-modal .review-addon-v2 .slide {
  height: 200px;
  position: relative;
}

.review-addon-modal .review-addon-v2 .slide ul.carousel-cards {
  margin: 0;
}

.review-addon-modal .review-addon-v2 .slide ul.carousel-cards li {
  width: 100%;
}

.review-addon-modal .review-addon-v2 .slide .slide-bg {
  height: 200px;
  position: relative;
  background: linear-gradient(to right, #cff1ff, #fff0f9);
  border-radius: 12px;
}

.review-addon-modal .review-addon-v2 .slide .slide-bg .title {
  font-weight: 600;
  font-size: 20px;
  position: absolute;
  top: 50px;
  left: 30px;
}

.review-addon-modal .review-addon-v2 .slide .slide-bg .des {
  font-weight: 400;
  font-size: 14px;
  position: absolute;
  top: 80px;
  left: 30px;
  max-width: 294px;
}

.review-addon-modal .review-addon-v2 .slide .slide-bg .img {
  position: absolute;
  top: 0;
  right: 0;
}

.review-addon-modal .review-addon-v2 .slide .carousel-controls {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
}

.review-addon-modal .review-addon-v2 .slide .carousel-controls .carousel-btn {
  display: none;
}

.review-addon-modal .review-addon-v2 .slide .carousel-controls .carousel-pagination {
  padding: 4px;
}

.review-addon-modal .review-addon-v2 .slide .carousel-controls .carousel-pagination div {
  border-radius: 50% !important;
  display: block;
  width: 8px;
  height: 8px;
  background: #d2d5d8;
}

.review-addon-modal
  .review-addon-v2
  .slide
  .carousel-controls
  .carousel-pagination.carousel-pagination--active
  div {
  border-radius: 50% !important;
  display: block;
  width: 8px;
  height: 8px;
  background: #575959 !important;
}

.review-addon-modal .review-addon-v2 .slide .slide-controls .btn-next,
.review-addon-modal .review-addon-v2 .slide .slide-controls .btn-prev {
  width: 28px;
  display: none;
}

.review-addon-modal .review-addon-v2 .slide .slide-controls .btn-next > span {
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  margin-top: 0;
}

.review-addon-modal .review-addon-v2 .slide .slide-controls .btn-prev > span {
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  margin-top: 0;
  left: 4px;
}

.review-addon-modal .review-addon-v2 .slide:hover .btn-next,
.review-addon-modal .review-addon-v2 .slide:hover .btn-prev {
  display: block;
}

.review-addon-modal .review-addon-v2 .slide:hover .hover::before {
  display: block;
  width: 24px;
  height: 100%;
  left: 0;
  content: '';
  position: absolute;
  background: linear-gradient(to right, #ffffff, #cff1ff);
  opacity: 0.65;
}

.review-addon-modal .review-addon-v2 .slide .carousel-item:hover .hover::after {
  display: block;
  width: 24px;
  height: 100%;
  right: 0;
  content: '';
  position: absolute;
  background: linear-gradient(to right, #fff0f9, #ffffff);
  opacity: 0.75;
}

/* BFCM2023 css end*/

.BC-Component-ProductList .product {
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 8px;
  gap: 14px;
}

.BC-Component-ProductList .no-product {
  display: flex;
  padding: 8px;
  border-radius: 8px;
  min-height: 270px;
}

.BC-Component-ProductList .product:hover {
  background-color: #f6f6f7;
  cursor: pointer;
}

.BC-Component-ProductList .product:hover .hover-view {
  display: flex;
}

.BC-Component-ProductList .product:hover .product-info .product-title {
  text-decoration: underline;
}

.BC-Component-ProductList .product .product-no {
  min-width: 30px;
  display: flex;
  justify-content: center;
}

.BC-Component-ProductList .product .product-ranking {
  border-radius: 4px;
  border: 1px solid var(--Banner-Border-color-new-border, #babfc3);
  background: var(--Banner-Background-color-new-bg, #fafafa);
  display: flex;
  width: 48px;
  min-width: 48px;
  height: 40px;
  padding: 6px 8px;
  justify-content: center;
  align-items: center;
  gap: 2px;
}

.BC-Component-ProductList .product .product-ranking-up {
  border: 1px solid var(--Banner-Border-color-success-border, #95c9b4);
  background: var(--Banner-Background-color-success-bg, #f7fdfc);
  color: #008060;
}

.BC-Component-ProductList .product .product-ranking-up .Polaris-Icon svg {
  fill: #008060;
}

.BC-Component-ProductList .product .product-ranking .Polaris-Icon {
  min-width: 12px;
  min-height: 12px;
  width: 12px;
  height: 12px;
  margin: 1px 2px;
}

.BC-Component-ProductList .product .product-ranking-down .Polaris-Icon svg {
  fill: #d72c0d;
}

.BC-Component-ProductList .product .product-ranking-down {
  border: 1px solid var(--Banner-Border-color-critical-border, #e0b3b2);
  background: var(--Banner-Background-color-critical-bg, #fff4f4);
  color: #d72c0d;
}

.BC-Component-ProductList .product .product-image {
  border: 1px solid #c9cccf;
  border-radius: 4px;
  width: 48px;
  height: 48px;
  min-width: 48px;
  display: flex;
  justify-content: center;
}

.BC-Component-ProductList .product .product-image img {
  width: auto;
  height: auto;
  max-height: 100%;
  max-width: 100%;
}

.BC-Component-ProductPrice .price-compare {
  color: #8c9196;
  margin-left: 5px;
}

.BC-Component-ProductPrice .price-sale {
  color: #d72c0d;
}

.BC-Component-ProductList .product .product-info {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.BC-Component-ProductList .product:not(:first-child) .product-info {
  padding: 8px;
}

.BC-Component-ProductList .load-more {
  padding: 8px;
  display: flex;
  justify-content: center;
}

.BC-Component-ProductList .product .hover-view {
  min-width: 42px;
  margin-left: auto;
  display: none;
}

.BC-Component-ProductDetail {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.BC-Component-ProductDetail .product-image {
  width: 35%;
}

.BC-Component-ProductDetail .product-image img {
  width: 100%;
  height: auto;
}

.BC-Component-ProductDetail .product-info {
  width: 65%;
}

.BC-Component-ProductDetail .product-info .product-title {
  font-size: 20px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 5px;
}

.BC-Component-ProductDetail .product-info .product-vendor {
  font-size: 12px;
  color: #6d7175;
  margin-bottom: 5px;
}

.BC-Component-ProductDetail .product-info .product-data {
  margin-top: 20px;
}

.BC-Component-ProductDetail .product-info .product-data .field-name {
  font-weight: 600;
}

.BC-Component-ProductDetail .product-info .product-data .field-value {
  color: #6d7175;
  margin-top: 8px;
}

.BC-Component-ProductDetail .product-info .product-data .field-value .Polaris-Badge {
  margin-right: 8px;
  margin-bottom: 8px;
  font-size: 12px;
}

.BC-Component-ProductDetail .product-info .product-data .field-value:has(.Polaris-Badge) {
  margin-bottom: -8px;
}

/* Lucky draw: START */
.lucky-modal-container {
  min-height: 600px;
}

.lucky-modal-container .close {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 9;
  cursor: pointer;
}

.lucky-modal-container .ReactTypeformEmbed {
  border-radius: 8px;
}

body:has(.lucky-modal-container) .Polaris-Modal-Section {
  padding: 0;
}

/* Lucky draw: END */

/*Search Engine Control start*/
.BC-Page__SearchControl .Polaris-Page {
  max-width: 1152px;
}

.BC-Page__SearchControl .layout-wrapper {
  margin-top: 20px;
}

.BC-Page__SearchControl .BC-GuideBanner {
  margin-top: 24px !important;
}

.BC-Container__Translation .BC-GuideBanner {
  margin-top: 0 !important;
}

.SearchControl__Content table {
  border: 1px solid var(--p-divider);
  border-radius: 8px;
  margin-top: 20px;
}

.BC-Page__SearchControl .Polaris-Layout__Section:first-child {
  margin-top: 0;
}

.BC-Page__SearchControl .Polaris-Layout__Section:not(:first-child) {
  margin-top: 24px;
}

.SearchControl__Content table thead td {
  font-weight: 600;
}

.SearchControl__Content table tbody td {
  padding: 16px;
}

.SearchControl__Content .table-features .feature-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

.SearchControl__Content .table-features .feature-wrapper .Polaris-Badge > span {
  display: flex;
  align-items: center;
  grid-gap: 4px;
  gap: 4px;
  font-size: 12px;
}

.SearchControl__Content .table-features .action .settings-icon .Polaris-Icon,
.SearchControl__Content .table-features .action img {
  width: 16px;
  height: 16px;
}

.SearchControl__Content .table-features .action .unlock-button {
  display: flex;
  gap: 4px;
  border: 1px solid #e1b878;
  border-radius: 4px;
  padding: 4px 10px;
  cursor: pointer;
}

.SearchControl__Content .table-features .action .unlock-button-disabled {
  background: #f7f3ef !important;
  border: 1px solid #d1d1d1;
  color: gray !important;
  cursor: unset;
}

.SearchControl__Content .table-features .action .unlock-button-disabled .Polaris-Icon svg {
  fill: var(--p-icon);
}

.SearchControl__Content .table-features .action .unlock-button .Polaris-Icon {
  height: 20px;
  width: 20px;
}

.SearchControl__Content .table-features .action .wrap-icon {
  width: 28px;
  height: 28px;
  border: 1px solid #c9cccf;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.SearchControl__Content .table-features .action .wrap-icon:first-child {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}

.SearchControl__Content .table-features .action .wrap-icon:nth-child(2) {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  border-left: none;
}

.SearchControl__Content .table-features .action .wrap-icon-disabled .Polaris-Icon__Svg {
  fill: #babec3;
}

.SearchControl__Content .table-features .wrap-icon-disabled img {
  filter: invert(77%) sepia(5%) saturate(229%) hue-rotate(173deg) brightness(101%) contrast(85%);
}

.SearchControl__Content .table-features .Polaris-Badge--statusNew .Polaris-Badge-Pip {
  background-color: #6d7175;
}

.SearchControl__Content .table-features .Polaris-Badge--statusNew {
  background-color: #f1f2f3;
}

.SearchControl__Content .table-features .type-wrapper .Polaris-Badge {
  border-radius: 2px;
}

.SearchControl__Content .table-features .Polaris-Badge {
  font-size: 12px;
  font-weight: 400;
}

.control-lock-tooltip .Polaris-Icon {
  margin: unset;
  display: inline-flex;
  vertical-align: top;
}

.control-lock-tooltip .Polaris-Link {
  text-decoration: none;
}

.Search-Control-Table tbody .Polaris-DataTable__TableRow:hover {
  background: rgba(246, 246, 247, 1);
  cursor: pointer;
}

.Search-Control-Table tbody .group-heading:hover,
.Search-Control-Table .group-heading {
  color: rgba(109, 113, 117, 1);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  background: rgba(250, 251, 251, 1);
}

.Search-Control-Table .group-heading td {
  padding: 12px 16px !important;
}

.Search-Control-Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:first-child {
  width: 35%;
}

.Search-Control-Table tbody .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:first-child {
  padding: unset;
}

.Search-Control-Table .Polaris-DataTable__TableRow .type-wrapper {
  color: rgba(32, 34, 35, 1);
}

.Search-Control-Table tbody .Polaris-DataTable__TableRow .feature-wrapper {
  padding: 16px 16px 16px 32px;
}

.Search-Control-Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:nth-child(2) {
  width: 28%;
}

.Search-Control-Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:nth-child(3) {
  width: 18%;
}

.Search-Control-Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:nth-child(4) {
  text-align: center;
}

.BC-Page__Synonym .Polaris-Header-Title .Polaris-Badge {
  font-size: 10px;
  line-height: 14px;
  margin-left: 4px;
}

.BC-Page__Synonym .Polaris-Header-Title .Polaris-Badge > span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.BC_VerticalTab_Wrapper .badge-ai .Polaris-Badge,
.BC-Page__Synonym .Polaris-Header-Title .Polaris-Badge,
.SearchControl__Content .table-features .feature-wrapper .Polaris-Badge {
  background: rgba(255, 48, 0, 0.1);
}

.BC_VerticalTab_Wrapper .badge-ai .Polaris-Badge > span,
.BC-Page__Synonym .Polaris-Header-Title .Polaris-Badge > span,
.SearchControl__Content .table-features .feature-wrapper .Polaris-Badge > span {
  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 600;
}

.search-control-lock-banner {
  position: relative;
  border-radius: 8px;
  width: 100%;
  padding: 20px;
  border: 1px solid var(--Banner-Border-color-warning-border, #e1b878);
  background: var(--Banner-Background-color-warning-bg, #fffbf3);
}

.search-control-lock-banner > .Polaris-Button {
  position: absolute;
  top: 20px;
  right: 20px;
}

.search-control-lock-banner .title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.search-control-lock-banner .body {
  display: flex;
  gap: 36px;
}

.search-control-lock-banner .content {
  display: grid;
  gap: 20px;
  margin-top: 4px;
  margin-bottom: 16px;
}

/*Search Engine Control end*/

/*Enhance AI Search Banner start*/
.enhance-ai-search-banner .Polaris-Banner__ContentWrapper .Polaris-Banner__Heading {
  display: flex;
}

.enhance-ai-search-banner .Polaris-Banner__ContentWrapper .Polaris-Banner__Heading:before {
  content: url('https://cdn.boostcommerce.io/assets/subscription-v3/rocket.png');
  margin-right: 6px;
}

.enhance-ai-search-banner .Polaris-Banner__Ribbon {
  display: none;
}

.enhance-ai-search-banner .Polaris-Banner__Button {
  border: 0;
  background: #ffc96b !important;
  box-shadow: 0px -1px 0px 0px #00000033 inset;
}

.BC-Analytic--RecommendedFeatures .action-locked,
.enhance-ai-search-banner .action-locked {
  display: flex;
  gap: 4px;
  align-items: center;
  font-weight: 500;
}

.enhance-ai-search-banner .banner-content {
  display: flex;
}

.enhance-ai-search-banner .banner-content img {
  width: 240px;
  height: 132px;
}

.enhance-ai-search-banner .Polaris-Banner__Actions {
  margin-top: -20px;
}

.enhance-ai-search-banner .Polaris-Banner__Actions .Polaris-Banner__SecondaryAction {
  text-decoration: underline;
}

.enhance-ai-search-banner .Polaris-Banner__Actions .Polaris-Banner__SecondaryAction:hover,
.enhance-ai-search-banner
  .Polaris-Banner__Actions
  .Polaris-Banner__SecondaryAction:hover
  > .Polaris-Banner__Text {
  text-decoration: none;
}

.enhance-ai-search-banner .Polaris-Banner {
  --pc-banner-background: #fffbf3;
  --pc-banner-border: #e1b878;
  border: 1px solid #e1b878;
}

.enhance-ai-search-banner .Polaris-Banner--hasDismiss {
  padding-right: var(--p-space-5);
}

.enhance-ai-search-banner .Polaris-Banner--hasDismiss .Polaris-Banner__Dismiss {
  right: 20px;
}

.enhance-ai-search-banner-disabled .Polaris-Banner__Button {
  border: 1px solid #d1d1d1 !important;
  background: #f7f3ef !important;
  box-shadow: none;
}

.enhance-ai-search-banner .banner-content .description > ul {
  padding-left: 20px;
  margin-top: 2px;
}

@media (min-width: 1095px) {
  .enhance-ai-search-banner .banner-content .description {
    height: 120px !important;
  }
}

@media (max-width: 1094px) {
  .enhance-ai-search-banner .banner-content .description {
    min-height: 130px !important;
  }
}

@media (max-width: 943px) {
  .enhance-ai-search-banner .banner-content .description {
    min-height: 140px !important;
  }
}

@media (max-width: 849px) {
  .enhance-ai-search-banner .banner-content .description {
    min-height: 190px !important;
  }
}

@media (max-width: 782px) {
  .enhance-ai-search-banner .banner-content .description {
    min-height: 220px !important;
  }

  .enhance-ai-search-banner .Polaris-Banner__Actions {
    margin-top: 0px;
  }
}

/*Enhance AI Search Banner end*/

/* START: Year end review in app popup */
.PFS-YEP-Popup-Container .Polaris-Backdrop {
  z-index: 529;
}

div > :has(.TermAndCondition) + .Polaris-Backdrop {
  z-index: 519;
  background: rgba(0, 0, 0, 0.7);
}

div:has(.TermAndCondition) {
  z-index: 520;
}

.PFS-YEP-Popup-Container .Polaris-Modal-Dialog__Container {
  z-index: 530;
}

.PFS-YEP-Popup-Container .Polaris-Modal-Dialog__Modal {
  min-width: 816px !important;
  max-width: 816px !important;
}

.PFS-YEP-Popup {
  position: relative;
  width: 816px;
  height: 530px;
  overflow: hidden;
}

.PFS-YEP-Popup map {
  position: absolute;
  top: 0;
  left: 0;
}

.PFS-YEP-Popup img {
  width: 816px;
  height: 532px;
}

.PFS-YEP-Popup .closeBtn {
  position: absolute;
  top: 16px;
  right: 16px;
}

.BC-Component__SearchGuideTour {
  color: #6d7175;
}

.BC-Component__SearchGuideTour .Trigger {
  display: flex;
  cursor: pointer;
}

.BC-Component__SearchGuideTour .hidden {
  display: none;
  visibility: hidden;
}

.GuideTour__Step .Step__Gif img {
  width: 380px;
  height: 220px;
  border-radius: 8px 8px 0 0;
}

.GuideTour__Step .Step__Content {
  padding: 16px 20px;
}

.Step__Content .Heading {
  font-size: 20px;
  line-height: 28px;
  font-weight: 400;

  color: #202223;
}

.Step__Content .Description {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;

  color: #6d7175;
}

.GuideTour__Step .Step__Navigation {
  border-top: 1px solid #e1e3e5;

  padding: 16px 20px;
}

.Step__Navigation .Navigation__Container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Step__Navigation .Navigation__Container p {
  color: #6d7175;
}

.BC-Component__SearchWelcomePopup {
  position: relative;
  width: 620px;
}

.BC-Component__SearchWelcomePopup .SearchWelcomePopup__Banner img {
  width: 100%;
}

.SearchWelcomePopup__Close {
  position: absolute;
  right: 24px;
  top: 24px;

  cursor: pointer;
}

.BC-Component__SearchWelcomePopup .SearchWelcomePopup__Content {
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  color: #202223;
}

.SearchWelcomePopup__Content .title {
  font-size: 20px;
  line-height: 28px;
  font-weight: 400;
}

.SearchWelcomePopup__Content .description {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}

/* New guide on dashboard */

.BC-QuickStartGuideV2__DashboardV3 .GuideMenu .GuideMenu__Activator {
  cursor: pointer;
  border-radius: 4px;
  padding: 2px;
}

.BC-QuickStartGuideV2__DashboardV3 .GuideMenu .GuideMenu__Activator:hover {
  background-color: #f6f6f7;
}

.BC-QuickStartGuideV2__DashboardV3 .heading {
  display: flex;
  justify-content: space-between;
}

.BC-QuickStartGuideV2__DashboardV3 .description-progress-percent {
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
  gap: 20px;
}

.BC-QuickStartGuideV2__DashboardV3 .description-progress-percent .description {
  flex-grow: 1;
}

.BC-QuickStartGuideV2__DashboardV3 .description-progress-percent .progress {
  width: 210px;
}

.BC-QuickStartGuideV2__DashboardV3 .description-progress-percent .percent {
  width: unset;
  text-align: right;
}

.BC-QuickStartGuideV2__DashboardV3.V4 .Polaris-Card__Section {
  padding: 0;
}

.BC-QuickStartGuideV2__DashboardV3.V4 .GuideHeader {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  border-bottom: 1px solid #e1e3e5;
}

.BC-QuickStartGuideV2__DashboardV3.V4 .GuideHeader,
.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2List,
.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2Dismiss {
  padding: var(--p-space-5);
}

.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2List,
.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2Dismiss {
  margin-top: 0;
}

.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2Item {
  background: #fafbfb;
  border: 0;
}

.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2Item.open {
  background: #fafbfb;
}

.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2Item.open .GuideV2ItemStep.open {
  background: #f1f8f5;
}

.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2Item .GuideV2Item__Activator:hover,
.BC-QuickStartGuideV2__DashboardV3.V4
  .GuideV2Item.open
  .GuideV2ItemStep
  .GuideV2ItemStep__Activator:hover {
  background: #f1f8f5;
}

.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2Done {
  padding: 0 20px 20px 20px;
}

.BC-SyncHookStatus__DashboardV3.V4 .progress-status {
  margin-top: 0;
}

.BC-SyncHookStatus__DashboardV3.V4 .progress-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
}

.BC-SyncHookStatus__DashboardV3.V4 .Polaris-Link,
.BC-ChangeLogs__Dashboard.V4 .Polaris-Link {
  text-decoration: none;
}

.BC-HelpAndSupport__DashboardV3.V4 .Polaris-Card__Section,
.BC-ResourceCenter__DashboardV3.V4 .Polaris-Card__Section,
.BC-ChangeLogs__Dashboard.V4 .Polaris-Card__Section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.BC-HelpAndSupport__DashboardV3__HelpCenter .Polaris-Card__Section .Polaris-Button__Text {
  gap: 6px;
}

.BC-HelpAndSupport__DashboardV3__HelpCenter .schedule-demo {
  margin-bottom: 6px;
  margin-top: 6px;
}

.BC-HelpAndSupport__DashboardV3__HelpCenter .schedule-demo .Polaris-Button {
  width: 100%;
}

.BC-HelpAndSupport__DashboardV3__HelpCenter .action-help {
  display: flex;
  gap: 16px;
}

.BC-HelpAndSupport__DashboardV3.V4 .action,
.BC-ResourceCenter__DashboardV3.V4 .action {
  display: flex;
  justify-content: 'space-between';
  margin-top: '10px';
  gap: 10px;
}

.BC-RecommendedApps__DashboardV3.V4 .Polaris-Card__Section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.BC-CrossSellUpSell__DashboardV3.V4 .action .Polaris-Link {
  text-decoration: none;
}

.BC-CrossSellUpSell__DashboardV3.V4 .card {
  text-decoration: none;
  padding: 12px 16px 12px 16px;
  background: #fafbfb;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: unset;
}

.BC-CrossSellUpSell__DashboardV3.V4 .card:hover {
  background: var(--p-action-secondary-hovered);
}

.BC-CrossSellUpSell__DashboardV3.V4 .card .head {
  display: flex;
  gap: 4px;
  font-size: 14px;
  align-items: center;
  color: #202223;
  font-weight: 600;
}

.BC-CrossSellUpSell__DashboardV3.V4 .card .icon {
  background: #f1f8f5;
  padding: 8px;
  border-radius: 8px;
  width: 34px;
  height: 34px;
}

.BC-CrossSellUpSell__DashboardV3.V4 .card .btn {
  font-weight: 400;
  font-size: 14px;
  color: #2c6ecb;
}

.BC-CrossSellUpSell__DashboardV3.V4 .card .btn:hover {
  cursor: pointer;
  text-decoration: underline;
}

.BC-CrossSellUpSell__DashboardV3.V4 .card.store {
  background: #f1f8f5;
}

.BC-CrossSellUpSell__DashboardV3.V4 .card.store .icon {
  background: #00a47c;
}

.BC-CrossSellUpSell__DashboardV3.V4 .card.store:hover {
  background: #e5fbf2;
}

.GuideV2List {
  display: flex;
  flex-direction: column;
  gap: 18px;
  overflow: hidden;
  margin-top: 20px;
}

.GuideV2List.Collapsing {
  animation-name: collapsing;
  animation-duration: 1s;
}

.BC-PlanSubscription__DashboardV3 .Polaris-Card__Section {
  padding: 0;
}

.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3,
.BC-PlanSubscription__DashboardV3 .BC-CrossSellUpSell__DashboardV3 {
  padding: var(--p-space-5);
}

.BC-PlanSubscription__DashboardV3 .BC-CrossSellUpSell__DashboardV3 {
  border-top: 1px solid #e1e3e5;
}

.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3 .subscribe__action {
  position: unset;
}

.BC-PlanSubscription__DashboardV3
  .BC-Subscription__DashboardV3
  .subscribe-bolton__action
  .Polaris-Button {
  min-width: 116px;
}

.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3 .subscribe__bottom {
  display: flex;
}

.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3 .subscribe__bottom > p {
  flex-grow: 1;
}

.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3 .current-package {
  gap: 8px;
  display: inline-flex;
  margin-bottom: 5px;
}

.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3 .current-package .Polaris-Badge {
  border-radius: 8px;
  padding: 2px 8px;
  height: 20px;
}

.BC-PlanSubscription__DashboardV3
  .BC-Subscription__DashboardV3
  .current-package
  .Polaris-Badge
  > span {
  font-weight: 500;
}

.BC-PlanSubscription__DashboardV3
  .BC-Subscription__DashboardV3
  .current-package
  .Polaris-Badge--statusCritical
  span {
  color: #8e1f0b;
}

.BC-PlanSubscription__DashboardV3
  .BC-Subscription__DashboardV3
  .current-package
  .Polaris-Badge--statusSucces {
  background-color: #cdfee1;
  color: #0c5132;
}

.BC-PlanSubscription__DashboardV3
  .BC-Subscription__DashboardV3
  .current-package
  .Polaris-Badge--statusWarning {
  background-color: #ffea8a;
  color: #4f4700;
}

.BC-PlanSubscription__DashboardV3
  .BC-Subscription__DashboardV3
  .subscribe__bottom
  .subscribe__action {
  display: flex;
  justify-content: flex-end;
}

.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3.has-coupon {
  background: linear-gradient(
    271.85deg,
    rgba(244, 187, 64, 0.1) 9.09%,
    rgba(255, 102, 167, 0.06) 94.53%
  );
}

.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3 .subscription-freemium-title {
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0px;
  padding-bottom: 0.75rem;
}

.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3 .text-color {
  background: linear-gradient(90deg, #ff4151 22.71%, #ff9300 37.95%);
  background-clip: content-box;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.BC-PlanSubscription__DashboardV3
  .BC-Subscription__DashboardV3.has-coupon
  .subscribe__action
  button {
  background: linear-gradient(179.82deg, #fb5f4b 5.79%, #fe384f 99.05%);
}

.BC-BoostInsightsHub__DashboardV3 .BC-Carousel .carousel-item > div,
.BC-BoostInsightsHub__DashboardV3 .BC-Carousel .carousel-item > div .card {
  height: 100%;
}

.BC-BoostInsightsHub__DashboardV3 .BC-Carousel .carousel-cards {
  grid-gap: 12px;
}

.BC-BoostInsightsHub__DashboardV3 .BC-Carousel .carousel-item {
  width: calc((100% - calc(12px * 2)) / 3);
  height: 254px;
  border: 1px solid #e1e3e5;
  border-radius: 8px;
  overflow: hidden;
}

.BC-BoostInsightsHub__DashboardV3 .BC-Carousel .card:hover {
  cursor: pointer;
  box-shadow: var(--p-shadow-card);
  background: var(--p-action-secondary-hovered);
}

.BC-BoostInsightsHub__DashboardV3 .BC-Carousel .card .img {
  width: 100%;
  height: 166px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.BC-BoostInsightsHub__DashboardV3 .BC-Carousel .card .img img {
  width: 100%;
  object-fit: contain;
}

.BC-BoostInsightsHub__DashboardV3 .BC-Carousel .card .title {
  padding: 14px;
  padding-top: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
  height: 70px;
}

.BC-BoostInsightsHub__DashboardV3 .Polaris-Link {
  text-decoration: none;
  color: rgb(32, 34, 35);
  padding: 4px 16px;
}

.BC-BoostInsightsHub__DashboardV3 .Polaris-Link {
  text-decoration: none;
  color: rgb(32, 34, 35);
  padding: 8px 16px;
  outline: none;
}

.BC-BoostInsightsHub__DashboardV3__Action {
  margin-top: 8px;
}

.BC-BoostInsightsHub__DashboardV3 .BC-BoostInsightsHub__DashboardV3__Action .Polaris-Button {
  padding: 0;
}

.BC-RecommendedApps__DashboardV3.V4 .item {
  display: flex;
  flex-wrap: wrap;
  max-width: 288px;
  padding: 16px;
  background: #fafbfb;
  border-radius: 4px;
  gap: 10px;
  align-items: center;
}

.BC-RecommendedApps__DashboardV3.V4 .item:hover {
  background: var(--p-action-secondary-hovered);
}

.BC-RecommendedApps__DashboardV3.V4 .item .icon {
  width: 40px;
  height: 40px;
  width: 40px;
}

.BC-RecommendedApps__DashboardV3.V4 .item .title {
  font-weight: 600;
  font-size: 14px;
  color: #202223;
  flex-grow: 1;
  max-width: calc(100% - 50px);
  height: 40px;
}

.BC-RecommendedApps__DashboardV3.V4 .item img,
.BC-RecommendedApps__DashboardV3.V4 .item .title {
  cursor: pointer;
}

.BC-RecommendedApps__DashboardV3.V4 .item .description {
  font-weight: 400;
  font-size: 14px;
  color: #6d7175;
  width: 100%;
}

@keyframes collapsing {
  0% {
    height: 100px;
    opacity: 1;
    margin-top: 20px;
  }

  100% {
    height: 0;
    opacity: 0;
    margin-top: 0;
  }
}

.GuideV2Item {
  border-radius: 8px;
  border: 1px solid #e1e3e5;
  position: relative;
}

.GuideV2Item .GuideV2Item__Close {
  position: absolute;
  right: 10px;
  top: 10px;
  background: white;
  z-index: 9;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
}

.GuideV2Item .GuideV2Item__Close:hover {
  background-color: #f6f6f7;
}

.GuideV2Item .GuideV2Item__Activator {
  display: flex;
  align-items: center;
  padding: 12px;
  gap: 10px;
  justify-content: space-between;
  border-radius: 8px;
}

.GuideV2Item .GuideV2Item__Activator:hover {
  background-color: #f6f6f7;
  cursor: pointer;
}

.GuideV2Item .GuideV2Item__Activator .icon {
  width: 20px;
}

.GuideV2Item .GuideV2Item__Activator .title {
  flex-grow: 1;
  font-weight: normal;
  font-size: 16px;
}

.GuideV2Item .GuideV2Item__Activator .complete {
  width: 100px;
}

.GuideV2Item .GuideV2Item__Activator .collapse {
  width: 20px;
}

.GuideV2Item .GuideV2Item__Container {
  padding: 15px;
  padding-top: 2px;
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.GuideV2Item .GuideV2Item__Advanced {
  border-top: 1px solid #e1e3e5;
  padding-top: 15px;
  margin-top: 15px;
}

.GuideV2Item .GuideV2Item__Advanced .GuideV2Item__Advanced--Screen {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.GuideV2Item .GuideV2Item__Advanced .GuideV2Item__Advanced--Screen .title {
  display: flex;
  gap: 10px;
  align-items: center;
  font-weight: bold;
}

.GuideV2Item .GuideV2Item__Advanced .GuideV2Item__Advanced--Screen .action {
  display: flex;
  gap: 10px;
  align-items: center;
}

.GuideV2Item .GuideV2Item__Advanced .GuideV2Item__Advanced--Screen .action .Polaris-Button {
  color: #008060;
  border: 1px solid #98c6cd;
}

.GuideV2Item .GuideV2Item__Survey {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.GuideV2Item .GuideV2Item__Survey .item {
  padding-left: 10px;
}

.GuideV2Item .GuideV2Item__Survey .item.action {
  padding-left: 10px;
  display: flex;
  gap: 10px;
  align-items: center;
}

.GuideV2Item .GuideV2Item__Survey .item.action span {
  cursor: pointer;
}

.GuideV2ItemStep {
  border-radius: 8px;
}

.GuideV2ItemStep:not(:has(.Polaris-Collapsible--isFullyClosed)) {
  background-color: #f1f2f3;
}

.GuideV2ItemStep .GuideV2ItemStep__Activator {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 10px;
  border-radius: 8px;
}

.GuideV2ItemStep:not(:has(.Polaris-Collapsible--isFullyClosed)) .GuideV2ItemStep__Activator .title {
  font-weight: bold;
}

.GuideV2ItemStep .GuideV2ItemStep__Activator:not(.title-preview):hover {
  background-color: #f6f6f7;
  cursor: pointer;
}

.GuideV2ItemStep .GuideV2ItemStep__Activator.title-preview {
  padding-top: 10px;
}

.GuideV2ItemStep .GuideV2ItemStep__Container {
  padding-left: 40px;
}

.GuideV2ItemStep .GuideV2ItemStep__Container .container {
  padding: 5px 10px 10px 0;
}

.GuideV2ItemStep .GuideV2ItemStep__Container .container .container__flex {
  display: flex;
  justify-content: space-between;
}

@media screen and (max-width: 480px) {
  .GuideV2ItemStep .GuideV2ItemStep__Container .container .container__flex {
    flex-direction: column;
  }
}

.GuideV2ItemStep .GuideV2ItemStep__Container .container .container__flex .left {
  gap: 20px;
  display: flex;
  flex-direction: column;
}

.GuideV2ItemStep .GuideV2ItemStep__Container .container .container__flex .left .description {
  color: #6d7175;
}

.GuideV2ItemStep .GuideV2ItemStep__Container .container .container__flex .left .action {
  display: flex;
  gap: 10px;
  margin-bottom: 40px;
}

.GuideV2ItemStep .GuideV2ItemStep__Container .container .container__flex .img {
  margin-top: -8px;
}

.GuideV2Dismiss {
  margin-top: 20px;
  color: #6d7175;
  cursor: pointer;
}

.GuideV2Done {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0 0px 0;
}

.GuideV2Done .GuideV2Done__text {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* End: New guide on dashboard */

/* Start Region: Test your Search */
.BC-TestYourSearch-Card {
  min-height: 594px;
  width: 77%;
  padding: 24px 32px 32px 32px;
  border-radius: 8px;
  background: var(--Surface-Default, #fff);
  margin: 24px auto 48px auto;
}

.BC-TestYourSearch-Card .BC-Page__Title--Help {
  margin-bottom: unset;
}

.BC-TestYourSearch-Card .Polaris-DataTable__ScrollContainer {
  scrollbar-width: thin;
}

.BC-Page__ProductPerformanceRanking
  .product-compare
  .product-list
  .Polaris-DataTable__ScrollContainer::-webkit-scrollbar,
.BC-TestYourSearch-Card
  .product-compare
  .product-list
  .Polaris-DataTable__ScrollContainer::-webkit-scrollbar {
  width: 4px;
  max-width: 4px;
}

.BC-TestYourSearch-Card > div:not(:first-child) {
  margin-top: 24px;
}

.BC-TestYourSearch-Card .text-field-query {
  display: grid;
  gap: 8px;
}

.BC-TestYourSearch-Card .text-field-query .Polaris-Connected input {
  font-size: 15px;
}

.BC-TestYourSearch-Card .text-field-query > div:first-child {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BC-TestYourSearch-Card .text-field-query .Polaris-TextStyle--variationStrong {
  font-weight: 700;
}

.BC-TestYourSearch-Card .text-field-query > div:first-child p {
  font-size: 15px;
}

.BC-TestYourSearch-Card .text-field-query .query-fields {
  display: flex;
  gap: 12px;
}

.BC-TestYourSearch-Card .text-field-query .query-fields > div:last-child {
  width: 25%;
  min-width: 200px;
}

.BC-TestYourSearch-Card .text-field-query .query-fields > div:first-child {
  width: 100%;
}

.BC-TestYourSearch-Card .text-field-query .query-fields .Polaris-Button__Text,
.BC-TestYourSearch-Card .text-field-query .query-fields .Polaris-Button__Content,
.BC-TestYourSearch-Card .text-field-query .query-fields .Polaris-Button {
  width: 100%;
}

.BC-TestYourSearch-Card .text-field-query .query-fields .Polaris-Button .Polaris-Icon {
  margin: 0;
}

.TestYourSearch_Table {
  border-radius: 8px;
  border: 1px solid var(--Border-Divider, #e1e3e5);
  background: var(--Surface-Default, #fff);
}

.BC-TestYourSearch-Card .test-your-search-divider {
  background: #e1e3e5;
  height: 1px;
  width: 100%;
}

.BC-TestYourSearch-Card .product-preview .header-product-preview {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.BC-TestYourSearch-Card .product-preview .pagination .icon {
  border: 1px solid #c9cccf;
  border-radius: 6px;
  width: 24px;
  height: 24px;
  padding: 4px;
}

.BC-TestYourSearch-Card .product-preview .pagination .icon:not(:last-child) {
  margin-right: 6px;
}

.BC-TestYourSearch-Card .product-preview .pagination .disabled {
  background-color: #edeeef;
  opacity: 0.5;
}

.BC-TestYourSearch-Card .product-preview .pagination .item {
  min-width: 24px;
  padding: 2px;
  text-align: center;
  border: 1px solid #c9cccf;
  border-radius: 6px;
  margin-right: 6px;
  font-weight: 400;
  font-size: 0.875rem;
  height: 24px;
}

.BC-TestYourSearch-Card .product-preview .pagination .selected {
  background-color: #202123;
  color: #fff;
}

.BC-TestYourSearch-Card .product-preview .pagination .link {
  cursor: pointer;
}

.BC-TestYourSearch-Card .product-preview .pagination .point {
  border: none;
}

.BC-TestYourSearch-Card .product-preview .content {
  font-size: 1.25rem;
  padding-top: 1.25rem;
}

.BC-TestYourSearch-Card .product-preview .productList .productRow {
  display: inline-flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}

.BC-TestYourSearch-Card .product-preview .productList .productItem {
  position: relative !important;
}

.BC-TestYourSearch-Card .product-preview .productList .productItem {
  min-width: 100px;
  max-width: 130px;
}

.BC-TestYourSearch-Card .product-preview .productList .bannerItem {
  min-width: 130px;
}

.BC-TestYourSearch-Card .product-preview .productList .bannerItem .Polaris-Thumbnail {
  width: 100%;
  height: 100%;
  border: unset;
}

.BC-TestYourSearch-Card .product-preview .productList .bannerItem:hover {
  cursor: pointer;
}

.BC-TestYourSearch-Card .product-preview .productList .bannerItem .Polaris-Thumbnail img {
  margin: 0;
  width: 100%;
  height: 100%;
}

.BC-TestYourSearch-Card .product-preview .productList .productRow:not(:last-child) .productItem {
  margin-bottom: 24px;
}

.BC-TestYourSearch-Card .product-preview .productList .productItem .noImage {
  width: 100%;
}

.BC-TestYourSearch-Card .product-preview .productList .productItem .image {
  width: auto;
  height: auto;
  max-height: 188px;
  max-width: 100%;
}

.BC-TestYourSearch-Card .product-preview .productList .productItem .title {
  font-size: 14px;
  line-height: 20px;
  height: 45px;
  margin: 8px 0px;
  display: inline-block;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  line-height: 1.65;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.BC-TestYourSearch-Card .product-preview .productList .productItem .priceMin {
  color: #d72c0d;
}

.BC-TestYourSearch-Card .product-preview .productList .productItem .comparedAtPrice {
  color: #8c9196;
  text-decoration: line-through;
}

.BC-TestYourSearch-Card .product-preview .productRow .productItem .product-image .mask-view > span {
  position: absolute;
  bottom: 40%;
  right: 0;
  left: 0;
  text-align: center;
}

.BC-TestYourSearch-Card .product-preview .productList .productItem .image {
  width: auto;
  height: auto;
  max-height: 193px;
  max-width: 100%;
}

.BC-TestYourSearch-Card .product-preview .productList .productItem .priceMin {
  color: #d72c0d;
}

.BC-TestYourSearch-Card
  .product-preview
  .productRow
  .productItem
  .product-image
  .mask-view
  .Polaris-Icon {
  width: 1.5625rem;
  height: 1.5625rem;
  fill: #fff;
}

.BC-Page__TestYourSearch .pagination {
  display: flex;
  justify-content: center;
  position: relative;
}

.BC-TestYourSearch-Card .TestYourSearch_Table .Polaris-DataTable__Cell--header {
  font-size: 12px;
  font-weight: 600;
  line-height: 15px;
  color: #6d7175;
  padding: 10px 16px;
}

.BC-TestYourSearch-Card .product-preview .productRow .productItem .product-image--no-image {
  background-color: #f4f6f8;
}

.BC-TestYourSearch-Card
  .TestYourSearch_Table
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image,
.BC-TestYourSearch-Card .product-preview .productRow .productItem .product-image {
  position: relative;
  height: 188px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.BC-TestYourSearch-Card
  .TestYourSearch_Table
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image
  a,
.BC-TestYourSearch-Card .product-preview .productRow .productItem .product-image .mask-view {
  display: none;
}

.BC-TestYourSearch-Card
  .TestYourSearch_Table
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image:hover
  a,
.BC-TestYourSearch-Card .product-preview .productRow .productItem .product-image:hover .mask-view {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  cursor: pointer;
}

.BC-TestYourSearch-Card
  .TestYourSearch_Table
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image
  a
  > span,
.BC-TestYourSearch-Card .product-preview .productRow .productItem .product-image .mask-view > span {
  position: absolute;
  bottom: 40%;
  right: 0;
  left: 0;
  text-align: center;
}

.BC-TestYourSearch-Card
  .TestYourSearch_Table
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image
  a
  .Polaris-Icon,
.BC-TestYourSearch-Card
  .product-preview
  .productRow
  .productItem
  .product-image
  .mask-view
  .Polaris-Icon {
  width: 1.5625rem;
  height: 1.5625rem;
}

.BC-TestYourSearch-Card
  .TestYourSearch_Table
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image
  a
  .Polaris-Icon,
.BC-TestYourSearch-Card
  .product-preview
  .productRow
  .productItem
  .product-image
  .mask-view
  .Polaris-Icon {
  fill: white;
}

.BC-TestYourSearch-Card
  .TestYourSearch_Table
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image
  a
  .view-product,
.BC-TestYourSearch-Card
  .product-preview
  .productRow
  .productItem
  .product-image
  .mask-view
  .view-product {
  margin-top: 0.5rem;
  color: white !important;
  font-weight: 500 !important;
}

.BC-TestYourSearch-Card .TestYourSearch_Table .Polaris-Product-Tooltip-TooltipOverlay__Content {
  width: 10.8rem;
  padding: 1.25rem;
}

.BC-TestYourSearch-Card
  .TestYourSearch_Table
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  label {
  margin-top: 0.5rem;
  display: block;
}

.TestYourSearch_Table .consequence-detail {
  display: flex;
  gap: 8px;
}

.TestYourSearch_Table .consequence-detail:not(:first-child) {
  margin-top: 8px;
}

.TestYourSearch_Table .consequence-detail .Polaris-Icon {
  border-radius: 4px;
  border: 1px solid var(--Border-Subdued, #c9cccf);
  width: 20px;
  height: 20px;
  min-width: 20px;
  padding: 4px;
  margin: 0;
  display: flex;
}

.TestYourSearch_Table .consequence-detail .Polaris-Icon svg {
  width: 12px;
  height: 12px;
}

.TestYourSearch_Table .Polaris-DataTable__TableRow td {
  padding: 10px 16px;
  white-space: unset;
}

.TestYourSearch_Table .Polaris-DataTable__TableRow--merchandising td,
.TestYourSearch_Table .Polaris-DataTable__TableRow--category td {
  width: 100%;
  vertical-align: text-top;
}

.TestYourSearch_Table--close {
  border: unset;
}

.TestYourSearch_Table tr td:first-child {
  width: 15%;
}

.TestYourSearch_Table .Polaris-DataTable__TableRow td:first-child {
  width: 15%;
}

.TestYourSearch_Table .Polaris-DataTable__TableRow td:nth-child(2) {
  width: 26%;
}

.TestYourSearch_Table .Polaris-DataTable__TableRow td:nth-child(3) {
  width: 55%;
}

.BC-TestYourSearch-Card .product-preview .no-result a,
.TestYourSearch_Table .Polaris-DataTable__TableRow td a {
  color: #2c6ecb;
}

.TestYourSearch_Table .category {
  display: flex;
  padding: 2px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 10px;
  width: fit-content;
}

.TestYourSearch_Table .category-search {
  background: #e2f1ea;
}

.TestYourSearch_Table .category-merchandising {
  background: #fdf3c8;
}

.TestYourSearch_Table .description-collapse:hover {
  cursor: pointer;
}

.TestYourSearch_Table .description-collapse {
  text-align: left;
  width: 100%;
  padding: 12px 16px !important;
  background: #ebf9fc;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}

.TestYourSearch_Table .description-close {
  border: 1px solid var(--Border-Highlight-Subdued, #98c6cd);
  border-radius: 8px;
}

.TestYourSearch_Table .description-collapse {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
}

.TestYourSearch_Table .description-collapse > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.TestYourSearch_Table .description-collapse .collapse {
  color: #2c6ecb;
}

.TestYourSearch_Table .Polaris-DataTable__Cell--action .Polaris-Icon {
  width: 16px;
  height: 16px;
  margin: 0px;
}

.TestYourSearch_Table .Polaris-Button--plain.Polaris-Button--iconOnly svg {
  fill: #8c9196;
}

.TestYourSearch_Table .Polaris-DataTable__Cell--action .Polaris-Button:hover svg {
  fill: #44474a;
}

.TestYourSearch_Table tr .search-item {
  display: flex;
  gap: 12px;
}

.TestYourSearch_Table tr .search-item > p:nth-child(2) > p {
  text-align: center;
  width: 100%;
  min-width: 27px;
}

.TestYourSearch_Table tr .search-item:not(:first-child) {
  margin-top: 4px;
}

.TestYourSearch_Table tr .synonyms > p {
  display: flex;
  gap: 4px;
}

.TestYourSearch_Table tr .search-item > p > p {
  align-items: center;
  display: flex;
  height: 24px;
}

.TestYourSearch_Table tr .search-item > p > p:not(:first-child) {
  margin-top: 4px;
}

.TestYourSearch_Table tr .synonyms .synonym-item {
  border-radius: 4px;
  background: #f4f6f8;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  /* 133.333% */
  padding: 4px 8px;
  color: var(--Text-Subdued, #6d7175);
}

.TestYourSearch_Table tbody .Polaris-DataTable__TableRow:hover td:not(:first-child) {
  background-color: #f6f6f7;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}

.TestYourSearch_Table tbody .Polaris-DataTable__TableRow--outline td {
  padding: 6px;
  border-top: var(--p-border-divider);
}

.TestYourSearch_Table tbody tr:hover td:not(:first-child) .synonym-item {
  background: #e0e6eb;
  color: var(--Text-Subdued, #6d7175);
}

.TestYourSearch_Table .Polaris-Badge {
  width: 32px;
  height: 20px;
  border-radius: 1000px;
  background: #ffebd3;
  padding: 4px 10px;
}

.TestYourSearch_Table .Polaris-Badge span {
  height: 12px;
}

.BC-TestYourSearch-Card .product-compare .product-list {
  display: flex;
  margin-top: 16px;
  margin-right: 16px;
  justify-content: space-between;
  gap: 24px;
}

.BC-Page__ProductPerformanceRanking .product-compare .product-list {
  display: flex;
  margin-top: 16px;
  justify-content: space-between;
  gap: 16px;
}

.BC-Page__ProductPerformanceRanking .Polaris-Layout,
.BC-Page__Redirect .Polaris-Layout,
.BC-Page__SuggestionDictionary .Polaris-Layout {
  margin-top: 16px;
}

.BC-Page__ProductPerformanceRanking
  .product-compare
  .product-list
  .Polaris-DataTable__ScrollContainer,
.BC-TestYourSearch-Card .product-compare .product-list .Polaris-DataTable__ScrollContainer {
  max-height: 556px;
}

.BC-Page__ProductPerformanceRanking .product-compare .product-list > div,
.BC-TestYourSearch-Card .product-compare .product-list > div {
  width: 50%;
  border: 1px solid #e1e3e5;
  border-radius: 8px;
}

.BC-Page__ProductPerformanceRanking .product-compare .product-list .header,
.BC-TestYourSearch-Card .product-compare .product-list .header {
  padding: 12px 16px;
  border-bottom: 1px solid #e1e3e5;
  display: flex;
  justify-content: space-between;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.BC-Page__ProductPerformanceRanking .product-compare .product-list .with-ranking .header,
.BC-TestYourSearch-Card .product-compare .product-list .with-ranking .header {
  background-color: #fff5ea;
}

.BC-Page__ProductPerformanceRanking .product-compare .product-list .without-ranking .header,
.BC-TestYourSearch-Card .product-compare .product-list .without-ranking .header {
  background-color: #f1f2f3;
}

.BC-Page__ProductPerformanceRanking .product,
.BC-TestYourSearch-Card .BC-Component-ProductList .product {
  padding: 4px 8px;
}

.BC-Page__ProductPerformanceRanking .product:first-child,
.BC-TestYourSearch-Card .BC-Component-ProductList .product:first-child {
  padding: 18px 8px 10px;
  background-color: unset;
  cursor: unset;
  gap: 8px;
}

.BC-TestYourSearch-Card .BC-Component-ProductList .load-more {
  padding: 10px;
  font-size: 16px;
  margin-bottom: 16px;
}

.BC-TestYourSearch-Card .header-product-preview > div > span {
  height: 30px;
}

.BC-TestYourSearch-Card .header-product-preview .toggle {
  height: 30px;
  display: flex;
  align-items: center;
}

.BC-TestYourSearch-Card .product-preview {
  margin-top: 24px !important;
}

.BC-TestYourSearch-Card .header-product-preview {
  margin-bottom: 24px;
}

.BC-TestYourSearch-Card .premium-lock-banner {
  display: flex;
  padding: 14px 20px;
  justify-content: space-between;
  align-items: center;
  background: var(--Banner-Background-color-warning-bg, #fffbf3);
}

.BC-TestYourSearch-Card .premium-lock-banner .detail {
  display: flex;
}

.BC-TestYourSearch-Card .premium-lock-banner .detail img {
  margin-right: 0.5rem;
}

/* End-Region: Test your Search */

.render-status-block {
  gap: 6px;
  display: flex;
  flex-direction: column;
}

.render-status-block .b-icon.running img {
  position: static;
  animation: rotation 8s infinite linear;
}

.render-status-block .b-percent {
  font-weight: 600;
  font-size: 14px;
}

.render-status-block .b-progress-bar .Polaris-ProgressBar {
  height: 16px;
  margin-top: 6px;
  margin-bottom: 6px;
}

.render-status-block .b-progress-bar .Polaris-ProgressBar .Polaris-ProgressBar__Label {
  display: none;
}

.render-status-block .b-progress-bar .Polaris-ProgressBar .Polaris-ProgressBar__Indicator {
  background-color: #008060;
}

.render-status-block
  .b-progress-bar.wait-retry
  .Polaris-ProgressBar
  .Polaris-ProgressBar__Indicator {
  background-color: #6d7175;
}

.render-status-block .b-partical {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
}

.Polaris-Tooltip-TooltipOverlay:has(.tooltip-long-sync) {
  margin-left: 250px;
}

.Polaris-Tooltip-TooltipOverlay__Content:has(.tooltip-long-sync) {
  width: 246px !important;
}

.BC-Sync__Content .Polaris-Badge > span {
  display: flex;
  align-items: center;
}

.BC-Sync__Content .status-icon {
  width: 8px !important;
  height: 8px !important;
  margin-right: 5px;
  border-radius: 50%;
  display: inline-block;
}

/* SSR code-editor */
.disabled-editor {
  pointer-events: none;
}

.BC-Page__AccountDetail .account-wrapper .item {
  display: flex;
  gap: 20px;
  padding: 25px 0;
}

.BC-Page__AppPreferences .app-preferences-list .item {
  border-bottom: 1px solid #e1e3e5;
}

.BC-Page__AppPreferences .app-preferences-list .item:last-child {
  border-bottom: 0;
}

@media (max-width: 639px) {
  .BC-Page__AccountDetail .account-wrapper .item {
    flex-direction: column;
    padding: 15px;
  }
}

.BC-Page__AccountDetail .account-wrapper .item .title {
  margin-bottom: 15px;
}

.BC-Page__AccountDetail .account-wrapper .item .title,
.BC-Page__AccountDetail .account-wrapper .item .default-text-style {
  font-weight: 600 !important;
  font-size: 14px;
}

.BC-Page__AccountDetail .account-wrapper .item .left .description {
  width: 304px;
  color: #6d7175;
}

.BC-Page__AccountDetail .account-wrapper .item .right {
  flex: 1;
}

.BC-Page__AccountDetail .account-wrapper .item .right .Polaris-Card {
  padding: 25px;
}

.BC-Page__AccountDetail .Polaris-Card .watermark-status {
  display: flex;
}

.BC-Page__AccountDetail .watermark-status .Polaris-Badge {
  background: rgba(255, 242, 217, 1);
  padding: 2px 4px 2px 4px;
  border-radius: 4px;
  color: rgba(255, 51, 69, 1);
  font-weight: 600;
  margin-left: 6px;
}

.BC-Page__AccountDetail .watermark-status .Polaris-Badge > span:last-child {
  display: flex;
  gap: 4px;
  align-items: center;
}

.BC-Page__AccountDetail .watermark-card .guide {
  margin-top: 8px;
  color: rgba(109, 113, 117, 1);
}

.watermark-status--disabled > div > span:first-child,
.watermark-status--disabled label {
  opacity: 0.5 !important;
}

.BC-Page__AccountDetail .account-wrapper .item .right .item-preferences {
  gap: 10px;
  display: flex;
  flex-direction: column;
}

.BC-Page__AccountDetail .account-wrapper .item .right .guide {
  margin-bottom: 10px;
}

.BC-Page__AccountDetail .account-wrapper .item .right .guide .Polaris-Link {
  display: inline-flex;
}

.BC-Page__AccountDetail .account-wrapper .item .right .guide .Polaris-Icon {
  width: 1rem;
  height: 1rem;
}

.BC-Page__AccountDetail .Polaris-Banner--statusWarning {
  background: #fff5ea;
  border-color: #e1b878;
  padding: 12px 20px;
  margin-bottom: 16px;
}

.BC-Page__AccountDetail .Polaris-Banner--statusWarning .Polaris-Banner__Ribbon {
  display: none;
}

.BC-Page__AccountDetail .Polaris-Banner--statusWarning .Polaris-Link {
  color: #2c6ecb !important;
}

.BC-Page__AccountDetail .warning-back-to-v3 .Polaris-Banner--statusWarning {
  margin-bottom: 0;
  margin-top: 16px;
}

.BC-Page__Integration .third-party-wrapper {
  margin-top: 16px;
}

.BC-Page__ThirdPartyIntegration .third-party-wrapper .comming-soon,
.BC-Page__Integration .third-party-wrapper .comming-soon {
  display: grid;
  place-items: center;
  min-height: 400px;
}

.BC-Page__ThirdPartyIntegration .third-party-wrapper .comming-soon .content,
.BC-Page__Integration .third-party-wrapper .comming-soon .content {
  align-items: center;
  display: flex;
  flex-direction: column;
  max-width: 512px;
  gap: 20px;
  text-align: center;
}

.BC-Page__ThirdPartyIntegration .third-party-wrapper .comming-soon .content .title,
.BC-Page__Integration .third-party-wrapper .comming-soon .content .title {
  font-weight: 600;
  font-size: 20px;
}

.BC-Page__ThirdPartyIntegration .third-party-wrapper .comming-soon .content .description,
.BC-Page__Integration .third-party-wrapper .comming-soon .content .description {
  font-weight: 400;
  font-size: 14px;
}

@media (max-width: 639px) {
  .BC-Page__ThirdPartyIntegration .third-party-wrapper,
  .BC-Page__Integration .third-party-wrapper {
    flex-direction: column;
    padding: 15px;
  }
}

.Polaris-Modal-Dialog:has(.video-upgraded) iframe {
  border: 0;
  border-radius: 8px;
}

.BC-Page__AccountDetail .Polaris-PageActions {
  border-top: 0;
}

.BC-Page__AccountDetail .Polaris-InlineError__Icon {
  display: block;
}

.Polaris-Button:has(.dont-show-again) {
  padding-left: 10px;
}

.Polaris-Modal-Footer:has(.dont-show-again) .Polaris-Stack {
  justify-content: space-between;
}

.Polaris-Modal-Footer:has(.dont-show-again) .Polaris-Stack__Item.Polaris-Stack__Item--fill {
  display: none;
}

.Polaris-Modal-Footer:has(.dont-show-again) .Polaris-Stack > .Polaris-Stack__Item {
  margin-left: 0;
}

.Polaris-Modal-Footer:has(.dont-show-again) .Polaris-Stack .Polaris-Stack__Item {
  width: 100%;
}

.Polaris-Modal-Footer:has(.dont-show-again)
  .Polaris-Stack
  .Polaris-Stack__Item
  .Polaris-ButtonGroup__Item:has(.dont-show-again) {
  flex-grow: 1;
}

.Polaris-Modal-Footer:has(.dont-show-again)
  .Polaris-ButtonGroup__Item:has(.dont-show-again)
  .Polaris-Button {
  border: 0;
  background: none;
  box-shadow: none;
}

.Polaris-Modal-Footer:has(.dont-show-again)
  .Polaris-ButtonGroup__Item:has(.dont-show-again)
  .Polaris-Button:hover {
  background: none;
}

.BC-Page__AccountDetail .account-wrapper .item .Polaris-Button {
  min-width: 150px;
}

.BC-Page__AccountDetail .account-wrapper .item.turbo-banner {
  background: #190738;
  padding: 20px 32px 20px 32px;
  border-radius: var(--p-border-radius-2);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.BC-Page__AccountDetail .account-wrapper .item.turbo-banner img {
  max-width: calc(100% - 180px);
}

@media (max-width: 766px) {
  .BC-Page__AccountDetail .account-wrapper .item.turbo-banner {
    flex-direction: column;
    align-items: flex-start;
  }

  .BC-Page__AccountDetail .account-wrapper .item.turbo-banner img {
    max-width: 100%;
  }
}

.BC-Page__AccountDetail .account-wrapper .item.turbo-banner .Polaris-Button {
  background: linear-gradient(91.21deg, #c830e1 1.04%, #fe4a25 131.05%);
  box-shadow: 0px 5.45px 32.71px 0px rgba(235, 69, 38, 0.4);
  color: rgba(255, 255, 255, 1);
  font-weight: 500;
  font-size: 14px;
  border: 0;
}

.BC-Page__AccountDetail .account-wrapper .item.turbo-banner .Polaris-Button:hover {
  background: linear-gradient(91.21deg, #920da7 1.04%, #ce2907 131.05%);
  box-shadow: 0px 15.23px 91.35px 0px rgba(235, 69, 38, 0.4);
}

/* SubscriptionV4 */
.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4,
.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 {
  border-radius: 4px;
  display: grid !important;
  gap: 0;
}

.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-1 {
  display: flex;
  justify-content: center;
}

.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-2,
.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4.cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-3,
.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4.cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-4,
.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4.cols-4 {
  grid-template-columns: repeat(4, 1fr);
}

.BC-Page__SubscriptionV3.V4 .packages div div .Polaris-Card,
.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 .Polaris-Card {
  width: unset;
  border-radius: 0;
  box-shadow: unset;
  border: 1px solid #e1e3e5;
  text-align: left;
  padding: 32px 12px 20px 12px;
  min-width: 200px;
}

.BC-Page__SubscriptionV3.V4 .packages div div .Polaris-Card:last-child,
.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 .Polaris-Card:last-child {
  border-right: 1px solid #e1e3e5;
}

.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-2 .Polaris-Card,
.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4.cols-2 .Polaris-Card {
  padding: 24px 32px 20px 32px;
}

.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-3 .Polaris-Card,
.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4.cols-3 .Polaris-Card {
  padding: 32px 18px 20px 18px;
}

.BC-Page__SubscriptionV3 .packages div .Polaris-Card:nth-child(2),
.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card:nth-child(2) {
  background: unset;
}

.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4 .Polaris-Card:has(.essential),
.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 .Polaris-Card.package-suggest-card {
  border: 1.5px solid #008060;
  background: #f1f8f5;
}

.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4 .Polaris-Card:first-child,
.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 .Polaris-Card:first-child {
  border-radius: 4px 0 0 4px;
}

.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4 .Polaris-Card:last-child,
.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 .Polaris-Card:last-child {
  border-radius: 0 4px 4px 0;
}

.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4 .Polaris-Card .tag,
.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 .Polaris-Card .tag {
  right: 0;
  left: unset;
  top: 0;
  border-radius: 0px 0px 0px 4px;
  position: absolute;
  font-weight: 600;
  font-size: 12;
  background: #edeeef;
  padding: 2px 12px 2px 12px;
}

.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4 .Polaris-Card:has(.essential) .tag,
.BC-Page__SubscriptionV3-Package.V4
  .packages
  .ListPackageV4
  .Polaris-Card.package-suggest-card
  .tag {
  background: #008060;
  color: white;
}

.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4 .Polaris-Card .Polaris-Button,
.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 .Polaris-Card .Polaris-Button {
  width: 100%;
}

.BC-Page__SubscriptionV3.V4 .permonth,
.BC-Page__SubscriptionV3-Package.V4 .permonth {
  font-weight: 600;
  font-size: 12px;
  color: #6d7175;
}

.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .package-name,
.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .price,
.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .select-product,
.BC-Page__SubscriptionV3-Package.V4 .packages div .Polaris-Card .package-name,
.BC-Page__SubscriptionV3-Package.V4 .packages div .Polaris-Card .price,
.BC-Page__SubscriptionV3-Package.V4 .packages div .Polaris-Card .select-product {
  text-align: left;
}

.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .select-product,
.BC-Page__SubscriptionV3-Package.V4 .packages div .Polaris-Card .select-product {
  justify-content: flex-start;
}

.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .package-action .Polaris-Button,
.BC-Page__SubscriptionV3-Package.V4 .packages div .Polaris-Card .package-action .Polaris-Button {
  height: 36px;
}

.BC-Page__SubscriptionV3.V4 .packages:has(.cols-2) div .Polaris-Card .Polaris-Select,
.BC-Page__SubscriptionV3-Package.V4 .packages:has(.cols-2) div .Polaris-Card .Polaris-Select {
  width: 200px;
}

.BC-Page__SubscriptionV3.V4 .packages:has(.cols-3) div .Polaris-Card .Polaris-Select,
.BC-Page__SubscriptionV3-Package.V4 .packages:has(.cols-3) div .Polaris-Card .Polaris-Select {
  width: 165px;
}

.BC-Page__SubscriptionV3.V4 .packages:has(.cols-4) div .Polaris-Card .Polaris-Select,
.BC-Page__SubscriptionV3-Package.V4 .packages:has(.cols-4) div .Polaris-Card .Polaris-Select {
  width: 130px;
}

.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .select-product > div {
  width: unset;
}

.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .package-name {
  height: 35px;
}

.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .select-product,
.BC-Page__SubscriptionV3-Package.V4 .packages div .Polaris-Card .select-product {
  height: 50px;
  display: flex;
  align-items: center;
}

.BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card {
  display: flex;
  justify-content: space-between;
}

.BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card .left {
  padding: 20px 20px 20px 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
}

.BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card .left .Polaris-Heading {
  font-size: 20px;
  font-weight: 600;
}

.BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card .left .label {
  font-weight: 600;
  font-size: 14px;
}

.BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card .left .list-feature {
  font-weight: 400;
  font-size: 14px;
  gap: 6px;
  display: flex;
  flex-direction: column;
}

.BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card .left .list-feature img {
  margin-right: 10px;
}

.BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card .right img {
  width: 540px;
  height: 330px;
}

/* Customization service */
.BC-Page__SubscriptionV3 .SmartStylingBanner .Polaris-Card {
  display: flex;
}

.BC-Page__SubscriptionV3 .SmartStylingBanner .Polaris-Card .left img {
  width: 490px;
  height: 100%;
}

.BC-Page__SubscriptionV3 .SmartStylingBanner .Polaris-Card .right {
  padding: 48px 98px 48px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
}

.BC-Page__SubscriptionV3 .SmartStylingBanner .Polaris-Badge {
  color: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);
  background: #ff30001a;
}

.BC-Page__SubscriptionV3 .SmartStylingBanner .Polaris-Badge > span {
  display: flex;
  align-items: center;
  gap: 4px;
  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.BC-Page__SubscriptionV3 .SmartStylingBanner .Polaris-Card .Polaris-Heading {
  font-size: 20px;
  margin-top: 8px;
}

.BC-Page__SubscriptionV3 .SmartStylingBanner .action-list .Polaris-Button--plain {
  padding: 6px;
  margin-left: 8px;
}

.BC-Page__SubscriptionV3 .SmartStylingBanner .action-list > p {
  color: #6d7175;
  font-style: italic;
  margin-top: 4px;
}

.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner {
  background-image: url('https://cdn.boostcommerce.io/assets/campaigns/turbo-campaign-banner.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 24px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__title {
  text-shadow: 0px 5.452px 32.712px rgba(235, 69, 38, 0.4);
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  margin-bottom: 4px;
  color: #fff;
}

.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__desc {
  color: #fff;
  display: flex;
  align-items: center;
  gap: 4px;
}

.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__desc .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__desc .Polaris-Icon__Svg {
  fill: #fff !important;
}

.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__code {
  font-weight: 700;
  line-height: 150%;
  background: linear-gradient(91deg, #c830e1 1.04%, #fe4a25 131.05%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__saving {
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  background: linear-gradient(91deg, #c830e1 1.04%, #fe4a25 131.05%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__saving-semibold {
  font-weight: 600;
  line-height: 150%;
  background: linear-gradient(91deg, #c830e1 1.04%, #fe4a25 131.05%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__advanced-features {
  margin-top: 12px;
  display: flex;
  align-items: center;
}

.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__advanced-features .advanced-features__item {
  padding-right: 14px;
  margin-right: 14px;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  display: flex;
  align-items: center;
  column-gap: 6px;
}

.BC-Page__SubscriptionV3
  .former-upgrade-turbo__banner__advanced-features
  .advanced-features__item:last-child {
  padding-right: 0;
  margin-right: 0;
  border-right: 0;
}

.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__actions {
  display: flex;
  column-gap: 10px;
  margin-top: 20px;
}

.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__actions .Polaris-Button:first-child {
  background: linear-gradient(91.21deg, #c830e1 1.04%, #fe4a25 131.05%);
  box-shadow: 0px 5.45px 32.71px 0px #eb452666;
  border: none;
}

.BC-Page__SubscriptionV3
  .former-upgrade-turbo__banner__actions
  .Polaris-Button:first-child
  .Polaris-Button__Content {
  color: #fff;
  font-weight: 600;
}

.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__actions .Polaris-Button:last-child {
  border: 1px solid #ffffff;
  box-shadow: 0px 1px 0px 0px #0000000d;
  background-color: transparent;
}

.BC-Page__SubscriptionV3
  .former-upgrade-turbo__banner__actions
  .Polaris-Button:last-child
  .Polaris-Button__Content {
  color: #fff;
  font-weight: 500;
}

/* enterprise request modal */
.pfs-enterprise-request-modal {
  display: grid;
  gap: 20px;
}

.pfs-enterprise-request-modal .row-2,
.pfs-enterprise-request-modal .checkbox-list {
  display: flex;
  width: 100%;
  gap: 20px;
}

.pfs-enterprise-request-modal .row-2 > div {
  width: 100%;
}

.pfs-enterprise-request-modal .row > p {
  margin-bottom: 8px;
}

.pfs-enterprise-request-modal .default-text-style {
  font-weight: 400 !important;
}

.Polaris-Modal-Dialog__Modal:has(.pfs-enterprise-request-modal) {
  max-width: 672px;
}

/* end - enterprise request modal */

.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Card {
  padding: 16px 20px 16px 20px;
}

.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Card .header {
  display: flex;
  justify-content: space-between;
}

.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Card .slide {
  padding-bottom: 40px;
}

.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Card .slide .carousel-item {
  width: calc(50% - 10px);
  padding: 20px;
  border-radius: 8px;
  background: #fafbfb;
}

.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Card .slide .carousel-item .name {
  font-weight: 600;
  font-size: 16px;
}

.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Card .slide .carousel-item .date {
  font-weight: 400;
  font-size: 14px;
  color: #6d7175;
  margin-top: 10px;
  margin-bottom: 10px;
}

.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Card .slide .carousel-item .content {
  font-weight: 400;
  font-size: 14px;
  color: #292929;
}

.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Card .slide .carousel-item .head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.BC-Page__SubscriptionV3.V4 .PlanV4 {
  display: flex;
  justify-content: space-between;
}

.BC-Page__SubscriptionV3-Package.V4 .packages span,
.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Link,
.BC-Page__SubscriptionV3.V4 .PlanV4 .Polaris-Link {
  text-decoration: none;
}

.BC-Page__SubscriptionV3.V4 .packages > div {
  min-height: unset;
}

.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .advances-package .advance-line,
.BC-Page__SubscriptionV3-Package.V4 .packages div .Polaris-Card .advances-package .advance-line {
  gap: 4px;
}

.BC-Page__SubscriptionV3-Package.V4 .planStatus .Polaris-Card {
  box-shadow: none;
  border: 1px solid #dfe3e8;
}

@media (max-width: 639px) {
  .BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-2,
  .BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4.cols-2 {
    grid-template-columns: repeat(1, 1fr);
  }

  .BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-3,
  .BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4.cols-3 {
    grid-template-columns: repeat(1, 1fr);
  }

  .BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-4,
  .BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4.cols-4 {
    grid-template-columns: repeat(1, 1fr);
  }

  .BC-Page__SubscriptionV3.V4 .packages div div .Polaris-Card,
  .BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 .Polaris-Card {
    border: 1px solid #e1e3e5;
    border-radius: 0 !important;
    min-height: unset !important;
    padding: 20px 32px;
  }
}

.Polaris-Modal-Dialog__Modal:has(.DowngradeInfoModal) {
  max-width: 680px;
}

.Polaris-Modal-Dialog__Modal:has(.DowngradeInfoModal) .Polaris-Modal-Header {
  border-bottom: 0;
  padding-bottom: 0;
}

.DowngradeInfoModal {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.DowngradeInfoModal .block {
  flex: 1;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.DowngradeInfoModal .block .header {
  padding: 8px 20px 8px 20px;
}

.DowngradeInfoModal .block.left {
  border: 1.5px solid #008060;
}

.DowngradeInfoModal .block.left .header {
  background: #008060;
  color: white;
}

.DowngradeInfoModal .block.right {
  border: 1.5px solid #e1e3e5;
}

.DowngradeInfoModal .block.right .header {
  background: #e1e3e5;
}

.DowngradeInfoModal .block .content {
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 1;
  padding: 20px;
}

.DowngradeInfoModal .block .title {
  font-weight: 600;
  font-size: 28px;
}

.DowngradeInfoModal .block .features,
.DowngradeInfoModal .block .feature,
.DowngradeInfoModal .block .feature .item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.DowngradeInfoModal .block .feature .item > div {
  display: flex;
  align-items: center;
  gap: 4px;
}

.DowngradeInfoModal .block .feature p {
  font-weight: 600;
  font-size: 14px;
}

@media (max-width: 639px) {
  .BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card {
    flex-direction: column;
  }

  .BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card .right img {
    width: 100%;
    height: auto;
  }
}

/* END: SubscriptionV4 */

/* Suspense Fallback UI */
.BC-Fallback {
  height: 800px;
}

.BC-Fallback__Header {
  display: flex;
  justify-content: space-between;
  padding-top: 40px;
  padding-bottom: 20px;
}

.BC-Fallback__Header .Polaris-SkeletonDisplayText__DisplayText:first-child {
  width: 200px;
  max-width: 200px;
}

.BC-Fallback__Header .Polaris-SkeletonDisplayText__DisplayText:last-child {
  width: 120px;
}

/* END: Suspense Fallback UI */

/* For some waiting page loading: Charge/Finalize */
.BC-AppLoadingPage {
  margin-top: 25%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.BC-AppLoadingPage--fullScreen {
  margin-top: 0;
  height: 100vh;
  justify-content: center;
}

.BC-AppLoadingPage .Polaris-Heading {
  margin-top: 12px;
  font-size: 28px;
}

.BC-AppLoadingPage > p {
  color: #6d7175;
}

/* ===== Pricing Update – Post-Charge (isExtraFeeCharged) UI ===== */

/* Scroll anchor for "Learn why." link in the charged banner */
.BC-PricingUpdate_ScrollAnchor {
  display: block;
  position: relative;
  top: -80px;
  visibility: hidden;
  pointer-events: none;
}

/* Green success banner: match the same spacing as the warning banner */
.BC-Page__SubscriptionV5 .Polaris-Banner--statusSuccess {
  padding: 5px 16px;
  align-items: center;
  margin-top: 40px;
}

/* When Upcoming price change column is hidden (isExtraFeeCharged=true),
   let the Current plan block fill the full card width */
.BC-SubscriptionV5_BillingInformation--PricingUpdate > div:only-child {
  width: 100%;
}

/* END: Pricing Update – Post-Charge */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT;;2DAEyD;EACzD,mCAAmC;EACnC,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+EAA+E;AACjF;;AAEA,iBAAiB;AACjB;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE;;IAEE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB;;uCAEmC;EACrC;;EAEA;IACE,sBAAsB;IACtB;;uCAEmC;EACrC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,mCAAmC;IACnC;;uCAEmC;EACrC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,mCAAmC;IACnC;;uCAEmC;EACrC;;EAEA;IACE,gCAAgC;IAChC;;uCAEmC;EACrC;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,cAAc;EACd,oCAAoC;EACpC,sEAAsE;EACtE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;;;EAGE,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;EAGE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,0BAA0B;;AAE1B;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD;;uCAEqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,KAAK;AACL;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD;;uCAEqC;EACrC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,8DAA8D;EAC9D,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,OAAO;EACP,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,SAAS;AACX;;AAEA;EACE,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,YAAY;AACZ,sDAAsD;AACtD;EACE,mGAAmG;EACnG,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kEAAkE;EAClE,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA,sBAAsB;;AAEtB,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE;IACE,wBAAwB;IACxB,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,2BAA2B;EAC7B;AACF;;AAEA;EACE,iGAAiG;EACjG,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kEAAkE;EAClE,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,0CAA0C;EAC1C,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,OAAO;EACP,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,UAAU;AACZ;;AAEA;;;;;;;EAOE,aAAa;AACf;;AAEA;;;;;;;;;;;;;EAaE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;EAYE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;EAmBE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;EAYE,wBAAwB;AAC1B;;AAEA,cAAc;AACd;EACE,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,MAAM;EACN,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,+CAA+C;EAC/C,UAAU;EACV,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA,2BAA2B;;AAE3B;EACE,mBAAmB;EACnB;;mCAEiC;EACjC,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE;;AAEF;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;EAME,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;EAME,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,0BAA0B;EAC1B,0BAA0B;EAC1B,2DAA2D;AAC7D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE;;AAEF,kBAAkB;AAClB;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;;AAErB;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE;;AAEF,cAAc;;AAEd;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;CAuBC;;AAED;;EAEE,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;;;;;;EAOE;;AAEF;;EAEE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,UAAU;EACV,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE;;IAEE,YAAY;EACd;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;;IAEE,sBAAsB;EACxB;AACF;;AAEA,oBAAoB;AACpB;;;;GAIG;;AAEH;EACE,YAAY;AACd;;AAEA;;;;;;GAMG;;AAEH;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;IAChB,+BAA+B;IAC/B,gCAAgC;EAClC;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;;;;;;GAMG;;AAEH;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;CACC;AACD;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE;AACF;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAqCE,oBAAoB;EACpB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;;;;EAIE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;EAKE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B,gEAAgE;AAChE;;GAEG;;AAEH;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,kCAAkC;;AAElC;EACE,oBAAoB;EACpB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;;;;;;;EASE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ;;gCAE8B;AAChC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA,oBAAoB;;AAEpB;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sDAAsD;EACtD,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,wCAAwC;EACxC,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;EAKE,0BAA0B;EAC1B,kDAAkD;EAClD,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;;;;EAKE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB;;6BAE2B;EAC3B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,uBAAuB;;AAEvB;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8FAA8F;EAC9F,4BAA4B;AAC9B;;AAEA;EACE,gGAAgG;EAChG,4BAA4B;AAC9B;;AAEA;EACE,8FAA8F;EAC9F,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB;;yCAEuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,QAAQ;EACR,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;;;;;;EAME,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;;IAEE,aAAa;IACb,sBAAsB;EACxB;;EAEA;;IAEE,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,sEAAsE;EACtE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,aAAa;AACf;;AAEA,iCAAiC;;AAEjC;;;;;;GAMG;AACH,sCAAsC;;AAEtC;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,oBAAoB;AACpB;;EAEE,eAAe;EACf,YAAY;EACZ,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,4GAA4G;EAC5G,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mGAAmG;EACnG,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,4GAA4G;EAC5G,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,4GAA4G;EAC5G,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB;;sCAEoC;EACpC,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;EAcE,aAAa;AACf;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;;;;;;;;;;;;;;IAcE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;;EAEE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,yDAAyD;EACzD,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,qBAAqB;AACvB;;AAEA;;;;;;;;;;;EAWE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;EAKE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;EAKE,8BAA8B;AAChC;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;;;;;;;;IAQE,aAAa;EACf;;EAEA;;IAEE,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;;;GAKG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;EAIE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;;;;;EAKE,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;;EAKE,6CAA6C;EAC7C,qDAAqD;EACrD,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;EAC/C,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;;EAIE,+CAA+C;EAC/C,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;;;;EAME,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;EAmBE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;;;;;;;;;EAcE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,cAAc;AACd;;;;;;;;;;EAUE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;EAsBE,UAAU;AACZ;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;;;;;;EAUE;;AAEF;;;;;;;EAOE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;;;;;;EAWE,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;;;;;EAKE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;EAKE,oBAAoB;AACtB;;AAEA;;;;;EAKE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;GAGG;;AAEH;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,wCAAwC;AAC1C;;AAEA;;;;;;;;;EASE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,+CAA+C;EAC/C,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;;EAGE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,SAAS;EACT,8BAA8B;EAC9B,wCAAwC;EACxC,+CAA+C;EAC/C,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,sCAAsC;EACtC,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;;;;;;EAUE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAoEE;;AAEF;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;;EAGE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA,mBAAmB;AACnB;;EAEE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;AAChB;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;;EAME,cAAc;EACd,aAAa;EACb,UAAU;EACV,8BAA8B;AAChC;;AAEA;;;;;;;EAOE,kBAAkB;AACpB;;AAEA;;;;;;EAME,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;;;;EAQE,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;;;EAME,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;EA0BE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;;;;;EAOE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;;;EAME,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;;;;;;;;;;;;EAcE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;EAYE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,oCAAoC;AACtC;;AAEA;;;;;;;;;;;;EAYE,4CAA4C;EAC5C,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;EAYE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;;EAEE,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;;;;;;;;EAQE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;EAgBE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,wDAAwD;EACxD,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,0CAA0C;AAC5C;;AAEA;;;;;;;;EAQE,gBAAgB;AAClB;;AAEA;;;;;;;;;EASE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;;;;;;;EAQE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;EAIE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;EAgBE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;;;;EAQE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;EAYE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;;;;;;;;;;;EAYE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;;EAIE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA,uBAAuB;;AAEvB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,+FAA+F;EAC/F,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;;;;;;EAUE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;;;;EAKE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;;EAME,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;;;;EAME,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sDAAsD;EACtD,UAAU;EACV,kBAAkB;EAClB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,QAAQ;EACR,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,uDAAuD;EACvD,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;;EAME,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,wDAAwD;EACxD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,2BAA2B;;AAE3B,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA,mCAAmC;;AAEnC;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;;EAIE,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;AACA;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;;IAEE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,OAAO;EACP,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,OAAO;IACP,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iCAAiC;;AAEjC;EACE;;yDAEuD;EACvD,WAAW;EACX;;yDAEuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB,kBAAkB;AAClB;;;EAGE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;;AAE/B;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;EAME,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;EACV,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;EACV,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB;;sCAEoC;EACpC,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;;gCAGgC;;AAEhC;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,2BAA2B;;AAE3B;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;EAYE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;;EAIE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;;;;;;;;EAQE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;EAOE,WAAW;EACX,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;;;EAIE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;;;;;;EAME,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,iBAAiB;AACnB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;;;;;EAKE,eAAe;EACf,gDAAgD;AAClD;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;;;EAME,WAAW;EACX,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;;EAGE,eAAe;EACf,0CAA0C;AAC5C;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;EAgBE,2BAA2B;AAC7B;;AAEA;;;;;;;;;;EAUE,gBAAgB;AAClB;;AAEA;;;;;EAKE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;;;;;EAME,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;;;;;;;EAWE,eAAe;AACjB;;AAEA;;;;;;EAME,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;EAKE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;EAME,YAAY;AACd;;AAEA;;;;;EAKE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;;;EAKE,wBAAwB;AAC1B;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA,KAAK;;AAEL;EACE,WAAW;EACX,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;EAaE,qCAAqC;EACrC,WAAW;EACX,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;;;;;;EAME,eAAe;EACf,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;;;;EAME,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;;;;;EAKE,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;;;;;EAME,SAAS;EACT,WAAW;AACb;;AAEA;;;;;;EAME,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;;;;;;;EAUE,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;;;;;;;;;;EAYE,aAAa;AACf;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,aAAa;AACf;;AAEA;;;;;;;;;;EAUE,YAAY;AACd;;AAEA;;;;;;;;;;;;EAYE,YAAY;AACd;;AAEA;;;;;;;;;;;;EAYE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA,wBAAwB;;AAExB,0BAA0B;AAC1B;;;;;;;EAOE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;EAEE;;AAEF;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;;;;;;EAME,2BAA2B;AAC7B;;AAEA,aAAa;AACb;EACE,SAAS;AACX;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;;;;;;EAME,6BAA6B;AAC/B;;AAEA;;;;;;EAME,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD;;uCAEqC;EACrC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;;;;;;EAME,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;;EAME,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;;;;EAKE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE;;AAEF;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;EAIE,qBAAqB;EACrB,SAAS;EACT,0EAA0E;AAC5E;;AAEA;;;;EAIE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;EAKE,4BAA4B;AAC9B;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA;;;;;EAKE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;;;EAIE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;;;;EAIE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,kDAAkD;EAClD;;uCAEqC;EACrC,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,QAAQ;EACR,aAAa;AACf;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;;EAGE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA,qBAAqB;;AAErB;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;;;;;;;EASE,mBAAmB;AACrB;;AAEA;;;;;;EAME,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,6EAA6E;EAC7E,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;EAIE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;;EAME,kDAAkD;EAClD;;uCAEqC;EACrC,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,8BAA8B;EAC9B,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,uCAAuC;AACzC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,uCAAuC;EACvC,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;EAC1B,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,kFAAkF;;AAElF,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;AACA;;AAEA;;EAEE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qEAAqE;EACrE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,mEAAmE;EACnE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;EAuBE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,+CAA+C;EAC/C,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;;;;;EAME,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;EAIE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;;EAKE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,qCAAqC;AACvC;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oDAAoD;EACpD,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,sDAAsD;AACxD;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB;;sCAEoC;AACtC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,aAAa;;AAEb;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;EAKE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;EAEE,qDAAqD;EACrD,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;;;;;;;;;;;;;EAaE,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;;;;;;;;;;;;;;EAeE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;EAWE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;EAKE,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;;EAEE,kDAAkD;EAClD,oDAAoD;AACtD;;AAEA;;;;;EAKE,uBAAuB;AACzB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,eAAe;EACf,oDAAoD;AACtD;;AAEA;;;;;EAKE,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;;;;;EAKE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;EAKE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;;;EAME,eAAe;EACf,YAAY;AACd;;AAEA;;;;;;EAME,cAAc;EACd,YAAY;AACd;;AAEA;;;;;;EAME,cAAc;EACd,WAAW;AACb;;AAEA;;;;;EAKE,eAAe;EACf,cAAc;AAChB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;;;EAME,oBAAoB;AACtB;;AAEA;;;;;;;EAOE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;;;;;;EAME,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;;;;EAME,UAAU;AACZ;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;;;;EAIE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iDAAiD;EACjD,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,wCAAwC;EACxC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;;;;;;;EAUE,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,SAAS;AACX;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;EAME,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB;;;aAGW;AACb;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,+BAA+B;EAC/B,sBAAsB;EACtB,gBAAgB;EAChB;;2BAEyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,8BAA8B;;AAE9B,oCAAoC;AACpC;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0GAA0G;EAC1G,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;EAIE,OAAO;EACP,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;;EAGE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,wDAAwD;EACxD,iDAAiD;EACjD,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;;EAEnC,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,oCAAoC;EACpC,iBAAiB;;EAEjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB;;;sBAGoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;;;EAME,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;;;;;EAQE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;EAiBE,aAAa;AACf;;AAEA;;;EAGE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;EAcE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;;;;EAME,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;EAME,oBAAoB;AACtB;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA,0CAA0C;;AAE1C;EACE,oBAAoB;AACtB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA,8CAA8C;;AAE9C,0BAA0B;AAC1B;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;;;EAME,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;GAGG;;AAEH;;;;;;EAME,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;EAKE,6BAA6B;AAC/B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,8BAA8B;;AAE9B,mCAAmC;AACnC;EACE,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;;EAEE,UAAU;EACV,sBAAsB;AACxB;;AAEA;;;;EAIE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;;;;;;EAME,sBAAsB;EACtB,oBAAoB;EACpB,iEAAiE;EACjE,sCAAsC;AACxC;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;;;;;;EAME,oCAAoC;AACtC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,OAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,OAAO;AACT;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;EAIE,OAAO;AACT;;AAEA,uCAAuC;;AAEvC,qCAAqC;AACrC;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;;;EAGE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE;;;;;;;;;;;IAWE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,QAAQ;IACR,oBAAoB;EACtB;;EAEA;;IAEE,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;;;;;;;;;;IAUE,gBAAgB;EAClB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,wCAAwC;EACxC,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;AACA;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;EAIE,eAAe;EACf,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;;;;EAIE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,mCAAmC;IACnC,sCAAsC;IACtC,+BAA+B;IAC/B,kCAAkC;IAClC,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,oCAAoC;IACpC,uCAAuC;IACvC,gCAAgC;IAChC,mCAAmC;IACnC,4BAA4B;IAC5B,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,mCAAmC;IACnC,oCAAoC;IACpC,+BAA+B;IAC/B,gCAAgC;IAChC,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,uCAAuC;IACvC,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;EAME,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,UAAU;EACV,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,+CAA+C;EAC/C,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;;;;EAIE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;;;;;;;;;;EAgBE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,wCAAwC;EACxC,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;EAgBE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,WAAW;;AAEX;;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;;;;;EAKE,4BAA4B;AAC9B;;AAEA;;;;EAIE,aAAa;EACb,QAAQ;AACV;;AAEA;;;;EAIE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;;;;EAKE,4BAA4B;AAC9B;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;AACA;;AAEA,0BAA0B;AAC1B;;;;;;;EAOE,qBAAqB;AACvB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;;;EAKE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;EACxB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,oBAAoB;AACpB;;;;;;EAME,aAAa;AACf;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,kCAAkC;EAClC,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf;;sCAEoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,8FAA8F;AAChG;;AAEA;EACE,8FAA8F;AAChG;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;;EAGE,4BAA4B;EAC5B,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C;;IAEE,WAAW;IACX,WAAW;EACb;AACF;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,sBAAsB;EACtB,QAAQ;EACR,gCAAgC;EAChC,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B;;mCAEiC;EACjC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;EACZ,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;EAKE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;;;;;EAME,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;EAKE,WAAW;EACX,eAAe;AACjB;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;;;IAIE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA,qBAAqB;EACrB;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA,4CAA4C;EAC5C;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,gBAAgB;EAChB;IACE,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;;IAEE,gBAAgB;EAClB;;EAEA,2BAA2B;EAC3B;;IAEE,oBAAoB;EACtB;;EAEA;IACE,iCAAiC;EACnC;;EAEA,cAAc;EACd;IACE,iBAAiB;EACnB;;EAEA,WAAW;EACX;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA,mBAAmB;;EAEnB;IACE,kBAAkB;IAClB,cAAc;IACd,cAAc;EAChB;;EAEA,mBAAmB;EACnB;IACE,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,UAAU;EACZ;;EAEA,gBAAgB;EAChB;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oGAAoG;EACpG,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;;;;EAOE,sBAAsB;AACxB;;AAEA;;;;;EAKE,SAAS;AACX;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,2CAA2C;EAC3C;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,SAAS;IACT,+BAA+B;IAC/B,mBAAmB;EACrB;AACF;;AAEA,cAAc;AACd;EACE,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,YAAY;EACZ,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,+BAA+B;EAC/B,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;EACtD,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,kDAAkD;EAClD,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;EAC7C,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,wDAAwD;EACxD,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kEAAkE;EAClE,4BAA4B;AAC9B;;AAEA;;EAEE,8CAA8C;EAC9C,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,gBAAgB;EAChB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yDAAyD;EACzD,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,wDAAwD;EACxD,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kEAAkE;EAClE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,8CAA8C;EAC9C,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;AACpB;;AAEA,GAAG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;;;;;;;EASE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;;AAExB;EACE,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;EAYE,YAAY;AACd;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;;;;;GAOG;;AAEH;;;;;;;EAOE,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;;;;;;;EAOE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;;;;;EAOE,iBAAiB;AACnB;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA;;;;;;;EAOE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,sBAAsB;AACxB;;AAEA;;;;;EAKE,UAAU;EACV,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;;;;EAME,UAAU;EACV,qBAAqB;AACvB;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;;;;;;;;;EASE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;;;;;EASE,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;;;;EASE,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;;;;EASE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;;;;EASE,aAAa;AACf;;AAEA;;;;;;;EAOE,aAAa;AACf;;AAEA;;;;;;;;;;;;;;EAcE,aAAa;AACf;;AAEA;;;;;;;EAOE,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;;EAGE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;;;EAGE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;;;EAOE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA,2CAA2C;;AAE3C;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;;;EAGE,oCAAoC;EACpC,+DAA+D;EAC/D,kBAAkB;AACpB;;AAEA;;;EAGE,oCAAoC;EACpC,+DAA+D;EAC/D,kBAAkB;AACpB;;AAEA;;;EAGE,oCAAoC;EACpC,+DAA+D;EAC/D,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;;;EAIE,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;;;;;;;;;;EAUE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAoCE,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;EAgBE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,aAAa;AACf;;AAEA;;;;;;;;;;EAUE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;EAYE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,iBAAiB;AACnB;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;;;;EAIE,+CAA+C;AACjD;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;;EAGE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;;EAGE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;;EAGE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;;;EAIE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;EAIE,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;;;;;EASE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA,qCAAqC;;AAErC,sCAAsC;AACtC;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,4CAA4C;EAC5C,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,6BAA6B;;AAE7B;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,4DAA4D;AAC9D;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;;AAKA;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,2BAA2B;;AAE3B,gCAAgC;;AAEhC;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA,qCAAqC;;AAErC;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;EACE;;;IAGE,iBAAiB;EACnB;AACF;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;;;EAKE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,cAAc;AAChB;;AAEA;;;;;;EAME,SAAS;AACX;;AAEA;;;;;EAKE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;EAKE,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,qBAAqB;EACrB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;;EAKE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;GAEG;AACH;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;;;;;EAME,SAAS;AACX;;AAEA;;;;;EAKE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;EAKE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;;;;EAKE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;;;;;EAME,SAAS;AACX;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;;EAEb,aAAa;EACb,mBAAmB;;EAEnB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;;EAE1B,aAAa;EACb,sBAAsB;EACtB,QAAQ;;EAER,mBAAmB;EACnB,gBAAgB;;EAEhB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;;EAEpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;;;;;;qCAMmC;AACrC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;;EAEvB,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;;EAEX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;EAEjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;EAEjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;;EAEhB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;;EAEnB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;;EAE3B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;;EAEpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;;EAER,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;EAEjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;;2BAEyB;AAC3B;;AAEA;EACE;;gCAE8B;AAChC;;AAEA;EACE;;gCAE8B;AAChC;;AAEA;EACE;;gCAE8B;AAChC;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,uCAAuC;EACvC,yGAAyG;EACzG,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;EAC3B,aAAa;EACb,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mGAAmG;EACnG,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mFAAmF;EACnF,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,cAAc;;AAEd,iBAAiB;AACjB;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;EAeE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,iBAAiB;;AAEjB,oCAAoC;;AAEpC,wCAAwC;AACxC;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA,wCAAwC;AACxC;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wCAAwC;;AAExC,qCAAqC;AACrC;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,uCAAuC;AACvC;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;AACA;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;;;;;;;;EAUE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;;;;;;;EAUE,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;;;;;;;;;;EAYE,aAAa;AACf;;AAEA,qCAAqC;;AAErC,iCAAiC;AACjC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,aAAa;EACb,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iCAAiC;;AAEjC,8BAA8B;AAC9B;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,mDAAmD;EACnD,oDAAoD;EACpD,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,6BAA6B;;AAE7B,yCAAyC;AACzC;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;;EAIE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;EAIE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yCAAyC;;AAEzC,wBAAwB;AACxB;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iGAAiG;EACjG,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,uBAAuB;;AAEvB,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sEAAsE;EACtE,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;AACA;;AAEA,6BAA6B;;AAE7B;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sEAAsE;EACtE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;;EAME,2BAA2B;AAC7B;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA,6BAA6B;;AAE7B,gDAAgD;AAChD;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA,qDAAqD;;AAErD;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE,sFAAsF;EACtF,kFAAkF;EAClF,oFAAoF;EACpF,kFAAkF;EAClF,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sFAAsF;EACtF,kFAAkF;EAClF,oFAAoF;EACpF,kFAAkF;EAClF,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qEAAqE;EACrE,+DAA+D;EAC/D,iEAAiE;EACjE,+DAA+D;AACjE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,UAAU;EACV,kCAAkC;EAClC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,OAAO;AACT;;AAEA;EACE,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,gDAAgD;EAChD,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,2BAA2B;AAC7B;;AAEA;;EAEE,sFAAsF;EACtF,kFAAkF;EAClF,oFAAoF;EACpF,kFAAkF;EAClF,6BAA6B;AAC/B;;AAEA;;EAEE,6EAA6E;EAC7E,yEAAyE;EACzE,2EAA2E;EAC3E,yEAAyE;EACzE,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;;;EAGE,6FAA6F;AAC/F;;AAEA;;;EAGE,iGAAiG;AACnG;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA,yCAAyC;AACzC;EACE,gDAAgD;EAChD,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;EAKE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;;;EAKE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;;;;;EAKE,iBAAiB;EACjB,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;;;;;EAKE,4CAA4C;EAC5C,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;EAKE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;;EAKE,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,6EAA6E;EAC7E,yEAAyE;EACzE,2EAA2E;EAC3E,yEAAyE;EACzE,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sFAAsF;EACtF,kFAAkF;EAClF,oFAAoF;EACpF,kFAAkF;EAClF,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE;;;;;GAKC;EACD;;;;;GAKC;EACD;;;;;GAKC;EACD;;;;;GAKC;AACH;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;;EAKE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;;;;;EAKE,kFAAkF;EAClF,6BAA6B;AAC/B;;AAEA;;;;;EAKE,6EAA6E;EAC7E,yEAAyE;EACzE,2EAA2E;EAC3E,yEAAyE;EACzE,6BAA6B;AAC/B;;AAEA;;;;;;EAME,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;EAYE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;EAYE,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uDAAuD;EACvD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;;;;EAME,6BAA6B;EAC7B,cAAc;EACd,UAAU;EACV,WAAW;EACX,8BAA8B;AAChC;;AAEA;;EAEE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,uDAAuD;EACvD,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,uDAAuD;EACvD,aAAa;AACf;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gEAAgE;EAChE,0DAA0D;EAC1D,aAAa;EACb,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oEAAoE;EACpE,8DAA8D;EAC9D,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qEAAqE;EACrE,+DAA+D;EAC/D,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA,oBAAoB;;AAEpB,8BAA8B;AAC9B;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8FAA8F;AAChG;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;;EAEE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;;;EAGE,sEAAsE;EACtE,qBAAqB;EACrB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,oEAAoE;EACpE,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA,4BAA4B;;AAE5B,iCAAiC;AACjC;EACE,aAAa;AACf;;AAEA;EACE,8EAA8E;EAC9E,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,+BAA+B;;AAE/B,wCAAwC;AACxC;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;;EAEhB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;;EAEhB,cAAc;AAChB;;AAEA;EACE,6BAA6B;;EAE7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;;EAET,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2BAA2B;;AAE3B;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,gCAAgC;AAClC;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;;EAIE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kEAAkE;EAClE,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;;;;EAIE,qEAAqE;AACvE;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,4BAA4B;EAC5B,YAAY;AACd;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE;IACE,aAAa;IACb,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,gCAAgC;;AAEhC,mCAAmC;AACnC;EACE,iBAAiB;EACjB,UAAU;EACV,4BAA4B;EAC5B,kBAAkB;EAClB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;;;;EAQE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;;;EAME,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,cAAc;EACd,yEAAyE;EACzE,eAAe;AACjB;;AAEA;;;;;;;EAOE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;EAaE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;EAaE,WAAW;AACb;;AAEA;;;;;;;;;;;;;EAaE,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;EAIE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,0DAA0D;EAC1D,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,8DAA8D;AAChE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA,iCAAiC;;AAEjC;EACE,QAAQ;EACR,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;;IAEE,sBAAsB;IACtB,aAAa;EACf;AACF;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;EAGE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,qEAAqE;EACrE,yDAAyD;EACzD,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,qEAAqE;EACrE,0DAA0D;AAC5D;;AAEA,mBAAmB;AACnB;;EAEE,kBAAkB;EAClB,wBAAwB;EACxB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,QAAQ;EACR,WAAW;EACX,MAAM;EACN,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;;;;;EAME,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iEAAiE;EACjE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sEAAsE;EACtE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gGAAgG;EAChG,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wDAAwD;EACxD,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kEAAkE;EAClE,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kEAAkE;EAClE,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kEAAkE;EAClE,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;EAChD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qEAAqE;EACrE,4CAA4C;EAC5C,YAAY;AACd;;AAEA;;;;EAIE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;;;;EAIE,WAAW;EACX,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;;AAEnC;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,qCAAqC;EACvC;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;;IAEE,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,wBAAwB;;AAExB,yBAAyB;AACzB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,8BAA8B;;AAE9B,mDAAmD;AACnD;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,oEAAoE;;AAEpE,8DAA8D;AAC9D;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,uEAAuE;AACvE;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;wDACwD;AACxD;EACE,WAAW;AACb;;AAEA,sCAAsC","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Poppins&display=swap');\n\nbody {\n  margin: 0;\n  font-family:\n    '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',\n    'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  height: auto;\n}\n\nbody[data-lock-scrolling] {\n  overflow-y: hidden;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n/* Common class */\n.full-width {\n  width: 100%;\n}\n\n.align-center {\n  text-align: center;\n}\n\n.flex-align-center {\n  display: flex;\n  justify-content: center;\n}\n\n.clear {\n  clear: both;\n  display: block;\n}\n\n.card-title-green {\n  color: var(--p-action-primary);\n}\n\n.text-disable {\n  color: #8c9196;\n}\n\n.background-addon-unlock {\n  background: #fff5ea;\n  border: 1px solid #e1b878;\n  border-radius: 4px;\n}\n\n.icon-warning .Polaris-Icon svg {\n  fill: #ff9b10;\n}\n\n.btn-highlight button {\n  animation: wiggle 4s 2s infinite;\n}\n\n.Polaris-Scrollable--hasBottomShadow {\n  box-shadow: unset !important;\n}\n\n.hyperlink {\n  position: relative;\n  color: var(--p-interactive);\n  cursor: pointer;\n}\n\n.hyperlink:has(img) {\n  padding-right: 18px;\n}\n\n.hyperlink img {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n}\n\n@keyframes wiggle {\n  5%,\n  50% {\n    transform: scale(1);\n  }\n\n  10% {\n    transform: scale(0.9);\n    box-shadow:\n      5px 5px 20px rgb(221, 221, 221),\n      -5px -5px 20px rgb(244, 244, 244);\n  }\n\n  15% {\n    transform: scale(1.15);\n    box-shadow:\n      5px 5px 20px rgb(192, 191, 191),\n      -5px -5px 20px rgb(209, 208, 208);\n  }\n\n  20% {\n    transform: scale(1.15) rotate(-5deg);\n  }\n\n  25% {\n    transform: scale(1.15) rotate(5deg);\n    box-shadow:\n      5px 5px 20px rgb(186, 226, 201),\n      -5px -5px 20px rgb(186, 226, 201);\n  }\n\n  30% {\n    transform: scale(1.15) rotate(-3deg);\n  }\n\n  35% {\n    transform: scale(1.15) rotate(2deg);\n    box-shadow:\n      5px 5px 20px rgb(140, 187, 157),\n      -5px -5px 20px rgb(140, 187, 157);\n  }\n\n  40% {\n    transform: scale(1.15) rotate(0);\n    box-shadow:\n      5px 5px 20px rgb(140, 187, 157),\n      -5px -5px 20px rgb(140, 187, 157);\n  }\n}\n\n.recommendation-collapse .Polaris-DataTable__Cell--status .Polaris-Tooltip-TooltipOverlay__Content {\n  max-width: 21rem;\n}\n\n.card-title {\n  margin: 0.25rem 0 1.5rem;\n}\n\n.backdrop-custom {\n  position: fixed;\n  z-index: -1;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  background-color: rgba(0, 0, 0, 0.2);\n  animation: var(--p-keyframes-fade-in) var(--p-duration-200) 1 forwards;\n  opacity: 0;\n}\n\n.datetime-picker-input {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  align-self: center;\n  width: 100%;\n}\n\n.datetime-picker-input > div {\n  width: 50%;\n}\n\n/* Css for product tour */\n.custom-btn-tour {\n  position: relative;\n  position: static;\n  min-width: 64px;\n  height: 36px;\n  font-size: 0.875rem;\n  border-radius: 4px;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  margin: 0px 5px;\n  font-weight: 500;\n}\n\n.custom-btn-action {\n  background-color: #008060;\n  border-color: transparent;\n  color: white;\n}\n\n.custom-btn-tour:hover,\n.custom-btn-action:hover {\n  cursor: pointer;\n}\n\n.custom-btn-learn-more {\n  border: 0.0625rem solid rgb(202, 200, 200);\n  background: #ffffff;\n  min-width: 105px;\n  margin-right: 10px !important;\n}\n\n.custom-btn-back {\n  border: 0.0625rem solid rgb(202, 200, 200);\n  background: #ffffff;\n}\n\n.product-tour-step0 div[data-tour-elem='controls'],\n.product-tour-step1 div[data-tour-elem='controls'],\n.product-tour div[data-tour-elem='controls'] {\n  margin-top: 0px !important;\n  width: max-content;\n  margin-left: auto;\n  margin-right: 8px;\n}\n\n.product-tour-step0 div[data-tour-elem='controls'] > button,\n.product-tour-step1 div[data-tour-elem='controls'] > button,\n.product-tour div[data-tour-elem='controls'] > button {\n  margin-right: 3px;\n  margin-left: 3px;\n}\n\n.product-tour-step0,\n.product-tour-step1,\n.product-tour {\n  --reactour-accent: #5cb7b7;\n  line-height: 1.3;\n  color: rgb(132 85 144 / 11%);\n}\n\n.product-tour-step0 .reactour__close,\n.product-tour-step1 .reactour__close,\n.product-tour .reactour__close {\n  width: 12px;\n  height: 25px;\n}\n\n#___reactour rect {\n  color: #202123;\n}\n\n.heading-tour {\n  font-size: 20px;\n  line-height: 28px;\n  color: #202223;\n  padding: 16px 20px;\n  font-weight: normal;\n}\n\n.heading_tour_list {\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.content-tour {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  padding: 16px;\n  color: #202223;\n}\n\n.word-break {\n  word-break: break-word;\n  word-wrap: break-word;\n}\n\n/* --------------------- */\n\n.Polaris-Page {\n  max-width: 984px;\n}\n\n.beta0323Title {\n  color: #d9730d;\n}\n\n.card-title-uppercase {\n  margin: 1.5rem 0;\n  text-transform: uppercase;\n}\n\n.BC-Button__Dismiss {\n  position: absolute;\n  right: 1rem;\n  top: 1rem;\n}\n\n.section-title {\n  margin: 1.5rem auto 1.25rem;\n}\n\n.sortableHelper {\n  z-index: 99999999 !important;\n}\n\n.sortableHelper .BC-Select__multi-value {\n  cursor: grabbing !important;\n  pointer-events: fill;\n}\n\n.inline-warning .Polaris-InlineError {\n  color: #f2711c;\n  fill: #f2711c;\n}\n\n.inline-info {\n  margin-top: 10px;\n}\n\n.inline-info-blue {\n  color: var(--p-interactive);\n}\n\n.align-middle {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n\n.BC-Popover__Button {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.BC-Popover__Button_spaceBetween {\n  justify-content: space-between;\n}\n\n.badge-dangerous .Polaris-Badge--statusWarning {\n  background-color: #de3618 !important;\n  color: #ffffff;\n  border: 2px solid #efefef;\n}\n\nul.dashed {\n  list-style-type: none;\n  margin: 0;\n  padding-left: 0;\n}\n\nul.dashed > li:before {\n  content: '-';\n  margin-right: 5px;\n}\n\nul.four-cols {\n  list-style-type: none;\n  margin: 0 2.5rem;\n  padding-left: 0;\n  display: flex;\n}\n\nul.four-cols li {\n  flex: 1 1 25%;\n  text-align: center;\n}\n\nul.four-cols li p {\n  margin: 0.75rem 3.125rem 0.25rem;\n}\n\nul.four-cols li:first-child p,\nul.four-cols li:last-child p {\n  margin: 0.75rem 1.25rem 0.25rem;\n}\n\n.modal-title .Polaris-DisplayText {\n  font-weight: 600;\n}\n\n.modal-title span {\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5rem;\n}\n\n.send-request-text {\n  margin-top: 1.25rem;\n}\n\n.send-request-text button {\n  padding-top: 0rem;\n}\n\n/* banner */\n.pfs-plan-search-banner {\n  position: relative;\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n  padding: 12px 8px;\n}\n\n.pfs-plan-search-banner--warning {\n  background: #fffbf3;\n}\n\n.pfs-plan-search-banner--warning .plan-search-banner-actions .Polaris-Button--disabled {\n  background-color: rgb(243, 242, 242) !important;\n}\n\n.pfs-plan-search-banner--warning .plan-search-banner-actions .Polaris-Button {\n  border-radius: 4px;\n  background: var(--decorative-surface-one, #ffc96b);\n  box-shadow:\n    0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset,\n    0px 1px 0px 0px rgba(0, 0, 0, 0.08);\n  margin-top: 16px;\n  padding: 8px !important;\n  width: 100%;\n}\n\n.plan-search-banner-actions .action .Polaris-Button__Text {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.Polaris-Badge {\n  border-radius: 8px;\n  padding: 2px 8px;\n}\n\n.Polaris-Badge--statusSuccess {\n  background-color: #cdfee1;\n  color: #0c5132;\n}\n\n.Polaris-Badge--statusCritical {\n  background-color: #fedad9;\n  color: #8e1f0b;\n}\n\n.Polaris-Badge--statusWarning {\n  background-color: #fff2d9;\n}\n\n.BC-Page__ProductPerformanceRanking .test-your-search .Polaris-Icon,\n.intro-new-product-performance-ranking .Polaris-Icon,\n.addon-standard-search li .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  max-width: 16px;\n}\n\n.intro-new-product-performance-ranking a,\n.addon-standard-search li a {\n  color: #2c6ecb;\n  margin-right: 4px;\n}\n\n.BC-Page__ProductPerformanceRanking .test-your-search .Polaris-Icon svg,\n.intro-new-product-performance-ranking .Polaris-Icon svg,\n.addon-standard-search li .Polaris-Icon svg {\n  fill: #2c6ecb;\n}\n\n.plan-search-banner-infos .title {\n  position: relative;\n  z-index: 10;\n}\n\n.plan-search-banner-child {\n  z-index: 10;\n}\n\n.pfs-plan-search-banner .imageTop {\n  position: absolute;\n  top: 12px;\n  right: 8px;\n}\n\n.pfs-plan-search-banner .imageTop img {\n  max-width: 24px;\n}\n\n.plan-search-banner-child {\n  position: relative;\n  z-index: 10;\n}\n\n.pfs-plan-search-banner .imageBottom img {\n  position: absolute;\n  bottom: 0;\n  max-width: 116px;\n  right: 0;\n  z-index: 1;\n  height: auto;\n}\n\n.plan-search-banner-infos .title {\n  display: flex;\n  gap: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n/*  */\n.pfs-app-banner {\n  position: relative;\n  padding: 20px 20px 0 20px;\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  display: flex;\n  gap: 20px;\n}\n\n.pfs-banner-dismiss {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  z-index: 12;\n}\n\n.pfs-app-banner--success {\n  background-color: #f7fdfc;\n}\n\n.pfs-app-banner--warning {\n  background-color: #fffbf3;\n}\n\n.pfs-app-banner--info {\n  background-color: #ebf9fc;\n}\n\n.pfs-app-banner .title {\n  display: flex;\n  gap: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.pfs-banner-detail {\n  margin-top: 4px;\n  display: flex;\n  gap: 20px;\n}\n\n.pfs-banner-infos {\n  width: 100%;\n}\n\n.pfs-banner-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-bottom: 20px;\n  padding-right: 10px;\n  gap: 20px;\n}\n\n.pfs-banner-actions {\n  bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pfs-banner-actions .secondary-action {\n  text-decoration: underline;\n  height: 100%;\n  padding: 2px 5px;\n}\n\n.pfs-banner-actions .Polaris-Button__Text {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.pfs-app-banner--warning .primary-action .Polaris-Button--disabled {\n  background-color: rgb(243, 242, 242) !important;\n}\n\n.pfs-app-banner--warning .primary-action .Polaris-Button {\n  border-radius: 4px;\n  background: var(--decorative-surface-one, #ffc96b);\n  box-shadow:\n    0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset,\n    0px 1px 0px 0px rgba(0, 0, 0, 0.08);\n  margin-top: 16px;\n  padding: 8px !important;\n}\n\n.pfs-banner-actions .secondary-action:hover {\n  cursor: pointer;\n}\n\n.pfs-banner-actions .Polaris-Button {\n  background: none;\n}\n\n.banner-success--hasOutline,\n.pfs-app-banner--success .pfs-banner-actions .Polaris-Button {\n  border: 1px solid #95c9b4;\n}\n\n.banner-warning--hasOutline,\n.pfs-app-banner--warning .pfs-banner-actions .Polaris-Button {\n  border: 1px solid #e1b878;\n}\n\n.banner-info--hasOutline,\n.pfs-app-banner--info .pfs-banner-actions .Polaris-Button {\n  border: 1px solid #98c6cd;\n}\n\n.pfs-banner-dismiss .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.pfs-banner-detail .image {\n  width: 30%;\n  z-index: 10;\n  max-width: 240px;\n  margin-left: auto;\n}\n\n.pfs-app-banner .backgroundImage {\n  z-index: 9;\n  bottom: 0;\n  right: 0;\n  position: absolute;\n}\n\n.pfs-app-banner .backgroundImage img {\n  max-width: 140px;\n  height: auto;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n\n.pfs-banner-detail .image img {\n  width: 100%;\n  height: auto;\n}\n\n.BC-PriceChangeNotificationBanner {\n  display: flex;\n  width: 100%;\n  padding: 14px 48px;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  background: var(--Banner-Background-color-error-bg, #fff5ea);\n  position: relative;\n}\n\n.BC-PriceChangeNotificationBanner .content {\n  display: flex;\n  gap: 8px;\n}\n\n.BC-PriceChangeNotificationBanner .Polaris-Button .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.BC-PriceChangeNotificationBanner a {\n  cursor: pointer;\n}\n\n.trial-banner,\n.promote-banner,\n.incident-banner {\n  display: flex;\n  width: 100%;\n  padding: 14px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  background: var(--Banner-Background-color-warning-bg, #fffbf3);\n  position: relative;\n}\n\n.promote-banner .Polaris-Button,\n.incident-banner .incident-dismiss .Polaris-Button {\n  position: absolute;\n  top: 14px;\n  right: 20px;\n}\n\n.promote-banner .Polaris-Button .Polaris-Icon,\n.incident-banner .Polaris-Button .Polaris-Icon {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n}\n\n.promote-banner .Polaris-Button .Polaris-Icon svg,\n.incident-banner .Polaris-Button .Polaris-Icon svg {\n  width: 16px;\n  height: 16px;\n}\n\n.BC-PriceChangeNotificationBanner a,\n.trial-banner a,\n.promote-banner a,\n.incident-banner a {\n  color: #2c6ecb;\n  text-decoration: underline;\n}\n\n.promote-banner a:hover,\n.incident-banner a:hover {\n  cursor: pointer;\n}\n\n.trial-banner.trial-banner_EndToDay {\n  background: #ff8d58;\n  color: #ffffff;\n}\n\n.trial-banner.trial-banner_Ended {\n  background: #ff5951;\n  color: #ffffff;\n}\n\n.trial-banner.trial-banner_EndToDay a,\n.trial-banner.trial-banner_Ended a {\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.recommendation-popover-inline button,\n.recommendation-popover-inline {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n}\n\n.recommendation-popover-inline button .Polaris-Icon {\n  padding: 2px;\n}\n\n.BC-Page--child .Polaris-Header-Title > div {\n  display: flex;\n  gap: 16px;\n  font-size: 20px;\n  line-height: 28px;\n  font-weight: 600;\n  align-items: center;\n}\n\n.BC-Page--heading > div button,\n.BC-Page--child .Polaris-Header-Title > div button {\n  background-color: unset;\n}\n\n.BC-Page--child .BC-Page__Title--Help {\n  margin-left: 54px;\n}\n\n.BC-Page--heading {\n  display: flex;\n  gap: 16px;\n}\n\n.Polaris-Header-Title h1,\n.BC-Page--heading h1 {\n  font-size: 28px;\n  line-height: 32px;\n  font-weight: 600;\n}\n\n/* Checkbox slider status */\n.BC-Toggle-Switch {\n  display: inline-flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.BC-Toggle-Switch .Polaris-Labelled__LabelWrapper {\n  display: inline-flex;\n  margin: unset;\n}\n\n.BC-Toggle-Switch .Polaris-Labelled__LabelWrapper .tooltip {\n  margin-top: 4px;\n}\n\n.BC-Toggle-Switch .Polaris-Labelled__LabelWrapper .tooltip.disabled {\n  cursor: not-allowed;\n}\n\n.BC-Toggle-Switch .Polaris-Labelled__LabelWrapper .tooltip.disabled svg {\n  fill: #babec3;\n}\n\n.BC-Toggle-Switch .Polaris-Labelled__LabelWrapper .Polaris-Label__Text.disabled {\n  color: #8c9196;\n  cursor: not-allowed;\n}\n\n.BC-Checkbox-Status {\n  position: relative;\n  display: inline-block;\n  width: 34px;\n  min-width: 34px;\n  height: 16px;\n  margin-top: 2px;\n  margin-right: 1rem;\n}\n\n.BC-Checkbox-Status input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.BC-Checkbox-Status span {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 8px;\n  background-color: var(--p-surface-neutral);\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.BC-Checkbox-Status span:before {\n  position: absolute;\n  content: '';\n  height: 16px;\n  width: 16px;\n  left: 0;\n  bottom: 0;\n  border-radius: 8px;\n  background-color: var(--p-icon);\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.BC-Checkbox-Status input:checked + span {\n  background-color: var(--p-surface-success);\n}\n\n.BC-Checkbox-Status input:checked + span:before {\n  background-color: var(--p-border-success);\n  left: 2px;\n}\n\n.BC-Checkbox-Status input:disabled + span {\n  background-color: var(--p-surface-neutral-disabled);\n  cursor: not-allowed;\n}\n\n.BC-Checkbox-Status input:disabled + span:before {\n  background-color: var(--p-icon-disabled);\n}\n\n.BC-Checkbox-Status input:focus + span {\n  box-shadow: 0 0 1px var(--p-surface-success-subdued-pressed);\n}\n\n.BC-Checkbox-Status input:checked + span:before {\n  -webkit-transform: translateX(16px);\n  -ms-transform: translateX(16px);\n  transform: translateX(16px);\n}\n\n/* ------- */\n/* Popup pre launch promotion before release 04/2023 */\n.PFS-Pre-launch-Modal {\n  background-image: url('https://cdn.boostcommerce.io/assets/common/popup-pre-launch-background.png');\n  background-repeat: no-repeat;\n  background-position-y: bottom;\n  background-size: contain;\n  min-height: 482px;\n  padding-bottom: 28px;\n  position: relative;\n}\n\n.PFS-Pre-launch-Modal .action {\n  width: 100%;\n  position: absolute;\n  bottom: 28px;\n  display: flex;\n  justify-content: center;\n}\n\n.PFS-Pre-launch-Modal .promotion-content {\n  text-align: center;\n  color: hsl(0, 0%, 100%);\n  margin-top: 46%;\n}\n\n.PFS-Pre-launch-Modal .closeBtn {\n  text-align: right;\n}\n\n.PFS-Pre-launch-Modal .closeBtn .Polaris-Button {\n  margin-top: 18px;\n  margin-right: 18px;\n}\n\n.PFS-Pre-launch-Modal .closeBtn .Polaris-Icon svg {\n  fill: #ffffff;\n}\n\n.PFS-Pre-launch-Modal .promotion-content p:first-child {\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 33px;\n}\n\n.PFS-Pre-launch-Modal .promotion-content p:last-child {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 21px;\n}\n\n.PFS-Pre-launch-Modal .action .Polaris-Button {\n  background: linear-gradient(94.17deg, #ff005c 2.45%, #ff5c00 100%);\n  box-shadow: 0px 4px 24px rgba(255, 48, 0, 0.4);\n  border-radius: 4px;\n}\n\n/* ----------------- */\n\n/* Popup BFCM23 promotion */\n.Polaris-Modal-Dialog__Modal:has(.PFS-BFCM23-Popup) {\n  max-width: 912px;\n  height: 532px;\n}\n\n@media (max-width: 950px) or (max-height: 595px) {\n  .Polaris-Modal-Dialog__Modal:has(.PFS-BFCM23-Popup) {\n    height: 432px !important;\n    max-width: 741px !important;\n  }\n}\n\n@media (max-width: 785px) or (max-height: 493px) {\n  .Polaris-Modal-Dialog__Modal:has(.PFS-BFCM23-Popup) {\n    height: 332px !important;\n    max-width: 570px !important;\n  }\n}\n\n.PFS-BFCM23-Popup {\n  background-image: url('https://cdn.boostcommerce.io/assets/dashboard-v3/bfcm23-in-app-popup.png');\n  background-repeat: no-repeat;\n  background-position-y: bottom;\n  background-size: contain;\n  height: 100%;\n  width: 100%;\n  padding-bottom: 2px;\n  position: relative;\n}\n\n.PFS-BFCM23-Popup .action:hover {\n  cursor: pointer;\n}\n\n.PFS-BFCM23-Popup .action {\n  width: 80%;\n  height: 35%;\n  position: absolute;\n  top: 22%;\n  left: 10%;\n  display: flex;\n  justify-content: center;\n}\n\n.PFS-BFCM23-Popup .promotion-content {\n  text-align: center;\n  color: hsl(0, 0%, 100%);\n  margin-top: 46%;\n}\n\n.PFS-BFCM23-Popup .closeBtn {\n  text-align: right;\n}\n\n.PFS-BFCM23-Popup .closeBtn .Polaris-Button {\n  margin-top: 18px;\n  margin-right: 18px;\n}\n\n.PFS-BFCM23-Popup .closeBtn .Polaris-Icon svg {\n  fill: #ffffff;\n}\n\n.PFS-BFCM23-Popup .promotion-content p:first-child {\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 33px;\n}\n\n.PFS-BFCM23-Popup .promotion-content p:last-child {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 21px;\n}\n\n.PFS-BFCM23-Popup .action .Polaris-Button {\n  background: linear-gradient(94.17deg, #ff005c 2.45%, #ff5c00 100%);\n  box-shadow: 0px 4px 24px rgba(255, 48, 0, 0.4);\n  border-radius: 4px;\n}\n\n/* ----------------- */\n.BC-Page__Integration .Polaris-Stack--alignmentBaseline {\n  align-items: center;\n}\n\n.BC-Page__Integration .Polaris-Stack__Item--fill {\n  max-width: 240px;\n}\n\n.BC-Page__Integration .Polaris-Stack__Item:last-child {\n  margin-left: auto;\n}\n\n.BC-Page__Integration .BC-Filter-Type .Polaris-Button {\n  padding-right: 12px;\n}\n\n.BC-Page__Integration .BC-Filter-Type .Polaris-Button .Polaris-Button__Text {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: 500;\n}\n\n.BC-Page__Integration .BC-Filter-Type .Polaris-Button .Polaris-Icon {\n  margin: 0;\n}\n\n.BC-Filter-Type__List {\n  padding: 8px;\n}\n\n.BC-Filter-Type__List .Polaris-ChoiceList__ChoiceItem .Polaris-Choice {\n  padding: 8px;\n  width: 100%;\n}\n\n.BC-Filter-Type__List .Polaris-ChoiceList__ChoiceItem .Polaris-Choice:hover {\n  background-color: #f6f6f7;\n}\n\n.BC-Filter-Status__List {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n}\n\n.BC-Page__Integration .BC-Checkbox-Status {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 28px;\n}\n\n.BC-Page__Integration .BC-Checkbox-Status span {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 15px;\n  background-color: var(--p-surface-neutral);\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.BC-Page__Integration .BC-Checkbox-Status span:before {\n  position: absolute;\n  content: '';\n  height: 28px;\n  width: 28px;\n  left: 0;\n  bottom: 0;\n  border-radius: 15px;\n  background-color: var(--p-icon);\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.BC-Page__Integration .BC-Checkbox-Status input:checked + span:before {\n  background-color: var(--p-border-success);\n  left: 16px;\n}\n\n.BC-Page .Polaris-Page > div:not(.Polaris-Page-Header) > .Polaris-Layout > .Polaris-Layout__Section,\n.BC-Page\n  .Polaris-Page\n  > div:not(.Polaris-Page-Header)\n  > form\n  > .Polaris-Layout\n  > .Polaris-Layout__Section {\n  margin-top: 0;\n}\n\n.BC-Page\n  .Polaris-Page\n  > div:not(.Polaris-Page-Header)\n  > .Polaris-Layout\n  > .Polaris-Layout__Section:not(:first-child)\n  > *:first-child,\n.BC-Page\n  .Polaris-Page\n  > div:not(.Polaris-Page-Header)\n  > form\n  > .Polaris-Layout\n  > .Polaris-Layout__Section:not(:first-child)\n  > *:first-child {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__SearchPageDisplay\n  .Polaris-Page\n  > div:not(.Polaris-Page-Header)\n  > .Polaris-Layout\n  > .Polaris-Layout__Section:not(:first-child)\n  > *:first-child,\n.BC-Page__MerchandisingV2\n  .Polaris-Page\n  > div:not(.Polaris-Page-Header)\n  > .Polaris-Layout\n  > .Polaris-Layout__Section:not(:first-child)\n  > *:first-child {\n  margin-top: 8px;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-Tabs__Wrapper {\n  padding: unset;\n}\n\n.BC-Page\n  .Polaris-Page\n  > div:not(.Polaris-Page-Header)\n  > .Polaris-Layout\n  > .Polaris-Layout__Section:not(:first-child)\n  > .BC-Container__Notifications,\n.BC-Page\n  .Polaris-Page\n  > div:not(.Polaris-Page-Header)\n  > .Polaris-Layout\n  > .Polaris-Layout__Section:not(:first-child)\n  > #BC-onboardingArticles__Wrapper,\n.BC-Page\n  .Polaris-Page\n  > div:not(.Polaris-Page-Header)\n  > form\n  > .Polaris-Layout\n  > .Polaris-Layout__Section:not(:first-child)\n  > .BC-Container__Notifications {\n  margin-top: 0;\n}\n\n#BC-onboardingArticles__Wrapper > *:first-child {\n  margin-top: 1.5rem;\n}\n\n.BC-Container__Notifications > *:first-child {\n  margin-top: 1.5rem;\n}\n\n.BC-Container__Notifications > *:not(:first-child) {\n  margin-top: 1.25rem;\n}\n\n.BC-Page__StandardSearch\n  .tab-children\n  .Polaris-Page\n  > div:not(.Polaris-Page-Header)\n  > .Polaris-Layout,\n.BC-Page__Synonym .Polaris-Page > div:not(.Polaris-Page-Header) > .Polaris-Layout,\n.BC-Page__AdvancedSearch\n  .tab-children\n  .Polaris-Page\n  > div:not(.Polaris-Page-Header)\n  > .Polaris-Layout,\n.BC-Page__StopWords .Polaris-Page > div:not(.Polaris-Page-Header) > .Polaris-Layout {\n  margin-top: 0 !important;\n}\n\n/* Main menu */\n.BC_MainMenu_Wrapper {\n  position: -webkit-sticky;\n  /* Safari */\n  position: sticky;\n  background-color: #f4f6f8;\n  top: 0;\n  z-index: 518;\n  box-shadow: inset 0px -1px 0px var(--p-divider);\n}\n\n.BC_MainMenu {\n  display: table;\n  margin: 0 auto;\n  padding: 0;\n  max-width: 65rem;\n  width: 100%;\n}\n\n.BC_MainMenu > li.menuItem {\n  text-align: center;\n  color: #637381;\n  font-size: 14px;\n  border: none;\n  padding: 17px 0;\n  list-style-type: none;\n  cursor: pointer;\n  display: table-cell;\n  min-width: 4rem;\n}\n\n.BC_MainMenu a {\n  text-decoration: none;\n  color: inherit;\n}\n\n.BC_MainMenu > li.menuItem > a {\n  margin: -17px 0;\n  padding: 17px 0;\n  display: block;\n}\n\n.BC_MainMenu > li.menuItem.active {\n  border-bottom: solid 3px var(--p-action-primary);\n  color: var(--p-action-primary);\n  background-color: var(--p-background-selected);\n}\n\n.BC_MainMenu > li.menuItem.active .dropbtn,\n.BC_MainMenu > li.menuItem.active > a {\n  font-weight: 700;\n}\n\n.BC_MainMenu > li.menuItem.hovered,\n.BC_MainMenu > li.menuItem:hover {\n  color: var(--p-action-primary);\n  background-color: white;\n}\n\n.BC_MainMenu .dropbtn {\n  display: inline-flex;\n}\n\n#menu-search-test-your-search {\n  display: flex;\n}\n\n#menu-search-test-your-search .Polaris-ActionList__Suffix {\n  margin-left: 4px;\n}\n\n.BC_MainMenu .dropbtn .Polaris-Icon svg {\n  fill: #637381;\n}\n\n.BC_MainMenu > li.menuItem.active .dropbtn .Polaris-Icon svg {\n  fill: var(--p-action-primary);\n}\n\n.BC_MainMenu > li.menuItem:hover .dropbtn .Polaris-Icon svg,\n.BC_MainMenu > li.menuItem.hovered .dropbtn .Polaris-Icon svg {\n  fill: var(--p-action-primary);\n}\n\n.BC_MainMenu .Polaris-Badge {\n  margin-left: 0.3125rem;\n}\n\n.BC_MainMenu .Polaris-Icon + .Polaris-Badge {\n  margin-left: 0;\n}\n\n.BC_MainMenu .dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.BC_MainMenu .dropdown-content {\n  display: none;\n  position: absolute;\n  background-color: #ffffff;\n  min-width: 185px;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n  top: 54px;\n  /*left: -25px;*/\n}\n\n.BC_MainMenu > li.menuItem.menu-merchandising .dropdown-content,\n.BC_MainMenu .dropdown.menu-tool .dropdown-content {\n  /*left: -10px;*/\n  min-width: 216px;\n}\n\n.BC_MainMenu > li.menuItem.menu-tool .dropdown-content {\n  right: 0;\n}\n\n.BC_MainMenu .dropdown-content a {\n  color: #212b36;\n  padding: 10px 0 10px 16px;\n  text-decoration: none;\n  display: block;\n  text-align: left;\n  border-left: solid 2px transparent;\n}\n\n.BC_MainMenu .dropdown-content a:hover {\n  background-color: rgba(223, 227, 232, 0.3);\n  border-left: solid 2px var(--p-action-primary);\n}\n\n.BC_MainMenu .dropdown-content a.active {\n  background-color: rgba(223, 227, 232, 0.3);\n  border-left: solid 2px var(--p-action-primary);\n  font-weight: 600;\n}\n\n.BC_MainMenu .dropdown:hover .dropdown-content {\n  display: block;\n}\n\n@media (min-width: 30.625em) {\n  .BC_MainMenu {\n    padding: 0 1.25rem;\n  }\n}\n\n@media (min-width: 46.5em) {\n  .BC_MainMenu {\n    padding: 0 2rem;\n  }\n}\n\n.BC-Search__WarningBannerUpgrade .Polaris-Banner p .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  max-width: 16px;\n}\n\n.BC-Search__WarningBannerUpgrade .Polaris-Banner p a {\n  color: #2c6ecb;\n  margin-right: 4px;\n}\n\n.BC-Search__WarningBannerUpgrade .Polaris-Banner p .Polaris-Icon svg {\n  fill: #2c6ecb;\n}\n\n/* New feature onboarding */\n\n.PFS-New-Feature-Onboard .Polaris-Page {\n  background: #ffffff;\n  box-shadow:\n    0px 2px 1px rgba(0, 0, 0, 0.05),\n    0px 0px 1px rgba(0, 0, 0, 0.25);\n  border-radius: 8px;\n  width: 100%;\n  max-width: 1120px;\n  height: 100%;\n  margin: 24px auto;\n  padding: unset;\n}\n\n.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content {\n  padding-top: 1px;\n}\n\n.PFS-New-Feature-Onboard--one .Polaris-Page {\n  padding: 40px;\n}\n\n/*@media (max-width: 47.9em) {\n  .Polaris-Page-Header__Title > div {\n    width: calc(100% - 0.5rem);\n  }\n}*/\n\n.PFS-New-Feature-Onboard--one .Polaris-Page .Polaris-Page__Content > div {\n  justify-content: center;\n  display: flex;\n  align-items: center;\n}\n\n.PFS-New-Feature-Onboard--one .Polaris-Page .Polaris-Page__Content .title {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 32px;\n\n  text-align: center;\n  color: #008060;\n  margin-top: 5%;\n}\n\n.PFS-New-Feature-Onboard--one .Polaris-Page .Polaris-Page__Content .subtitle {\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 28px;\n  margin-top: 12px;\n}\n\n.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .advanced-list {\n  margin-top: 32px;\n  display: grid;\n  gap: 16px;\n  align-items: center;\n}\n\n.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .advanced-list .element-advanced {\n  gap: 11px;\n  display: flex;\n}\n\n.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .advanced-list .element-advanced p {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n}\n\n.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content > div:first-child img,\n.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content > div > img {\n  max-width: 392px;\n  max-height: 160px;\n  width: auto;\n  height: auto;\n}\n\n.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .element-advanced img {\n  max-width: 24px;\n  max-height: 24px;\n}\n\n.PFS-New-Feature-Onboard--one .Polaris-Page .Polaris-Page__Content .sub-action {\n  margin-top: 32px;\n  margin-bottom: 12px;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 28px;\n}\n\n.PFS-New-Feature-Onboard--two .Polaris-Page .Polaris-Page__Content > div:first-child,\n.PFS-New-Feature-Onboard--four .Polaris-Page .Polaris-Page__Content > div:first-child {\n  margin: 24px 56px 20px;\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 32px;\n  text-align: center;\n}\n\n.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .feature-list {\n  display: inline-flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin: 0 56px;\n}\n\n.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .feature-list .feature-card {\n  display: flex;\n  align-items: flex-start;\n  padding: 16px;\n  gap: 12px;\n  margin-top: 12px;\n  max-width: 48%;\n  background: #f6f6f7;\n  border-radius: 8px;\n}\n\n.PFS-New-Feature-Onboard\n  .Polaris-Page\n  .Polaris-Page__Content\n  .feature-list\n  .feature-card\n  > div:first-child {\n  max-width: 32px;\n  max-height: 32px;\n}\n\n.PFS-New-Feature-Onboard\n  .Polaris-Page\n  .Polaris-Page__Content\n  .feature-list\n  .feature-card\n  p:first-child {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n}\n\n.PFS-New-Feature-Onboard\n  .Polaris-Page\n  .Polaris-Page__Content\n  .feature-list\n  .feature-card\n  p:last-child {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  margin-top: 6px;\n}\n\n.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .actions .step-action-circle {\n  display: inline-flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .actions .circle-active {\n  width: 10px !important;\n  height: 10px !important;\n  background: #008060 !important;\n}\n\n.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .actions .circle {\n  width: 6px;\n  height: 6px;\n  background: #c9ccd0;\n  border-radius: 50%;\n}\n\n.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .actions .circle:hover {\n  cursor: pointer;\n}\n\n.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .actions {\n  padding: 24px 56px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.PFS-New-Feature-Onboard .Polaris-Page .Polaris-Page__Content .actions .action-btn {\n  display: flex;\n  gap: 12px;\n}\n\n.PFS-New-Feature-Onboard--three .Polaris-Page .Polaris-Page__Content > div:first-child {\n  margin: 40px 56px 0;\n  font-weight: 600;\n  font-size: 28px;\n  text-align: center;\n  line-height: 32px;\n}\n\n.PFS-New-Feature-Onboard--three .Polaris-Page .Polaris-Page__Content .content-step {\n  margin: 40px 56px;\n  display: flex;\n  justify-content: space-between;\n  gap: 64px;\n}\n\n.PFS-New-Feature-Onboard--three .Polaris-Page .Polaris-Page__Content .content-step .advanced-list {\n  width: 452px;\n}\n\n.PFS-New-Feature-Onboard--three .Polaris-Page .Polaris-Page__Content .divider {\n  margin: unset;\n}\n\n.PFS-New-Feature-Onboard--three\n  .Polaris-Page\n  .Polaris-Page__Content\n  .content-step\n  > div:first-child\n  > img {\n  width: 492px;\n  max-height: 332px;\n}\n\n.PFS-New-Feature-Onboard--five .Polaris-Page {\n  padding: 40px 56px 56px;\n  text-align: center;\n}\n\n.PFS-New-Feature-Onboard--five .Polaris-Page .Polaris-Page__Content > div:first-child {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 32px;\n  color: #008060;\n}\n\n.PFS-New-Feature-Onboard--five .Polaris-Page img {\n  width: 100%;\n  height: 100%;\n  margin: 24px 0;\n}\n\n@media (max-height: 680px) {\n  .PFS-New-Feature-Onboard--five .Polaris-Page img {\n    max-height: 402px;\n  }\n}\n\n.PFS-New-Feature-Onboard--five .Polaris-Page .Polaris-Page__Content .action-last-step {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n/* Date picker */\n.datePicker .date-select .Polaris-Button {\n  padding: 0.4375rem 0.5rem;\n}\n\n.datePicker .date-select .Polaris-Button__Content {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.datePicker .date-select .Polaris-Button__Content .Polaris-Button__Icon {\n  -webkit-order: 1;\n  -ms-flex-order: 1;\n  order: 1;\n}\n\n.datePicker .date-select .Polaris-Button__Content .Polaris-Button__Text {\n  -webkit-order: 0;\n  -ms-flex-order: 0;\n  order: 0;\n  margin-top: 2px;\n}\n\n.datePicker .date-select-picker {\n  display: flex;\n  align-items: center;\n}\n\n.analytics-select-popover .Polaris-Button {\n  width: 100%;\n}\n\n.analytics-select-popover .Polaris-Button .Polaris-Button__Content {\n  justify-content: unset !important;\n}\n\n.analytics-select-popover .Polaris-Button .Polaris-Button__Content .Polaris-Button__Text {\n  width: 100%;\n  display: flex;\n  justify-content: space-between !important;\n  align-items: center;\n}\n\n.analytics-select-popover .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  margin-right: 0px;\n}\n\n.date-select .subdued-icon .Polaris-Icon svg {\n  fill: var(--p-icon-subdued);\n}\n\n/* Update Polaris component */\n.Polaris-Page,\n.Polaris-Card {\n  position: relative;\n}\n\n.Polaris-Card {\n  overflow: visible;\n}\n\n.Polaris-Layout__Section:empty,\n.Polaris-Layout__Section.empty {\n  margin: 0;\n}\n\n.Polaris-ProgressBar--sizeMedium {\n  height: 1.75rem;\n}\n\n.Polaris-ProgressBar__Indicator {\n  position: relative;\n}\n\n.Polaris-ProgressBar__Label {\n  left: 50%;\n  width: auto !important;\n  height: auto !important;\n  clip: auto !important;\n  color: white;\n  margin: 4px 5px !important;\n  clip-path: none !important;\n  transform: scaleX(calc(1 / var(--pc-progress-bar-percent)));\n}\n\n.Polaris-Modal-Header--titleHidden .Polaris-Modal-CloseButton {\n  display: none;\n}\n\n.Polaris-Tooltip__Wrapper {\n  max-height: inherit;\n}\n\n.Polaris-Tooltip__Content {\n  max-width: inherit;\n  max-height: inherit;\n}\n\n.Polaris-InlineError {\n  margin-top: 10px;\n}\n\n.BC-Page-Variants-Display .Polaris-InlineError {\n  margin-bottom: 10px;\n}\n\n.Polaris-Tabs .Polaris-Tabs__Tab:focus,\n.Polaris-Tabs__Title:after {\n  box-shadow: none !important;\n}\n\n.Polaris-Choice {\n  padding: 0;\n}\n\n.Polaris-ButtonGroup__Item {\n  margin-left: 1.25rem;\n}\n\n.Polaris-Banner__Content .Polaris-ButtonGroup__Item {\n  margin-left: 0.5rem;\n}\n\n.Polaris-InlineError .Polaris-InlineError__Icon {\n  display: none;\n}\n\n.titleMetadata {\n  display: inline-flex;\n}\n\n.title-Icon-Merchandising-Rule {\n  margin-left: 8px;\n}\n\n.titleMetadata .Polaris-Icon {\n  height: 1rem;\n  width: 1rem;\n}\n\n.titleMetadata button {\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  background: none;\n  vertical-align: middle;\n}\n\n.Polaris-Popover__PopoverOverlay {\n  z-index: 520;\n}\n\n.Polaris-Popover__Content {\n  max-width: 100% !important;\n  max-height: 32.5rem;\n}\n\n/*.Polaris-Modal-Dialog__Container .Polaris-Scrollable--vertical .Polaris-DataTable__ScrollContainer {\n  overflow-x: visible;\n}*/\n\n/* Another layout*/\n.BC-AnotherLayout .Polaris-Page {\n  max-width: 51.5625rem;\n}\n\n.BC-AnotherLayoutV3 .Polaris-Page {\n  max-width: 69.3rem;\n}\n\n.BC-AnotherLayoutV3 .Polaris-Layout__Section:empty {\n  margin-top: 0;\n}\n\n.BC-AnotherLayoutV3.V2 .Polaris-Layout__Section:first-child:empty {\n  margin-top: 10px;\n}\n\n.BC-AnotherLayoutV3 .Polaris-Layout__Section,\n.BC-AnotherLayout .Polaris-Layout__Section {\n  flex: 2 2 22.5rem;\n  margin-top: 1.5rem;\n}\n\n.BC-AnotherLayoutV3 .Polaris-Layout__Section--oneThird,\n.BC-AnotherLayout .Polaris-Layout__Section--oneThird {\n  flex: 1 1 13.75rem;\n}\n\n.BC-AnotherLayoutV3 .Polaris-Layout__Section--secondary,\n.BC-AnotherLayout .Polaris-Layout__Section--secondary {\n  flex: 1 1 16.25rem;\n}\n\n.BC-AnotherLayoutV3 .Polaris-Page-Header__RightAlign,\n.BC-AnotherLayout .Polaris-Page-Header__RightAlign {\n  align-items: center;\n}\n\n.BC-AnotherLayout .enableTAE a:visited {\n  color: var(--p-interactive);\n}\n\n.BC-Page__Installation__Option2 .Polaris-ChoiceList__Title {\n  margin-bottom: 12px;\n}\n\n.BC-Page__Installation__Option2 .Polaris-ChoiceList__Choices li:not(:first-child) {\n  margin-top: 12px;\n}\n\n/* Another layout v3*/\n\n.BC-AnotherLayoutV3\n  .BC-Page__FirstColumn\n  .Polaris-Layout__Section:first-child:empty\n  + .Polaris-Layout__Section:nth-child(2) {\n  margin-top: 14px;\n}\n\n.BC-AnotherLayoutV3\n  .BC-Page__FirstColumn\n  .Polaris-Layout__Section:first-child:empty\n  + .Polaris-Layout__Section:nth-child(2):empty\n  + .Polaris-Layout__Section:nth-child(3) {\n  margin-top: 0px;\n}\n\n/* install page */\n.text-installation,\n.preview-not-available {\n  color: #637381;\n}\n\n.Polaris-Card .select-layout-button {\n  margin-top: 1.25rem;\n}\n\n/*@media (max-width: 47.9em) {\n  .Polaris-Page-Header__Title > div {\n    width: calc(100% - 0.5rem);\n  }\n}*/\n\n/* Slideshow */\n\n.carousel .slide {\n  background-color: transparent;\n}\n\n.migration-slideshow,\n.slideshow {\n  margin: 0.25rem 1.25rem;\n}\n\n/*.carousel .control-prev.control-arrow:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg width='17' height='30' viewBox='0 0 17 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.585786 13.5858C-0.195262 14.3668 -0.195262 15.6332 0.585786 16.4142L13.3137 29.1421C14.0948 29.9232 15.3611 29.9232 16.1421 29.1421C16.9232 28.3611 16.9232 27.0948 16.1421 26.3137L4.82843 15L16.1421 3.68629C16.9232 2.90524 16.9232 1.63891 16.1421 0.857865C15.3611 0.0768166 14.0948 0.0768164 13.3137 0.857865L0.585786 13.5858ZM4.5 13L2 13L2 17L4.5 17L4.5 13Z' fill='%23C4CDD5' fill-opacity='0.5'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  border: none;\n  width: 30px;\n  height: 30px;\n}\n\n.carousel .control-next.control-arrow:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg width='18' height='30' viewBox='0 0 18 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.9142 13.5858C17.6953 14.3668 17.6953 15.6332 16.9142 16.4142L4.18629 29.1421C3.40524 29.9232 2.13891 29.9232 1.35787 29.1421C0.576817 28.3611 0.576817 27.0948 1.35787 26.3137L12.6716 15L1.35786 3.68629C0.576815 2.90524 0.576814 1.63891 1.35786 0.857865C2.13891 0.0768166 3.40524 0.0768164 4.18629 0.857865L16.9142 13.5858ZM13 13L15.5 13L15.5 17L13 17L13 13Z' fill='%23C4CDD5' fill-opacity='0.5'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  border: none;\n  width: 30px;\n  height: 30px;\n}\n\n.slideshow .carousel.carousel-slider:hover .control-arrow {\n  background: none;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n*/\n\n.migration-slideshow .carousel .control-dots .dot,\n.slideshow .carousel .control-dots .dot {\n  background-color: #c4cdd5;\n  width: 6px;\n  height: 6px;\n  box-shadow: none;\n  margin: 0 6px;\n}\n\n.slideshow .carousel .control-dots .dot:first-child {\n  display: none;\n}\n\n.carousel .control-dots .dot:focus {\n  outline: none;\n}\n\n.carousel .control-dots .dot.selected {\n  background-color: var(--p-action-primary);\n}\n\n/*.slideshow .carousel ul.slider {\n  height: auto !important;\n}\n\n.slideshow .carousel ul.slider,\n.slideshow .carousel .slider-wrapper {\n  height: auto !important;\n}*/\n\n.migration-slideshow .carousel .slide,\n.slideshow .carousel .slide {\n  max-height: 1px;\n}\n\n.migration-slideshow .carousel .slide.selected,\n.slideshow .carousel .slide.selected {\n  max-height: 100%;\n}\n\n.migration-slideshow .carousel .slide img,\n.slideshow .carousel .slide img {\n  width: 372px;\n  max-width: 100%;\n}\n\n.migration-slideshow .slideshow-button,\n.slideshow .slideshow-button {\n  margin: 1.5rem 2.5rem 0 2.5rem;\n  text-align: center;\n}\n\n.migration-slideshow .slideshow-button button,\n.slideshow .slideshow-button button {\n  min-width: 6.75rem;\n}\n\n.migration-slideshow .slideshow-image-content,\n.slideshow .slideshow-image-content {\n  margin: 2.875rem 2.5rem 0 2.5rem;\n}\n\n.migration-slideshow .carousel .control-dots,\n.slideshow .carousel .control-dots {\n  top: 265px;\n  padding-left: 0;\n}\n\n.migration-slideshow .content-line,\n.slideshow .content-line {\n  display: block;\n}\n\n@media (max-width: 514px) {\n  .migration-slideshow .carousel .slide img,\n  .slideshow .carousel .slide img {\n    width: 260px;\n  }\n\n  .migration-slideshow .carousel .control-dots,\n  .slideshow .carousel .control-dots {\n    top: 200px;\n  }\n\n  .migration-slideshow .content-line,\n  .slideshow .content-line {\n    display: inline;\n  }\n\n  .migration-slideshow .slideshow-button,\n  .slideshow .slideshow-button {\n    margin: 1.5rem 0 0 0;\n  }\n\n  .migration-slideshow .slideshow-image-content,\n  .slideshow .slideshow-image-content {\n    margin: 2.875rem 0 0 0;\n  }\n}\n\n/** progress step **/\n/* .step-progress-initializing {\n  position: absolute;\n  top: 45px;\n  right: -15px;\n} */\n\n.step-progress-container {\n  width: 240px;\n}\n\n/* @media (max-width: 47.9em) {\n  .step-progress-initializing {\n    position: static;\n    margin: 0.625rem 0 0 -2.8125rem;\n    max-width: calc(100% + 5.625rem);\n  }\n} */\n\n.step-progress-container ul {\n  margin: 0;\n  padding: 0;\n}\n\n.step-progress-container .progressbar li {\n  list-style-type: none;\n  width: 31%;\n  float: left;\n  font-size: 0;\n  position: relative;\n  text-align: center;\n  color: #c4cdd5;\n  line-height: 1;\n}\n\n.step-progress-container .progressbar li:first-child {\n  width: 6%;\n}\n\n.step-progress-container .progressbar li:before {\n  width: 15px;\n  height: 15px;\n  content: '';\n  color: white;\n  font-size: 16px;\n  line-height: 12px;\n  border: 1px solid #c4cdd5;\n  display: block;\n  text-align: center;\n  margin: 0 auto 10px auto;\n  border-radius: 50%;\n  background-color: white;\n  margin-bottom: 0;\n  margin-right: 0;\n}\n\n.step-progress-container .progressbar li:after {\n  width: 61px;\n  height: 1px;\n  content: '';\n  position: absolute;\n  background-color: #c4cdd5;\n  top: 7px;\n  left: 0;\n  z-index: 1;\n}\n\n.step-progress-container .progressbar li:first-child:after {\n  content: none;\n}\n\n.step-progress-container .progressbar li.active {\n  color: var(--p-action-primary);\n}\n\n.step-progress-container .progressbar li.active:before {\n  border-color: var(--p-action-primary);\n  background-color: var(--p-action-primary);\n  content: '\\2713';\n  font-size: 0.625rem;\n  font-weight: 900;\n}\n\n.step-progress-container .progressbar li.active.activating:before {\n  content: '';\n}\n\n.step-progress-container .progressbar li.active:not(.activating) + li:after {\n  background-color: var(--p-action-primary);\n}\n\n.step-progress-upgrade .step-progress-container .progressbar li:after {\n  width: 85px;\n}\n\n.step-progress-upgrade .step-progress-container {\n  width: 300px;\n}\n\n.step-progress-upgrade .step-progress-container .progressbar li {\n  width: 33%;\n}\n\n.step-progress-initializing .step-progress-container {\n  width: 300px;\n}\n\n.step-progress-initializing .step-progress-container .progressbar li {\n  width: 20%;\n}\n\n.step-progress-initializing .progressbar li:after {\n  width: 45px;\n}\n\n@media (max-width: 47.9em) {\n  .step-progress-upgrade {\n    position: static;\n    margin: 0.625rem 0 0 -2.8125rem;\n    max-width: calc(100% + 5.625rem);\n  }\n}\n\n.step-progress-setup {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n}\n\n/* @media (max-width: 47.9em) {\n  .step-progress-setup {\n    position: static;\n    margin: 0.625rem 0 0 -2.8125rem;\n    max-width: calc(100% + 5.625rem);\n  }\n} */\n\n.step-progress-setup .step-progress-container {\n  width: 176px;\n}\n\n.step-progress-setup .step-progress-container .progressbar {\n  counter-reset: step;\n}\n\n.step-progress-setup .step-progress-container .progressbar li {\n  width: calc(100% / 2);\n}\n\n.step-progress-setup .step-progress-container .progressbar li:before {\n  content: counter(step);\n  counter-increment: step;\n  width: 24px;\n  height: 24px;\n  font-size: 0.875rem;\n  padding-top: 5px;\n  font-weight: 600;\n  color: #c4cdd5;\n}\n\n.step-progress-setup .step-progress-container .progressbar li.active.activating:before {\n  content: counter(step);\n  counter-increment: step;\n}\n\n.step-progress-setup .step-progress-container .progressbar li.active:before {\n  content: '\\2713';\n  color: white;\n}\n\n.step-progress-setup .step-progress-container .progressbar li:after {\n  top: 12px;\n  width: 64px;\n}\n\n/* Custom package\n*/\n.BC-Select__ValueContainer {\n  flex: 1 1 0%;\n}\n\n.BC-Select__ValueContainerInner {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.BC-Illustration-Image__Notification {\n  width: 100%;\n}\n\n.BC-Benefit_Referral_Image {\n  width: 100%;\n  cursor: pointer;\n}\n\n/*\n  Custom css Dashboard\n */\n.BC-Page__Dashboard .Polaris-Card__Header,\n.BC-Page__FilterTree-Item .Polaris-Card__Header,\n.BC-Page__FilterTree-Management .Polaris-Card__Header,\n.BC-Page__Theme-Setup .Polaris-Card__Header,\n.BC-Page__Merge-Value .Polaris-Card__Header,\n.BC-Page__SuggestionDictionary .Polaris-Card__Header,\n.BC-Page__Synonym .Polaris-Card__Header,\n.BC-Page__ProductRanking .Polaris-Card__Header,\n.BC-Page__Merchandising .Polaris-Card__Header,\n.BC-Page__Merchandising-Rule .Polaris-Card__Header,\n.BC-Page__Metafield .Polaris-Card__Header,\n.BC-Page__Product-Visibility .Polaris-Card__Header,\n.BC-Page__Q1-Beta-Features .Polaris-Card__Header,\n.BC-OnboardingChecklist__OnPage .Polaris-Card__Header,\n.BC-OnboardingChecklist__OnSetupPage .Polaris-Card__Header,\n.BC-BC-Page__MerchandisingV2 .Polaris-Card__Header,\n.BC-Page__Sync .Polaris-Card__Header,\n.BC-Page__ShopifyIntegration .Polaris-Card__Header,\n.BC-Page__CustomSorting .Polaris-Card__Header,\n.BC-Page__Language-Setting .Polaris-Card__Header,\n.BC-Page__RecommendationNewWidgetItem .Polaris-Card__Header,\n.BC-Page__RecommendationWidgetItem .Polaris-Card__Header,\n.BC-Page__SearchAnalytics__SearchTerms .Polaris-Card__Header,\n.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-Card__Header,\n.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-Card__Header,\n.BC-Page__SearchAnalytics__SearchesWithoutResults .Polaris-Card__Header,\n.BC-Page__SearchAnalytics__ProductPerformance .Polaris-Card__Header,\n.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-Card__Header,\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-Card__Header,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-Card__Header,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-Card__Header,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-Card__Header,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-Card__Header,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-Card__Header,\n.BC-Page__Language-Setting .Polaris-Card__Header,\n.BC-Page__Language-Setting .Polaris-Card__Header,\n.BC-Page__SubscriptionV3 .Polaris-Card__Header {\n  padding-bottom: 1rem;\n  padding-top: 1rem;\n  border-bottom: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page__Merge-Value .Polaris-Card__Section {\n  padding-top: 20px;\n}\n\n.BC-Page__Dashboard .BC-Paragraph__Dashboard {\n  line-height: 1.5rem;\n}\n\n.BC-Page__Dashboard .BC-Iframe-Container__Wrapper {\n  display: flex;\n  justify-content: center;\n}\n\n.BC-Page__Dashboard .BC-Iframe-Container__Center {\n  width: 70%;\n}\n\n.BC-Iframe-Container {\n  position: relative;\n  width: 100%;\n  padding-bottom: 56.25%;\n  height: 0;\n}\n\n.BC-Iframe-Container img {\n  cursor: pointer;\n}\n\n.BC-Iframe-Container img:focus {\n  cursor: pointed;\n}\n\n.BC-Page\n  .Polaris-Page\n  > div:not(.Polaris-Page-Header)\n  > .Polaris-Layout\n  > .Polaris-Layout__Section:not(:first-child) {\n  margin-top: 0;\n}\n\n.BC-Welcome__Dashboard {\n  margin-bottom: -1.5rem;\n}\n\n.BC-Welcome__Dashboard .Polaris-Layout {\n  align-items: flex-end;\n}\n\n.BC-Welcome__Dashboard button {\n  margin-top: 0.5625rem;\n  margin-bottom: 1.25rem;\n  width: fit-content;\n}\n\n.BC-Welcome__Dashboard img {\n  width: 243px;\n  margin-left: auto;\n}\n\n.BC-Welcome__Dashboard .Polaris-DisplayText--sizeSmall {\n  font-size: 1.125rem;\n}\n\n.BC-Welcome__Image {\n  width: 243px;\n  max-width: 100%;\n}\n\n.BC-Iframe-Container iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.BC-Feedback-Card__Dashboard .Polaris-Card {\n  background-color: transparent;\n}\n\n.BC-Button-Notice .Polaris-ButtonGroup__Item,\n.BC-Feedback-Card__Dashboard .Polaris-ButtonGroup__Item {\n  margin-left: 0.5rem;\n}\n\n.BC-Button-Notice .Polaris-Caption {\n  color: var(--p-text-subdued);\n}\n\n.BC-Illustration-Image__Dashboard {\n  display: none;\n}\n\n.BC-Illustration-Image__Dashboard > div {\n  margin: auto;\n}\n\n.menuBox .Polaris-Card__Section {\n  padding: 1rem;\n}\n\n.BC-Page__Dashboard .menuBox .Polaris-Card,\n.BC-Page__Dashboard .menuBox .Polaris-Card-Hover {\n  box-shadow: none;\n}\n\n.BC-Menu__Dashboard .Polaris-Layout,\n.BC-Menu__Dashboard .Polaris-Layout__Section--secondary,\n.BC-HelpCenter__Dashboard .Polaris-Layout,\n.BC-HelpCenter__Dashboard .Polaris-Layout__Section--secondary {\n  margin: 0;\n}\n\n.BC-Review__Dashboard .Polaris-Layout__Section,\n.BC-Email__Dashboard .Polaris-Layout__Section,\n.BC-SyncHookStatus__Dashboard .Polaris-Layout__Section,\n.BC-Feedback__Dashboard .Polaris-Layout__Section,\n.BC-Sync__Content .Polaris-Layout__Section {\n  flex: 2 2 28.75rem;\n}\n\n.BC-Review__Dashboard .Polaris-Layout__Section .Polaris-TextContainer,\n.BC-Email__Dashboard .Polaris-Layout__Section .Polaris-TextContainer,\n.BC-SyncHookStatus__Dashboard .Polaris-Layout__Section .Polaris-TextContainer,\n.BC-Feedback__Dashboard .Polaris-Layout__Section .Polaris-TextContainer {\n  margin-right: -1.25rem;\n}\n\n.BC-Review__Dashboard .Polaris-Layout__Section--secondary,\n.BC-Email__Dashboard .Polaris-Layout__Section--secondary,\n.BC-SyncHookStatus__Dashboard .Polaris-Layout__Section--secondary,\n.BC-Feedback__Dashboard .Polaris-Layout__Section--secondary {\n  flex: 1 1 15rem;\n  text-align: right;\n  padding-right: 25px;\n}\n\n.BC-Sync__Content .Polaris-Layout__Section--secondary {\n  flex: 0 1 15rem;\n  text-align: right;\n}\n\n.BC-Review__Dashboard .BC-Illustration-Image__Dashboard img,\n.BC-SyncHookStatus__Dashboard .BC-Illustration-Image__Dashboard img,\n.BC-Feedback__Dashboard .BC-Illustration-Image__Dashboard img,\n.BC-Sync__Content .BC-Illustration-Image__Dashboard img,\n.BC-Merchandising__TryNewVersion .BC-Illustration-Image__Dashboard img {\n  width: 150px;\n  max-width: 100%;\n}\n\n.BC-Email__Dashboard .BC-Illustration-Image__Dashboard img {\n  width: 52%;\n}\n\n.BC-Email__Dashboard .Polaris-Layout__Section .Polaris-FormLayout .Polaris-FormLayout__Item {\n  max-width: none;\n}\n\n.BC-Email__Dashboard .Polaris-Layout__Section .Polaris-FormLayout {\n  width: 118%;\n}\n\n.BC-Language-Setting__Content .BC-Illustration-Image__Dashboard img {\n  max-width: 265px;\n}\n\n.BC-SyncHookStatus__Dashboard .Polaris-Card__Header .tooltip,\n.BC-Sync__Content .Polaris-Card__Header .tooltip {\n  margin-top: 7px;\n}\n\n.BC-SyncHookStatus__Dashboard .recent-sync {\n  margin-top: 12px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.BC-SyncHookStatus__Dashboard .completed-icon {\n  width: 14px;\n  height: 14px;\n  display: block;\n  margin-right: 0.3125rem;\n  padding: 0;\n}\n\n.BC-SyncHookStatus__Dashboard .Polaris-Layout__Section {\n  margin-top: 1.25rem;\n}\n\n.BC-KnowledgeBase__Dashboard .Polaris-Layout__Section--oneThird:not(:first-child) {\n  margin-left: 0.875rem;\n}\n\na.BC-Link__Dashboard {\n  text-decoration: none;\n}\n\n.BC-Link__Dashboard:hover .menuContent > *:first-child {\n  color: var(--p-interactive-hovered);\n}\n\n.BC-ThemeSetup__DashboardV3 .Polaris-CalloutCard__Image,\n.BC-CalloutCard-ThemeSetup__Dashboard .Polaris-CalloutCard__Image,\n.BC-CalloutCard-ExpReviewRating__Dashboard .Polaris-CalloutCard__Image {\n  width: auto;\n}\n\n.BC-ThemeSetup__DashboardV3 .Polaris-Card__Section,\n.BC-CalloutCard-ThemeSetup__Dashboard .Polaris-Card__Section {\n  margin: auto;\n}\n\n.BC-CalloutCard-ExpReviewRating__Dashboard .Polaris-Card__Section {\n  padding: 1rem 1.25rem;\n}\n\n.BC-ThemeSetup__DashboardV3 .layoutCols,\n.BC-CalloutCard-ThemeSetup__Dashboard .layoutCols {\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n}\n\n.BC-CalloutCard-ExpReviewRating__Dashboard .layoutCols {\n  width: 242px;\n  display: flex;\n}\n\n.BC-CalloutCard-ExpReviewRating__Dashboard .layoutCols.submitted {\n  padding-top: 0.75rem;\n}\n\n.BC-CalloutCard-ExpReviewRating__Dashboard .layoutCols.lowRating {\n  width: 332px;\n  display: flex;\n}\n\n.BC-CalloutCard-ThemeSetup__Dashboard .Polaris-TextStyle--variationStrong,\n.BC-CalloutCard-ExpReviewRating__Dashboard .Polaris-TextStyle--variationStrong {\n  font-weight: 500;\n  font-size: 0.9375rem;\n  line-height: 1.25rem;\n}\n\n.BC-CalloutCard-ThemeSetup__Dashboard .theme-status-text,\n.BC-CalloutCard-ExpReviewRating__Dashboard .theme-status-text {\n  font-weight: 600;\n  margin-bottom: auto;\n}\n\n.BC-Page__Dashboard .knowledgeBox .Polaris-Card__Section {\n  padding: 0.75rem 1rem 1rem;\n  min-height: 3.75rem;\n}\n\n.knowledgeBox button {\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  background: white;\n}\n\n.knowledgeBox .Polaris-Caption {\n  text-align: left;\n}\n\n.BC-Page__Dashboard .menuIconImg {\n  float: left;\n  padding: 10px;\n  background-color: #f4f6f8;\n}\n\n.BC-Page__Dashboard .menuIconImg.hover {\n  background-color: var(--p-divider);\n}\n\n.BC-Page__Dashboard .menuContent {\n  display: grid;\n  padding-left: 1.25rem;\n}\n\n.BC-Page__Dashboard .BC-HelpCenter__Dashboard .menuContent {\n  padding-left: 0.5rem;\n}\n\n.BC-Page__Dashboard .BC-HelpCenter__Dashboard .Polaris-Layout .Polaris-Layout__Section {\n  margin-left: 0;\n}\n\n.BC-Page__Dashboard .BC-HelpCenter__Dashboard .Polaris-Layout .Polaris-Layout__Section:last-child {\n  margin-right: 0.375rem;\n}\n\n.BC-Page__Dashboard .BC-HelpCenter__Dashboard .Polaris-Layout .Polaris-Card__Section {\n  padding: 1rem;\n  padding-right: 0;\n}\n\n.BC-Page__Dashboard .menuContent .Polaris-TextStyle--variationStrong {\n  color: var(--p-interactive);\n}\n\n.BC-Page__Dashboard .guideBox img {\n  width: 100%;\n}\n\n.BC-Page__Dashboard .guideBox .Polaris-TextStyle--variationStrong {\n  padding: 0.625rem;\n  display: inline-block;\n  margin-top: -5px;\n}\n\n.BC-CalloutCard-Subscription__Dashboard {\n  text-align: center;\n}\n\n.BC-CalloutCard-Subscription__Dashboard .Polaris-Card {\n  display: flex;\n}\n\n.BC-CalloutCard-Subscription__Dashboard .Polaris-Card .Polaris-Card__Section {\n  padding-top: 0;\n  padding-bottom: 0;\n  margin: auto;\n}\n\n.BC-CalloutCard-Subscription__Dashboard .Polaris-Badge {\n  padding: 0 1.25rem;\n  margin-top: 6px;\n}\n\n.BC-CalloutCard-Subscription__Dashboard .Polaris-Button {\n  margin-top: 0;\n}\n\n.BC-CalloutCard-Subscription__Dashboard p {\n  margin: 8px 0;\n}\n\n.BC-CalloutCard-Subscription__Dashboard .subscribe__bottom .upgrade {\n  padding: 0 1.125rem;\n}\n\n.BC-Page__Dashboard .knowledgeBox .guide {\n  text-align: left;\n  color: #212b36;\n}\n\n/* Custom style notification */\n/* Class exceededPlanNotice is getting from notification in DB */\n/* .BC-Page__Dashboard .notification:not(:first-child) {\n  margin-top: 1.25rem;\n} */\n\n.BC-Page__Dashboard .notification.exceededPlanNotice .Polaris-Banner__SecondaryAction {\n  color: var(--p-interactive);\n  font-weight: 600;\n}\n\n.BC-Page__Dashboard .notification.exceededPlanNotice .Polaris-Banner__Text::after {\n  border: none;\n}\n\n/*-------Dashboard v3------------*/\n\n.BC-Page__DashboardV3 .Polaris-Page__Content {\n  display: inline-flex;\n  width: 100%;\n  padding-top: 12px;\n}\n\n.BC-Page__DashboardV3 .BC-Page__FirstColumn {\n  width: 72%;\n  height: 100%;\n}\n\n.BC-Page__DashboardV3 .BC-Page__SecondColumn {\n  width: 28%;\n  height: 100%;\n}\n\n.BC-Page__DashboardV3 .BC-Page__FirstColumn .Polaris-Layout {\n  padding-right: calc(var(--p-space-5) * 1) !important;\n}\n\n.BC-Page__DashboardV3 .notification .BC-Notification_Dismiss {\n  position: absolute;\n  right: 20px;\n  color: #6d7175;\n  cursor: pointer;\n}\n\n.BC-Page__DashboardV3\n  .notification\n  .BC-Notification_Dismiss.BC-Notification_Dismiss_WithoutActionButton {\n  bottom: 55px;\n}\n\n.BC-Page__DashboardV3\n  .BC-Notifications_DashboardV3\n  .notification-item\n  .BC-Notification_Dismiss.BC-Notification_Dismiss_WithoutActionButton {\n  bottom: 25px;\n}\n\n.BC-Page__DashboardV3 .notification .BC-Notification_Dismiss_WithActionButton {\n  bottom: 65px;\n}\n\n.BC-Page__DashboardV3\n  .BC-Notifications_DashboardV3\n  .notification-item\n  .BC-Notification_Dismiss_WithActionButton {\n  bottom: 35px;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .Polaris-Heading,\n.BC-RecommendedApps__DashboardV3 .Polaris-Heading,\n.BC-QuickStartGuide__DashboardV3 .Polaris-Heading .BC-SyncHookStatus__DashboardV3 .Polaris-Heading,\n.BC-ChangeLogs__Dashboard .Polaris-Heading,\n.BC-Subscription__DashboardV3 .Polaris-Heading,\n.BC-ThemeSetup__DashboardV3 .Polaris-Heading,\n.BC-OptionInEmail__DashboardV3 .option-email-content .Polaris-Heading,\n.BC-Support-Feature__DashboardV3 .section .Polaris-Heading,\n.BC-AppInsight__DashboardV3 .Polaris-Heading {\n  font-size: 20px;\n  line-height: 28px;\n}\n\n.BC-OptionInEmail__DashboardV3 .option-email-content > p,\n.BC-Support-Feature__DashboardV3 .section > p {\n  margin-top: 8px;\n  color: #6d7175;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.BC-Welcome__DashboardV3 .Polaris-DisplayText--sizeSmall {\n  font-size: 16px;\n  line-height: 24px;\n  margin-top: 8px;\n}\n\n.BC-Welcome__DashboardV3 .Polaris-Layout {\n  display: inherit;\n}\n\n.BC-Notifications_DashboardV3 {\n  width: 100%;\n  height: auto;\n}\n\n.small-screen {\n  margin-top: -30px;\n}\n\n.BC-Notifications_DashboardV3 .notification .Polaris-Banner .Polaris-Banner__ContentWrapper {\n  margin-bottom: 40px;\n}\n\n.BC-Notifications_DashboardV3 .notification-item .Polaris-Banner .Polaris-Banner__ContentWrapper {\n  margin-bottom: 0px;\n}\n\n.BC-Notifications_DashboardV3 .notification {\n  width: 100%;\n  height: auto;\n}\n\n.BC-Notifications_DashboardV3 .notification .link-add-new a {\n  color: #202223;\n}\n\n.BC-Notifications_DashboardV3 .BC-Carousel {\n  position: relative;\n  height: auto;\n}\n\n.BC-Notifications_DashboardV3 .BC-Carousel .carousel-controls {\n  position: absolute;\n  bottom: 20px;\n  left: 45px;\n}\n\n.BC-Notifications_DashboardV3 .carousel-item {\n  width: 100%;\n  height: fit-content;\n}\n\n.BC-Notifications_DashboardV4 .Polaris-Card__Section {\n  padding: 16px;\n}\n\n.BC-Notifications_DashboardV4 .Polaris-Card__Section .carousel-cards {\n  margin-bottom: 0;\n}\n\n.BC-Notifications_DashboardV4 .Polaris-Card__Section .carousel-item {\n  width: 100%;\n  padding-left: 1px;\n}\n\n/* installation status */\n.BC-InstallationStatus__Dashboard {\n  display: flex;\n  padding: 20px;\n  gap: 10px;\n  background: #f1f8f5;\n  border: 1px solid #95c9b4;\n  border-radius: 8px;\n}\n\n.BC-InstallationStatus__Popup {\n  display: flex;\n  padding: 20px;\n  gap: 10px;\n  background: #fff;\n  border-radius: 8px;\n  position: fixed;\n  width: 360px;\n  bottom: 180px;\n  right: 40px;\n  z-index: 521;\n  box-shadow:\n    0 26px 80px 0 rgba(0, 0, 0, 0.2),\n    0 0 2px 0 rgba(0, 0, 0, 0.2);\n}\n\n.BC-InstallationStatus__Popup .icon-status,\n.BC-InstallationStatus__Dashboard .icon-status {\n  margin-top: 4px;\n}\n\n.BC-InstallationStatus__Popup .info-status .Polaris-Icon,\n.BC-InstallationStatus__Dashboard .info-status .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  width: 1rem;\n  height: 1.2rem;\n  margin-left: 4px;\n}\n\n.BC-InstallationStatus__Popup .info-status .action-list a,\n.BC-InstallationStatus__Popup .info-status a,\n.BC-InstallationStatus__Dashboard .info-status .action-list a,\n.BC-InstallationStatus__Dashboard .info-status a {\n  color: #2c6ecb !important;\n}\n\n.BC-InstallationStatus__Popup .info-status .action-list a,\n.BC-InstallationStatus__Dashboard .info-status .action-list a {\n  margin-left: 4px;\n}\n\n.BC-InstallationStatus__Popup .info-status .action-list > p,\n.BC-InstallationStatus__Dashboard .info-status .action-list > p {\n  color: #6d7175;\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n}\n\n.BC-InstallationStatus__Popup .info-status .action-list .Polaris-Icon svg,\n.BC-InstallationStatus__Popup .info-status .content .Polaris-Icon svg,\n.BC-InstallationStatus__Dashboard .info-status .action-list .Polaris-Icon svg,\n.BC-InstallationStatus__Dashboard .info-status .content .Polaris-Icon svg {\n  fill: #2c6ecb;\n}\n\n.BC-InstallationStatus__Popup .info-status > div:first-child,\n.BC-InstallationStatus__Dashboard .info-status > div:first-child {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n  color: #008060;\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-InstallationStatus__Popup .info-status .content {\n  display: grid;\n  gap: 20px;\n  margin: 10px 30px 20px 0;\n}\n\n.BC-InstallationStatus__Dashboard .info-status .content {\n  display: grid;\n  gap: 20px;\n  margin: 10px 0 20px 0;\n}\n\n.BC-InstallationStatus__Popup .info-status .action-list,\n.BC-InstallationStatus__Dashboard .info-status .action-list {\n  display: flex;\n  gap: 10px;\n}\n\n.BC-InstallationStatus__ChildPage {\n  display: flex;\n  padding: 10px;\n  gap: 10px;\n  background: #f1f8f5;\n  border: 1px solid #95c9b4;\n  border-radius: 6px;\n}\n\n.BC-InstallationStatus__ChildPage .icon-status {\n  margin-top: 5px;\n}\n\n.BC-InstallationStatus__ChildPage .info-status .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  width: 1rem;\n  height: 1.2rem;\n  margin-left: 4px;\n}\n\n.BC-InstallationStatus__ChildPage .info-status > div:first-child {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 28px;\n  color: #008060;\n  display: flex;\n  justify-content: space-between;\n}\n\n/* =============== */\n\n.BC-SendRequestReport__Form .Polaris-FormLayout__Item:first-child {\n  padding-top: 20px;\n}\n\n.BC-SendRequestReport__Form\n  .Polaris-FormLayout__Item\n  .Polaris-ChoiceList\n  .Polaris-ChoiceList__Choices {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-top: 12px;\n}\n\n/* quick start guide */\n.BC-QuickStartGuide__DashboardV3 .heading {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 17px;\n}\n\n.BC-QuickStartGuide__DashboardV3 .progress-bar {\n  display: flex;\n  gap: 7px;\n  align-items: center;\n}\n\n.BC-QuickStartGuide__DashboardV3 .progress-bar .progress {\n  width: 100%;\n}\n\n.BC-QuickStartGuide__DashboardV3 .progress-bar .progress .Polaris-ProgressBar--colorCritical {\n  --pc-progress-bar-background: var(--p-surface-neutral);\n  --pc-progress-bar-indicator: #b98900;\n}\n\n.BC-QuickStartGuide__DashboardV3 .progress-bar > p {\n  min-width: 94px;\n}\n\n.BC-QuickStartGuide__DashboardV3 .detail-guide {\n  display: flex;\n  gap: 9px;\n  margin-bottom: 20px;\n  margin-top: 8px;\n}\n\n.BC-QuickStartGuide__DashboardV3 .detail-guide img,\n.BC-QuickStartGuide__DashboardV3 .detail-guide .Polaris-Icon {\n  margin-top: 4px;\n  min-width: 18px;\n  min-height: 18px;\n}\n\n.BC-QuickStartGuide__DashboardV3 .detail-guide .content p,\n.BC-QuickStartGuide__DashboardV3 .sub-action {\n  color: #6d7175;\n}\n\n.BC-QuickStartGuide__DashboardV3 .sub-action {\n  min-width: 31px;\n  min-height: 22px;\n  display: flex;\n}\n\n.BC-QuickStartGuide__DashboardV3 .sub-action:hover {\n  cursor: pointer;\n  color: #4e5053;\n}\n\n.BC-QuickStartGuide__DashboardV3 .detail-guide .content .Polaris-TextStyle--variationStrong {\n  margin-bottom: 4px;\n}\n\n.BC-QuickStartGuide__DashboardV3 .action-list {\n  display: flex;\n  gap: 30px;\n  align-items: center;\n}\n\n/* banners marketing */\n.BC-CampaignCarousel__DashboardV3 {\n  height: 100%;\n  position: relative;\n}\n\n.BC-CampaignCarousel__DashboardV3 .BC-Carousel {\n  position: relative;\n}\n\n.BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-item {\n  width: 100%;\n  border-radius: 8px;\n  background-repeat: no-repeat !important;\n  background-position: left top !important;\n  background-size: 100% !important;\n  position: relative;\n}\n\n.BC-CampaignCarousel__DashboardV3 .carousel-item.carousel-item-custom-freemium .banner {\n  padding: 10px 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 6px;\n}\n\n.BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-item.carousel-item-custom-freemium > div {\n  width: 100%;\n  height: 100%;\n  background-position: right;\n  background-size: 320px 130px;\n  background-repeat: no-repeat;\n  padding: 20px 10px;\n}\n\n.BC-CampaignCarousel__DashboardV3\n  .BC-Carousel\n  .carousel-item.carousel-item-custom-freemium\n  .action {\n  display: flex;\n  align-items: center;\n}\n\n.BC-CampaignCarousel__DashboardV3\n  .BC-Carousel\n  .carousel-item.carousel-item-custom-freemium\n  .action\n  .Polaris-Button {\n  position: unset !important;\n  background: var(--decorative-surface-one, #ffc96b);\n  font-weight: 500;\n  margin-right: 0.75rem;\n  align-items: center;\n  border: unset;\n}\n\n.BC-CampaignCarousel__DashboardV3\n  .BC-Carousel\n  .carousel-item.carousel-item-custom-freemium\n  .action\n  .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.BC-CampaignCarousel__DashboardV3 .carousel-item.carousel-item-custom-freemium .banner > span {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n  letter-spacing: 0px;\n}\n\n.BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-item > div {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  padding: 30px 20px 10px 10px;\n}\n\n.BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-item .Polaris-Button {\n  position: absolute;\n  right: 20px;\n  top: 15px;\n}\n\n.BC-CampaignCarousel__DashboardV3 .Polaris-Button--plain.Polaris-Button--iconOnly svg:hover,\n.BC-CampaignCarousel__DashboardV3 .Polaris-Button--plain.Polaris-Button--iconOnly svg {\n  fill: white;\n}\n\n.BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-controls {\n  justify-content: center;\n  position: absolute;\n  width: 100%;\n  bottom: 10px;\n}\n\n.BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-cards {\n  margin: 0 !important;\n  min-height: 130px;\n}\n\n@media (max-width: 1040px) {\n  .BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-cards {\n    min-height: 127px;\n  }\n}\n\n@media (max-width: 1040px) {\n  .BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-cards {\n    min-height: 127px;\n  }\n}\n\n@media (max-width: 980px) {\n  .BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-cards {\n    min-height: 119px;\n  }\n}\n\n@media (max-width: 820px) {\n  .BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-cards {\n    min-height: 111px;\n  }\n}\n\n.BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-controls .carousel-pagination--active div {\n  width: 10px;\n  height: 10px;\n}\n\n.BC-CampaignCarousel__DashboardV3 .BC-Carousel .banner {\n  width: 100%;\n  height: 100%;\n}\n\n.BC-CampaignCarousel__DashboardV3 .BC-Carousel .banner:hover,\n.BC-CampaignBanner__DashboardV4:hover {\n  cursor: pointer;\n}\n\n.BC-CampaignBanner__DashboardV4 {\n  display: flex;\n  align-items: center;\n  position: relative;\n  box-shadow:\n    0px 0px 1px 0px #00000040,\n    0px 2px 1px 0px #0000000d;\n  border-radius: 8px;\n  background-color: #fff;\n}\n\n.BC-CampaignBanner__DashboardV4 .close {\n  cursor: pointer;\n  position: absolute;\n  top: 16px;\n  right: 14px;\n}\n\n.BC-CampaignBanner__DashboardV4__Content {\n  padding: 24px 20px;\n}\n\n.BC-ChangeLogs__Dashboard .BC-ChangeLogs__Dashboard__ChangelogWrapper {\n  max-height: 280px;\n  overflow-y: auto;\n}\n\n.BC-ChangeLogs__Dashboard .btn-view-all .Polaris-Button {\n  padding: 0;\n}\n\n.BC-ChangeLogs__Dashboard .btn-view-all .Polaris-Button .Polaris-Button__Text {\n  width: 100%;\n  display: block;\n}\n\n.BC-ChangeLogs__Dashboard .btn-view-all .Polaris-Link {\n  color: #202223;\n  font-weight: 600;\n  height: 36px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.BC-ChangeLogs__Dashboard__Changelog {\n  padding: 12px;\n  background-color: #fafbfb;\n  border-radius: 4px;\n}\n\n.BC-ChangeLogs__Dashboard .changelog-tag {\n  padding: 2px 8px;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 12px;\n  margin-bottom: 8px;\n  display: inline-block;\n}\n\n.BC-ChangeLogs__Dashboard__Changelog > ul {\n  margin: 0;\n}\n\n.BC-ChangeLogs__Dashboard .changelog-tag.changelog-tag--new {\n  background-color: #e0f0ff;\n  color: #00527c;\n}\n\n.BC-ChangeLogs__Dashboard .changelog-tag.changelog-tag--improve {\n  background-color: #cdfee1;\n  color: #00527c;\n}\n\n.BC-ChangeLogs__Dashboard .changelog-tag.changelog-tag--fixed {\n  background-color: #ffd6a4;\n  color: #5e4200;\n}\n\n/* cross sell up sell */\n\n.BC-Carousel .carousel-cards {\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  gap: 20px;\n  scroll-snap-type: x mandatory;\n  list-style: none;\n  padding-left: 0px;\n}\n\n.BC-Carousel .carousel-item {\n  flex-shrink: 0;\n}\n\n.BC-Carousel .carousel-controls {\n  display: flex;\n  align-items: center;\n}\n\n.BC-Carousel .carousel-controls button {\n  background: unset !important;\n  border: unset !important;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n}\n\n.BC-Carousel .carousel-controls .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.BC-Carousel .carousel-pagination-btn--active,\n.BC-Carousel .carousel-btn--disabled {\n  opacity: 0.3;\n}\n\n.BC-Carousel .carousel-pagination--active div {\n  background: #007f5f !important;\n}\n\n.BC-Carousel .carousel-pagination div {\n  width: 6px;\n  height: 6px;\n  background: #8c9196;\n  border-radius: 100%;\n}\n\n.BC-Carousel .carousel-pagination .Polaris-Icon {\n  width: 6px;\n  height: 7px;\n}\n\n.BC-Carousel {\n  position: relative;\n}\n\n.BC-Carousel .slide-controls .Polaris-Icon {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 0px;\n  background: #0000001a;\n  margin-top: 73%;\n}\n\n.BC-Carousel .slide-controls > div {\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: 200px;\n}\n\n.BC-Carousel .slide-controls > div:hover {\n  cursor: pointer;\n}\n\n.BC-Carousel .slide-controls .btn-next {\n  right: 0;\n}\n\n.BC-Carousel .slide-controls .btn-next .Polaris-Icon {\n  margin-right: 0;\n}\n\n.BC-Carousel .slide-controls .btn-prev {\n  left: 0;\n}\n\n.BC-Carousel .slide-controls .btn-prev .Polaris-Icon {\n  margin-left: 0;\n}\n\n.BC-Carousel .slide-controls .Polaris-Icon svg {\n  fill: #575959;\n  min-height: 16px;\n  min-width: 16px;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .feature-list {\n  margin-top: 20px;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .feature-list .card {\n  padding: 20px;\n  width: 330px;\n  min-height: 228px;\n  position: relative;\n  border-radius: 4px;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .feature-list .card h2 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 8px 0;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .feature-list .card h1 {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n  margin: 8px 0;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .feature-list .card .Polaris-TextStyle--variationSubdued {\n  margin-bottom: 16px;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .feature-list .card-addon {\n  background-image: url('https://cdn.boostcommerce.io/assets/dashboard-v3/addon-background.png');\n  background-size: 330px 228px;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .feature-list .card-feature {\n  background-image: url('https://cdn.boostcommerce.io/assets/dashboard-v3/feature-background.png');\n  background-size: 330px 228px;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .feature-list .card-other {\n  background-image: url('https://cdn.boostcommerce.io/assets/dashboard-v3/other-background.png');\n  background-size: 330px 228px;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .feature-list .card-addon .Polaris-Button {\n  background: #ffc96b;\n  box-shadow:\n    0px 1px 0px rgba(0, 0, 0, 0.08),\n    inset 0px -1px 0px rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .feature-list .card-addon .Polaris-Button--disabled {\n  box-shadow: unset;\n  background: #f3eee5;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .feature-list .card-addon .sub-text {\n  line-height: 20px;\n  margin-top: 4px;\n  color: #d72c0d;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .card .Polaris-Button {\n  position: absolute;\n  bottom: 20px;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .card .Polaris-Badge > span {\n  display: flex;\n  width: 100%;\n  gap: 8px;\n  padding: 0 5px;\n  justify-content: center;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .card .Polaris-Badge .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  width: 1rem;\n  height: 1rem;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .card .Polaris-Badge--statusWarning .Polaris-Icon svg {\n  fill: #f48d32;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .card .Polaris-Badge {\n  min-height: 24px;\n  max-width: 97px;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .card .Polaris-Badge--statusWarning {\n  background: #ffebd3;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .card .Polaris-Badge--statusInfo {\n  background: #e5effd;\n}\n\n.BC-CrossSellUpSell__DashboardV3 .card .Polaris-Badge--statusInfo .Polaris-Icon svg {\n  fill: #2c6ecb;\n}\n\n/* sync */\n.BC-SyncHookStatus__DashboardV3 .Polaris-Heading {\n  margin-bottom: 18px;\n}\n\n.BC-SyncHookStatus__DashboardV3 .Polaris-Card .Polaris-ProgressBar .Polaris-ProgressBar__Label {\n  color: var(--pc-progress-bar-indicator);\n  text-indent: -9999px;\n}\n\n.BC-SyncHookStatus__DashboardV3 .Polaris-Card .Polaris-ProgressBar--sizeMedium {\n  height: 6px;\n}\n\n.BC-SyncHookStatus__DashboardV3 .Polaris-Card .progress-caption {\n  margin-top: 20px;\n}\n\n.BC-SyncHookStatus__DashboardV3 .Polaris-Card .progress-status {\n  margin-top: 16px;\n  display: grid;\n}\n\n.BC-SyncHookStatus__DashboardV3 .Polaris-Card .progress-status > strong {\n  margin-bottom: 8px;\n}\n\n.BC-SyncHookStatus__DashboardV3 .Polaris-Card .progress-step-status {\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 600;\n  margin-top: 8px;\n  display: flex;\n  gap: 5px;\n}\n\n.BC-SyncHookStatus__DashboardV3 .Polaris-Card .progress-step-status img {\n  margin-top: 3px;\n}\n\n/* subscription status */\n.BC-ThemeSetup__DashboardV3 .Polaris-Card,\n.BC-Subscription__DashboardV3 .Polaris-Card {\n  height: 230px;\n}\n\n.BC-Subscription__DashboardV3 .Polaris-Card .Polaris-Card__Section {\n  display: flex;\n}\n\n.BC-Subscription__DashboardV3 .Polaris-Card .img {\n  max-width: 200px;\n}\n\n.BC-Subscription__DashboardV3 .Polaris-Card .current-package {\n  margin-top: 14px;\n  height: 24px;\n}\n\n.BC-Subscription__DashboardV3 .Polaris-Card .current-package .Polaris-TextStyle--variationStrong {\n  font-size: 16px;\n  line-height: 24px;\n  margin-right: 8px;\n}\n\n.BC-Subscription__DashboardV3 .Polaris-Card .current-package .Polaris-Badge {\n  height: 100%;\n  min-width: 96px;\n}\n\n.BC-Subscription__DashboardV3 .Polaris-Card .Polaris-Badge--statusNew span {\n  font-weight: 400;\n}\n\n.BC-Subscription__DashboardV3 .Polaris-Card .current-package .Polaris-Badge span {\n  margin: auto;\n}\n\n.BC-Subscription__DashboardV3 .Polaris-Card .subscribe__bottom {\n  margin-top: 14px;\n}\n\n.BC-Subscription__DashboardV3 .subscribe__action {\n  position: absolute;\n  bottom: 23px;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.BC-Subscription__DashboardV3 .subscribe-money-back {\n  color: #d72c0d;\n}\n\n@media (max-width: 768px) {\n  .BC-ThemeSetup__DashboardV3 .Polaris-Card,\n  .BC-Subscription__DashboardV3 .Polaris-Card {\n    height: unset;\n  }\n\n  .BC-Subscription__DashboardV3 .Polaris-Card .Polaris-Card__Section {\n    flex-direction: column;\n  }\n}\n\n/* change logs */\n.BC-ChangeLogs__Dashboard .date {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  margin-top: 20px;\n}\n\n.BC-ChangeLogs__Dashboard .list-badge {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n  margin: 8px 0 18px 0;\n}\n\n.BC-ChangeLogs__Dashboard .list-badge .Polaris-Badge {\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.BC-ChangeLogs__Dashboard .detail-logs ul {\n  margin-top: 6px;\n  font-size: 14px;\n  line-height: 20px;\n  padding-left: 20px;\n}\n\n.BC-ChangeLogs__Dashboard .Polaris-Button {\n  width: 100%;\n}\n\n/* Theme status */\n.BC-ThemeSetup__DashboardV3 .Polaris-Card .Polaris-Card__Section {\n  padding: unset;\n}\n\n.BC-ThemeSetup__DashboardV3 .Polaris-Card .Polaris-Card__Section .layoutCols .firstCol {\n  padding: 32px 20px;\n  display: grid;\n  gap: 20px;\n}\n\n.BC-ThemeSetup__DashboardV3\n  .Polaris-Card\n  .Polaris-Card__Section\n  .layoutCols\n  .firstCol\n  .content-status {\n  min-height: 100px;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.BC-ThemeSetup__DashboardV3 .secondCol {\n  max-width: 140px;\n}\n\n/* recommended apps */\n.BC-RecommendedApps__DashboardV3 .Polaris-Card__Section > .Polaris-TextStyle--variationSubdued {\n  line-height: 20px;\n  margin-top: 8px;\n}\n\n.BC-RecommendedApps__DashboardV3 .apps-recommended {\n  max-width: 256px;\n  min-height: 464px;\n}\n\n.BC-RecommendedApps__DashboardV3 .app-detail {\n  margin-top: 20px;\n  background: #fafbfb;\n  border-radius: 4px;\n  padding: 16px;\n  min-height: 240px;\n}\n\n.BC-RecommendedApps__DashboardV3 .app-detail .Polaris-Link {\n  display: flex;\n  gap: 12px;\n  color: black;\n  text-decoration: none;\n  font-size: 14px;\n  line-height: 20px;\n  align-items: center;\n}\n\n.BC-RecommendedApps__DashboardV3 .app-detail img {\n  max-width: 40px;\n  max-height: 40px;\n  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.07);\n  border-radius: 8px;\n}\n\n.BC-RecommendedApps__DashboardV3 .app-detail:last-child {\n  margin-bottom: 20px;\n}\n\n.BC-RecommendedApps__DashboardV3 .app-detail .description {\n  margin: 12px 0;\n}\n\n.BC-RecommendedApps__DashboardV3 .app-detail .rating {\n  margin-bottom: 4px;\n}\n\n.BC-RecommendedApps__DashboardV3 .app-detail .rating .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  margin-right: 4px;\n  width: 14px;\n  height: 16px;\n}\n\n.BC-RecommendedApps__DashboardV3 .app-detail .rating .Polaris-Icon svg {\n  fill: #f48d32;\n}\n\n/* Support feature block*/\n.BC-Support-Feature__DashboardV3 .Polaris-Card .Polaris-Card__Section {\n  padding: unset;\n}\n\n.BC-Support-Feature__DashboardV3 .Polaris-Card .section {\n  border-bottom: 1px solid #e1e3e5;\n  padding: 20px;\n}\n\n.BC-Support-Feature__DashboardV3 .section > .action-list {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n  flex-direction: row;\n  gap: 20px;\n}\n\n.BC-Support-Feature__DashboardV3 .section > .action-list-mini {\n  display: grid;\n}\n\n.BC-Support-Feature__DashboardV3 .section > .action-list .card-action {\n  display: flex;\n  gap: 12px;\n  background: #fafbfb;\n  border-radius: 4px;\n  align-items: center;\n  padding: 20px;\n  min-height: 60px;\n  width: 100%;\n  max-width: 226px;\n}\n\n.PFS_MainMenu_Wrapper {\n  width: 100%;\n}\n\n.BC-Support-Feature__DashboardV3 .section > .action-list .card-action:hover {\n  cursor: pointer;\n  background-color: #f0f8f8;\n}\n\n/* START: Custom for dashboard v4 */\n.BC-AnotherLayoutV3.V2 .small-screen {\n  margin-top: 0;\n}\n\n.BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .Polaris-Page {\n  padding: 0;\n}\n\n.BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .Polaris-Page__Content {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 0;\n}\n\n.PFS_MainMenu:has(.PFS_MainMenu--Mini) {\n  display: none;\n}\n\n.PFS_MainMenu--Mini {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.PFS_MainMenu--Mini .left {\n  display: flex;\n  align-items: center;\n  opacity: 0.7;\n  width: 50px;\n  justify-content: center;\n}\n\n.PFS_MainMenu--Mini .right {\n  display: flex;\n}\n\n.Polaris-PositionedOverlay:has(.menu-mobile) {\n  left: 10px !important;\n}\n\n.Polaris-PositionedOverlay:has(.menu-mobile) .Polaris-Popover__Content {\n  min-height: 220px;\n}\n\n.menu-mobile {\n  padding: 10px;\n}\n\n.menu-mobile .main-item {\n  display: flex;\n  text-align: left;\n}\n\n.menu-mobile .main-item .Polaris-Icon {\n  margin: 0;\n  margin-right: 4px;\n}\n\n.menu-mobile .main-item .Polaris-Icon svg {\n  fill: #5c5f62;\n}\n\n.BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .BC-Page__FirstColumn {\n  margin: 0;\n  width: unset;\n  display: flex;\n  flex-direction: column;\n  max-width: calc(100% - 320px - 20px);\n  position: sticky;\n  top: 50px;\n  height: 100%;\n}\n\n.BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .BC-Page__SecondColumn {\n  width: unset;\n  width: 320px;\n}\n\n.BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .Polaris-Page__Content .Polaris-Layout {\n  margin-left: 0;\n  margin-top: 0;\n}\n\n@media screen and (max-width: 1050px) {\n  .BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .Polaris-Page {\n    padding: 0 30px;\n  }\n}\n\n@media screen and (max-width: 940px) {\n  .BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .Polaris-Page__Content {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .BC-Page__FirstColumn {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .BC-Page__SecondColumn {\n    width: 100%;\n    display: flex;\n    max-height: unset !important;\n    overflow: unset !important;\n  }\n\n  .PFS_MainMenu .menuItem .main-item {\n    text-wrap: nowrap;\n  }\n}\n\n@media screen and (max-width: 820px) {\n  .PFS_MainMenu_Wrapper {\n    width: 100%;\n  }\n\n  .PFS_MainMenu_Wrapper .menu-features .menuItem {\n    display: flex;\n    justify-content: flex-start;\n    max-width: 115px;\n    overflow: hidden;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .PFS_MainMenu_Wrapper {\n    width: 100%;\n  }\n\n  .PFS_MainMenu_Wrapper .menu-features,\n  .PFS_MainMenu_Wrapper .menu-settings {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .PFS_MainMenu_Wrapper .menu-features .menuItem,\n  .PFS_MainMenu_Wrapper .menu-settings .menuItem {\n    display: flex;\n    justify-content: flex-start;\n    max-width: 300px;\n  }\n\n  .PFS_MainMenu {\n    display: none !important;\n  }\n\n  .PFS_MainMenu:has(.PFS_MainMenu--Mini) {\n    display: block !important;\n  }\n}\n\n.BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .BC-Page__FirstColumn .Polaris-Layout,\n.BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .BC-Page__SecondColumn .Polaris-Layout {\n  width: 100%;\n  margin: 0;\n}\n\n.BC-AnotherLayoutV3.V2 .Polaris-Layout__Section {\n  max-width: calc(100% - var(--p-space-6));\n  max-width: unset;\n}\n\n.BC-AnotherLayoutV3.V2 .BC-Notifications_DashboardV3 ul {\n  margin: 0;\n}\n\n.BC-AnotherLayoutV3.V2 .BC-Page__DashboardV3 .BC-Page__FirstColumn .Polaris-Layout {\n  padding: unset !important;\n}\n\n.BC-AnotherLayoutV3.V2 .Polaris-Layout__Section {\n  margin-left: 0;\n}\n\n.BC-HelpAndSupport__DashboardV3 .Polaris-Button,\n.BC-ResourceCenter__DashboardV3 .Polaris-Button {\n  width: 140px;\n  padding: 0;\n}\n\n.BC-HelpAndSupport__DashboardV3 .Polaris-Button .Polaris-Button__Text,\n.BC-ResourceCenter__DashboardV3 .Polaris-Button .Polaris-Button__Text {\n  align-items: center;\n  display: flex;\n  gap: 10px;\n}\n\n/* Option in email */\n.BC-OptionInEmail__DashboardV3 .Polaris-Card .Polaris-Card__Section {\n  display: flex;\n  width: 100%;\n}\n\n.BC-OptionInEmail__DashboardV3 .Polaris-Card .Polaris-Card__Section .option-email-content {\n  width: 100%;\n}\n\n.BC-OptionInEmail__DashboardV3 .Polaris-Card .Polaris-Card__Section > div:first-child {\n  padding: 20px 20px 20px 0;\n  width: 100%;\n}\n\n.BC-OptionInEmail__DashboardV3 .Polaris-Card .Polaris-Card__Section > div .option-input {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 20px;\n  width: 100%;\n}\n\n.BC-OptionInEmail__DashboardV3 .Polaris-Card .Polaris-Card__Section > div .option-input > div {\n  flex: 40% 1;\n}\n\n.BC-OptionInEmail__DashboardV3\n  .Polaris-Card\n  .Polaris-Card__Section\n  > div\n  .option-input\n  > *:not(:first-child) {\n  margin-top: unset;\n}\n\n.BC-OptionInEmail__DashboardV3 .Polaris-Card .Polaris-Card__Section .background-image {\n  margin-left: 20px;\n  width: 57%;\n  height: auto;\n}\n\n.BC-OptionInEmail__DashboardV3 .Polaris-Card .Polaris-Card__Section .background-image img {\n  width: 100%;\n  height: 100%;\n}\n\n.BC-AppInsight__DashboardV3 .Polaris-Card__Header .header-action {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.BC-AppInsight__DashboardV3 .Polaris-Card__Header .BC-Analytics__Filter {\n  margin: 0;\n}\n\n.BC-AppInsight__DashboardV3 .Polaris-Card__Header .BC-Analytics__Filter .tooltip {\n  display: none;\n}\n\n.BC-AppInsight__DashboardV3 .Polaris-Card__Section {\n  padding: 15px;\n}\n\n.BC-AppInsight__DashboardV3 .content .list {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-gap: 10px;\n}\n\n@media screen and (max-width: 764px) {\n  .BC-AppInsight__DashboardV3 .content .list {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media screen and (max-width: 460px) {\n  .BC-AppInsight__DashboardV3 .content .list {\n    grid-template-columns: 1fr;\n  }\n}\n\n.BC-AppInsight__DashboardV3 .content .list .item {\n  display: flex;\n  min-height: 90px;\n  background: #fafbfb;\n  border-radius: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  padding: 16px;\n}\n\n.BC-AppInsight__DashboardV3 .content .list .item.item--ai-insight {\n  flex-wrap: nowrap;\n  background: linear-gradient(321.74deg, #e3fffa -3.64%, #d0ffd3 91.45%);\n  justify-content: space-between;\n}\n\n.BC-AppInsight__DashboardV3 .content .list .item.item--ai-insight .blue-star {\n  margin-right: 4px;\n}\n\n.BC-AppInsight__DashboardV3 .content .list .item.item--ai-insight .tag-AI {\n  background: #42ffd026;\n  border-radius: 50%;\n  padding: 3px 8px;\n  max-width: max-content;\n}\n\n.BC-AppInsight__DashboardV3 .content .list .item .title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: calc(100% - 60px);\n}\n\n.BC-AppInsight__DashboardV3 .content .list .item.item--ai-insight .title {\n  width: auto;\n}\n\n.BC-AppInsight__DashboardV3 .content .list .item .title p {\n  font-weight: 600;\n  font-size: 14px;\n  color: #202223;\n  display: inline-block;\n  border-bottom: 3px dotted #bcbcbc;\n}\n\n.BC-AppInsight__DashboardV3 .content .list .item .img {\n  width: 58px;\n  display: flex;\n}\n\n.BC-AppInsight__DashboardV3 .content .list .item .value-wrapper {\n  display: flex;\n  align-items: baseline;\n  margin-top: 12px;\n}\n\n.BC-AppInsight__DashboardV3 .content .list .item .value {\n  font-weight: 600;\n  font-size: 28px;\n  margin-right: 10px;\n  color: #202223;\n}\n\n.BC-AppInsight__DashboardV3 .content .list .item .percent-change {\n  font-weight: 600;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n}\n\n.BC-AppInsight__DashboardV3 .content .list .item .percent-change.up,\n.BC-AppInsight__DashboardV3 .content .list .item .percent-change.up svg path {\n  color: #008060;\n  fill: #008060;\n}\n\n.BC-AppInsight__DashboardV3 .content .list .item .percent-change.down,\n.BC-AppInsight__DashboardV3 .content .list .item .percent-change.down svg path {\n  color: #d72c0d;\n  fill: #d72c0d;\n}\n\n/* END: Custom for dashboard v4 */\n\n/* .Polaris-Layout {\n  border: 1px solid red;\n}\n.Polaris-Page {\n  border: 1px solid blue;\n\n} */\n/*-------End Dashboard v3------------*/\n\n.priceBox .subscribe-money-back,\n.BC-CalloutCard-Subscription__Dashboard .subscribeBox .subscribe__bottom .subscribe-money-back {\n  color: rgb(222, 54, 24);\n  margin-top: 10px;\n  font-style: italic;\n}\n\n.exceededPlanNotification .Polaris-Banner__Text::after {\n  border: none;\n}\n\n.BC-Transition-enter {\n  opacity: 0.01;\n}\n\n.BC-Transition-enter-active {\n  opacity: 1;\n  transition: opacity 500ms ease-out;\n}\n\n.BC-Transition-exit {\n  opacity: 1;\n}\n\n.BC-Transition-exit-active {\n  opacity: 0.01;\n  transition: opacity 300ms ease-out;\n}\n\n.BC-Block-Dismiss--Right-Menu {\n  position: absolute;\n  right: 20px;\n  top: 20px;\n}\n\n.BC-CalloutCard-ThemeSetup__Dashboard .firstCol .Polaris-Button,\n.BC-CalloutCard-ExpReviewRating__Dashboard .firstCol .Polaris-Button {\n  margin-top: 1rem;\n  width: fit-content;\n}\n\n.subscribeBox .Polaris-TextContainer p {\n  font-size: 12px;\n  line-height: 1rem;\n  margin-top: 0;\n}\n\n.subscribeBox .Polaris-TextContainer {\n  min-height: 122px;\n  display: flex;\n  flex-wrap: wrap;\n  text-align: center;\n}\n\n.subscribeBox .Polaris-TextContainer .Polaris-Heading {\n  width: 100%;\n}\n\n.subscribeBox .Polaris-TextContainer .subscribe_badge,\n.subscribeBox .Polaris-TextContainer .subscribe_dangerous,\n.subscribeBox .Polaris-TextContainer .subscribe_warning {\n  margin: 4px auto;\n}\n\n.subscribeBox .Polaris-TextContainer .subscribe_badge span.Polaris-Badge,\n.subscribeBox .Polaris-TextContainer .subscribe_dangerous span.Polaris-Badge,\n.subscribeBox .Polaris-TextContainer .subscribe_warning span.Polaris-Badge {\n  margin-left: 4px;\n  height: 1.5rem;\n}\n\n.subscribeBox .Polaris-TextContainer .subscribe_dangerous span.Polaris-Badge {\n  background-color: #de3618;\n  color: #ffff;\n}\n\n.subscribeBox .Polaris-TextContainer .subscribe_warning span.Polaris-Badge {\n  /* background-color: #FFC453; */\n  color: #202223;\n}\n\n.subscribeBox .Polaris-TextContainer .subscribe_badge span.Polaris-Badge:first-child,\n.subscribeBox .Polaris-TextContainer .subscribe_dangerous span.Polaris-Badge:first-child,\n.subscribeBox .Polaris-TextContainer .subscribe_warning span.Polaris-Badge:first-child {\n  margin-left: 0;\n}\n\n.subscribeBox .Polaris-TextContainer .subscribe__bottom {\n  align-self: flex-end;\n  width: 100%;\n  margin-top: 0;\n}\n\n.BC-Illustration-Image__Dashboard.BC-Remove-Image__Dashboard img {\n  width: 373px;\n  max-width: 100%;\n}\n\n/* ExpReviewRating */\n#BC-UnsubscribeModal-Backdrop,\n#BC-ExpReviewRatingModal-Backdrop {\n  position: fixed;\n  z-index: 519;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  background: rgba(33, 43, 54, 0.4);\n}\n\n#BC-UnsubscribeModal-Content,\n#BC-ExpReviewRatingModal-Content {\n  position: relative;\n  width: 436px;\n  min-height: 244px;\n}\n\n#BC-UnsubscribeModal-Content.success .Polaris-Card {\n  background-image: url('https://cdn.boostcommerce.io/assets/dashboard/expReviewRating/modal/bg_Feedback.png');\n  background-repeat: no-repeat;\n  background-position-y: 50px;\n  background-position-x: right;\n  background-size: 164px auto;\n}\n\n#BC-ExpReviewRatingModal-FloatingButton {\n  border-radius: 50%;\n  position: fixed;\n  width: 60px;\n  height: 60px;\n  bottom: 110px;\n  right: 40px;\n  z-index: 521;\n}\n\n@media (max-height: 740px) {\n  #BC-ExpReviewRatingModal-FloatingButton {\n    bottom: 80px;\n    right: 20px;\n  }\n}\n\n#BC-ExpReviewRatingModal-Button {\n  position: absolute;\n  top: 1.25rem;\n  right: 1.25rem;\n  padding: 0;\n  background: none;\n  border: none;\n  min-width: unset;\n  min-height: unset;\n  cursor: pointer;\n  z-index: 521;\n}\n\n#BC-UnsubscribeModal-Content .topImage,\n#BC-ExpReviewRatingModal-Content .topImage {\n  position: absolute;\n  top: -22px;\n  left: 0;\n  right: 0;\n  text-align: center;\n  z-index: 520;\n}\n\n#BC-UnsubscribeModal-Content .topImage img,\n#BC-ExpReviewRatingModal-Content .topImage img {\n  width: 72px;\n  height: 72px;\n}\n\n#BC-UnsubscribeModal-Content .Polaris-Card,\n#BC-ExpReviewRatingModal-Content .Polaris-Card {\n  padding-top: 1.875rem;\n}\n\n#BC-UnsubscribeModal-Content .Polaris-Card .Polaris-FormLayout .Polaris-FormLayout__Item textarea {\n  max-height: 200px;\n}\n\n#BC-ExpReviewRatingModal-Content .rating .Polaris-Card .Polaris-Card__Section {\n  padding: 1.25rem 3.75rem;\n}\n\n#BC-ExpReviewRatingModal-Content .rating .Polaris-Card {\n  background-image: url('https://cdn.boostcommerce.io/assets/dashboard/expReviewRating/modal/bg.png');\n  background-repeat: no-repeat;\n  background-position-y: bottom;\n  background-size: contain;\n}\n\n#BC-ExpReviewRatingModal-Content .submitted .Polaris-Card {\n  background-image: url('https://cdn.boostcommerce.io/assets/dashboard/expReviewRating/modal/bg_Feedback.png');\n  background-repeat: no-repeat;\n  background-position-y: center;\n  background-position-x: right;\n  background-size: 168px auto;\n}\n\n#BC-ExpReviewRatingModal-Content .submitted-best-rating .Polaris-Card {\n  background-image: url('https://cdn.boostcommerce.io/assets/dashboard/expReviewRating/modal/bg_Feedback.png');\n  background-repeat: no-repeat;\n  background-position-y: 100px;\n  background-position-x: right;\n  background-size: 168px auto;\n}\n\n#BC-ExpReviewRatingModal-Content .ratingLayout {\n  text-align: center;\n}\n\n#BC-ExpReviewRatingModal-Content .ratingLayout p,\n#BC-ExpReviewRatingModal-Content .ratingLayout .rating-star {\n  padding-bottom: 1.5rem;\n}\n\n#BC-ExpReviewRatingModal-Content .submittedMessage {\n  width: 21.875rem;\n}\n\n#BC-ExpReviewRatingModal-Content .Polaris-ChoiceList__Choices li:not(:first-child) {\n  margin-top: 12px;\n}\n\n#BC-ExpReviewRatingModal-Content .Polaris-TextField--multiline > .Polaris-TextField__Input {\n  max-height: 106px;\n}\n\n/* New language launch */\n.BC-NewLanguageNotification__Wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: flex-end;\n}\n\n.BC-NewLanguageNotification__Wrapper .BC-NewLanguageNotification__Content {\n  -webkit-flex: 1 1 20rem;\n  flex: 1 1 20rem;\n}\n\n.BC-NewLanguageNotification__Wrapper .BC-NewLanguageNotification__Content {\n  margin: 1.25rem;\n}\n\n.BC-NewLanguageNotification__Wrapper .BC-NewLanguageNotification__Content .Polaris-TextContainer p {\n  margin-top: 0.5rem;\n}\n\n.BC-NewLanguageNotification__Wrapper\n  .BC-NewLanguageNotification__Content\n  .Polaris-TextContainer\n  .Polaris-ButtonGroup\n  .Polaris-ButtonGroup__Item {\n  margin-left: 0.5rem;\n}\n\n.BC-NewLanguageNotification__Wrapper .BC-NewLanguageNotification__Image {\n  -webkit-flex: 1 1 25rem;\n  flex: 1 1 25rem;\n}\n\n.BC-NewLanguageNotification__Wrapper img.BC-Illustration-Image__Dashboard {\n  width: 326px;\n  max-width: 100%;\n}\n\n/* Checklist onboarding */\n.BC-OnboardingChecklist__OnPage {\n  position: relative;\n  max-width: 62.375rem;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0;\n}\n\n.BC-OnboardingChecklist__OnPage .BC-OnboardingChecklist {\n  margin-top: 2.5rem;\n}\n\n.BC-OnboardingChecklist__OnPage .BC-OnboardingChecklist {\n  background: #ffffff;\n  box-shadow:\n    0px 0px 0px rgba(63, 63, 68, 0.05),\n    0px 1px 3px rgba(63, 63, 68, 0.15);\n  border-radius: 3px;\n}\n\n.BC-Page__FilterTree-Management\n  .BC-OnboardingChecklist__OnPage\n  .Polaris-Card__Header\n  + .Polaris-Card__Section,\n.BC-Page__SuggestionDictionary .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n.BC-Page__Synonym .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n.BC-Page__ProductRanking .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n.BC-Page__Merchandising .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n.BC-Page__MerchandisingV2 .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n.BC-Page__Metafield .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n.BC-Page__CustomRangeSlider .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n.BC-Page__SwatchSettings .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n.BC-Page__CustomSorting .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n.BC-Page__Product-Visibility .BC-OnboardingChecklist__OnPage .Polaris-Card__Section {\n  padding: 1rem;\n}\n\n@media (min-width: 30.625em) {\n  .BC-OnboardingChecklist__OnPage .BC-OnboardingChecklist {\n    margin-left: 1.25rem;\n    margin-right: 1.25rem;\n  }\n\n  .BC-Page__FilterTree-Management\n    .BC-OnboardingChecklist__OnPage\n    .Polaris-Card__Header\n    + .Polaris-Card__Section,\n  .BC-Page__SuggestionDictionary .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n  .BC-Page__Synonym .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n  .BC-Page__ProductRanking .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n  .BC-Page__Merchandising .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n  .BC-Page__MerchandisingV2 .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n  .BC-Page__Metafield .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n  .BC-Page__CustomRangeSlider .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n  .BC-Page__SwatchSettings .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n  .BC-Page__CustomSorting .BC-OnboardingChecklist__OnPage .Polaris-Card__Section,\n  .BC-Page__Product-Visibility .BC-OnboardingChecklist__OnPage .Polaris-Card__Section {\n    padding: 1.25rem;\n  }\n}\n\n@media (min-width: 46.5em) {\n  .BC-OnboardingChecklist__OnPage .BC-OnboardingChecklist {\n    margin-left: 2rem;\n    margin-right: 2rem;\n  }\n}\n\n.BC-OnboardingChecklist .Polaris-Card,\n.BC-OnboardingArticles .Polaris-Card {\n  border: 2px solid var(--p-decorative-one-surface);\n}\n\n.BC-OnboardingChecklist .Polaris-Card__Header {\n  border-bottom: none;\n}\n\n.BC-OnboardingChecklist .Polaris-Card__Header,\n.BC-OnboardingArticles .Polaris-Card__Header {\n  background-color: var(--p-surface-warning-subdued);\n}\n\n.BC-OnboardingChecklist .Polaris-Card__Header,\n.BC-OnboardingArticles .Polaris-Card__Header {\n  border-bottom: 0.125rem solid var(--p-decorative-one-surface);\n}\n\n.BC-OnboardingChecklist.active .Polaris-Card {\n  border-bottom: 0.125rem solid var(--p-decorative-one-surface);\n}\n\n.BC-OnboardingChecklist .Polaris-Card {\n  border-bottom: 0rem solid var(--p-decorative-one-surface);\n  transition: border-bottom 0.5s ease-in;\n}\n\n.BC-OnboardingChecklist .Polaris-ProgressBar__Indicator {\n  background-color: var(--p-action-primary);\n}\n\n.BC-OnboardingChecklist .BC_Card-Header .Polaris-Heading .icon,\n.BC-Finish-trial .icon {\n  width: 16px;\n  margin-left: 5px;\n}\n\n.BC-OnboardingChecklist .BC_Card-Header,\n.BC-OnboardingChecklist .checklist .checklist-item {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-OnboardingChecklist .BC_Card-Header .progress-bar {\n  display: flex;\n  margin-top: 3px;\n}\n\n.BC-OnboardingChecklist .BC_Card-Header .progress-bar .Polaris-TextStyle--variationStrong {\n  min-width: 40px;\n}\n\n.BC-OnboardingChecklist .BC_Card-Header .progress-bar .progress {\n  width: 13.75rem;\n  margin: 6px 20px 0px 10px;\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item {\n  margin-top: 1.5625rem;\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item:first-child {\n  margin-top: 0rem;\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item .item-description {\n  display: flex;\n  align-items: center;\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item .item-description.completed p {\n  text-decoration: line-through;\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item .item-description .completed-icon,\n.BC-OnboardingChecklist .checklist .checklist-item .item-description .un-completed-icon,\n.BC-OnboardingChecklist .checklist-item-style_04 .step-icon {\n  width: 26px;\n  height: 26px;\n  background-color: #919eab;\n  color: white;\n  border-radius: 50%;\n  display: block;\n  margin-right: 0.75rem;\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item .item-description .completed-icon {\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  margin-right: 0.75rem;\n}\n\n.BC-OnboardingChecklist\n  .checklist\n  .checklist-item-style_01.current\n  .item-description\n  .un-completed-icon,\n.BC-OnboardingChecklist\n  .checklist\n  .checklist-item-style_03.current\n  .item-description\n  .un-completed-icon,\n.BC-OnboardingChecklist .checklist-item-style_04.current .step-icon {\n  background-color: var(--p-action-primary);\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item-style_02 .item-description .un-completed-icon {\n  background-color: #ffffff;\n  border: 2px solid #c4cdd5;\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item-style_03 .item-description .tooltip {\n  margin-top: 4px;\n}\n\n.BC-OnboardingChecklist\n  .checklist\n  .checklist-item-style_03\n  .item-description\n  .Polaris-TextStyle--variationStrong {\n  font-weight: 500;\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item .item-description .un-completed-icon,\n.BC-OnboardingChecklist .checklist-item-style_04 .step-icon {\n  padding: 4px 9px;\n  font-weight: 500;\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item .completed-icon .Polaris-Icon {\n  width: 1.625rem;\n  height: 1.625rem;\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item.current .item-description p {\n  font-weight: 600;\n}\n\n.BC-OnboardingChecklist\n  .checklist\n  .checklist-item.checklist-item-style_03.current\n  .item-description\n  p {\n  color: var(--p-action-primary);\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item .item-action {\n  display: none;\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item .item-action button {\n  min-width: 7.5rem;\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item .item-action .Polaris-Button__Text {\n  font-weight: 600;\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item.current .item-action {\n  display: block;\n}\n\n.BC-OnboardingChecklist .action-checklist {\n  margin-top: 1.25rem;\n}\n\n.BC-OnboardingChecklist .action-checklist .action-skip {\n  text-align: right;\n}\n\n.BC-OnboardingChecklist .action-checklist .action-skip .Polaris-Button__Text {\n  color: #919eab;\n}\n\n.BC-OnboardingChecklist .Polaris-Button--plain.Polaris-Button--pressed,\n.BC-OnboardingChecklist .Polaris-Button--plain:hover,\n.BC-OnboardingChecklist .Polaris-Button--plain:focus,\n.BC-OnboardingChecklist .Polaris-Button--plain:active,\n.BC-OnboardingChecklist .Polaris-Button--monochrome.Polaris-Button--plain .Polaris-Button__Text {\n  text-decoration: none;\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item.checklist-item-style_04 {\n  display: block;\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item.checklist-item-style_04 .item-description {\n  flex: 1 1 15.625rem;\n  align-items: baseline;\n}\n\n.BC-OnboardingChecklist .checklist .checklist-item.checklist-item-style_04 .item-video {\n  flex: 1 1 28.125rem;\n}\n\n.BC-OnboardingChecklist\n  .checklist\n  .checklist-item.checklist-item-style_04.current\n  .item-description\n  .step-title {\n  color: var(--p-action-primary);\n}\n\n.BC-OnboardingChecklist\n  .checklist\n  .checklist-item.checklist-item-style_04.current\n  .item-description\n  p {\n  font-weight: 400;\n}\n\n.BC-OnboardingChecklist .checklist-content > .Polaris-Layout > .Polaris-Layout__Section:last-child,\n.BC-OnboardingArticles\n  .BC-Article4__Content\n  > .Polaris-Layout\n  > .Polaris-Layout__Section:last-child {\n  display: block;\n}\n\n.BC-OnboardingChecklist .checklist-content .checklist .BC-Checklist-Video__Wrapper,\n.BC-OnboardingArticles .BC-Article4__Content .article-content .BC-Article-Video__Wrapper {\n  display: none;\n}\n\n.BC-OnboardingChecklist .BC-Checklist-Video__Wrapper .BC-Checklist-Video__Container,\n.BC-OnboardingArticles .BC-Article4__Content .BC-Article-Video__Container {\n  position: relative;\n  width: 100%;\n  padding-bottom: 56.25%;\n  height: 0;\n}\n\n.BC-OnboardingChecklist .BC-Checklist-Video__Wrapper .BC-Checklist-Video__Container img,\n.BC-OnboardingArticles .BC-Article4__Content .BC-Article-Video__Container img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n@media (max-width: 46.5em) {\n  .BC-OnboardingChecklist\n    .checklist-content\n    > .Polaris-Layout\n    > .Polaris-Layout__Section:last-child,\n  .BC-OnboardingArticles\n    .BC-Article4__Content\n    > .Polaris-Layout\n    > .Polaris-Layout__Section:last-child {\n    display: none;\n  }\n\n  .BC-OnboardingChecklist .checklist-content .checklist .BC-Checklist-Video__Wrapper,\n  .BC-OnboardingArticles .BC-Article4__Content .article-content .BC-Article-Video__Wrapper {\n    display: block;\n    margin-top: 1.25rem;\n  }\n}\n\n.BC-OnboardingArticles .BC-Article4__Content .article-content {\n  margin-top: 1.375rem;\n}\n\n.BC-OnboardingArticles .BC-Article4__Content .article-content:first-child {\n  margin-top: 0;\n}\n\n/* Onboarding transition */\n.BC-OnboardingChecklist .transition-enter {\n  transform: translateY(-1.25rem);\n  opacity: 0;\n  visibility: hidden;\n  z-index: -1;\n}\n\n.BC-OnboardingChecklist .transition-enter-active {\n  transform: translateY(0%);\n  opacity: 1;\n  visibility: visible;\n  z-index: 1;\n  transition: all 0.3s ease-in;\n}\n\n.BC-OnboardingChecklist .transition-exit {\n  transform: translateY(0);\n  opacity: 1;\n  z-index: 1;\n  visibility: visible;\n}\n\n.BC-OnboardingChecklist .transition-exit-active {\n  transform: translateY(-1.25rem);\n  opacity: 0;\n  visibility: hidden;\n  z-index: -1;\n  transition: all 0.3s ease-out;\n}\n\n.BC-OnboardingChecklist .item-transition {\n  overflow: hidden;\n}\n\n.BC-OnboardingChecklist .segment,\n.BC-OnboardingArticles .segment {\n  margin-top: 1.25rem;\n}\n\n.BC-PreOnboardingChecklist .icon .Polaris-Icon {\n  width: 4rem;\n  height: 4rem;\n  padding: 1rem;\n  background-color: #ebf5fa;\n}\n\n.BC-PreOnboardingChecklist .name {\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 700;\n  margin-top: 0.75rem;\n}\n\n.BC-PreOnboardingChecklist .description {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 400;\n  color: #212b36;\n  margin: 0.25rem 3.125rem 0 3.125rem;\n}\n\n.BC-PreOnboardingChecklist button.Polaris-Button {\n  margin-top: 1.25rem;\n  margin-bottom: 0.5rem;\n  padding: 0.5rem 2.5rem;\n}\n\n/* .BC-PreOnboardingChecklist button.Polaris-Button:hover {\n  background: linear-gradient(to bottom, #6371c7, #5563c1);\n  border-color: #3f4eae;\n  box-shadow: inset 0 1px 0 0 #6774c8, 0 1px 0 0 rgb(22 29 37 / 5%), 0 0 0 0 transparent;\n  color: white;\n} */\n\n.BC-OnboardingArticles .list-feature {\n  display: flex;\n  align-items: center;\n  margin-top: 1.375rem;\n}\n\n.BC-OnboardingArticles .list-feature.current .title {\n  color: var(--p-action-primary);\n}\n\n.BC-OnboardingArticles .list-feature:first-child {\n  margin-top: 0;\n}\n\n.BC-OnboardingArticles .list-feature .icon,\n.BC-OnboardingArticles .BC-Article4__Content .list-feature > button {\n  margin-right: 0.75rem;\n}\n\n.BC-OnboardingArticles .BC-Article4__Content .list-feature {\n  align-items: end;\n}\n\n.BC-OnboardingArticles .BC-Article4__Content .list-feature.not-current .Polaris-Icon {\n  transform: rotate(90deg);\n}\n\n/* Recommended Apps block */\n.BC_RecommendedApps-Sliders .title {\n  display: flex;\n  align-items: center;\n  padding: 0 12px 12px 0;\n}\n\n.BC_AddonList-Sliders .title .icon,\n.BC_RecommendedApps-Sliders .title .icon {\n  display: block;\n  height: 64px;\n  width: 64px;\n  margin: auto;\n  filter: drop-shadow(0px 4px 24px rgba(0, 0, 0, 0.07));\n}\n\n.BC_RecommendedApps-Sliders .title .name {\n  margin-left: 12px;\n}\n\n.BC_RecommendedApps-Sliders .title .name .Polaris-Link-Content {\n  color: black;\n  text-decoration: none;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.BC_RecommendedApps-Sliders .description {\n  clear: both;\n  padding-right: 10px;\n}\n\n.BC_RecommendedApps-Sliders {\n  position: inherit;\n}\n\n.BC_AddonList-Sliders .react-multiple-carousel__arrow,\n.BC_RecommendedApps-Sliders .react-multiple-carousel__arrow {\n  min-width: 28px;\n  min-height: 28px;\n  background: rgba(0, 0, 0, 0.2);\n  z-index: 517;\n}\n\n.BC_AddonList-Sliders .react-multiple-carousel__arrow--left,\n.BC_RecommendedApps-Sliders .react-multiple-carousel__arrow--left {\n  left: -10px;\n}\n\n.BC_AddonList-Sliders .react-multiple-carousel__arrow--left::before,\n.BC_RecommendedApps-Sliders .react-multiple-carousel__arrow--left::before {\n  content: '\\e822';\n  margin-left: -2px;\n}\n\n.BC_AddonList-Sliders .react-multiple-carousel__arrow--right,\n.BC_RecommendedApps-Sliders .react-multiple-carousel__arrow--right {\n  right: -10px;\n}\n\n.BC_RecommendedApps-Sliders .react-multiple-carousel__arrow--right::before {\n  content: '\\e823';\n}\n\n.BC_RecommendedApps-Sliders_Dot-list {\n  margin-top: 12px;\n  position: relative;\n}\n\n.BC_RecommendedApps-Sliders_Dot-list .react-multi-carousel-dot button {\n  border: none;\n}\n\n.BC_RecommendedApps-Sliders_Dot-list .react-multi-carousel-dot button {\n  background: #d9d9d9;\n}\n\n.BC_RecommendedApps-Sliders_Dot-list .react-multi-carousel-dot--active button {\n  background: var(--p-text-success);\n}\n\n/* Filter tree page */\n.BC-Page__FilterTree-Item .Polaris-Page-Header__TitleAndRollup {\n  align-items: center;\n}\n\n.BC-Page__FilterTree-Item .Polaris-Page-Header__MainContent > .Polaris-Page-Header__PrimaryAction {\n  display: none;\n}\n\n.BC-Page__FilterTree-Item\n  .Polaris-Page-Header__MainContent\n  > .Polaris-Page-Header__TitleAndActions {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-Page__FilterTree-Item\n  .Polaris-Page-Header__MainContent\n  > .Polaris-Page-Header__TitleAndActions\n  > div {\n  flex: 2 2 22.5rem;\n}\n\n.BC-Page__FilterTree-Item\n  .Polaris-Page-Header__MainContent\n  > .Polaris-Page-Header__TitleAndActions\n  .Polaris-Page-Header__Actions {\n  flex: 1 1 13.75rem;\n  justify-content: flex-end;\n  align-items: baseline;\n}\n\n.BC-Page__FilterTree-Item .Polaris-Page-Header__PrimaryAction {\n  display: block;\n}\n\n.BC-Page__FilterTree-Item\n  .Polaris-Page-Header__Header--hasRollup\n  .Polaris-Page-Header__SecondaryActions {\n  justify-content: flex-end;\n  margin-right: 1.25rem;\n}\n\n.BC-Page__FilterTree-Item .Polaris-Header-Action {\n  border: 0.0625rem solid #c4cdd5;\n  box-shadow: 0 1px 0 0 rgba(22, 29, 37, 0.05);\n  border-radius: 3px;\n}\n\n.BC-Page__FilterTree-Item .Polaris-FormLayout,\n.BC-Page__Merchandising .Polaris-FormLayout,\n.BC-Page__Metafield .Polaris-FormLayout,\n.BC-Page__Product-Visibility .Polaris-FormLayout,\n.BC-Page__SwatchSettings .Polaris-FormLayout {\n  margin-top: -1.25rem;\n}\n\n.BC-Page__FilterTree-Item .Polaris-FormLayout__Item,\n.BC-Page__Merchandising-Rule .Polaris-FormLayout__Item {\n  margin-top: 1.25rem;\n}\n\n.BC-Page__FilterTree-Item .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing,\n.BC-Page__Merchandising-Rule .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {\n  justify-content: flex-end;\n}\n\n.BC-Page__FilterTree-Item .Polaris-Card .Polaris-Button__Content,\n.BC-Page__Merge-Value .Polaris-Card .Polaris-Button__Content {\n  font-weight: 600;\n}\n\n.BC-DataTable__FilterOptions .Polaris-DataTable__Table,\n.BC-DataTable__InstantSearchDisplay .Polaris-DataTable__Table {\n  table-layout: fixed;\n}\n\n.BC-DataTable__FilterOptions .Polaris-DataTable__Cell,\n.BC-DataTable__MergeValuesOptions .Polaris-DataTable__Cell,\n.BC-DataTable__MergeValues .Polaris-DataTable__Cell,\n.BC-DataTable__InstantSearchDisplay .Polaris-DataTable__Cell,\n.BC-DataTable__SearchSettings .Polaris-DataTable__Cell {\n  padding: 1.0625rem 0.625rem 1.0625rem 1.25rem;\n  /* border-bottom: 0.0625rem solid var(--p-divider); */\n  vertical-align: middle;\n  word-wrap: break-word;\n  white-space: inherit;\n}\n\n.BC-DataTable__SearchSettings thead tr .Polaris-DataTable__Cell {\n  border-bottom: 0.0625rem solid var(--p-divider);\n  height: 63px;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.BC-DataTable__SearchSettings .Polaris-DataTable__Cell-toggle {\n  width: 8%;\n}\n\n.BC-DataTable__SearchSettings .Polaris-DataTable__Cell-searchField {\n  width: 48%;\n}\n\n.BC-DataTable__SearchSettings .Polaris-DataTable__Cell-searchWeight {\n  width: 44%;\n}\n\n.BC-DataTable__SearchSettings .Polaris-DataTable__Cell-searchWeight .Polaris-Select {\n  width: 90%;\n}\n\n.BC-DataTable__FilterOptions .Polaris-DataTable__TableRow:last-child .Polaris-DataTable__Cell,\n.BC-DataTable__MergeValuesOptions .Polaris-DataTable__TableRow:last-child .Polaris-DataTable__Cell,\n.BC-DataTable__MergeValues .Polaris-DataTable__TableRow:last-child .Polaris-DataTable__Cell {\n  border-bottom: none;\n}\n\n.BC-DataTable__FilterOptions .Polaris-DataTable__Cell--header,\n.BC-DataTable__MergeValuesOptions .Polaris-DataTable__Cell--header,\n.BC-DataTable__MergeValues .Polaris-DataTable__Cell--header,\n.BC-DataTable__InstantSearchDisplay .Polaris-DataTable__Cell--header {\n  border-bottom: 0.0625rem solid var(--p-divider);\n  padding: 1.125rem 0.625rem 1.125rem 1.25rem;\n  font-weight: 500;\n}\n\n.BC-DataTable__FilterOptions .Polaris-DataTable__Cell:first-child {\n  width: 48px;\n}\n\n.BC-DataTable__FilterOptions .Polaris-DataTable__Cell:nth-child(2) {\n  width: 100px;\n}\n\n.BC-DataTable__FilterOptions .Polaris-DataTable__Cell:nth-child(3) {\n  width: 157px;\n  word-break: break-word;\n}\n\n.BC-DataTable__FilterOptions .Polaris-DataTable__Cell:nth-child(4) {\n  width: 145px;\n}\n\n.BC-DataTable__FilterOptions .Polaris-DataTable__Cell:nth-child(5) {\n  width: 164px;\n}\n\n.BC-DataTable__FilterOptions .Polaris-DataTable__Cell:nth-child(6) {\n  width: 228px;\n  white-space: pre-wrap;\n}\n\n.BC-DataTable__FilterOptions .Polaris-DataTable__Cell:last-child {\n  width: 92px;\n  padding-right: 1.25rem;\n  padding-left: 0.625rem;\n}\n\n.BC-DataTable__FilterOptions th.Polaris-DataTable__Cell:last-child {\n  padding: 0;\n  text-align: center;\n}\n\n.BC-DataTable__FilterOptions .Polaris-DataTable__Cell.EmptyCell,\n.BC-DataTable__MergeValuesOptions .Polaris-DataTable__Cell.EmptyCell,\n.BC-DataTable__MergeValues .Polaris-DataTable__Cell.EmptyCell,\n.BC-Page__Merchandising .Polaris-DataTable__Cell.EmptyCell,\n.BC-Page__Metafield .Polaris-DataTable__Cell.EmptyCell,\n.BC-Page__Product-Visibility .Polaris-DataTable__Cell.EmptyCell {\n  width: 0px;\n}\n\n.Polaris-DataTable__Cell-Action .Polaris-Button--iconOnly {\n  padding: 0.325rem;\n  min-height: 1.875rem;\n}\n\n.Polaris-DataTable__Cell-Action .Polaris-Icon {\n  width: 1.05rem;\n  height: 1.05rem;\n}\n\n.Polaris-DataTable__Cell-Action .Polaris-ButtonGroup--segmented {\n  justify-content: flex-end;\n}\n\n.BC-EmptyOption__FilterTree,\n.BC-EmptyTheme__ThemeSetup,\n.BC-EmptyOption__Filter-Setting,\n.BC-EmptyOption__SuggestionDictionary,\n.BC-EmptyOption__StopWords,\n.BC-EmptyOption__Synonym,\n.BC-EmptyOption__ProductRanking,\n.BC-EmptyRules__Merchandising,\n.BC-EmptyRules__MerchandisingV2,\n.BC-EmptySearch__RecommendationWidget,\n.BC-EmptySearch__ABTestingCampaign,\n.BC-EmptyRules__Metafield,\n.BC-EmptyRules__CustomRangeSlider,\n.BC-EmptyRules__Product-Visibility,\n.BC-EmptyOption__IgnoreIPs,\n.BC-EmptySwatch,\n.BC-EmptyRules__CustomSorting,\n.BC-EmptyOption__Sync,\n.BC-EmptyOption__Translation {\n  text-align: center;\n  margin: 1.5rem;\n}\n\n.BC-EmptySearch__Integration {\n  text-align: center;\n  margin: 1.5rem 0;\n  padding-top: 1.5rem;\n}\n\n.BC-Page__Integration .Polaris-Tabs__Panel .BC-EmptySearch__Integration .Polaris-Button {\n  width: auto;\n}\n\n.BC-EmptyOption__FilterTree img,\n.BC-EmptyTheme__ThemeSetup img,\n.BC-EmptyOption__Filter-Setting img,\n.BC-EmptyOption__SuggestionDictionary img,\n.BC-EmptyOption__StopWords img,\n.BC-EmptyOption__Synonym img,\n.BC-EmptyOption__ProductRanking img,\n.BC-EmptySearch__RecommendationWidget img,\n.BC-EmptySearch__Integration img,\n.BC-EmptySearch__ABTestingCampaign img,\n.BC-EmptyOption__IgnoreIPs img,\n.BC-EmptySwatch img,\n.BC-EmptyOption__Sync img,\n.BC-EmptyOption__Translation img {\n  width: 45px;\n  height: 40px;\n  margin-bottom: 12px;\n}\n\n.BC-Modal__OptionFilter .Polaris-Layout__Section--secondary {\n  margin-left: 0;\n}\n\n.BC-Modal__OptionFilter .Polaris-FormLayout__Item {\n  margin-top: 1.25rem;\n}\n\n.BC-Modal__OptionFilter .Polaris-FormLayout + .Polaris-FormLayout {\n  margin-top: 0;\n}\n\n.BC-DataTable__ManualValues .Polaris-DataTable__ScrollContainer {\n  overflow-x: initial;\n}\n\n.BC-Modal__OptionFilter .Polaris-Select__Content {\n  min-height: 2.125rem;\n  padding: 0.3125rem 0.4375rem 0.3125rem 0.4375rem;\n}\n\n.BC-Modal__OptionFilter .Polaris-TextField__Input {\n  padding: 0.3125rem 0.4375rem;\n}\n\n.BC-Modal__OptionFilter .noMetafield {\n  margin-top: 0.25rem;\n}\n\n.BC-Modal__OptionFilter .locationWarning {\n  margin-top: -1rem;\n}\n\n.BC-DataTable__ManualValues button,\n.List_MultiLevelTags .action button,\n.MultiLevelTag_ButtonAdd button {\n  color: var(--p-action-primary);\n  border-color: var(--p-action-primary);\n}\n\n.BC-DataTable__ManualValues button:hover,\n.List_MultiLevelTags .action button:hover,\n.MultiLevelTag_ButtonAdd button:hover {\n  border-color: var(--p-action-primary);\n}\n\n.BC-DataTable__ManualValues button svg,\n.List_MultiLevelTags .action button svg,\n.MultiLevelTag_ButtonAdd button svg {\n  fill: var(--p-action-primary);\n}\n\n.BC-DataTable__ManualValues .Polaris-DataTable__Table {\n  table-layout: fixed;\n}\n\n.BC-DataTable__ManualValues .Polaris-DataTable__Cell {\n  padding: 8px 5px;\n  border: none !important;\n}\n\n.BC-DataTable__ManualValues tbody {\n  vertical-align: top;\n}\n\n.BC-DataTable__ManualValues .Polaris-DataTable__Cell--header {\n  border: none;\n  padding: 0 5px 8px 5px;\n}\n\n.BC-DataTable__ManualValues .Polaris-DataTable__Cell:first-child {\n  width: 30px;\n}\n\n.BC-DataTable__ManualValues .Polaris-DataTable__Cell:first-child .Polaris-Icon {\n  margin-top: 8px;\n}\n\n.BC-DataTable__ManualValues .Polaris-DataTable__Cell:nth-child(2) {\n  width: 190px;\n}\n\n.BC-DataTable__ManualValues .Polaris-DataTable__Cell:nth-child(3) {\n  width: auto;\n}\n\n.BC-DataTable__ManualValues .Polaris-DataTable__Cell:nth-child(4) {\n  width: 40px;\n  padding-right: 0;\n}\n\n.BC-DataTable__ManualValues .Polaris-DataTable__Cell button {\n  padding-top: 0.46875rem;\n  padding-bottom: 0.46875rem;\n}\n\n.BC-DataTable__ManualValues .button-add {\n  padding-top: 8px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.BC-DataTable__ManualValues .button-add .Polaris-Icon {\n  width: 0.8125rem;\n  height: 0.8125rem;\n}\n\n/* Price list values*/\n.BC-Modal__OptionFilter .price-values > div {\n  margin-bottom: 0.5rem;\n}\n\n.BC-Modal__OptionFilter .price-values > div.Polaris-Labelled__LabelWrapper {\n  margin-bottom: 0.75rem;\n}\n\n.BC-List__Values .priceItem {\n  margin-bottom: 9px;\n}\n\n.BC-List__Values .priceItem:last-child {\n  margin-top: 16px;\n  margin-bottom: 0;\n}\n\n.BC-List__Values .priceItem .fromPrice,\n.BC-List__Values .priceItem .toPrice,\n.BC-List__Values .priceItem .button {\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n.BC-List__Values .priceItem .fromPrice span:first-child {\n  min-width: 4.0625rem;\n}\n\n.BC-List__Values .priceItem .fromPrice span:last-child {\n  min-width: 6.25rem;\n  text-align: center;\n  font-weight: bold;\n}\n\n.BC-List__Values .priceItem .toPrice {\n  margin-right: 1.5rem;\n}\n\n.BC-List__Values .priceItem .toPrice span {\n  min-width: 4.0625rem;\n  text-align: center;\n  margin-top: auto;\n  margin-bottom: auto;\n}\n\n.BC-List__Values .priceItem .toPrice input {\n  text-align: center;\n  max-width: 100px;\n  font-weight: bold;\n}\n\n.BC-List__Values .priceItem .button button i {\n  margin: 0 !important;\n}\n\n.BC-List__Values .priceItem .button .Polaris-Icon {\n  width: 1.05rem;\n  height: 1.05rem;\n}\n\n.BC-List__Values .priceItem .button button {\n  border-color: var(--p-action-primary);\n}\n\n.BC-List__Values .priceItem .button button svg {\n  fill: var(--p-action-primary);\n}\n\n/*Filter tree*/\n.BC-Page__FilterTree-Management .Polaris-Layout__Section,\n.BC-Page__SuggestionDictionary .Polaris-Layout__Section,\n.BC-Page__Synonym .Polaris-Layout__Section,\n.BC-Page__ProductRanking .Polaris-Layout__Section,\n.BC-Page__Merchandising .Polaris-Layout__Section,\n.BC-Page__Metafield .Polaris-Layout__Section,\n.BC-Page__CustomRangeSlider .Polaris-Layout__Section,\n.BC-Page__Product-Visibility .Polaris-Layout__Section,\n.BC-Page__SwatchSettings .Polaris-Layout__Section,\n.BC-Page__CustomSorting .Polaris-Layout__Section {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__FilterTree-Management .Polaris-Card__Header + .Polaris-Card__Section,\n.BC-Page__SuggestionDictionary .Polaris-Card__Section,\n.BC-Page__Synonym .Polaris-Card__Section,\n.BC-Page__ProductRanking .Polaris-Card__Section,\n.BC-Page__Merchandising .Polaris-Card__Section,\n.BC-Page__MerchandisingV2 .Polaris-Card__Section + .Polaris-Card__Section,\n.BC-Page__Metafield .Polaris-Card__Section,\n.BC-Page__CustomRangeSlider .Polaris-Card__Section,\n.BC-Page__Product-Visibility .Polaris-Card__Section,\n.BC-Page__SwatchSettings .Polaris-Card__Section,\n.BC-Page__SearchAnalytics__SearchTerms .Polaris-Card__Section,\n.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-Card__Section,\n.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-Card__Section,\n.BC-Page__SearchAnalytics__ProductPerformance .Polaris-Card__Section,\n.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-Card__Section,\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-Card__Section,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-Card__Section,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-Card__Section,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-Card__Section,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-Card__Section,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-Card__Section,\n.BC-Page__CustomSorting #sort-by-options .Polaris-Card__Section {\n  padding: 0;\n}\n\n.BC-Page__Redirect .BC-QuickStartGuide__DashboardV3 .Polaris-Card__Section,\n.BC-Page__Synonym .BC-QuickStartGuide__DashboardV3 .Polaris-Card__Section,\n.BC-Page__SuggestionDictionary .BC-QuickStartGuide__DashboardV3 .Polaris-Card__Section,\n.BC-Page__SwatchSettings .BC-QuickStartGuide__DashboardV3 .Polaris-Card__Section,\n.BC-Page__CustomRangeSlider .BC-QuickStartGuide__DashboardV3 .Polaris-Card__Section,\n.BC-Page__Metafield .BC-QuickStartGuide__DashboardV3 .Polaris-Card__Section {\n  padding: var(--p-space-5);\n}\n\n/*.BC-Page__FilterTree-Management .Polaris-DataTable--collapsed .Polaris-DataTable__ScrollContainer {\n  margin-left: 5.9375rem;\n}\n\n.BC-Page__FilterTree-Management .Polaris-DataTable__Cell--fixed {\n  width: 5.9375rem;\n}\n\n.BC-Page__FilterTree-Management .Polaris-DataTable__Cell--truncated {\n  max-width: 5.9375rem;\n}*/\n\n.BC-Page__FilterTree-Management .Polaris-DataTable__Cell,\n.BC-Page__Merchandising .Polaris-DataTable__Cell,\n.BC-Page__Metafield .Polaris-DataTable__Cell,\n.BC-Page__CustomRangeSlider .Polaris-DataTable__Cell,\n.BC-Page__Product-Visibility .Polaris-DataTable__Cell,\n.BC-Page__SwatchSettings .Polaris-DataTable__Cell,\n.BC-Page__CustomSorting .Polaris-DataTable__Cell {\n  padding: 1.25rem;\n  white-space: normal;\n  vertical-align: middle;\n}\n\n.BC-Page__FilterTree-Management .Polaris-DataTable__Cell:first-child {\n  width: 15%;\n}\n\n.BC-Page__FilterTree-Management .Polaris-DataTable__Cell:nth-child(2) {\n  width: 25%;\n}\n\n.BC-Page__FilterTree-Management .Polaris-DataTable__Cell:nth-child(2) .cell-locked {\n  color: var(--p-text-disabled);\n}\n\n.BC-Page__FilterTree-Management .Polaris-DataTable__Cell:last-child {\n  width: 90px;\n}\n\n.BC-Page__FilterTree-Management .Polaris-DataTable__Cell--header,\n.BC-Page__SuggestionDictionary .Polaris-DataTable__Cell--header,\n.BC-Page__Synonym .Polaris-DataTable__Cell--header,\n.BC-Page__ProductRanking .Polaris-DataTable__Cell--header,\n.BC-Page__Merchandising .Polaris-DataTable__Cell--header,\n.BC-Page__Metafield .Polaris-DataTable__Cell--header,\n.BC-Page__CustomRangeSlider .Polaris-DataTable__Cell--header,\n.BC-Page__Product-Visibility .Polaris-DataTable__Cell--header,\n.BC-Page__SwatchSettings .Polaris-DataTable__Cell--header,\n.BC-Page__CustomSorting .Polaris-DataTable__Cell--header,\n.BC-Sync__Content .Polaris-DataTable__Cell--header {\n  padding: 1.125rem;\n  font-weight: 500;\n  border-bottom: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page__FilterTree-Management .Polaris-DataTable__Cell ul.collections,\n.BC-Page__Merchandising .Polaris-DataTable__Cell ul.collections,\n.BC-Page__Metafield .Polaris-DataTable__Cell ul.appliesTo,\n.BC-Page__CustomRangeSlider .Polaris-DataTable__Cell ul.appliesTo,\n.BC-Page__Product-Visibility .Polaris-DataTable__Cell ul.appliesTo {\n  list-style: none;\n  display: contents;\n}\n\n.BC-Page__FilterTree-Management .Polaris-DataTable__Cell ul.collections li,\n.BC-Page__Merchandising .Polaris-DataTable__Cell ul.collections li,\n.BC-Page__Metafield .Polaris-DataTable__Cell ul.appliesTo li,\n.BC-Page__CustomRangeSlider .Polaris-DataTable__Cell ul.appliesTo li,\n.BC-Page__Product-Visibility .Polaris-DataTable__Cell ul.appliesTo li {\n  display: inline-flex;\n}\n\n.BC-Page__FilterTree-Management .Polaris-DataTable__Cell ul.collections li > span:first-child,\n.BC-Page__Merchandising .Polaris-DataTable__Cell ul.collections li > span:first-child,\n.BC-Page__Metafield .Polaris-DataTable__Cell ul.appliesTo li > span:first-child,\n.BC-Page__CustomRangeSlider .Polaris-DataTable__Cell ul.appliesTo li > span:first-child,\n.BC-Page__Product-Visibility .Polaris-DataTable__Cell ul.appliesTo li > span:first-child {\n  padding: 2px 6px;\n  margin: 0 0 2px 2px;\n  font-size: 0.75rem;\n  line-height: 18px;\n  color: #637381;\n  background-color: #f4f6f8;\n  border-radius: 3px;\n  display: inline;\n  float: left;\n}\n\n.BC-Page__FilterTree-Management .Polaris-Button__Content .Polaris-Icon {\n  width: 1.05rem;\n  height: 1.05rem;\n}\n\n.BC-Page__FilterTree-Management .Polaris-DataTable__TableRow .Polaris-Button {\n  min-height: 0;\n  min-width: 0;\n}\n\n.BC-Page__FilterTree-Management .Polaris-Button .Polaris-Button__Text .clone {\n  display: flex;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__TableRow .Polaris-Button--sizeSlim,\n.BC-Page__FilterTree-Management .Polaris-DataTable__TableRow .Polaris-Button--sizeSlim {\n  padding: 6px;\n}\n\n.BC-Page__FilterTree-Management .Polaris-DataTable__TableRow .Polaris-Button--iconOnly {\n  padding-bottom: 6px;\n}\n\n.BC-Page__FilterTree-Management .Polaris-DataTable tbody > tr:first-child th:hover {\n  background: unset;\n}\n\n.exceed-feature-notify {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #fffbf3;\n  border-radius: 8px;\n  min-height: 56px;\n  align-items: center;\n}\n\n.exceed-feature-notify.premium-locked-banner {\n  margin-bottom: 10px;\n}\n\n.exceed-feature-notify > div {\n  display: flex;\n  gap: 6px;\n}\n\n.exceed-feature-notify .Polaris-Button {\n  background: #ffc96b;\n  box-shadow: 0px -1px 0px 0px #00000033 inset;\n  border: unset;\n  height: 36px;\n  padding: 8px 16px 8px 16px;\n  min-width: 112px;\n}\n\n.exceed-feature-notify .Polaris-Link .Polaris-Icon {\n  margin: 0;\n  vertical-align: top;\n  display: inline-flex;\n  width: 16px;\n  height: 16px;\n  margin-left: 2px;\n}\n\n.Polaris-DataTable__Cell--firstColumn:has(.exceed-feature-notify):hover {\n  background: unset;\n}\n\n/*Tooltip*/\n.tooltip {\n  margin-top: 5px;\n  margin-left: 4px;\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.Polaris-DataTable__Cell--header .tooltip {\n  margin-top: 4px;\n}\n\n.Polaris-Tooltip-TooltipOverlay__Content2 {\n  white-space: 'normal' !important;\n}\n\n.Polaris-Tooltip__Content,\n.Polaris-Tooltip-TooltipOverlay__Content {\n  max-width: 25rem;\n  white-space: normal;\n  word-wrap: break-word;\n}\n\n.tooltip .Polaris-Icon {\n  width: 0.75rem;\n  height: 0.75rem;\n}\n\n.BC-Page__FilterTree-Management\n  .Polaris-ButtonGroup--segmented\n  .Polaris-ButtonGroup__Item\n  .cloneFilter\n  button:first-child {\n  border-radius: 0;\n}\n\n.BC-Page__MerchandisingV2\n  .Polaris-ButtonGroup--segmented\n  .Polaris-ButtonGroup__Item\n  .cloneFilter\n  button:first-child {\n  border-radius: 0;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-ButtonGroup--segmented .Polaris-Button .clone {\n  display: flex;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-Page-Header__PrimaryActionWrapper .Polaris-Button__Text {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-Page__MerchandisingV2 .pagination .Polaris-Button__Text {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* button.Polaris-ActionList__Item {\n  min-height: 1.25rem;\n  padding: 0.25rem 1.125rem;\n} */\n\n.BC-Page__FilterTree-Management .Polaris-Stack > .Polaris-Stack__Item .search {\n  position: absolute;\n  right: 1.25rem;\n  top: 0.78125rem;\n  width: 14.125rem;\n}\n\n.BC-Page__Synonym .Polaris-Stack > .Polaris-Stack__Item .search {\n  position: absolute;\n  right: 1.25rem;\n  top: 0.65625rem;\n  width: 14.125rem;\n}\n\n/*Filter tree*/\n.BC-Page__FilterTree-Management .Polaris-DataTable__Cell {\n  padding: 1.25rem 1.25rem 1.25rem 1.25rem;\n}\n\n.BC-Page__FilterTree-Management .pagination,\n.BC-Page__SuggestionDictionary .pagination,\n.BC-Page__Synonym .pagination,\n.BC-Page__ProductRanking .pagination,\n.BC-Page__Merchandising .pagination,\n.BC-Page__MerchandisingV2 .pagination,\n.BC-Page__SwatchSettings .pagination,\n.BC-Page__Sync .pagination,\n.BC-Page__ManualRecommendationManagement .pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: 1.5rem;\n  position: relative;\n  margin-bottom: 1.25rem;\n}\n\n.BC-Page__FilterTree-Management .collectionsMore,\n.BC-Page__Merchandising .collectionsMore {\n  font-size: 0.75rem;\n  padding-left: 6px;\n}\n\n.BC-Page__FilterTree-Management .collectionsMore .Polaris-Icon,\n.BC-Page__Merchandising .collectionsMore .Polaris-Icon {\n  display: inline-flex;\n  width: 0.75rem;\n  height: 0.75rem;\n  vertical-align: middle;\n}\n\n.BC-Page__FilterTree-Management .collectionsMore .text,\n.BC-Page__Merchandising .collectionsMore .text {\n  padding-left: 2px;\n  vertical-align: middle;\n}\n\n.BC-Page__FilterTree-Management .Polaris-Card + .Polaris-Card {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__FilterTree-Management .infoBanner .Polaris-Banner--withinPage,\n.BC-Page__FilterTree-Item .infoBanner .Polaris-Banner--withinPage,\n.BC-Page__Translation .Polaris-Banner--withinPage {\n  padding: 1.25rem;\n}\n\n.BC-Page__Translation textarea {\n  resize: none;\n  overflow-y: scroll;\n  line-height: 1.4375rem;\n}\n\n.BC-Page__Translation textarea[rows='2'] {\n  max-height: 58px;\n}\n\n.BC-Page__Translation textarea[rows='3'] {\n  max-height: 82px;\n}\n\n.BC-Page__Translation textarea[rows='4'] {\n  max-height: 106px;\n}\n\n.BC-Page__Translation textarea[rows='5'] {\n  max-height: 130px;\n}\n\n.BC-Page__Translation textarea[rows='6'] {\n  max-height: 154px;\n}\n\n.BC-Page__Translation textarea::-webkit-scrollbar {\n  width: 8px;\n}\n\n.BC-Page__Translation textarea::-webkit-scrollbar-thumb {\n  background: #cccccc;\n  border-radius: 4px;\n}\n\n.BC-Page__Translation .search-result--withIcon {\n  display: inline-flex;\n}\n\n.BC-Page__Translation .search-result--withIcon .Polaris-Icon {\n  width: 0.75rem;\n  height: 0.75rem;\n  margin-top: 4px;\n  margin-left: 5px;\n}\n\n.BC-Page__Translation .spinner-loading {\n  min-height: 300px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.BC-Page__FilterTree-Management .infoBanner .Polaris-Banner__Content,\n.BC-Page__FilterTree-Item .infoBanner .Polaris-Banner__Content {\n  padding-top: 0.375rem;\n  padding-bottom: 0;\n}\n\n.BC-Page__FilterTree-Management .infoBanner p:not(:first-child),\n.BC-Page__FilterTree-Item .infoBanner p:not(:first-child) {\n  padding-top: 1.25rem;\n}\n\n/* Preview filter tree */\n.BC-Modal__OptionFilter .Polaris-Tabs__Panel {\n  min-height: 360px;\n  max-height: 503px;\n  overflow-x: auto;\n}\n\n.BC-Modal__OptionFilter .tabs .Polaris-Card__Header {\n  position: absolute;\n  right: 0;\n  top: -5px;\n}\n\n.BC-Modal__OptionFilter .previewPanel .Polaris-Card {\n  width: 100%;\n  box-shadow: none;\n  background: inherit;\n}\n\n.BC-Modal__OptionFilter .previewPanel .Polaris-Card .Polaris-Card__Header,\n.BC-Page__Filter-Settings .right .Polaris-Card .Polaris-Card__Header,\n.BC-Page__Layout-Settings .previewPanel .Polaris-Card .Polaris-Card__Header {\n  border-bottom: 0.0625rem solid var(--p-divider);\n  padding-top: 0.9375rem;\n  padding-bottom: 0.9375rem;\n}\n\n.BC-Modal__OptionFilter .previewPanel .Polaris-Card .Polaris-Heading,\n.BC-Page__Layout-Settings .previewPanel .Polaris-Card .Polaris-Heading {\n  text-align: center;\n  font-size: 0.875rem;\n  font-weight: 400;\n}\n\n.BC-Modal__OptionFilter .previewPanel .Polaris-Card__Section {\n  display: inline-flex;\n  width: 100%;\n}\n\n.BC-Modal__OptionFilter .previewPanel .device,\n.BC-Modal__OptionFilter .previewPanel .layout {\n  width: 50%;\n  text-align: center;\n}\n\n.BC-Modal__OptionFilter .previewPanel .device > div,\n.BC-Modal__OptionFilter .previewPanel .layout > div {\n  margin-top: 6px;\n  margin-bottom: 3px;\n}\n\n.BC-Modal__OptionFilter .previewPanel .device > div > span,\n.BC-Modal__OptionFilter .previewPanel .layout > div > span {\n  display: flex;\n}\n\n.BC-Modal__OptionFilter .previewPanel .device > div > span:focus,\n.BC-Modal__OptionFilter .previewPanel .layout > div > span:focus {\n  outline: none;\n}\n\n.BC-Modal__OptionFilter .previewPanel .device > div > span .icon:hover,\n.BC-Modal__OptionFilter .previewPanel .layout > div > span .icon:hover {\n  cursor: pointer;\n}\n\n.BC-Modal__OptionFilter .previewPanel .icons {\n  display: inline-flex;\n}\n\n.BC-Modal__OptionFilter .previewPanel .icons .active {\n  border: 2px solid var(--p-action-primary);\n}\n\n.BC-Modal__OptionFilter .previewPanel .icon.first {\n  margin-right: 1.5rem;\n}\n\n.BC-Modal__OptionFilter .previewPanel .icon {\n  border: 2px solid #919eab;\n  border-radius: 3px;\n  padding: 8px 10px;\n}\n\n.BC-Modal__OptionFilter .previewPanel .message {\n  color: #687381;\n  padding: 0.625rem 1.25rem 1.25rem 1.25rem;\n}\n\n.BC-Modal__OptionFilter .previewPanel .previewSoon {\n  color: #919eab;\n  padding: 0.625rem 1.25rem 1.25rem 1.25rem;\n}\n\n.BC-Modal__OptionFilter .previewPanel .filterTree {\n  margin: 0 1.25rem 1.25rem 1.25rem;\n  border: 1px solid #c4cdd5;\n  border-radius: 3px;\n  height: 301px;\n  max-height: 362px;\n}\n\n.BC-Modal__OptionFilter .previewPanel .explanProductNumbers {\n  margin: 1.25rem;\n  color: #637381;\n}\n\n.BC-Modal__OptionFilter .groupFields > div {\n  margin-top: 1.25rem;\n}\n\n/*Review ratings*/\n.BC-Modal__OptionFilter .reviewRatings-subtext {\n  margin-top: -0.9375rem;\n}\n\n.BC-Modal__OptionFilter .colorPickerBox {\n  width: 130px;\n}\n\n.BC-Modal__OptionFilter .selectedColor {\n  background-color: #fff;\n  z-index: 417;\n  width: 25px;\n  height: 25px;\n  margin-right: 0;\n  border: 1px solid #c4cdd5;\n  border-radius: 3px;\n  margin-right: 0.3125rem;\n}\n\n.BC-Page__Filter-Settings .selectedColor,\n.BC-Page__Layout-Settings .selectedColor,\n.BC-Default-Theme-Settings .selectedColor {\n  background-color: #fff;\n  z-index: 417;\n  width: 25px;\n  height: 25px;\n  margin-right: 0;\n  border: 1px solid #c4cdd5;\n  border-radius: 3px;\n  margin-left: 0.75rem;\n}\n\n.BC-Modal__OptionFilter .checkboxWithTextfield {\n  display: inline-flex;\n  width: 100%;\n}\n\n.BC-Modal__OptionFilter .checkboxWithTextfield .checkbox {\n  width: 27%;\n}\n\n.BC-Modal__OptionFilter .checkboxWithTextfield .checkbox .Polaris-Choice {\n  padding-top: 0.5rem;\n}\n\n.BC-Modal__OptionFilter .checkboxWithTextfield .textfield {\n  width: 100%;\n}\n\n.BC-Modal__OptionFilter .tabs .Polaris-Card {\n  border-radius: unset;\n  border-bottom: none !important;\n}\n\n.BC-Modal__OptionFilter .actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n  padding: 16px;\n}\n\n.BC-Modal__OptionFilter .actions .Polaris-Link {\n  padding: 8px 16px 8px 16px;\n  gap: 10px;\n  border-radius: 4px 0px 0px 0px;\n  border: 1px solid rgba(186, 191, 195, 1);\n  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.05);\n  color: rgba(32, 34, 35, 1);\n  text-decoration: none;\n}\n\n.BC-Modal__OptionFilter .analytics-select-popover .Polaris-Button {\n  padding: 0.3125rem 0.4375rem 0.3125rem 0.4375rem;\n}\n\n.BC-Modal__OptionFilter .actions .upgrade-button {\n  background: #ffc96b;\n  border: unset;\n  font-weight: 500;\n  box-shadow: 0px 1px 0px 0px #00000014;\n}\n\n.BC-Modal__OptionFilter .actions .upgrade-button:hover {\n  background: #f6bf61;\n}\n\n.BC-Modal__OptionFilter .actions-general {\n  margin-top: 16px;\n  border-top: 1px solid #e1e3e5;\n}\n\n.reviewRatingsPicker {\n  padding: 0.3125rem;\n}\n\n/* Filter settings */\n.BC-Page__Filter-Settings .headingStyle {\n  font-size: 1.75rem;\n  line-height: 2rem;\n  font-weight: 600;\n  margin-top: 2.5rem;\n  padding-top: 2.5rem;\n  padding-bottom: 1.5rem;\n  border-top: 1px solid var(--p-divider);\n}\n\n.BC-Page__Theme-Setup .headingWrapper {\n  padding-top: 2.5rem;\n  padding-bottom: 1.5rem;\n  border-top: 1px solid var(--p-divider);\n  display: flex;\n  align-items: baseline;\n}\n\n.BC-Page__Theme-Setup .headingStyle {\n  font-size: 1.75rem;\n  line-height: 2rem;\n  font-weight: 600;\n  margin-right: 0.5rem;\n}\n\n.BC-Page__Filter-Settings .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing,\n.BC-Page-Variants-Display .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {\n  justify-content: flex-end;\n}\n\n.BC-Page__Filter-Settings\n  .Polaris-PageActions\n  .Polaris-Stack--distributionEqualSpacing\n  > .Polaris-Stack__Item,\n.BC-Page__Translation\n  .Polaris-PageActions\n  .Polaris-Stack--distributionEqualSpacing\n  > .Polaris-Stack__Item {\n  margin-left: 1rem;\n}\n\n.BC-Page__Filter-Settings .styleBox .Polaris-Card__Section {\n  padding: 0;\n}\n\n.BC-Page__Filter-Settings .styleBox .tabs .Polaris-Card__Section {\n  padding: 1rem;\n}\n\n.BC-Page__Filter-Settings .Polaris-Tabs__Title {\n  min-width: auto;\n}\n\n.BC-Page__Filter-Settings .styleBox .Polaris-Card__Section {\n  padding: 0;\n}\n\n.BC-Page__Filter-Settings .displayBox {\n  margin-top: 40px;\n}\n\n.BC-Page__Filter-Settings .BC-GuideBanner {\n  margin-top: 24px !important;\n}\n\n.BC-Page__Filter-Settings .displayBox .Polaris-Stack {\n  margin-top: -1.75rem;\n}\n\n.BC-Page__Filter-Settings .displayBox .Polaris-Stack__Item {\n  margin-top: 0.75rem;\n  margin-bottom: 0.25rem;\n}\n\n.BC-Page__Filter-Settings .displayBox .BC-Button-ClearCache {\n  border-top: 0.0625rem solid var(--p-divider);\n  padding: 1.25rem 0 0.25rem 0;\n}\n\n.BC-Page__Filter-Settings .displayBox .BC-Select__control {\n  -webkit-align-items: start;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: start;\n  padding: 3px 0;\n}\n\n.BC-Page__Filter-Settings .tabs .Polaris-Card__Section,\n.BC-Page__Filter-Settings .right .Polaris-Card .Polaris-Card__Section {\n  padding: 1rem;\n}\n\n.BC-Page__Filter-Settings .style-tabs .left .Polaris-Card__Section {\n  padding: 1rem 1rem 1.5rem 1rem;\n  min-height: 480px;\n}\n\n.BC-Page__Filter-Settings .style-tabs .Polaris-Layout,\n.BC-Page__Filter-Settings .style-tabs .Polaris-Layout__Section {\n  margin-top: 0;\n  margin-left: 0;\n}\n\n.BC-Page__Filter-Settings .style-tabs .right .Polaris-Card {\n  box-shadow: none;\n  background: inherit;\n}\n\n.BC-Page__Filter-Settings .right .Polaris-Card .Polaris-Card__Header .Polaris-Heading {\n  line-height: 1.375rem;\n}\n\n.BC-Page__Filter-Settings .right .previewPanel .Polaris-Heading {\n  font-size: 0.875rem;\n  font-weight: 400;\n  text-align: center;\n}\n\n.BC-Page__Filter-Settings .right .previewPanel .content {\n  text-align: center;\n  display: inline-block;\n}\n\n.BC-Page__Filter-Settings .right .previewPanel ul.list {\n  list-style: none;\n  text-align: left;\n  margin-block-start: 1.5rem;\n  padding-inline-start: 0;\n}\n\n.BC-Page__Filter-Settings .right .previewPanel ul.list li:first-child {\n  display: inline-flex;\n  margin-left: -0.625rem;\n}\n\n.BC-Page__Filter-Settings .right .previewPanel .mobileButton {\n  text-align: center;\n  margin: 1.5rem 2.1875rem 0 2.1875rem;\n}\n\n.BC-Page__Filter-Settings .right .previewPanel .mobileButton button {\n  width: 100%;\n  border: none;\n  padding: 10px 0;\n  cursor: pointer;\n  background-color: #000;\n  color: #fff;\n  text-transform: uppercase;\n}\n\n.BC-Page__Filter-Settings .left .fontFamily-note {\n  color: #617985;\n  margin-top: -0.5rem;\n}\n\n/* Filter layout*/\n.BC-Page__Filter-Layout .Polaris-PageActions {\n  border-top: none;\n}\n\n.BC-Page__Filter-Layout .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {\n  justify-content: flex-end;\n}\n\n.BC-Page__Filter-Layout\n  .Polaris-PageActions\n  .Polaris-Stack--distributionEqualSpacing\n  > .Polaris-Stack__Item {\n  margin-left: 1rem;\n}\n\n.BC-Page__Filter-Layout .tabs .Polaris-Tabs__Panel {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__Filter-Layout .tabs .BC_FilterLayout-Vertical .Polaris-Card__Section,\n.BC-Page__Filter-Layout .tabs .BC_FilterLayout-Horizontal .Polaris-Card__Section,\n.BC-Page__Filter-Layout .tabs .BC_FilterLayout-Mobile .Polaris-Card__Section {\n  text-align: center;\n}\n\n.BC-Page__Filter-Layout .tabs .layout-style {\n  margin-top: 1rem;\n}\n\n.BC-Page__Filter-Layout .tabs .layout-style > div {\n  margin-top: 1rem;\n}\n\n.BC-Page__Filter-Layout .BC_FilterLayout-Desktop .box img,\n.BC-Page__Filter-Layout .BC_FilterLayout-Vertical .box img,\n.BC-Page__Filter-Layout .BC_FilterLayout-Horizontal .box img {\n  width: 100%;\n  max-height: 10.625rem;\n}\n\n.BC-Page__Filter-Layout .BC_FilterLayout-Mobile .box img {\n  width: 5rem;\n  height: 10.625rem;\n}\n\n.BC-Page__Filter-Layout .layout-oneFour .Polaris-Layout__Section--oneThird {\n  flex: 1 1 11.25rem;\n}\n\n.BC-Page__Filter-Layout .layout-oneFour .Polaris-Card__Section {\n  padding: 0.75rem;\n}\n\n.BC-Page__Filter-Layout .layout-oneFour .BC_FilterLayout-Desktop .Polaris-Choice {\n  min-height: 2.5rem;\n}\n\n/* Subscription */\n.BC-Page__Subscription .planStatus {\n  padding: 0.75rem;\n}\n\n.BC-Page__Subscription .planStatus .top {\n  display: flex;\n}\n\n.BC-Page__Subscription .planStatus .bottom {\n  padding-top: 1.5625rem;\n  text-align: center;\n}\n\n.BC-Page__Subscription .planStatus .status {\n  width: 50%;\n  text-align: center;\n  border-right: 1px solid var(--p-divider);\n}\n\n.BC-Page__Subscription .planStatus .status .title {\n  display: inline-block;\n  min-width: 87px;\n  margin: auto;\n}\n\n.BC-Page__Subscription .planStatus .status .Polaris-Badge {\n  padding: 0.125rem 0.625rem;\n  min-width: 107px;\n}\n\n.BC-Page__Subscription .planStatus .status .Polaris-Badge--statusWarning,\n.subscribeBox .Polaris-TextContainer .subscribe_warning .Polaris-Badge--statusWarning {\n  background-color: #ffc453;\n}\n\n.BC-Page__Subscription .planStatus .status .Polaris-Badge__Content {\n  margin: auto;\n}\n\n.BC-Page__Subscription .planStatus .status > div,\n.BC-Page__Subscription .planStatus .productCount > div {\n  font-size: 1rem;\n  font-weight: 700;\n  padding-bottom: 0.5rem;\n}\n\n.BC-Page__Subscription .planStatus .productCount {\n  width: 50%;\n  text-align: center;\n  float: right;\n}\n\n.BC-Page__Subscription .planStatus .productCount .count {\n  font-size: 1.625rem;\n}\n\n.BC-Page__Subscription .priceBox {\n  text-align: center;\n  padding: 3rem 0 0.25rem 0;\n}\n\n.BC-Page__Subscription .priceBox .price-information {\n  padding-left: 5.5rem;\n  margin-bottom: 2.5rem;\n  text-align: left;\n  -moz-column-count: 2;\n  -moz-column-gap: 20px;\n  -webkit-column-count: 2;\n  -webkit-column-gap: 20px;\n  column-count: 2;\n  column-gap: 20px;\n}\n\n.BC-Page__Subscription .priceBox .price-information > div {\n  display: inline-flex;\n}\n\n.BC-Page__Subscription .priceBox .price-information .icon-check {\n  display: inline-block;\n  margin-right: 0.625rem;\n}\n\n.BC-Page__Subscription .priceBox .price {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--p-action-primary);\n  letter-spacing: 2px;\n}\n\n.BC-Page__Subscription .priceBox .priceLarge {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--p-action-primary);\n  letter-spacing: 2px;\n  padding-bottom: 6px;\n}\n\n.BC-Page__Subscription .priceBox .price .unit {\n  font-size: 1.5625rem;\n  font-weight: 500;\n}\n\n.BC-Page__Subscription .priceBox .discountCode {\n  display: inline-flex;\n  padding-top: 1rem;\n}\n\n.BC-Page__Subscription\n  .priceBox\n  .discountCode\n  .Polaris-Connected\n  .Polaris-Connected__Item--primary {\n  width: 13.75rem;\n}\n\n.BC-Page__Subscription .priceBox .applied {\n  padding-top: 8px;\n  color: #008060;\n}\n\n.BC-Page__Subscription .priceBox .error {\n  color: #de3618;\n}\n\n.BC-Page__Subscription .priceBox .description {\n  padding: 1rem;\n}\n\n.BC-Page__Subscription .priceBox .warning {\n  color: #de3618;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.BC-Page__Subscription .priceBox .warning:empty {\n  padding-top: 2.25rem;\n}\n\n.BC-Page__Subscription .Polaris-Layout__Section:last-child {\n  color: #31373d;\n}\n\n.BC-Page__Subscription .priceSlider {\n  margin: 3.625rem 2.125rem 1.875rem 2.125rem;\n}\n\n.BC-Page__Subscription .textSetupComplete:first-child {\n  margin-top: 0.6875rem;\n}\n\n.BC-Page__Subscription .textSetupComplete {\n  color: #212b36;\n  margin-top: 1rem;\n}\n\n.BC-Page__Subscription .textSetupComplete:last-child {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__Subscription .noUiButton {\n  display: inline-flex;\n  margin-top: 5px;\n  margin-left: 1px;\n}\n\n.BC-Page__Subscription .noUiMaxProductLabel {\n  margin-top: -38px;\n  position: absolute;\n  right: -40px;\n  font-size: 14px;\n}\n\n.BC-Page__Subscription .noUi-active {\n  box-shadow: none;\n}\n\n.BC-Page__Subscription .noUiButton .Polaris-Icon {\n  width: 0.9375rem;\n  height: 0.9375rem;\n}\n\n.BC-Page__Subscription .noUiButton .Polaris-Icon:last-child {\n  margin-left: -7px;\n}\n\n.BC-Page__Subscription .information-pricing-V2 {\n  padding: 0 0.75rem;\n}\n\n.BC-Page__Subscription .information-pricing-V2 p {\n  margin: 1.25rem 0;\n}\n\n.BC-Page__Subscription .information-pricing-V2 .btn-show {\n  text-align: center;\n  margin: 0.75rem;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans {\n  border: 0.0625rem solid #d8e6ff;\n  background: #f9fbff;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans table {\n  table-layout: fixed;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .Polaris-DataTable__Cell {\n  border-right: 0.0625rem solid #d8e6ff;\n  border-bottom: 0.0625rem solid #d8e6ff;\n  font-weight: 500;\n  text-align: center;\n  white-space: normal;\n  padding: 1rem 1.5rem;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans tr .Polaris-DataTable__Cell:first-child {\n  padding-right: 0;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .Polaris-DataTable__Cell.Column__5 {\n  width: 132px;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .Polaris-DataTable__Cell.Column__1 {\n  width: 664px;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .Polaris-DataTable__Cell:first-child {\n  width: 268px;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .Polaris-DataTable__Cell.left-title,\n.BC-Page__Subscription .BC_DataTable_Plans .Polaris-DataTable__Cell.content-description,\n.BC-Page__Subscription .BC_DataTable_Plans .row-heading .Polaris-DataTable__Cell {\n  text-align: left;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .row-without-border .Polaris-DataTable__Cell,\n.BC-Page__Subscription .BC_DataTable_Plans tr .Polaris-DataTable__Cell:last-child {\n  border-right: none;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .row-heading td.Polaris-DataTable__Cell {\n  background: #d8e6ff;\n  padding: 1.125rem 1.5rem;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .row-heading button,\n.BC-Page__Subscription .BC_DataTable_Plans .left-title button {\n  color: inherit;\n  text-decoration: none;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .row-heading button:active .Polaris-Button__Content,\n.BC-Page__Subscription .BC_DataTable_Plans .left-title button:active .Polaris-Button__Content {\n  background: none;\n}\n\n.BC-Page__Subscription\n  .BC_DataTable_Plans\n  .row-heading\n  .Polaris-Button__DisclosureIcon\n  .Polaris-Icon__Svg,\n.BC-Page__Subscription\n  .BC_DataTable_Plans\n  .left-title\n  .Polaris-Button__DisclosureIcon\n  .Polaris-Icon__Svg {\n  fill: inherit;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .row-heading .Polaris-Button__Text {\n  text-transform: uppercase;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 28px;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans th.Polaris-DataTable__Cell {\n  border-right: 0.0625rem solid #ffffff;\n  background: #d8e6ff;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 22px;\n  padding: 0.625rem;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans th.Polaris-DataTable__Cell:last-child {\n  padding: 0.625rem 1rem;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .Polaris-Icon--colorGreen {\n  margin-left: auto;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .Polaris-DataTable__Cell.content-description {\n  font-size: 12px;\n  font-weight: normal;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .Polaris-DataTable__Cell.content-description > span {\n  display: block;\n}\n\n.BC-Page__Subscription\n  .BC_DataTable_Plans\n  .Polaris-DataTable__Cell.content-description\n  > span:before {\n  content: '-';\n  margin-right: 5px;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .Polaris-Badge {\n  background-color: #d8e6ff;\n  color: #2459b4;\n  border: none;\n  padding: 0 0.3125rem;\n  font-size: 10px;\n  font-weight: 600;\n  margin-left: 4px;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .icon-minus .Polaris-Icon {\n  width: 0.75rem;\n  padding-top: 0.3125rem;\n}\n\n/*Transition*/\n.BC-Page__Subscription .BC_DataTable_Plans .transition-enter {\n  transform: translateY(-1.25rem);\n  opacity: 0;\n  visibility: hidden;\n  z-index: -1;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .transition-enter-active {\n  transform: translateY(0%);\n  opacity: 1;\n  visibility: visible;\n  z-index: 1;\n  transition: all 0.3s ease-in-out;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .transition-exit {\n  transform: translateY(0);\n  opacity: 1;\n  z-index: 1;\n  visibility: visible;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .transition-exit-active {\n  transform: translateY(-1.25rem);\n  opacity: 0;\n  visibility: hidden;\n  z-index: -1;\n  transition: all 0.3s ease-in-out 0s;\n}\n\n.BC-Page__Subscription .BC_DataTable_Plans .item-transition {\n  overflow: hidden;\n}\n\n/*.BC-Page__Subscription .reviews-slideshow .brand .Polaris-Layout {\n  margin: 1.25rem 0;\n}\n\n.BC-Page__Subscription .reviews-slideshow .brand .Polaris-Layout .Polaris-Layout__Section {\n  margin: auto;\n}\n\n.BC-Page__Subscription .reviews-slideshow {\n  padding-bottom: 0.625rem;\n}\n\n.BC-Page__Subscription .reviews-slideshow .review img.icon {\n  max-width: 100%;\n  width: 238px;\n}\n\n.BC-Page__Subscription .reviews-slideshow .review-content {\n  text-align: left;\n  margin: 0.625rem 1.25rem 0.625rem 0;\n}\n\n.BC-Page__Subscription .reviews-slideshow .review .icon-quote {\n  width: 1.875rem;\n}\n\n.BC-Page__Subscription .reviews-slideshow .review .close-quote {\n  text-align: right;\n}\n\n.BC-Page__Subscription .reviews-slideshow .review .review-by:before {\n  content: ' ';\n  width: 2.5rem;\n  display: block;\n  border-top: solid 4px #ff3300;\n  margin-bottom: 12px;\n}\n\n.BC-Page__Subscription .reviews-slideshow .review .review-by {\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 22px;\n  margin-bottom: 1.875rem;\n}\n\n.BC-Page__Subscription .reviews-slideshow .carousel .control-dots .dot.selected {\n  background-color: #ff3300;\n}\n\n.BC-Page__Subscription .reviews-slideshow .carousel .control-dots .dot {\n  box-shadow: none;\n  opacity: 1;\n  background-color: #e4e4e9;\n}\n\n.BC-Page__Subscription .reviews-slideshow .slideshow-button {\n  position: absolute;\n  bottom: 1.25rem;\n  right: 1.25rem;\n}\n\n.BC-Page__Subscription .reviews-slideshow .slideshow-button button {\n  margin-left: -4px;\n  margin-right: -4px;\n}\n\n.BC-Page__Subscription .reviews-slideshow .slideshow-button button:active {\n  background: none;\n}*/\n\n.BC-Page__Subscription .brand {\n  margin-top: 2.5rem;\n  margin-bottom: 1.875rem;\n}\n\n.BC-Page__Subscription .brand .Polaris-Heading,\n.BC-Page__Subscription .review .title .Polaris-Heading,\n.BC-Page__Subscription .questions .title .Polaris-Heading {\n  font-weight: bold;\n  font-size: 28px;\n  line-height: 36px;\n}\n\n.BC-Page__Subscription .brand .brand-items {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  margin: 0.25rem 0;\n}\n\n.BC-Page__Subscription .review {\n  margin-top: 4.3125rem;\n  margin-bottom: 2.75rem;\n}\n\n.BC-Page__Subscription .review .title {\n  margin-bottom: 1.75rem;\n}\n\n.BC-Page__Subscription .review .Polaris-Layout__Section--oneThird {\n  flex: 1 1 21.875rem;\n}\n\n.BC-Page__Subscription .review .utilities {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  text-align: center;\n  margin: 1.5rem auto;\n}\n\n.BC-Page__Subscription .review .Polaris-Layout__Section .utilities:first-child {\n  margin-top: 0;\n}\n\n.BC-Page__Subscription .review .Polaris-Layout__Section .utilities:last-child {\n  margin-bottom: 0;\n}\n\n.BC-Page__Subscription .review .utilities > div {\n  text-align: center;\n  flex-direction: column;\n  flex-basis: 100%;\n  flex: 1;\n}\n\n.BC-Page__Subscription .review .utilities .Polaris-Heading {\n  margin-top: 1.25rem;\n  margin-bottom: 1.5rem;\n}\n\n.BC-Page__Subscription .review .Polaris-Card + .Polaris-Card {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__Subscription .review .review-info {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1.25rem;\n}\n\n.BC-Page__Subscription .review .review-content {\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 22px;\n  margin-bottom: 0.25rem;\n}\n\n.BC-Page__Subscription .questions {\n  margin-top: 3.75rem;\n  margin-bottom: 1.25rem;\n}\n\n.BC-Page__Subscription .questions .Polaris-Card__Header {\n  padding-bottom: 1rem;\n  padding-top: 1rem;\n}\n\n.BC-Page__Subscription .questions .Polaris-Card__Header .Polaris-Stack {\n  flex-wrap: unset;\n}\n\n.BC-Page__Subscription .questions .Polaris-Card__Section {\n  padding-top: 0;\n}\n\n.BC-Page__Subscription .questions .answer p + p {\n  margin-top: 1.25rem;\n}\n\n.BC-Page__Subscription .questions .answer p {\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 22px;\n  overflow-wrap: break-word;\n}\n\n.BC-Page__Subscription .transition-enter {\n  transform: translateY(-1.25rem);\n  opacity: 0;\n  visibility: hidden;\n  z-index: -1;\n}\n\n.BC-Page__Subscription .transition-enter-active {\n  transform: translateY(0%);\n  opacity: 1;\n  visibility: visible;\n  z-index: 1;\n  transition: all 0.6s ease-in;\n}\n\n.BC-Page__Subscription .transition-exit {\n  transform: translateY(0);\n  opacity: 1;\n  z-index: 1;\n  visibility: visible;\n}\n\n.BC-Page__Subscription .transition-exit-active {\n  transform: translateY(-1.25rem);\n  opacity: 0;\n  visibility: hidden;\n  z-index: -1;\n  transition: all 0.3s ease-out;\n}\n\n.BC-Page__Subscription .item-transition {\n  overflow: hidden;\n}\n\n/* Price slider */\n.priceSlider .noUi-horizontal {\n  height: 4px !important;\n}\n\n.priceSlider .noUi-target {\n  background: var(--p-divider) !important;\n  border: 0 !important;\n  box-shadow: none !important;\n}\n\n.priceSlider .noUi-connect {\n  background: var(--p-action-primary) !important;\n}\n\n.priceSlider .noUi-marker-horizontal.noUi-marker-large:first-child {\n  margin-left: 0;\n  width: 12px;\n  border-radius: 50%;\n  background: var(--p-action-primary);\n  margin-top: -18px;\n}\n\n.priceSlider .noUi-marker-large-last {\n  position: absolute;\n  margin-left: -12px !important;\n  width: 12px !important;\n  border-radius: 50%;\n  border: 1px solid #637381;\n  margin-top: -18px !important;\n  background: #fff !important;\n}\n\n.priceSlider .noUi-marker-horizontal.noUi-marker:first-child,\n.priceSlider .noUi-marker-large-last {\n  height: 12px !important;\n}\n\n.priceSlider .noUi-marker-horizontal.noUi-marker-large {\n  height: 8px !important;\n}\n\n.priceSlider .noUi-marker-horizontal.noUi-marker {\n  height: 8px !important;\n  background: var(--p-action-primary);\n  margin-top: -16px;\n}\n\n.priceSlider .noUi-value-horizontal {\n  font-size: 14px;\n  margin-top: -8px;\n  margin-left: 5px;\n  color: #637381;\n}\n\nhtml:not([dir='rtl']) .priceSlider .noUi-horizontal .noUi-handle {\n  right: -11px !important;\n}\n\n.priceSlider .noUi-horizontal .noUi-handle {\n  width: 24px !important;\n  height: 24px !important;\n  top: -10px !important;\n  border-radius: 50%;\n  background: var(--p-action-primary);\n  box-shadow: none;\n  border: none;\n}\n\n.priceSlider .noUi-handle:after,\n.priceSlider .noUi-handle:before {\n  width: 0 !important;\n}\n\n.priceSlider .noUi-value-horizontal:last-child {\n  left: 100% !important;\n}\n\n.priceSlider .noUi-handle-lower {\n  outline: none;\n}\n\n/* Subscription v3*/\n.subscribe-status-modal--success,\n.subscribe-status-modal--error {\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.subscribe-status-modal--success .Polaris-Icon,\n.subscribe-status-modal--error .Polaris-Icon {\n  margin-right: 5px;\n}\n\n.subscribe-status-modal--error {\n  color: #d72c0d;\n}\n\n.subscribe-status-modal--error .Polaris-Icon svg {\n  fill: #d72c0d;\n}\n\n.subscribe-status-modal--success {\n  color: #008060;\n}\n\n.subscribe-status-modal--success .Polaris-Icon svg {\n  fill: #008060;\n}\n\n.BC-Page__SubscriptionV3 .sub-info-page {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 24px;\n}\n\n.BC-Page__SubscriptionV3 .sub-info-page img {\n  width: 14px;\n  height: 14px;\n}\n\n.BC-Page__SubscriptionV3 .sub-info-page a {\n  text-decoration: none;\n  color: #6d7175;\n}\n\n.BC-Page__SubscriptionV3-Package .planStatus,\n.BC-Page__SubscriptionV3 .planStatus {\n  padding: 0.75rem;\n}\n\n.BC-Page__SubscriptionV3-Package .planStatus .top,\n.BC-Page__SubscriptionV3 .planStatus .top {\n  display: flex;\n}\n\n.BC-Page__SubscriptionV3-Package .planStatus .bottom,\n.BC-Page__SubscriptionV3 .planStatus .bottom {\n  padding-top: 1.5625rem;\n  text-align: center;\n}\n\n.BC-Page__SubscriptionV3-Package .planStatus .status,\n.BC-Page__SubscriptionV3 .planStatus .status {\n  width: 50%;\n  text-align: center;\n  border-right: 1px solid var(--p-divider);\n}\n\n.BC-Page__SubscriptionV3-Package .planStatus .status .title,\n.BC-Page__SubscriptionV3 .planStatus .status .title {\n  display: inline-block;\n  min-width: 87px;\n  margin: auto;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.BC-Page__SubscriptionV3-Package .planStatus .status .Polaris-Badge,\n.BC-Page__SubscriptionV3 .planStatus .status .Polaris-Badge {\n  padding: 0.125rem 0.625rem;\n  min-width: 96px;\n  min-height: 24px;\n}\n\n.BC-Page__SubscriptionV3-Package .planStatus .status .Polaris-Badge--statusWarning,\n.BC-Page__SubscriptionV3 .planStatus .status .Polaris-Badge--statusWarning,\n.subscribeBox .Polaris-TextContainer .subscribe_warning .Polaris-Badge--statusWarning {\n  background-color: #ffc453;\n}\n\n.BC-Page__SubscriptionV3-Package .planStatus .status .Polaris-Badge__Content,\n.BC-Page__SubscriptionV3 .planStatus .status .Polaris-Badge__Content {\n  margin: auto;\n}\n\n.BC-Page__SubscriptionV3 .planStatus .Polaris-Stack {\n  margin-top: 0;\n}\n\n.BC-Page__SubscriptionV3 .planStatus .Polaris-Stack .Polaris-Stack__Item:first-child strong,\n.BC-Page__SubscriptionV3 .planStatus .cost-breakdown {\n  display: flex;\n  justify-content: center;\n}\n\n.BC-Page__SubscriptionV3 .planStatus .cost-breakdown .Polaris-Icon {\n  height: 1rem;\n  width: 1rem;\n  margin: 3px 0 0 3px;\n}\n\n.BC-Page__SubscriptionV3 .planStatus .cost-breakdown {\n  color: #2c6ecb;\n}\n\n.BC-Page__SubscriptionV3 .planStatus .Polaris-Stack .Polaris-Stack__Item:last-child .discount-info {\n  background: #fafbfb;\n  border-radius: 8px;\n  margin: 10px -16px 0 -16px;\n  padding: 16px;\n}\n\n.cost-breakdown-modal .discount-info {\n  background: #fafbfb;\n  border-radius: 8px;\n  margin-top: 10px;\n  padding: 16px;\n}\n\n.cost-breakdown-modal .price-change-breakdown {\n  margin-top: 16px;\n}\n\n.cost-breakdown-modal .price-change-breakdown__header,\n.cost-breakdown-modal .price-change-breakdown__info {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.cost-breakdown-modal .price-change-breakdown__header p,\n.cost-breakdown-modal .price-change-breakdown__info p {\n  margin: 0;\n}\n\n.cost-breakdown-modal .price-change-breakdown__amount {\n  flex: 0 0 auto;\n  font-weight: 600;\n}\n\n.cost-breakdown-modal .price-change-breakdown__details {\n  margin-top: 4px;\n  padding-left: 20px;\n}\n\n.cost-breakdown-modal .price-change-breakdown__info p:last-child {\n  text-align: right;\n}\n\n.cost-breakdown-modal .code .Polaris-Button {\n  position: absolute;\n  top: 0rem;\n  right: -1.3rem;\n}\n\n.BC-Page__SubscriptionV3\n  .planStatus\n  .Polaris-Stack\n  .Polaris-Stack__Item:last-child\n  .Polaris-TextContainer {\n  margin-top: 24px;\n  padding: 0 28px;\n}\n\n.divider {\n  border-bottom: 1px solid var(--p-divider);\n  margin-top: 24px;\n}\n\n.BC-Page__SubscriptionV3\n  .planStatus\n  .Polaris-Stack\n  .Polaris-Stack__Item:last-child\n  .Polaris-TextContainer\n  .total-bill,\n.cost-breakdown-modal .total-bill {\n  display: flex;\n  justify-content: space-between;\n}\n\n.cost-breakdown-modal .total-bill {\n  margin-top: 16px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.cost-breakdown-modal .plan-status-action {\n  margin-top: 8px;\n}\n\n.BC-Page__SubscriptionV3 .planStatus .Polaris-Stack .Polaris-Stack__Item:last-child ul,\n.cost-breakdown-modal .discount-info ul,\n.cost-breakdown-modal div div ul {\n  padding-left: 20px;\n  margin-top: 4px;\n}\n\n.BC-Page__SubscriptionV3 .planStatus .cost-breakdown .Polaris-Icon svg {\n  fill: #2c6ecb;\n}\n\n.BC-Page__SubscriptionV3-Package .planStatus .status > div,\n.BC-Page__SubscriptionV3 .planStatus .status > div,\n.BC-Page__SubscriptionV3-Package .planStatus .productCount > div,\n.BC-Page__SubscriptionV3 .planStatus .productCount > div {\n  font-size: 1rem;\n  font-weight: 700;\n  padding-bottom: 0.5rem;\n}\n\n.BC-Page__SubscriptionV3-Package .planStatus .productCount,\n.BC-Page__SubscriptionV3 .planStatus .productCount {\n  width: 50%;\n  text-align: center;\n  float: right;\n}\n\n.BC-Page__SubscriptionV3-Package .planStatus .productCount .count {\n  font-weight: 600;\n  font-size: 26px;\n  line-height: 32px;\n}\n\n.plan-status-action {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.BC-Page__SubscriptionV3-Package > .Polaris-Page .card-title-uppercase {\n  margin-bottom: 24px;\n}\n\n.BC-Page__SubscriptionV3-Package .plan-notice-status {\n  margin-top: 8px;\n  width: 100%;\n  margin-bottom: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.BC-Page__SubscriptionV3 .planStatus .productCount .count {\n  font-size: 1.625rem;\n}\n\n.BC-Page__SubscriptionV3 .planStatus .discountCode .Polaris-Connected .Polaris-Connected__Item {\n  --p-focused: none;\n}\n\n.BC-Page__SubscriptionV3 .planStatus .error {\n  color: #de3618;\n  padding-top: 8px;\n}\n\n.BC-Page__SubscriptionV3\n  .subscription-plan\n  .Polaris-Card\n  .Polaris-Card__Section\n  .package-infos\n  .package-content {\n  margin: 20px 0;\n  display: flex;\n  width: 70%;\n  justify-content: space-between;\n}\n\n.BC-Page__SubscriptionV3\n  .subscription-plan\n  .Polaris-Card\n  .Polaris-Card__Section\n  .package-infos\n  .package-content\n  ul {\n  padding-left: 32px;\n}\n\n.BC-Page__SubscriptionV3\n  .subscription-plan\n  .Polaris-Card\n  .Polaris-Card__Section\n  .package-infos\n  .package-title {\n  display: flex;\n  height: 100%;\n  height: 64px;\n  background-color: #f1f8f5;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n  align-items: center;\n  border-radius: 8px;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.BC-Page__SubscriptionV3\n  .subscription-plan\n  .Polaris-Card\n  .Polaris-Card__Section\n  .package-infos\n  .package-title\n  > div:first-child\n  .Polaris-Badge {\n  margin-left: 6px;\n  height: 20px;\n}\n\n.BC-Page__SubscriptionV3-Package .planStatus .Polaris-Badge--statusAttention,\n.BC-Page__SubscriptionV3 .subscription-plan .planStatus .Polaris-Badge--statusAttention {\n  background-color: #ffd79d;\n}\n\n.BC-Page__SubscriptionV3 .subscription-plan .Polaris-Card .Polaris-Card__Section .addon-infos {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.BC-Page__SubscriptionV3\n  .subscription-plan\n  .Polaris-Card\n  .Polaris-Card__Section\n  .addon-infos\n  .addon-card {\n  width: 285px;\n  min-height: 172px;\n  background: #f1f8f5;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.review-addon-modal .addon-info .Polaris-TextStyle--variationStrong,\n.review-package-modal .package-info .Polaris-TextStyle--variationStrong,\n.review-addon-modal .addon-billing .total,\n.review-package-modal .package-billing .total,\n.BC-Page__SubscriptionV3\n  .planStatus\n  .Polaris-Stack\n  .Polaris-Stack__Item:last-child\n  .Polaris-TextContainer\n  .Polaris-TextStyle--variationStrong,\n.BC-Page__SubscriptionV3 .planStatus .Polaris-Stack .Polaris-Stack__Item:first-child strong,\n.BC-Page__SubscriptionV3\n  .subscription-plan\n  .Polaris-Card\n  .Polaris-Card__Section\n  .addon-infos\n  .addon-card\n  div\n  > .Polaris-TextStyle--variationStrong,\n.BC-Page__SubscriptionV3\n  .subscription-plan\n  .Polaris-Card\n  .Polaris-Card__Section\n  .addon-infos\n  .addon-card\n  > .Polaris-TextStyle--variationStrong {\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.BC-Page__SubscriptionV3\n  .subscription-plan\n  .Polaris-Card\n  .Polaris-Card__Section\n  .addon-infos\n  .addon-card {\n  position: relative;\n}\n\n.BC-Page__SubscriptionV3\n  .subscription-plan\n  .Polaris-Card\n  .Polaris-Card__Section\n  .addon-infos\n  .addon-card\n  > .Polaris-TextStyle--variationStrong {\n  position: absolute;\n  bottom: 20px;\n}\n\n.BC-Page__SubscriptionV3\n  .subscription-plan\n  .Polaris-Card\n  .Polaris-Card__Section\n  .addon-infos\n  .addon-card\n  .Polaris-Button--iconOnly {\n  padding-right: 0px;\n}\n\n.addon-infos .addon-card > ul {\n  margin-bottom: 36px;\n  margin-top: 8px;\n  padding-left: 20px;\n}\n\n/* Subscription v3 - plan summary */\n.BC-Page__SubscriptionV3 .BC-planSummary {\n  display: flex;\n  gap: 40px;\n}\n\n.BC-Page__SubscriptionV3 .BC-planSummary .status .bottom {\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 7px;\n}\n\n.BC-Page__SubscriptionV3 .BC-planSummary .status {\n  padding-right: 20px;\n  width: 50%;\n}\n\n.BC-Page__SubscriptionV3 .BC-planSummary > .status > div > .Polaris-TextStyle--variationStrong,\n.BC-Page__SubscriptionV3 .BC-planSummary > div > .Polaris-TextStyle--variationStrong {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n}\n\n.BC-Page__SubscriptionV3 .BC-planSummary .status > div:first-child {\n  display: flex;\n  gap: 8px;\n  text-align: center;\n  align-items: center;\n}\n\n.BC-Page__SubscriptionV3 .BC-planSummary .productCount {\n  width: 24%;\n}\n\n.BC-Page__SubscriptionV3 .BC-planSummary .count {\n  margin-top: 7px;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 32px;\n}\n\n.BC-Page__SubscriptionV3 .BC-planSummary .invoiceTotal .cost {\n  color: var(--interactive-default, #2c6ecb);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  padding: 2px 0;\n  margin-top: 4px;\n}\n\n.BC-Page__SubscriptionV3 .BC-planSummary .invoiceTotal .cost:hover {\n  cursor: pointer;\n}\n\n.BC-Page__SubscriptionV3 .BC-planSummary .invoiceTotal {\n  width: 30%;\n}\n\n.BC-Page__SubscriptionV3 .Polaris-Card__Section .planSummary-addon .title {\n  width: 100%;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.BC-Page__SubscriptionV3 .Polaris-Card__Section .planSummary-addon .addon-item {\n  padding: 8px 16px 8px 4px;\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.BC-Page__SubscriptionV3 .Polaris-Card__Section .planSummary-addon .addon-item > div:first-child {\n  width: 29%;\n}\n\n.BC-Page__SubscriptionV3 .Polaris-Card__Section .planSummary-addon .addon-item > div:nth-child(2) {\n  width: 10%;\n}\n\n.BC-Page__SubscriptionV3\n  .Polaris-Card__Section\n  .planSummary-addon\n  .addon-item\n  > div\n  .Polaris-Badge--statusNew {\n  font-weight: 400 !important;\n  background-color: #f1f2f3;\n}\n\n.BC-Page__SubscriptionV3 .Polaris-Card__Section .planSummary-addon .addon-item > div:nth-child(3) {\n  width: 10%;\n}\n\n.BC-Page__SubscriptionV3 .Polaris-Card__Section .planSummary-addon .addon-item > div:nth-child(4) {\n  color: var(--text-subdued, #6d7175);\n}\n\n.BC-Page__SubscriptionV3 .Polaris-Card__Section .planSummary-addon .addon-item .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.cost-breakdown-modal div div .Polaris-TextStyle--variationStrong {\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.cost-breakdown-modal div div .error {\n  color: var(--text-critical, #d72c0d);\n  margin-top: 4px;\n}\n\n#BC-UnsubscribeModal-Content .Polaris-Card .Polaris-FormLayout .Polaris-FormLayout__Item ul li {\n  margin-top: 10px;\n}\n\n#BC-UnsubscribeModal-Content .Polaris-Card .Polaris-Button {\n  margin-top: 20px;\n}\n\n.BC-Page__SubscriptionV3-Package .packages > div {\n  max-width: 1170px;\n  min-height: 778px;\n  margin-top: 40px !important;\n  margin: auto;\n  padding: 38px 24px 24px 24px;\n  background: #ffffff;\n  border-radius: 8px;\n}\n\n.BC-Page__SubscriptionV3 .packages > div {\n  min-height: 584px;\n  margin: auto;\n  background: #ffffff;\n  border-radius: 8px;\n}\n\n.BC-Page__SubscriptionV3 .packages > div > div:first-child {\n  gap: 20px;\n}\n\n.BC-Page__SubscriptionV3 .packages > div > div:first-child,\n.BC-Page__SubscriptionV3-Package .packages > div > div:first-child {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-Page__SubscriptionV3 .packages > div > p,\n.BC-Page__SubscriptionV3-Package .packages > div > p {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.BC-Page__SubscriptionV3 .packages > div > p span,\n.BC-Page__SubscriptionV3-Package .packages > div > p span {\n  margin-left: 4px;\n}\n\n.BC-Page__SubscriptionV3 .packages div div .Polaris-Card {\n  margin-top: 0;\n  padding: 20px 16px;\n  min-height: 544px;\n  width: 100%;\n}\n\n.BC-Page__SubscriptionV3-Package .packages div div .Polaris-Card {\n  width: 358px;\n  min-height: 664px;\n  margin-top: 0;\n  padding: 40px 32px;\n}\n\n.BC-Page__SubscriptionV3 .packages div div .Polaris-Card:nth-child(2),\n.BC-Page__SubscriptionV3-Package .packages div div .Polaris-Card:nth-child(2) {\n  position: relative;\n}\n\n.BC-Page__SubscriptionV3 .packages div div .Polaris-Card .most-popular {\n  width: 100px;\n  height: 20px;\n  background: #008060;\n  border-radius: 20px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #ffffff;\n  position: absolute;\n  top: -10px;\n  left: 33%;\n}\n\n.BC-Page__SubscriptionV3-Package .packages div div .Polaris-Card .most-popular {\n  width: 147px;\n  height: 28px;\n  background: #008060;\n  border-radius: 20px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #ffffff;\n  position: absolute;\n  top: -15px;\n  left: 30%;\n}\n\n.BC-Page__SubscriptionV3-Package .packages div div .Polaris-Card > div:nth-child(2) {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 32px;\n  text-align: center;\n}\n\n.BC-Page__SubscriptionV3 .packages div div .Polaris-Card > div:nth-child(2) {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n  text-align: center;\n  margin-top: 9px;\n}\n\n.BC-Page__SubscriptionV3 .packages div div .Polaris-Card .package-name {\n  margin-top: unset !important;\n}\n\n.BC-Page__SubscriptionV3-Package .packages div div .Polaris-Card .price {\n  margin-top: 0 !important;\n}\n\n.BC-Page__SubscriptionV3-Package .packages div div .Polaris-Card > div:not(:first-child) {\n  margin-top: 24px;\n}\n\n.BC-Page__SubscriptionV3 .packages div div .Polaris-Card > div:not(:first-child) {\n  margin-top: 16px;\n}\n\n.BC-Page__SubscriptionV3 .packages div div .Polaris-Card > div:nth-child(3),\n.BC-Page__SubscriptionV3-Package .packages div div .Polaris-Card > div:nth-child(3) {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  color: var(--text-subdued, #6d7175);\n}\n\n.BC-Page__SubscriptionV3-Package .packages div div .Polaris-Card > div:nth-child(3) {\n  margin-bottom: 24px;\n  margin-top: 8px;\n}\n\n.BC-Page__SubscriptionV3 .packages div div .Polaris-Card > div:nth-child(3) {\n  margin-top: 0;\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card .price {\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 32px;\n  text-align: center;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card .price span {\n  font-size: 16px !important;\n  font-weight: 600;\n  line-height: 24px !important;\n}\n\n.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card > div:nth-child(4) {\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 48px;\n  text-align: center;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card > div:nth-child(4) span,\n.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card > div:nth-child(4) span {\n  font-size: 24px;\n  line-height: 32px;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card > div:nth-child(5),\n.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card > div:nth-child(5) {\n  display: flex;\n  justify-content: center;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card > div:nth-child(5) > div {\n  width: 45%;\n}\n\n.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card > div:nth-child(5) > div {\n  width: 75%;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card > div:nth-child(5) div .Polaris-Icon,\n.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card > div:nth-child(5) div .Polaris-Icon {\n  width: 2rem;\n  height: 1.5rem;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card > div:nth-child(5) .Polaris-Button,\n.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card > div:nth-child(5) .Polaris-Button {\n  width: 100%;\n}\n\n.BC-Page__SubscriptionV3\n  .packages\n  div\n  .Polaris-Card\n  > div:nth-child(5)\n  .Polaris-Button\n  .Polaris-Button__Content,\n.BC-Page__SubscriptionV3-Package\n  .packages\n  div\n  .Polaris-Card\n  > div:nth-child(5)\n  .Polaris-Button\n  .Polaris-Button__Content {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card > div:nth-child(5) p,\n.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card > div:nth-child(5) p {\n  display: flex;\n  align-items: center;\n  margin-left: 16px;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card > div:nth-child(5) p {\n  margin-left: 8px;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card:nth-child(2),\n.BC-Page__SubscriptionV3-Package .packages div .package-suggest-card {\n  background: #f1f8f5;\n  border: 1px solid #008060;\n  border-radius: 4px;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card {\n  border: 1px solid var(--border-subdued, #c9cccf);\n  box-shadow: none;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card .package-action .Polaris-Button {\n  width: 100%;\n  border: 1px solid #008060;\n  border-radius: 4px;\n  height: 44px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card .package-action .Polaris-Button {\n  width: 100%;\n  border: 1px solid #008060;\n  border-radius: 4px;\n  height: 56px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.BC-Page__SubscriptionV3\n  .packages\n  div\n  .Polaris-Card:not(:nth-child(2))\n  .package-action\n  .Polaris-Button,\n.BC-Page__SubscriptionV3-Package\n  .packages\n  div\n  .Polaris-Card:not(.package-suggest-card)\n  .package-action\n  .Polaris-Button {\n  color: #008060;\n  background: #ffffff;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card .package-action .Polaris-Button--disabled,\n.BC-Page__SubscriptionV3-Package\n  .packages\n  div\n  .Polaris-Card\n  .package-action\n  .Polaris-Button--disabled {\n  border: 1px solid rgb(165, 164, 164);\n}\n\n.BC-Page__SubscriptionV3\n  .packages\n  div\n  .Polaris-Card:not(:nth-child(2))\n  .package-action\n  .Polaris-Button--disabled,\n.BC-Page__SubscriptionV3-Package\n  .packages\n  div\n  .Polaris-Card:not(.package-suggest-card)\n  .package-action\n  .Polaris-Button--disabled {\n  background: var(--p-action-primary-disabled);\n  color: var(--p-text-disabled);\n}\n\n.BC-Page__SubscriptionV3\n  .packages\n  div\n  .Polaris-Card:not(:nth-child(2))\n  .package-action\n  .Polaris-Button:hover,\n.BC-Page__SubscriptionV3-Package\n  .packages\n  div\n  .Polaris-Card:not(.package-suggest-card)\n  .package-action\n  .Polaris-Button:hover {\n  background: #f1f8f5 !important;\n  box-shadow: #f1f8f5 !important;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card .question-title,\n.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card .question-title {\n  font-weight: 600;\n  font-size: 16px !important;\n  line-height: 28px !important;\n}\n\n.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card .advances-package {\n  margin: 0;\n  margin-top: 0 !important;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card .advances-package .advance-line {\n  margin-top: 16px;\n  display: flex;\n  gap: 8px;\n}\n\n.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card .advances-package .advance-line {\n  margin-top: 16px;\n  display: flex;\n  gap: 12px;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card .advances-package .advance-line .Polaris-Icon,\n.BC-Page__SubscriptionV3-Package\n  .packages\n  div\n  .Polaris-Card\n  .advances-package\n  .advance-line\n  .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  margin-left: 0px;\n  margin-right: 0px;\n  max-width: 14px;\n}\n\n.BC-Page__SubscriptionV3\n  .packages\n  div\n  .Polaris-Card\n  .advances-package\n  .advance-line\n  .Polaris-Icon\n  svg,\n.BC-Page__SubscriptionV3-Package\n  .packages\n  div\n  .Polaris-Card\n  .advances-package\n  .advance-line\n  .Polaris-Icon\n  svg {\n  fill: #5e8e3e;\n}\n\n.BC-Page__SubscriptionV3 .packages .compare-package {\n  margin-top: 20px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding: 12px 160px;\n  gap: 66px;\n  align-items: center;\n  border-radius: 8px;\n  border: 1px solid var(--border-neutral-subdued, #babfc3);\n  background: var(--surface-neutral-subdued, #f6f6f7);\n}\n\n.BC-Page__SubscriptionV3 .packages .compare-package p:first-child {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.BC-Page__SubscriptionV3 .packages .compare-package p:last-child {\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.BC-Page__SubscriptionV3 .packages .compare-package .Polaris-Button {\n  background: var(--surface-neutral-subdued, #f6f6f7);\n}\n\n.BC-Page__SubscriptionV3-Package .extend-addons {\n  display: flex;\n  margin-top: 40px !important;\n  margin: auto;\n  justify-content: center;\n  height: 76px;\n  letter-spacing: 1px;\n}\n\n.BC-Page__SubscriptionV3-Package .extend-addons > div {\n  background: #f1f8f5;\n  display: flex;\n  padding: 32px;\n  gap: 24px;\n  border-radius: 8px;\n  align-items: center;\n}\n\n.BC-Page__SubscriptionV3-Package .extend-addons p {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.review-addon-modal,\n.review-package-modal {\n  display: flex;\n  max-height: 680px;\n  min-height: 624px;\n}\n\n.review-addon-modal .review-addon,\n.review-package-modal .review-package {\n  width: 65%;\n}\n\n.review-addon-modal .review-addon,\n.review-package-modal .review-package .Polaris-Scrollable {\n  padding: 20px;\n  height: 100%;\n}\n\n.review-package-modal .review-package .Polaris-Scrollable > div:first-child {\n  font-size: 20px;\n  line-height: 28px;\n}\n\n.review-package-modal .review-package .Polaris-Scrollable .link {\n  color: #2c6ecb;\n  cursor: pointer;\n}\n\n.review-package-modal .review-package .Polaris-Scrollable .link .Polaris-Icon svg {\n  fill: #2c6ecb;\n}\n\n.review-package-modal .review-package .Polaris-Scrollable > div:not(:first-child) {\n  margin-top: 20px;\n}\n\n.review-package-modal .review-package .Polaris-Scrollable .selected {\n  border: 1px solid #2c6ecb !important;\n}\n\n.review-package-modal\n  .review-package\n  .Polaris-ChoiceList\n  .Polaris-ChoiceList__ChoiceItem\n  .Polaris-Choice__Label {\n  font-weight: 600;\n}\n\n.review-package-modal .review-package .Polaris-ChoiceList .Polaris-ChoiceList__ChoiceItem {\n  padding: 12px 28px 16px 17px;\n  width: 100%;\n  height: auto;\n  border: 1px solid #dfe3e8;\n  border-radius: 8px;\n  margin-top: 20px;\n}\n\n.review-package-modal .review-package .explore-addon-card > div {\n  margin-top: 8px;\n}\n\n.review-package-modal .review-package .explore-addon-card .Polaris-Select {\n  width: 36%;\n}\n\n.review-package-modal .review-package .explore-addon-card .addon-card-price {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n}\n\n.review-addon-modal .addon-billing,\n.review-package-modal .package-billing {\n  padding: 20px;\n  width: 340px;\n  background: white;\n  border-radius: 8px;\n}\n\n.review-addon-modal .addon-billing .billing-title,\n.review-package-modal .package-billing .billing-title {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 4px;\n  margin-bottom: 32px;\n}\n\n.review-package-modal .package-billing .package-info div > div:nth-child(2) {\n  margin-top: 8px !important;\n}\n\n.review-package-modal .discount-breakdown {\n  margin-right: 15px;\n  float: right;\n  color: #008060;\n  font-weight: var(--p-font-weight-semibold);\n}\n\n.review-addon-modal .addon-billing .discount-code-info .discount-applied > div:nth-child(4),\n.review-package-modal .package-billing .discount-code-info .discount-applied > div:nth-child(4),\n.review-addon-modal .addon-billing > .Polaris-Button,\n.review-addon-modal .addon-billing .total,\n.review-addon-modal .addon-billing .discount-code-info,\n.review-package-modal .package-billing > .Polaris-Button,\n.review-package-modal .package-billing .total,\n.review-package-modal .package-billing .discount-code-info {\n  margin-top: 20px;\n}\n\n.cost-breakdown-modal .code,\n.BC-Page__SubscriptionV3\n  .planStatus\n  .Polaris-Stack\n  .Polaris-Stack__Item:last-child\n  .Polaris-TextContainer\n  .code,\n.review-addon-modal .addon-billing .discount-code-info .discount-applied .code div,\n.review-package-modal .package-billing .discount-code-info .discount-applied .code div {\n  display: flex;\n  background: #f1f8f5;\n  border-radius: 4px;\n  margin-top: 4px;\n  width: auto;\n  padding: 5px;\n  height: 24px;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n}\n\n.cost-breakdown-modal .code .Polaris-Icon,\n.BC-Page__SubscriptionV3\n  .planStatus\n  .Polaris-Stack\n  .Polaris-Stack__Item:last-child\n  .Polaris-TextContainer\n  .code\n  .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  margin-left: 8px;\n  width: 16px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.review-addon-modal .review-addon a,\n.review-package-modal .review-package a {\n  text-decoration: none;\n  color: #2c6ecb;\n}\n\n.review-addon-modal .review-addon .Polaris-Icon,\n.review-package-modal .review-package .Polaris-Icon,\n.review-addon-modal .addon-billing .discount-code-info .discount-applied .Polaris-Icon,\n.review-package-modal .package-billing .discount-code-info .discount-applied .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.review-addon-modal .review-addon a .Polaris-Icon svg,\n.review-package-modal .review-package a .Polaris-Icon svg,\n.review-addon-modal\n  .addon-billing\n  .discount-code-info\n  .discount-applied\n  > div:nth-child(4)\n  .Polaris-Icon\n  svg,\n.review-package-modal\n  .package-billing\n  .discount-code-info\n  .discount-applied\n  > div:nth-child(4)\n  .Polaris-Icon\n  svg {\n  fill: #2c6ecb;\n}\n\n.review-package-modal .Polaris-Icon {\n  margin: unset !important;\n}\n\n.review-addon-modal .addon-billing .discount-code-info .discount-applied .code div .Polaris-Icon,\n.review-package-modal\n  .package-billing\n  .discount-code-info\n  .discount-applied\n  .code\n  div\n  .Polaris-Icon {\n  width: 15px;\n  height: 13px;\n  margin-left: 8px;\n  cursor: pointer;\n  margin-right: unset;\n}\n\n.review-addon-modal .addon-billing .discount-code-info .discount-applied .code,\n.review-package-modal .package-billing .discount-code-info .discount-applied .code {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.review-addon-modal\n  .addon-billing\n  .discount-code-info\n  .discount-applied\n  .code\n  .Polaris-Button--iconOnly,\n.review-package-modal\n  .package-billing\n  .discount-code-info\n  .discount-applied\n  .code\n  .Polaris-Button--iconOnly {\n  top: 8px !important;\n  right: 8px !important;\n}\n\n.review-addon-modal .addon-billing .discount-code-info .discount-applied > div:nth-child(3),\n.review-package-modal .package-billing .discount-code-info .discount-applied > div:nth-child(3) {\n  color: #6d7175;\n  margin-top: 8px;\n  font-size: 12px;\n}\n\n.review-addon-modal\n  .addon-billing\n  .discount-code-info\n  .discount-applied\n  .code\n  .Polaris-TextStyle--variationStrong,\n.review-package-modal\n  .package-billing\n  .discount-code-info\n  .discount-applied\n  .code\n  .Polaris-TextStyle--variationStrong {\n  color: #008060;\n  margin-right: 10px;\n}\n\n.review-addon-modal .addon-billing > .Polaris-Button,\n.review-package-modal .package-billing > .Polaris-Button {\n  width: 100%;\n}\n\n.review-addon-modal .addon-billing .total,\n.review-addon-modal .addon-billing .package-info div div,\n.review-package-modal .package-billing .total,\n.review-package-modal .package-billing .package-info div.detail-bill {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.review-package-modal .package-billing .package-info div.detail-bill .detail-bill-addon {\n  display: flex;\n}\n\n.review-package-modal .package-billing .package-info div .Polaris-Select {\n  width: 60%;\n  margin-bottom: 5px;\n}\n\n.review-package-modal .package-billing .discount-code-info > p,\n.review-addon-modal .addon-billing .discount-code-info > p {\n  color: #2c6ecb;\n  cursor: pointer;\n}\n\n.review-package-modal .package-billing .discount-code-info .error,\n.review-addon-modal .addon-billing .discount-code-info .error {\n  color: #de3618;\n  line-height: 20px;\n  margin-top: 4px;\n}\n\n/* addon-review modal */\n\n.review-addon-modal .review-addon > div:not(:first-child) {\n  margin-top: 20px;\n}\n\n.review-addon-modal .review-addon > div:first-child > p {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n}\n\n.review-addon-modal .addon-billing .addon-info,\n.review-addon-modal .review-addon > div:nth-child(3),\n.review-addon-modal .review-addon > div:first-child {\n  display: flex;\n  justify-content: space-between;\n}\n\n.review-addon-modal .addon-billing .addon-info {\n  align-items: center;\n}\n\n.review-addon-modal .review-addon > div:nth-child(2) .addon-visualMerchandising {\n  display: grid;\n  gap: 8px;\n}\n\n.review-addon-modal .review-addon > div:nth-child(2) > div > div {\n  flex: 40%;\n}\n\n.review-addon-modal .review-addon > div:nth-child(2) {\n  width: 100%;\n  padding: 20px;\n  background: #fafbfb;\n  border-radius: 8px;\n}\n\n.review-addon-modal .review-addon > div:nth-child(2) > div {\n  margin-top: 16px;\n}\n\n.review-addon-modal .review-addon > div:nth-child(2) > div.addon-aiPowerSearch {\n  display: block;\n}\n\n.review-addon-modal .review-addon > div:nth-child(2) > div.addon-aiPowerSearch > div {\n  margin-bottom: 8px;\n}\n\n.review-addon-modal .review-addon > div:nth-child(2) div div div span.sub-addon-title {\n  font-size: 16px;\n  line-height: 24px;\n  margin-left: 2px;\n}\n\n.review-addon-modal .review-addon > div:nth-child(2) div div div span.sub-addon-new {\n  margin-left: 4px;\n}\n\n.review-addon-modal .review-addon > div:nth-child(2) div div > p {\n  font-size: 12px;\n  line-height: 16px;\n  margin-left: 18px;\n}\n\n.review-addon-modal .review-addon > div:nth-child(2) .Polaris-Icon {\n  fill: #008060;\n  height: 1.5rem;\n  width: 1rem;\n}\n\n.review-addon-modal .review-addon > div:nth-child(3) > div {\n  flex: 1 1 1;\n  text-align: center;\n}\n\n.review-addon-modal .review-addon > div:nth-child(3) > div img {\n  margin: auto;\n}\n\n.review-addon-modal .review-addon > div:nth-child(4) ul {\n  margin-top: 4px;\n  padding-left: 24px;\n}\n\n.review-addon-modal .addon-billing .Polaris-Select {\n  width: 60%;\n}\n\n.review-addon-modal .addon-billing .sub-addon-info {\n  font-size: 12px;\n  line-height: 16px;\n  color: #6d7175;\n  margin-top: 4px;\n}\n\n.review-addon-modal .addon-billing .describe-button {\n  width: 85%;\n  margin: auto;\n  text-align: center;\n  margin-top: 8px;\n}\n\n.review-addon-modal .review-addon .Polaris-Icon {\n  margin-top: 0 !important;\n}\n\n.review-addon-modal .review-addon .Polaris-Icon svg {\n  max-width: none;\n  max-height: none;\n  width: auto;\n}\n\n.review-addon-modal .addon-modal-highlight {\n  background-image: url('https://cdn.boostcommerce.io/assets/common/background-warning-mini.png');\n  background-repeat: no-repeat;\n  background-position-y: bottom;\n  background-size: contain;\n  border-radius: 8px;\n  padding: 8px;\n  margin-top: -20px;\n  margin-bottom: 20px;\n}\n\n.review-addon-modal .addon-modal-highlight ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.review-addon-modal .addon-modal-highlight ul .Polaris-Icon {\n  margin: unset;\n  display: inline-flex;\n  vertical-align: top;\n}\n\n/* end  */\n.BC-Page__SubscriptionV3 .textSetupComplete:first-child {\n  margin-top: 0.6875rem;\n}\n\n.BC-Page__SubscriptionV3 .textSetupComplete {\n  color: #212b36;\n  margin-top: 1rem;\n}\n\n.BC-Page__SubscriptionV3 .textSetupComplete:last-child {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__SubscriptionV3 .noUiButton {\n  display: inline-flex;\n  margin-top: 5px;\n  margin-left: 1px;\n}\n\n.BC-Page__SubscriptionV3 .noUiMaxProductLabel {\n  margin-top: -38px;\n  position: absolute;\n  right: -40px;\n  font-size: 14px;\n}\n\n.BC-Page__SubscriptionV3 .noUi-active {\n  box-shadow: none;\n}\n\n.BC-Page__Subscription .noUiButton .Polaris-Icon {\n  width: 0.9375rem;\n  height: 0.9375rem;\n}\n\n.BC-Page__SubscriptionV3 .noUiButton .Polaris-Icon:last-child {\n  margin-left: -7px;\n}\n\n.BC-Page__SubscriptionV3 .information-pricing-V2 {\n  padding: 0 0.75rem;\n}\n\n.BC-Page__SubscriptionV3 .information-pricing-V2 p {\n  margin: 1.25rem 0;\n}\n\n.BC-Page__SubscriptionV3 .information-pricing-V2 .btn-show {\n  text-align: center;\n  margin: 0.75rem;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans {\n  border: 0.0625rem solid #d8e6ff;\n  background: #f9fbff;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans table {\n  table-layout: fixed;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-DataTable__Cell {\n  border-right: 0.0625rem solid #d8e6ff;\n  border-bottom: 0.0625rem solid #d8e6ff;\n  font-weight: 500;\n  text-align: center;\n  white-space: normal;\n  padding: 1rem 1.5rem;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans tr .Polaris-DataTable__Cell:first-child {\n  padding-right: 0;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-DataTable__Cell.Column__5 {\n  width: 132px;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-DataTable__Cell.Column__1 {\n  width: 664px;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-DataTable__Cell:first-child {\n  width: 268px;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-DataTable__Cell.left-title,\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-DataTable__Cell.content-description,\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .row-heading .Polaris-DataTable__Cell {\n  text-align: left;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .row-without-border .Polaris-DataTable__Cell,\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans tr .Polaris-DataTable__Cell:last-child {\n  border-right: none;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .row-heading td.Polaris-DataTable__Cell {\n  background: #d8e6ff;\n  padding: 1.125rem 1.5rem;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .row-heading button,\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .left-title button {\n  color: inherit;\n  text-decoration: none;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .row-heading button:active .Polaris-Button__Content,\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .left-title button:active .Polaris-Button__Content {\n  background: none;\n}\n\n.BC-Page__SubscriptionV3\n  .BC_DataTable_Plans\n  .row-heading\n  .Polaris-Button__DisclosureIcon\n  .Polaris-Icon__Svg,\n.BC-Page__SubscriptionV3\n  .BC_DataTable_Plans\n  .left-title\n  .Polaris-Button__DisclosureIcon\n  .Polaris-Icon__Svg {\n  fill: inherit;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .row-heading .Polaris-Button__Text {\n  text-transform: uppercase;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 28px;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans th.Polaris-DataTable__Cell {\n  border-right: 0.0625rem solid #ffffff;\n  background: #d8e6ff;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 22px;\n  padding: 0.625rem;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans th.Polaris-DataTable__Cell:last-child {\n  padding: 0.625rem 1rem;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-Icon--colorGreen {\n  margin-left: auto;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-DataTable__Cell.content-description {\n  font-size: 12px;\n  font-weight: normal;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-DataTable__Cell.content-description > span {\n  display: block;\n}\n\n.BC-Page__SubscriptionV3\n  .BC_DataTable_Plans\n  .Polaris-DataTable__Cell.content-description\n  > span:before {\n  content: '-';\n  margin-right: 5px;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .Polaris-Badge {\n  background-color: #d8e6ff;\n  color: #2459b4;\n  border: none;\n  padding: 0 0.3125rem;\n  font-size: 10px;\n  font-weight: 600;\n  margin-left: 4px;\n}\n\n.BC-Page__SubscriptionV3 .BC_DataTable_Plans .icon-minus .Polaris-Icon {\n  width: 0.75rem;\n  padding-top: 0.3125rem;\n}\n\n.plan-review-brand {\n  margin-top: 2.5rem;\n  margin-bottom: 1.875rem;\n}\n\n.BC-Page__SubscriptionV3-Package .card-title-uppercase .Polaris-Heading,\n.BC-Page__SubscriptionV3-Addon .card-title-uppercase .Polaris-Heading,\n.BC-Page__SubscriptionV3 .addon-card-preview .card-title-uppercase .Polaris-Heading,\n.BC-Page__SubscriptionV3 .review .title .Polaris-Heading,\n.BC-Page__SubscriptionV3 .questions .title .Polaris-Heading {\n  font-weight: bold;\n  font-size: 28px;\n  line-height: 36px;\n}\n\n.BC-Page__SubscriptionV3-Addon .card-title-uppercase p {\n  text-transform: none !important;\n}\n\n.BC-Page__SubscriptionV3-Package .Polaris-FullscreenBar,\n.BC-Page__SubscriptionV3-Addon .Polaris-FullscreenBar {\n  z-index: 518;\n}\n\n.BC-Page__SubscriptionV3 .addon-card-preview > .Polaris-Card {\n  min-height: 510px;\n}\n\n.BC-Page__SubscriptionV3 .addon-card-preview .Polaris-Card .Polaris-Card__Section .Polaris-Card {\n  max-width: 264px;\n  margin-top: unset;\n}\n\n.BC-Page__SubscriptionV3\n  .addon-card-preview\n  .Polaris-Card\n  .Polaris-Card\n  .addon-card-detail\n  .addon-price {\n  align-items: unset;\n  margin-top: 8px;\n}\n\n.Polaris-Card .addon-card-detail .addon-price {\n  font-size: 24px;\n  font-weight: 500;\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  min-height: 36px;\n}\n\n.Polaris-Card .addon-card-detail .addon-price > span,\n.Polaris-Card .addon-card-detail .addon-price > div {\n  flex: 40% 1;\n}\n\n.BC-Page__SubscriptionV3-Addon .Polaris-FullscreenBar div {\n  display: flex;\n  flex-grow: 1;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 36px;\n}\n\n.BC-Page__SubscriptionV3-Addon .addons-list .Polaris-Card {\n  max-width: 363px;\n  /* max-height: 400px; */\n  height: max-content;\n  margin-top: unset;\n}\n\n.BC-Page__SubscriptionV3-Addon .addons-list .Polaris-Card .addon-card-detail,\n.BC-Page__SubscriptionV3 .addon-card-preview .Polaris-Card .Polaris-Card .addon-card-detail {\n  margin: 8px 16px 16px 16px;\n}\n\n.BC-Page__SubscriptionV3-Addon .addons-list .Polaris-Card .addon-card-detail {\n  min-height: 200px;\n}\n\n.BC-Page__SubscriptionV3-Addon .addons-list .Polaris-Card .addon-card-detail button {\n  position: absolute;\n  bottom: 0px;\n}\n\n.BC-Page__SubscriptionV3-Addon .addons-list .Polaris-Card .addon-card-detail ul,\n.BC-Page__SubscriptionV3 .addon-card-preview .Polaris-Card .Polaris-Card .addon-card-detail ul {\n  padding-left: 24px;\n  margin: 8px 0 16px 0;\n}\n\n.BC-Page__SubscriptionV3 .addon-card-preview .Polaris-Card .Polaris-Card .addon-card-detail {\n  min-height: 295px;\n}\n\n.BC-Page__SubscriptionV3-Addon .addons-list .Polaris-Card .addon-card-detail,\n.BC-Page__SubscriptionV3 .addon-card-preview .Polaris-Card .Polaris-Card .addon-card-detail {\n  position: relative;\n}\n\n.BC-Page__SubscriptionV3 .addon-card-preview .Polaris-Card .Polaris-Card .addon-card-detail button {\n  width: 100%;\n  position: absolute;\n  bottom: 20px;\n}\n\n.BC-Page__SubscriptionV3\n  .addon-card-preview\n  .Polaris-Card\n  .Polaris-Card\n  .addon-card-detail\n  .Polaris-Select {\n  max-width: 70%;\n  margin-top: 8px;\n}\n\n.BC-Page__SubscriptionV3-Addon .addons-list .Polaris-Card .addon-card-detail button {\n  margin-top: 8px;\n  min-width: 45%;\n}\n\n.BC-Page__SubscriptionV3-Addon .addons-list {\n  background: #ffffff;\n  border-radius: 0px 0px 8px 8px;\n  max-width: 1170px;\n  /* max-height: 440px; */\n  padding: 20px;\n  margin-top: 40px !important;\n  margin: auto;\n  display: flex;\n  gap: 20px;\n}\n\n.BC_AddonList-Sliders {\n  position: inherit;\n  min-height: 443px;\n  padding-bottom: 1px;\n}\n\n.BC_AddonList-Sliders ul li {\n  /* width: 284px !important; */\n  padding-right: 19px;\n  margin-right: 1px;\n  margin-left: 1px;\n}\n\n.subscriptionV3-questions .title .Polaris-Heading,\n.plan-review-brand .Polaris-Heading {\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 32px;\n}\n\n.BC-Page__SubscriptionV3 .subscriptionV3-questions .Polaris-Card__Header {\n  border-bottom: unset !important;\n}\n\n.plan-review-brand .brand-items {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 40px;\n  margin: 16px 0;\n}\n\n.BC-Page__SubscriptionV3 .review {\n  margin-top: 4.3125rem;\n  margin-bottom: 2.75rem;\n}\n\n.BC-Page__SubscriptionV3 .review .title {\n  margin-bottom: 1.75rem;\n}\n\n.BC-Page__SubscriptionV3 .review .Polaris-Layout__Section--oneThird {\n  flex: 1 1 21.875rem;\n}\n\n.BC-Page__SubscriptionV3 .review .utilities {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  text-align: center;\n  margin: 1.5rem auto;\n}\n\n.BC-Page__SubscriptionV3 .review .Polaris-Layout__Section .utilities:first-child {\n  margin-top: 0;\n}\n\n.BC-Page__SubscriptionV3 .review .Polaris-Layout__Section .utilities:last-child {\n  margin-bottom: 0;\n}\n\n.BC-Page__SubscriptionV3 .review .utilities > div {\n  text-align: center;\n  flex-direction: column;\n  flex-basis: 100%;\n  flex: 1;\n}\n\n.BC-Page__SubscriptionV3 .review .utilities .Polaris-Heading {\n  margin-top: 1.25rem;\n  margin-bottom: 1.5rem;\n}\n\n.BC-Page__SubscriptionV3 .review .Polaris-Card + .Polaris-Card {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__SubscriptionV3 .review .review-info {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1.25rem;\n}\n\n.BC-Page__SubscriptionV3 .review .review-content {\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 22px;\n  margin-bottom: 0.25rem;\n}\n\n.subscriptionV3-questions {\n  margin-top: 3.75rem;\n  margin-bottom: 1.25rem;\n}\n\n.subscriptionV3-questions .Polaris-Card__Header {\n  padding-bottom: 1rem;\n  padding-top: 1rem;\n}\n\n.subscriptionV3-questions .Polaris-Card__Header .Polaris-Stack {\n  flex-wrap: unset;\n}\n\n.subscriptionV3-questions\n  .Polaris-Card__Header\n  .Polaris-Stack\n  .Polaris-Stack__Item\n  .rotate-icon\n  .Polaris-Icon {\n  transform: rotate(90deg);\n}\n\n.subscriptionV3-questions .Polaris-Card__Section {\n  padding-top: 0;\n}\n\n.subscriptionV3-questions .answer p + p {\n  margin-top: 1.25rem;\n}\n\n.subscriptionV3-questions .answer p {\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 22px;\n  overflow-wrap: break-word;\n}\n\n.BC-Page__SubscriptionV3-Package .transition-enter {\n  transform: translateY(-1.25rem);\n  opacity: 0;\n  visibility: hidden;\n  z-index: -1;\n}\n\n.BC-Page__SubscriptionV3-Package .transition-enter-active {\n  transform: translateY(0%);\n  opacity: 1;\n  visibility: visible;\n  z-index: 1;\n  transition: all 0.6s ease-in;\n}\n\n.BC-Page__SubscriptionV3-Package .transition-exit {\n  transform: translateY(0);\n  opacity: 1;\n  z-index: 1;\n  visibility: visible;\n}\n\n.BC-Page__SubscriptionV3-Package .transition-exit-active {\n  transform: translateY(-1.25rem);\n  opacity: 0;\n  visibility: hidden;\n  z-index: -1;\n  transition: all 0.3s ease-out;\n}\n\n.BC-Page__SubscriptionV3-Package .item-transition {\n  overflow: hidden;\n}\n\n/* Package comparison page */\n.BC-Page__Package-Comparison .title-bar,\n.BC-Page__Package-ComparisonV4 .title-bar {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.BC-Page__Package-Comparison .choose-product-number,\n.BC-Page__Package-ComparisonV4 .choose-product-number {\n  font-size: 20px;\n}\n\n.BC-Page__Package-Comparison .choose-product-number .select-product,\n.BC-Page__Package-ComparisonV4 .choose-product-number .select-product {\n  margin: 0 auto;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  justify-content: center;\n}\n\n.BC-Page__Package-Comparison .choose-product-number .select-product .Polaris-Select,\n.BC-Page__Package-ComparisonV4 .choose-product-number .select-product .Polaris-Select {\n  width: 150px;\n}\n\n.BC-Page__Package-ComparisonV4 .Polaris-Heading,\n.BC-Page__Package-Comparison .Polaris-Heading {\n  font-size: 36px;\n  font-weight: 600;\n  line-height: 44px;\n  margin: 40px auto;\n}\n\n.package-comparison-table {\n  border-top: 0.03rem solid var(--neutral-n-30, #e4e4e9);\n  width: 80%;\n  border-radius: 4px;\n  background: var(--neutral-white, #fff);\n  margin: 24px auto;\n}\n\n.package-comparison-table .price {\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 32px;\n  text-align: center;\n}\n\n.BC-Page__Package-ComparisonV4 .package-comparison-table .price > span:first-child {\n  font-size: 36px !important;\n  font-weight: 600 !important;\n  line-height: 40px !important;\n  text-align: center;\n}\n\n.package-comparison-table .row .package-tag {\n  width: 100%;\n  height: 24px;\n  padding: 4px 43px 4px 43px;\n  gap: 4px;\n  border-radius: 8px 8px 0px 0px;\n  border: 1px 0px 1px 1px;\n  position: absolute;\n  top: -24px;\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 600;\n}\n\n.BC-Page__Package-ComparisonV4 .package-comparison-table {\n  margin-top: 64px;\n}\n\n.package-comparison-table .column-package {\n  position: relative;\n}\n\n.package-comparison-table .column-package--success {\n  background-color: #f1f8f5;\n}\n\n.package-comparison-table .row .package-tag-subdued {\n  background: #e4e5e7;\n}\n\n.package-comparison-table .row .package-tag-success {\n  background: #008060;\n  color: #ffffff;\n}\n\n.BC-Page__Package-ComparisonV4 .package-comparison-table .price span:last-child {\n  font-size: 12px !important;\n  font-weight: 600;\n  color: #6d7175;\n  line-height: 16px !important;\n}\n\n.package-comparison-table .price span {\n  font-size: 16px !important;\n  font-weight: 600;\n  line-height: 24px !important;\n}\n\n.package-comparison-table .row {\n  width: 100%;\n  height: auto;\n  display: flex;\n  margin-top: 0px;\n}\n\n.package-comparison-table .feature-collapse .action-collapse,\n.package-comparison-table .row {\n  border-left: 0.03rem solid var(--neutral-n-30, #e4e4e9);\n  border-bottom: 0.03rem solid var(--neutral-n-30, #e4e4e9);\n}\n\n.package-comparison-table .row .column {\n  height: auto;\n  padding: 12px 24px;\n}\n\n.package-comparison-table .row-header .column {\n  padding: 28px 24px !important;\n  display: grid;\n  gap: 20px;\n  align-items: center;\n  text-align: center;\n}\n\n.package-comparison-table .row-header .column p {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n}\n\n.package-comparison-table .row .column {\n  height: auto;\n  border-right: 1px solid var(--neutral-n-30, #e4e4e9);\n}\n\n.package-comparison-table .row .column:first-child {\n  width: 40%;\n}\n\n.package-comparison-table .row .column:not(:first-child) {\n  width: 24%;\n}\n\n.package-comparison-table .row .column p .Polaris-Icon {\n  margin: unset;\n}\n\n.package-comparison-table .minus-icon-value svg {\n  fill: #babec3 !important;\n}\n\n.package-comparison-table .addon-badge .Polaris-Badge {\n  background: #ffebd3;\n  height: 24px;\n}\n\n.package-comparison-table .addon-badge .Polaris-Icon {\n  width: 12px !important;\n  height: 12px !important;\n}\n\n.package-comparison-table .addon-badge .Polaris-Icon svg {\n  fill: #f48d32;\n}\n\n.package-comparison-table .feature-collapse .action-collapse:hover {\n  cursor: pointer;\n}\n\n.package-comparison-table .feature-collapse {\n  width: 100%;\n}\n\n.package-comparison-table .feature-collapse .row .column:not(:first-child) {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.package-comparison-table .feature-collapse .row .column > .Polaris-Icon {\n  width: 20px;\n  height: 20px;\n}\n\n.package-comparison-table .feature-collapse .row .column .Polaris-Badge--statusWarning span {\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n}\n\n.package-comparison-table\n  .feature-collapse\n  .row\n  .column\n  .Polaris-Badge--statusWarning\n  .Polaris-Icon {\n  width: 8px;\n  height: 8px;\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.package-comparison-table .feature-collapse .row .column .Polaris-Badge--statusNew {\n  background: var(--neutral-n-40, #a1a3ad);\n  color: var(--neutral-white, #fff);\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n}\n\n.package-comparison-table .feature-collapse .row .column ul {\n  padding-left: 20px;\n  margin-top: 4px;\n  margin-bottom: 0px;\n}\n\n.package-comparison-table .feature-collapse .action-collapse {\n  width: 100%;\n  padding: 16px 24px;\n  display: flex;\n  justify-content: space-between;\n  background: var(--neutral-bg-grey, #f7f7f7);\n  align-items: center;\n  border-right: 0.03rem solid var(--neutral-n-30, #e4e4e9);\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n}\n\n.package-comparison-table .feature-collapse .action-collapse .collapse-down {\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n/* ---------------------- */\n\n/* Theme setup */\n.BC-Page__Theme-Setup .BC-Container__Notifications > *:first-child {\n  margin-top: 2.5rem;\n}\n\n.BC-Page__Theme-Setup .theme-status-text,\n.BC-Page__Theme-Setup .theme-item-left .Polaris-TextStyle--variationStrong {\n  font-size: 1rem;\n  line-height: 1.25rem;\n}\n\n.BC-Page__Theme-Setup .Polaris-ResourceList-Item {\n  cursor: inherit;\n}\n\n.BC-Page__Theme-Setup .Polaris-ResourceList__ResourceListWrapper {\n  margin: -1rem;\n}\n\n.BC-Page__Theme-Setup .theme-item {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-Page__Theme-Setup .theme-item-left .Polaris-Badge {\n  line-height: 1rem;\n}\n\n.BC-Page__Theme-Setup .theme-item-right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.BC-Page__Theme-Setup .theme-item-right .Theme__ActionMenu .Polaris-Button {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.BC-Page__Theme-Setup .theme-item-right .Polaris-ButtonGroup__Item {\n  margin-left: 10px;\n}\n\n@media screen and (max-width: 767px) {\n  .BC-Page__Theme-Setup .theme-item-right .Polaris-ButtonGroup {\n    justify-content: right;\n  }\n}\n\n.BC-Page__Theme-Setup .clone-setting-loading .Polaris-Button {\n  width: 122px;\n}\n\n.BC-Page__Theme-Setup .BC-Page__Text {\n  margin-bottom: 1.25rem;\n}\n\n.BC-Page__Theme-Setup .BC-Page__Text:last-child {\n  margin-bottom: 0;\n}\n\n.BC-Page__Theme-Setup .BC-Page__Bottom-Text {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__Theme-Setup .BC-Page__Text .Polaris-Button__Text,\n.BC-Page__Theme-Setup .BC-Page__Bottom-Text .Polaris-Button__Text,\n.BC-Page__Layout-Switch .BC-Page__Text .Polaris-Button__Text {\n  font-weight: 600;\n}\n\n.BC-Page__Theme-Setup .BC-Theme-Setup_Form {\n  padding-top: 0.25rem;\n}\n\n.BC-Page__Theme-Setup .BC-Theme-Setup_Form .Polaris-ChoiceList__ChoiceChildren {\n  display: inline-block;\n  vertical-align: top;\n  padding-left: 0.625rem;\n}\n\n.BC-Page__Theme-Setup .BC-Theme-Setup_Form .BC-Theme-Setup_Form-Item > div.title,\n.BC-Page__Theme-Upgrade .BC-Theme-Upgrade_Form .BC-Theme-Upgrade_Form-Item > div.title,\n.BC-Page__Theme-Revert .BC-Theme-Revert_Form .BC-Theme-Revert_Form-Item > div.title,\n.BC-Page__Layout-Switch .BC-Layout-Switch_Form .BC-Layout-Switch_Form-Item > div.title {\n  padding-bottom: 0.5625rem;\n}\n\n.BC-Page__Theme-Setup .Polaris-Page-Header__Title {\n  align-items: center;\n}\n\n.BC-Page__Theme-Setup .Polaris-Header-Title__TitleMetadata .toggle-button-show {\n  margin-left: 0.625rem;\n  color: var(--p-action-primary);\n}\n\n.BC-Page__Theme-Setup .show-hide-content-wraper {\n  overflow: hidden;\n  padding: 1px;\n}\n\n/* START: new theme setup 02.2023 */\n\n.img-new-tab {\n  margin: 0 2px;\n  cursor: pointer;\n}\n\n.img-new-tab.no-underline a,\n.img-new-tab.no-underline button {\n  text-decoration: none;\n}\n\n.img-new-tab span.Polaris-Icon {\n  vertical-align: middle;\n  display: inline-block;\n  padding-bottom: 2px;\n  width: 16px;\n  height: 16px;\n  margin-top: 2px !important;\n}\n\n.icon-inline {\n  margin: 0 2px;\n  cursor: pointer;\n}\n\n.icon-inline span.Polaris-Icon {\n  vertical-align: middle;\n  display: inline-block;\n  padding-bottom: 2px;\n}\n\n.BC-Page__Theme-Setup .ThemeSetupScreenSetup.isSettingUp .Polaris-Breadcrumbs__Breadcrumb {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.BC-Page__Theme-Setup .BC-Theme-Setup_Form .Polaris-SkeletonDisplayText__DisplayText {\n  max-width: 480px;\n  height: 37px;\n}\n\n.BC-Page__Theme-Setup\n  .BC-Theme-Setup_Form.BC-Theme-Setup_Form-V2\n  .Polaris-SkeletonDisplayText__DisplayText {\n  max-width: 100%;\n}\n\n.BC-Page__Theme-Setup\n  .BC-Theme-Setup_Form.BC-Theme-Setup_Form-V2\n  .Polaris-ChoiceList__ChoiceChildren\n  a {\n  display: inline-flex;\n  gap: 10px;\n}\n\n.BC-Page__Theme-Setup .BC-Theme-Setup_Form .select-theme-refresh {\n  height: 20px;\n}\n\n@keyframes rotation {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(359deg);\n  }\n}\n\n.BC-Page__Theme-Setup .BC-Theme-Setup_Form .select-theme-refresh.refreshing {\n  animation: rotation 2s infinite linear;\n}\n\n.BC-Page__Theme-Setup .theme-setup-heading .Polaris-Stack {\n  align-items: center;\n}\n\n.BC-Page__Theme-Setup .theme-setup-heading .Polaris-Stack button {\n  width: 36px;\n}\n\n.BC-Page__Theme-Setup .Polaris-Stack {\n  align-items: center;\n}\n\n.BC-Page__Theme-Setup .theme-setup-menu {\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.BC-Page__Theme-Setup .theme-setup-menu .theme-setup-menu-action button:last-child {\n  margin-left: 16px;\n}\n\n.BC-Page__Theme-Setup .select-theme {\n  width: 520px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.BC-Page__Theme-Setup .select-theme-warning {\n  margin-top: 12px;\n  color: #916a00;\n}\n\n.theme-turbo-warning {\n  display: flex;\n  padding: 10px 0;\n}\n\n.theme-turbo-warning .icon {\n  padding: 2px 4px 4px 0px;\n}\n\n.theme-turbo-warning {\n  font-size: 14px;\n  color: #916a00;\n}\n\n.theme-turbo-warning.theme-turbo-warning--default {\n  color: rgb(32, 34, 35);\n}\n\n.theme-turbo-warning .content {\n  padding-left: 4px;\n}\n\n.theme-turbo-warning .title {\n  font-weight: 600;\n}\n\n.theme-turbo-warning ul {\n  margin: 6px 0;\n  margin-block-start: 0;\n  padding-inline-start: 26px;\n}\n\n.theme-turbo-warning .Polaris-Button.Polaris-Button--primary {\n  background: #b98900;\n  margin-top: 0;\n}\n\n.theme-turbo-warning .Polaris-Button.Polaris-Button--primary:hover {\n  background: #8f6901;\n}\n\n.theme-turbo-warning .Polaris-Banner--statusWarning {\n  background: #fff5ea;\n  border-color: #e1b878;\n  padding: 8px;\n  margin-bottom: 10px;\n}\n\n.theme-turbo-warning .Polaris-Banner--statusWarning .Polaris-Banner__Ribbon {\n  display: none;\n}\n\n.theme-turbo-warning .warning-inTurbo-live-themes {\n  margin-bottom: 8px;\n}\n\n.theme-turbo-warning .warning-inTurbo-live-themes .Polaris-Link {\n  display: inline-flex;\n  align-items: center;\n  color: #2c6ecb !important;\n  gap: 2px;\n  text-decoration: none;\n}\n\n.theme-turbo-warning .warning-inTurbo-live-themes .Polaris-Link .Polaris-Icon {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n  fill: #2c6ecb;\n}\n\n.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide {\n  margin-top: 25px;\n  border-bottom: 1px solid #e1e3e5;\n  padding-bottom: 25px;\n}\n\n.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide,\n.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .p1,\n.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .p2 {\n  display: flex;\n  gap: 10px;\n}\n\n.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .p2 .line {\n  border-left: 1px solid var(--p-interactive);\n}\n\n.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide {\n  justify-content: space-between;\n  padding-right: 30px;\n}\n\n.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .Polaris-Link {\n  display: inline-flex;\n  text-decoration: none;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .Polaris-Link:hover {\n  text-decoration: underline;\n}\n\n.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .Polaris-Link img {\n}\n\n.BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .Polaris-Link .Polaris-Icon {\n  width: 1rem;\n  height: 1rem;\n}\n\n.BC-Page__Theme-Setup .select-theme > div {\n  width: 480px;\n}\n\n@media screen and (max-width: 1024px) {\n  .BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide {\n    flex-direction: column;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide,\n  .BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .p2 {\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .BC-Shopify-Integration_Select-Theme-Form .theme-turbo-guide .p2 .Polaris-Icon {\n    margin: unset;\n  }\n}\n\n.BC-Page__Theme-Setup .select-theme .BC-Select__control--is-disabled .BC-Select__single-value {\n  color: var(--p-text-subdued) !important;\n}\n\n.BC-Page__Theme-Setup .feature-installed-info {\n  color: #008060;\n  margin-bottom: 10px;\n}\n\n.BC-Page__Theme-Setup .list-features-select > div {\n  margin-bottom: 12px;\n}\n\n.BC-Page__Theme-Setup .select-recommedation-wrapper {\n  /* border: 1px solid red;; */\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin-bottom: 15px;\n  margin-top: -15px;\n}\n\n.BC-Page__Theme-Setup .select-recommedation-wrapper div:nth-child(2) {\n  width: 356px;\n}\n\n.BC-Page__Theme-Setup .ListRecommendationWidgets {\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  margin-bottom: 10px;\n  min-height: 222px;\n  padding: 17px;\n}\n\n.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .heading {\n  font-weight: bold;\n}\n\n.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .heading,\n.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .row {\n  display: flex;\n  padding: 12px 0;\n}\n\n.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .data {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .heading div:nth-child(1),\n.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .row div:nth-child(1) {\n  width: 30px;\n  display: flex;\n  align-items: flex-start;\n}\n\n.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .heading div:nth-child(2),\n.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .row div:nth-child(2) {\n  width: 220px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .heading div:nth-child(3),\n.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .row div:nth-child(3) {\n  flex: 1;\n  max-width: 379px;\n}\n\n.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .heading div:nth-child(4),\n.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .row div:nth-child(4) {\n  width: 230px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .row div:nth-child(4) img {\n  cursor: pointer;\n}\n\n.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .data {\n  height: 100%;\n}\n\n.BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .empty {\n  height: 190px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n@media screen and (max-width: 768px) {\n  .BC-Page__Theme-Setup .ListRecommendationWidgets {\n    overflow-y: auto;\n  }\n\n  .BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper {\n    min-width: 800px;\n  }\n\n  .BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .heading div:nth-child(3),\n  .BC-Page__Theme-Setup .ListRecommendationWidgets .wrapper .content .row div:nth-child(3) {\n    flex: 1;\n    min-width: 300px;\n  }\n}\n\n.BC-Page__Theme-Setup .select-recommedation-widget .add-widget-action {\n  text-align: right;\n}\n\n.BC-Page__Theme-Setup .select-recommedation-widget .add-widget-action p {\n  color: #2c6ecb;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.BC-Page__Theme-Setup .theme-setup-v3-complete div.content {\n  margin-bottom: 12px;\n}\n\n.BC-Page__Theme-Setup .theme-setup-v3-complete .theme-setup-v3-complete-action button {\n  margin-right: 10px;\n}\n\n.BC-Page__Theme-Setup .theme-setup-v3-complete .theme-setup-v3-complete-action u {\n  cursor: pointer;\n}\n\n.BC-Page__Theme-Setup .theme-settup-upgrade-running {\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  gap: 10px;\n  background: #f1f8f5;\n  border: 1px solid #95c9b4;\n  border-radius: 8px;\n}\n\n.BC-Page__Theme-Setup .theme-settup-upgrade-running .title {\n  display: flex;\n  align-items: center;\n  padding: 0px;\n  gap: 10px;\n}\n\n.BC-Page__Theme-Setup .running {\n  animation: rotation 2s infinite linear;\n}\n\n.BC-Page__Theme-Setup .theme-settup-upgrade-running .title span {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n  color: #008060;\n}\n\n.BC-Page__Theme-Setup .theme-info {\n  display: flex;\n}\n\n.BC-Page__Theme-Setup .theme-info .Polaris-Icon {\n  margin: 0;\n  margin-right: 2px;\n}\n\n.BC-Page__Theme-Setup .theme-info .Polaris-TextStyle--variationWarning {\n  margin-right: 4px;\n}\n\n/* END: new theme setup 02.2023 */\n\n.BC-Page__Theme-Setup .show-hide-content {\n  -webkit-transition-property:\n    opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94),\n    margin-top 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  /* Safari */\n  transition:\n    opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94),\n    margin-top 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n#BC-Button__Theme-Setup-Refresh {\n  display: flex;\n  align-items: center;\n}\n\n#BC-Button__Theme-Setup-Refresh > *:not(:first-child) {\n  margin-left: 0.1875rem;\n}\n\n#BC-Button__Theme-Setup-Refresh .Polaris-Icon {\n  width: 0.75rem;\n  height: 0.75rem;\n}\n\n/* Theme revert */\n/* Layout switch */\n.BC-Page__Theme-Revert .Polaris-Banner__Content,\n.BC-Page__Layout-Switch .Polaris-Banner__Content,\n.BC-Page__StopWords .Polaris-Banner__Content {\n  padding: 0.5rem 0;\n}\n\n.BC-Page__Theme-Revert .Polaris-Banner__Content a,\n.BC-Page__Layout-Switch .Polaris-Banner__Content a {\n  font-weight: 600;\n}\n\n.BC-Theme-Revert_Form-Item.second,\n.BC-Layout-Switch_Form-Item.second {\n  padding-top: 0.5625rem;\n}\n\n.BC-Page__Layout-Switch .BC-Layout-Switch_Form .Polaris-ChoiceList__ChoiceChildren {\n  display: inline-block;\n  vertical-align: top;\n  padding-left: 0.625rem;\n}\n\n/* Page successs */\n.BC-Page_Success .Polaris-Banner__Content {\n  padding-top: 0.6875rem;\n}\n\n/* Translation */\n.BC-Page__Translation .search {\n  padding: 1rem 1rem 0.75rem;\n}\n\n.BC-Page__Translation .recommendation .translate-by-widget-type {\n  color: #202223;\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 24px;\n  margin-top: 10px;\n}\n\n.BC-Page__Translation .tabContent .Polaris-Stack__Item {\n  width: 48%;\n  display: inline-block;\n  /* margin-bottom: auto; */\n}\n\n.BC-Page__Translation .tabContent .Polaris-Stack__Item:last-child {\n  width: 47%;\n  float: right;\n}\n\n.BC-Page__Translation .tabContent .first .Polaris-Stack__Item {\n  margin-top: 0;\n}\n\n.BC-Page__Translation .tabContent .Polaris-Labelled__LabelWrapper {\n  margin-top: 1.25rem;\n}\n\n.BC-Page__Translation .tabContent .tab-section {\n  margin-bottom: 35px;\n}\n\n.BC-Page__Translation .tabContent .tab-section:last-child {\n  margin-bottom: 0;\n}\n\n.BC-Page__Translation .tabContent .tab-section__title {\n  margin-top: 5px;\n  margin-bottom: 15px;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.BC-Page__Translation .tabContent .tab-section__title--collapse {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n}\n\n.BC-Page__Translation\n  .Polaris-Page\n  > div:not(.Polaris-Page-Header)\n  > .Polaris-Layout\n  > .Polaris-Layout__Section:not(:first-child)\n  > .languages {\n  margin-top: 0.5rem;\n}\n\n.BC-Page__Translation .languages .Polaris-Button {\n  min-width: 148px;\n}\n\n.BC-Page__Translation .languages .Polaris-Button__Text {\n  display: inline-flex;\n}\n\n.BC-Page__Translation .languages .Polaris-Button svg {\n  fill: #31373d;\n  margin-right: 6px;\n}\n\n.BC-Page__Translation .BC-Page__Button .Polaris-Button,\n.BC-Page__Translation .Polaris-PageActions .Polaris-Button {\n  width: 136px;\n}\n\n.languageItem {\n  width: 122px;\n}\n\n.BC-Page__Translation .tabContent #basic-collapsible {\n  padding: 0 4px;\n}\n\n.BC-Page__Translation .Polaris-Tabs__Wrapper .Polaris-Tabs__Title {\n  padding: 0.75rem !important;\n}\n\n.BC-Page__Translation .feature-table {\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 8px;\n}\n\n.BC-Page__Translation .feature-table__header {\n  display: grid;\n  grid-template-columns: 1fr 284px;\n}\n.BC-Page__Translation .feature-table .Polaris-Card {\n  box-shadow: 0px -1px 0px 0px #e1e3e5 inset;\n  border: 1px solid #e1e3e5;\n}\n\n.BC-Page__Translation .feature-table .Polaris-Card .Polaris-Card__Section {\n  padding: 16px;\n  box-shadow: 0px -1px 0px 0px #e1e3e5 inset;\n}\n\n.BC-Page__Translation .feature-table .feature-table__section {\n  background: #fafbfb;\n  color: #6d7175;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0px;\n  vertical-align: middle;\n  text-transform: uppercase;\n  padding: 16px;\n  box-shadow: 0px -1px 0px 0px #e1e3e5 inset;\n}\n\n.BC-Page__Translation .feature-table .feature-table__row {\n  display: grid;\n  grid-template-columns: 1fr 252px;\n  padding: 16px 32px;\n  box-shadow: 0px -1px 0px 0px #e1e3e5 inset;\n}\n\n.BC-Page__Translation .feature-table .feature-table__row .feature-table__row-name {\n  font-weight: 500;\n}\n\n.BC-Page__Translation .feature-table .feature-table__row .Polaris-Button--plain {\n  max-width: max-content;\n  margin: 0 auto;\n  padding: 0;\n  min-height: 0;\n}\n\n.BC-Page__Translation-Feature .BC-Page__Translation-Feature__Header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.BC-Page__Translation-Feature .languages .Polaris-Button__Text {\n  display: inline-flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.BC-Page__Translation-Feature .BC-TranslationFeatureTab {\n  padding: 16px;\n}\n\n.BC-Page__Translation-Feature .BC-TranslationFeatureTab .tabContent .tab-section__body {\n  display: flex;\n  gap: 16px;\n  flex-direction: column;\n}\n\n.BC-Page__Translation-Feature .BC-TranslationFeatureTab .tabContent .spinner-loading {\n  min-height: 400px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.BC-Page__Translation-Feature .BC-TranslationFeatureTab .Polaris-Stack .Polaris-Stack__Item {\n  flex: 1;\n}\n\n.BC-Page__Translation-Feature .BC-TranslationFeatureTab .tab-section__title {\n  margin-top: 5px;\n  margin-bottom: 15px;\n  font-weight: 600;\n  font-size: 16px;\n}\n.BC-Page__Translation-Feature\n  .BC-TranslationFeatureTab\n  .tab-section__title.tab-section__title--collapse {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n}\n\n.BC-Page__Translation-Feature .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {\n  justify-content: flex-end;\n}\n\n.BC-Page__Translation-Feature\n  .Polaris-PageActions\n  .Polaris-Stack--distributionEqualSpacing\n  .Polaris-Stack__Item {\n  margin-left: 1rem;\n}\n\n/* Default layout settings */\n.BC-Page__Layout-Settings .tabs .Polaris-Card__Section {\n  padding: 0rem;\n}\n\n.BC-Page__Layout-Settings .tabs .Polaris-Layout {\n  margin-top: 0rem;\n  margin-left: -0.625rem;\n  margin-right: -0.625rem;\n}\n\n.BC-Page__Layout-Settings .tabs.tabs-with-preview .Polaris-Layout {\n  margin-left: 0rem;\n  margin-right: 0rem;\n}\n\n.BC-Page__Layout-Settings .tabs .Polaris-Layout .Polaris-Layout__Section {\n  margin-top: 0rem;\n  margin-left: 0rem;\n}\n\n.BC-Page__Layout-Settings .tabs.tabs-with-preview .Polaris-Layout .Polaris-Layout__Section {\n  flex: 2 2 35rem;\n}\n\n.BC-Page__Layout-Settings\n  .tabs.tabs-with-preview\n  .Polaris-Layout__Section.Polaris-Layout__Section--secondary {\n  margin-left: 0;\n  flex: 2 2 23.375rem;\n}\n\n.BC-Page__Layout-Settings .tabs .tab-content .Polaris-Card__Section {\n  padding: 1rem 1rem 1.5rem 1rem;\n}\n\n.BC-Page__Layout-Settings .tabs.tabs-with-preview .tab-content .Polaris-Card__Section {\n  min-height: 480px;\n}\n\n.BC-Page__Layout-Settings .previewPanel .Polaris-Card .Polaris-Heading {\n  line-height: 1.375rem;\n}\n\n.BC-Page__Layout-Settings .Polaris-FormLayout__Item {\n  margin-top: 1.5625rem;\n}\n\n.BC-Page__Layout-Settings .groupFields {\n  margin-top: 0.75rem;\n}\n\n.BC-Page__Layout-Settings .groupFields > div {\n  margin-top: 0.25rem;\n}\n\n.BC-Page__Layout-Settings .groupFields > div.Polaris-Stack:first-child .Polaris-Stack__Item {\n  margin-top: 0rem;\n}\n\n.BC-Page__Layout-Settings .quick-view-group .groupFields {\n  padding-bottom: 1.5rem;\n  border-bottom: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page__Layout-Settings .add-to-card-group {\n  padding-bottom: 0.25rem;\n}\n\n.BC-Page__Layout-Settings .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing,\n.BC-Page__Translation .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {\n  justify-content: flex-end;\n}\n\n.BC-Page__Layout-Settings\n  .Polaris-PageActions\n  .Polaris-Stack--distributionEqualSpacing\n  > .Polaris-Stack__Item,\n.BC-Page-Variants-Display\n  .Polaris-PageActions\n  .Polaris-Stack--distributionEqualSpacing\n  > .Polaris-Stack__Item {\n  margin-left: 1rem;\n}\n\n.BC-Page-Variants-Display .noSupportISW {\n  padding-top: 25px;\n  display: flex;\n}\n\n.BC-Page-Variants-Display .noSupportISW .icon {\n  margin: 2px 10px 0 0;\n  width: 1rem;\n  height: 1rem;\n}\n\n.BC-Page-Variants-Display .noSupportISW .text {\n  color: #d72c0d;\n  margin: 0 5px 0 0;\n}\n\n.variantDisplayInfos .image {\n  max-height: 112px;\n}\n\n.variantDisplayInfos .title {\n  font-size: 20px;\n}\n\n.action-group-detail-merchandising .Polaris-Stack > .Polaris-Stack__Item {\n  margin-left: 8px;\n}\n\n.BC-Page__Layout-Settings .tabs .previewPanel .Polaris-Card {\n  box-shadow: none;\n  background: inherit;\n}\n\n.BC-Page__Layout-Settings .tabs .previewPanel .item-center {\n  display: flex;\n  justify-content: center;\n  margin-top: 1.5625rem;\n}\n\n.BC-Page__Layout-Settings .Polaris-PageActions {\n  padding-top: 1.5rem;\n}\n\n/* Quick view & cart settings */\n\n.BC-Page__QuickView-Cart-Settings .content {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: flex-start;\n  margin: 0;\n}\n\n.BC-Page__QuickView-Cart-Settings .content-settings {\n  flex: 1 1 35rem;\n  min-width: 0;\n  border-right: 0.0625rem solid var(--p-divider);\n  min-height: 550px;\n}\n\n.BC-Page__QuickView-Cart-Settings .preview {\n  flex: 1 1 23.125rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .content-settings {\n  padding: 1rem 1.25rem 2.5rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .content .Polaris-Card__Section {\n  padding: 0rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .content .Polaris-Layout {\n  margin-top: 0rem;\n  margin-left: 0rem;\n  margin-right: 0rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .content .content-settings .Polaris-Card__Section {\n  padding: 1rem 1rem 1.5rem 1rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .previewPanel .Polaris-Card .Polaris-Heading {\n  line-height: 1.375rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .Polaris-FormLayout .Polaris-FormLayout__Item {\n  margin-top: 1.5625rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .Polaris-FormLayout .Polaris-FormLayout__Item:first-child {\n  margin-top: 1.25rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .groupFields {\n  margin-top: 0.75rem;\n  padding-left: 3.125rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .groupFields > .groupFields-label:first-child {\n  margin-top: 0.75rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .groupFields .groupFields-label {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__QuickView-Cart-Settings\n  .groupFields\n  .groupFields-label\n  .Polaris-Button\n  .Polaris-Button__Content\n  .Polaris-Button__Icon {\n  order: -1;\n  margin-left: -5px;\n  margin-right: 5px;\n}\n\n.BC-Page__QuickView-Cart-Settings .groupFields .groupFields-content > div {\n  margin-top: 0.25rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .groupFields .groupFields-content > div:first-child {\n  margin-top: -0.5rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .groupFields .groupFields-content .Polaris-Stack--vertical {\n  flex-wrap: nowrap;\n}\n\n.BC-Page__QuickView-Cart-Settings .selectedColor {\n  background-color: #fff;\n  z-index: 417;\n  width: 25px;\n  height: 25px;\n  margin-right: 0;\n  border: 1px solid #c4cdd5;\n  border-radius: 3px;\n  margin-left: 0.75rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .quick-view-group .groupFields {\n  padding-bottom: 1.5rem;\n  border-bottom: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page__QuickView-Cart-Settings .add-to-card-group {\n  padding-bottom: 0.25rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {\n  justify-content: flex-end;\n}\n\n.BC-Page__QuickView-Cart-Settings\n  .Polaris-PageActions\n  .Polaris-Stack--distributionEqualSpacing\n  > .Polaris-Stack__Item {\n  margin-left: 1rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .content .previewPanel .Polaris-Card {\n  box-shadow: none;\n  background: inherit;\n}\n\n.BC-Page__QuickView-Cart-Settings .content .previewPanel .Polaris-Card .Polaris-Heading {\n  text-align: center;\n}\n\n.BC-Page__QuickView-Cart-Settings .content .previewPanel .item-center {\n  display: flex;\n  justify-content: center;\n  margin-top: 1.5625rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .Polaris-PageActions {\n  padding-top: 1.5rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .render-choice-flex-3 ul {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  margin-left: -1rem;\n}\n\n.BC-Page__QuickView-Cart-Settings .render-choice-flex-3 ul li {\n  max-width: 100%;\n  flex: 1 0 100%;\n  padding-left: 1rem;\n}\n\n@media screen and (min-width: 1200px) {\n  .BC-Page__QuickView-Cart-Settings .render-choice-flex-3 ul li {\n    flex: 0 1 33.33%;\n  }\n}\n\n.BC-Page__QuickView-Cart-Settings .render-choice-with-tooltip .extraTooltipClass {\n  width: 276px;\n  padding: 8px;\n}\n\n.BC-Page__QuickView-Cart-Settings .render-choice-with-tooltip .extraTooltipClass img {\n  width: 100%;\n}\n\n/* Merge value */\n.BC-Page__Merge-Value .Polaris-DisplayText .Polaris-Button__Content {\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5rem;\n}\n\n.BC-Page__Merge-Value .BC-Custom__ButtonMore .Polaris-Button {\n  vertical-align: middle;\n}\n\n.BC-Page__Merge-Value .BC-Custom__ButtonMore .Polaris-Button__Text {\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 1rem;\n}\n\n.BC-Page__Merge-Value .BC-Custom__ButtonMore .Polaris-Button__Icon .Polaris-Icon {\n  width: 0.8rem;\n  height: 0.8rem;\n}\n\n.BC-Page__Merge-Value .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {\n  justify-content: flex-end;\n}\n\n.BC-Page__Merge-Value\n  .Polaris-PageActions\n  .Polaris-Stack--distributionEqualSpacing\n  .Polaris-Stack__Item {\n  margin-left: 1rem;\n}\n\n.BC-DataTable__MergeValuesOptions,\n.BC-DataTable__MergeValues {\n  margin: -1rem;\n}\n\n.BC-DataTable__MergeValuesOptions .Polaris-DataTable__Cell:first-child {\n  min-width: 100px;\n  width: 50%;\n}\n\n.BC-DataTable__MergeValuesOptions .Polaris-DataTable__Cell:nth-child(2) {\n  min-width: 430px;\n  width: 40%;\n}\n\n.BC-DataTable__MergeValuesOptions .Polaris-DataTable__Cell:last-child {\n  min-width: 90px;\n  width: 10%;\n  padding-right: 1.25rem;\n  padding-left: 0.625rem;\n}\n\n/* .BC-DataTable__MergeValues button {\n  color: var(--p-action-primary);\n  border-color: var(--p-action-primary);\n}\n\n.BC-DataTable__MergeValues button:hover {\n  border-color: var(--p-action-primary);\n}\n\n.BC-DataTable__MergeValues button svg {\n  fill: var(--p-action-primary);\n} */\n\n.BC-DataTable__MergeValues tbody {\n  vertical-align: top;\n}\n\n.BC-DataTable__MergeValues .Polaris-DataTable__Cell:first-child {\n  width: 10%;\n}\n\n.BC-DataTable__MergeValues .Polaris-DataTable__Cell:nth-child(2) {\n  min-width: 169px;\n  width: 20%;\n}\n\n.BC-DataTable__MergeValues .Polaris-DataTable__Cell:nth-child(4) {\n  min-width: 90px;\n  width: 10%;\n  padding-right: 1.25rem;\n  padding-left: 0.625rem;\n}\n\n.BC-DataTable__MergeValues .Polaris-DataTable__Cell button {\n  padding-top: 0.46875rem;\n  padding-bottom: 0.46875rem;\n}\n\n.BC-DataTable__MergeValues .button-add {\n  padding-top: 8px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.BC-DataTable__MergeValues .button-add .Polaris-Icon {\n  width: 0.8125rem;\n  height: 0.8125rem;\n}\n\n/* Integration tool */\n.BC-Page__Integration .Polaris-Layout__Section:last-child {\n  margin-top: 0.5rem;\n}\n\n.BC-Page__Integration .Polaris-Tabs li:first-child > button {\n  padding-left: 0;\n}\n\n.BC-Page__Integration .tabContent .item {\n  margin-top: 1.5rem;\n  background: #fff;\n  width: 300px;\n  text-align: center;\n  border-radius: 3px;\n  box-shadow:\n    0 0 0 1px rgba(63, 63, 68, 0.05),\n    0 1px 3px 0 rgba(63, 63, 68, 0.15);\n  float: left;\n  min-height: 390px;\n  position: relative;\n}\n\n.BC-Page__Integration .tabContent .item .Polaris-Badge {\n  position: absolute;\n  top: 10px;\n  right: 16px;\n  color: #616161;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.BC-Page__Integration .tabContent .middle {\n  margin-right: 1.5rem;\n  margin-left: 1.5rem;\n}\n\n.BC-Page__Integration .tabContent .icon {\n  width: 70px;\n  margin: 24px 0 22px;\n  border-radius: 8px;\n}\n\n.BC-Page__Integration .tabContent .icon--attentive {\n  width: 80px;\n  border-radius: 50%;\n  margin: 19px 0 17px;\n  /* box-shadow: 0px 4px 24px 0px #00000012; */\n}\n\n.BC-Page__Integration .tabContent .integration {\n  margin-top: -8px;\n  margin-bottom: 22px;\n}\n\n.BC-Page__Integration .tabContent .name {\n  font-size: 1rem;\n  font-weight: 700;\n  margin-top: -10px;\n  padding-bottom: 8px;\n}\n\n.BC-Page__Integration .tabContent .description {\n  min-height: 60px;\n  font-size: 14px;\n  color: #637381;\n  padding: 0.5rem 1.25rem 0.75rem 1.25rem;\n}\n\n.BC-Page__Integration .tabContent .instruction {\n  font-size: 0.75rem;\n  color: #637381;\n  line-height: 1rem;\n  padding: 0.75rem 1.25rem 1.5rem 1.25rem;\n}\n\n.BC-Page__Integration .BC-Checkbox-Status {\n  margin: 0.75rem 0 1.5rem 0;\n}\n\n.BC-Page__Integration .tabContent form {\n  padding: 0 1.25rem 0.5rem 1.25rem;\n}\n\n.BC-Page__Integration .Polaris-Tabs__Panel .Polaris-Button {\n  margin-bottom: 1.5rem;\n  width: 120px;\n}\n\n.BC-Page__Integration .Polaris-Tabs__Panel .btn-configure {\n  margin: 24px 0;\n}\n\n.BC-Page__Integration .Polaris-Tabs__Panel .btn-configure .Polaris-Button {\n  width: auto;\n  margin-bottom: 0;\n}\n\n.BC-Page__Integration .Polaris-Tabs__Panel .integrateGemPages .Polaris-Button {\n  width: 255px;\n}\n\n/* Search settings*/\n.BC-Page__SearchSettings .Polaris-FormLayout .Polaris-FormLayout__Item {\n  margin-top: 1.25rem;\n}\n\n.BC-Page__SearchSettings .Polaris-DataTable.BC-DataTable__SearchSettings {\n  margin: 0 -1.25rem;\n}\n\n.BC-Page__SearchSettings\n  .Polaris-Page\n  .Polaris-Tabs__Wrapper\n  .Polaris-Tabs__TabContainer\n  .Polaris-Badge--statusWarning {\n  margin-left: 4px;\n}\n\n.BC-DataTable__SearchSettings .Polaris-DataTable__Cell.Polaris-DataTable__Cell--firstColumn {\n  width: 60px;\n  padding: 0rem 1.25rem;\n}\n\n.BC-Page__SearchSettings .range-slider-input {\n  display: flex;\n  margin-top: 1rem;\n}\n\n.BC-Page__SearchSettings .range-slider-input > div:first-child {\n  width: 18.375rem;\n}\n\n.BC-Page__SearchSettings .range-slider-input > div:last-child {\n  margin-left: 1rem;\n  width: 5rem;\n}\n\n.BC-Page__SearchSettings .range-slider-input .Polaris-RangeSlider-SingleThumb__InputWrapper {\n  height: 2.1875rem;\n}\n\n.BC-Page__SearchSettings\n  .range-slider-input\n  .Polaris-RangeSlider-SingleThumb__Input::-webkit-slider-thumb {\n  width: 1.0625rem;\n  height: 1.0625rem;\n  margin-top: -0.4375rem;\n}\n\n.BC-Page__SearchSettings .range-slider-input .Polaris-TextField__Segment:first-child {\n  margin-top: 1px;\n}\n\n.BC-Page__SearchSettings .advanced .heading {\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.5rem;\n}\n\n.BC-Page__SearchSettings .advanced .heading.searchTerm {\n  padding-bottom: 0.3125rem;\n}\n\n.BC-Page__SearchSettings .advanced .heading.fuzzy {\n  margin-top: 1.25rem;\n  padding-top: 1.25rem;\n  padding-bottom: 0.3125rem;\n  border-top: 1px solid #dfe3e8;\n}\n\n/* margin-top: 1.25rem;\npadding-top: 1.25rem;\npadding-bottom: 0.3125rem;\nborder-top: 1px solid #DFE3E8; */\n\n.BC-Page__SearchSettings .fuzzySearchSetting {\n  margin-top: -0.625rem;\n}\n\n.BC-Page__SearchSettings .fuzzySearchSetting .Polaris-ChoiceList__Choices li {\n  padding: 0.4375rem 0 0.25rem 0;\n}\n\n/* Instant search display */\n\n.BC-Page__InstantSearchDisplay .Polaris-DisplayText .Polaris-Button__Content {\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5rem;\n}\n\n.BC-Page__InstantSearchDisplay .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing,\n.BC-Page__SearchSettings .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing,\n.BC-Page__SearchPageDisplay .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {\n  justify-content: flex-end;\n}\n\n.BC-Page__SearchPageDisplay textarea {\n  line-height: 1.4375rem;\n}\n\n.BC-Page__InstantSearchDisplay\n  .Polaris-PageActions\n  .Polaris-Stack--distributionEqualSpacing\n  .Polaris-Stack__Item,\n.BC-Page__SearchSettings\n  .Polaris-PageActions\n  .Polaris-Stack--distributionEqualSpacing\n  .Polaris-Stack__Item,\n.BC-Page__SearchPageDisplay\n  .Polaris-PageActions\n  .Polaris-Stack--distributionEqualSpacing\n  .Polaris-Stack__Item {\n  margin-left: 1rem;\n}\n\n.BC-Page__InstantSearchDisplay .Polaris-Layout {\n  margin-top: 1rem;\n}\n\n.BC-Page__InstantSearchDisplay .layoutSettings {\n  padding-bottom: 2.5rem;\n  border-bottom: 1px solid var(--p-divider);\n}\n\n.BC-Page__InstantSearchDisplay .headingStyle {\n  display: flex;\n  font-size: 1.75rem;\n  line-height: 2rem;\n  font-weight: 600;\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n\n.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .Polaris-Layout {\n  align-items: stretch;\n}\n\n.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .Polaris-Layout .Polaris-Card {\n  min-height: 100%;\n  height: 100%;\n}\n\n.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .layout-image img {\n  width: 100%;\n  min-height: 170px;\n}\n\n.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .layout-style,\n.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .layout-type,\n.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .layout-position,\n.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .layout-products-per-row {\n  margin-bottom: 1.125rem;\n  text-align: center;\n}\n\n.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .layout-style {\n  margin: 0.875rem;\n}\n\n.BC-Page__InstantSearchDisplay .layoutSettings .styleBox .layout-products-per-row {\n  margin-bottom: 0rem;\n}\n\n.BC-Page__InstantSearchDisplay .headingStyle .headingText {\n  margin-right: 0.5rem;\n}\n\n.BC-Page__InstantSearchDisplay .BC-Page__Fields > div,\n.BC-Page__SearchSettings .BC-Page__Fields > div {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__SearchPageDisplay .BC-Page__Fields > div {\n  margin-top: 8px;\n}\n\n/* .BC-Page__SearchPageDisplay .BC-Page__Fields .textArea-align-center textarea {\n  text-align: center !important;\n} */\n\n.BC-Page__InstantSearchDisplay .BC-Page__Fields > div.tabs {\n  margin: 1.25rem -1rem -1rem;\n  border-top: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page__InstantSearchDisplay .titleStyle .Polaris-Label__Text,\n.BC-Page__SearchSettings .titleStyle .Polaris-Label__Text {\n  font-size: 1.0625rem;\n  font-weight: 600;\n  line-height: 1.5rem;\n}\n\n.BC-Page__InstantSearchDisplay .groupFields > div:first-child {\n  margin-top: -0.75rem;\n}\n\n.BC-Page__InstantSearchDisplay .groupFields > div {\n  margin-top: 0.5rem;\n}\n\n.BC-Page__InstantSearchDisplay .groupFields .groupFields-item {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__InstantSearchDisplay\n  .groupFields\n  .groupFields-item\n  .BC-Toggle-Switch\n  .Polaris-Label__Text {\n  font-weight: 500;\n}\n\n.BC-Page__InstantSearchDisplay .groupFields .groupFields-item .Polaris-FormLayout {\n  margin-top: 1rem;\n}\n\n.BC-Page__InstantSearchDisplay\n  .groupFields\n  .Polaris-Stack--distributionFillEvenly\n  .Polaris-Stack__Item {\n  flex: 1 0;\n}\n\n.BC-DataTable__InstantSearchDisplay {\n  padding-top: 0.375rem;\n}\n\n.BC-DataTable__InstantSearchDisplay .Polaris-DataTable__Cell:first-child {\n  width: 20px;\n  padding: 0rem;\n}\n\n.BC-DataTable__InstantSearchDisplay .Polaris-DataTable__Cell:nth-child(2) {\n  width: 100px;\n}\n\n.BC-DataTable__InstantSearchDisplay .Polaris-DataTable__Cell:nth-child(3) {\n  width: 484px;\n}\n\n.BC-DataTable__InstantSearchDisplay .Polaris-DataTable__Cell:last-child {\n  width: 290px;\n  overflow: hidden;\n  padding-right: 0rem;\n  padding-left: 0.625rem;\n  text-align: center;\n}\n\n.BC-Page__InstantSearchDisplay div.tabs .scopedSuggestionWrap .groupFields > div:first-child {\n  margin-top: 0;\n}\n\n.BC-Page__InstantSearchDisplay div.tabs .scopedSuggestionWrap .groupFields .Polaris-Select {\n  width: 180px;\n}\n\n.BC-Page__InstantSearchDisplay div.tabs .scopedSuggestionWrap {\n  border-top: 1px solid #e1e3e5;\n  margin-top: 20px;\n}\n\n.BC-Page__InstantSearchDisplay div.tabs .titleStyle {\n  margin-top: 2.25rem;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__SearchTerm {\n  margin-top: 1.4375rem;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__Product {\n  margin-top: 0.625rem;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__SearchTerm .empty-term {\n  margin: 1.875rem auto 0.375rem 0;\n  text-align: center;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__SearchTerm .Polaris-DataTable__Cell {\n  padding: 1.0625rem;\n  /* border-bottom: 1px solid var(--p-divider); */\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__SearchTerm .Polaris-DataTable__Cell:first-child {\n  width: 20px;\n  padding: 0rem;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__SearchTerm .Polaris-DataTable__Cell:nth-child(2) {\n  width: auto;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__SearchTerm .Polaris-DataTable__Cell:nth-child(3) {\n  width: 50px;\n  text-align: right;\n  padding-right: 0.375rem;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__Product .empty-product {\n  margin: 0.625rem auto 1.875rem;\n  text-align: center;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__Product .addProducts {\n  border-top: 1px solid var(--p-divider);\n  padding-top: 0.875rem;\n  text-align: right;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__Product .addProducts .Polaris-Button__Text {\n  font-weight: 500;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__Product .addProducts button {\n  text-decoration: none;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__Product .Polaris-DataTable__Cell {\n  padding: 0.875rem 0.78125rem;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__Product tbody .Polaris-DataTable__Cell {\n  border-top: 1px solid var(--p-divider);\n  border-bottom: none;\n  white-space: normal;\n}\n\n.BC-Page__InstantSearchDisplay\n  .BC-DataTable__Product\n  tbody\n  tr:first-child\n  .Polaris-DataTable__Cell {\n  border-top: none;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__Product .Polaris-DataTable__Cell:first-child {\n  width: 20px;\n  padding: 0rem;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__Product .Polaris-DataTable__Cell:nth-child(2) {\n  width: 50px;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__Product .Polaris-DataTable__Cell:nth-child(3) {\n  width: auto;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__Product .Polaris-DataTable__Cell:nth-child(4) {\n  width: 50px;\n  text-align: right;\n  padding-right: 0.375rem;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__Product .Polaris-DataTable__Cell .product-image,\n.BC-DataTable__Product-Options .Polaris-DataTable__Cell .product-image {\n  width: 40px;\n  padding-bottom: 40px;\n  position: relative;\n  border: 1px solid var(--p-divider);\n  box-sizing: border-box;\n}\n\n.BC-Page__InstantSearchDisplay\n  .BC-DataTable__Product\n  .Polaris-DataTable__Cell\n  .product-image.no-image,\n.BC-DataTable__Product-Options .Polaris-DataTable__Cell .product-image.no-image {\n  background-color: #f9fafb;\n}\n\n.BC-Page__InstantSearchDisplay .BC-DataTable__Product .Polaris-DataTable__Cell .product-image img,\n.BC-DataTable__Product-Options .Polaris-DataTable__Cell .product-image img {\n  position: absolute;\n  max-width: 100%;\n  max-height: 100%;\n  display: block;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n\n/* standard search - isw */\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .Polaris-Layout__Section:nth-child(2) {\n  display: grid;\n  gap: 24px;\n  width: 100%;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .Polaris-Layout__Section\n  div\n  .Polaris-Card__Header\n  > div\n  .titleMetadata\n  .Polaris-Icon {\n  width: 14px;\n  height: 14px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .Polaris-Layout__Section\n  div\n  .Polaris-Card__Header\n  > div\n  > div {\n  width: auto;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .Polaris-Layout__Section:nth-child(2)\n  .layoutSettings {\n  padding-bottom: unset;\n  border-bottom: none;\n}\n\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .Polaris-Layout__Section .Polaris-Card {\n  box-shadow: none;\n  border-radius: 8px;\n  border: 1px solid var(--border-divider, #e1e3e5);\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .Polaris-Layout__Section\n  div\n  .Polaris-Card__Header\n  > div {\n  display: flex;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  gap: 8px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .layoutSettings\n  > .Polaris-Card\n  > .Polaris-Card__Section {\n  padding-top: 16px;\n}\n\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .layoutSettings .styleBox {\n  display: flex;\n  align-items: stretch;\n}\n\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .layoutSettings .styleBox > div {\n  flex: 1 1 0;\n  width: 0;\n  margin-top: unset;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .layoutSettings\n  .styleBox\n  .Polaris-Card\n  > .Polaris-Card__Section {\n  padding: 12px;\n}\n\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .layoutSettings .styleBox .Polaris-Card {\n  border: none;\n  height: 100%;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .layoutSettings\n  .styleBox\n  .Polaris-Card:hover {\n  cursor: pointer;\n  border: 1px solid var(--border-divider, #e1e3e5);\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .layoutSettings\n  .styleBox\n  .layout-selected\n  .Polaris-Card {\n  border: 1px solid #2c6ecb;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .layoutSettings\n  .styleBox\n  .layout-image\n  img {\n  width: 100%;\n  height: auto;\n}\n\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .layoutSettings .styleBox .layout-settings {\n  margin-top: 12px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .layoutSettings\n  .styleBox\n  .layout-settings\n  > div {\n  margin-top: 16px;\n  text-align: center;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .layoutSettings\n  .styleBox\n  .layout-settings\n  .Polaris-Choice {\n  width: 100%;\n  justify-content: center;\n}\n\n.BC-Page__SearchControl .sub-title,\n.BC-Page__StandardSearch .ref-to-test-search {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.BC-Page__SearchControl .sub-title > span > p:hover,\n.BC-Page__StandardSearch .ref-to-test-search > span > span:hover,\n.BC-Page__StandardSearch .ref-to-test-search > span > p:hover {\n  cursor: pointer;\n  color: var(--Interactive-Default, #1d65ca);\n}\n\n.BC-Page__SearchControl .sub-title > span > p,\n.BC-Page__StandardSearch .ref-to-test-search > span > span,\n.BC-Page__StandardSearch .ref-to-test-search > span > p {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: 500;\n  color: var(--Interactive-Default, #2c6ecb) !important;\n  margin-right: 20px;\n}\n\n.BC-Page__SearchControl .BC-Page.SearchControl__Content.BC-Page__Fields__Status .toggle-status {\n  border: 1px solid var(--border-divider, #e1e3e5);\n  border-radius: 8px;\n  box-shadow: none;\n  padding: 20px;\n  display: flex;\n  margin-top: 16px;\n  margin-bottom: 20px;\n}\n\n.BC-Page__SearchControl .BC-BaseBanner {\n  margin-bottom: 0;\n}\n\n.BC-Page__StandardSearch .groupFields .render-choice-2 {\n  padding-bottom: unset;\n}\n\n.BC-Page__StandardSearch .groupFields .render-choice-2 .Polaris-ChoiceList__ChoiceChildren {\n  margin-bottom: 3px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .isw-with-results\n  .groupFields\n  .groupFields-item-scope,\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .groupFields-item .Polaris-Stack__Item,\n.BC-Page__StandardSearch .groupFields .render-choice-2 li:not(:first-child),\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .BC-DataTable__SearchTerm,\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .isw-with-results\n  .groupFields\n  .product-suggestion,\n.BC-Page__StandardSearch .isw-with-results .scopedSuggestionWrap .groupFields,\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .isw-with-results > div:last-child > div,\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .groupFields .groupFields-item {\n  margin-top: 16px !important;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .groupFields\n  .radioButtonGroup\n  .Polaris-Button,\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .groupFields\n  .radioButtonGroup\n  .Polaris-TextField {\n  max-height: 30px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .groupFields\n  .radioButtonGroup\n  .Polaris-Button {\n  padding: 5px 12px;\n  min-height: 30px;\n}\n\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .empty-product,\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .empty-term {\n  margin: 40px auto 16px 0;\n  color: #6d7175;\n}\n\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .isw-with-results > div:last-child {\n  margin-top: 16px;\n  border-top: 1px solid #e1e3e5;\n  margin: 20px -20px 0;\n  padding: 16px 20px 0;\n}\n\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .isw-with-results > div > p,\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .isw-with-results\n  .Polaris-FormLayout__Item\n  > p {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .isw-with-results > div > label,\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .isw-with-results\n  .groupFields-item-scope\n  > p:first-child,\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .isw-with-results\n  .Polaris-FormLayout__Item\n  > .BC-Toggle-Switch {\n  margin-top: 4px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .isw-with-results\n  .Polaris-FormLayout__Item\n  .BC-Toggle-Switch\n  label {\n  font-weight: 600;\n  font-style: normal;\n}\n\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .groupFields > div {\n  margin-top: unset;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .isw-with-results\n  .groupFields\n  .groupFields-item {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .isw-with-results\n  .groupFields\n  .groupFields-item\n  .Polaris-Select__Content {\n  text-align: center;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .isw-with-results\n  .groupFields\n  .groupFields-item\n  > div {\n  flex: 48% 1;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .groupFields\n  .Polaris-Stack--distributionFillEvenly\n  .Polaris-Stack__Item {\n  margin-top: 12px;\n}\n\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay div.tabs .scopedSuggestionWrap {\n  border-top: unset;\n  margin-top: 16px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  div.tabs\n  .scopedSuggestionWrap\n  .groupFields\n  .Polaris-Select {\n  width: 286px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .isw-with-results\n  > div:last-child\n  .Polaris-Icon {\n  display: inline-flex;\n}\n\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .block-order {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .block-icon {\n  display: flex;\n  align-items: center;\n}\n\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .content-order .BC-Draggable__Container {\n  display: grid;\n  gap: 16px;\n}\n\n.search-results-tab .BC-Draggable__Container .BC-Draggable__Tag,\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .BC-Draggable__Container\n  .BC-Draggable__Tag {\n  padding: 4px 0px 4px 8px;\n}\n\n.search-results-tab .BC-Draggable__Container .BC-Draggable__Tag button,\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .BC-Draggable__Container\n  .BC-Draggable__Tag\n  button {\n  width: 20px;\n  height: 20px;\n}\n\n.search-results-tab .BC-Draggable__Container .BC-Draggable__Tag button .Polaris-Icon svg,\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .BC-Draggable__Container\n  .BC-Draggable__Tag\n  button\n  .Polaris-Icon\n  svg {\n  fill: #5c5f62;\n}\n\n/*  */\n\n.BC-DataTable__Product-Options .Polaris-DataTable__Cell:first-child {\n  width: 20px;\n  padding: 0rem;\n  padding-right: 0.3125rem;\n}\n\n.BC-DataTable__Product-Options .Polaris-DataTable__Cell:nth-child(2) {\n  width: 50px;\n}\n\n.BC-DataTable__Product-Options .Polaris-DataTable__Cell:nth-child(3) {\n  width: auto;\n}\n\n.search-product-suggestion {\n  margin-bottom: 0.625rem;\n}\n\n#infiniteScroll_Wrapper_Modal {\n  height: calc(100vh - 18.125rem);\n  overflow-y: auto;\n  margin-right: -1.25rem;\n  padding-right: 1.25rem;\n}\n\n#infiniteScroll_Wrapper_ModalSelectProduct {\n  height: calc(100vh - 21.625rem);\n  overflow-y: auto;\n  max-height: 500px;\n}\n\n/* Search fields*/\n.BC-Page__SearchFields .Polaris-FormLayout .Polaris-FormLayout__Item {\n  margin-top: 1.25rem;\n}\n\n.BC-Page__SearchFields .BC-Page__Fields > div {\n  margin-top: 1.5rem;\n}\n\n.Polaris-FormLayout__Item\n  .search-fields-footer\n  .Polaris-Button__Content\n  .Polaris-Button__Icon\n  .Polaris-Icon\n  svg,\n.BC-Page__Theme-Setup\n  .external-link\n  .Polaris-Button__Content\n  .Polaris-Button__Icon\n  .Polaris-Icon\n  svg,\n.Polaris-Layout .external-link .Polaris-Button__Content .Polaris-Button__Icon .Polaris-Icon svg {\n  fill: var(--p-interactive) !important;\n  width: 20px;\n  height: auto;\n}\n\n/* Search page display */\n.isw-banner-custom-actions {\n  margin-top: 16px;\n}\n\n.isw-banner-custom-actions .Polaris-Button__Text {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.BC-Page__SearchPageDisplay .BC-Toggle-Switch label {\n  font-weight: 600;\n}\n\n.BC-Page__SearchPageDisplay .groupFields > div {\n  margin-top: 1.25rem;\n}\n\n.BC-Page__SearchPageDisplay .groupFields > div:first-child {\n  margin-top: 1rem;\n}\n\n.BC-Page__SearchPageDisplay .groupFields .radioButtonGroup {\n  padding: 1.5rem 1rem 0.3125rem;\n  border: 1px solid #c4cdd5;\n  border-radius: 3px;\n  box-shadow: inset 0px 1px 2px rgba(102, 113, 123, 0.21);\n}\n\n.BC-Page__SearchPageDisplay .groupFields .radioButtonGroup li:not(:first-child) {\n  margin-top: 1.4375rem;\n}\n\n.BC-Page__InstantSearchDisplay .groupFields .radioButtonGroup {\n  padding: 1.5rem 1rem 1.5rem;\n  border: 1px solid #c4cdd5;\n  border-radius: 3px;\n  box-shadow: inset 0px 1px 2px rgba(102, 113, 123, 0.21);\n}\n\n.BC-Page__InstantSearchDisplay .groupFields .radioButtonGroup li:not(:first-child) {\n  margin-top: 1.4375rem;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__SearchTerm .empty-term {\n  margin: 1.875rem auto 1.125rem 0;\n  text-align: center;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__SearchTerm .Polaris-DataTable__Cell:first-child {\n  width: 20px;\n  padding: 0rem;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__SearchTerm .Polaris-DataTable__Cell:nth-child(2) {\n  width: auto;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__SearchTerm .Polaris-DataTable__Cell:nth-child(3) {\n  width: 50px;\n  text-align: right;\n  padding-right: 0.375rem;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__Product {\n  margin-top: -0.625rem;\n  margin-bottom: 0.6875rem;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__Product .empty-product {\n  margin: 1.4375rem auto 1.875rem;\n  text-align: center;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__Product .addProducts {\n  border-top: 1px solid var(--p-divider);\n  padding-top: 0.875rem;\n  text-align: right;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__Product .addProducts .Polaris-Button__Text {\n  font-weight: 500;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__Product .addProducts button {\n  text-decoration: none;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__Product .Polaris-DataTable__Cell {\n  padding: 0.875rem 0.78125rem;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__Product tbody .Polaris-DataTable__Cell {\n  border-top: 1px solid var(--p-divider);\n  border-bottom: none;\n  white-space: normal;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__Product tbody tr:first-child .Polaris-DataTable__Cell {\n  border-top: none;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__Product .Polaris-DataTable__Cell:first-child {\n  width: 20px;\n  padding: 0rem;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__Product .Polaris-DataTable__Cell:nth-child(2) {\n  width: 50px;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__Product .Polaris-DataTable__Cell:nth-child(3) {\n  width: auto;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__Product .Polaris-DataTable__Cell:nth-child(4) {\n  width: 50px;\n  text-align: right;\n  padding-right: 0.375rem;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__Product .Polaris-DataTable__Cell .product-image,\n.BC-DataTable__Product-Options .Polaris-DataTable__Cell .product-image {\n  width: 40px;\n  padding-bottom: 40px;\n  position: relative;\n  border: 1px solid var(--p-divider);\n  box-sizing: border-box;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__Product .Polaris-DataTable__Cell .product-image.no-image,\n.BC-DataTable__Product-Options .Polaris-DataTable__Cell .product-image.no-image {\n  background-color: #f9fafb;\n}\n\n.BC-Page__SearchPageDisplay .BC-DataTable__Product .Polaris-DataTable__Cell .product-image img,\n.BC-DataTable__Product-Options .Polaris-DataTable__Cell .product-image img {\n  position: absolute;\n  max-width: 100%;\n  max-height: 100%;\n  display: block;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n\n.BC-Page__SearchPageDisplay .BC-Page__Fields .groupFields .groupFields-flex-2 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.375rem;\n}\n\n.BC-Page__SearchPageDisplay .BC-Page__Fields .groupFields .groupFields-flex-2 > div {\n  flex: 48%;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-Page__Fields\n  .search-results-tab\n  .layout-custom\n  .Polaris-Button {\n  margin-top: 8px;\n  padding: 5px 8px;\n  border: 1px solid var(--border-default, #8c9196);\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-Page__Fields\n  .search-results-tab\n  .layout-custom\n  .Polaris-Button__Text {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-Page__Fields\n  .search-results-tab\n  .layout-custom\n  > p:nth-child(2) {\n  margin-top: 4px;\n  line-height: 20px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-Page__Fields\n  .search-results-tab\n  .layout-custom\n  .Polaris-Button\n  .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  width: 20px;\n  height: 20px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-Page__Fields\n  .search-results-tab\n  .Polaris-Banner {\n  margin-top: 24px;\n  padding: 20px 40px 20px 20px;\n  border-radius: 8px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-Page__Fields\n  .search-results-tab\n  .Polaris-Banner\n  .Polaris-Banner__Dismiss {\n  top: 20px;\n  right: 20px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-Page__Fields\n  .search-results-tab\n  .Polaris-Banner\n  .Polaris-Banner__Ribbon {\n  flex: unset;\n  padding-right: unset;\n  visibility: hidden;\n  width: 0px;\n}\n\n.BC-Page__StandardSearch .BC-Page__SearchSettings .Polaris-Tabs__Panel .Polaris-Card__Section,\n.BC-Page__StandardSearch .BC-Page__SearchPageDisplay .Polaris-Tabs__Panel .Polaris-Card__Section {\n  padding: 0;\n}\n\n.BC-Page__StandardSearch .BC-Page__SearchPageDisplay .groupFields .radioButtonGroup {\n  padding: 20px !important;\n}\n\n.BC-Page__StandardSearch .BC-Page__SearchPageDisplay .BC-DataTable__Product {\n  margin-top: 16px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .BC-DataTable__Product\n  .Polaris-DataTable__Cell:nth-child(4),\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .BC-DataTable__SearchTerm\n  .Polaris-DataTable__Cell:nth-child(3) {\n  width: 50px;\n  text-align: center;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .BC-DataTable__Product\n  .Polaris-DataTable__Cell:nth-child(4)\n  .Polaris-Button,\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .BC-DataTable__SearchTerm\n  .Polaris-DataTable__Cell:nth-child(3)\n  .Polaris-Button {\n  width: 30px;\n  min-width: unset;\n  padding: 0;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .BC-DataTable__Product\n  .Polaris-DataTable__Cell:nth-child(4)\n  .Polaris-Button\n  .Polaris-Button__Icon,\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .BC-DataTable__SearchTerm\n  .Polaris-DataTable__Cell:nth-child(3)\n  .Polaris-Button\n  .Polaris-Button__Icon {\n  display: flex;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .BC-DataTable__Product\n  .Polaris-DataTable__Cell:nth-child(1)\n  .Polaris-Icon__Svg,\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .BC-DataTable__SearchTerm\n  .Polaris-DataTable__Cell:nth-child(1)\n  .Polaris-Icon__Svg,\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-DataTable__Product\n  .Polaris-DataTable__Cell:nth-child(1)\n  .Polaris-Icon__Svg,\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-DataTable__SearchTerm\n  .Polaris-DataTable__Cell:nth-child(1)\n  .Polaris-Icon__Svg {\n  fill: #5c5f62;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .BC-DataTable__SearchTerm\n  .BC__SearchTermSuggestion-Add\n  .Polaris-Stack__Item:nth-child(1),\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-DataTable__SearchTerm\n  .BC__SearchTermSuggestion-Add\n  .Polaris-Stack__Item:nth-child(1) {\n  width: 300px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .BC-DataTable__SearchTerm\n  .BC__SearchTermSuggestion-Add\n  .Polaris-Stack__Item:nth-child(1)\n  .Polaris-TextField,\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-DataTable__SearchTerm\n  .BC__SearchTermSuggestion-Add\n  .Polaris-Stack__Item:nth-child(1)\n  .Polaris-TextField {\n  height: 30px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__InstantSearchDisplay\n  .BC-DataTable__SearchTerm\n  .BC__SearchTermSuggestion-Add\n  .Polaris-Stack__Item:nth-child(2)\n  .Polaris-Button,\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-DataTable__SearchTerm\n  .BC__SearchTermSuggestion-Add\n  .Polaris-Stack__Item:nth-child(2)\n  .Polaris-Button {\n  padding: 10px;\n  width: 100%;\n  height: 30px;\n  display: flex;\n  min-height: unset;\n}\n\n/* Search page display */\n\n/* Suggestion dictionary */\n.BC-Page__SuggestionDictionary .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty,\n.BC-Page__Merchandising .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty,\n.BC-Page__Metafield .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty,\n.BC-Page__CustomRangeSlider .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty,\n.BC-Page__Product-Visibility .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty,\n.BC-Page__SwatchSettings .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty,\n.BC-Page__CustomSorting .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty {\n  height: 20px;\n}\n\n.BC-Page__SuggestionDictionary .Polaris-DataTable__Cell {\n  padding: 0.75rem 0.78125rem;\n}\n\n.BC-Page__SuggestionDictionary .Polaris-DataTable__Cell:first-child {\n  width: 180px;\n  padding-left: 1.25rem;\n}\n\n/*.BC-Page__SuggestionDictionary .Polaris-DataTable__Cell:nth-child(2) {\n  width: 25%;\n}*/\n\n.BC-Page__SuggestionDictionary .Polaris-DataTable__Cell:last-child {\n  width: 142px;\n  padding-right: 1.25rem;\n}\n\n.BC-Page__SuggestionDictionary .newSuggestion .Polaris-DataTable__Cell:first-child,\n.BC-Page__SuggestionDictionary .editSuggestion .Polaris-DataTable__Cell:nth-child(2) {\n  width: 75%;\n}\n\n.BC-Page__SuggestionDictionary .newSuggestion .Polaris-DataTable__Cell:last-child,\n.BC-Page__SuggestionDictionary .editSuggestion .Polaris-DataTable__Cell:last-child {\n  width: 76px;\n  text-align: right;\n  padding-right: 1.25rem;\n}\n\n.BC-Page__SuggestionDictionary .Polaris-DataTable__Cell .BC-Checkbox-Status {\n  margin-top: 4px;\n}\n\n.BC-Page__SuggestionDictionary .ImportExportActionsGroup {\n  display: inline-flex;\n  color: #637381;\n}\n\n.BC-Page__SuggestionDictionary .ImportExportActionsGroup .action {\n  display: inline-flex;\n  cursor: pointer;\n}\n\n.BC-Page__SuggestionDictionary .ImportExportActionsGroup .action:last-child {\n  margin-left: 1.4375rem;\n}\n\n.BC-Page__SuggestionDictionary .ImportExportActionsGroup .action .Polaris-Icon {\n  margin-right: 3px;\n}\n\n.BC-Page__SuggestionDictionary .addMoreSuggestion {\n  padding: 0.75rem 1.25rem 0.75rem 0.75rem;\n  padding-right: 16px;\n  text-align: right;\n}\n\n.BC-Page__SuggestionDictionary .addMoreSuggestion .Polaris-Button,\n.BC-Page__SuggestionDictionary .newSuggestion .Polaris-DataTable__Cell .Polaris-Button {\n  width: 36px;\n}\n\n.BC-Page__SuggestionDictionary .addMoreSuggestion .Polaris-Button__Text,\n.BC-Page__SuggestionDictionary .newSuggestion .Polaris-DataTable__Cell .Polaris-Button__Text {\n  font-weight: 700;\n}\n\n.BC-Page__SuggestionDictionary .editSuggestion .Polaris-DataTable__Cell:last-child,\n.BC-Page__SuggestionDictionary .editRedirect .Polaris-DataTable__Cell:last-child {\n  text-align: center;\n}\n\n.BC-Page__SuggestionDictionary .editSuggestion .Polaris-DataTable__Cell .Polaris-Choice__Control,\n.BC-Page__SuggestionDictionary .editRedirect .Polaris-DataTable__Cell .Polaris-Choice__Control {\n  margin-top: 10px;\n  margin-right: 0;\n}\n\n.BC-Page__SuggestionDictionary .actionsGroup,\n.BC-Page__Merchandising .actionsGroup,\n.BC-Page__MerchandisingV2 .actionsGroup {\n  position: absolute;\n  right: 0px;\n  top: 0px;\n}\n\n.BC-Page__SuggestionDictionary\n  .BC-Page__Button-HasBreadcrumb\n  .Polaris-Stack__Item:last-child\n  .Polaris-Button,\n.BC-Page__SuggestionDictionary .actionsGroup .Polaris-Stack__Item:last-child .Polaris-Button,\n.BC-Page__Merchandising .actionsGroup .Polaris-Stack__Item:last-child .Polaris-Button {\n  padding: 0.4375rem 0.625rem;\n}\n\n/* Redirect */\n.BC-Page__Redirect .editRedirect .Polaris-DataTable__Cell:first-child {\n  width: 9%;\n}\n\n.BC-Page__Redirect .newRedirect .Polaris-DataTable__Cell:first-child,\n.BC-Page__Redirect .editRedirect .Polaris-DataTable__Cell:nth-child(2) {\n  width: 340px;\n}\n\n.BC-Page__Redirect .newRedirect .Polaris-DataTable__Cell:nth-child(2),\n.BC-Page__Redirect .editRedirect .Polaris-DataTable__Cell:nth-child(3) {\n  width: auto;\n}\n\n.BC-Page__Redirect .newRedirect .Polaris-DataTable__Cell:last-child,\n.BC-Page__Redirect .editRedirect .Polaris-DataTable__Cell:last-child {\n  width: 68px;\n}\n\n.BC-Page__Redirect .Polaris-DataTable__Cell:last-child {\n  width: auto;\n}\n\n.BC-Page__Merchandising .noRules .Polaris-DataTable__Cell:last-child {\n  width: 9%;\n}\n\n.BC-Page__Redirect .Polaris-DataTable__Cell:first-child {\n  width: 120px;\n}\n\n.BC-Page__Redirect .Polaris-DataTable__Cell:nth-child(2) {\n  width: 240px;\n}\n\n.BC-Page__Redirect-New .addMoreSuggestion .Polaris-Button {\n  padding: 0;\n}\n\n.BC-Page__Redirect-New .addMoreSuggestion .Polaris-Button .Polaris-Button__Text {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.BC-Page__Redirect .newRedirect .Polaris-DataTable__Cell:last-child .Polaris-Button {\n  width: 36px;\n  padding: 0;\n}\n\n.BC-Page__Redirect\n  .newRedirect\n  .Polaris-DataTable__Cell:last-child\n  .Polaris-Button\n  .Polaris-Button__Text {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Dropzone */\n.dropzone .Polaris-DropZone--sizeExtraLarge {\n  min-height: 40px;\n}\n\n.Polaris-Icon--colorGreen {\n  margin-left: 0;\n}\n\n/* Synonym */\n.BC-Page__Synonym .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty {\n  height: 20px;\n}\n\n.BC-EmptyOption__Synonym {\n  padding-top: 1.875rem;\n  padding-bottom: 1.5rem;\n}\n\n.BC-EmptyOption__AISynonym .title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #202223;\n}\n\n.BC-EmptyOption__AISynonym .content {\n  font-size: 14px;\n  font-weight: 400;\n  color: #6d7175;\n  margin-top: 5px;\n}\n\n.BC-Page__Synonym .Polaris-DataTable__Cell {\n  padding: 1.25rem 0.78125rem;\n}\n\n.BC-Page__Synonym .listSynonyms.empty thead tr {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page__Synonym .listSynonyms.empty .Polaris-DataTable__Cell {\n  border-bottom: none;\n}\n\n.BC-Page__Synonym .listSynonyms .Polaris-DataTable__Cell:first-child,\n.BC-Page__Synonym .editSynonyms .Polaris-DataTable__Cell:first-child {\n  width: 9%;\n  padding-left: 1.25rem;\n}\n\n.BC-Page__Synonym .listSynonyms .Polaris-DataTable__Cell:nth-child(2) {\n  width: 25%;\n}\n\n.BC-Page__Synonym .listSynonyms .Polaris-DataTable__Cell .disabled {\n  color: #8c9196;\n}\n\n.BC-Page__Synonym .listSynonyms .Polaris-DataTable__Cell:nth-child(3) {\n  width: 78px;\n  text-align: center;\n}\n\n.BC-Page__Synonym .listSynonyms .Polaris-DataTable__Cell:last-child {\n  padding-right: 1.25rem;\n}\n\n.BC-Page__Synonym .listSynonyms .synonyms {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.BC-Page__Synonym .listSynonyms .synonym-item {\n  padding: 2px 6px;\n  background: #f4f6f8;\n  border-radius: 3px;\n  margin-right: 2px;\n  margin-top: 4px;\n  color: #637381;\n}\n\n.BC-Page__Synonym .newSynonyms .Polaris-DataTable__Cell:first-child,\n.BC-Page__Synonym .editSynonyms .Polaris-DataTable__Cell:nth-child(2) {\n  width: 25%;\n}\n\n.BC-Page__Synonym .newSynonyms .Polaris-DataTable__Cell:nth-child(2),\n.BC-Page__Synonym .editSynonyms .Polaris-DataTable__Cell:nth-child(3) {\n  width: 78px;\n}\n\n.BC-Page__Synonym .editSynonyms .Polaris-DataTable__Cell:nth-child(5),\n.BC-Page__Synonym .newSynonyms .Polaris-DataTable__Cell:nth-child(4) {\n  width: 100px;\n  text-align: center;\n}\n\n.BC-Page__Synonym .newSynonyms .Polaris-DataTable__Cell:last-child,\n.BC-Page__Synonym .editSynonyms .Polaris-DataTable__Cell:last-child {\n  width: 76px;\n  text-align: center;\n}\n\n.BC-Page__Synonym .Polaris-DataTable__Cell .BC-Checkbox-Status {\n  margin-top: 4px;\n}\n\n.BC-Page__Synonym .ImportExportActionsGroup {\n  display: inline-flex;\n  color: #637381;\n}\n\n.BC-Page__Synonym .ImportExportActionsGroup .action {\n  display: inline-flex;\n  cursor: pointer;\n}\n\n.BC-Page__Synonym .ImportExportActionsGroup .action:last-child {\n  margin-left: 1.4375rem;\n}\n\n.BC-Page__Synonym .ImportExportActionsGroup .action .Polaris-Icon {\n  margin-right: 3px;\n}\n\n.BC-Page__Synonym .addMoreSynonyms {\n  padding: 1.25rem;\n  text-align: right;\n}\n\n.BC-Page__SuggestionDictionary .editSuggestion .Polaris-Button,\n.BC-Page__Synonym .addMoreSynonyms .Polaris-Button,\n.BC-Page__Synonym .editSynonyms .Polaris-DataTable__Cell .Polaris-Button,\n.BC-Page__Synonym .newSynonyms .Polaris-DataTable__Cell .Polaris-Button {\n  width: 36px;\n}\n\n.BC-Page__Synonym .addMoreSynonyms .Polaris-Button__Text,\n.BC-Page__Synonym .newSynonyms .Polaris-DataTable__Cell .Polaris-Button__Text {\n  font-weight: 700;\n}\n\n.BC-Page__Synonym .editSynonyms .Polaris-DataTable__Cell:last-child {\n  text-align: center;\n}\n\n.BC-Page__Synonym .newSynonyms .Polaris-DataTable__Cell .Polaris-Choice__Control,\n.BC-Page__Synonym .editSynonyms .Polaris-DataTable__Cell .Polaris-Choice__Control {\n  margin-top: 10px;\n  margin-right: 0;\n}\n\n.BC-Page__Synonym .actionsGroup {\n  position: absolute;\n  right: 0px;\n  top: 0px;\n}\n\n.BC-Page__Synonym .actionsGroup--height {\n  height: 36px;\n}\n\n.BC-Page__Synonym .BC-Page__Button-HasBreadcrumb .Polaris-Stack__Item:last-child .Polaris-Button,\n.BC-Page__Synonym .actionsGroup .Polaris-Stack__Item:last-child .Polaris-Button {\n  padding: 0.4375rem 0.625rem;\n}\n\n.BC-Page__Synonym .Polaris-Tabs__Wrapper {\n  padding: 0 0 1.5rem;\n}\n\n.BC-Page__Synonym .editSynonymModel .Polaris-DataTable__Cell--header {\n  border-bottom: 0;\n  padding-bottom: 0;\n}\n\n.BC-Page__Synonym .editSynonymModel .Polaris-DataTable__Cell--firstColum {\n  padding-left: 0;\n}\n\n.BC-Page__Synonym .actionIcon .Polaris-Icon {\n  width: 1rem;\n  height: 1rem;\n  cursor: pointer;\n}\n\n.BC-Page__Synonym .Polaris-Tabs__Wrapper .Polaris-Tabs__TabContainer .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  margin-right: 2px;\n  height: 1.2rem;\n  width: 1rem;\n}\n\n.BC-Page__Synonym\n  .tab-AIsynonym-disabled\n  .Polaris-Tabs\n  .Polaris-Tabs__TabContainer:nth-child(2)\n  button\n  p {\n  color: var(--p-text-disabled);\n}\n\n.BC-Page__Synonym\n  .tab-AIsynonym-disabled\n  .Polaris-Tabs\n  .Polaris-Tabs__TabContainer:nth-child(2)\n  button\n  span::before {\n  bottom: unset;\n  content: unset;\n  box-shadow: none;\n  transition: none;\n  border-radius: none;\n  height: 0px;\n}\n\n.BC-Page__Synonym .manual-synonym-suggest--ai {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 8px;\n  border: 1px solid #e1e3e5;\n  padding: 0 20px;\n  height: 56px;\n  background-color: white;\n}\n\n.BC-Page__Synonym .manual-synonym-suggest--ai .Polaris-Link {\n  text-decoration: none;\n}\n\n.BC-Page__Synonym .manual-synonym-suggest--ai .manual-synonym-suggest--ai-title {\n  font-size: 16px !important;\n}\n\n.BC-Page__Synonym .manual-synonym-suggest--ai .manual-synonym-suggest--ai-title .Polaris-Badge {\n  margin-left: 10px;\n  font-size: 12px;\n}\n\n.BC-Page__Synonym .manual-synonym-suggest--ai .manual-synonym-suggest--ai-title .Polaris-Badge-Pip {\n  --pc-pip-size: 7px;\n}\n\n.BC-Page__Synonym .manual-synonym-banner--unlock {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 16px;\n  background-color: #fffbf3;\n  border-radius: 8px;\n}\n\n.BC-Page__Synonym .unlock-button {\n  border-radius: 4px;\n  background: var(--decorative-surface-one, #ffc96b);\n  box-shadow:\n    0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset,\n    0px 1px 0px 0px rgba(0, 0, 0, 0.08);\n  width: 99px;\n  font-weight: 500;\n}\n\n.BC-Page__Synonym .unlock-button .Polaris-Icon svg {\n  fill: #1a1c1d;\n}\n\n.SynonymTable__Header .Polaris-Stack__Item {\n  width: 100%;\n}\n\n.SynonymTable__Header .Polaris-Stack__Item--fill {\n  display: none;\n}\n\n.SynonymTable__Header .premium-warning-restore {\n  min-height: 104px !important;\n}\n\n/* Merchandising */\n.BC-Merchandising__TryNewVersion\n  .Polaris-Banner\n  .Polaris-Banner__ContentWrapper\n  .Polaris-Banner__Content\n  > p:first-child\n  a {\n  color: #2c6ecb;\n  text-decoration: none;\n}\n\n.BC-Merchandising__TryNewVersion\n  .Polaris-Banner\n  .Polaris-Banner__ContentWrapper\n  .Polaris-Banner__Content\n  > p:first-child\n  .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.BC-Merchandising__TryNewVersion\n  .Polaris-Banner\n  .Polaris-Banner__ContentWrapper\n  .Polaris-Banner__Content\n  ul {\n  margin: 0px;\n  padding-left: 20px;\n}\n\n.BC-Merchandising__TryNewVersion .Polaris-Layout__Section {\n  flex: 2 2 41.25rem;\n}\n\n.BC-Merchandising__TryNewVersion .Polaris-Layout__Section--secondary {\n  flex: 1 1 12.5rem;\n  text-align: right;\n}\n\n.BC-Page__Merchandising .BC-EmptyRules__Merchandising .Polaris-Button--primary,\n.BC-Page__Metafield .BC-EmptyRules__Metafield .Polaris-Button--primary,\n.BC-Page__Product-Visibility .BC-EmptyRules__Product-Visibility .Polaris-Button--primary {\n  width: 167px;\n}\n\n.BC-Page__Merchandising .Polaris-Stack > .Polaris-Stack__Item .search {\n  position: absolute;\n  right: 20px;\n  top: 10px;\n  width: 18.75rem;\n}\n\n.BC-Page__Merchandising .Polaris-Stack > .Polaris-Stack__Item .search .Polaris-TextField__Input {\n  font-size: 0.75rem;\n}\n\n.BC-Page__Merchandising .noRules .Polaris-DataTable__Cell:not(:first-child) {\n  text-align: center;\n}\n\n.BC-Page__Merchandising .Polaris-DataTable__Cell:first-child {\n  width: 5%;\n  padding-left: 1.25rem;\n  padding-right: 0;\n}\n\n.BC-Page__Merchandising .Polaris-DataTable__Cell:nth-child(2) {\n  width: 10%;\n  padding-left: 0.9375rem;\n}\n\n.BC-Page__Merchandising .Polaris-DataTable__Cell:nth-child(3) {\n  width: 25%;\n}\n\n/*.BC-Page__Merchandising .Polaris-DataTable__Cell:nth-child(4) {\n  width: 30%;\n}*/\n\n.BC-Page__Merchandising .Polaris-DataTable__Cell:nth-child(5) {\n  width: 12%;\n}\n\n.BC-Page__Merchandising .Polaris-DataTable__Cell:nth-child(6) {\n  width: 111px;\n  text-align: center;\n}\n\n.BC-Page__Merchandising .hasRules .Polaris-DataTable .Polaris-DataTable__TableRow {\n  background-color: #fff;\n}\n\n.BC-EmptyRules__Merchandising img,\n.BC-EmptyRules__Metafield img,\n.BC-EmptyRules__CustomRangeSlider img,\n.BC-EmptyRules__CustomSorting img,\n.BC-EmptyRules__Product-Visibility img {\n  width: 50px;\n}\n\n.BC-Page__Merchandising .BC-Page__Button-HasBreadcrumb .Polaris-Button,\n.BC-Page__Merchandising .Polaris-PageActions .Polaris-Button {\n  width: 68px;\n}\n\n.BC-Page__Merchandising-Rule .Polaris-Page-Header .Polaris-Header-Title__SubTitle {\n  font-size: 20px;\n  line-height: 28px;\n  color: #637381;\n}\n\n.BC-Page__Merchandising-Rule-DateRange {\n  color: rgb(118, 118, 118);\n}\n\n.datePicker .date-select .Polaris-Button svg {\n  fill: var(--p-icon-subdued);\n}\n\n.BC-Page__Merchandising-Rule .conditions legend {\n  float: left;\n}\n\n.BC-Page__Merchandising-Rule .conditions .Polaris-ChoiceList ul li:first-child {\n  float: left;\n  padding: 0 1.25rem;\n}\n\n.BC-Page__Merchandising-Rule\n  .conditions\n  .Polaris-DataTable__Table\n  .Polaris-DataTable__Cell--firstColumn {\n  padding: 0 !important;\n  width: 0%;\n  /* Fix issue tooltip showed in the first column by adding an empty column*/\n}\n\n.BC-Page__Merchandising-Rule\n  .conditions\n  .Polaris-DataTable__Table\n  .Polaris-DataTable__Cell--header {\n  padding-bottom: 0;\n  border-bottom: 0;\n}\n\n.BC-Page__Merchandising-Rule\n  .conditions\n  .Polaris-DataTable__Table\n  .Polaris-DataTable__TableRow\n  .Polaris-DataTable__Cell {\n  padding: 1.5625rem 0.6875rem;\n}\n\n.BC-Page__Merchandising-Rule\n  .conditions\n  .Polaris-DataTable__Table\n  .Polaris-DataTable__TableRow:first-child\n  .Polaris-DataTable__Cell {\n  padding-top: 0.8125rem;\n}\n\n.BC-Page__Merchandising-Rule\n  .conditions\n  .Polaris-DataTable__Table\n  .Polaris-DataTable__TableRow\n  .Polaris-DataTable__Cell:last-child {\n  width: 36px;\n  padding-right: 1px !important;\n}\n\n.BC-Page__Merchandising-Rule\n  .conditions\n  .Polaris-DataTable__Table\n  .Polaris-DataTable__Cell:nth-child(2) {\n  padding-left: 0 !important;\n  width: 28%;\n}\n\n.BC-Page__Merchandising-Rule\n  .conditions\n  .Polaris-DataTable__Table\n  .Polaris-DataTable__Cell:nth-child(3) {\n  width: 40%;\n}\n\n.BC-Page__Merchandising-Rule\n  .conditions\n  .Polaris-DataTable__Table\n  .Polaris-DataTable__Cell:nth-child(4) {\n  max-width: 240px;\n}\n\n.BC-Page__Merchandising-Rule .conditions .Polaris-DataTable__TableRow .Polaris-Button--iconOnly {\n  padding: 0.625rem;\n}\n\n.BC-Page__Merchandising-Rule .conditions .Polaris-DataTable__TableRow .Polaris-Icon {\n  width: 0.875rem;\n  height: 0.875rem;\n}\n\n.BC-Page__Merchandising-Rule .addNewCondition {\n  text-align: right;\n  padding-top: 1.25rem;\n  border-top: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page__Merchandising-Rule\n  .Polaris-PageActions\n  .Polaris-Stack--spacingTight\n  > .Polaris-Stack__Item {\n  margin-top: 0.75rem;\n  margin-left: 1rem;\n}\n\n.field-error-text {\n  margin-top: 10px;\n  color: var(--p-critical-text, #bf0711);\n}\n\n.in-collection-search-lock .action,\n.premium-lock-card .action {\n  margin-top: 1rem;\n  display: flex;\n  align-items: center;\n}\n\n.premium-lock-card .content-list > div {\n  margin-top: 0.75rem;\n  display: flex;\n  align-items: flex-start;\n}\n\n.premium-lock-card .content-list img {\n  margin-right: 0.25rem;\n}\n\n.in-collection-search-lock .Polaris-Button,\n.premium-lock-card .Polaris-Button {\n  background: var(--decorative-surface-one, #ffc96b);\n  box-shadow:\n    0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset,\n    0px 1px 0px 0px rgba(0, 0, 0, 0.08);\n  font-weight: 500;\n  margin-right: 0.75rem;\n  align-items: center;\n  gap: 4px;\n  border: unset;\n}\n\n.in-collection-search-lock .Polaris-Button .Polaris-Icon svg,\n.premium-lock-card .Polaris-Button .Polaris-Icon svg {\n  fill: var(--p-icon-hovered);\n}\n\n.upgrade-plan-analytic .Polaris-Link .Polaris-Icon,\n.in-collection-search-lock .action a .Polaris-Icon,\n.premium-lock-card .action a .Polaris-Icon {\n  vertical-align: middle;\n  display: inline-block;\n}\n\n.upgrade-plan-analytic {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.upgrade-plan-analytic .Polaris-Badge {\n  background: #fff2d9;\n  color: #ff3345;\n  font-weight: 600;\n  padding: 4px;\n  border-radius: 4px;\n}\n\n.upgrade-plan-analytic .Polaris-Badge > span:last-child {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.upgrade-plan-analytic .Polaris-Link {\n  text-decoration: none;\n}\n\n.premium-lock-card .Polaris-Grid-Cell > img {\n  width: 100%;\n}\n\n.in-collection-search-lock {\n  text-align: center;\n  margin: 40px 100px;\n}\n\n.in-collection-search-lock img {\n  width: 30%;\n  height: auto;\n}\n\n.in-collection-search-lock .content {\n  margin-top: 16px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.in-collection-search-lock > p {\n  color: #6d7175;\n  margin-top: 4px;\n}\n\n.in-collection-search-lock .action {\n  width: 100%;\n  justify-content: center;\n}\n\n/* Merchandising V2 */\n\n.BC-Page__MerchandisingV2 .Polaris-Card .premium-lock-card .Polaris-Icon,\n.collection-action-locked .Polaris-Icon,\n.BC-Page__MerchandisingV2 .Polaris-Tabs__Wrapper .Polaris-Tabs__TabContainer .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  margin-right: 2px;\n  height: 20px;\n  width: 20px;\n}\n\n.collection-action-locked {\n  color: #8c9196;\n}\n\n.collection-action-locked .Polaris-Icon svg {\n  fill: var(--p-icon-disabled);\n}\n\n#PolarisPortalsContainer .Polaris-Tooltip-TooltipOverlay {\n  pointer-events: auto;\n}\n\n.link-tooltip {\n  color: #1f5199;\n}\n\n.link-tooltip:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.collection-action-locked .Polaris-Icon,\n.action-locked .Polaris-Icon {\n  margin-left: 2px;\n  margin-right: 0 !important;\n}\n\n.premium-warning-restore {\n  display: flex;\n  margin-bottom: 17px;\n  padding: 16px;\n  gap: 16px;\n}\n\n.PFS-scope-suggestion-locked {\n  width: 100%;\n  margin-top: 16px;\n}\n\n.premium-iws-card {\n  min-height: 144px;\n  border-radius: 8px;\n  padding: 20px;\n  position: relative;\n  background: #fffbf3;\n}\n\n.premium-iws-card .Polaris-TextStyle--variationStrong {\n  font-size: 16px;\n}\n\n.premium-iws-card--trial {\n  border: 1px solid #e1b878;\n  background-color: #fff5ea;\n}\n\n.premium-iws-card--trial > .Polaris-Button svg {\n  fill: var(--p-icon-warning);\n}\n\n.premium-iws-card > .unlock-button {\n  width: fit-content;\n  background: #fff5ea;\n  margin-top: 12px;\n  border: 1px solid #e1b878;\n  border-radius: 4px;\n  padding: 8px 16px 8px 12px;\n  font-weight: 500;\n}\n\n.premium-warning-restore > .Polaris-Button {\n  align-items: baseline !important;\n}\n\n.premium-iws-card > .unlock-button .Polaris-Icon {\n  width: 20px;\n  height: 20px;\n}\n\n.premium-warning-restore > .Polaris-Button .Polaris-Icon {\n  height: 1rem;\n  width: 1rem;\n}\n\n.premium-warning-restore .Polaris-Icon {\n  margin: 0;\n  min-width: 2%;\n}\n\n.unlock-button:hover {\n  cursor: pointer;\n}\n\n.premium-iws-card > .Polaris-Button .Polaris-Icon {\n  margin-right: 7px;\n}\n\n.premium-iws-card div .unlock-button,\n.premium-warning-restore div .unlock-button {\n  background: #fff5ea;\n  border: 1px solid #e1b878;\n  font-weight: 500;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__Synonym\n  .unlock-button-disabled\n  .Polaris-Banner__Button\n  .Polaris-Icon\n  svg,\n.enhance-ai-search-banner-disabled .Polaris-Banner__Button .Polaris-Icon svg,\n.premium-iws-card > .unlock-button-disabled .Polaris-Icon svg,\n.premium-lock-card .unlock-button-disabled .Polaris-Icon svg {\n  fill: var(--p-icon);\n}\n\n.BC-Page__StandardSearch .BC-Page__Synonym .unlock-button-disabled .Polaris-Banner__Button,\n.enhance-ai-search-banner-disabled .Polaris-Banner__Button,\n.premium-card-lock > div .unlock-button-disabled,\n.premium-iws-card > .unlock-button-disabled,\n.premium-lock-card .unlock-button-disabled,\n.premium-warning-restore div .unlock-button-disabled {\n  background: #f7f3ef !important;\n  border: 1px solid #d1d1d1;\n  font-weight: 500;\n  color: gray !important;\n}\n\n.BC-Page__StandardSearch .BC-Page__Synonym .unlock-button-disabled .Polaris-Banner__Button:hover,\n.enhance-ai-search-banner-disabled .Polaris-Banner__Button:hover,\n.premium-card-lock > div .unlock-button-disabled:hover,\n.premium-iws-card > .unlock-button-disabled:hover,\n.premium-warning-restore div .unlock-button-disabled:hover {\n  cursor: unset;\n}\n\n.breakLine {\n  border-top: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page-Variants-Display .Polaris-Page .Polaris-Layout .Polaris-Card,\n.BC-Page__MerchandisingV2 .Polaris-Card {\n  position: relative;\n}\n\n.merchandisingV2Infos .image {\n  max-height: 132px;\n}\n\n.premium-card-lock {\n  width: 100%;\n  height: 100%;\n  opacity: 2.5;\n  position: absolute;\n  background: white;\n  z-index: 21;\n  background: linear-gradient(0, #ffffff 39.69%, rgba(255, 255, 255, 0.7) 100%);\n  backdrop-filter: blur(1.5px);\n  border-radius: 8px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n}\n\n.premium-lock-card .Polaris-Card {\n  padding: 1.25rem 0rem;\n}\n\n.premium-lock-card .Polaris-Card__Section {\n  padding: 1.25rem 2rem;\n  border: none;\n}\n\n.premium-lock-card .Polaris-Grid-Cell {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n\n.premium-lock-card p.title {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 32px;\n  margin-bottom: 0.25rem;\n}\n\n.premium-lock-card p.title img {\n  margin-right: 0.25rem;\n}\n\n.pfs-freemium-card-lock .action,\n.search-control-lock-banner .action,\n.pfs-feature-lock-media-card .action .pfs-feature-lock-card .action,\n.premium-lock-card .action {\n  margin-top: 1rem;\n  display: flex;\n  align-items: center;\n}\n\n.premium-lock-card .content-list > div {\n  margin-top: 0.75rem;\n  display: flex;\n  align-items: flex-start;\n}\n\n.premium-lock-card .content-list img {\n  margin-right: 0.25rem;\n}\n\n.freemiumAnalyticBanner .Polaris-Button,\n.pfs-freemium-card-lock .action .Polaris-Button,\n.search-control-lock-banner .action .Polaris-Button,\n.pfs-feature-lock-media-card .Polaris-Button,\n.pfs-feature-lock-card .Polaris-Button,\n.premium-lock-card .Polaris-Button {\n  background: var(--decorative-surface-one, #ffc96b);\n  box-shadow:\n    0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset,\n    0px 1px 0px 0px rgba(0, 0, 0, 0.08);\n  font-weight: 500;\n  margin-right: 0.75rem;\n  align-items: center;\n  gap: 4px;\n  border: unset;\n}\n\n.freemiumAnalyticBanner .Polaris-Button .Polaris-Button__Text {\n  font-weight: 500;\n}\n\n.freemiumAnalyticBanner .Polaris-Button {\n  margin-right: unset;\n}\n\n.pfs-freemium-card-lock .action .Polaris-Button .Polaris-Icon svg,\n.search-control-lock-banner .action .Polaris-Button .Polaris-Icon svg,\n.pfs-feature-lock-media-card .Polaris-Button .Polaris-Icon svg,\n.pfs-feature-lock-card .Polaris-Button .Polaris-Icon svg,\n.premium-lock-card .Polaris-Button .Polaris-Icon svg {\n  fill: var(--p-icon-hovered);\n}\n\n.search-control-lock-banner .action .Polaris-Button .Polaris-Icon,\n.option-premium-lock .Polaris-Link .Polaris-Icon,\n.pfs-feature-lock-media-card .action a .Polaris-Icon,\n.pfs-feature-lock-card .action a .Polaris-Icon,\n.premium-lock-card .action a .Polaris-Icon {\n  vertical-align: middle;\n  display: inline-block;\n}\n\n.premium-lock-card .Polaris-Grid-Cell > img {\n  width: 100%;\n}\n\n.pfs-feature-lock-card {\n  text-align: center;\n  margin: 40px 100px;\n}\n\n.pfs-feature-lock-media-card .content {\n  display: inline;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 32px;\n}\n\n.pfs-feature-lock-media-card .content img {\n  margin-right: 4px;\n}\n\n.pfs-feature-lock-card img {\n  width: 30%;\n  height: auto;\n}\n\n.pfs-feature-lock-card .content {\n  margin-top: 16px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.pfs-feature-lock-card > p {\n  color: #6d7175;\n  margin-top: 4px;\n}\n\n.pfs-feature-lock-card .action {\n  width: 100%;\n  margin-top: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pfs-feature-lock-card .Polaris-Icon {\n  margin: unset;\n}\n\n.pfs-feature-lock-card .Polaris-Link {\n  display: flex;\n  gap: 4px;\n}\n\n.pfs-feature-lock-media-card {\n  padding: 24px;\n  border-radius: 8px 0px 0px 0px;\n  background: #ffffff;\n}\n\n.pfs-feature-lock-media-card > p {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #202223;\n  margin-top: 6px;\n}\n\n.search-control-lock-banner .action,\n.pfs-feature-lock-media-card .action {\n  margin-top: 16px;\n  display: flex;\n  align-items: center;\n}\n\n.pfs-feature-lock-media-card .media {\n  margin-top: 32px;\n  width: 100%;\n}\n\n.pfs-feature-lock-media-card .media iframe {\n  width: 100%;\n  min-height: 400px;\n  border: unset;\n  border-radius: 8px;\n}\n\n.pfs-feature-lock-media-card .media img {\n  width: 100%;\n  height: auto;\n}\n\n.option-premium-lock {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.option-premium-lock .Polaris-Badge {\n  background: #fff2d9;\n  color: #ff3345;\n  font-weight: 600;\n  padding: 4px;\n  border-radius: 4px;\n}\n\n.option-premium-lock .Polaris-Badge > span:last-child {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.option-premium-lock .Polaris-Link {\n  text-decoration: none;\n}\n\n.pfs-advanced-settings-lock {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  padding: 84px 134px 64px;\n}\n\n.pfs-advanced-settings-lock img {\n  min-width: 160px;\n  min-height: 100px;\n  width: 160px;\n  height: 100px;\n}\n\n.pfs-advanced-settings-lock .content {\n  display: grid;\n  gap: 4px;\n  align-items: center;\n  justify-content: center;\n}\n\n.pfs-advanced-settings-lock .heading {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.pfs-advanced-settings-lock .text {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #69696b;\n  max-width: 431px;\n}\n\n.pfs-freemium-card-lock .action .Polaris-Icon,\n.search-control-lock-banner .action .Polaris-Icon {\n  display: inline-block;\n  vertical-align: top;\n}\n\n.search-control-lock-banner .action .Polaris-Link {\n  color: #000;\n}\n\n.pfs-freemium-card-lock {\n  background: rgba(255, 255, 255, 1);\n  width: 100%;\n  height: auto;\n  padding: 40px 32px 32px 32px;\n  border-radius: 8px 0px 0px 0px;\n  display: grid;\n  gap: 40px;\n}\n\n.pfs-freemium-card-lock .row {\n  display: flex;\n  width: 100%;\n  gap: 48px;\n  align-items: center;\n}\n\n.pfs-freemium-card-lock .heading {\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 32px;\n}\n\n.pfs-freemium-card-lock .heading img {\n  margin-right: 4px;\n}\n\n.pfs-freemium-card-lock .content > p {\n  margin-top: 8px;\n}\n\n.pfs-freemium-card-lock .content ul {\n  margin-top: 8px;\n  padding-left: 24px;\n}\n\n.pfs-freemium-card-lock .row > div {\n  width: 50%;\n}\n\n.pfs-freemium-card-lock .row .media img {\n  width: 100%;\n  height: auto;\n}\n\n.pfs-freemium-card-lock .row .media iframe {\n  width: 100%;\n  height: auto;\n  min-height: 240px;\n  border: unset;\n}\n\n.textfield-with-prefix {\n  width: 100%;\n}\n\n.textfield-with-prefix .Polaris-TextField__Prefix {\n  background: #f1f2f3;\n  height: 2.084rem !important;\n  width: 25%;\n  display: flex;\n  align-items: center;\n  margin-left: 1px;\n  color: #202223;\n  justify-content: center;\n}\n\n.textfield-with-prefix .Polaris-TextField__Prefix + .Polaris-TextField__Input {\n  padding-left: 8px;\n}\n\n.select-with-prefix {\n  width: 92%;\n}\n\n.select-with-prefix .select-wrapper {\n  display: flex;\n  align-items: center;\n  border: var(--p-border-width-1) solid var(--p-border-subdued);\n  border-radius: var(--p-border-radius-1);\n}\n\n.select-with-prefix .select-wrapper > div:last-child {\n  width: 100%;\n}\n\n.select-with-prefix .select-prefix {\n  background: #f1f2f3;\n  height: 2.084rem !important;\n  width: 90px;\n  display: flex;\n  align-items: center;\n  margin-left: 1px;\n  color: #202223;\n  justify-content: center;\n}\n\n.select-with-prefix .Polaris-Select .Polaris-Select__Backdrop {\n  border: none;\n}\n\n.textfield-with-icon {\n  display: flex;\n  align-items: center;\n  border: var(--p-border-width-1) solid var(--p-border-subdued);\n  border-radius: var(--p-border-radius-1);\n  border-top-color: var(--p-border-shadow);\n  background-color: #fff;\n}\n\n.textfield-with-icon .Polaris-TextField__Backdrop {\n  border: none;\n}\n\n.textfield-with-icon .Polaris-TextField__Input:focus ~ .Polaris-TextField__Backdrop::after {\n  box-shadow: none;\n}\n\n.textfield-with-icon--img {\n  display: flex;\n}\n\n.textfield-with-icon img {\n  margin-right: 6px;\n  cursor: pointer;\n}\n\n.set-rule-strategies .Polaris-FormLayout {\n  margin-top: 1rem;\n}\n\n.merchandising-rule-strategy .card-add-field-attribute .add-field-attribute {\n  margin-top: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.merchandising-rule-strategy .card-add-field-attribute .banner-card-section {\n  margin-top: 20px;\n}\n\n.merchandising-rule-strategy\n  .card-add-field-attribute\n  .add-field-attribute\n  .Polaris-Badge--statusInfo {\n  color: #00527c;\n  background: #e0f0ff;\n  border-radius: 8px;\n}\n\n.set-rule-conditions .apply-same-rule-queries {\n  margin-left: 15px;\n}\n\n.set-rule-conditions .apply-same-rule-queries p,\n.add-field-attribute p {\n  color: #2c6ecb;\n  display: flex;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.set-rule-conditions .apply-same-rule-queries span {\n  margin: auto 10px auto 0;\n}\n\n.set-rule-conditions .apply-same-rule-queries .Polaris-Icon--colorBase svg,\n.add-field-attribute .Polaris-Icon--colorBase svg {\n  fill: #2c6ecb;\n}\n\n.BC-Page__StandardSearch .default-text-style,\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .card-section .default-text-style {\n  font-weight: 400 !important;\n}\n\n.BC-Page__MerchandisingV2-Rule\n  .Polaris-Page\n  .Polaris-Page-Header\n  .Polaris-Page-Header__Row\n  .Polaris-Page-Header__TitleWrapper {\n  width: calc(100% - 350px);\n}\n\n.BC-Page__MerchandisingV2-Rule\n  .Polaris-Page\n  .Polaris-Page__Content\n  .Polaris-Layout__Section--secondary\n  .Polaris-Card\n  form,\n.BC-MerchandisingV2-Rule-save-modal,\n.BC-Management-Widget .Polaris-Card__Section .searchField .Polaris-Connected {\n  --p-focused: none !important;\n}\n\n.pfs-link {\n  color: #2c6ecb;\n  margin-right: 4px;\n  text-decoration: underline;\n}\n\n.pfs-link:hover {\n  cursor: pointer;\n}\n\n.pfs-link .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  max-width: 16px;\n  margin-left: 2px;\n}\n\n.pfs-link .Polaris-Icon svg {\n  fill: #2c6ecb;\n}\n\n/* end-region Merchandising rule end */\n.BC-DataTable__PinProducts .Polaris-DataTable__TableRow .Polaris-DataTable__Cell {\n  border-top: none;\n  padding: 10px 1px 10px 10px;\n}\n\n.BC-DataTable__PinProducts .Polaris-DataTable__TableRow:first-child .Polaris-DataTable__Cell {\n  border-top: none;\n  padding: 0px 10px;\n}\n\n.BC-DataTable__PinProducts .Polaris-DataTable__Cell:first-child {\n  width: 20px;\n  padding-left: 0 !important;\n}\n\n.BC-DataTable__PinProducts .Polaris-DataTable__TableRow:nth-child(2) .Polaris-DataTable__Cell {\n  padding: 4px 1px 10px 10px;\n}\n\n.BC-DataTable__PinProducts .Polaris-DataTable__Cell:nth-child(2) {\n  width: 53px;\n  vertical-align: baseline;\n}\n\n.BC-Page__PinProductModal .Polaris-Modal-Section:first-child {\n  padding: 1rem 1.25rem;\n}\n\n.BC-Page__PinProductModal .Polaris-Modal-CloseButton:focus::after {\n  box-shadow: none;\n}\n\n.BC-Page__PinProductModal .Polaris-Icon__Svg {\n  fill: var(--p-text);\n}\n\n.BC-DataTable__PinProducts .position-number {\n  width: 100%;\n  text-align: center;\n  border: 1px solid var(--p-border-subdued);\n  border-radius: 4px;\n  margin: 0;\n  padding: 0.4375rem 0rem;\n  background: #f1f2f3;\n}\n\n.BC-Select_SingleValue-Product .BC-Select__single-value .product-image,\n.BC-Select_Option-Product .BC-Select__option .product-image {\n  min-width: 35px !important;\n  padding-bottom: 28px;\n  float: left;\n  position: relative;\n  border: 1px solid #d2d5d8;\n  border-radius: 4px;\n  box-sizing: border-box;\n  margin-right: 8px;\n  background: #ffffff;\n}\n\n.BC-Select_SingleValue-Product .BC-Select__single-value .product-image img,\n.BC-Select_Option-Product .BC-Select__option .product-image img {\n  position: absolute;\n  max-width: 100%;\n  max-height: 100%;\n  display: block;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n\n.BC-Select_SingleValue-Product .BC-Select__single-value label,\n.BC-Select_Option-Product.BC-Select_Merchandising-Pin .BC-Select__option .product-detail {\n  display: grid;\n  vertical-align: middle;\n  line-height: 30px;\n}\n\n/* ─── Pin Slots Panel (pin-tags-table) ──────────────────────────────────────── */\n\n/* PositionMultiSelect & TagMultiSelect shared activator */\n.psp-multi-activator {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 7px 8px;\n  background: #fff;\n  border-radius: 0 4px 4px 0;\n  min-height: 36px;\n  gap: 6px;\n  overflow: hidden;\n}\n\n.psp-multi-activator__text {\n  flex: 1;\n  min-width: 0;\n  font-size: 14px;\n  color: #202223;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.psp-multi-activator--placeholder .psp-multi-activator__text {\n  color: #6d7175;\n}\n\n.psp-multi-activator__icon {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.psp-multi-activator__icon .Polaris-Icon--colorSubdued svg {\n  fill: #5c5f62;\n}\n\n.psp-position-popover {\n  padding: 8px;\n  max-height: 240px;\n  overflow-y: auto;\n  min-width: 152px;\n}\n\n/* TagMultiSelect popover */\n.psp-tag-popover {\n  width: 260px;\n}\n\n.psp-tag-popover__search {\n  padding: 8px 8px 4px;\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.psp-tag-popover__search .Polaris-TextField {\n  border-radius: 4px;\n}\n\n.psp-tag-popover__list {\n  padding: 4px 0;\n  max-height: 220px;\n  overflow-y: auto;\n}\n\n.psp-tag-popover__empty {\n  padding: 8px 12px;\n  color: #6d7175;\n  font-size: 13px;\n}\n\n.psp-position-checkbox {\n  padding: 8px;\n}\n\n/* table-row helper */\n.psp-table-row {\n  display: flex;\n  border: 1px solid #babfc3;\n  border-radius: 4px;\n  margin-top: 8px;\n}\n\n.psp-item-card .Polaris-Select__Backdrop {\n  border: none;\n  border-radius: 0 4px 4px 0;\n}\n\n.psp-item-card .Polaris-Select__SelectedOption {\n  color: #202223;\n}\n\n/* Placeholder state: dim the \"select value\" text */\n.psp-select-wrap {\n  width: 100%;\n}\n\n.psp-select-wrap--placeholder .Polaris-Select__SelectedOption {\n  color: #6d7175;\n}\n\n.psp-table-row__label {\n  width: 80px;\n  min-width: 80px;\n  padding: 0 8px;\n  background: #f6f6f7;\n  font-size: 14px;\n  color: #202223;\n  display: flex;\n  align-items: center;\n  border-right: 1px solid #e1e3e5;\n  border-radius: 4px 0 0 4px;\n}\n\n.psp-table-row__value {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.psp-table-row__value .Polaris-Select__Input {\n  cursor: pointer;\n}\n\n.psp-table-row__value .Polaris-Select .Polaris-Select__Content {\n  padding: 7px 8px;\n}\n\n.psp-table-row__value .Polaris-Select--disabled .Polaris-Select__Content {\n  opacity: 0.6;\n}\n\n.psp-table-row__value .Polaris-Select--disabled .Polaris-Select__Input {\n  pointer-events: none;\n}\n\n/* description paragraphs */\n.psp-desc-1 {\n  margin-bottom: 12px;\n  font-size: 14px;\n}\n\n.psp-desc-2 {\n  margin-bottom: 16px;\n  font-size: 14px;\n}\n\n/* product tag content */\n.psp-tag-content {\n}\n\n.psp-tag-content .css-ewu0nz-control,\n.psp-tag-content .Polaris-Select__Backdrop {\n  border: none;\n  border-radius: 0 4px 4px 0;\n}\n\n.psp-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin: 8px 28px 8px 24px;\n  justify-content: end;\n}\n\n.psp-pill {\n  display: inline-block;\n  padding: 2px 10px;\n  background: #e8e8e8;\n  border-radius: 8px;\n  font-size: 12px;\n  line-height: 16px;\n  color: #616161;\n}\n\n/* product item content */\n.psp-item-content {\n  margin-top: 8px;\n}\n\n.psp-add-product .Polaris-Button {\n  padding-top: 16px;\n  padding-bottom: 0;\n}\n\n.psp-product-item-block {\n  margin-bottom: 16px;\n}\n\n.psp-item-card {\n  margin-bottom: 8px;\n}\n\n.psp-item-product-row {\n  display: flex;\n  align-items: center;\n}\n\n.psp-item-product-selector {\n  flex: 1;\n  min-width: 0;\n}\n\n.psp-item-delete-btn {\n  padding: 0 8px;\n  flex-shrink: 0;\n}\n\n.psp-item-sub-rows,\n.psp-inner-table {\n  position: relative;\n  margin: 6px 28px 6px 24px;\n}\n\n.psp-item-sub-rows::before,\n.psp-inner-table::before {\n  content: '';\n  position: absolute;\n  left: -12px;\n  top: -8px;\n  width: 1px;\n  height: calc(100% - 10px);\n  background: #babfc4;\n}\n\n.psp-item-sub-rows .psp-item-product-row,\n.psp-item-sub-rows .psp-table-row,\n.psp-inner-table .psp-table-row {\n  position: relative;\n}\n\n.psp-item-sub-rows .psp-item-product-row::before,\n.psp-item-sub-rows .psp-table-row::before,\n.psp-inner-table .psp-table-row::before {\n  content: '';\n  position: absolute;\n  left: -12px;\n  top: 50%;\n  width: 12px;\n  height: 1px;\n  background: #babfc4;\n}\n\n/* lock UI */\n.psp-lock-desc-2 {\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n.psp-lock-img {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.psp-lock-img img {\n  max-width: 180px;\n}\n\n.psp-lock-card {\n  text-align: center;\n  padding: 12px;\n}\n\n.psp-lock-card h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #202223;\n  margin-bottom: 8px;\n}\n\n.psp-lock-card__subtitle {\n  font-size: 14px;\n  color: #6d7175;\n  margin-bottom: 24px;\n}\n\n.psp-lock-card__cta {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n}\n\n.psp-lock-card__cta .Polaris-Link {\n  display: inline-flex;\n  align-items: center;\n}\n\n.psp-lock-btn {\n  background: linear-gradient(91.21deg, #c830e1 1.04%, #fe4a25 131.05%);\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 10px 20px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  box-shadow: 0px 5.45px 19.3px 0px #eb452666;\n}\n\n/* group card */\n.psp-group-card {\n  margin-bottom: 20px;\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n}\n\n.psp-group-header {\n  display: flex;\n  align-items: center;\n  padding: 10px 12px;\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.psp-drag-handle {\n  margin-right: 8px;\n  cursor: grab;\n  line-height: 0;\n}\n\n.psp-group-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  min-width: 20px;\n  border-radius: 4px;\n  background: #ffffff;\n  color: #6d7175;\n  font-size: 11px;\n  font-weight: 600;\n  margin-right: 8px;\n  border: 1px solid #c9cccf;\n}\n\n.psp-group-label {\n  flex: 1;\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 500;\n  text-transform: uppercase;\n  color: #6d7175;\n}\n\n.psp-group-body {\n  padding: 16px 12px;\n  background: #f6f6f7;\n  border-radius: 0 0 8px 8px;\n}\n\n.psp-slot-type-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.psp-slot-type-select {\n  flex: 1;\n}\n\n.psp-slot-type-select .Polaris-Select__Input {\n  cursor: pointer;\n}\n\n.psp-add-group {\n  margin-top: 12px;\n}\n\n.BC-Select_Option-Product.BC-Select_Merchandising-Attribute .BC-Select__option .product-detail {\n  display: grid;\n  vertical-align: middle;\n}\n\n.BC-Select_Option-Product.BC-Select_Merchandising-Attribute .BC-Select__option .product-image {\n  margin-top: 4px;\n}\n\n.BC-Select_Option-Product.BC-Select_Merchandising-Attribute\n  .BC-Select__option:not(.BC-Select__option--is-selected)\n  .product-detail\n  p {\n  /* color: var(--p-text-subdued); - Do not understand outside body */\n  color: #6d7175;\n}\n\n/* Welcome new feature modal */\n.welcome-new-feature {\n  text-align: center;\n  padding: 0 20px;\n}\n\n.welcome-new-feature .welcome-content {\n  transition: 750ms ease-in;\n}\n\n.welcome-new-feature h1 {\n  font-weight: 600 !important;\n  font-size: 28px !important;\n  line-height: 32px !important;\n}\n\n.welcome-new-feature h2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  width: 70%;\n  margin: 10px auto;\n}\n\n.welcome-new-feature img {\n  width: 100%;\n  height: auto;\n  margin: 10px 0;\n}\n\n.welcome-new-feature .action-sliders .dot-slider {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: #c9ccd0;\n  cursor: pointer;\n}\n\n.welcome-new-feature .action-sliders .active {\n  width: 10px !important;\n  height: 10px !important;\n  border-radius: 50%;\n  background-color: #007f5f;\n}\n\n.welcome-new-feature .action-sliders {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  align-items: center;\n  margin: 6px 0;\n}\n\n.welcome-new-feature .action {\n  margin: 18px 0 29px 0;\n}\n\n.welcome-new-feature .action button {\n  animation: wiggle 4s 2s infinite;\n}\n\n.welcome-new-feature .closeBtn {\n  text-align: right;\n}\n\n.welcome-new-feature .closeBtn button {\n  border: none;\n  background-color: #fff;\n  cursor: pointer;\n  padding-right: 0px;\n  margin-top: 1.25rem;\n}\n\n.Polaris-Modal__BodyWrapper .Polaris-Heading {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.BC-Page__MerchandisingV2-Rule\n  .Polaris-Scrollable\n  .Polaris-Layout\n  .Polaris-Layout__Section\n  .Polaris-Card__Section\n  .Polaris-Label\n  .Polaris-Label__Text,\n.BC-Page__MerchandisingV2-Rule\n  .Polaris-Scrollable\n  .Polaris-Layout\n  .Polaris-Layout__Section\n  .Polaris-Card__Section\n  .Polaris-Connected\n  .Polaris-TextField\n  .Polaris-TextField__Input,\n.BC-Page__Merchandising-Rule-DateRange,\n.Polaris-Modal__BodyWrapper .condition-scope-layout p,\n.Polaris-Modal__BodyWrapper .condition-scope-layout .Polaris-FormLayout,\n.Polaris-Modal__BodyWrapper .condition-scope-layout .Polaris-FormLayout .Polaris-Choice__Label,\n.Polaris-Modal__BodyWrapper .condition-scope-layout .Polaris-FormLayout .Polaris-Label__Text,\n.Polaris-Modal__BodyWrapper .condition-scope-layout .Polaris-FormLayout .BC-Select__value-container,\n.Polaris-Modal__BodyWrapper .Condition-Modal-Pick-apply-rule .Polaris-Choice__Label,\n.BC-Page__MerchandisingV2-Rule .consequence-detail-content p {\n  font-weight: 400 !important;\n  font-size: 14px !important;\n  line-height: 20px !important;\n}\n\n.BC-Select__value-container--has-value div {\n  color: #202223 !important;\n}\n\n.ai-based-primary-algorithm\n  .BC-Select__control--is-disabled\n  .BC-Select__value-container--has-value\n  div {\n  color: rgb(153, 153, 153) !important;\n}\n\n.BC-Select__control--is-focused:visited {\n  border-bottom: 1px solid rgba(69, 143, 255, 1) !important;\n}\n\n.BC-Select__control--is-focused:focus-visible {\n  border-bottom: 1px solid rgba(69, 143, 255, 1) !important;\n}\n\n.default-text-style {\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  line-height: 20px !important;\n}\n\n.intro-new-version-modal {\n  padding: 20px;\n}\n\n.focus-outline-hidden {\n  --p-focused: unset !important;\n}\n\n.intro-new-version-modal h2 {\n  font-size: 20px;\n  margin-bottom: 8px;\n  line-height: 32px;\n}\n\n.intro-new-version-modal .Polaris-TextContainer > *:not(:first-child) {\n  margin-top: 0;\n}\n\n.Condition-Modal-Pick-apply-rule .Polaris-Choice {\n  margin-right: 1.1875rem;\n}\n\n.MerchandiseV2-Condition-Modal-Search-Box {\n  padding-top: 0.625rem;\n  display: flex;\n  justify-content: space-between;\n}\n\n.MerchandiseV2-Condition-Modal-Search-Box p {\n  margin-bottom: 4px;\n}\n\n.MerchandiseV2-Condition-Modal-Search-Box .Search-box_Section {\n  width: 37%;\n}\n\n.MerchandiseV2-Condition-Modal-Search-Box .Search-box_Section_two {\n  width: 61%;\n}\n\n.MerchandiseV2-Rule-Condition-List {\n  display: flex;\n  justify-content: space-between;\n  width: 110%;\n  margin: 0.0625rem -0.625rem -0.625rem -0.625rem;\n  background: none;\n  padding: 0rem 0.625rem 0.625rem 0.625rem;\n}\n\n.MerchandiseV2-Rule-Condition-List .Condition-List_Section_two,\n.Condition-Detail-Title .Condition-Title_Section_two {\n  display: none;\n}\n\n.MerchandiseV2-Rule-Condition-List:hover,\n.BC-Page__MerchandisingV2-Rule .condition-hover-all-content:hover {\n  background: #f6f6f7;\n}\n\n.MerchandiseV2-Rule-Condition-List:hover .Condition-List_Section_two,\n.BC-Page__MerchandisingV2-Rule\n  .condition-hover-all-content:hover\n  .Condition-Detail-Title\n  .Condition-Title_Section_two {\n  display: flex;\n}\n\n.MerchandiseV2-Rule-Condition-List .Condition-List_Section {\n  width: 85%;\n}\n\n.MerchandiseV2-Rule-Condition-List .Condition-List_Section_two {\n  width: 15%;\n}\n\n.Condition-Heading-Title {\n  width: 100%;\n}\n\n.Condition-Detail-Title {\n  display: flex;\n  width: 100%;\n  align-items: center;\n}\n\n.Condition-Detail-Title .Condition-Title_Section {\n  width: 85%;\n}\n\n.Condition-Detail-Title .Condition-Title_Section_two {\n  width: 15%;\n}\n\n.Condition-Detail-Title .Condition-Title_Section_two .Polaris-Icon {\n  margin-right: 0.1875rem;\n}\n\n.MerchandiseV2-Rule-Condition-List .Condition-List_Section_two .Polaris-Icon,\n.MerchandiseV2-Rule-Condition-List .Condition-Collection_Section_two .Polaris-Icon {\n  margin-right: 0.3125rem;\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n.MerchandiseV2-Condition-Modal-Search-Box .Search-box_Section_second {\n  display: flex;\n  width: 61%;\n}\n\n.mt-3 {\n  margin-top: 0.625rem;\n}\n\n.mt-5 {\n  margin-top: 0.9375rem;\n}\n\n.pb-3 {\n  padding-bottom: 0.625rem;\n}\n\n.Condition-Modal-Icon-delete {\n  margin-top: 1.875rem;\n  margin-left: 0.625rem;\n}\n\n.Condition-Modal-Icon-delete:hover,\n.apply-same-rule-queries p:hover,\n.add-field-attribute p:hover,\n.Condition-Detail-Title .Condition-Title_Section_two .Polaris-Icon:hover,\n.MerchandiseV2-Rule-Condition-List .Condition-List_Section_two .Polaris-Icon:hover,\n.MerchandiseV2-Rule-Condition-List .Condition-Collection_Section_two .Polaris-Icon:hover {\n  cursor: pointer;\n}\n\n.Collection-Add-Query-Filter {\n  display: flex;\n}\n\n.Collection-Add-Query-Filter .Collection-Add-Query-Filter-Action span,\n.BC-Page__MerchandisingV2-Rule .consequence-add-button {\n  margin: 0.125rem 0 auto 0;\n}\n\n.Collection-Add-Query-Filter .Collection-Add-Query-Filter-Action .Polaris-Icon,\n.Collection-Add-Query-Filter .tooltip .Polaris-Icon {\n  height: 1.25rem;\n}\n\n.Collection-Add-Query-Filter .tooltip .Polaris-Icon,\n.consequences-detail .tooltip .Polaris-Icon {\n  margin-top: 2px;\n  margin-left: 4px;\n}\n\n.Collection-Add-Query-Filter .Collection-Add-Query-Filter-Action .Polaris-Icon--colorBase svg {\n  size: 0.875rem;\n}\n\n/* Recommendation */\n/* Recommendation Widget */\n.BC-Page__RecommendationWidgetManagement .RecommendationWidgetHighlightInfo.pfs-app-banner {\n  padding: 0.75rem;\n}\n\n.BC-Page__RecommendationWidgetManagement .RecommendationWidgetHighlightInfo .pfs-banner-content {\n  padding: 0;\n}\n\n.BC-Page__RecommendationWidgetManagement\n  .RecommendationWidgetHighlightInfo\n  .pfs-banner-content\n  > p {\n  display: flex;\n  justify-content: center;\n}\n\n.BC-Page__RecommendationWidgetManagement .Polaris-Page {\n  max-width: 936px;\n  padding: 0;\n}\n\n.BC-Page__RecommendationWidgetManagement .Polaris-PageActions {\n  border-top: none;\n}\n\n.BC-Page__RecommendationWidgetManagement .BC-Container__Notifications a .Polaris-Icon {\n  display: inline-block;\n}\n\n.BC-Page__RecommendationWidgetManagement\n  .BC-Container__Notifications\n  a\n  .Polaris-Icon\n  .Polaris-Icon__Svg {\n  margin-top: 5px;\n}\n\n.BC-Page__RecommendationWidgetManagement\n  .BC-Container__Notifications\n  .Polaris-Banner\n  .Polaris-Link--monochrome {\n  color: var(--p-interactive);\n}\n\n.BC-Page__RecommendationWidgetManagement .BC-Filters {\n  position: relative;\n}\n\n.BC-Page__RecommendationWidgetManagement .BC-Filters .BC-Filters-ConnectedFilterControl {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-right: 0.75rem;\n  border-bottom: var(--p-border-divider);\n}\n\n.BC-Page__RecommendationWidgetManagement .BC-Filters .Polaris-Tabs__Wrapper {\n  border-bottom: none;\n}\n\n.BC-Page__RecommendationWidgetManagement\n  .BC-Filters\n  .BC-Filters-ConnectedFilterControl__LeftContainer {\n  flex: 1 1 auto;\n}\n\n.BC-Page__RecommendationWidgetManagement\n  .BC-Filters\n  .BC-Filters-ConnectedFilterControl__RightContainer {\n  flex: 2 1 auto;\n  display: flex;\n  align-items: center;\n}\n\n.BC-Page__RecommendationWidgetManagement\n  .BC-Filters\n  .BC-Filters-ConnectedFilterControl__RightContainer\n  > div {\n  margin-right: 0.5rem;\n}\n\n.BC-Page__RecommendationWidgetManagement\n  .BC-Filters\n  .BC-Filters-ConnectedFilterControl__RightContainer\n  .action {\n  padding: 0 0.5rem;\n}\n\n.BC-Page__RecommendationWidgetManagement\n  .BC-Filters\n  .BC-Filters-ConnectedFilterControl__RightContainer\n  .action\n  button {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.BC-Page__RecommendationWidgetManagement\n  .BC-Filters\n  .BC-Filters-ConnectedFilterControl__RightContainer\n  .search {\n  flex: 2 1 auto;\n}\n\n.BC-Page__RecommendationWidgetManagement\n  .BC-Filters\n  .BC-Filters-ConnectedFilterControl__RightContainer\n  .filter {\n  border-right: var(--p-border-divider);\n}\n\n.BC-Page__RecommendationWidgetManagement .BC-Filters .BC-Filters__TagsContainer,\n.BC-Page__RecommendationWidgetManagement .BC-Filters .BC-Filters__Warning {\n  padding: 1rem 1rem 0;\n}\n\n.BC-Management-Widget table {\n  table-layout: fixed;\n}\n\n.BC-Management-Widget .Polaris-Card__Section:first-child {\n  padding: 16px;\n}\n\n.BC-Popover__Recommendation-Filters-Options {\n  width: 276px;\n}\n\n.BC-Management-Widget .BC-Filters__Warning .Polaris-InlineError .Polaris-InlineError__Icon {\n  display: block;\n}\n\n.recommendation-actions-dashboard {\n  width: 100%;\n  margin-left: auto;\n}\n\n.BC-Page__RecommendationWidgetManagement\n  .Polaris-Page\n  .Polaris-PageActions\n  .Polaris-Stack\n  .Polaris-Stack__Item {\n  margin-top: 24px;\n}\n\n.BC-Management-Widget .no-widget-recommendation {\n  background-color: #fafbfb;\n  height: 112px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  color: #6d7175;\n}\n\n.recommendation-widget-table {\n  margin-bottom: 1rem;\n}\n\n.recommendation-widget-table .page-type {\n  display: flex;\n  padding: 1rem 0;\n  cursor: pointer;\n}\n\n.recommendation-widget-table.not-active .page-type-collapse-icon .Polaris-Icon {\n  transform: rotate(90deg);\n}\n\n.recommendation-widget-table .page-type-title {\n  font-weight: 600;\n  display: flex;\n}\n\n.recommendation-widget-table .page-type-title .Polaris-Icon {\n  margin: 0 0.5rem 0 0.25rem;\n}\n\n.recommendation-widget-table .Polaris-DataTable__Cell--actions div {\n  display: flex;\n  justify-content: space-around;\n}\n\n.recommendation-widget-table thead {\n  background: var(--surface-subdued, #fafbfb);\n}\n\n.recommendation-widget-table thead tr td {\n  border-top: 1px solid var(--border-divider, #e1e3e5);\n  border-bottom: 1px solid var(--border-divider, #e1e3e5);\n}\n\n.recommendation-widget-table thead tr td:first-child {\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  border-left: 1px solid var(--border-divider, #e1e3e5);\n}\n\n.recommendation-widget-table thead tr td:last-child {\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border-right: 1px solid var(--border-divider, #e1e3e5);\n}\n\n.recommendation-widget-table table tr td.Polaris-DataTable__Cell--actions {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.recommendation-widget-table .btn-launch button {\n  margin-left: 0.75rem;\n  color: var(--p-action-primary);\n  border-color: var(--p-action-primary);\n}\n\n.recommendation-widget-table .btn-launch button:hover {\n  border-color: var(--p-action-primary);\n}\n\n.recommendation-widget-table .group_btn button svg {\n  fill: var(--p-icon);\n}\n\n.recommendation-widget-table .recommendation-collapse .Polaris-DataTable__Cell--name .Polaris-Link {\n  word-break: break-word;\n}\n\n.BC-Management-Widget .Polaris-DataTable__Table .Polaris-DataTable__Cell--type .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  margin-right: 5px;\n  height: 1.2rem;\n  width: 1rem;\n}\n\n.Polaris-DataTable__Cell--name button,\n.Polaris-DataTable__Cell--displayOn p,\n.Polaris-DataTable__Cell--type p {\n  white-space: break-spaces;\n  word-wrap: break-word;\n}\n\n.Polaris-DataTable__Cell--displayOn p {\n  text-align: center;\n}\n\n.recommendation-translation {\n  display: flex;\n}\n\n.list-widgets {\n  position: relative;\n}\n\n.list-widgets .overlay-actions {\n  position: absolute;\n  width: 16%;\n  right: 12px;\n  height: 47%;\n  border-radius: 8px;\n}\n\n.list-widgets .widget-by-type {\n  width: 97.5%;\n  height: 47%;\n  left: 12px;\n  top: 12px;\n  border-radius: 8px;\n  position: absolute;\n}\n\n.recommendationAddonLockBanner .image img,\n.recommendationAddonLockBanner .image {\n  max-height: 112px;\n  max-width: 240px;\n  width: 100%;\n}\n\n.recommendationAddonLockBanner .pfs-banner-detail {\n  gap: unset;\n  justify-content: space-between;\n}\n\n/* recommendation-widget-tour */\n.widgets-tour {\n  border-radius: 8px;\n  box-shadow:\n    0px 26px 80px 0px rgba(0, 0, 0, 0.2),\n    0px 0px 1px 0px rgba(0, 0, 0, 0.2);\n}\n\n.widgets-tour .actions-tour {\n  margin-top: 8px;\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n@media only screen and (max-height: 800px) and (max-width: 1440px) {\n  .product-tour-step0 {\n    top: -13% !important;\n    left: -30% !important;\n  }\n}\n\n@media only screen and (max-height: 785px) {\n  .product-tour-step0 {\n    top: -17% !important;\n  }\n}\n\n@media only screen and (max-height: 630px) {\n  .product-tour-step0 {\n    top: -14% !important;\n  }\n}\n\n@media only screen and (max-width: 1014px) {\n  .product-tour-step0 {\n    left: -25% !important;\n  }\n}\n\n@media only screen and (max-width: 820px) {\n  .product-tour-step0 {\n    left: -17%;\n  }\n}\n\n.widgets-tour .actions-tour .count {\n  color: #6d7175;\n}\n\n.widgets-tour .actions-tour .actions {\n  display: flex;\n  gap: 14px;\n}\n\n.widgets-tour .heading-tour {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* end tour */\n\n.recommendation-translation .not-active .page-type-collapse-icon .Polaris-Icon {\n  transform: rotate(90deg);\n}\n\n.recommendation-translation .recommendation-translation-collapse {\n  display: flex;\n  cursor: pointer;\n  height: 30px;\n  font-weight: 550;\n}\n\n.BC-Page__RecommendationWidgetItem .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {\n  justify-content: flex-end;\n}\n\n.BC-Page__RecommendationWidgetItem .general-items .recommendation-type--select {\n  display: flex;\n}\n\n.BC-Page__RecommendationWidgetItem .general-items .recommendation-type--select .Polaris-Choice {\n  padding-top: 2px;\n}\n\n.BC-Page__RecommendationWidgetItem .general-items .Polaris-Heading {\n  margin-top: 1.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.BC-Page__RecommendationWidgetItem .general-items .button-large .Polaris-Button {\n  padding: 12px 16px 14px;\n}\n\n.BC-Page__RecommendationWidgetItem .not-plus-on-checkout-page img {\n  width: 160px;\n  max-width: 160px;\n  height: auto;\n}\n\n.BC-Page__RecommendationWidgetItem .not-plus-on-checkout-page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 70px 32px;\n}\n\n.BC-Page__RecommendationWidgetItem .not-plus-on-checkout-page .content {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  justify-content: center;\n  align-items: center;\n}\n\n.BC-Page__RecommendationWidgetItem .not-plus-on-checkout-page .content > p:first-child {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  color: #202223;\n}\n\n.BC-Page__RecommendationWidgetItem .not-plus-on-checkout-page .content > p:last-child {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #6d7175;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .general-items\n  .button-large\n  .Polaris-Button__Text\n  .btn-title-content {\n  font-size: var(--p-font-size-5);\n  line-height: 1.5rem;\n  font-weight: 600;\n}\n\n.BC-Page__RecommendationWidgetItem .general-items .btn-title-type {\n  display: flex;\n  align-items: center;\n  gap: 5px !important;\n}\n\n.BC-Page__RecommendationWidgetItem .general-items .btn-title-type .btn-title-content {\n  font-size: 20px !important;\n  line-height: 28px !important;\n}\n\n.BC-Page__RecommendationWidgetItem .general-items .button-large .Polaris-Button:hover,\n.BC-Page__RecommendationWidgetItem .general-items .button-large.isSelected .Polaris-Button {\n  border: 1px solid var(--interactive-hovered, #1f5199);\n  background: var(--surface-selected-pressed, #e5effd);\n}\n\n.BC-Page__RecommendationWidgetItem .general-items .button-large .Polaris-Button__Text .btn-content {\n  font-weight: var(--p-font-weight-regular);\n  line-height: 1.25rem;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .general-items\n  .button-large\n  .Polaris-Button__Text\n  .btn-content\n  .Polaris-TextStyle--variationSubdued {\n  color: #202223;\n}\n\n.widget-page-type .button-large .Polaris-Button {\n  padding: 12px 4px 14px !important;\n}\n\n.BC-Page__RecommendationNewWidgetItem .page-items .widget-page-type {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.BC-Page__RecommendationNewWidgetItem .page-items .widget-page-type > div {\n  width: calc(20% - 12px);\n}\n\n.BC-Page__RecommendationNewWidgetItem .page-items .Polaris-Button {\n  border: 1px solid transparent;\n  box-shadow: none;\n  background: #fafbfb;\n}\n\n.BC-Page__RecommendationNewWidgetItem .page-items .btn-title .btn-title-icon .Polaris-Icon {\n  width: 2.75rem;\n  height: 2.75rem;\n  padding: 0.75rem;\n  border-radius: 44px;\n  margin-bottom: 0.75rem;\n  background: var(--surface-selected-pressed, #e5effd);\n}\n\n.BC-Page__RecommendationNewWidgetItem\n  .page-items\n  .Polaris-Button:hover\n  .btn-title\n  .btn-title-icon\n  .Polaris-Icon,\n.BC-Page__RecommendationNewWidgetItem\n  .page-items\n  .isSelected\n  .Polaris-Button\n  .btn-title\n  .btn-title-icon\n  .Polaris-Icon {\n  background: var(--icon-interactive, #2c6ecb);\n}\n\n.BC-Page__RecommendationNewWidgetItem .page-items .btn-title .btn-title-icon .Polaris-Icon svg {\n  fill: var(--icon-interactive, #2c6ecb);\n}\n\n.BC-Page__RecommendationNewWidgetItem\n  .page-items\n  .Polaris-Button:hover\n  .btn-title\n  .btn-title-icon\n  .Polaris-Icon\n  svg,\n.BC-Page__RecommendationNewWidgetItem\n  .page-items\n  .isSelected\n  .Polaris-Button\n  .btn-title\n  .btn-title-icon\n  .Polaris-Icon\n  svg {\n  fill: var(--p-background, #f6f6f7);\n}\n\n.BC-Page__RecommendationWidgetItem .type-items .Polaris-Grid-Cell > div {\n  height: 100%;\n}\n\n.BC-Page__RecommendationWidgetItem .type-items .Polaris-Button {\n  height: 100%;\n  align-items: flex-start;\n  border: 1px solid transparent;\n  background: #fafbfb;\n  box-shadow: none;\n}\n\n.BC-Page__RecommendationWidgetItem .type-items .Polaris-Button:hover,\n.BC-Page__RecommendationWidgetItem .type-items .isSelected .Polaris-Button {\n  border: 1px solid var(--border-subdued, #c9cccf);\n}\n\n.BC-Page__RecommendationNewWidgetItem .type-items .Polaris-Button__Text {\n  text-align: left;\n}\n\n.BC-Page__RecommendationNewWidgetItem .type-items .Polaris-Button__Text .btn-title,\n.BC-Page__RecommendationWidgetItem .widget-based-section .Polaris-Button__Text .btn-title {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 0.25rem;\n}\n\n.BC-Page__RecommendationNewWidgetItem\n  .type-items\n  .Polaris-Button.Polaris-Button--disabled\n  .btn-content\n  .Polaris-TextStyle--variationSubdued {\n  color: #6d7175;\n}\n\n.BC-Page__RecommendationNewWidgetItem .type-items .decorative .Polaris-Badge {\n  background: var(--surface-warning-subdued-pressed, #ffebd3);\n}\n\n.BC-Page__RecommendationNewWidgetItem .type-items .decorative .Polaris-Icon {\n  width: unset;\n}\n\n.BC-Page__RecommendationNewWidgetItem .type-items .decorative .Polaris-Badge .badge-with-icon {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.BC-Page__RecommendationNewWidgetItem\n  .type-items\n  .decorative\n  .Polaris-Badge\n  .badge-with-icon\n  .Polaris-Icon,\n.BC-Page__RecommendationWidgetItem\n  .widget-based-section\n  .Polaris-Button__Text\n  .btn-title-icon\n  .Polaris-Icon {\n  width: 1rem;\n  height: 1rem;\n  margin-right: 0.25rem;\n}\n\n.BC-Page__RecommendationNewWidgetItem .type-items .decorative,\n.BC-Page__RecommendationNewWidgetItem .type-items .btn-title-icon {\n  margin-left: 6px;\n}\n\n.BC-Page__RecommendationNewWidgetItem .type-items .disabled .Polaris-Button__Text .btn-title,\n.BC-Page__RecommendationNewWidgetItem\n  .type-items\n  .disabled\n  .Polaris-Button__Text\n  .btn-content\n  .Polaris-TextStyle--variationSubdued {\n  color: #8c9196;\n}\n\n.BC-Page__RecommendationNewWidgetItem .type-items .disabled .decorative .Polaris-Badge {\n  background: #fdf3e7;\n}\n\n.BC-Page__RecommendationNewWidgetItem .type-items .disabled .decorative .badge-with-icon {\n  color: #8d8e8f;\n}\n\n.BC-Page__RecommendationNewWidgetItem .type-items .disabled .decorative svg rect {\n  fill: rgb(205, 113, 92);\n}\n\n.BC-Page__RecommendationNewWidgetItem .type-items .disabled .decorative svg path {\n  fill: #c6117c8a;\n}\n\n.BC-Page__RecommendationNewWidgetItem .type-items .disabled .decorative .Polaris-Icon {\n  width: unset;\n}\n\n.BC-Page__RecommendationNewWidgetItem .type-items .disabled .btn-title-icon svg rect {\n  fill: #cff1f7;\n}\n\n.BC-Page__RecommendationNewWidgetItem .type-items .disabled .btn-title-icon svg path {\n  fill: #7dcdd3;\n}\n\n.BC-Page__RecommendationNewWidgetItem .btn-inline--recommendation-lock {\n  margin-top: 5px;\n  margin-left: 28px;\n  color: #2c6ecb;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  line-height: 20px;\n}\n\n.BC-Page__RecommendationNewWidgetItem .btn-inline--recommendation-lock .img-crown {\n  padding: 2px 4px 2px 4px;\n  border-radius: 4px 0px 0px 0px;\n  background: rgba(255, 242, 217, 1);\n  max-width: 22px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n}\n\n.BC-Page__RecommendationNewWidgetItem .btn-inline--recommendation-lock .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  align-items: center;\n  margin: unset;\n}\n\n.BC-Page__RecommendationNewWidgetItem .btn-inline--recommendation-lock .Polaris-Icon svg {\n  fill: var(--p-interactive);\n}\n\n.BC-Page__RecommendationNewWidgetItem .type-items .Polaris-Button__Text .btn-title .Polaris-Badge {\n  margin-left: 4px;\n}\n\n.BC-Page__RecommendationNewWidgetItem\n  .type-items\n  .Polaris-Button__Text\n  .btn-title\n  .Polaris-Badge--statusInfo {\n  background: #e0f0ff;\n  color: #00527c;\n  flex-shrink: 0;\n}\n\n.BC-Page__RecommendationWidgetItem .Polaris-Card__Section a .Polaris-Icon,\n.BC-Page__RecommendationWidgetItem button.Polaris-Link .Polaris-Icon {\n  display: inline-block;\n}\n\n.BC-Page__RecommendationWidgetItem .Polaris-Card__Section a .Polaris-Icon .Polaris-Icon__Svg,\n.BC-Page__RecommendationWidgetItem button.Polaris-Link .Polaris-Icon .Polaris-Icon__Svg {\n  margin-top: 4px;\n}\n\n.BC-Page__RecommendationWidgetItem .setup-content .setup-content-title {\n  position: relative;\n  padding-bottom: 1.25rem;\n}\n\n.BC-Page__RecommendationWidgetItem .setup-content .setup-content-title .help-doc {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.BC-Page__RecommendationWidgetItem .setup-content .setup-content-title .help-doc-content {\n  display: inline-flex;\n}\n\n.BC-Page__RecommendationWidgetItem .setup-content .setup-content-title .sub-title {\n  margin-top: 0.75rem;\n}\n\n.BC-Page__RecommendationWidgetItem .setup-content .setup-content-title .sub-title > * {\n  margin-right: 0.5rem;\n}\n\n.BC-Page__RecommendationWidgetItem .setup-content .setup-cart-drawer-step {\n  list-style-type: disc;\n  padding-left: 1.25rem;\n  margin-top: 4px;\n}\n\n.BC-Page__RecommendationWidgetItem .setup-content .setup-cart-drawer-step svg {\n  fill: #5c5f62;\n  width: 15px;\n  height: 16px;\n}\n\n.BC-Page__RecommendationWidgetItem .widget-based-section .button-large .Polaris-Button {\n  align-items: baseline;\n  min-height: 110px;\n  background: var(--surface-default, #fff);\n}\n\n.BC-Page__RecommendationWidgetItem .widget-based-section .button-large .Polaris-Button:hover,\n.BC-Page__RecommendationWidgetItem .widget-based-section .isSelected .Polaris-Button {\n  border: 1px solid var(--icon-interactive, #2c6ecb);\n  background: var(--surface-selected-pressed, #e5effd);\n}\n\n.BC-Page__RecommendationWidgetItem\n  .widget-based-section\n  .button-large\n  .Polaris-Button__Text\n  .btn-title {\n  justify-content: center;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .widget-based-section\n  .button-large\n  .Polaris-Button__Text\n  .btn-content {\n  padding: 0 2.5rem;\n}\n\n.BC-Page__RecommendationWidgetItem .widget-details-block {\n  border-radius: 8px;\n  border: 1px solid var(--border-divider, #e1e3e5);\n  padding: 1.25rem;\n}\n\n.BC-Page__RecommendationWidgetItem .widget-details-block .field-title {\n  font-size: var(--p-font-size-5);\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.BC-Page__RecommendationWidgetItem .widget-details-block .field-helper {\n  font-size: var(--p-font-size-3);\n  line-height: 20px;\n  margin-bottom: 0.5rem;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .widget-based-section\n  .widget-details-block\n  .ai-base-algorithm\n  > *:not(:first-child) {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__RecommendationWidgetItem .setup-content .extra-fields .BC-Draggable__Container {\n  margin-top: 1rem;\n  margin-left: 1rem;\n}\n\n.BC-Page__RecommendationWidgetItem .setup-content .extra-fields .BC-Draggable__Container > div {\n  background-color: #ffffff;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .setup-content\n  .extra-fields\n  .Polaris-ChoiceList__Choices\n  li:not(:first-child) {\n  margin-top: 8px;\n  /* make the margin between choice smaller - Design */\n}\n\n.BC-Page__RecommendationWidgetItem\n  .setup-content\n  .extra-fields\n  .Polaris-ChoiceList__Choices\n  li:not(:first-child) {\n  margin-top: 0.75rem;\n  /* make the margin between choice smaller - Design */\n}\n\n.BC-Page__RecommendationWidgetItem .extra-fields .rule-based-item {\n  display: flex;\n  margin-bottom: 1rem;\n}\n\n.BC-Page__RecommendationWidgetItem .extra-fields .rule-based-item .rule-based-item_draggable {\n  margin-right: 1rem;\n}\n\n.BC-Page__RecommendationWidgetItem .extra-fields .rule-based-item .rule-based-item_details {\n  flex: 1 1 auto;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .extra-fields\n  .rule-based-item\n  .rule-based-item_details\n  .rule-based-item_groupFields {\n  margin-top: 0.75rem;\n  margin-left: 3.265rem;\n  margin-right: 0.25rem;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .extra-fields\n  .rule-based-item\n  .rule-based-item_details\n  .rule-based-item_field {\n  margin-top: 0.75rem;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .extra-fields\n  .rule-based-item\n  .rule-based-item_details\n  .rule-based-item_subField {\n  margin-top: 0.75rem;\n  margin-left: 1rem;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .extra-fields\n  .rule-based-item\n  .rule-based-item_details\n  .rule-based-item_filterRow {\n  display: flex;\n  gap: 1rem;\n  align-items: flex-start;\n  margin-top: 0.75rem;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .extra-fields\n  .rule-based-item\n  .rule-based-item_details\n  .rule-based-item_filterRow\n  > *:first-child {\n  flex: 0 0 240px;\n  min-width: 0;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .extra-fields\n  .rule-based-item\n  .rule-based-item_details\n  .rule-based-item_filterRow\n  > *:last-child {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .extra-fields\n  .rule-based-item\n  .rule-based-item_details\n  .rule-based-item_filterRow\n  .Polaris-Popover__Anchor {\n  display: block;\n  width: 100%;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .setup-content\n  .extra-fields\n  .rule-based-item_filterRow\n  .BC-Draggable__Container {\n  margin-top: 2px;\n  margin-left: 0;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .setup-content\n  .extra-fields\n  .rule-based-item_filterRow\n  .Polaris-Tag.BC-Draggable__Tag {\n  margin-right: 8px;\n}\n\n.BC-Page__RecommendationWidgetItem .extra-fields .rule-based-item .note {\n  margin-top: 0.25rem;\n}\n\n.BC-Page__RecommendationWidgetItem .extra-fields .ai-based-primary-algorithm-helper-text {\n  margin-top: 5px;\n}\n\n.BC-Page__RecommendationWidgetItem .setup-content .tab-content {\n  padding-top: 1.25rem;\n}\n\n.BC-Page__RecommendationWidgetItem .setup-content .tab-content .tab-content-title {\n  padding-bottom: 1.25rem;\n}\n\n.BC-Page__RecommendationWidgetItem .setup-content .tab-content .tab-content-content > div {\n  margin-bottom: 1rem;\n}\n\n.BC-Page__RecommendationWidgetItem .setup-content .tab-content .tab-content-content .action {\n  margin-top: 1rem;\n  margin-bottom: 0.75rem;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .setup-content\n  .tab-content\n  .tab-content-content\n  .action\n  .non-action {\n  display: inline-flex;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .setup-content\n  .tab-content\n  .tab-content-content\n  .action\n  .non-action\n  .Polaris-Icon {\n  margin-right: 0.5rem;\n}\n\n.BC-Page__RecommendationWidgetItem .widget-rule-group {\n  border-radius: 8px;\n  border: 1px solid var(--border-divider, #e1e3e5);\n  background: var(--surface-default, #fff);\n  margin-bottom: 0.75rem;\n}\n\n.BC-Page__RecommendationWidgetItem .widget-rule-group .rule-group-title {\n  display: flex;\n  padding: 12px;\n  padding-left: 16px;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.BC-Page__RecommendationWidgetItem .widget-rule-group .rule-group-title.active {\n  border-bottom: 1px dashed #e1e3e5;\n}\n\n.BC-Page__RecommendationWidgetItem .widget-rule-group .rule-group-title .title {\n  color: var(--text-subdued, #6d7175);\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.BC-Page__RecommendationWidgetItem .widget-rule-group .rule-group-title .title .number {\n  border-radius: 4px;\n  border: 1px solid var(--border-subdued, #c9cccf);\n  font-size: 12px;\n  padding: 2px 6px;\n  display: flex;\n  align-items: center;\n  max-height: 20px;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .widget-rule-group\n  .action\n  .Polaris-Button--plain.Polaris-Button--iconOnly\n  svg {\n  fill: var(--p-icon-subdued);\n}\n\n.BC-Page__RecommendationWidgetItem\n  .widget-rule-group\n  .action\n  .Polaris-Button--plain.Polaris-Button--iconOnly:hover\n  svg {\n  fill: var(--p-icon-hovered);\n}\n\n.BC-Page__RecommendationWidgetItem .widget-rule-group .rule-group-block {\n  border-radius: 6px;\n  margin: 1rem;\n  padding: 0.75rem;\n  background: var(--background-default, #f6f6f7);\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .field-title {\n  font-size: var(--p-font-size-3);\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .field-helper {\n  font-size: var(--p-font-size-3);\n  line-height: 20px;\n  margin-bottom: 0.5rem;\n  color: var(--text-subdued, #6d7175);\n}\n\n.BC-Page__RecommendationWidgetItem .widgetItem-rule-attributes {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.BC-Page__RecommendationWidgetItem .widgetItem-rule-attributes > div {\n  padding-left: 4px;\n}\n\n.BC-Page__RecommendationWidgetItem .widgetItem-rule-attributes .add-action p {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  color: #2c6ecb;\n  font-weight: 500;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .field-array-content {\n  display: flex;\n  gap: 12px;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .rule-group-block\n  .field-array-content\n  .Polaris-Popover__PopoverOverlay {\n  width: 659px !important;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .field-array-content .action {\n  margin-top: 9px;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .field-array-content .connect-right {\n  margin-right: 12px;\n  margin-top: 9px;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .field-array-content .main {\n  width: 100%;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .field-array-content .main .header {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .rule-group-block\n  .field-array-content\n  .main\n  .header\n  > :first-child {\n  width: 32%;\n  min-width: 240px;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .rule-group-block\n  .field-array-content\n  .main\n  .header\n  > :nth-child(2) {\n  width: 16%;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .rule-group-block\n  .field-array-content\n  .main\n  .header\n  > :last-child {\n  width: 100%;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .rule-group-block\n  .field-array-content\n  .main\n  .header\n  .Polaris-TextField__Input:focus\n  ~ .Polaris-TextField__Backdrop::after {\n  box-shadow: none;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .rule-group-block\n  .field-array-content\n  .reviews-io-warning-block {\n  background-color: #fff5ea;\n  border: 1px solid #e1b878;\n  padding: 8px 12px;\n  border-radius: 4px;\n  margin-top: 6px;\n}\n\n.BC-Page__RecommendationWidgetItem .field-array-content .reviews-io-warning-block .Polaris-Icon {\n  padding: 2px;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .Polaris-Badge {\n  min-width: 45px;\n  justify-content: center;\n  font-weight: 500;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .Polaris-Badge--statusWarning {\n  background: #ffea8a;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .Polaris-Badge--statusInfo {\n  background: #e0f0ff;\n  color: #00527c;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .Polaris-Badge--statusNew {\n  color: #616161;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .content-list {\n  padding: 0;\n  border-radius: 8px;\n  border: 1px dashed var(--border-divider, #e1e3e5);\n  background: var(--surface-default, #fff);\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .product-list {\n  list-style-type: none;\n  margin: 0.75rem 0 0;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-list {\n  margin: unset;\n  padding: unset;\n  list-style-type: none;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .product-list.consequence-list {\n  margin: 0.5rem 0 0;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .product-list .product-item {\n  padding: 0.5rem 1rem;\n  background: var(--surface-default, #fff);\n  /* Divider/Bottom */\n  box-shadow: 0px -1px 0px 0px #e1e3e5 inset;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .product-list .product-item:last-child {\n  /* Divider/Bottom */\n  box-shadow: none;\n}\n\n.BC-Page__RecommendationWidgetItem\n  .rule-group-block\n  .product-list.condition-list\n  .product-item\n  .Polaris-Stack__Item:nth-child(2),\n.BC-Page__RecommendationWidgetItem\n  .rule-group-block\n  .product-list.consequence-list\n  .product-item\n  .Polaris-Stack__Item:nth-child(3) {\n  padding: 0.5rem 1rem;\n  flex: 1 1;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .collection-list {\n  padding: 0.75rem 0.75rem 0.25rem;\n  margin: 0.75rem 0 0;\n}\n\n.BC-Page__RecommendationWidgetItem .rule-group-block .collection-list .BC-Custom__Tag {\n  margin: 0 0.75rem 0.5rem 0;\n  height: 1.5rem;\n  min-height: 1.5rem;\n  line-height: var(--p-line-height-1);\n}\n\n.BC-Page__SelectProductModal .list-available {\n  padding: 0;\n  list-style-type: none;\n}\n\n.BC-Page__SelectProductModal .list-available .Polaris-SkeletonDisplayText__DisplayText {\n  max-width: 100%;\n}\n\n.BC-Page__SelectProductModal .list-available li {\n  margin-bottom: 0.75rem;\n}\n\n.BC-Page__SelectProductModal .list-available li:last-child {\n  margin-bottom: 0;\n}\n\n.BC-Page__SelectProductModal .list-available .BC-ProductItem .BC-ProductItem__Checkbox {\n  display: flex;\n  position: relative;\n  top: 1px;\n}\n\n.BC-Page__SelectProductModal\n  .list-available\n  .BC-ProductItem\n  .BC-ProductItem__Checkbox\n  .Polaris-Choice__Control {\n  margin-right: 0;\n}\n\n.BC-Page__SelectProductModal .list-available .BC-ProductItem .Polaris-Stack__Item:nth-child(3) {\n  flex: 1;\n}\n\n.ProductModal__Variants-Options li {\n  display: flex;\n  justify-content: space-between;\n}\n\n.ProductModal__Variants-Options .list-available {\n  padding-right: 10px;\n}\n\n.ProductModal__Variants-Options .list-available .variant {\n  padding-left: 28px;\n  margin-bottom: 12px;\n}\n\n.ProductModal__Variants-Options .list-available .variant li {\n  padding: 10px 0;\n}\n\n.ProductModal__Variants-Options .list-available .variant .BC-ProductItem__Checkbox {\n  display: flex;\n  position: relative;\n  top: 1px;\n}\n\n.ProductModal__Variants-Options .list-available .BC-ProductItem__Checkbox .Polaris-Choice__Control {\n  margin-right: 0;\n}\n\n.BC-SelectedProductsField .product-list .product-item {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  padding: 8px;\n}\n\n.BC-SelectedProductsField .product-list .product-item .product-item__Thumbnail {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.BC-Widget-Editor-Page .range-slider-input .Polaris-Connected {\n  width: 100%;\n}\n\n.BC-Widget-Editor-Page .range-slider-input .Polaris-Connected > div:first-child {\n  width: 77%;\n}\n\n.BC-Widget-Editor-Page .range-slider-input .Polaris-Connected > div:last-child {\n  width: 23%;\n}\n\n.BC-Widget-Editor-Page .range-slider-input .Polaris-Connected > div:last-child input {\n  text-align: center;\n  font-weight: 700;\n}\n\n.BC-Widget-Editor-Page .selectedColor {\n  z-index: 417;\n  width: 25px;\n  height: 25px;\n  margin-right: 0;\n  border: 1px solid #c4cdd5;\n  border-radius: 3px;\n  margin-left: 0.75rem;\n}\n\n.BC-Widget-Editor-Page .selectedColor:hover {\n  cursor: pointer;\n}\n\n.widget-visual-editor .visual-editor-body {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.widget-visual-editor .visual-editor-body .visual-editor-settings {\n  isolation: isolate;\n  width: 300px;\n  height: calc(100vh - 61px);\n  background: #ffffff;\n  border-right: 1px solid #e1e3e5;\n  border-left: 1px solid #e1e3e5;\n  overflow-y: auto;\n}\n\n.widget-visual-editor .visual-editor-body .visual-editor-settings .card-section {\n  box-shadow: inset 0px -1px 0px #e1e3e5;\n  padding: 16px 20px;\n  margin: 0;\n}\n\n.widget-visual-editor\n  .visual-editor-body\n  .visual-editor-settings\n  .card-section\n  .widget-layout-settings\n  .Polaris-Banner {\n  padding: 12px;\n}\n\n.widget-visual-editor .visual-editor-body .visual-editor-settings .card-section:last-child {\n  box-shadow: unset;\n}\n\n.widget-visual-editor\n  .visual-editor-body\n  .visual-editor-settings\n  .card-section\n  .title-line\n  .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  margin-right: 0.5rem;\n  border-radius: 4px;\n  border: 1px solid var(--border-subdued, #c9cccf);\n}\n\n.widget-visual-editor .visual-editor-body .visual-editor-settings .card-section .sub-title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.widget-visual-editor .visual-editor-body .visual-editor-settings .card-section .sub-title > * {\n  margin-right: 0.5rem;\n  display: inline;\n}\n\n.widget-visual-editor .visual-editor-body .visual-editor-settings .widget-id {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.widget-visual-editor .visual-editor-body .visual-editor-settings .edit-sections {\n  margin-top: 1rem;\n}\n\n.widget-visual-editor .visual-editor-body .visual-editor-settings .btn-section {\n  margin-bottom: 0.5rem;\n  margin-left: -20px;\n  margin-right: -20px;\n}\n\n.widget-visual-editor .edit-sections .btn-section .Polaris-Button {\n  padding-left: 20px;\n}\n\n.widget-visual-editor .edit-sections .btn-section .Polaris-Button,\n.widget-visual-editor .edit-sections .btn-section .Polaris-Button__Text {\n  text-decoration: none;\n}\n\n.widget-visual-editor .edit-sections .Polaris-Button .Polaris-Icon {\n  color: var(--p-icon, #5c5f62);\n}\n\n.widget-visual-editor .edit-sections .active .Polaris-Button {\n  background: var(--surface-primary-selected, #f1f8f5);\n}\n\n.widget-visual-editor .edit-sections .active .Polaris-Button .Polaris-Icon,\n.widget-visual-editor .edit-sections .active .Polaris-Button .Polaris-Button__Text {\n  color: var(--p-action-primary, #008060);\n}\n\n.widget-visual-editor .visual-editor-body .visual-editor-settings .card-section p {\n  color: #6d7175;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 2px;\n  margin-bottom: 1px;\n}\n\n.external-link {\n  display: -webkit-inline-flex;\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.external-link .Polaris-Button__Content .Polaris-Button__Icon .Polaris-Icon svg {\n  fill: var(--p-interactive) !important;\n  width: 20px;\n  height: auto;\n}\n\n.title-bold-normal {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  padding: 20px 20px !important;\n}\n\n.widget-title-settings .default-settings-widget {\n  padding-top: 12px;\n  color: #6d7175;\n}\n\n.widget-visual-editor .visual-editor-body .visual-editor-preview-wrapper {\n  width: calc(100% - 600px);\n}\n\n.widget-visual-editor .visual-editor-body .cart-drawer-preview-container {\n  height: calc(100% - 105px);\n}\n\n.widget-visual-editor .visual-editor-preview-header {\n  box-shadow: inset 0px -1px 0px #e1e3e5;\n  background: #ffffff;\n  padding: 11px;\n  display: flex;\n  flex-grow: 1;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.widget-visual-editor .visual-editor-preview-header div p {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.widget-visual-editor .visual-editor-preview-header .select-theme-preview {\n  display: inline-block;\n  width: 80%;\n}\n\n.widget-visual-editor .visual-editor-preview-header .theme-preview {\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  width: 35%;\n  align-items: center;\n}\n\n.widget-visual-editor .visual-editor-preview-header .theme-preview .theme-preview-label {\n  padding-right: 20px;\n}\n\n.widget-visual-editor .visual-editor-preview-header .theme-preview .theme-preview-label span {\n  margin-top: 10px;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.widget-visual-editor .visual-editor-preview {\n  margin: 2rem 22px;\n  text-align: left;\n  /* display: flex;\n  justify-content: center;\n  position: sticky;\n  top: 15%; */\n}\n\n.widget-visual-grid .visual-editor-preview {\n  width: 60%;\n  min-width: 444px;\n  margin: 2rem auto;\n}\n\n.widget-visual-grid .visual-editor-preview .recommendation-note {\n  display: flex;\n  justify-content: center;\n  gap: 3px;\n  color: #6d7175;\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-bundle,\n.widget-visual-editor .visual-editor-body .recommendation-carousel,\n.widget-visual-editor .visual-editor-body .recommendation-bundle-body {\n  width: 100%;\n  margin: auto;\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-title,\n.widget-visual-editor .visual-editor-body .recommendation-title-left {\n  margin: 40px 0;\n  display: flex;\n}\n\n.widget-visual-editor .visual-editor-body .checkout-preview .recommendation-title {\n  margin-top: 0;\n  margin-bottom: 16px;\n}\n\n.widget-visual-editor .visual-editor-body .checkout-preview {\n  padding: 38px;\n}\n\n.widget-visual-editor .visual-editor-body .checkout-preview .recommendation-title-left {\n  margin-top: 0;\n  margin-bottom: 16px;\n}\n\n.widget-visual-editor .visual-editor-body .checkout-preview .recommendation-title-text {\n  font-weight: 500;\n  font-size: medium;\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-title-left::before {\n  width: 3%;\n  position: relative;\n  border-top: 1px solid #d2d5d8;\n  transform: translateY(50%);\n  content: '';\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-title-left::after {\n  width: 97%;\n  position: relative;\n  border-top: 1px solid #d2d5d8;\n  transform: translateY(50%);\n  content: '';\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-title::before {\n  width: 50%;\n  position: relative;\n  border-top: 1px solid #d2d5d8;\n  transform: translateY(50%);\n  content: '';\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-title::after {\n  width: 50%;\n  position: relative;\n  border-top: 1px solid #d2d5d8;\n  transform: translateY(50%);\n  content: '';\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-title-text {\n  padding: 0 48px;\n  flex: 0 0 auto;\n  text-align: center;\n  word-break: break-word;\n  line-height: 1.2;\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-title-text-left {\n  padding: 0 48px 0 0;\n  flex: 0 0 auto;\n  text-align: left;\n  word-break: break-word;\n  line-height: 1.2;\n  font-weight: 500;\n}\n\n.widget-visual-editor .visual-editor-body .product-items {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.widget-visual-editor .visual-editor-body .product-items .product-image-wrapper {\n  outline: none;\n  position: relative;\n  display: block;\n  margin: 0 0 0 8px;\n  min-width: calc(100% / 5 - 5px);\n  word-break: break-word;\n  line-height: 1.2;\n  /* display: flex;\n  justify-content: center;\n  flex-direction: column; */\n}\n\n.widget-visual-editor .visual-editor-body .product-items .product-images {\n  display: flex;\n  width: 100%;\n  /* height: 100%; */\n  justify-content: center;\n}\n\n.widget-visual-editor .visual-editor-body .product-items .product-image-wrapper img[alt='plus'] {\n  width: 6%;\n  display: flex;\n}\n\n.widget-visual-editor .visual-editor-body .product-items .product-items-wrapper {\n  max-width: 100%;\n  outline: none;\n  position: relative;\n  display: flex;\n}\n\n.widget-visual-editor .visual-editor-body .product-items .product-image-card {\n  max-width: calc(100% - 100% / 5 - 5px);\n  outline: none;\n  position: relative;\n  display: flex;\n  overflow-x: auto;\n  overflow-y: hidden;\n  white-space: nowrap;\n  padding-bottom: 0.5rem;\n}\n\n.widget-visual-editor .visual-editor-body .product-items .product-image-card .product-image {\n  max-width: calc(100%-10px);\n  min-width: calc(100% - 100% / 5 - 5px);\n  display: flex;\n  margin: 0 8px 0 0;\n  border-radius: 4px;\n  overflow: hidden;\n  align-items: center;\n}\n\n.widget-visual-editor\n  .visual-editor-body\n  .product-items\n  .product-image-card\n  .product-image--has-border {\n  border: 1px solid #222;\n}\n\n.widget-visual-editor .visual-editor-body .product-items .product-image-card .product-image--blur {\n  opacity: 0.5;\n}\n\n.widget-visual-editor .visual-editor-body .product-items .product-image-img {\n  position: relative;\n  display: block;\n  max-width: 100%;\n}\n\n.widget-visual-editor .visual-editor-body .product-grid-items {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  gap: 16px;\n}\n\n.widget-visual-editor .visual-editor-body .product-grid-card-item {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  border-radius: 8px;\n  border: 1px solid #e1e3e5;\n  padding: 16px;\n  width: 100%;\n}\n\n.widget-visual-editor .visual-editor-body .product-grid-card-item .product-image {\n  width: 64px;\n  height: 64px;\n  min-width: 64px;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #e1e3e5;\n  display: flex;\n  background-color: #ffffff;\n  justify-content: center;\n}\n\n.widget-visual-editor .visual-editor-body .product-grid-card-item .product-info {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n}\n\n.widget-visual-editor .visual-editor-body .product-grid-card-item .product-info .Polaris-Select {\n  pointer-events: none;\n  cursor: not-allowed;\n}\n\n.widget-visual-editor .visual-editor-body .product-grid-card-item .product-info .product-price {\n  color: #1e5ea1;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.widget-visual-editor .visual-editor-body .product-grid-card-item .product-image img {\n  width: 100%;\n  height: 100%;\n  max-width: 64px;\n  object-fit: contain;\n}\n\n.widget-visual-editor .visual-editor-body .product-grid-card-item .product-actions button {\n  border: 1px solid #dedede;\n  border-radius: 8px;\n  background-color: unset;\n  padding: 10px 14px;\n  color: #1e5ea1;\n  font-weight: 700;\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-bundle {\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 0px 32px 40px;\n  flex-direction: column;\n  display: flex;\n  height: 92%;\n  overflow: auto;\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-bundle-body .cart {\n  outline: none;\n  display: block;\n  position: relative;\n  width: 156px;\n  margin-left: 10px;\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-bundle-body .total {\n  width: 150px;\n  margin-bottom: 10px;\n  text-align: center;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  color: #222222;\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-bundle-body .total span {\n  font-family: 'SF Pro Text';\n  font-weight: 600;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n  color: #222222;\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-bundle-body .add-to-cart {\n  width: 150px;\n  font-size: 16px;\n  padding: 10px 10px;\n  background-color: #000000;\n  color: #fff;\n  border: none;\n  cursor: pointer;\n  border-radius: 80px;\n  min-width: 110px;\n  max-width: 220px;\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-bundle-body .item-detail-preview {\n  display: block;\n  margin-top: 1rem;\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-bundle-body .label {\n  font-family: 'SF Pro Text';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  color: #202223;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  word-break: break-word;\n  line-height: 1.2;\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-bundle-body .checkbox-container {\n  display: flex;\n  align-items: center;\n}\n\n.widget-visual-editor\n  .visual-editor-body\n  .recommendation-bundle-body\n  .checkbox-container\n  .Polaris-Checkbox__Backdrop::before {\n  background-color: #202223;\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-bundle-body .label-container {\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-bundle-body .label-wrapper {\n  align-items: center;\n  white-space: pre-wrap;\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-bundle-body .details-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.widget-visual-editor .visual-editor-body .recommendation-bundle-body .item-detail-price {\n  font-family: 'SF Pro Text';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  color: #202223;\n  flex: none;\n}\n\n.boost-sd__recommendation .boost-sd__recommendation-title .boost-sd__recommendation-title-text {\n  line-height: 1.2;\n}\n\n.recommendation-carousel {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.visual-editor-preview-wrapper\n  .visual-editor-preview\n  .recommendation-carousel\n  .recommendation-carousel-body {\n  width: 100%;\n  text-align: center;\n}\n\n.visual-editor-preview-wrapper .visual-editor-preview .recommendation-note {\n  padding-top: 1rem;\n  padding-left: 1rem;\n  text-align: left;\n}\n\n.visual-editor-preview-wrapper .visual-editor-preview .recommendation-carousel .boost-sd__dots {\n  margin-bottom: 10px;\n}\n\n.visual-editor-preview-wrapper\n  .visual-editor-preview\n  .recommendation-carousel\n  .Polaris-Button--iconOnly {\n  vertical-align: middle;\n}\n\n.visual-editor-preview-wrapper .visual-editor-preview .recommendation-carousel .Polaris-Icon svg {\n  fill: var(--p-interactive) !important;\n  width: 20px;\n  /* vertical-align: middle; */\n}\n\n.visual-editor-preview-wrapper .visual-editor-preview .recommendation-missing-template {\n  margin-bottom: 16px;\n}\n\n.visual-editor-preview-wrapper\n  .visual-editor-preview\n  .recommendation-missing-template\n  .Polaris-Banner {\n  border: 0;\n  background-color: #fff5ea80;\n  box-shadow: none;\n}\n\n.visual-editor-preview-wrapper\n  .visual-editor-preview\n  .recommendation-missing-template\n  .Polaris-Banner\n  .Polaris-Link {\n  color: #2c6ecb;\n}\n\n.code {\n  font-family: Monaco;\n  border: 1px solid #d0d0d0;\n  border-radius: 4px;\n  background: #f5f5f5;\n  padding: 0.75rem 1rem;\n  margin: 0.5rem 0;\n  position: relative;\n}\n\n.code .Polaris-Button {\n  position: absolute;\n  top: 0.75rem;\n  right: 1rem;\n}\n\n.code .Polaris-Button--plain.Polaris-Button--iconOnly svg,\n.copy .Polaris-Button--plain.Polaris-Button--iconOnly svg {\n  fill: var(--p-icon-subdued);\n}\n\n.code .Polaris-Button--plain.Polaris-Button--iconOnly:hover svg,\n.copy .Polaris-Button--plain.Polaris-Button--iconOnly:hover svg {\n  fill: var(--p-icon-hovered);\n}\n\n.copy button.Polaris-Button--plain.Polaris-Button--iconOnly {\n  margin: 0 0 0 2px;\n  padding: 0;\n  min-width: auto;\n  min-height: auto;\n}\n\n.copy .Polaris-Icon {\n  width: 12px;\n  height: 12px;\n}\n\n/* Recommendation Widget End */\n\n/* Recommendation General Settings */\n.BC-Page__RecommendationGeneralSettings .Polaris-Page {\n  max-width: 936px !important;\n  padding: 0;\n}\n\n.BC-Page__RecommendationGeneralSettings .general-settings-banner {\n  background-color: #f7fdfc;\n  width: 100%;\n  min-height: 160px;\n  border-radius: 8px;\n  display: inline-flex;\n}\n\n.BC-Page__RecommendationGeneralSettings .general-settings-banner .banner-title {\n  color: var(--Text-Default, #202223);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.BC-Page__RecommendationGeneralSettings .general-settings-banner .banner-content-body {\n  color: var(--Text-Default, #202223);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  /* 142.857% */\n}\n\n.BC-Page__RecommendationGeneralSettings .general-settings-banner .banner-left {\n  width: calc(100% - 336px);\n}\n\n.BC-Page__RecommendationGeneralSettings .general-settings-banner .banner-left .banner-content {\n  margin: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.BC-Page__RecommendationGeneralSettings .general-settings-banner .banner-left .Polaris-Button {\n  border-color: #95c9b4;\n  background-color: #f7fdfc;\n}\n\n.BC-Page__RecommendationGeneralSettings .general-settings-banner .banner-right {\n  float: right;\n}\n\n.BC-Page__RecommendationGeneralSettings .general-settings-banner .banner-right .banner-dismiss {\n  margin-top: 20px;\n  margin-left: 280px;\n  cursor: pointer;\n}\n\n.BC-Page__RecommendationGeneralSettings .general-settings-banner .banner-right .banner-image {\n  background-image: url('https://cdn.boostcommerce.io/assets/recommendation/recommend-general-settings.png');\n  background-size: 100%;\n  width: 336px;\n  height: 112px;\n  margin-top: 8px;\n}\n\n.BC-Page__RecommendationGeneralSettings\n  .Polaris-FormLayout\n  .BC-Toggle-Switch\n  .BC-Toggle-HelperText {\n  color: #6d7175;\n}\n\n.BC-Page__RecommendationGeneralSettings .Polaris-FormLayout .BC-RecomendGeneralSetting_TextButton {\n  color: #2c6ecb;\n  float: right;\n  cursor: pointer;\n}\n\n.BC-Page__RecommendationGeneralSettings .Polaris-FormLayout .BC-RecomendGeneralSetting_ProductList {\n  margin-top: 10px;\n  border: 1px solid #e1e3e5;\n  border-radius: 4px;\n  text-align: center;\n  padding: 16px;\n}\n\n.BC-RecomendGeneralSetting_ProductList-NoProduct {\n  color: #6d7175;\n}\n\n.BC-Page__RecommendationGeneralSettings .section-divider {\n  margin-top: 20px;\n  border-top: 1px solid #e1e3e5;\n}\n\n.BC-Page__RecommendationGeneralSettings .footer {\n  display: flex;\n  justify-content: center;\n  margin-top: 1.5rem;\n  position: relative;\n  margin-bottom: 1.25rem;\n}\n\n.BC-Page__RecommendationGeneralSettings .footer .BC-Page__Button {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options {\n  margin-top: 0.375rem;\n}\n\n.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options .list-available {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n\n.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options\n  .list-available\n  .Polaris-SkeletonDisplayText__DisplayText {\n  max-width: 100%;\n}\n\n.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options .list-available li {\n  margin-bottom: 0.75rem;\n}\n\n.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options\n  .list-available\n  li:last-child {\n  margin-bottom: 0;\n}\n\n.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options\n  .list-available\n  .BC-ProductItem\n  .BC-ProductItem__Checkbox {\n  display: flex;\n  position: relative;\n  top: 1px;\n}\n\n.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options\n  .list-available\n  .BC-ProductItem\n  .product-image {\n  margin-right: 2px;\n}\n\n.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options\n  .list-available\n  .BC-ProductItem\n  .BC-ProductItem__Checkbox\n  .Polaris-Choice__Control {\n  margin-right: 0;\n}\n\n.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options\n  .list-available\n  .BC-ProductItem\n  .Polaris-Stack__Item:nth-child(3) {\n  flex: 1;\n  margin-right: 2px;\n}\n\n.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options\n  .BC-ProductItem\n  .BC-ProductItem__title {\n  flex: 1 1 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options\n  .BC-ProductItem\n  .BC-ProductItem__badge {\n  margin-left: auto;\n  min-width: 100px;\n  margin-right: 10px;\n}\n\n.BC-Page__RecommendationGeneralSettings .BC-SubSettings {\n  margin-top: 20px;\n}\n\n.BC-Page__RecommendationGeneralSettings .BC-SubSettings .Polaris-Card {\n  box-shadow: none !important;\n}\n\n.BC-Page__RecommendationGeneralSettings .BC-SubSettings .SubSettings__description {\n  color: var(--Text-Subdued, #6d7175);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  /* 142.857% */\n}\n\n.BC-RecomendGeneralSetting_ProductList .ProductsList {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n\n.BC-RecomendGeneralSetting_ProductList .ProductsList .ProductsList__item {\n  display: flex;\n  height: 56px;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  padding-bottom: 5px;\n  padding-top: 5px;\n  width: 100%;\n  background-color: #fff;\n}\n\n.BC-RecomendGeneralSetting_ProductList .ProductsList li {\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.BC-RecomendGeneralSetting_ProductList .ProductsList li:last-child {\n  border-bottom: 0px;\n}\n\n.BC-RecomendGeneralSetting_ProductList .ProductsList .ProductsList__item-thumbnail {\n  display: flex;\n  position: relative;\n  margin-right: 8px;\n}\n\n.BC-RecomendGeneralSetting_ProductList .ProductsList .ProductsList__item-title {\n  flex: 1 1 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.BC-RecomendGeneralSetting_ProductList .ProductsList .ProductsList__item-title .Polaris-Link {\n  margin-left: 3px;\n  text-align: left;\n}\n\n.BC-RecomendGeneralSetting_ProductList .ProductsList .ProductsList__item-action {\n  display: flex;\n  width: 30px;\n  height: 30px;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  border-radius: 4px;\n  border: 1px solid var(--border-neutral-subdued, #babfc3);\n  background: var(--action-secondary-default, #fff);\n  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.05);\n}\n\n.BC-RecomendGeneralSetting_ProductList .ProductsList .ProductsList__item-title .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  margin: 0;\n}\n\n.BC-RecomendGeneralSetting_ProductList .ProductsList .ProductsList__item-draggable {\n  margin-right: 5px;\n}\n\n.BC-Page__RecommendationGeneralSettings .ProductsList__note-wrapper {\n  margin-top: 5px;\n}\n\n.BC-Page__RecommendationGeneralSettings .ProductsList__note-dragAndDrop {\n  color: var(--text-subdued, #6d7175);\n  /* Desktop/Body */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  /* 142.857% */\n}\n\n.BC-Page__RecommendationGeneralSettings .ProductsList__note-strong {\n  color: var(--text-critical, #d72c0d);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  /* 142.857% */\n}\n\n.BC-Page__RecommendationGeneralSettings .ProductsList__note-content {\n  color: var(--text-default, #202223);\n  /* Desktop/Body */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.BC-Page__RecommendationGeneralSettings .ProductsList__note-highlight {\n  color: var(--text-default, #202223);\n  /* Desktop/Body */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.BC-Page__RecommendationGeneralSettings .ProductsList__note-default {\n  color: var(--Text-Default, #202223);\n\n  /* Desktop/Body */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.BC-Page__RecommendationGeneralSettings\n  .Polaris-FormLayout\n  .BC-RecomendGeneralSetting_TextButton-disable {\n  color: var(--icon-disabled, #babec3);\n  text-align: right;\n\n  /* Desktop/Body */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  /* 142.857% */\n  float: right;\n  cursor: pointer;\n}\n\n/* Recommendation End */\n.BC-Page__RW-StepGuide .fullscreen-bar {\n  display: flex;\n  width: 100%;\n  height: auto;\n  align-items: center;\n  text-align: center;\n  justify-content: flex-end;\n  padding-right: 16px;\n}\n\n.BC-Page__RW-StepGuide .section01 {\n  margin-top: 36px;\n  padding: 24px;\n}\n\n.BC-Page__RW-StepGuide .section02 {\n  margin-top: 24px;\n  padding: 24px;\n}\n\n.BC-Page__RW-StepGuide .section02 > p {\n  margin-bottom: 8px;\n}\n\n.BC-Page__RW-StepGuide .section01 > .Polaris-Heading {\n  font-size: 28px;\n  line-height: 32px;\n  margin-bottom: 4px;\n}\n\n.BC-Page__RW-StepGuide .section01 .online-store-v2 > .Polaris-Heading {\n  font-size: 20px;\n  line-height: 28px;\n}\n\n.BC-Page__RW-StepGuide .section01 .step-guide {\n  margin-top: 16px;\n  /* display: flex;\n  justify-content: space-between;\n  gap: 82px;\n  line-height: 20px; */\n}\n\n.BC-Page__RW-StepGuide .section01 .online-store-v1 > div {\n  margin-top: 16px;\n}\n\n.BC-Page__RW-StepGuide .section01 .online-store-v1 .step02 img {\n  width: 100%;\n  border-radius: 8px;\n  margin-top: 8px;\n}\n\n.BC-Page__RW-StepGuide .section01 .Polaris-Tabs__Panel .content > div {\n  margin-top: 4px;\n}\n\n.BC-Page__RW-StepGuide .section01 .step-guide .BC-Iframe-Container {\n  width: 360px;\n  height: 110px;\n}\n\n.BC-Page__RW-StepGuide .section01 .step-guide .BC-Iframe-Container iframe {\n  border-radius: 4px;\n}\n\n.BC-Page__RW-StepGuide .section01 .step01 .content > p .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  margin: 0;\n}\n\n.BC-Page__RW-StepGuide .section01 .step01 .content > p {\n  color: var(--p-text-success);\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n  font-size: 15px;\n}\n\n.BC-Page__RW-StepGuide .section01 .Polaris-Banner {\n  margin-top: 8px;\n}\n\n.BC-Page__RW-StepGuide .section01 .step-guide .content .Polaris-Button {\n  margin-top: 16px;\n  margin-bottom: 0.75rem;\n}\n\n.BC-Page__RW-StepGuide .section01 .content .html-placeholder input,\n.BC-Page__RW-StepGuide .section01 .content .html-placeholder textarea,\n.BC-Page__RecommendationWidgetItem .html-placeholder input,\n.BC-Page__RecommendationWidgetItem .html-placeholder textarea,\n.BC-PreOrderItem__Placement .html-placeholder input,\n.BC-PreOrderItem__Placement .html-placeholder textarea {\n  font-size: 0.75rem;\n  padding: 12px;\n  height: max-content !important;\n}\n\n.BC-Page__RW-StepGuide .section01 .content .html-placeholder .Polaris-Button--plain svg,\n.BC-Page__RecommendationWidgetItem .html-placeholder .Polaris-Button--plain svg,\n.BC-PreOrderItem__Placement .html-placeholder .Polaris-Button--plain svg {\n  fill: #8c9196;\n}\n\n.Polaris-Button--plain.Polaris-Button--iconOnly:hover svg {\n  fill: rgba(92, 95, 98, 1);\n}\n\n.BC-Page__RW-StepGuide .section01 .content .html-placeholder .Polaris-TextField,\n.BC-Page__RecommendationWidgetItem .html-placeholder .Polaris-TextField,\n.BC-PreOrderItem__Placement .html-placeholder .Polaris-TextField {\n  margin-top: 4px;\n  align-items: unset;\n}\n\n.BC-Page__RW-StepGuide\n  .section01\n  .content\n  .html-placeholder\n  .Polaris-TextField\n  .Polaris-TextField__Suffix,\n.BC-Page__RecommendationWidgetItem .html-placeholder .Polaris-TextField .Polaris-TextField__Suffix,\n.BC-PreOrderItem__Placement .html-placeholder .Polaris-TextField .Polaris-TextField__Suffix {\n  margin: unset;\n  padding: 5px 4px;\n}\n\n.BC-Page__RW-StepGuide\n  .section01\n  .content\n  .html-placeholder\n  .Polaris-TextField\n  .Polaris-TextField__Suffix\n  .Polaris-Button--plain,\n.BC-Page__RecommendationWidgetItem\n  .html-placeholder\n  .Polaris-TextField\n  .Polaris-TextField__Suffix\n  .Polaris-Button--plain,\n.BC-PreOrderItem__Placement\n  .html-placeholder\n  .Polaris-TextField\n  .Polaris-TextField__Suffix\n  .Polaris-Button--plain {\n  margin: unset;\n}\n\n.BC-Page__RW-StepGuide .section01 .content .html-placeholder .Polaris-TextField__Input:disabled,\n.BC-Page__RecommendationWidgetItem .html-placeholder .Polaris-TextField__Input:disabled,\n.BC-PreOrderItem__Placement .html-placeholder .Polaris-TextField__Input:disabled {\n  -webkit-text-fill-color: #202223 !important;\n  font-family: Monaco;\n}\n\n.BC-Page__RW-StepGuide\n  .section01\n  .content\n  .html-placeholder\n  .Polaris-TextField--disabled\n  > .Polaris-TextField__Backdrop,\n.BC-Page__RecommendationWidgetItem\n  .html-placeholder\n  .Polaris-TextField--disabled\n  > .Polaris-TextField__Backdrop,\n.BC-PreOrderItem__Placement\n  .html-placeholder\n  .Polaris-TextField--disabled\n  > .Polaris-TextField__Backdrop {\n  background-color: #f5f5f5;\n  border: 1px solid #d0d0d0;\n}\n\n.BC-Page__RW-StepGuide .section01 .content table,\n.BC-Page__RecommendationWidgetItem .content table,\n.BC-PreOrderItem__Placement .content table {\n  margin-top: 1rem;\n}\n\n.BC-Page__RW-StepGuide .section01 .content table,\n.BC-Page__RW-StepGuide .section01 .content tr,\n.BC-Page__RecommendationWidgetItem .content table,\n.BC-Page__RecommendationWidgetItem .content tr,\n.BC-PreOrderItem__Placement .content table,\n.BC-PreOrderItem__Placement .content tr {\n  border: 1px solid #e1e3e5;\n  border-collapse: collapse;\n  text-align: left;\n  width: 20rem;\n}\n\n.BC-PreOrderItem__Placement .content table.file-name {\n  width: 28rem;\n}\n\n.BC-Page__RW-StepGuide .section01 .content th,\n.BC-Page__RW-StepGuide .section01 .content td,\n.BC-Page__RecommendationWidgetItem .content th,\n.BC-Page__RecommendationWidgetItem .content td,\n.BC-PreOrderItem__Placement .content th,\n.BC-PreOrderItem__Placement .content td {\n  padding: 0.5rem 1rem;\n}\n\n.BC-Page__RW-StepGuide .section01 .content tbody tr td:nth-child(2),\n.BC-Page__RecommendationWidgetItem .content tbody tr td:nth-child(2),\n.BC-PreOrderItem__Placement .content tbody tr td:nth-child(2) {\n  color: var(--p-text-critical);\n}\n\n.BC-Page__RW-StepGuide .section02 > .Polaris-Heading {\n  font-size: 20px;\n  line-height: 28px;\n}\n\n.BC-Page__RW-StepGuide .section02 .useful {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.BC-Page__RW-StepGuide .section02 .useful .card-action {\n  display: flex;\n  gap: 12px;\n  background: #fafbfb;\n  border-radius: 4px;\n  align-items: center;\n  padding: 20px;\n  min-height: 60px;\n  width: 100%;\n}\n\n.BC-Page__RW-StepGuide .section02 .useful .card-action:hover {\n  cursor: pointer;\n  background-color: #f0f8f8;\n}\n\n.BC-Page__RW-StepGuide .tab-content .tab-content-title {\n  padding-bottom: 1.25rem;\n}\n\n.BC-Page__RW-StepGuide .tab-content .tab-content-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.BC-Page__RW-StepGuide .tab-content .tab-content-content .action {\n  margin-top: 16px;\n}\n\n.BC-Page__RW-StepGuide .tab-content .tab-content-content .action .non-action {\n  display: inline-flex;\n}\n\n.BC-Page__RW-StepGuide .tab-content .tab-content-content .action .non-action .Polaris-Icon {\n  margin-right: 0.5rem;\n}\n\n.BC-Page__RW-StepGuide .tab-content .setup-cart-drawer-step {\n  list-style-type: disc;\n  padding-left: 1.25rem;\n  margin-top: 4px;\n}\n\n.BC-Page__RW-StepGuide .tab-content .setup-cart-drawer-step svg {\n  fill: #5c5f62;\n  width: 15px;\n  height: 16px;\n}\n\n/* Recommendation Grant Permission Notif */\n\n.BC-Container__Notifications__GrantPermissionBanner {\n  color: var(--p-text);\n}\n\n.BC-Page__RecommendationWidgetManagement\n  .BC-Container__Notifications\n  .BC-Container__Notifications__GrantPermissionBanner\n  .Polaris-Banner__Heading {\n  margin-bottom: 4px;\n}\n\n.BC-Page__RecommendationWidgetManagement\n  .BC-Container__Notifications\n  .BC-Container__Notifications__GrantPermissionBanner\n  .Polaris-List__Item {\n  margin-bottom: 0;\n}\n\n/* Recommendation Grant Permission Notif End */\n\n/* Manual Recommendation */\n.BC-Page__ManualRecommendationManagement .searchField {\n  width: 50%;\n  margin-left: auto;\n}\n\n.BC-Page__ManualRecommendationManagement .pagination .BC-Page__Button {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.BC-Page__ManualRecommendationManagement .pagination .Polaris-ButtonGroup__Item {\n  margin-left: 0.75rem;\n}\n\n.BC-Page__ManualRecommendationManagement .BC-Container__Notifications .Polaris-List__Item {\n  margin-bottom: 0.125rem;\n}\n\n.BC-Page__ManualRecommendationManagement\n  .BC-Container__Notifications\n  .Polaris-Banner\n  .Polaris-Banner__ContentWrapper\n  a\n  .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  max-width: 16px;\n  margin-left: 2px;\n  margin-right: 2px;\n}\n\n/* .BC-Page__ManualRecommendationManagement .BC-Container__Notifications .Polaris-Banner\n  .Polaris-Banner__ContentWrapper a .Polaris-Icon .Polaris-Icon__Svg {\n  margin-top: 5px;\n} */\n\n.BC-Page__ManualRecommendationManagement\n  .BC-Container__Notifications\n  .Polaris-Banner\n  .Polaris-Banner__ContentWrapper\n  .manual-external-link\n  .Polaris-Link--monochrome {\n  color: var(--p-interactive);\n}\n\n.BC-Page__ManualType .Polaris-Card > .Polaris-Card__Section:nth-child(2) {\n  padding-top: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.BC-Page__ManualType__ComingSoon {\n  padding-top: 2.5rem;\n  padding-bottom: 1.25rem;\n}\n\n.BC-Page__ManualType__NoRecommendation {\n  padding: 1.5rem 0 0.25rem;\n}\n\n.BC-Page__ManualType__NoSearchResult {\n  padding: 0.25em 0;\n}\n\n.BC-Page__ManualType .tabs .Polaris-Tabs__Panel .Polaris-Card__Section {\n  padding: 0;\n}\n\n.BC-Page__ManualType__HandPickedProduct .Polaris-DataTable th.Polaris-DataTable__Cell:first-child {\n  width: 76px;\n}\n\n.BC-Page__ManualType__HandPickedProduct\n  .Polaris-DataTable\n  .Polaris-DataTable__TableRow\n  .Polaris-DataTable__Cell:first-child {\n  padding: 0.5rem 1rem 0.5rem 1.25rem;\n}\n\n.BC-Page__ManualType__HandPickedProduct .Polaris-DataTable th.Polaris-DataTable__Cell:nth-child(2) {\n  width: 249px;\n}\n\n.BC-Page__ManualType__HandPickedProduct .Polaris-DataTable th.Polaris-DataTable__Cell:nth-child(2),\n.BC-Page__ManualType__HandPickedProduct\n  .Polaris-DataTable\n  .Polaris-DataTable__TableRow\n  .Polaris-DataTable__Cell:nth-child(2) {\n  padding: 0.5rem 1rem 0.5rem 0;\n}\n\n.BC-Page__ManualType__HandPickedProduct\n  .Polaris-DataTable\n  .Polaris-DataTable__TableRow\n  .Polaris-DataTable__Cell:nth-child(3) {\n  padding: 0.5rem 0 0.5rem 1rem;\n}\n\n.BC-Page__ManualType__HandPickedProduct .Polaris-DataTable th.Polaris-DataTable__Cell:last-child {\n  width: 92px;\n  text-align: center;\n}\n\n.BC-Page__ManualType__HandPickedProduct\n  .Polaris-DataTable\n  .Polaris-DataTable__TableRow\n  .Polaris-DataTable__Cell:last-child {\n  padding: 0.5rem 1.25rem 0.5rem 1rem;\n}\n\n.BC-Page__ManualType__RecommendationProduct__items {\n  margin-left: 0.5rem;\n}\n\n.BC-Page__ManualType__HandPickedProduct__ButtonGroups {\n  position: relative;\n  top: 3px;\n}\n\n.BC-Page__ManualType__HandPickedProduct__SourceProduct {\n  max-width: 309px;\n  white-space: initial;\n}\n\n.BC-Page__ManualType__HandPickedProduct .BC-Page__ManualType__HandPickedProduct__ColumnTitle {\n  font-weight: 500;\n}\n\n.BC-Page__ManualType__SearchResult__Loading {\n  padding: 1rem 1rem 0.5rem 1rem;\n}\n\n.BC-Page__ManualType__SearchResult__Loading .Polaris-SkeletonDisplayText__DisplayText {\n  margin-bottom: 0.5rem;\n  max-width: 100%;\n}\n\n.BC-Page__ManualType__SearchResult__Loading .Polaris-SkeletonDisplayText__DisplayText:last-child {\n  margin-bottom: 0;\n}\n\n.BC-Page__ManualType__SearchResult .BC-Page__ManualType__SearchResult__Title {\n  padding: 1.25rem 1.25rem 0.5rem;\n}\n\n.BC-Page__ManualType__SearchResult .Polaris-Card__Section {\n  margin-bottom: 0.5rem;\n  max-height: 670px;\n  overflow: auto;\n}\n\n.BC-Page__ManualType__SearchResult .Polaris-Card__Section:last-child {\n  margin-bottom: 0;\n}\n\n.BC-Page__ManualType__SearchResult .BC-Page__ManualType__SearchResult__Empty {\n  padding: 2.75rem;\n  padding-bottom: 1.5rem;\n}\n\n/* Manual Recommendation End */\n\n/* Manual Recommendation New Item */\n.BC-Page__ManualRecommendationNew .BC-Page__ManualRecommendationNew__SourceProduct {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__ManualRecommendationNew__SourceProduct .Polaris-Card__Header,\n.BC-Page__ManualRecommendationNew__RecommendProduct .Polaris-Card__Header {\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.BC-Page__ManualRecommendationNew__SourceProduct .Polaris-Card__Section,\n.BC-Page__ManualRecommendationNew__RecommendProduct .Polaris-Card__Section {\n  padding: 0;\n  padding-bottom: 0.5rem;\n}\n\n.BC-Page__ManualRecommendationNew__SourceProduct\n  .BC-Page__ManualRecommendationNew__SourceProduct__List,\n.BC-Page__ManualRecommendationNew__RecommendProduct\n  .BC-Page__ManualRecommendationNew__RecommendProduct__List {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.BC-Page__ManualRecommendationNew__SourceProduct\n  .BC-Page__ManualRecommendationNew__SourceProduct__List\n  li,\n.BC-Page__ManualRecommendationNew__RecommendProduct\n  .BC-Page__ManualRecommendationNew__RecommendProduct__List\n  li {\n  background-color: #fff;\n  padding: 0.5rem 1rem;\n  transition: background-color 200ms cubic-bezier(0.42, 0, 0.58, 1);\n  box-shadow: inset 0px -1px 0px #e1e3e5;\n}\n\n.BC-Page__ManualRecommendationNew__SourceProduct\n  .BC-Page__ManualRecommendationNew__SourceProduct__List\n  li:last-child,\n.BC-Page__ManualRecommendationNew__RecommendProduct\n  .BC-Page__ManualRecommendationNew__RecommendProduct__List\n  li:last-child {\n  box-shadow: none;\n}\n\n.BC-Page__ManualRecommendationNew__SourceProduct\n  .BC-Page__ManualRecommendationNew__SourceProduct__List\n  li:hover,\n.BC-Page__ManualRecommendationNew__RecommendProduct\n  .BC-Page__ManualRecommendationNew__RecommendProduct__List\n  li:hover {\n  background-color: rgb(246, 246, 247);\n}\n\n.BC-Page__ManualRecommendationNew__SourceProduct__Skeleton,\n.BC-Page__ManualRecommendationNew__RecommendProduct__Skeleton {\n  padding: 1rem 1.25rem;\n}\n\n.BC-Page__ManualRecommendationNew__SourceProduct__Skeleton\n  .Polaris-SkeletonDisplayText__DisplayText,\n.BC-Page__ManualRecommendationNew__RecommendProduct__Skeleton\n  .Polaris-SkeletonDisplayText__DisplayText {\n  max-width: 100%;\n}\n\n.BC-Page__ManualRecommendation__SourceProductItem .Polaris-Stack__Item:nth-child(2) {\n  padding: 0.5rem 1rem;\n  flex: 1;\n}\n\n.BC-Page__ManualRecommendation__RecommendProductItem .Polaris-Stack__Item:nth-child(3) {\n  padding: 0.5rem 1rem;\n  flex: 1;\n}\n\n.BC-Page__ManualRecommendation__SourceProductItem__Action,\n.BC-Page__ManualRecommendation__RecommendProductItem__Action {\n  position: relative;\n  top: 3px;\n}\n\n.BC-Page__ManualRecommendationNew\n  .BC-Page__ManualRecommendationNew__SourceProduct\n  .BC-Page__ManualRecommendationNew__NoProduct {\n  padding: 3rem 0 2.5rem;\n}\n\n.BC-Page__ManualRecommendationNew\n  .BC-Page__ManualRecommendationNew__RecommendProduct\n  .BC-Page__ManualRecommendationNew__NoProduct {\n  padding: 3rem 0 2.5rem;\n}\n\n.BC-Page__ManualRecommendationNew__RecommendProduct .titleMetadata {\n  width: 12px;\n  height: 12px;\n}\n\n.BC-Page__ManualRecommendationNew__RecommendProduct .titleMetadata svg {\n  width: 12px;\n}\n\n.BC-Page__ManualRecommendationNew .BC-Page__Button .Polaris-ButtonGroup__Item {\n  margin-left: 1rem;\n}\n\n.BC-Page__SelectProductModal .Polaris-Modal-Section:first-child {\n  padding: 1rem 1.25rem;\n}\n\n.BC-Page__SelectProductModal__Header .Polaris-Modal-CloseButton:focus::after {\n  box-shadow: none;\n}\n\n.BC-Page__SelectProductModal__Header .Polaris-Icon__Svg {\n  fill: var(--p-text);\n}\n\n.BC-Page__ManualRecommendationNew__SelectProductModal__Description {\n  margin-bottom: 1.4rem;\n}\n\n.BC-Page__ManualRecommendationNew__SelectProductModal__Product-Options {\n  margin-top: 0.375rem;\n}\n\n.BC-Page__ManualRecommendationNew__SelectProductModal__Product-Options .list-available {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n\n.BC-Page__ManualRecommendationNew__SelectProductModal__Product-Options\n  .list-available\n  .Polaris-SkeletonDisplayText__DisplayText {\n  max-width: 100%;\n}\n\n.BC-Page__ManualRecommendationNew__SelectProductModal__Product-Options .list-available li {\n  margin-bottom: 0.75rem;\n}\n\n.BC-Page__ManualRecommendationNew__SelectProductModal__Product-Options\n  .list-available\n  li:last-child {\n  margin-bottom: 0;\n}\n\n.BC-Page__ManualRecommendationNew__SelectProductModal__Product-Options\n  .list-available\n  .BC-ProductItem\n  .BC-ProductItem__Checkbox {\n  display: flex;\n  position: relative;\n  top: 1px;\n}\n\n.BC-Page__ManualRecommendationNew__SelectProductModal__Product-Options\n  .list-available\n  .BC-ProductItem\n  .BC-ProductItem__Checkbox\n  .Polaris-Choice__Control {\n  margin-right: 0;\n}\n\n.BC-Page__ManualRecommendationNew__SelectProductModal__Product-Options\n  .list-available\n  .BC-ProductItem\n  .Polaris-Stack__Item:nth-child(3) {\n  flex: 1;\n}\n\n/* Manual Recommendation New Item End */\n\n/* Filter option - Multi level tags */\n.List_MultiLevelTags .BC-Draggable {\n  background-color: #ffffff;\n}\n\n.List_MultiLevelTags .BC-Draggable.dragging {\n  padding-right: 10px;\n  border: 1px solid var(--p-divider);\n}\n\n.List_MultiLevelTags .rowTag {\n  display: flex;\n  padding-top: 0.4375rem;\n  padding-bottom: 0.4375rem;\n}\n\n.List_MultiLevelTags .rowTag .dragIcon {\n  width: 25px;\n  margin-top: 5px;\n}\n\n.List_MultiLevelTags .rowTag .dragShowHideBtn {\n  width: 27px;\n  margin-top: 6px;\n}\n\n.List_MultiLevelTags .rowTag .dragSelectTag {\n  width: 45%;\n  padding-right: 0.625rem;\n}\n\n.List_MultiLevelTags .rowTag .dragDisplayName {\n  width: 40%;\n  padding-right: 0.625rem;\n}\n\n.List_MultiLevelTags .rowTag .action {\n  width: auto;\n}\n\n.MultiLevelTag_ButtonAdd {\n  padding-top: 0.4375rem;\n}\n\n.List_MultiLevelTags .Polaris-Button,\n.MultiLevelTag_ButtonAdd .Polaris-Button {\n  min-height: 2.125rem;\n  padding-top: 0.3125rem;\n  padding-bottom: 0.3125rem;\n}\n\n.List_MultiLevelTags .buttonAdd {\n  padding-top: 0.4375rem;\n}\n\n.List_MultiLevelTags .subTagBox1,\n.List_MultiLevelTags .buttonAddSubTag1 {\n  margin-left: 1.4375rem;\n}\n\n.List_MultiLevelTags .buttonAddSubTag1 {\n  margin: 0 0 0.4375rem 1.4375rem;\n  padding: 0.4375rem 0 0.875rem 0;\n  border-bottom: 1px solid var(--p-divider);\n}\n\n.List_MultiLevelTags .buttonAddSubTag1 .Polaris-Icon,\n.MultiLevelTag_ButtonAdd .Polaris-Icon,\n.List_MultiLevelTags .rowTag .action .Polaris-Icon {\n  height: 0.9375rem;\n  width: 0.9375rem;\n}\n\n.List_MultiLevelTags .dragShowHideBtn button svg {\n  fill: #212b36;\n}\n\n.List_MultiLevelTags .dragShowHideBtn .Polaris-Button--disabled svg {\n  fill: #fff;\n}\n\n.List_MultiLevelTags .BC-Button_Select .Polaris-Button {\n  min-height: 2.375rem;\n}\n\n.List_MultiLevelTags .BC-Button_Select .Polaris-Button {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.List_MultiLevelTags .BC-Button_Select .Polaris-Button__Content {\n  justify-content: space-between;\n  flex-direction: row-reverse;\n  color: #202223;\n  font-weight: var(--p-font-weight-regular);\n}\n\n.List_MultiLevelTags .BC-Button_Select .Polaris-Button__Content .Polaris-Button__Text {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.List_MultiLevelTags .BC-Button_Select .Polaris-Button__Content .Polaris-Button__Icon svg {\n  fill: #cccccc;\n}\n\n/* Update media screen */\n@media (max-width: 30.625em) {\n  .BC-Page__Dashboard .Polaris-Card__Header,\n  .BC-Page__FilterTree-Item .Polaris-Card__Header,\n  .BC-Page__FilterTree-Management .Polaris-Card__Header,\n  .BC-Page__Theme-Setup .Polaris-Card__Header,\n  .BC-Page__Merge-Value .Polaris-Card__Header,\n  .BC-Page__SuggestionDictionary .Polaris-Card__Header,\n  .BC-Page__Synonym .Polaris-Card__Header,\n  .BC-Page_ProductRanking .Polaris-Card__Header,\n  .BC-Page__Merchandising .Polaris-Card__Header,\n  .BC-Page__Merchandising-Rule .Polaris-Card__Header,\n  .BC-OnboardingChecklist__OnPage .Polaris-Card__Header {\n    padding-bottom: 1rem;\n    padding-top: 1rem;\n  }\n\n  .BC-Welcome__Dashboard {\n    padding: 1rem 1rem 0;\n  }\n\n  .BC-Page__Dashboard .BC-Iframe-Container__Center {\n    width: 100%;\n  }\n\n  .BC-Review__Dashboard .BC-Email__Dashboard .Polaris-Layout__Section,\n  .BC-Feedback__Dashboard .Polaris-Layout__Section {\n    order: 1;\n    margin-top: 0.625rem;\n  }\n\n  .BC-Review__Dashboard .BC-Email__Dashboard .Polaris-Layout__Section--secondary,\n  .BC-Feedback__Dashboard .Polaris-Layout__Section--secondary {\n    order: 0;\n    margin-bottom: 0;\n    margin-top: 1rem;\n  }\n\n  .BC-HelpCenter__Dashboard .Polaris-Layout__Section--secondary:not(:first-child),\n  .BC-Menu__Dashboard .Polaris-Layout__Section--secondary:not(:first-child) {\n    margin-top: 0;\n  }\n\n  .BC-KnowledgeBase__Dashboard .Polaris-Layout__Section:not(:first-child) {\n    display: none;\n  }\n\n  .BC-SyncHookStatus__Dashboard .Polaris-Layout__Section--secondary {\n    margin: 0;\n  }\n\n  .BC-Menu__Dashboard\n    .Polaris-Layout__Section:first-child\n    .BC-Link__Dashboard:first-child\n    .menuBox\n    .Polaris-Card__Section,\n  .BC-HelpCenter__Dashboard\n    .Polaris-Layout__Section:first-child\n    .BC-Link__Dashboard:first-child\n    .menuBox\n    .Polaris-Card__Section {\n    padding-top: 0px;\n  }\n\n  .BC-Menu__Dashboard .menuBox .Polaris-Card__Section,\n  .BC-HelpCenter__Dashboard .menuBox .Polaris-Card__Section {\n    padding-bottom: 0px;\n  }\n\n  .BC-ThemeSetup__DashboardV3,\n  .BC-CalloutCard-ThemeSetup__Dashboard,\n  .BC-CalloutCard-ExpReviewRating__Dashboard {\n    text-align: center;\n  }\n\n  .BC-ThemeSetup__DashboardV3 .firstCol .Polaris-Button,\n  .BC-CalloutCard-ThemeSetup__Dashboard .firstCol .Polaris-Button,\n  .BC-CalloutCard-ExpReviewRating__Dashboard .firstCol .Polaris-Button {\n    margin-top: 1rem;\n  }\n\n  .BC-Page__FilterTree-Item .BC-Page__Text {\n    padding: 1.5rem 1rem 0;\n  }\n\n  .BC-Page__FilterTree-Management .BC-Page__Text {\n    padding: 0 1rem;\n  }\n}\n\n/* Stop words */\n.BC-EmptyOption__StopWords {\n  margin-top: 3.75rem;\n  margin-bottom: 2.5rem;\n}\n\n.BC-Page__StopWords .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {\n  justify-content: flex-end;\n}\n\n.BC-Page__StopWords\n  .Polaris-PageActions\n  .Polaris-Stack--distributionEqualSpacing\n  .Polaris-Stack__Item {\n  margin-left: 1rem;\n}\n\n.BC-Page__StopWords .ImportExportActionsGroup {\n  display: inline-flex;\n  color: #637381;\n}\n\n.BC-Page__StopWords .ImportExportActionsGroup .action {\n  display: inline-flex;\n  cursor: pointer;\n}\n\n.BC-Page__StopWords .ImportExportActionsGroup .action:last-child {\n  margin-left: 1.4375rem;\n}\n\n.BC-Page__StopWords .ImportExportActionsGroup .action .Polaris-Icon {\n  margin-right: 3px;\n}\n\n.BC__StopWords-Search {\n  display: flex;\n  justify-content: flex-end;\n  margin: -0.35rem 0;\n  width: 272px;\n}\n\n.BC__StopWords-Search > div {\n  width: 100%;\n}\n\n.BC__StopWords-Search .Polaris-Icon--colorInk svg {\n  fill: #212b36;\n}\n\n.BC__StopWords-List {\n  display: flex;\n  list-style-type: none;\n  flex-wrap: wrap;\n  margin: 1.375rem -0.8125rem 0 -0.8125rem;\n  -webkit-padding-start: 0;\n  padding-inline-start: 0;\n}\n\n.BC__StopWords-Item {\n  flex: 0 0 10rem;\n  background-color: #f4f6f8;\n  display: flex;\n  padding-left: 0.75rem;\n  margin: 0.625rem 0.75rem;\n  align-items: center;\n  border-radius: 5px;\n}\n\n.BC__StopWords-Item.is-new {\n  background-color: #d7f2ff;\n}\n\n.BC__StopWords-Item.is-new .BC__StopWords--Value .Polaris-TextStyle--variationSubdued {\n  color: #084e8a;\n}\n\n.BC__StopWords-Item.is-new\n  .BC__StopWords--Remove\n  .Polaris-Button--plain.Polaris-Button--iconOnly\n  svg {\n  fill: #084e8a;\n}\n\n.BC__StopWords-Item.is-new\n  .BC__StopWords--Remove\n  .Polaris-Button--plain.Polaris-Button--iconOnly:hover\n  svg,\n.BC__StopWords-Item.is-new\n  .BC__StopWords--Remove\n  .Polaris-Button--plain.Polaris-Button--iconOnly:active\n  svg {\n  fill: #212b36;\n}\n\n.BC__StopWords--Remove {\n  margin-left: auto;\n  line-height: 0;\n}\n\n.BC__StopWords--Remove .Polaris-Icon {\n  width: 21px;\n  height: 21px;\n}\n\n.BC__StopWords--Remove .Polaris-Button--plain.Polaris-Button--iconOnly {\n  margin: 0;\n  margin-left: 0.75rem;\n  min-width: 0;\n  min-height: 0;\n  height: 28px;\n  padding: 0 0.25rem;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n\n.BC__StopWords--Remove:hover .Polaris-Button--plain.Polaris-Button--iconOnly {\n  background-color: #c4cdd5;\n}\n\n.BC__StopWords-Item.is-new\n  .BC__StopWords--Remove:hover\n  .Polaris-Button--plain.Polaris-Button--iconOnly {\n  background-color: #b4e0fa;\n}\n\n.BC__StopWords--Value {\n}\n\n.BC__StopWords--Value .Polaris-Caption {\n  font-size: 0.75rem;\n  line-height: 21px;\n  height: 22px;\n}\n\n/* Product ranking */\n.BC-Page__ProductRanking .Polaris-Stack > .Polaris-Stack__Item .Polaris-Heading:empty {\n  height: 20px;\n}\n\n.BC-Page__ProductRanking .Polaris-Stack > .Polaris-Stack__Item .search {\n  position: absolute;\n  right: 20px;\n  top: 10px;\n  width: 16.375rem;\n}\n\n.BC-Page__ProductRanking .Polaris-Stack > .Polaris-Stack__Item .search .Polaris-TextField__Input {\n  font-size: 0.75rem;\n}\n\n.BC-Page__ProductRanking .Polaris-DataTable__Cell {\n  padding: 0.9375rem 0.78125rem;\n}\n\n.BC-Page__ProductRanking tbody .Polaris-DataTable__Cell {\n  border-top: 1px solid var(--p-divider);\n  border-bottom: none;\n  white-space: normal;\n}\n\n.BC-Page__ProductRanking tbody tr:first-child .Polaris-DataTable__Cell {\n  border-top: none;\n}\n\n.BC-Page__ProductRanking .Polaris-DataTable__Cell.sortable-heading {\n  cursor: pointer;\n}\n\n.BC-Page__ProductRanking .Polaris-DataTable__Cell.sortable-heading:hover {\n  color: var(--p-action-primary);\n}\n\n.BC-Page__ProductRanking .Polaris-DataTable__Cell.sortable-heading > span {\n  display: inline-flex;\n}\n\n.BC-Page__ProductRanking tbody.list-available tr:nth-child(odd) .Polaris-DataTable__Cell {\n  padding: 0.4375rem 0.78125rem;\n}\n\n.BC-Page__ProductRanking\n  tbody.list-available\n  tr:nth-child(odd)\n  .Polaris-DataTable__Cell:first-child {\n  width: 3.125rem;\n  padding-left: 1.25rem;\n  padding-right: 0.5rem;\n}\n\n.BC-Page__ProductRanking .Polaris-DataTable__Cell .product-image {\n  width: 50px;\n  padding-bottom: 50px;\n  position: relative;\n  border: 1px solid var(--p-divider);\n  box-sizing: border-box;\n}\n\n.BC-Page__ProductRanking .Polaris-DataTable__Cell .product-image.no-image {\n  background-color: #f9fafb;\n}\n\n.BC-Page__ProductRanking .Polaris-DataTable__Cell .product-image img {\n  position: absolute;\n  max-width: 100%;\n  max-height: 100%;\n  display: block;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n\n.BC-Page__ProductRanking tr:nth-child(odd) .Polaris-DataTable__Cell:nth-child(3) {\n  width: 20%;\n}\n\n.BC-Page__ProductRanking tr:nth-child(odd) .Polaris-DataTable__Cell:nth-child(4) {\n  width: 34%;\n  padding-right: 1.25rem !important;\n}\n\n.BC-Page__ProductRanking tr:nth-child(even) .Polaris-DataTable__Cell {\n  padding-top: 0rem;\n  border-top: none;\n}\n\n.BC-Page__ProductRanking tr:nth-child(even) .Polaris-DataTable__Cell:first-child {\n  padding-left: 1.25rem;\n}\n\n.BC-Page__ProductRanking tr:nth-child(even) .Polaris-DataTable__Cell:last-child {\n  padding-right: 1.25rem;\n}\n\n.BC-Page__ProductRanking .bottom {\n  display: block;\n  margin-top: 1.5rem;\n  position: relative;\n}\n\n.BC-Page__ProductRanking .actionsGroup {\n  position: absolute;\n  right: 0px;\n  top: 0px;\n}\n\n.BC-EmptyOption__ProductRanking,\n.BC-EmptySearch__RecommendationWidget,\n.BC-EmptySearch__Integration,\n.BC-EmptySearch__ABTestingCampaign {\n  padding-top: 1.875rem;\n  padding-bottom: 1.5rem;\n}\n\n/* Analytics */\n.BC-Analytics__Tabs .Polaris-Tabs__Tab:first-child {\n  padding-left: 0;\n}\n\n.action-locked--analytics {\n  display: flex;\n  gap: 8px;\n}\n\n.BC-Analytics__Total {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.BC-Analytics__Total .section {\n  flex: 1 1 19.375rem;\n  min-width: 0;\n  max-width: 100%;\n  border: 1px solid;\n  padding: 1.5rem;\n  text-align: center;\n}\n\n.BC-Analytics__Total .section > p {\n  margin-bottom: 0.25rem;\n  font-size: 1.625rem;\n}\n\n.BC-Analytics__Total .section > span {\n  font-size: 0.75rem;\n}\n\n.BC-Analytics__Total,\n.BC-Analytics__Total .section {\n  border-style: solid;\n  border-color: #c4cdd5;\n}\n\n.BC-Analytics__Total {\n  border-width: 1px 0 0 1px;\n  -webkit-border: 4px;\n  -webkit-border: 4px;\n  -moz-border: 4px;\n  -moz-border: 4px;\n  border-radius: 4px;\n}\n\n.BC-Analytics__Total .section {\n  border-width: 0 1px 1px 0;\n}\n\n@media screen and (min-width: 995px) {\n  .BC-Analytics__Total .section:first-child {\n    -webkit-border-top-left-radius: 4px;\n    -webkit-border-bottom-left-radius: 4px;\n    -moz-border-radius-topleft: 4px;\n    -moz-border-radius-bottomleft: 4px;\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n\n  .BC-Analytics__Total .section:last-child {\n    -webkit-border-top-right-radius: 4px;\n    -webkit-border-bottom-right-radius: 4px;\n    -moz-border-radius-topright: 4px;\n    -moz-border-radius-bottomright: 4px;\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n}\n\n@media screen and (max-width: 994px) {\n  .BC-Analytics__Total .section:first-child {\n    -webkit-border-top-left-radius: 4px;\n    -webkit-border-top-right-radius: 4px;\n    -moz-border-radius-topleft: 4px;\n    -moz-border-radius-topright: 4px;\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n  }\n\n  .BC-Analytics__Total .section:last-child {\n    -webkit-border-bottom-right-radius: 4px;\n    -webkit-border-bottom-left-radius: 4px;\n    -moz-border-radius-bottomright: 4px;\n    -moz-border-radius-bottomleft: 4px;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n}\n\n.BC-Analytics__Filter {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: center;\n  margin: 24px 0;\n  gap: 16px;\n}\n\n.BC-Analytics__Filter.BC-Analytics__Filter--turbo {\n  margin: 0;\n}\n\n.BC-Analytics__Filter.BC-Analytics__Filter--turbo > .Polaris-Stack {\n  order: 2;\n}\n\n.BC-Analytics__Filter div.filter-collection {\n  flex: 0 1 12.5rem;\n  min-width: 0;\n}\n\n.BC-Analytics__Filter .separator {\n  margin: auto 0.75rem;\n}\n\n.BC-Analytics__Filter .Polaris-Button__Text {\n  font-weight: 400;\n}\n\n.BC-Analytics__Filter .date-select-picker button {\n  padding: 0 1.25rem 0 1.5rem;\n}\n\n.BC-Analytics__Filter .date-select-picker .Polaris-Button__Text {\n  margin-left: 0.75rem;\n}\n\n.BC-Analytics__Filter .date-select-picker .compare-time {\n  margin-left: 0.5rem;\n}\n\n.BC-Analytics__Filter .freemium-export-locked {\n  display: flex;\n  gap: 4px;\n  margin-left: 8px;\n}\n\n.BC-Analytics__Filter .freemium-export-locked:hover {\n  cursor: pointer;\n}\n\n.BC-Analytics__Filter .freemium-export-locked > div {\n  background: rgba(255, 242, 217, 1);\n  padding: 0px 1px 0px 1px;\n  border-radius: 4px 0px 0px 0px;\n}\n\n.BC-Analytics__Filter .freemium-export-locked span {\n  color: rgba(44, 110, 203, 1);\n  font-weight: 500;\n}\n\n.open-link-text .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.open-link-text:hover {\n  text-decoration: underline;\n}\n\n.BC-Analytics__Export-Modal .Polaris-Button__Text {\n  font-weight: 400;\n}\n\n.BC-Analytics__Export-Modal .Polaris-ChoiceList__Choices {\n  display: flex;\n}\n\n.BC-Analytics__Export-Modal .Polaris-ChoiceList__Choices li {\n  margin-right: 1.25rem;\n}\n\n.BC-Analytics__Export-Modal .default-text-style {\n  font-weight: normal !important;\n}\n\n.BC-Page__Analytics .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {\n  justify-content: flex-end;\n}\n\n.BC-Page__Analytics .Polaris-DataTable__Cell .sortable-heading {\n  cursor: pointer;\n  display: inline-flex;\n}\n\n.BC-Page__Analytics .spinner-loading {\n  text-align: center;\n}\n\n.BC-Page__Analytics .analytic-empty {\n  text-align: center;\n  color: var(--p-text-subdued);\n}\n\n.BC-Page__Analytics .Polaris-Page .Polaris-Card .Polaris-Heading {\n  border-bottom: 2px dotted #c4cdd5;\n  display: inline;\n}\n\n.BC-Page__Analytics .Polaris-Page .Polaris-Card .Polaris-Card__Header .Polaris-Stack {\n  flex-wrap: inherit;\n}\n\n.BC-Page__Analytics\n  .Polaris-Page\n  .Polaris-Card\n  .Polaris-Card__Header\n  .Polaris-Stack\n  .Polaris-Stack__Item--fill {\n  margin-right: 1.5rem;\n}\n\n.BC-Page__Analytics .content-compact-title {\n  text-transform: uppercase;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  padding-bottom: 0.5rem;\n}\n\n.BC-Page__Analytics .content-compact-content {\n  display: flex;\n}\n\n.BC-Page__Analytics .content-compact-content .content-compact-content-item {\n  flex: 1 1 50%;\n}\n\n.BC-Page__Analytics .content-compact-content .content-compact-content-item.first {\n  margin-right: 2.5rem;\n}\n\n.BC-Page__Analytics .content-compact-content table {\n  counter-reset: serial-number;\n}\n\n.BC-Page__Analytics .content-compact-content table .item-first-col > div,\n.BC-Page__Analytics .content table .item-first-col .range + div {\n  overflow: hidden;\n}\n\n.BC-Page__Analytics .content table .item-first-col .range {\n  float: left;\n  margin-right: 5px;\n  float: left;\n}\n\n.BC-Page__Analytics .content-compact-content table .item-options > div {\n  overflow: hidden;\n}\n\n.BC-Page__Analytics .content table .item-options .filter-option {\n  margin-top: 10px;\n}\n\n.BC-Page__Analytics .content table .item-first-col .option {\n  margin-top: 10px;\n}\n\n.BC-Page__Analytics .content table .item-first-col .option:first-child {\n  margin-top: 0;\n}\n\n.BC-Page__Analytics .item-value {\n  color: #43467f;\n  margin-left: 0.625rem;\n  display: inline-block;\n  font-weight: 500;\n}\n\n.BC-Page__Analytics .content table td {\n  word-break: break-all;\n  vertical-align: top;\n}\n\n.BC-Page__Analytics .content-compact-content td {\n  padding-bottom: 0.75rem;\n}\n\n.BC-Page__Analytics .content-compact-content .item-percentage,\n.BC-Page__Analytics .content-compact-content .item-total {\n  width: 20%;\n  text-align: right;\n}\n\n.BC-Page__Analytics .content-detail .item-percentage,\n.BC-Page__Analytics .content-detail .item-total {\n  width: 20%;\n  text-align: center;\n}\n\n.BC-Page__Analytics .content-compact-content .item-percentage .Polaris-Icon,\n.BC-Page__Analytics .content-detail td.item-percentage .Polaris-Icon {\n  display: inline-block;\n  width: 0.6875rem;\n  height: 0.6875rem;\n}\n\n.BC-Page__Analytics .Polaris-DataTable__Cell--header {\n  font-weight: 500;\n}\n\n.BC-Page__Analytics .content-detail .Polaris-DataTable__Cell {\n  padding: 0.875rem 0rem 0.875rem 0;\n  border-bottom: 0.0625rem solid var(--p-divider);\n  vertical-align: middle;\n  word-wrap: break-word;\n  white-space: inherit;\n}\n\n.BC-Page__Analytics .content-detail tr:last-child .Polaris-DataTable__Cell {\n  border-bottom: none;\n}\n\n.BC-Page__Analytics .content-detail .pagination {\n  text-align: center;\n}\n\n.BC-Page__Analytics .content-detail .item-total.item-1 {\n  background-color: var(--p-action-primary);\n  color: #ffffff;\n}\n\n.BC-Page__Analytics .content-detail .item-total.item-2 {\n  background-color: rgba(180, 224, 250, 0.9);\n}\n\n.BC-Page__Analytics .content-detail .item-total.item-3 {\n  background-color: rgba(235, 245, 250, 0.8);\n}\n\n.BC-Analytics__Tabs .summary {\n  line-height: 2rem;\n}\n\n.BC-Analytics__Tabs .summary .total {\n  font-size: 1.75rem;\n  font-weight: 600;\n}\n\n.BC-Analytics__Tabs .summary .percentChange {\n  float: right;\n  font-size: 1.75rem;\n}\n\n.BC-Analytics__Tabs .summary .percentChange.up {\n  color: var(--p-action-primary);\n}\n\n.BC-Analytics__Tabs .summary .percentChange.down {\n  color: #de3618;\n}\n\n.BC-Analytics__Tabs .summary .percentChange .Polaris-Icon {\n  height: 1.5625rem;\n  width: 1.5625rem;\n}\n\n.BC-Analytics__Tabs .Polaris-Card .Polaris-Card__Header .Polaris-ButtonGroup__Item {\n  margin-left: 1rem;\n}\n\n.BC-Analytics__Tabs .Polaris-Card .Polaris-Card__Header .Polaris-Button--plain {\n  padding-left: 0;\n}\n\n.BC-Page__Analytics .BC-Analytics__Settings {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__Analytics .BC-Analytics__Settings .field-title .Polaris-Label .Polaris-Label__Text {\n  font-weight: 500;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.BC-Page__Analytics .Polaris-Page .BC-Analytics__Settings .Polaris-Card .Polaris-Card__Header {\n  padding-bottom: 1.125rem;\n  padding-top: 1.125rem;\n  border-bottom: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page__Analytics .Polaris-Page .BC-Analytics__Settings .Polaris-Card .Polaris-Heading {\n  border-bottom: none;\n}\n\n.BC-Page\n  .BC-Page__SearchAnalytics__SearchesWithoutResults\n  .Polaris-SkeletonDisplayText__DisplayText {\n  max-width: unset;\n}\n\n.BC-Page .BC-Page__SearchAnalytics__SearchesWithoutResults .Polaris-Card__Header,\n.BC-Page .BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-Card__Header,\n.BC-Page .BC-Page__SearchAnalytics__SearchTerms .Polaris-Card__Header {\n  padding-left: 1rem;\n}\n\n.BC-Page .BC-Page__SearchAnalytics__SearchesWithoutResults .Polaris-Card__Section {\n  padding: 0;\n}\n\n.BC-Page .BC-Page__SearchAnalytics__SearchesWithoutResults thead th.Polaris-DataTable__Cell {\n  font-weight: 600;\n}\n\n.BC-Page\n  .BC-Page__SearchAnalytics__SearchesWithoutResults\n  thead\n  th.Polaris-DataTable__Cell\n  .Polaris-DataTable__Heading {\n  font-weight: 600;\n}\n\n.BC-Page .BC-Page__SearchAnalytics__SearchesWithoutResults tbody .Polaris-DataTable__Cell {\n  padding: var(--p-space-2) var(--p-space-4);\n  vertical-align: middle;\n}\n\n.BC-Page\n  .BC-Page__SearchAnalytics__SearchesWithoutResults\n  tbody\n  .Polaris-DataTable__Cell:first-child {\n  width: 400px;\n}\n\n.BC-Page\n  .BC-Page__SearchAnalytics__SearchesWithoutResults\n  tbody\n  .Polaris-DataTable__Cell\n  .Polaris-DataTable__TooltipContent {\n  white-space: normal;\n}\n\n.BC-Page__SearchAnalytics__SearchesWithoutResults .Polaris-DataTable__Icon--custom,\n.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Icon--custom,\n.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Icon--custom,\n.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Icon--custom {\n  display: flex;\n  align-self: flex-end;\n}\n\n.BC-Page__SearchAnalytics__SearchesWithoutResults .Polaris-DataTable__Icon {\n  display: none;\n}\n\n.BC-Page__SearchAnalytics__SearchesWithoutResults\n  .Polaris-DataTable__Cell--sorted\n  .Polaris-DataTable__Icon--custom\n  .Polaris-Icon__Svg,\n.BC-Page__SearchAnalytics__SearchesWithoutClicks\n  .Polaris-DataTable__Cell--sorted\n  .Polaris-DataTable__Icon--custom\n  .Polaris-Icon__Svg,\n.BC-Page__SearchAnalytics__SearchTerms\n  .Polaris-DataTable__Cell--sorted\n  .Polaris-DataTable__Icon--custom\n  .Polaris-Icon__Svg,\n.BC-Page__SearchAnalytics__SearchTermDetail\n  .Polaris-DataTable__Cell--sorted\n  .Polaris-DataTable__Icon--custom\n  .Polaris-Icon__Svg {\n  fill: var(--p-action-primary) !important;\n}\n\n.BC-Page__SearchAnalytics__SearchesWithoutResults__Pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: 24px;\n}\n\n.BC-Page__SearchAnalytics__SearchesWithoutResults__Pagination .Polaris-ButtonGroup__Item {\n  margin-left: 0.75rem;\n}\n\n.BC-Page__SearchAnalytics__SearchesWithoutResults__Pagination .Polaris-Button {\n  background-color: #fff;\n}\n\n.BC-Page__SearchAnalytics__SearchTerms .BC-Link__Dashboard {\n  color: #2c6ecb;\n}\n\n.BC__IgnoreIPs-List {\n  display: flex;\n  list-style-type: none;\n  flex-wrap: wrap;\n  margin: 1.375rem -0.8125rem 0 -0.8125rem;\n  -webkit-padding-start: 0;\n  padding-inline-start: 0;\n}\n\n.BC__IgnoreIPs-Item {\n  flex: 0 0 10rem;\n  background-color: #f4f6f8;\n  display: flex;\n  padding-left: 0.75rem;\n  margin: 0.625rem 0.75rem;\n  align-items: center;\n  border-radius: 5px;\n}\n\n.BC__IgnoreIPs-Item.is-new {\n  background-color: #d7f2ff;\n}\n\n.BC__IgnoreIPs-Item.is-new .BC__IgnoreIPs--Value .Polaris-TextStyle--variationSubdued {\n  color: #084e8a;\n}\n\n.BC__IgnoreIPs-Item.is-new\n  .BC__IgnoreIPs--Remove\n  .Polaris-Button--plain.Polaris-Button--iconOnly\n  svg {\n  fill: #084e8a;\n}\n\n.BC__IgnoreIPs-Item.is-new\n  .BC__IgnoreIPs--Remove\n  .Polaris-Button--plain.Polaris-Button--iconOnly:hover\n  svg,\n.BC__IgnoreIPs-Item.is-new\n  .BC__IgnoreIPs--Remove\n  .Polaris-Button--plain.Polaris-Button--iconOnly:active\n  svg {\n  fill: #212b36;\n}\n\n.BC__IgnoreIPs--Remove {\n  margin-left: auto;\n  line-height: 0;\n}\n\n.BC__IgnoreIPs--Remove .Polaris-Icon {\n  width: 21px;\n  height: 21px;\n}\n\n.BC__IgnoreIPs--Remove .Polaris-Button--plain.Polaris-Button--iconOnly {\n  margin: 0;\n  margin-left: 0.75rem;\n  min-width: 0;\n  min-height: 0;\n  height: 28px;\n  padding: 0 0.25rem;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n\n.BC__IgnoreIPs--Remove:hover .Polaris-Button--plain.Polaris-Button--iconOnly {\n  background-color: #c4cdd5;\n}\n\n.BC__IgnoreIPs-Item.is-new\n  .BC__IgnoreIPs--Remove:hover\n  .Polaris-Button--plain.Polaris-Button--iconOnly {\n  background-color: #b4e0fa;\n}\n\n.BC__IgnoreIPs--Value .Polaris-Caption {\n  font-size: 0.75rem;\n  line-height: 21px;\n  height: 22px;\n}\n\n.BC-chart .Polaris-Heading,\n.BC-analytics-table .Polaris-Heading,\n.BC-chart-table .Polaris-Heading,\n.BC-chart-impact .Polaris-Heading,\n.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-Heading,\n.BC-Page__SearchAnalytics__SearchesWithoutResults .Polaris-Heading,\n.BC-Page__SearchAnalytics__SearchTerms .Polaris-Heading,\n.BC-Page__SearchAnalytics__ProductPerformance .Polaris-Heading,\n.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-Heading,\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-Heading,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-Heading,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-Heading,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-Heading,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-Heading,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-Heading,\n.BC-Page__AnalyticSettings .Polaris-Heading {\n  border-bottom: 3px dotted #dfe3e8;\n  display: inline-block;\n}\n\n.BC-chart-table .BC-chart .Polaris-Heading,\n.BC-chart-table .BC-analytics-table .Polaris-Heading {\n  border-bottom: none;\n}\n\n.BC-chart--transparent .Polaris-Card {\n  background: transparent;\n  box-shadow: none;\n}\n\n.BC-chart .Polaris-Card__Section {\n  padding-top: 12px;\n}\n\n.BC-chart .BC-chart__overall,\n.BC-chart-table .BC-chart__overall,\n.BC-chart-impact .BC-chart__overall,\n.BC-chart-impact .BC-chart-impact__extraData__overall {\n  display: flex;\n  align-items: baseline;\n}\n\n.BC-chart .BC-chart__total,\n.BC-chart-table .BC-chart__total,\n.BC-chart-impact .BC-chart__total {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 32px;\n  color: #202223;\n}\n\n.BC-chart-impact .BC-chart-impact__extraData__total {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 28px;\n}\n\n.BC-Page__AppImpact .total-metrics .BC-chart__percent-growth {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  color: #202223;\n  display: flex;\n  align-items: center;\n}\n\n.BC-chart .BC-chart__percent-growth,\n.BC-chart-table .BC-chart__percent-growth,\n.BC-chart-impact .BC-chart__percent-growth,\n.BC-chart-impact .BC-chart-impact__percent-growth {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  color: #202223;\n  margin-left: 12px;\n  display: flex;\n  align-items: center;\n}\n\n.BC-Page__AppImpact .total-metrics .BC-chart__percent-growth .Polaris-Icon {\n  margin: unset;\n}\n\n.BC-Page__AppImpact .total-metrics .BC-chart__percent-growth--up,\n.BC-chart .BC-chart__percent-growth--up,\n.BC-chart-table .BC-chart__percent-growth--up,\n.BC-chart-impact .BC-chart__percent-growth--up,\n.BC-chart-impact .BC-chart-impact__percent-growth--up {\n  color: #008060;\n}\n\n.BC-Page__AppImpact .total-metrics .BC-chart__percent-growth--up svg path,\n.BC-chart .BC-chart__percent-growth--up svg path,\n.BC-chart-table .BC-chart__percent-growth--up svg path,\n.BC-chart-impact .BC-chart__percent-growth--up svg path,\n.BC-chart-impact .BC-chart-impact__percent-growth--up {\n  fill: #008060;\n}\n\n.BC-Page__AppImpact .total-metrics .BC-chart__percent-growth--down,\n.BC-chart .BC-chart__percent-growth--down,\n.BC-chart-table .BC-chart__percent-growth--down,\n.BC-chart-impact .BC-chart__percent-growth--down,\n.BC-chart-impact .BC-chart-impact__percent-growth--down {\n  color: #d72c0d;\n}\n\n.BC-Page__AppImpact .total-metrics .BC-chart__percent-growth--down svg path,\n.BC-chart .BC-chart__percent-growth--down svg path,\n.BC-chart-table .BC-chart__percent-growth--down svg path,\n.BC-chart-impact .BC-chart__percent-growth--down svg path,\n.BC-chart-impact .BC-chart-impact__percent-growth--down svg path {\n  fill: #d72c0d;\n}\n\n.BC-chart-impact__extraData__wrapper {\n  padding-top: 36px;\n}\n\n.BC-chart-impact__extraData {\n  margin-bottom: 32px;\n}\n\n.BC-chart-impact__extraData:last-child {\n  margin-bottom: 0;\n}\n\n.BC-chart-impact__extraData__title {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  text-transform: uppercase;\n  color: #202223;\n  padding-bottom: 2px;\n  margin-bottom: 10px;\n  border-bottom: 1px dashed #dfe3e8;\n  display: inline-block;\n}\n\n.BC-chart .custom-tooltip .custom-tooltip-title {\n  padding: 8px 10px;\n  background: #eceff1;\n  border-bottom: 1px solid #ddd;\n  font-size: 12px;\n  font-weight: 500;\n  color: #202223;\n}\n\n.BC-chart .custom-tooltip .custom-tooltip-series-group {\n  text-align: left;\n  justify-content: left;\n  align-items: center;\n  padding: 8px 10px;\n  order: 1;\n  display: flex;\n}\n\n.BC-chart .custom-tooltip-marker {\n  margin-right: 6px;\n  border-radius: 50%;\n  width: 12px;\n  height: 12px;\n  position: relative;\n  top: 0;\n}\n\n.BC-chart .custom-tooltip-text {\n  flex-grow: 1;\n}\n\n.BC-chart .custom-tooltip-y-group {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-chart .custom-tooltip-text-y-label {\n  color: #202223;\n  font-weight: 400;\n  font-size: 13px;\n  margin-right: 2.25rem;\n  line-height: 16px;\n}\n\n.BC-chart .custom-tooltip-text-y-value {\n  color: #202223;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 16px;\n}\n\n.BC-chart .apexcharts-legend-marker {\n  top: 1px !important;\n}\n\n.BC-analytics-table .Polaris-DataTable {\n  border: 1px solid #e1e3e5;\n  border-radius: 6px;\n}\n\n.BC-analytics-table--transparent .Polaris-Card {\n  background: transparent;\n  box-shadow: none;\n}\n\n.BC-analytics-table .Polaris-DataTable__Cell--header {\n  font-weight: 500;\n}\n\n.BC-analytics-table--small .Polaris-DataTable__Cell {\n  padding: var(--p-space-3) var(--p-space-4);\n}\n\n.BC-table-product-performance .BC-analytics-table tbody .Polaris-DataTable__Cell {\n  padding: var(--p-space-2) var(--p-space-4);\n  vertical-align: middle;\n}\n\n.BC-table-product-performance .BC-analytics-table .Polaris-DataTable__Cell--firstColumn {\n  width: 56px;\n}\n\n.BC-table-product-performance .BC-analytics-table tr td:nth-child(2) {\n  width: 56px;\n  padding-right: 0;\n}\n\n.BC-table-product-performance .BC-analytics-table tr td:nth-child(2) .Polaris-Thumbnail {\n  margin-left: auto;\n}\n\n.BC-table-product-performance .BC-analytics-table tr td:nth-child(3) {\n  white-space: normal;\n}\n\n.BC-table-product-performance .BC-analytics-table tr td:nth-child(4) {\n  width: 160px;\n}\n\n.BC-chart-table .Polaris-Card__Section,\n.BC-chart-impact .Polaris-Card__Section {\n  padding-top: var(--p-space-3);\n}\n\n.BC-chart-table .BC-chart--transparent .Polaris-Heading,\n.BC-chart-table .BC-analytics-table--transparent .Polaris-Heading {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  text-transform: uppercase;\n}\n\n.BC-chart-table .BC-chart__overall {\n  margin-bottom: var(--p-space-6);\n}\n\n.BC-chart-impact .BC-chart__overall {\n  margin-bottom: var(--p-space-4);\n}\n\n.BC-chart-table .BC-chart .Polaris-Card__Header,\n.BC-chart-table .BC-analytics-table .Polaris-Card__Header,\n.BC-chart-impact .BC-chart .Polaris-Card__Header {\n  padding: 0;\n}\n\n.BC-chart-table .BC-chart .Polaris-Card__Section,\n.BC-chart-table .BC-analytics-table .Polaris-Card__Section,\n.BC-chart-impact .BC-chart .Polaris-Card__Section {\n  padding: var(--p-space-4) 0 0;\n}\n\n.BC-chart-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n}\n\n/* In App */\n\n.BC-Page__Q1-Beta-Features .featureBox .Polaris-Card,\n.BC-Page__Q1-Beta-Features .featureBox .Polaris-Card-Hover {\n  box-shadow: none;\n}\n\n.BC-Page__Q1-Beta-Features .featureIconImg {\n  float: left;\n}\n\n.BC-Page__Q1-Beta-Features .feature .featureBox {\n  padding: 1.25rem;\n}\n\n.BC-Page__Q1-Beta-Features .featureIconImg .Polaris-Icon {\n  width: 24px;\n  height: 24px;\n}\n\n.BC-Page__Q1-Beta-Features .featureContent {\n  display: grid;\n  padding-left: 1.25rem;\n}\n\n.BC-Page__Q1-Beta-Features .BC-Image__Q1-Beta-Features {\n  width: 100%;\n}\n\n.BC-Page__Q1-Beta-Features .Polaris-List {\n  line-height: 24px;\n}\n\n.BC-Page__Q1-Beta-Features .Polaris-Layout__Section--oneThird {\n  flex: 1 1 21.25rem;\n  margin-top: 2rem;\n  align-self: flex-end;\n}\n\n.BC-Autocomplete__TextContainer .Polaris-TextContainer .Polaris-Stack {\n  margin-top: -0.5rem;\n}\n\n.BC-Autocomplete__Wrapper {\n  position: relative;\n}\n\n.BC-Autocomplete__Wrapper .BC-Autocomplete__Backdrop {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 50;\n}\n\n.BC-Draggable__Container,\n.BC-Custom__Container {\n  padding: grid;\n  overflow: auto;\n  white-space: normal;\n  margin-top: 0.25rem;\n}\n\n.BC-Autocomplete__TextContainer .BC-Draggable__Container {\n  max-height: 200px;\n}\n\n.BC-Autocomplete__TextContainer .BC-Draggable__Container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.BC-Autocomplete__TextContainer .BC-Draggable__Container::-webkit-scrollbar-track {\n  background: #ebebeb;\n  border-radius: 4px;\n}\n\n.BC-Autocomplete__TextContainer .BC-Draggable__Container::-webkit-scrollbar-thumb {\n  background: #cccccc;\n  border-radius: 4px;\n}\n\n.BC-Draggable__Tag,\n.BC-Custom__Tag {\n  margin: 0 0.25rem 0.25rem 0;\n  height: 1.375rem;\n  min-height: 1.375rem;\n  font-size: 0.75rem;\n}\n\n.BC-Draggable__Tag {\n  cursor: grab;\n}\n\n.BC-Draggable__Tag:active {\n  cursor: grabbing;\n}\n\n.BC-Draggable__Tag.sortableHelper {\n  cursor: grabbing !important;\n  pointer-events: fill;\n  display: none;\n}\n\n.BC-Draggable__Tag.sortableHelper.isDragging {\n  display: block;\n}\n\n.BC-Draggable__Tag .Polaris-Tag__Button {\n  width: 1.5625rem;\n  height: 1.5625rem;\n  margin-left: 0;\n  cursor: inherit;\n}\n\n.BC-Draggable__Tag .Polaris-Tag__Button:hover,\n.BC-Custom__Tag .Polaris-Tag__Button:hover {\n  background: none;\n}\n\n.BC-Draggable__Tag .Polaris-Tag__Button .Polaris-Icon {\n  width: 0.9375rem;\n  height: 0.9375rem;\n}\n\n.BC-Draggable__Tag button svg {\n  fill: #212b36;\n}\n\n.BC-Custom__Container {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.BC-Custom__ButtonMore .Polaris-Button {\n  min-height: 1.25rem;\n  padding: 0 0.5rem;\n  margin: 0 -0.5rem;\n}\n\n/* Metafield */\n.BC-Page__Metafield .Polaris-DataTable__Cell:first-child {\n  width: 30%;\n}\n\n.BC-Page__Metafield .Polaris-DataTable__Cell:nth-child(2) {\n  width: 30%;\n}\n\n.BC-Page__Metafield .addNew {\n  padding: 1.25rem;\n  border-top: 0.0625rem solid var(--p-divider);\n  text-align: right;\n}\n\n.BC-Page__Metafield .addNew .Polaris-Button__Text {\n  font-weight: 600;\n}\n\n.BC-Modal__Metafield .Polaris-FormLayout__Item .appliesTo_Name {\n  margin-bottom: 5px;\n}\n\n.BC-Modal__Metafield .analytics-select-popover button {\n  margin-top: 5px;\n}\n\n.BC-Modal__Metafield .switch-input-mode {\n  margin-top: 5px;\n}\n\n.BC-Page__Metafield .BC-Page__Bottom-Text {\n  margin-top: 1.5rem;\n}\n\n.BC-Modal__Metafield .error-message {\n  display: inline-flex;\n}\n\n.BC-Modal__Metafield .error-message span:first-child {\n  margin-right: 5px;\n}\n\n.Polaris-ActionList__Actions:has(.metafield-modal-popover-item) li:first-child {\n  background-color: #f1f1f1;\n}\n\n.Polaris-ActionList__Actions:has(.metafield-modal-popover-item) li:first-child p {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  color: #616161;\n}\n\n.BC-Page__Metafield .Polaris-List .Polaris-List__Item,\n.BC-Page__Dashboard .notification .Polaris-List .Polaris-List__Item {\n  margin-bottom: 0;\n}\n\n.BC-Page__Metafield .BC-BaseBanner {\n  margin-bottom: 0;\n}\n\n.BC-Page__Dashboard .liveThemeV2Banner .Polaris-List {\n  list-style-type: '- ';\n  list-style-position: inside;\n  padding-left: 0;\n}\n\n.BC-Page__Dashboard .liveThemeV2Banner .Polaris-List__Item {\n  margin: 0;\n}\n\n.BC-Page__Dashboard .liveThemeV2Banner .Polaris-Banner {\n  padding-right: 16px;\n}\n\n#BC-Banner__LiveThemeV2Info ul {\n  margin: 0;\n  padding-left: 0.625rem;\n  padding-right: 0;\n  list-style-type: '- ';\n}\n\n#BC-Banner__LiveThemeV2Info ul > li::marker {\n  font-weight: 600;\n}\n\n/* Custom range slider */\n.BC-Page__CustomRangeSlider .Polaris-DataTable__Cell:first-child {\n  width: 40%;\n}\n\n.BC-Page__CustomRangeSlider .addNew {\n  padding: 1.25rem;\n  border-top: 0.0625rem solid var(--p-divider);\n  text-align: right;\n}\n\n.BC-Page__CustomRangeSlider .addNew .Polaris-Button__Text {\n  font-weight: 600;\n}\n\n.BC-Modal__CustomRangeSlider .Polaris-FormLayout__Item:last-child {\n  margin-top: 5px;\n}\n\n.BC-Page__CustomRangeSlider .BC-Page__Bottom-Text {\n  margin-top: 1.5rem;\n}\n\n.BC-Modal__CustomRangeSlider .groupFields > div {\n  margin-top: 1.25rem;\n}\n\n.BC-Page__CustomRangeSlider .Polaris-TextStyle--variationCode {\n  font-size: 12px;\n}\n\n/* Product visibility */\n.BC-Page__Product-Visibility .Polaris-DataTable__Cell:first-child {\n  width: 42%;\n}\n\n.BC-Page__Product-Visibility .Polaris-DataTable__Cell:nth-child(2) {\n  width: 44%;\n}\n\n.BC-Page__Product-Visibility .addNew {\n  text-align: right;\n  padding: 1.25rem;\n  border-top: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page__Product-Visibility .addNew .Polaris-Button__Text {\n  font-weight: 600;\n}\n\n.BC-Product-Visibility .Polaris-FormLayout__Item:last-child {\n  margin-top: 5px;\n}\n\n.BC-Page__Product-Visibility .BC-Page__Bottom-Text {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__Product-Visibility .Polaris-List .Polaris-List__Item {\n  margin-bottom: 0;\n}\n\n/* Custom sorting */\n.BC-Page__CustomSorting .Polaris-PageActions {\n  border-top: none;\n}\n\n.BC-Page__CustomSorting .addNew {\n  padding: 1.25rem;\n  border-top: 0.0625rem solid var(--p-divider);\n  text-align: right;\n}\n\n.BC-Page__CustomSorting .addNew .Polaris-Button__Text {\n  font-weight: 600;\n}\n\n.BC-Page__CustomSorting .BC-Page__Bottom-Text {\n  margin-top: 1.5rem;\n}\n\n.BC-Modal__CustomSorting .groupFields > div {\n  margin-top: 1.25rem;\n}\n\n.BC-Page__CustomSorting .groupFields .groupFields-item {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__CustomSorting .groupFields .groupFields-item .groupFields-item-child {\n  margin-top: 8px;\n  margin-left: 1.8125rem;\n}\n\n.BC-Page__CustomSorting .Polaris-TextStyle--variationCode {\n  font-size: 12px;\n}\n\n.BC-Page__CustomSorting .Polaris-DataTable__Cell:first-child {\n  width: 5%;\n  padding-left: 1.25rem;\n  padding-right: 0;\n}\n\n.BC-Page__CustomSorting .Polaris-DataTable__Cell:nth-child(2) {\n  width: 10%;\n  padding-left: 0.9375rem;\n}\n\n.BC-Page__CustomSorting .Polaris-DataTable__Cell:nth-child(3) {\n  width: 25%;\n}\n\n.BC-Page__CustomSorting .Polaris-DataTable__Cell:nth-child(4) {\n  width: 25%;\n}\n\n.BC-Page__CustomSorting .Polaris-DataTable__Cell:nth-child(5) {\n  width: 25%;\n}\n\n.BC-Page__CustomSorting .Polaris-DataTable__Cell:nth-child(6) {\n  width: 111px;\n  text-align: center;\n}\n\n.BC-Page__CustomSorting .Polaris-DataTable__TableRow--disabled .label-disabled {\n  display: flex;\n  color: rgba(189, 193, 204, 1);\n  gap: 4px;\n}\n\n.BC-Page__CustomSorting .Polaris-DataTable__TableRow--disabled .label-disabled .Polaris-Badge {\n  background: rgba(255, 242, 217, 1);\n  color: rgba(255, 51, 69, 1);\n  border-radius: 4px;\n  font-weight: 600;\n  opacity: 50%;\n}\n\n.BC-Page__CustomSorting\n  .Polaris-DataTable__TableRow--disabled\n  .Polaris-DataTable__Cell:nth-child(4) {\n  color: rgba(140, 145, 150, 1);\n}\n\n.BC-Page__CustomSorting\n  .Polaris-DataTable__TableRow--disabled\n  .Polaris-DataTable__Cell:nth-child(4)\n  .Polaris-Icon\n  svg {\n  fill: rgba(186, 190, 195, 1);\n}\n\n.BC-Page__CustomSorting\n  .Polaris-DataTable__TableRow--disabled\n  .Polaris-DataTable__Cell-Action\n  .Polaris-Button__Text {\n  display: flex;\n  gap: 4px;\n}\n\n.BC-Page__CustomSorting\n  .Polaris-DataTable__TableRow--disabled\n  .Polaris-DataTable__Cell-Action\n  button {\n  padding: 5px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  color: rgba(32, 34, 35, 1);\n}\n\n.BC-Page__CustomSorting\n  .Polaris-DataTable__TableRow--disabled\n  .Polaris-DataTable__Cell:first-child\n  .Polaris-Icon\n  svg {\n  fill: rgba(186, 190, 195, 1);\n}\n\n.BC-Page__CustomSorting\n  .Polaris-DataTable__TableRow--disabled\n  .label-disabled\n  .Polaris-Badge\n  > span {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-Page__CustomSorting .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {\n  justify-content: flex-end;\n}\n\n.BC-Page__CustomSorting\n  .Polaris-PageActions\n  .Polaris-Stack--distributionEqualSpacing\n  > .Polaris-Stack__Item {\n  margin-left: 1rem;\n}\n\n.BC-Page__CustomSorting .BC-DataTable__CollectionDefaultSort {\n  padding: 0 1.25rem;\n  border: 1px solid var(--p-divider);\n}\n\n.BC-Page__CustomSorting .BC-DataTable__CollectionDefaultSort .Polaris-DataTable__Cell:first-child {\n  width: 150px;\n}\n\n.BC-Page__CustomSorting .BC-DataTable__CollectionDefaultSort .Polaris-DataTable__Cell:nth-child(2) {\n  width: auto;\n}\n\n.BC-Page__CustomSorting .BC-DataTable__CollectionDefaultSort .Polaris-DataTable__Cell:last-child {\n  width: 110px;\n}\n\n.BC-Page__CustomSorting .BC-DataTable__CollectionDefaultSort .collections {\n  overflow: auto;\n  white-space: normal;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.BC-Page__CustomSorting .BC-DataTable__CollectionDefaultSort .collections {\n}\n\n/* Feedback at the bottom*/\n.BC-Page__Analytics,\n.BC-Page__FilterTree-Management,\n.BC-Page__Integration,\n.BC-Page__Product-Visibility,\n.BC-Page__Metafield,\n.BC-Page__CustomRangeSlider,\n.BC-Page__CustomSorting {\n  margin-bottom: 2.5rem;\n}\n\n.BC-Page__Page__Redirect-New,\n.BC-Page__Merchandising .noRules {\n  margin-bottom: 1.25rem;\n}\n\n.BC-Bottom__Feedback {\n  display: flex;\n  justify-content: center;\n  padding-bottom: 5rem;\n  margin-top: 4rem;\n}\n\n.BC-Bottom__Feedback > div.feedback {\n  display: flex;\n  align-items: center;\n  padding: 12px 23px 12px 12px;\n  box-sizing: border-box;\n  border-radius: 31px;\n}\n\n.BC-Bottom__Feedback\n  > div.feedback\n  .Polaris-Button--plain\n  > .Polaris-Button__Content\n  .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  height: 0.9rem;\n  width: 1rem;\n}\n\n.BC-Bottom__Feedback .icon {\n  margin-right: 3px;\n  padding: 7px;\n  border-radius: 50%;\n}\n\n.BC-Bottom__Feedback .icon .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.BC-Bottom__Feedback .icon .Polaris-Icon svg {\n  fill: #00a0ac;\n}\n\n/* Landing page */\n.BC-Page__Landing-Page .Polaris-Card__Header {\n  padding-bottom: 1.125rem;\n  padding-top: 1.125rem;\n  border-bottom: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page__Landing-Page .feature {\n  padding-bottom: 1.25rem;\n}\n\n.BC-Page__Landing-Page .feature .Polaris-Layout,\n.BC-Page__Landing-Page .feature .Polaris-Layout .Polaris-Layout__Section {\n  margin-top: 0;\n}\n\n.BC-Page__Landing-Page .feature .featureBox {\n  padding: 1.25rem 1.25rem 0 1.25rem;\n}\n\n.BC-Page__Landing-Page .featureIconImg {\n  float: left;\n}\n\n.BC-Page__Landing-Page .featureIconImg .Polaris-Icon {\n  width: 24px;\n  height: 24px;\n}\n\n.BC-Page__Landing-Page .featureContent {\n  display: grid;\n  padding-left: 1.25rem;\n}\n\n.BC-Page__Landing-Page .BC-Image__Landing-Page {\n  width: 100%;\n}\n\n.BC-Page__Landing-Page .summary {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__Landing-Page .summary p {\n  font-size: 1rem;\n}\n\n.BC-Page__Landing-Page .summary .Polaris-List {\n  line-height: 24px;\n  font-size: 1rem;\n}\n\n.BC-Page__Landing-Page .summary .Polaris-List__Item {\n  margin-bottom: 0rem;\n}\n\n.BC-Page__Landing-Page .Polaris-Layout__Section--oneThird {\n  flex: 1 1 21.25rem;\n  margin-top: 2rem;\n  align-self: flex-end;\n}\n\n.BC-Page__Landing-Page .feature .Polaris-Heading {\n  font-size: 0.875rem;\n}\n\n/* Theme upgrade */\n.BC-Page__Theme-Upgrade .upgrade-progress {\n  display: flex;\n  align-items: center;\n}\n\n.BC-Page__Theme-Upgrade .upgrade-progress .Polaris-ProgressBar {\n  width: 12.5rem;\n}\n\n.BC-Page__Theme-Upgrade .upgrade-progress .upgrade-inline-text {\n  margin-left: 16px;\n}\n\n.BC-Page__Theme-Upgrade .tooltip {\n  margin: 0;\n  vertical-align: baseline;\n}\n\n.BC-Page__Theme-Upgrade .RenderSelect2__Wrapper {\n  width: 358px;\n}\n\n.BC-Page__Theme-Upgrade .Polaris-SkeletonDisplayText__DisplayText {\n  max-width: unset;\n}\n\n.BC-Page__Theme-Upgrade__Option2 .Polaris-ChoiceList__Title {\n  margin-bottom: 12px;\n}\n\n.BC-Page__Theme-Upgrade__Option2 .Polaris-ChoiceList__Choices li:not(:first-child) {\n  margin-top: 12px;\n}\n\n.BC-Page__Theme-Upgrade\n  .Polaris-Page\n  > div:not(.Polaris-Page-Header)\n  > .Polaris-Layout\n  > .Polaris-Layout__Section\n  > .Polaris-Card {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__Theme-Upgrade .Polaris-Page-Header__RightAlign,\n.BC-Page_Success .Polaris-Page-Header__RightAlign {\n  display: flex;\n  align-items: center;\n}\n\n@media (max-width: 400px) {\n  .BC-Page__Theme-Upgrade .RenderSelect2__Wrapper {\n    width: 220px;\n  }\n}\n\n/* Swatch settings */\n.BC-Page__SwatchSettings\n  .Polaris-Page\n  .Polaris-Card\n  .Polaris-Card__Header\n  .Polaris-Stack\n  .Polaris-Stack__Item--fill {\n  display: none;\n}\n\n.BC-Page__SwatchSettings\n  .Polaris-Page\n  .Polaris-Card\n  .Polaris-Card__Header\n  .Polaris-Stack\n  .Polaris-Stack__Item {\n  width: 100%;\n}\n\n.BC-Page__SwatchSettings .search {\n  display: flex;\n  min-width: 262px;\n}\n\n.BC-Page__SwatchSettings .search > div:first-child {\n  width: calc(100% - 165px);\n}\n\n.BC-Page__SwatchSettings .searchOption {\n  margin-top: -0.625rem;\n}\n\n.BC-Page__SwatchSettings .searchOption .item {\n  display: inline-flex;\n  background-color: #e4e5e7;\n  padding: 4px 8px;\n  border-radius: 2px;\n  font-weight: 500;\n}\n\n.BC-Page__SwatchSettings .searchOption .item .value {\n  padding-right: 0.75rem;\n}\n\n.BC-Page__SwatchSettings .Polaris-DataTable__Cell {\n  padding: 0.9375rem 0.78125rem;\n}\n\n.BC-Page__SwatchSettings tbody .Polaris-DataTable__Cell {\n  border-top: 1px solid var(--p-divider);\n  border-bottom: none;\n  white-space: normal;\n}\n\n.BC-Page__SwatchSettings tbody tr:first-child .Polaris-DataTable__Cell {\n  border-top: none;\n}\n\n.BC-Page__SwatchSettings .Polaris-DataTable__Cell.sortable-heading,\n.BC-Page__SwatchSettings .searchOption .item .remove {\n  cursor: pointer;\n}\n\n.BC-Page__SwatchSettings .Polaris-DataTable__Cell.sortable-heading:hover {\n  color: var(--p-action-primary);\n}\n\n.BC-Page__SwatchSettings .Polaris-DataTable__Cell.sortable-heading > span {\n  display: inline-flex;\n}\n\n.BC-Page__SwatchSettings .Polaris-DataTable__Cell:first-child {\n  width: 5%;\n  padding-left: 1.25rem;\n  padding-right: 0;\n}\n\n.BC-Page__SwatchSettings .Polaris-DataTable__Cell:nth-child(2) {\n  width: 25%;\n  padding-left: 0.9375rem;\n  word-break: break-word;\n}\n\n.BC-Page__SwatchSettings .Polaris-DataTable__Cell:nth-child(3) {\n  width: 25%;\n}\n\n.BC-Page__SwatchSettings .actionsGroup {\n  position: absolute;\n  right: 0px;\n  top: 0px;\n}\n\n.BC-Page__SwatchSettings .swatch-color {\n  width: 31px;\n  height: 32px;\n  border: 1px solid var(--p-divider);\n}\n\n.BC-Page__SwatchSettings .Polaris-TextField__Input {\n  padding-right: 0.6875rem;\n}\n\n.BC-Page__SwatchSettings .selectedColor {\n  background-color: #fff;\n  z-index: 417;\n  width: 25px;\n  height: 25px;\n  margin-right: 0;\n  border-radius: 3px;\n  margin-left: 0.75rem;\n}\n\n.BC-EmptySwatch {\n  margin: 2.5rem 0;\n}\n\n.BC-Page__SwatchSettings .colorCode .Polaris-Stack .Polaris-Stack__Item {\n  max-width: calc(50% - 1rem);\n}\n\n.swatchActionList {\n  margin-left: 0.625rem;\n  margin-right: 0.9375rem;\n}\n\n.swatchActionList .Polaris-Button {\n  width: 168px;\n}\n\n.Polaris-ActionList__Title {\n  font-size: 0.875rem;\n  font-weight: normal;\n  text-transform: none;\n}\n\n.Polaris-ActionList__Actions {\n  border-top: none;\n}\n\n/* Sync page */\n.BC-Page__SyncOverview .Polaris-Page-Header__Row .Polaris-Button--primary {\n  background-color: #ffff !important;\n  border: 1px solid #babfc3;\n  color: #000;\n}\n\n.BC-Page__Sync .did-you-know .Polaris-List__Item {\n  margin-bottom: 0;\n}\n\n.BC-Page__Sync .unlock-addon {\n  width: fit-content;\n  height: 40px;\n  padding: 10px 12px;\n}\n\n.BC-Page__Sync .unlock-addon:hover {\n  cursor: pointer;\n  background-color: #fcecdb;\n}\n\n.BC-Page__Sync .unlock-addon .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.BC-Sync__Content .Polaris-TextContainer > * {\n  margin-top: 1.25rem;\n}\n\n.BC-Sync__Content .sync-select {\n  max-width: 100%;\n}\n\n.BC-Sync__Content .sync-select div .Polaris-Select {\n  min-width: 465px;\n  margin-right: 16px;\n}\n\n.BC-Sync__Content .progress-status {\n  display: flex;\n  align-items: center;\n  margin-right: -1.25rem;\n}\n\n.BC-Sync__Content .progress-bar {\n  flex-basis: 40%;\n  margin-right: 0.5rem;\n}\n\n.BC-Sync__Content .progress-name {\n  margin-top: 12px;\n}\n\n.BC-Sync__Content .step-name {\n  font-size: 12px;\n  line-height: 18px;\n}\n\n.BC-Sync__Content .step-name .tooltip {\n  margin-left: 2px;\n  margin-right: 7px;\n  margin-top: 4px;\n}\n\n.BC-Sync__Content .progress-step-item {\n  margin: 1.25rem 0;\n}\n\n.BC-Sync__Content .progress-step-item .Polaris-Icon {\n  float: left;\n  margin-right: 8px;\n}\n\n.BC-Sync__Content .button-sync {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.BC-Sync__Content .button-sync div.button {\n  min-width: 13.125rem;\n}\n\n.BC-Sync__Content .button-sync button {\n  max-height: 2.25rem;\n}\n\n.BC-Sync__Content .button-sync .Polaris-Caption {\n  margin-left: 1rem;\n  /* color: var(--p-interactive); */\n  font-size: 12px;\n  line-height: 18px;\n}\n\n.BC-Sync__Content .special-sync-banner {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0.5rem;\n  box-shadow:\n    0px 0px 0px rgba(63, 63, 68, 0.05),\n    0px 1px 3px rgba(63, 63, 68, 0.15);\n  border-radius: 4px;\n}\n\n.BC-Sync__Content .special-sync-error {\n  background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #fcf1cd;\n}\n\n.BC-Sync__Content .special-sync-success {\n  background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #e3f1df;\n}\n\n.BC-Sync__Content .special-sync-banner span {\n  margin-left: 0.9375rem;\n}\n\n.BC-Sync__Content .recent-sync {\n  margin-top: 12px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.BC-Sync__Content .completed-icon {\n  width: 14px;\n  height: 14px;\n  margin-right: 0.3125rem;\n  padding: 0;\n}\n\n.BC-Sync__Content .groupFields-flex-2 {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  margin-left: -1rem;\n}\n\n.BC-Sync__Content .groupFields-flex-2 > div {\n  max-width: 100%;\n  flex: 1 0 100%;\n  padding-left: 1rem;\n}\n\n.BC-Sync__Content .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {\n  justify-content: flex-end;\n}\n\n/* time select */\n.time-select .BC-Select__control .Select__Prefix {\n  margin-left: 0.75rem;\n}\n\n.time-select .BC-Select__control .Select__Prefix svg {\n  fill: var(--p-icon);\n}\n\n.time-select .BC-Select__control.BC-Select__control--is-disabled .Select__Prefix svg {\n  fill: var(--p-icon-disabled);\n}\n\n.BC-Sync__Content .Polaris-Badge--statusCritical .status-icon {\n  background: var(--p-icon-critical);\n}\n\n.BC-Sync__Content .Polaris-Badge--statusSuccess .status-icon {\n  background: var(--p-icon-success);\n}\n\n@media screen and (min-width: 1200px) {\n  .BC-Sync__Content .groupFields-flex-2 > div {\n    flex: 0 1 50%;\n  }\n}\n\n/* Language setting page*/\n.BC-Language-Setting__Content .language-setting-select {\n  max-width: 164px;\n}\n\n/* Support ticket form */\n.BC-Dropzone-Box {\n  padding-top: 1.25rem;\n}\n\n.BC-Dropzone-ChooseFiles {\n  padding-bottom: 0.9375rem;\n}\n\n.BC-Dropzone-Box .tooltip {\n  margin-top: 9px;\n  margin-left: 5px;\n  display: -webkit-inline-flex;\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.search-fields-footer .external-link,\n.BC-Page__Theme-Setup .external-link,\n.BC-AnotherLayout .external-link {\n  display: -webkit-inline-flex;\n  display: inline-flex;\n  margin-left: -5px;\n  vertical-align: top;\n}\n\n.BC-SupportTicket__Form .BC-Dropzone-Box {\n  padding-top: 0.1875rem;\n}\n\n.BC-SupportTicket__Form .BC-Dropzone-ChooseFiles {\n  padding-bottom: 0;\n}\n\n.BC-SupportTicket__Form .attachFiles .Polaris-Button--sizeSlim {\n  margin-left: 0.9375rem;\n}\n\n.BC-SupportTicket__Form .Polaris-DropZone__Container {\n  cursor: default;\n  padding: 0.625rem;\n}\n\n.BC-SupportTicket__Form\n  .Polaris-DropZone__Container\n  .Polaris-Stack\n  > .Polaris-Stack__Item\n  .Polaris-Stack__Item:nth-child(2) {\n  width: 400px;\n}\n\n.BC-SupportTicket__Form .Polaris-DropZone::after {\n  content: '';\n  position: absolute;\n  z-index: 29;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  border: 0.0625rem dashed #ccc;\n  border-radius: 3px;\n  pointer-events: none;\n}\n\n/* DefaultThemeSettings_Dropzone .Polaris-DropZone::after {\n  content: '';\n  position: absolute;\n  z-index: 29;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  border: 0.0625rem dashed #fafbfb;\n  border-radius: 3px;\n  pointer-events: none;\n} */\n\n.BC-DefaultThemeSettings_Dropzone .Polaris-DropZone--hasOutline {\n  background-color: #fafbfb;\n}\n\n@media (max-width: 46.5em) {\n  /* Override 2 columns for translation page*/\n  .BC-Page__Translation .tabContent .Polaris-Stack__Item,\n  .BC-Page__Translation .tabContent .Polaris-Stack__Item:last-child {\n    width: 100%;\n    float: none;\n  }\n}\n\n/* Typeform survey */\n.button-feedback-survey {\n  position: fixed;\n  top: calc(50% - 250px);\n  right: 0;\n  transition: width 300ms ease-out;\n  width: 0;\n}\n\n.button-feedback-survey a {\n  box-sizing: border-box;\n  position: absolute;\n  top: 300px;\n  width: 200px;\n  height: 48px;\n  padding: 0 20px;\n  margin: 0;\n  cursor: pointer;\n  background: #fa6b05;\n  border-radius: 4px 4px 0px 0px;\n  box-shadow:\n    0px 2px 12px rgba(0, 0, 0, 0.06),\n    0px 2px 4px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  transform: rotate(-90deg);\n  transform-origin: bottom left;\n  color: white;\n  text-decoration: none;\n  z-index: 9999;\n}\n\n.button-feedback-survey a .icon {\n  width: 32px;\n  position: relative;\n  text-align: center;\n  transform: rotate(90deg) scale(0.85);\n  left: -8px;\n}\n\n.button-feedback-survey a .text {\n  text-decoration: none;\n  font-size: 18px;\n  font-family: Helvetica, Arial, sans-serif;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n  text-align: center;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Default theme settings */\n.BC-Default-Theme-Settings .groupFields-label {\n  margin-bottom: -10px;\n}\n\n.BC-Default-Theme-Settings .groupFields-content > div {\n  margin-top: 1rem;\n}\n\n.BC-Default-Theme-Settings .groupFields-content > div:first-child {\n  margin-top: 0rem;\n}\n\n.BC-Default-Theme-Settings\n  .groupFields-label\n  .Polaris-Button\n  .Polaris-Button__Content\n  .Polaris-Button__Icon {\n  order: -1;\n  margin-left: -5px;\n  margin-right: 5px;\n}\n\n.BC-Default-Theme-Settings .previewPanel .title {\n  border-bottom: 0.0625rem solid var(--p-divider);\n  padding-top: 1rem;\n  padding-bottom: 0.75rem;\n}\n\n.BC-Default-Theme-Settings .previewPanel .Polaris-Labelled__LabelWrapper {\n  justify-content: center;\n}\n\n.BC-Default-Theme-Settings .previewPanel .device {\n  margin: 1.25rem auto;\n  text-align: center;\n}\n\n.BC-Default-Theme-Settings .previewPanel .device > div > span {\n  display: flex;\n}\n\n.BC-Default-Theme-Settings .previewPanel .device > div > span:focus {\n  outline: none;\n}\n\n.BC-Default-Theme-Settings .previewPanel .device > div > span .icon:hover {\n  cursor: pointer;\n}\n\n.BC-Default-Theme-Settings .previewPanel .icons {\n  display: inline-flex;\n}\n\n.BC-Default-Theme-Settings .previewPanel .icons .active {\n  border: 2px solid var(--p-action-primary);\n}\n\n.BC-Default-Theme-Settings .previewPanel .icon.first {\n  margin-right: 1.5rem;\n}\n\n.BC-Default-Theme-Settings .previewPanel .icon {\n  border: 2px solid #919eab;\n  border-radius: 3px;\n  padding: 8px 10px;\n}\n\n.BC-Default-Theme-Settings .previewPanel .preview-content {\n  padding: 0 1.25rem;\n}\n\n.BC-Default-Theme-Settings .BC-Default-Theme-Settings__General,\n.BC-Default-Theme-Settings .BC-Default-Theme-Settings__ProductItem {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: flex-start;\n  margin: 0;\n}\n\n.BC-Default-Theme-Settings .BC-Default-Theme-Settings__General > div,\n.BC-Default-Theme-Settings .BC-Default-Theme-Settings__ProductItem > div {\n  width: calc(100% - 1.25rem);\n  flex: 2 2 30rem;\n}\n\n.BC-Default-Theme-Settings .BC-Default-Theme-Settings__General > div {\n  height: 43.75rem;\n  overflow-y: auto;\n}\n\n.BC-Default-Theme-Settings .BC-Default-Theme-Settings__ProductItem .settings-content-tab {\n  height: 43.75rem;\n  overflow-y: auto;\n}\n\n.BC-Default-Theme-Settings .BC-Default-Theme-Settings__General .settings-content {\n  flex: 1 1 13.75rem;\n  min-width: 0;\n  border-right: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Default-Theme-Settings .BC-Default-Theme-Settings__ProductItem .settings-content {\n  flex: 1 1 35.75rem;\n  min-width: 0;\n  border-right: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Default-Theme-Settings .BC-Default-Theme-Settings__ProductItem .preview.product-tab {\n  flex: 1 1 22.625rem;\n}\n\n.BC-Default-Theme-Settings\n  .BC-Default-Theme-Settings__ProductItem\n  .settings-content.product-list-tab {\n  flex: 1 1 26.75rem;\n}\n\n.BC-Default-Theme-Settings .BC-Default-Theme-Settings__General .settings-content,\n.BC-Default-Theme-Settings .BC-Default-Theme-Settings__ProductItem .settings-content-tab {\n  padding: 1rem 1.25rem 2.5rem;\n}\n\n.BC-Default-Theme-Settings .BC-Default-Theme-Settings__General .settings-content::-webkit-scrollbar,\n.BC-Default-Theme-Settings\n  .BC-Default-Theme-Settings__ProductItem\n  .settings-content-tab::-webkit-scrollbar {\n  width: 8px;\n}\n\n.BC-Default-Theme-Settings\n  .BC-Default-Theme-Settings__General\n  .settings-content::-webkit-scrollbar-track,\n.BC-Default-Theme-Settings\n  .BC-Default-Theme-Settings__ProductItem\n  .settings-content-tab::-webkit-scrollbar-track {\n  background: #ebebeb;\n}\n\n.BC-Default-Theme-Settings\n  .BC-Default-Theme-Settings__General\n  .settings-content::-webkit-scrollbar-thumb,\n.BC-Default-Theme-Settings\n  .BC-Default-Theme-Settings__ProductItem\n  .settings-content-tab::-webkit-scrollbar-thumb {\n  background: #cccccc;\n  border-radius: 4px;\n}\n\n.BC-Default-Theme-Settings .BC-Default-Theme-Settings__General .settings-content ul li {\n  margin-bottom: 0.75rem;\n}\n\n.BC-Default-Theme-Settings .BC-Default-Theme-Settings__General .settings-content ul li:last-child {\n  margin-bottom: 0rem;\n}\n\n.BC-Default-Theme-Settings .breakLine {\n  border-top: 1px solid var(--p-divider);\n}\n\n.BC-Default-Theme-Settings .groupFields-content .Polaris-Stack--vertical {\n  flex-wrap: nowrap;\n}\n\n.BC-Default-Theme-Settings .Polaris-PageActions .Polaris-Stack--distributionEqualSpacing {\n  justify-content: flex-end;\n}\n\n.BC-Default-Theme-Settings .Polaris-FormLayout .Polaris-FormLayout__Item {\n  margin-top: 1.25rem;\n}\n\n.BC-Default-Theme-Settings\n  .Polaris-FormLayout\n  .Polaris-FormLayout__Item\n  .Polaris-Labelled__LabelWrapper {\n  margin-bottom: 0;\n}\n\n.BC-Default-Theme-Settings .Polaris-FormLayout .Polaris-ChoiceList__Choices {\n  margin-bottom: -0.25rem;\n}\n\n.BC-Default-Theme-Settings .Polaris-FormLayout .Polaris-Choice__Label .Polaris-Label {\n  padding-bottom: 0rem;\n}\n\n.BC-Default-Theme-Settings .Polaris-FormLayout .Polaris-Label {\n  padding-bottom: 0.25rem;\n}\n\n.BC-Default-Theme-Settings .Polaris-FormLayout .Polaris-Button .Polaris-Label {\n  padding-bottom: 0;\n}\n\n.BC-Default-Theme-Settings\n  .Polaris-FormLayout\n  .Polaris-Button\n  .tooltip\n  .Polaris-Icon--colorBase\n  svg {\n  fill: var(--p-icon);\n}\n\n.BC-Default-Theme-Settings .Polaris-FormLayout .sectionLabel .Polaris-Label {\n  padding-bottom: 0.5rem;\n}\n\n.BC-Default-Theme-Settings .groupFields-flex-2,\n.BC-Default-Theme-Settings .render-choice-flex-3 ul {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  margin-left: -1rem;\n}\n\n.BC-Default-Theme-Settings .groupFields-flex-2 > div,\n.BC-Default-Theme-Settings .render-choice-flex-3 ul li {\n  max-width: 100%;\n  flex: 1 0 100%;\n  padding-left: 1rem;\n}\n\n@media screen and (min-width: 1200px) {\n  .BC-Default-Theme-Settings .groupFields-flex-2 > div {\n    flex: 0 1 50%;\n  }\n\n  .BC-Default-Theme-Settings .render-choice-flex-3 ul li {\n    flex: 0 1 33.33%;\n  }\n}\n\n.BC-Default-Theme-Settings .range-slider-input .Polaris-Connected > div:first-child,\n.BC-Widget-Editor-Page .range-slider-input .Polaris-Connected > div:first-child {\n  align-self: center;\n}\n\n.BC-Default-Theme-Settings .range-slider-input .Polaris-Connected > div:last-child {\n  margin-left: 0.375rem;\n  width: 4.5rem;\n  max-width: 4.5rem;\n}\n\n.BC-Default-Theme-Settings .range-slider-input .Polaris-Connected > div:first-child {\n  width: 288px;\n}\n\n.BC-Default-Theme-Settings\n  .groupFields-flex-2\n  .range-slider-input\n  .Polaris-Connected\n  > div:last-child {\n  width: 4rem;\n  max-width: 4rem;\n}\n\n.BC-Default-Theme-Settings\n  .groupFields-flex-2\n  .range-slider-input\n  .Polaris-Connected\n  > div:first-child {\n  width: 180px;\n}\n\n.BC-Default-Theme-Settings .subText {\n  margin-top: 6px;\n}\n\n.BC-Default-Theme-Settings #product-item-tab .Polaris-Layout__Section--oneThird {\n  flex: 1 1 20.875rem;\n}\n\n@media (min-width: 30.625em) {\n  .BC-Illustration-Image__Dashboard {\n    display: block;\n  }\n\n  .BC-Page__Dashboard .menuBox .Polaris-Card {\n    box-shadow: none;\n    min-height: 5.75rem;\n  }\n\n  .BC-Page__Dashboard .menuBox .Polaris-Card-Hover {\n    background-color: #f4f6f8;\n    min-height: 5.75rem;\n    box-shadow: none;\n  }\n\n  .BC-Page__Dashboard .BC-Iframe-Container__Wrapper {\n    margin-bottom: 0.75rem;\n    margin-top: 1.375rem;\n  }\n\n  .BC-ThemeSetup__DashboardV3 .Polaris-Card,\n  .BC-CalloutCard-ThemeSetup__Dashboard .Polaris-Card,\n  .BC-CalloutCard-Subscription__Dashboard .Polaris-Card,\n  .BC-CalloutCard-ExpReviewRating__Dashboard .Polaris-Card {\n    min-height: 162px;\n  }\n\n  .BC-CalloutCard-ThemeSetup__Dashboard .firstCol {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    padding-right: 1rem;\n  }\n\n  .BC-ThemeSetup__DashboardV3 .secondCol,\n  .BC-CalloutCard-ThemeSetup__Dashboard .secondCol {\n    display: flex;\n    justify-self: flex-end;\n  }\n\n  .BC-CalloutCard-ExpReviewRating__Dashboard .secondCol {\n    position: absolute;\n    left: 257px;\n    top: 0.75rem;\n  }\n\n  .BC-CalloutCard-ExpReviewRating__Dashboard .secondCol.lowRating {\n    position: absolute;\n    left: 257px;\n  }\n\n  .BC-ThemeSetup__DashboardV3 .secondCol img {\n    width: 140px;\n  }\n\n  .BC-CalloutCard-ThemeSetup__Dashboard .secondCol img {\n    width: 148px;\n  }\n\n  .BC-CalloutCard-ExpReviewRating__Dashboard .firstCol {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    padding-right: 0.375rem;\n  }\n\n  .BC-CalloutCard-ExpReviewRating__Dashboard .secondCol img {\n    width: 164px;\n  }\n\n  .BC-CalloutCard-ExpReviewRating__Dashboard .Polaris-FormLayout .Polaris-TextField textarea {\n    height: 60px !important;\n  }\n\n  .BC-CalloutCard-ExpReviewRating__Dashboard .Polaris-TextContainer > *:not(:first-child) {\n    margin-top: 9px;\n  }\n\n  /* Filter tree page */\n  .BC-Page__FilterTree-Item .Polaris-Page-Header__Actions {\n    margin-top: 0;\n  }\n\n  .BC-DataTable__FilterOptions {\n    margin: -1.25rem;\n  }\n\n  /* Filter tree page: Action on page header */\n  .BC-Page__FilterTree-Item .Polaris-Header-Title__TitleAndSubtitleWrapper {\n    max-width: 85%;\n  }\n\n  .BC-Page__FilterTree-Item .Polaris-Header-Title__TitleAndSubtitleWrapper:empty {\n    margin-top: 2rem;\n  }\n\n  /* Theme setup */\n  .BC-Page__Theme-Setup .Polaris-ResourceList__ResourceListWrapper {\n    margin: -1.25rem;\n  }\n\n  /* Merge values */\n  .BC-DataTable__MergeValuesOptions,\n  .BC-DataTable__MergeValues {\n    margin: -1.25rem;\n  }\n\n  /* Instant search display */\n  .BC-Page__InstantSearchDisplay .BC-Page__Fields,\n  .BC-Page__SearchSettings .BC-Page__Fields {\n    margin-top: -1.25rem;\n  }\n\n  .BC-Page__InstantSearchDisplay .BC-Page__Fields > div.tabs {\n    margin: 1.25rem -1.25rem -1.25rem;\n  }\n\n  /* Stop word */\n  .BC__StopWords-Add .Polaris-Stack .Polaris-Stack__Item:first-child {\n    flex: 0 0 21.5rem;\n  }\n\n  /* In app */\n  .BC-Page__Q1-Beta-Features .featureBox .Polaris-Card {\n    box-shadow: none;\n    min-height: 100px;\n  }\n\n  .BC-Page__Q1-Beta-Features .featureBox .Polaris-Card-Hover {\n    background-color: #f4f6f8;\n    min-height: 100px;\n    box-shadow: none;\n  }\n\n  .BC-Page__Q1-Beta-Features .feature {\n    display: table;\n  }\n\n  .BC-Page__Q1-Beta-Features .feature .featureBox {\n    display: table-cell;\n    width: 50%;\n  }\n\n  .BC-Analytics__Total .section {\n    padding: 1rem;\n  }\n\n  /* Search setting */\n\n  .BC-Page__SearchSettings .btn-reset {\n    position: absolute;\n    right: 1.25rem;\n    top: 1.0625rem;\n  }\n\n  /* Custom sorting */\n  .BC-Page__CustomSorting .addNew.top {\n    position: absolute;\n    right: 1.25rem;\n    top: 1.0625rem;\n    border-top: none;\n    padding: 0;\n  }\n\n  /* Translation */\n  .BC-Page__Translation .search {\n    padding: 1.25rem 1.25rem 0.75rem;\n  }\n}\n\n@media (min-width: 29.0625rem) {\n  .BC-Page__Button-HasBreadcrumb {\n    top: 2.875rem;\n  }\n}\n\n/* Custom cuss for Preview filte tree*/\n.bc-sf-filter-preview-inner {\n  padding: 1.5rem;\n  height: 300px;\n}\n\n#bc-sf-filter-tree:not(.bc-sf-filter-tree-mobile-open) {\n  display: inherit !important;\n}\n\n.bc-sf-filter-preview-inner:not(.bc-sf-filter-mobile-wrapper) #bc-sf-filter-tree {\n  display: block;\n}\n\n#bc-sf-filter-tree .bc-sf-filter-option-block .bc-sf-filter-block-title {\n  position: relative;\n  overflow: inherit;\n}\n\n.bc-sf-filter-mobile-wrapper #bc-sf-filter-tree {\n  display: none;\n}\n\n.bc-sf-filter-mobile-wrapper #bc-sf-filter-tree-mobile,\n.bc-sf-filter-mobile-wrapper\n  .bc-sf-filter-block-content\n  .bc-sf-filter-option-range-slider.no-ruler\n  .noUi-marker-normal {\n  display: block !important;\n}\n\n#bc-sf-filter-tree.hide {\n  display: none !important;\n}\n\n#bc-sf-filter-tree-h .bc-sf-filter-option-block .bc-sf-filter-block-content {\n  position: inherit;\n  width: 900px;\n}\n\n.bc-sf-filter-block-content .noUi-connect {\n  width: auto !important;\n}\n\n.bc-sf-filter-block-content .noUi-horizontal .noUi-origin {\n  z-index: 5;\n}\n\n#bc-sf-filter-tree .bc-sf-filter-option-block .bc-sf-filter-block-content ul li a,\n#bc-sf-filter-tree-h .bc-sf-filter-option-block .bc-sf-filter-block-content ul li a,\n#bc-sf-filter-tree-h .bc-sf-filter-option-block .bc-sf-filter-block-title a {\n  color: #3d4246;\n}\n\n#bc-sf-filter-tree-h .bc-sf-filter-option-block .bc-sf-filter-block-title a {\n  display: inline-block;\n  padding-top: 7px;\n  margin-bottom: 5px;\n  font-weight: 700;\n}\n\n#bc-sf-filter-tree-h .bc-sf-filter-option-single-list,\n#bc-sf-filter-block-content-my-tag {\n  width: 100% !important;\n}\n\n.bc-sf-filter-option-block-sub_category h3 {\n  font-size: 1.25em;\n}\n\n.bc-sf-filter-option-block-sub_category .bc-sf-filter-option-single-list ul {\n  padding-left: 1.25rem;\n}\n\n.previewPanel .overflow-vertical {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.previewPanel .overflow-horizontal {\n  overflow-x: auto;\n  overflow-y: auto;\n}\n\n#bc-sf-filter-tree-h .bc-sf-filter-option-view-more,\n#bc-sf-filter-tree-h .bc-sf-filter-option-view-less {\n  display: none;\n}\n\n.bc-sf-filter-tooltip-wrapper {\n  z-index: 9999;\n}\n\n.bc-sf-filter-option-view-less,\n.bc-sf-filter-option-view-more {\n  color: #3d4246;\n}\n\n.bc-sf-filter-option-block .bc-sf-filter-block-content .bc-sf-filter-option-swatch li a {\n  position: relative;\n}\n\n.bc-sf-filter-option-swatch-image {\n  z-index: 10;\n  position: relative;\n}\n\n.bc-sf-filter-option-swatch-image + span {\n  content: '';\n  background-image: url('https://cdn.boostcommerce.io/assets/filter-tree/bc-sf-filter-no-image-2.png');\n  display: block !important;\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  top: 0;\n  left: 0px;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  background-size: cover;\n  border-radius: 50%;\n  z-index: 5;\n}\n\n.bc-sf-filter-option-block\n  .bc-sf-filter-block-content\n  .bc-sf-filter-option-swatch\n  li\n  a:hover\n  .bc-sf-filter-option-swatch-image\n  + span {\n  border: 2px solid #000;\n}\n\n.bc-sf-filter-option-block\n  .bc-sf-filter-block-content\n  .bc-sf-filter-option-box\n  li\n  .bc-sf-filter-option-amount {\n  margin: 0;\n}\n\n#bc-sf-filter-tree\n  .bc-sf-filter-option-block[data-show-more-type*='scrollbar']\n  .bc-sf-filter-block-content {\n  max-height: 220px;\n}\n\n.bc-sf-filter-option-show-search-box {\n  padding: 10px;\n  width: 100%;\n  border: 1px solid #e3e3e3;\n  height: 30px;\n  line-height: 30px;\n}\n\n.bc-sf-filter-option-block[data-show-search-box-pc='true']\n  .bc-sf-filter-option-show-search-box-wrapper,\n.bc-sf-filter-option-block[data-show-search-box-mobile='true']\n  .bc-sf-filter-option-show-search-box-wrapper {\n  margin-top: 15px;\n}\n\n@media (min-width: 40em) {\n  .BC-Page__Merge-Value .Polaris-DisplayText .Polaris-Button__Content {\n    font-size: 1.25rem;\n    line-height: 1.75rem;\n  }\n\n  .Polaris-SkeletonDisplayText--sizeSmall {\n    height: 1.5rem;\n  }\n\n  .Polaris-Header-Title {\n    font-size: 1.75rem;\n  }\n}\n\n@media (max-width: 56.5em) {\n  /* Override 2 columns for translation page*/\n  .BC-Page__Translation .Polaris-Stack__Item {\n    margin-left: 0.9375rem;\n  }\n}\n\n@media (min-width: 48em) {\n  .Polaris-DataTable__TableRow.hover .Polaris-DataTable__Cell {\n    background: #f9fafb;\n    background: var(--p-surface-hovered, #f9fafb);\n  }\n}\n\n@media (max-width: 48.0525em) {\n  .Polaris-Modal-Dialog__Modal {\n    bottom: 0;\n    max-height: calc(100vh - 100px);\n    margin-bottom: 85px;\n  }\n}\n\n/* PFSN-3806 */\n.Polaris-Popover--measuring .Polaris-Popover__Content {\n  display: flex !important;\n}\n\n/* Youtube modal */\n#youtubeModal-Backdrop {\n  position: fixed;\n  z-index: 519;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  background: rgba(33, 43, 54, 0.4);\n}\n\n#youtubeModal-Content {\n  position: relative;\n  display: flex;\n  background-color: black;\n}\n\n#youtubeModal-Button {\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate(50%, -50%);\n  padding: 0;\n  background: none;\n  border: none;\n  min-width: unset;\n  min-height: unset;\n  cursor: pointer;\n}\n\n#youtubeModal-Button img {\n  width: 28px;\n  height: auto;\n}\n\n/* Polaris V6 */\n.Polaris-Header-Title__TitleWithMetadataWrapper {\n  align-items: baseline;\n}\n\n.cardTitle {\n  display: flex;\n  align-items: baseline;\n}\n\n.Polaris-Badge--statusInfo {\n  font-size: 0.75rem;\n}\n\n.subscribe_badge .Polaris-Badge--statusInfo,\n.planStatus .Polaris-Badge--statusInfo {\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--p-text);\n}\n\n.Container--flexHorizontal {\n  display: flex;\n  flex-direction: row;\n}\n\n.Container--flexVertical {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.Polaris-Page-Header {\n  padding-top: 2.5rem;\n}\n\n.Polaris-Icon--colorWhite svg {\n  fill: white;\n}\n\n.BC-Page__Verify-Setup .Polaris-Card__Header {\n  padding: 1.5rem 1.5rem 0;\n}\n\n.BC-Page__Verify-Setup .Polaris-Card__Section {\n  padding: 1.5rem;\n}\n\n.BC-Page__Verify-Setup .Polaris-Stack > .Polaris-Stack__Item {\n  display: flex;\n}\n\n.BC-Page__Verify-Setup .Polaris-Stack > .Polaris-Stack__Item:not(:first-child) {\n  margin-top: 1.5rem;\n}\n\n.BC-Page__Verify-Setup .Polaris-FormLayout__Item:not(:first-child) {\n  margin-top: 1.5rem;\n}\n\n.BC-page_Demographic .Polaris-Card__Header {\n  padding: 1.5rem 1.5rem 0;\n}\n\n.BC-page_Demographic .Polaris-FormLayout__Item:not(:first-child) {\n  margin-top: 1.5rem;\n}\n\n.BC-page_Demographic .Polaris-Card__Section {\n  padding: 1.5rem;\n}\n\n.BC-page_Demographic .Polaris-Card__Footer {\n  padding: 0 1.5rem 1.5rem;\n}\n\n.SelectIndustries .SelectIndustries__value-container {\n  /* custom-select-kind-service: select */\n  min-height: 56px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.SelectIndustries .SelectIndustries__control {\n  /* custom-select-kind-service: border when not focus */\n  border: 1px solid #a1a3ad !important;\n  border-radius: 8px !important;\n}\n\n.SelectIndustries .SelectIndustries__control--menu-is-open {\n  /* custom-select-kind-service: border when focus */\n  border-color: #ff3000 !important;\n  box-shadow: 0 0 0 1px #ff3000 !important;\n}\n\n.SelectIndustries .SelectIndustries__menu-list > div {\n  /* custom-select-kind-service: item of list */\n  height: 40px;\n  padding: 0 10px 0 5px;\n}\n\n.SelectIndustries .SelectIndustries__menu-list .tag-wrapper {\n  /* custom-select-kind-service: label when show popover */\n  display: flex;\n  height: 40px;\n  align-items: center;\n  padding-left: 5px;\n}\n\n.SelectIndustries .SelectIndustries__option {\n  /* custom-select-kind-service: remove bg when use key up or down */\n  background: unset !important;\n}\n\n.SelectIndustries .SelectIndustries__option--is-focused .tag-wrapper,\n.SelectIndustries .SelectIndustries__option:hover .tag-wrapper {\n  /* custom-select-kind-service: mouse on item */\n  background: #ffefeb;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.SelectIndustries .SelectIndustries__multi-value {\n  /* custom-select-kind-service: tag selected */\n  padding: 6px 8px;\n  gap: 8px;\n  background: #f1f2f3;\n  border-radius: 4px;\n  font-weight: 400;\n  font-size: 16px;\n}\n\n.SelectIndustries .SelectIndustries__multi-value .SelectIndustries__multi-value__remove:hover {\n  /* custom-select-kind-service: tag icon remove selected */\n  background: none;\n}\n\n.SelectIndustries .SelectIndustries__multi-value .SelectIndustries__multi-value__remove svg {\n  /* custom-select-kind-service: tag icon remove */\n  fill: white;\n  border-radius: 50%;\n  background: #5c5f62;\n  cursor: pointer;\n}\n\n.SelectIndustries .SelectIndustries__indicators {\n  /* custom-select-kind-service: hide action */\n  display: none !important;\n}\n\n.SelectRevenue .SelectRevenue__control {\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.SelectRevenue .SelectRevenue__value-container {\n  height: 48px;\n}\n\n.SelectRevenue .SelectRevenue__placeholder {\n  color: #292929;\n}\n\n.SelectRevenue .SelectRevenue__control--is-focused {\n  border-color: #ff3000 !important;\n  box-shadow: 0 0 0 1px #ff3000 !important;\n}\n\n.SelectRevenue .SelectRevenue__indicators {\n  display: none;\n}\n\n.SelectRevenueWrapper {\n  position: relative;\n}\n\n.SelectRevenueWrapper .down-icon {\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n\n.SelectRevenueWrapper .down-icon .Polaris-Icon {\n  width: 30px;\n  height: 30px;\n}\n\n.SelectRevenue .SelectRevenue__menu-list > div {\n  /* custom-select-kind-service: item of list */\n  height: 40px;\n  padding: 0 10px 0 5px;\n}\n\n.SelectRevenue .SelectRevenue__menu-list .tag-wrapper {\n  /* custom-select-kind-service: label when show popover */\n  display: flex;\n  height: 40px;\n  align-items: center;\n  padding-left: 5px;\n}\n\n.SelectRevenue .SelectRevenue__option--is-focused {\n  /* custom-select-kind-service: remove bg when use key up or down */\n  background: unset !important;\n}\n\n.SelectRevenue .tag-wrapper {\n  border-radius: 4px;\n}\n\n.SelectRevenue .SelectRevenue__option--is-focused .tag-wrapper,\n.SelectRevenue .SelectRevenue__option:hover .tag-wrapper {\n  /* custom-select-kind-service: mouse on item */\n  background: #ffefeb;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.SelectRevenue .SelectRevenue__option--is-selected .tag-wrapper {\n  background-color: #ff8366 !important;\n}\n\n.SelectRevenue .SelectRevenue__option.SelectRevenue__option--is-selected:hover .tag-wrapper {\n  background-color: #f16243 !important;\n}\n\n.SelectRevenue .SelectRevenue__option.SelectRevenue__option--is-selected {\n  background: none !important;\n}\n\n.feedback-form .Polaris-ChoiceList__Title {\n  margin-bottom: 0.5rem;\n}\n\nbody:has(* .ModalRedirect) .Polaris-Modal-Dialog__Modal .Polaris-Modal-CloseButton {\n  display: none;\n}\n\n.feedback-form .Polaris-ChoiceList__Title {\n  margin-bottom: 0.5rem;\n}\n\n.feedback-form .Polaris-ChoiceList__Choices > li:not(:last-child) > .Polaris-Choice > * {\n  margin-bottom: 0.75rem;\n}\n\n.BC-Welcome__Dashboard .Polaris-Layout__Section {\n  margin-top: 1rem;\n}\n\n#BC-Container__Empty {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n#BC-Container__Empty img {\n  width: 9.25rem;\n}\n\n#BC-Container__Empty .Polaris-EmptyState__ImageContainer {\n  padding-bottom: 2rem;\n}\n\n/* Fix language */\n.BC__Lang-en .BC-Page__Subscription .BC_DataTable_Plans th.Polaris-DataTable__Cell:last-child {\n  padding: 0.625rem 2.25rem;\n}\n\n/* React tooltip */\n.extraTooltipClass {\n  pointer-events: auto !important;\n  padding: 0 !important;\n  font-size: inherit !important;\n  opacity: 1 !important;\n}\n\n.extraTooltipClass:hover {\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n.extraTooltipClass::after,\n.extraTooltipClass::before {\n  content: none !important;\n}\n\n.extraTooltipClass.place-top {\n  margin-top: -5px !important;\n}\n\n.select-with-tooltip-option > span {\n  display: block;\n  margin: -8px -12px;\n  padding: 8px 12px;\n}\n\n.select-with-tooltip-option .extraTooltipClass {\n  width: 198px;\n  padding: 8px;\n  margin-left: 20px !important;\n}\n\n.select-with-tooltip-option .extraTooltipClass img {\n  width: 100%;\n}\n\n.visual-editor-right-panel .extraTooltipClass {\n  width: 198px;\n  padding: 8px;\n  margin-left: 20px !important;\n}\n\n.visual-editor-right-panel .extraTooltipClass img {\n  width: 100%;\n}\n\n.proceedUpdatePermissionBtn .Polaris-Link {\n  color: white !important;\n}\n\n.render-choice-2 {\n  padding-bottom: 1.1875rem;\n}\n\n.render-choice-2 .Polaris-ChoiceList__Choices li {\n  display: flex;\n}\n\n.render-choice-2 .Polaris-ChoiceList__Choices .Polaris-ChoiceList__ChoiceChildren {\n  padding: 0;\n}\n\n.ReactCollapse--collapse {\n  transition: height 300ms;\n}\n\n.BC-Page__SearchAnalytics .BC-Page__Search_ActionSearchTermDetail {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n/* Revert theme survey flow v2 */\n.BC-Page__SearchAnalytics .BC-Page__Search_ActionSearchTermDetail__Title {\n  margin-right: 10px;\n}\n\n/**/\n\n.BC-Page__SearchAnalytics .BC-Page__Search_ActionSearchTermDetail {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.BC-Page__SearchAnalytics .BC-Page__Search_ActionSearchTermDetail__Title {\n  margin-right: 10px;\n}\n\n.BC-Page__SearchAnalytics .BC-Page__SearchAnalytics__SearchTermDetail__Pagination {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 24px;\n}\n\n.BC-Page__SearchAnalytics .BC-Page__SearchAnalytics__SearchTermDetail__Pagination > div.empty {\n  width: 200px;\n}\n\n.BC-Page__SearchAnalytics .BC-Page__SearchAnalytics__ProductPerformance__Pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: 24px;\n}\n\n.BC-Page__CollectionAnalytics .BC-Page__CollectionAnalytics__CollectionPerformance__Pagination,\n.BC-Page__CollectionAnalytics .BC-Page__CollectionAnalytics__FilterOptionValue__Pagination,\n.BC-Page__CollectionAnalytics\n  .BC-Page__CollectionAnalytics__FilterOptionValueCombination__Pagination,\n.BC-Page__RecommendationAnalytics .BC-Page__RecommendationAnalytics__Top__Page__Pagination,\n.BC-Page__RecommendationAnalytics .BC-Page__RecommendationAnalytics__Top__Widget__Pagination,\n.BC-Page__RecommendationAnalytics .BC-Page__RecommendationAnalytics__Top__Product__Pagination,\n.BC-Page__PreOrderAnalytics .BC-Page__PreOrderAnalytics__Top__Product__Pagination,\n.BC-Page__PreOrderAnalytics .BC-Page__PreOrderAnalytics__Top__Product__Pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: 24px;\n}\n\n.BC-Page__SearchAnalytics .BC-Page__Search_ActionSearchTermDetail .Polaris-Button {\n  margin-right: 10px;\n  width: 40px;\n}\n\n.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Cell--header {\n  font-weight: 500 !important;\n  border-bottom: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Cell--header {\n  font-weight: 500 !important;\n  border-bottom: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Cell--header div {\n  font-weight: 500;\n}\n\n.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Cell {\n  vertical-align: middle;\n}\n\n.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Cell:first-child {\n  width: 60%;\n}\n\n.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Cell:nth-child(2) {\n  width: 20%;\n}\n\n.BC-Page__SearchAnalytics__SearchTerms thead .Polaris-DataTable__Cell:last-child {\n  text-align: right;\n}\n\n.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Cell--header div {\n  font-weight: 500;\n}\n\n.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Cell {\n  vertical-align: middle;\n}\n\n.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Cell:first-child {\n  width: 60%;\n}\n\n.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Cell:nth-child(2) {\n  width: 20%;\n  text-align: end;\n}\n\n.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Cell:nth-child(3) {\n  width: 20%;\n  text-align: end;\n}\n\n.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Cell:nth-child(3) {\n  width: 20%;\n  text-align: end;\n}\n\n.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Icon > .Polaris-Icon {\n  display: none;\n}\n\n.BC-Page__SearchAnalytics__SearchTerms .header-with-sortable {\n  display: flex;\n}\n\n.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Navigation {\n  display: none;\n}\n\n.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Navigation {\n  display: none;\n}\n\n.BC-Page__SearchAnalytics__SearchTermDetail .product-image {\n  width: 40px;\n  height: 40px;\n  padding-bottom: 40px;\n  position: relative;\n  border: 1px solid var(--p-divider);\n  border-radius: 4px;\n  box-sizing: border-box;\n  display: flex;\n}\n\n.BC-Page__SearchAnalytics__SearchTermDetail .product-image img,\n.BC-Page__SearchAnalytics__ProductPerformance .product-image img,\n.BC-Page__SearchAnalytics__ProductPerformance .product-image img {\n  position: absolute;\n  max-width: 100%;\n  max-height: 100%;\n  border-radius: 4px;\n  display: block;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n\n.BC-Page__SearchAnalytics__SearchTerms .Polaris-DataTable__Heading:focus,\n:hover {\n  outline: none;\n}\n\n.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Cell--header {\n  font-weight: 500 !important;\n  border-bottom: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Cell--header div {\n  font-weight: 500;\n}\n\n.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Cell {\n  vertical-align: middle;\n}\n\n.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Cell:first-child {\n  width: 48px;\n  padding-right: 0.5rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Cell:nth-child(2) {\n  width: 60%;\n  padding-left: 0.5rem;\n}\n\n.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Cell:nth-child(2) button {\n  margin-left: 0;\n  padding-left: 0;\n}\n\n.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Icon > .Polaris-Icon {\n  display: none;\n}\n\n.BC-Page__SearchAnalytics__SearchTermDetail .header-with-sortable {\n  display: flex;\n}\n\n.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-DataTable__Heading:focus,\n:hover {\n  outline: none;\n}\n\n.BC-Page__SearchAnalytics__SearchTermDetail__DidYouKnow .did-you-know p {\n  margin-bottom: 10px;\n}\n\n.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Icon > .Polaris-Icon {\n  display: none;\n}\n\n.BC-Page__SearchAnalytics__SearchesWithoutClicks .header-with-sortable {\n  display: flex;\n}\n\n.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-DataTable__Heading:focus,\n:hover {\n  outline: none;\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Navigation {\n  display: none;\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance .Polaris-Card__Footer {\n  padding-top: 15px;\n  border-top: var(--p-border-divider);\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance .action-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 16px;\n  height: 64px;\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance .cell-value-table {\n  text-align: right;\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance .product-image {\n  width: 40px;\n  height: 40px;\n  padding-bottom: 40px;\n  position: relative;\n  border: 1px solid var(--p-divider);\n  border-radius: 4px;\n  box-sizing: border-box;\n  display: flex;\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Cell--header {\n  font-weight: 500 !important;\n  border-bottom: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Cell--header div {\n  font-weight: 500;\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Cell {\n  vertical-align: middle;\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Cell:first-child {\n  width: 48px;\n  padding-right: 0.5rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Cell:nth-child(2) {\n  width: 60%;\n  padding-left: 0.5rem;\n  max-width: 200px;\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Cell:nth-child(2) > div {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Cell:nth-child(2) button {\n  margin-left: 0;\n  padding-left: 0;\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Cell:nth-child(2) button {\n  margin-left: 0;\n  padding-left: 0;\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance th.Polaris-DataTable__Cell:last-child > div {\n  text-align: right;\n  display: block;\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Icon > .Polaris-Icon {\n  display: none;\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance .header-with-sortable {\n  display: flex;\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance .Polaris-DataTable__Heading:focus,\n:hover {\n  outline: none;\n}\n\n.BC-Page__SearchAnalytics__ProductPerformance__DidYouKnow .did-you-know p {\n  margin-bottom: 10px;\n}\n\n/* Collection analytic */\n\n.CollectionAnalyticActionList button.Polaris-Button {\n  width: 100%;\n}\n\n.CollectionAnalyticActionList button.Polaris-Button .Polaris-Button__Content {\n  /* Style for export collection modal when choose collection */\n  display: flex;\n  justify-content: space-between;\n}\n\n.CollectionAnalyticActionList__Search {\n  margin: 10px 10px 0;\n}\n\n.CollectionAnalyticActionList__Popup {\n  width: 420px;\n  height: 314px;\n}\n\n.CollectionAnalyticActionList__Popup .Polaris-ActionList__Item.Polaris-ActionList--active::before {\n  background-color: #008060;\n}\n\n.CollectionAnalyticActionList__Popup .Polaris-ActionList__Item.Polaris-ActionList--active {\n  background-color: #f1f8f5;\n}\n\n.CollectionAnalyticActionList__Popup .Polaris-ActionList__Suffix {\n  display: none;\n}\n\n.CollectionAnalyticActionList__Popup .Polaris-TextField {\n  --p-focused: #008060;\n}\n\n.BC-Page__SearchAnalytics__SearchTerms .Polaris-TextStyle--variationSubdued,\n.BC-Page__SearchAnalytics__SearchTermDetail .Polaris-TextStyle--variationSubdued,\n.BC-Page__SearchAnalytics__SearchesWithoutClicks .Polaris-TextStyle--variationSubdued,\n.BC-Page__SearchAnalytics__SearchesWithoutResults .Polaris-TextStyle--variationSubdued,\n.BC-Page__SearchAnalytics__ProductPerformance .Polaris-TextStyle--variationSubdued,\n.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-TextStyle--variationSubdued,\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-TextStyle--variationSubdued,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-TextStyle--variationSubdued,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-TextStyle--variationSubdued,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-TextStyle--variationSubdued,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-TextStyle--variationSubdued,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-TextStyle--variationSubdued {\n  color: black;\n}\n\n.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Navigation,\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Navigation,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-DataTable__Navigation {\n  display: none;\n}\n\n/* .BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Navigation,\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Navigation,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-DataTable__Navigation,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Navigation,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Navigation,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Navigation {\n  display: none;\n} */\n\n.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-Card__Footer,\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-Card__Footer,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-Card__Footer,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-Card__Footer,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-Card__Footer,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-Card__Footer,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-Card__Footer {\n  padding-top: 15px;\n  border-top: var(--p-border-divider);\n}\n\n.BC-Page__CollectionAnalytics__CollectionPerformance .action-header,\n.BC-Page__CollectionAnalytics__FilterOptionValue .action-header,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .action-header,\n.BC-Page__RecommendationAnalytics__Top__Page .action-header,\n.BC-Page__RecommendationAnalytics__Top__Widget .action-header,\n.BC-Page__RecommendationAnalytics__Top__Product .action-header,\n.BC-Page__PreOrderAnalytics__Top__Product .action-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 16px;\n  height: 64px;\n}\n\n.BC-Page__CollectionAnalytics__CollectionPerformance .cell-value-table,\n.BC-Page__CollectionAnalytics__FilterOptionValue .cell-value-table,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .cell-value-table,\n.BC-Page__RecommendationAnalytics__Top__Page .cell-value-table,\n.BC-Page__RecommendationAnalytics__Top__Widget .cell-value-table,\n.BC-Page__RecommendationAnalytics__Top__Product .cell-value-table,\n.BC-Page__PreOrderAnalytics__Top__Product .cell-value-table {\n  text-align: right;\n}\n\n.BC-Page__CollectionAnalytics__CollectionPerformance .product-image,\n.BC-Page__CollectionAnalytics__FilterOptionValue .product-image,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .product-image,\n.BC-Page__RecommendationAnalytics__Top__Page .product-image,\n.BC-Page__RecommendationAnalytics__Top__Widget .product-image,\n.BC-Page__RecommendationAnalytics__Top__Product .product-image {\n  width: 40px;\n  height: 40px;\n  padding-bottom: 40px;\n  position: relative;\n  border: 1px solid var(--p-divider);\n  border-radius: 4px;\n  box-sizing: border-box;\n  display: flex;\n}\n\n.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Cell--header,\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Cell--header,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-DataTable__Cell--header,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell--header,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell--header,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell--header,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell--header {\n  font-weight: 500 !important;\n  border-bottom: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Cell--header div,\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Cell--header div,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-DataTable__Cell--header div,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell--header div,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell--header div,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell--header div,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell--header div {\n  font-weight: 500;\n}\n\n.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Cell,\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Cell,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-DataTable__Cell,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell {\n  vertical-align: middle;\n}\n\n.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Cell:first-child,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell:first-child,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell:first-child,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell:first-child,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:first-child {\n  width: 60%;\n  padding-right: 0.5rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Cell:first-child,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-DataTable__Cell:first-child,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell:first-child,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell:first-child,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell:first-child,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:first-child {\n  width: 80%;\n  padding-right: 0.5rem;\n}\n\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Cell:last-child,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-DataTable__Cell:last-child,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell:last-child,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell:last-child,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell:last-child,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:last-child {\n  text-align: right;\n}\n\n.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Cell:nth-child(2) > div,\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Cell:nth-child(2) > div,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination\n  .Polaris-DataTable__Cell:nth-child(2)\n  > div,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell:nth-child(2) > div,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell:nth-child(2) > div,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(2) > div,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(2) > div {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Cell:nth-child(2) button,\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Cell:nth-child(2) button,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination\n  .Polaris-DataTable__Cell:nth-child(2)\n  button,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell:nth-child(2) button,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell:nth-child(2) button,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(2) button,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(2) button {\n  margin-left: 0;\n  padding-left: 0;\n}\n\n.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Cell:nth-child(2) button,\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Cell:nth-child(2) button,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination\n  .Polaris-DataTable__Cell:nth-child(2)\n  button,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Cell:nth-child(2) button,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Cell:nth-child(2) button,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(2) button,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(2) button {\n  margin-left: 0;\n  padding-left: 0;\n}\n\n.BC-Page__CollectionAnalytics__CollectionPerformance th.Polaris-DataTable__Cell:last-child > div,\n.BC-Page__CollectionAnalytics__FilterOptionValue th.Polaris-DataTable__Cell:last-child > div,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination\n  th.Polaris-DataTable__Cell:last-child\n  > div,\n.BC-Page__RecommendationAnalytics__Top__Page th.Polaris-DataTable__Cell:last-child > div,\n.BC-Page__RecommendationAnalytics__Top__Widget th.Polaris-DataTable__Cell:last-child > div,\n.BC-Page__RecommendationAnalytics__Top__Product th.Polaris-DataTable__Cell:last-child > div,\n.BC-Page__PreOrderAnalytics__Top__Product th.Polaris-DataTable__Cell:last-child > div {\n  text-align: right;\n  display: block;\n}\n\n.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Icon > .Polaris-Icon,\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Icon > .Polaris-Icon,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination\n  .Polaris-DataTable__Icon\n  > .Polaris-Icon,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Icon > .Polaris-Icon,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Icon > .Polaris-Icon,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Icon > .Polaris-Icon,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Icon > .Polaris-Icon {\n  display: none;\n}\n\n.BC-Page__CollectionAnalytics__CollectionPerformance .header-with-sortable,\n.BC-Page__CollectionAnalytics__FilterOptionValue .header-with-sortable,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .header-with-sortable,\n.BC-Page__RecommendationAnalytics__Top__Page .header-with-sortable,\n.BC-Page__RecommendationAnalytics__Top__Widget .header-with-sortable,\n.BC-Page__RecommendationAnalytics__Top__Product .header-with-sortable,\n.BC-Page__PreOrderAnalytics__Top__Product .header-with-sortable {\n  display: flex;\n}\n\n.BC-Page__CollectionAnalytics__CollectionPerformance .Polaris-DataTable__Heading:focus,\n:hover,\n.BC-Page__CollectionAnalytics__FilterOptionValue .Polaris-DataTable__Heading:focus,\n:hover,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .Polaris-DataTable__Heading:focus,\n:hover,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Heading:focus,\n:hover,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Heading:focus,\n:hover,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Heading:focus,\n:hover,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Heading:focus,\n:hover {\n  outline: none;\n}\n\n.BC-Page__CollectionAnalytics__CollectionPerformance__DidYouKnow .did-you-know p,\n.BC-Page__CollectionAnalytics__FilterOptionValue__DidYouKnow .did-you-know p,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination__DidYouKnow .did-you-know p,\n.BC-Page__RecommendationAnalytics__Top__Page .did-you-know p,\n.BC-Page__RecommendationAnalytics__Top__Widget .did-you-know p,\n.BC-Page__RecommendationAnalytics__Top__Product .did-you-know p,\n.BC-Page__PreOrderAnalytics__Top__Product .did-you-know p {\n  margin-bottom: 10px;\n}\n\n.BC-Page__CollectionAnalytics__Overview .filter-option,\n.BC-Page__CollectionAnalytics__FilterOptionValue .filter-option,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .filter-option,\n.BC-Page__RecommendationAnalytics__Top__Page .filter-option,\n.BC-Page__RecommendationAnalytics__Top__Widget .filter-option,\n.BC-Page__RecommendationAnalytics__Top__Product .filter-option,\n.BC-Page__PreOrderAnalytics__Top__Product .filter-option {\n  display: flex;\n  margin: 2.5px auto;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable--hoverable:has(.cell-highlight) {\n  background: var(--p-surface-hovered) !important;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Widget\n  .Polaris-DataTable--hoverable\n  th:has(.cell-highlight) {\n  background: var(--p-surface-hovered) !important;\n}\n\n.BC-Page__CollectionAnalytics__Overview .filter-option.filter-option-small-table {\n  max-width: 250px;\n  margin: 0;\n}\n\n.BC-Page__CollectionAnalytics__Overview\n  .filter-option.filter-option-small-table\n  .filter-option-value {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.BC-Page__CollectionAnalytics__Overview .filter-option .filter-option-label,\n.BC-Page__CollectionAnalytics__FilterOptionValue .filter-option .filter-option-label,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .filter-option .filter-option-label,\n.BC-Page__RecommendationAnalytics__Top__Page .filter-option .filter-option-label,\n.BC-Page__RecommendationAnalytics__Top__Widget .filter-option .filter-option-label,\n.BC-Page__RecommendationAnalytics__Top__Product .filter-option .filter-option-label,\n.BC-Page__PreOrderAnalytics__Top__Product .filter-option .filter-option-label {\n  min-width: var(--width);\n}\n\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .filter-option .filter-option-label {\n  margin-right: 6px;\n}\n\n.BC-Page__CollectionAnalytics__Overview .filter-option .filter-option-value,\n.BC-Page__CollectionAnalytics__FilterOptionValue .filter-option .filter-option-value,\n.BC-Page__CollectionAnalytics__FilterOptionValueCombination .filter-option .filter-option-value,\n.BC-Page__RecommendationAnalytics__Top__Page .filter-option .filter-option-value,\n.BC-Page__RecommendationAnalytics__Top__Widget .filter-option .filter-option-value,\n.BC-Page__RecommendationAnalytics__Top__Product .filter-option .filter-option-value,\n.BC-Page__PreOrderAnalytics__Top__Product .filter-option .filter-option-value {\n  font-weight: 600;\n  color: #008060;\n}\n\n.BC-Page__CollectionAnalytics__Overview\n  .BC-analytics-table--small\n  .Polaris-DataTable__Cell:first-child {\n  width: 60px;\n}\n\n.BC-Page__CollectionAnalytics__Overview\n  .BC-analytics-table--small\n  td.Polaris-DataTable__Cell:last-child {\n  justify-items: center;\n  position: relative;\n}\n\n.BC-Page__CollectionAnalytics__Overview\n  .BC-analytics-table--small\n  td.Polaris-DataTable__Cell:last-child\n  .total-click {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translate(0, -50%);\n  padding-right: var(--p-space-4);\n}\n\n/* Collection: collection performance END */\n\n.BC-analytics-table__ProductPerformance .Polaris-DataTable__Cell {\n  vertical-align: middle;\n}\n\n.BC-analytics-table__ProductPerformance .Polaris-DataTable__Cell:first-child {\n  width: 50px;\n}\n\n.BC-analytics-table__ProductPerformance .Polaris-DataTable__Cell:nth-child(2) {\n  width: 40px;\n  padding: var(--p-space-1);\n}\n\n.BC-analytics-table__ProductPerformance .Polaris-DataTable__Cell:last-child {\n  text-align: right;\n  width: 200px;\n}\n\n.BC-analytics-table__ProductPerformance .product-image {\n  width: 40px;\n  height: 40px;\n  padding-bottom: 40px;\n  position: relative;\n  border: 1px solid var(--p-divider);\n  border-radius: 4px;\n  box-sizing: border-box;\n  display: flex;\n}\n\n.BC-analytics-table__ProductPerformance .product-image img {\n  position: absolute;\n  max-width: 100%;\n  max-height: 100%;\n  border-radius: 4px;\n  display: block;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n\n/* START: Recommendation analytics v2 */\n.BC-Page__RecommendationAnalytics .Polaris-Page-Header {\n  padding-bottom: 0;\n}\n\n.BC-Page__RecommendationAnalytics .BC-Page__RecommendationAnalytics--Help {\n  display: flex;\n  gap: 2px;\n  margin-bottom: var(--p-space-4);\n  color: #6d7175;\n  font-size: 12px;\n}\n\n.BC-Page__RecommendationAnalytics .BC-Page__RecommendationAnalytics--Help .line {\n  margin: 0 6px;\n  opacity: 0.5;\n}\n\n.BC-Page__RecommendationAnalytics .BC-Page__RecommendationAnalytics--Help span {\n  cursor: pointer;\n}\n\n.BC-Page__RecommendationAnalytics .BC-Page__RecommendationAnalytics--Help svg {\n  width: 16px;\n  height: 16px;\n}\n\n.BC-Page__RecommendationAnalytics__Overview .Table__Recommendation__Top--Page .Polaris-Card,\n.BC-Page__RecommendationAnalytics__Overview .Table__Recommendation__Top--Widget .Polaris-Card,\n.BC-Page__RecommendationAnalytics__Overview .Table__Recommendation__Top--Product .Polaris-Card {\n  min-height: 313px;\n}\n\n.BC-Page__RecommendationAnalytics__Overview\n  .Table__Recommendation__Top--Page\n  .Polaris-DataTable__Cell:first-child {\n  /* 120px is width of Total revenue */\n  max-width: calc(260px - max(var(--maxCharacter) * 10px, 120px));\n  padding-right: 2px;\n}\n\n.BC-Page__RecommendationAnalytics__Overview\n  .Table__Recommendation__Top--Widget\n  .Polaris-DataTable__Cell:first-child {\n  /* 120px is width of Total revenue */\n  max-width: calc(260px - max(var(--maxCharacter) * 12px, 140px));\n  padding-right: 2px;\n}\n\n.BC-Page__RecommendationAnalytics__Overview\n  .Table__Recommendation__Top--Product\n  .Polaris-DataTable__Cell:first-child {\n  /* 120px is width of Total revenue */\n  max-width: calc(260px - max(var(--maxCharacter) * 10px, 120px));\n  padding-right: 2px;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-Card > .Polaris-DataTable--condensed,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-Card > .Polaris-DataTable--condensed,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-Card > .Polaris-DataTable--condensed,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-Card > .Polaris-DataTable--condensed {\n  display: flex;\n  flex-direction: column-reverse;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Navigation,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Navigation,\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Navigation,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Navigation {\n  height: 50px;\n  padding: 0;\n  padding-right: var(--p-space-4);\n  border-top: var(--p-border-divider);\n}\n\n.BC-Page__RecommendationAnalytics__Top__Page\n  .Polaris-DataTable__Table\n  thead\n  tr:first-child\n  th:first-child,\n.BC-Page__RecommendationAnalytics__Top__Widget\n  .Polaris-DataTable__Table\n  thead\n  tr:first-child\n  th:first-child {\n  text-align: center;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Page\n  .Polaris-DataTable__Table\n  thead\n  tr:first-child\n  th:nth-child(2)\n  .Polaris-DataTable__Icon--custom,\n.BC-Page__RecommendationAnalytics__Top__Page\n  .Polaris-DataTable__Table\n  thead\n  tr:first-child\n  th:nth-child(3)\n  .Polaris-DataTable__Icon--custom,\n.BC-Page__RecommendationAnalytics__Top__Page\n  .Polaris-DataTable__Table\n  thead\n  tr:first-child\n  th:nth-child(4)\n  .Polaris-DataTable__Icon--custom,\n.BC-Page__RecommendationAnalytics__Top__Widget\n  .Polaris-DataTable__Table\n  thead\n  tr:first-child\n  th:nth-child(2)\n  .Polaris-DataTable__Icon--custom,\n.BC-Page__RecommendationAnalytics__Top__Widget\n  .Polaris-DataTable__Table\n  thead\n  tr:first-child\n  th:nth-child(3)\n  .Polaris-DataTable__Icon--custom,\n.BC-Page__RecommendationAnalytics__Top__Widget\n  .Polaris-DataTable__Table\n  thead\n  tr:first-child\n  th:nth-child(4)\n  .Polaris-DataTable__Icon--custom {\n  text-align: center;\n  display: none;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Heading,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Heading {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Page\n  table\n  thead\n  tr:nth-child(2)\n  .Polaris-DataTable__Heading,\n.BC-Page__RecommendationAnalytics__Top__Widget\n  table\n  thead\n  tr:nth-child(2)\n  .Polaris-DataTable__Heading,\n.BC-Page__RecommendationAnalytics__Top__Product\n  table\n  thead\n  tr:nth-child(1)\n  .Polaris-DataTable__Heading,\n.BC-Page__PreOrderAnalytics__Top__Product table thead tr:nth-child(1) .Polaris-DataTable__Heading {\n  padding-right: 0;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Page\n  .Polaris-DataTable__Navigation\n  .Polaris-DataTable__Pip:nth-child(2),\n.BC-Page__RecommendationAnalytics__Top__Page\n  .Polaris-DataTable__Navigation\n  .Polaris-DataTable__Pip:nth-child(3),\n.BC-Page__RecommendationAnalytics__Top__Page\n  .Polaris-DataTable__Navigation\n  .Polaris-DataTable__Pip:nth-child(4),\n.BC-Page__RecommendationAnalytics__Top__Page\n  .Polaris-DataTable__Navigation\n  .Polaris-DataTable__Pip:nth-child(5),\n.BC-Page__RecommendationAnalytics__Top__Widget\n  .Polaris-DataTable__Navigation\n  .Polaris-DataTable__Pip:nth-child(2),\n.BC-Page__RecommendationAnalytics__Top__Widget\n  .Polaris-DataTable__Navigation\n  .Polaris-DataTable__Pip:nth-child(3),\n.BC-Page__RecommendationAnalytics__Top__Widget\n  .Polaris-DataTable__Navigation\n  .Polaris-DataTable__Pip:nth-child(4),\n.BC-Page__RecommendationAnalytics__Top__Widget\n  .Polaris-DataTable__Navigation\n  .Polaris-DataTable__Pip:nth-child(5) {\n  display: none;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Page\n  .Polaris-DataTable__Table\n  thead\n  tr:first-child\n  th:nth-child(2),\n.BC-Page__RecommendationAnalytics__Top__Widget\n  .Polaris-DataTable__Table\n  thead\n  tr:first-child\n  th:nth-child(2) {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Page\n  .Polaris-DataTable__Table\n  thead\n  tr:first-child\n  th:first-child,\n.BC-Page__RecommendationAnalytics__Top__Page .Polaris-DataTable__Table tbody tr th:first-child,\n.BC-Page__RecommendationAnalytics__Top__Widget\n  .Polaris-DataTable__Table\n  thead\n  tr:first-child\n  th:first-child,\n.BC-Page__RecommendationAnalytics__Top__Widget .Polaris-DataTable__Table tbody tr th:first-child {\n  position: sticky;\n  left: 0;\n  z-index: 2;\n  background: white;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Widget\n  .Polaris-DataTable__Table\n  thead\n  tr:first-child\n  th:last-child,\n.BC-Page__RecommendationAnalytics__Top__Widget\n  .Polaris-DataTable__Table\n  tbody\n  .Polaris-DataTable__Cell:last-child,\n.BC-Page__RecommendationAnalytics__Top__Page\n  .Polaris-DataTable__Table\n  thead\n  tr:first-child\n  th:last-child,\n.BC-Page__RecommendationAnalytics__Top__Page\n  .Polaris-DataTable__Table\n  tbody\n  .Polaris-DataTable__Cell:last-child {\n  position: sticky;\n  right: 0;\n  z-index: 2;\n  background: white;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Widget\n  .Polaris-DataTable__Table\n  tbody\n  .Polaris-DataTable__Cell:last-child\n  .Polaris-Button {\n  padding: 8px;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Page tbody .Polaris-DataTable__TableRow:hover th,\n.BC-Page__RecommendationAnalytics__Top__Widget tbody .Polaris-DataTable__TableRow:hover th,\n.BC-Page__RecommendationAnalytics__Top__Page tbody .Polaris-DataTable__TableRow:hover td,\n.BC-Page__RecommendationAnalytics__Top__Widget tbody .Polaris-DataTable__TableRow:hover td {\n  background: var(--p-surface-hovered) !important;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Product .product-image img,\n.BC-Page__PreOrderAnalytics__Top__Product .product-image img {\n  position: absolute;\n  max-width: 100%;\n  max-height: 100%;\n  border-radius: 4px;\n  display: block;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell:first-child,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:first-child {\n  width: 48px;\n  padding-right: 0.5rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:first-child {\n  min-width: 300px;\n}\n\n.BC-Page__PreOrderAnalytics__Top__Product\n  .BC-Page__PreOrders-Table\n  .Polaris-DataTable__Cell:first-child {\n  min-width: 110px;\n  padding-right: 0.5rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.BC-Page__PreOrderAnalytics__Top__Product\n  .BC-Page__PreOrders-Table\n  .Polaris-DataTable__Cell:nth-child(1) {\n  text-align: left;\n}\n\n.BC-Page__PreOrderAnalytics__Top__Product\n  .BC-Page__PreOrders-Table\n  .Polaris-DataTable__Cell:nth-child(2) {\n  max-width: 200px;\n  width: 180px;\n  padding-left: 0.5rem;\n}\n\n.BC-Page__PreOrderAnalytics__Top__Product\n  .BC-Page__PreOrders-Table\n  .Polaris-DataTable__Cell:nth-child(3) {\n  max-width: 200px;\n  width: 180px;\n  padding-left: 0.5rem;\n}\n\n.BC-Page__PreOrderAnalytics__Top__Product\n  .BC-Page__PreOrders-Table\n  .Polaris-DataTable__Cell:nth-child(4) {\n  max-width: 120px;\n  width: 120px;\n  padding-left: 0.5rem;\n}\n\n.BC-Page__PreOrderAnalytics__Top__Product\n  .BC-Page__PreOrders-Table\n  .Polaris-DataTable__Cell:nth-child(5) {\n  max-width: 280px;\n  width: 280px;\n  padding-left: 0.5rem;\n}\n\n.BC-Page__PreOrderAnalytics__Top__Product\n  .BC-Page__PreOrders-Table\n  .Polaris-DataTable__Cell:nth-child(2)\n  > div {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.BC-Page__PreOrderAnalytics__Top__Product\n  .BC-Page__PreOrders-Table\n  .Polaris-DataTable__Cell:nth-child(2)\n  button {\n  margin-left: 0;\n  padding-left: 0;\n}\n\n.BC-Page__PreOrderAnalytics__Top__Product\n  .BC-Page__PreOrders-Table\n  .Polaris-DataTable__Cell:last-child {\n  text-align: right;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(2),\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(2) {\n  width: 60%;\n  padding-left: 0.5rem;\n  max-width: 160px;\n}\n\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Cell:nth-child(1) a {\n  text-decoration: none;\n}\n\n.BC-Page__PreOrderAnalytics__Top__Product\n  .Polaris-DataTable__Cell:nth-child(2)\n  .Polaris-SkeletonDisplayText__DisplayText,\n.BC-Page__PreOrderAnalytics__Top__Product\n  .Polaris-DataTable__Cell:nth-child(3)\n  .Polaris-SkeletonDisplayText__DisplayText,\n.BC-Page__PreOrderAnalytics__Top__Product\n  .Polaris-DataTable__Cell:nth-child(4)\n  .Polaris-SkeletonDisplayText__DisplayText {\n  float: right;\n  min-width: 80px;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Product .Polaris-DataTable__Navigation,\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-DataTable__Navigation {\n  display: none;\n}\n\n.BC-Page__PreOrderAnalytics__Top__Product .pre-orders-date-picker {\n  margin: 24px 0;\n}\n\n.BC-Page__PreOrderAnalytics__Top__Product\n  .pre-orders-date-picker\n  .date-select-picker\n  .Polaris-Button__Text {\n  margin-left: 0.75rem;\n}\n\n.BC-Page__PreOrderAnalytics__Top__Product .pre-orders-date-picker .Polaris-Button__Text {\n  font-weight: 400;\n}\n\n.BC-Page__PreOrderAnalytics__Top__Product .Polaris-Button--plain svg {\n  fill: var(--p-icon);\n}\n\n#PolarisPortalsContainer .Polaris-Link {\n  text-decoration: none;\n}\n\n#PolarisPortalsContainer .Polaris-Icon {\n  margin: unset;\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.BC-Page__RecommendationAnalytics__Top__Page\n  .header-with-sortable[aria-sort='ascending']\n  .Polaris-Icon,\n.BC-Page__RecommendationAnalytics__Top__Widget\n  .header-with-sortable[aria-sort='ascending']\n  .Polaris-Icon {\n  transform: rotate(180deg);\n}\n\n/* END: Recommendation analytics v2 */\n\n/* Recommended features in ANALYTICS */\n.BC-Analytic--RecommendedFeatures {\n  display: flex;\n  gap: 20px;\n}\n\n.BC-Analytic--RecommendedFeatures .feature {\n  max-width: 332px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.BC-Analytic--RecommendedFeatures .feature .content > p:first-child {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n  margin-bottom: 4px;\n}\n\n.BC-Analytic--RecommendedFeatures .feature .Polaris-Button {\n  width: 100%;\n  padding: 13px;\n  font-weight: 500;\n}\n\n.BC-Analytic--RecommendedFeatures .action-locked {\n  background-color: #ffc96b;\n  display: flex;\n  justify-content: center;\n  gap: 2px;\n  box-shadow: 0px -1px 0px 0px #00000033 inset;\n  padding: 12px;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n/* START: Analytic settings */\n\n.BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Action {\n  display: flex;\n  justify-content: flex-start;\n  gap: 30px;\n}\n\n.BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Action .Polaris-TextField__Input {\n  width: 430px;\n}\n\n@media (max-width: 640px) {\n  .BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Action {\n    flex-direction: column;\n  }\n\n  .BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Action .Polaris-TextField__Input {\n    width: 100%;\n  }\n}\n\n.BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__List {\n  padding-bottom: 10px;\n  padding-top: 30px;\n  display: grid;\n  gap: 10px 10px;\n  grid-template-columns: repeat(auto-fill, minmax(194px, 1fr));\n}\n\n.BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Item {\n  height: 36px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px 12px;\n  background: #f6f6f7;\n  border-radius: 4px;\n  max-width: 194px;\n}\n\n.BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Item:hover {\n  background-color: #ecf6f1;\n  cursor: pointer;\n}\n\n.BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Item .remove {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: 4px;\n}\n\n.BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Item .remove .Polaris-Icon {\n  width: 12px;\n  height: 12px;\n}\n\n.BC-Page__AnalyticSettings .BC-Page__AnalyticSettings__IPs__Item .remove:hover {\n  background-color: #aee9d1;\n  border-radius: 2px;\n}\n\n.BC-Page__AnalyticSettings\n  .BC-Page__AnalyticSettings__IPs__Item\n  .remove:hover\n  .Polaris-Icon--colorBase\n  svg {\n}\n\n.BC-Page__AnalyticSettings .loading {\n  animation: spinner 0.8s linear infinite;\n  border: 2px solid #ccc;\n  border-right-color: transparent;\n  border-radius: 100%;\n  display: inline-block;\n  overflow: hidden;\n  text-indent: -9999px;\n  width: 15px;\n  height: 15px;\n  vertical-align: middle;\n}\n\n@keyframes spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* END: Analytic settings */\n\n/* Revert theme survey flow v2 */\n\n.revert-theme-all-feature-choosing-heading {\n  margin-bottom: 30px;\n  position: relative;\n}\n\n.revert-theme-all-feature-choosing-heading .heading {\n  font-weight: 400;\n  font-size: 20px;\n  margin-bottom: 12px;\n}\n\n.revert-theme-all-feature-choosing-heading .hint {\n  font-weight: 400;\n  font-size: 14px;\n  color: #6d7175;\n}\n\n.revert-theme-all-feature-choosing-heading .close {\n  position: absolute;\n  right: 0;\n  top: 0;\n  cursor: pointer;\n}\n\n.revert-theme-all-feature-choosing-content {\n  display: flex;\n  border: 1px solid #e1e3e5;\n  border-radius: 2px;\n}\n\n.revert-theme-all-feature-choosing-content .manual-uninstallation {\n  border-right: 1px solid #e1e3e5;\n}\n\n.revert-theme-all-feature-choosing-content .manual-uninstallation,\n.revert-theme-all-feature-choosing-content .automatic-uninstallation {\n  display: flex;\n  padding: 28px 24px;\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.revert-theme-all-feature-choosing-content .manual-uninstallation .content .title,\n.revert-theme-all-feature-choosing-content .automatic-uninstallation .content .title {\n  font-weight: 500;\n  font-size: 20px;\n  color: #202223;\n  margin-bottom: 16px;\n}\n\n.revert-theme-all-feature-choosing-content .manual-uninstallation p,\n.revert-theme-all-feature-choosing-content .automatic-uninstallation p {\n  margin-bottom: 20px;\n}\n\n.modal-content-revert-survey .default-text-style {\n  font-weight: 400 !important;\n}\n\n.modal-footer-clone-setting .Polaris-Stack__Item--custom .Polaris-ButtonGroup__Item {\n  margin-left: 1rem;\n}\n\n.modal-content-clone-setting .clone-result {\n  display: flex;\n  column-gap: 12px;\n  align-self: stretch;\n  justify-content: space-between;\n}\n\n.truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.react-select-clone-setting__menu-list {\n  max-height: 250px !important;\n  border-radius: 8px;\n  padding: 8px !important;\n}\n\n.react-select-clone-setting__option {\n  border-radius: 4px;\n}\n\n.react-select-clone-setting__option .type-theme {\n  margin-bottom: 2px;\n  font-size: 12px;\n  color: #6d7175;\n}\n\n.react-select-clone-setting__option.react-select-clone-setting__option--is-selected p {\n  color: #fff;\n}\n\n@media screen and (max-height: 800px) {\n  .react-select-clone-setting__menu-list {\n    max-height: 200px !important;\n  }\n}\n\n@media screen and (max-height: 600px) {\n  .react-select-clone-setting__menu-list {\n    max-height: 150px !important;\n  }\n}\n\n/* END: Revert theme survey flow v2 */\n\n.colorPickerItem {\n  display: flex;\n  align-items: flex-start;\n  column-gap: 10px;\n  margin-bottom: 8px;\n}\n\n.colorPickerItem:last-child {\n  margin-bottom: 0;\n}\n\n.colorPickerItem__box-color {\n  width: 40px;\n  height: 40px;\n  border: 1px solid #6d7175;\n  border-radius: 2px;\n  cursor: pointer;\n}\n\n.colorPickerItem__box-color img {\n  width: 100%;\n  height: 100%;\n}\n\n.colorPickerItem .Polaris-Labelled__LabelWrapper {\n  display: block;\n  margin-bottom: 0;\n}\n\n.colorPickerItem .Polaris-Labelled__LabelWrapper .Polaris-Label {\n  margin-bottom: 4px;\n}\n\n.colorPickerItem .Polaris-Labelled__LabelWrapper .Polaris-Color {\n  color: #6d7175;\n}\n\n.colorPickerItem.disabled {\n  color: #8c9196;\n}\n\n.colorPickerItem.disabled .colorPickerItem__box-color {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n\n.colorPickerItem.disabled .Polaris-Color {\n  color: #8c9196;\n}\n\n.radio-button-2 {\n  flex-grow: 1;\n  flex-basis: 0;\n}\n\n.radio-button-2 input {\n  display: none;\n}\n\n.radio-button-2 .Polaris-Button {\n  width: 100%;\n}\n\n.radio-button-2.disabled .Polaris-Button {\n  background: #fafbfb;\n  color: #8c9196;\n  box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.05);\n  cursor: not-allowed;\n}\n\n.radio-button-2 .Polaris-Button .Polaris-Button__Text {\n  font-weight: 400;\n}\n\n.radio-button-2 .Polaris-Button.checked {\n  background: #008060;\n  color: #fff;\n}\n\n.radio-button-2.disabled .Polaris-Button.checked {\n  background: #f1f1f1;\n  color: #8c9196;\n}\n\n.radio-button-2 .Polaris-Button.checked .Polaris-Icon__Svg {\n  fill: #fff;\n}\n\n.radio-button-2 .Polaris-Button.checked .Polaris-Icon__Svg path {\n  fill: #fff;\n}\n\n.BC-ThemeSetting-Editor-Page.theme-setting-visual-editor\n  ~ #PolarisPortalsContainer\n  .Polaris-Modal-Footer\n  .Polaris-Stack__Item--custom\n  .Polaris-ButtonGroup {\n  justify-content: flex-end;\n}\n\n.BC-ThemeSetting-Editor-Page.theme-setting-visual-editor\n  ~ #PolarisPortalsContainer\n  .Polaris-Modal-Footer\n  .Polaris-Stack__Item--custom\n  .Polaris-ButtonGroup__Item {\n  margin-left: 1rem;\n}\n\n@media (max-width: 1700px) {\n  .BC-ThemeSetting-Editor-Page.theme-setting-visual-editor\n    ~ #PolarisPortalsContainer\n    .Polaris-Popover__Content {\n    max-height: 300px;\n  }\n}\n\n.BC-ThemeSetting-Editor-Page.theme-setting-visual-editor\n  ~ #PolarisPortalsContainer\n  .Polaris-Popover__PopoverOverlay {\n  z-index: 1000;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .visual-editor-preview__overlay.no-padding {\n  padding: 0;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .visual-editor-preview__overlay\n  .ajax-cart {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  background: #ffffff;\n}\n\n.ajax-cart--popup {\n  left: 50%;\n  transform: translate(-50%, 0);\n  width: 732px;\n  max-height: min(640px, calc(100% - 60px - 60px));\n}\n\n.ajax-cart--popup .ajax-cart__header {\n  width: 100%;\n  height: 60px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 16.775px 24.4px;\n  border-bottom: 0.7625px solid #e8e9eb;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n  letter-spacing: 0.02em;\n  color: #0f0f0f;\n}\n\n.ajax-cart--popup .ajax-cart__header .close-popup-btn {\n  position: absolute;\n  top: 22px;\n  right: 22px;\n}\n\n.ajax-cart--popup .ajax-cart__cart {\n  height: 378.2px;\n  overflow: auto;\n  padding: 24.4px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.ajax-cart--popup .ajax-cart__cart .product-item {\n  display: flex;\n  flex-direction: row;\n  gap: 12.2px;\n}\n\n.ajax-cart--popup .ajax-cart__cart .product-item .product-item__media {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ajax-cart--popup .ajax-cart__cart .product-item .product-item__media .product-item__single-photo {\n  width: 73.2px;\n  height: 97.6px;\n  object-fit: cover;\n  object-position: center;\n}\n\n.ajax-cart--popup .ajax-cart__cart .product-item .product-item__information-inner {\n  display: flex;\n  flex-direction: row;\n  gap: 24.4px;\n  align-items: center;\n}\n\n.ajax-cart--popup\n  .ajax-cart__cart\n  .product-item\n  .product-item__information-wrapper\n  .close-popup-btn {\n  display: none;\n}\n\n.ajax-cart--popup .ajax-cart__cart .product-item .product-item__information {\n  display: flex;\n  flex-direction: column;\n  gap: 6.1px;\n  width: 158.6px;\n}\n\n.ajax-cart--popup\n  .ajax-cart__cart\n  .product-item\n  .product-item__information\n  .product-item__delete-btn\n  > span {\n  margin: 0;\n}\n\n.ajax-cart--popup\n  .ajax-cart__cart\n  .product-item\n  .product-item__information\n  .product-item__delete-btn {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.ajax-cart--popup\n  .ajax-cart__cart\n  .product-item\n  .product-item__name\n  .product-item__delete-btn\n  .Polaris-Icon {\n  display: grid;\n  place-items: center;\n  width: 24px;\n  height: 24px;\n}\n\n.ajax-cart--popup\n  .ajax-cart__cart\n  .product-item\n  .product-item__name\n  .product-item__delete-btn\n  .Polaris-Icon__Svg {\n  width: 24px;\n  height: 24px;\n}\n\n.ajax-cart--popup .ajax-cart__cart .product-item .product-item__first-price {\n  width: 122px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.ajax-cart--popup .ajax-cart__cart .product-item .product-item__second-price {\n  width: 122px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.ajax-cart--popup .ajax-cart__cart .product-item .product-item__third-price {\n  display: none;\n}\n\n.ajax-cart--popup .ajax-cart__cart .product-item .product-item__name {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  color: #222222;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.ajax-cart--popup .ajax-cart__cart .product-item .product-item__options {\n  display: flex;\n  flex-direction: column;\n  gap: 6.1px;\n}\n\n.ajax-cart--popup .ajax-cart__cart .product-item .product-item__options .product-option {\n  display: flex;\n  flex-direction: row;\n  gap: 3px;\n}\n\n.ajax-cart--popup\n  .ajax-cart__cart\n  .product-item\n  .product-item__options\n  .product-option\n  .product-option__label {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #222222;\n}\n\n.ajax-cart--popup\n  .ajax-cart__cart\n  .product-item\n  .product-item__options\n  .product-option\n  .product-option__value {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  color: #222222;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ajax-cart--popup .ajax-cart__footer {\n  width: 100%;\n  height: 112px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  padding: 0px 24.4px 18.3px;\n  border-top: 0.7625px solid #e8e9eb;\n}\n\n.ajax-cart--popup .ajax-cart__cart .product-item .product-item__quantity-counter {\n  display: flex;\n  align-items: center;\n}\n\n.ajax-cart--popup\n  .ajax-cart__cart\n  .product-item\n  .product-item__quantity-counter\n  .quantity-counter__counter {\n  width: 122px;\n  height: 29.2px;\n  border: 0.7625px solid #ebebeb;\n  border-radius: 30.5px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.ajax-cart--popup .ajax-cart__footer .ajax-cart__sub-total {\n  display: flex;\n  flex-direction: row;\n  gap: 6.1px;\n  padding: 10.6px 0;\n}\n\n.ajax-cart--popup .ajax-cart__footer .ajax-cart__sub-total .text {\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 28px;\n}\n\n.ajax-cart--popup .ajax-cart__footer .ajax-cart__sub-total .price {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n  letter-spacing: 0.02em;\n  color: #0f0f0f;\n}\n\n.ajax-cart--popup .ajax-cart__footer .ajax-cart__buttons {\n  display: flex;\n  flex-direction: row;\n  gap: 12.2px;\n}\n\n.ajax-cart--popup .ajax-cart__footer .ajax-cart__buttons .button-item:hover {\n  cursor: pointer;\n}\n\n.ajax-cart--popup .ajax-cart__footer .ajax-cart__buttons .button-item {\n  width: 152.5px;\n  min-height: 34.3px;\n  padding: 9.15px 15.25px;\n  border: 0.7625px solid #4e4e4e;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ajax-cart--popup .ajax-cart__footer .ajax-cart__buttons .button-item.button-item--rounded {\n  border-radius: 61px;\n}\n\n.ajax-cart--popup.full {\n  left: 50%;\n  transform: translate(-50%, 0);\n  width: 960px;\n  max-height: min(640px, calc(100% - 60px - 60px));\n}\n\n.ajax-cart--popup.full .ajax-cart__header {\n  width: 100%;\n  height: 72px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 22px 32px;\n  border-bottom: 1px solid #e8e9eb;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n  letter-spacing: 0.02em;\n  color: #0f0f0f;\n}\n\n.ajax-cart--popup.full .ajax-cart__header .close-popup-btn {\n  position: absolute;\n  top: 28.5px;\n  right: 28.5px;\n}\n\n.ajax-cart--popup.full .ajax-cart__cart {\n  height: 496px;\n  overflow: auto;\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.ajax-cart--popup.full .ajax-cart__cart .product-item {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n}\n\n.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__media {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ajax-cart--popup.full\n  .ajax-cart__cart\n  .product-item\n  .product-item__media\n  .product-item__single-photo {\n  width: 98px;\n  height: 128px;\n  object-fit: cover;\n  object-position: center;\n}\n\n.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__information-inner {\n  display: flex;\n  flex-direction: row;\n  gap: 32px;\n}\n\n/* .ajax-cart--side .ajax-cart__cart .product-item .product-item__information-wrapper .product-item__name .product-item__delete-btn{\n  display: none;\n} */\n.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__information {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 208px;\n}\n\n.ajax-cart--popup.full\n  .ajax-cart__cart\n  .product-item\n  .product-item__information\n  .product-item__delete-btn\n  > span {\n  margin: 0;\n}\n\n.ajax-cart--popup.full\n  .ajax-cart__cart\n  .product-item\n  .product-item__information\n  .product-item__delete-btn {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__first-price {\n  width: 160px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__second-price {\n  width: 160px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__third-price {\n  display: none;\n}\n\n.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__name {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  color: #222222;\n}\n\n.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__options {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__options .product-option {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n}\n\n.ajax-cart--popup.full\n  .ajax-cart__cart\n  .product-item\n  .product-item__options\n  .product-option\n  .product-option__label {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #222222;\n}\n\n.ajax-cart--popup.full\n  .ajax-cart__cart\n  .product-item\n  .product-item__options\n  .product-option\n  .product-option__value {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  color: #222222;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ajax-cart--popup.full .ajax-cart__footer {\n  width: 100%;\n  height: 132px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  padding: 0px 32px 24px;\n  border-top: 1px solid #e8e9eb;\n}\n\n.ajax-cart--popup.full .ajax-cart__cart .product-item .product-item__quantity-counter {\n  display: flex;\n  align-items: center;\n}\n\n.ajax-cart--popup.full\n  .ajax-cart__cart\n  .product-item\n  .product-item__quantity-counter\n  .quantity-counter__counter {\n  width: 160px;\n  height: 38px;\n  border: 1px solid #ebebeb;\n  border-radius: 40px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.ajax-cart--popup.full .ajax-cart__footer .ajax-cart__sub-total {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  padding: 14px 0;\n}\n\n.ajax-cart--popup.full .ajax-cart__footer .ajax-cart__sub-total .text {\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 28px;\n}\n\n.ajax-cart--popup.full .ajax-cart__footer .ajax-cart__sub-total .price {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n  letter-spacing: 0.02em;\n  color: #0f0f0f;\n}\n\n.ajax-cart--popup.full .ajax-cart__footer .ajax-cart__buttons {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n}\n\n.ajax-cart--popup.full .ajax-cart__footer .ajax-cart__buttons .button-item:hover {\n  cursor: pointer;\n}\n\n.ajax-cart--popup.full .ajax-cart__footer .ajax-cart__buttons .button-item {\n  width: 200px;\n  min-height: 44px;\n  padding: 12px 20px;\n  border: 1px solid #4e4e4e;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ajax-cart--popup.full .ajax-cart__footer .ajax-cart__buttons .button-item.button-item--rounded {\n  border-radius: 80px;\n}\n\n.ajax-cart--side {\n  right: 0;\n  width: 320px;\n  height: 100%;\n}\n\n.ajax-cart--side .ajax-cart__header {\n  width: 100%;\n  height: 48px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 14px 16px;\n  border-bottom: 1px solid #e8e9eb;\n  border-top: 1px solid #e8e9eb;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  color: #0f0f0f;\n}\n\n.ajax-cart--side .ajax-cart__header .close-popup-btn {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n}\n\n.ajax-cart--side .ajax-cart__cart {\n  height: calc(100% - 48px - 192px);\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.ajax-cart__cart::-webkit-scrollbar {\n  width: 8px;\n}\n\n.ajax-cart__cart::-webkit-scrollbar-track {\n  background-color: #ffffff;\n}\n\n.ajax-cart__cart::-webkit-scrollbar-thumb {\n  background: #cccccc;\n  border-radius: 4px;\n}\n\n.ajax-cart--side .ajax-cart__cart .product-item {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n}\n\n.ajax-cart--side .ajax-cart__cart .product-item .product-item__media {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ajax-cart--side .ajax-cart__cart .product-item .product-item__media .product-item__single-photo {\n  width: 96px;\n  height: 128px;\n  object-fit: cover;\n  object-position: center;\n}\n\n.ajax-cart--side .ajax-cart__cart .product-item .product-item__information-inner {\n  padding: 7px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  position: relative;\n}\n\n.ajax-cart--side\n  .ajax-cart__cart\n  .product-item\n  .product-item__information-wrapper\n  .close-popup-btn {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  display: grid;\n  place-items: center;\n}\n\n.ajax-cart--side\n  .ajax-cart__cart\n  .product-item\n  .product-item__information-wrapper\n  .Polaris-Icon__Svg {\n  width: 24px;\n  height: 24px;\n  max-width: unset;\n  max-height: unset;\n}\n\n.ajax-cart--side .ajax-cart__cart .product-item .product-item__information {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 176px;\n}\n\n.ajax-cart--side\n  .ajax-cart__cart\n  .product-item\n  .product-item__information\n  .product-item__delete-btn\n  > span {\n  margin: 0;\n}\n\n.ajax-cart--side\n  .ajax-cart__cart\n  .product-item\n  .product-item__information\n  .product-item__delete-btn {\n  display: none;\n}\n\n.ajax-cart--side\n  .ajax-cart__cart\n  .product-item\n  .product-item__name\n  .product-item__delete-btn\n  .Polaris-Icon {\n  display: grid;\n  place-items: center;\n  width: 24px;\n  height: 24px;\n}\n\n.ajax-cart--side .ajax-cart__cart .product-item .product-item__first-price {\n  display: none;\n}\n\n.ajax-cart--side .ajax-cart__cart .product-item .product-item__second-price {\n  display: none;\n}\n\n.ajax-cart--side .ajax-cart__cart .product-item .product-item__third-price {\n  margin-left: auto;\n  display: flex;\n  gap: 8px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #0f0f0f;\n}\n\n.ajax-cart--side .ajax-cart__cart .product-item .product-item__name {\n  width: 100%;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  color: #222222;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.ajax-cart--side .ajax-cart__cart .product-item .product-item__options {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ajax-cart--side .ajax-cart__cart .product-item .product-item__options .product-option {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n}\n\n.ajax-cart--side\n  .ajax-cart__cart\n  .product-item\n  .product-item__options\n  .product-option\n  .product-option__label {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #222222;\n}\n\n.ajax-cart--side\n  .ajax-cart__cart\n  .product-item\n  .product-item__options\n  .product-option\n  .product-option__value {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  color: #222222;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ajax-cart--side .ajax-cart__cart .product-item .product-item__quantity-counter {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  margin-top: auto;\n}\n\n.ajax-cart--side\n  .ajax-cart__cart\n  .product-item\n  .product-item__quantity-counter\n  .quantity-counter__counter {\n  width: 81px;\n  height: 30px;\n  border: 1px solid #ebebeb;\n  border-radius: 40px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #222222;\n}\n\n.ajax-cart--side .ajax-cart__footer {\n  width: 100%;\n  height: 192px;\n  border-top: 1px solid #e8e9eb;\n}\n\n.ajax-cart--side .ajax-cart__footer .ajax-cart__sub-total {\n  display: flex;\n  flex-direction: row;\n  padding: 14px 16px;\n  justify-content: space-between;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  color: #0f0f0f;\n}\n\n.ajax-cart--side .ajax-cart__footer .ajax-cart__buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px 16px 16px 16px;\n}\n\n.ajax-cart--side .ajax-cart__footer .ajax-cart__buttons .button-item:hover {\n  cursor: pointer;\n}\n\n.ajax-cart--side .ajax-cart__footer .ajax-cart__buttons .button-item {\n  min-width: 200px;\n  min-height: 44px;\n  padding: 12px 20px;\n  border: 1px solid #4e4e4e;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ajax-cart--side .ajax-cart__footer .ajax-cart__buttons .button-item.button-item--rounded {\n  border-radius: 80px;\n}\n\n.BC-Page__Title--Help {\n  display: flex;\n  gap: 20px;\n  margin-bottom: var(--p-space-4);\n  color: #6d7175;\n  font-size: 12px;\n}\n\n.BC-Page__Title--Help__Item {\n  display: flex;\n  position: relative;\n  align-items: center;\n}\n\n.BC-Page__Title--Help__Item::after {\n  margin: 0 8px;\n  position: absolute;\n  display: inline-block;\n  width: 1px;\n  height: 12px;\n  background: #e1e3e5;\n  content: '';\n  right: -20px;\n  top: 4px;\n}\n\n.BC-Page__Title--Help__Item:last-child:after {\n  display: none;\n}\n\n.BC-Page__Title--Help span {\n  cursor: pointer;\n}\n\n.BC-Page__Title--Help span.img {\n  width: auto;\n  height: 11.2px;\n  margin-right: 5px;\n  display: inline-block;\n  display: flex;\n}\n\n.BC-Page__Title--Help span:hover {\n  color: black;\n}\n\n.BC-Page__Title--Help svg {\n  width: 14px;\n  height: 14px;\n}\n\n.BC-Page__Title--Help__Item .Polaris-Icon {\n  display: flex;\n  align-items: center;\n}\n\n.BC-CSATFeedback__Wrapper {\n  position: fixed;\n  top: 45%;\n  right: -422px;\n\n  display: flex;\n  flex-direction: row;\n\n  z-index: 520;\n  transition: all 0.4s ease-in-out;\n}\n\n.BC-CSATFeedback__Wrapper.expanded {\n  right: 0px;\n}\n\n.BC-CSATFeedback__Wrapper .StickyButton {\n  background-color: #2c6ecb;\n  padding: 10px 8px;\n  border-radius: 4px 0 0 4px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  height: min-content;\n  margin-top: 24px;\n\n  -webkit-user-select: none;\n  /* Safari */\n  -ms-user-select: none;\n  /* IE 10 and IE 11 */\n  user-select: none;\n  /* Standard syntax */\n\n  transition: all 0.1s ease-in-out;\n}\n\n.BC-CSATFeedback__Wrapper .StickyButton.clickable {\n  cursor: pointer;\n}\n\n.BC-CSATFeedback__Wrapper .StickyButton.clickable:hover {\n  box-shadow:\n    rgba(0, 0, 0, 0.07) 0px 1px 2px,\n    rgba(0, 0, 0, 0.07) 0px 2px 4px,\n    rgba(0, 0, 0, 0.07) 0px 4px 8px,\n    rgba(0, 0, 0, 0.07) 0px 8px 16px,\n    rgba(0, 0, 0, 0.07) 0px 16px 32px,\n    rgba(0, 0, 0, 0.07) 0px 32px 64px;\n}\n\n.BC-CSATFeedback__Wrapper .StickyButton .StickyButton__Title {\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n}\n\n.BC-CSATFeedback__Wrapper .StickyButton .StickyButton__Icon {\n  width: 100%;\n}\n\n.BC-CSATFeedback__Wrapper .FeedbackWidget {\n  width: 422px;\n  padding: 24px 20px;\n  background-color: white;\n\n  border-radius: 8px;\n}\n\n.BC-CSATFeedback__Wrapper .FeedbackWidget.visible {\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;\n}\n\n.BC-CSATFeedback__Wrapper .FeedbackWidget .FeedbackWidget__CloseButton {\n  position: absolute;\n  top: 28px;\n  right: 20px;\n\n  cursor: pointer;\n}\n\n.FeedbackWidget .FeedbackWidget__Rating {\n  -webkit-user-select: none;\n  /* Safari */\n  -ms-user-select: none;\n  /* IE 10 and IE 11 */\n  user-select: none;\n  /* Standard syntax */\n}\n\n.FeedbackWidget .FeedbackWidget__Rating.center {\n  text-align: center;\n}\n\n.FeedbackWidget .FeedbackWidget__Rating .Rating__Container {\n  display: flex;\n  flex-direction: column;\n}\n\n.FeedbackWidget .FeedbackWidget__Rating .Rating__Container.reverse {\n  flex-direction: column-reverse;\n  text-align: center;\n  margin-top: 20px;\n}\n\n.FeedbackWidget .FeedbackWidget__Rating .Rating__Title {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n\n  color: #202223;\n}\n\n.FeedbackWidget .FeedbackWidget__Rating .Rating__Subtitle {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n\n  margin-top: 4px;\n  color: #6d7175;\n}\n\n.FeedbackWidget__Rating .Rating__Container.reverse .Rating__Subtitle {\n  color: #202223;\n}\n\n.FeedbackWidget .FeedbackWidget__Rating .Rating__Stars {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n\n  margin-top: 16px;\n}\n\n.FeedbackWidget .FeedbackWidget__Rating .Rating__Action {\n  margin-top: 26px;\n\n  display: flex;\n  justify-content: flex-end;\n}\n\n.FeedbackWidget .FeedbackWidget__Rating .Rating__Action .Polaris-Button__Text {\n  color: #6d7175;\n}\n\n.Rating__Stars .Star__Container {\n  width: 89.5px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  transition: all 0.12s ease-in-out;\n}\n\n.Rating__Stars:hover .Star__Container {\n  filter: opacity(0.25);\n}\n\n.Rating__Stars .Star__Container:hover {\n  filter: opacity(1);\n}\n\n.Rating__Stars .Star__Container img {\n  transform: translateX(-5px);\n\n  cursor: pointer;\n}\n\n.Rating__Stars .Star__Container .Star__Name {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n\n  color: #6d7175;\n}\n\n.FeedbackWidget__Feedback {\n  display: flex;\n  gap: 16px;\n  flex-direction: column;\n}\n\n.FeedbackWidget__Feedback .Feedback__Title {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n\n  -webkit-user-select: none;\n  /* Safari */\n  -ms-user-select: none;\n  /* IE 10 and IE 11 */\n  user-select: none;\n  /* Standard syntax */\n\n  color: #202223;\n}\n\n.FeedbackWidget__Feedback .Feedback__Textarea {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.FeedbackWidget__Feedback .Feedback__Textarea textarea:focus {\n  outline: none !important;\n}\n\n.FeedbackWidget__Feedback .Feedback__Textarea textarea[rows='4'] {\n  max-height: 106px;\n}\n\n.FeedbackWidget__Feedback .Feedback__Action {\n  display: flex;\n  gap: 8px;\n\n  margin-top: 20px;\n}\n\n.FeedbackWidget .FeedbackWidget__GotIt {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  -webkit-user-select: none;\n  /* Safari */\n  -ms-user-select: none;\n  /* IE 10 and IE 11 */\n  user-select: none;\n  /* Standard syntax */\n}\n\n.FeedbackWidget .FeedbackWidget__GotIt .GotIt__Title {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n\n  color: #202223;\n}\n\n.FeedbackWidget .FeedbackWidget__GotIt .GotIt__Subtitle {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 24px;\n\n  color: #202223;\n}\n\n.FeedbackWidget .FeedbackWidget__GotIt .GotIt__Action {\n  margin-top: 5px;\n}\n\n.FeedbackWidget .FeedbackWidget__GotIt .GotIt__Decor {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n}\n\n.Rating__Stars .Star__Container.Poor.animation {\n  animation:\n    star-appear 0.3s ease-out,\n    star-jump 0.8s ease-out;\n}\n\n.Rating__Stars .Star__Container.Ok.animation {\n  animation:\n    star-appear 0.3s ease-out,\n    star-jump 0.8s ease-out 0.1s;\n}\n\n.Rating__Stars .Star__Container.Good.animation {\n  animation:\n    star-appear 0.3s ease-out,\n    star-jump 0.8s ease-out 0.2s;\n}\n\n.Rating__Stars .Star__Container.Excellent.animation {\n  animation:\n    star-appear 0.3s ease-out,\n    star-jump 0.8s ease-out 0.3s;\n}\n\n@keyframes star-appear {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes star-jump {\n  0% {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n\n  40% {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n\n  70% {\n    opacity: 0.6;\n    transform: translateY(-5px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n}\n\n.modal-get-feedback-after-rating-5stars {\n  display: flex;\n  justify-content: center;\n}\n\n.modal-get-feedback-after-rating-5stars .left {\n  display: 430px;\n  text-align: center;\n}\n\n.modal-get-feedback-after-rating-5stars .left img {\n  max-width: 416px;\n}\n\n.modal-get-feedback-after-rating-5stars .left .step-title {\n  font-weight: 600;\n  font-size: 24px;\n  color: #008060;\n}\n\n.modal-get-feedback-after-rating-5stars .left .step-detail {\n  font-weight: 400;\n  font-size: 16px;\n  color: #202223;\n  margin: 10px;\n}\n\n.modal-get-feedback-after-rating-5stars .left .carousel {\n  height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n  width: 100px;\n  margin: 20px auto;\n}\n\n.modal-get-feedback-after-rating-5stars .left .carousel .carousel-item {\n  width: 6px;\n  height: 6px;\n  background: #c9ccd0;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.modal-get-feedback-after-rating-5stars .left .carousel .carousel-item.active {\n  width: 10px;\n  height: 10px;\n  background: #008060;\n}\n\n.modal-get-feedback-after-rating-5stars .right {\n  width: 400px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  padding: 20px;\n}\n\n.modal-get-feedback-after-rating-5stars .right .title {\n  font-weight: 600;\n  font-size: 28px;\n  color: #202223;\n  line-height: 32px;\n}\n\n.modal-get-feedback-after-rating-5stars .right .description {\n  font-weight: 400;\n  font-size: 16px;\n  color: #202223;\n  line-height: 24px;\n}\n\n.modal-get-feedback-after-rating-5stars .right .action {\n  display: flex;\n  gap: 20px;\n}\n\n.modal-get-feedback-after-rating-5stars-all-set-wrapper {\n  padding-top: 30px;\n  padding-bottom: 60px;\n}\n\n.modal-get-feedback-after-rating-5stars-all-set {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  background: white;\n  border-radius: 0.5rem;\n  /* box-shadow: var(--p-shadow-modal); */\n  background-image: url('https://cdn.boostcommerce.io/assets/feedback-after-5-stars-rating/bg-all-set.png');\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: bottom;\n  padding: 10px;\n  padding-top: 40px;\n  background-origin: content-box;\n}\n\n.modal-get-feedback-after-rating-5stars-all-set .title {\n  font-weight: 600;\n  font-size: 20px;\n  margin-bottom: 20px;\n}\n\n.modal-get-feedback-after-rating-5stars-all-set .description {\n  font-weight: 400;\n  font-size: 14px;\n  max-width: 400px;\n  text-align: center;\n  padding: 10px;\n  padding-top: 0;\n}\n\n.modal-get-feedback-after-rating-5stars-all-set .smile {\n  width: 70px;\n  margin: 0 auto;\n  height: 70px;\n  border-radius: 50%;\n  background: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: -35px;\n}\n\n.Polaris-Modal-Dialog__Modal:has(.modal-get-feedback-after-rating-5stars-all-set) {\n  width: 440px;\n  background: transparent;\n  box-shadow: unset;\n}\n\n.Polaris-Modal-Dialog__Modal.Polaris-Modal-Dialog--sizeLarge:has(\n    .modal-get-feedback-after-rating-5stars\n  ) {\n  max-width: 912px !important;\n}\n\n.Polaris-Modal-Section:has(.modal-content-form-feedback-rating-5stars) {\n  padding: 0;\n}\n\n.modal-content-form-feedback-rating-5stars .title-action {\n  display: flex;\n  justify-content: space-between;\n  padding: var(--p-space-5);\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.modal-content-form-feedback-rating-5stars .title-action .title {\n  font-size: 20px;\n}\n\n.modal-content-form-feedback-rating-5stars .title-action .close {\n  cursor: pointer;\n}\n\n.modal-content-form-feedback-rating-5stars .content-action {\n  padding: var(--p-space-5);\n  padding-top: 0;\n}\n\n.modal-content-form-feedback-rating-5stars .content-action .Polaris-Labelled__LabelWrapper {\n  margin-top: var(--p-space-4);\n}\n\n.notification-feedback-5stars .action {\n  margin-top: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.notification-feedback-5stars .action .Polaris-Button.Polaris-Button--outline {\n  border: 1px solid #98c6cd;\n}\n\n.notification-feedback-5stars .action .Polaris-Button:hover {\n  background: #b8e9ef;\n}\n\n.notification-feedback-5stars .dismiss {\n  cursor: pointer;\n}\n\n.notification-feedback-5stars .Polaris-Icon {\n  background-image: url('https://cdn.boostcommerce.io/assets/feedback-after-5-stars-rating/gift.svg');\n  background-size: contain;\n}\n\n.notification-feedback-5stars .Polaris-Icon svg {\n  display: none;\n}\n\n.whatsapp-modal {\n  display: flex;\n  position: relative;\n}\n\n.whatsapp-modal .close {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.whatsapp-modal .close button {\n  border: none;\n  width: 20px;\n  height: 20px;\n  padding: 8px;\n}\n\n.whatsapp-modal .whatsapp-modal__qr {\n  display: flex;\n  padding: 48px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 37.75px;\n  min-width: 400px;\n}\n\n.whatsapp-modal .whatsapp-modal__qr .qr_header {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.whatsapp-modal .whatsapp-modal__qr .qr_header .qr-title {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 28px;\n  margin-bottom: 4px;\n}\n\n.whatsapp-modal .whatsapp-modal__qr .qr_header .qr-subtitle {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #6d7175;\n}\n\n.whatsapp-modal .whatsapp-modal__qr .qr-body .qr-wrapper {\n  padding: 12px;\n  background-image: url('https://cdn.boostcommerce.io/assets/dashboard-v3/bg-qr.png');\n  background-repeat: no-repeat;\n}\n\n.whatsapp-modal .whatsapp-modal__qr .qr-footer .qr-note {\n  line-height: 20px;\n  color: #8c9196;\n  text-align: center;\n  max-width: 304px;\n}\n\n.whatsapp-modal .whatsapp-modal__content {\n  display: flex;\n  padding: 48px 32px;\n  padding-right: 12px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.whatsapp-modal .whatsapp-modal__content .title {\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 32px;\n  margin-bottom: 24px;\n}\n\n.whatsapp-modal .whatsapp-modal__content .text {\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.whatsapp-modal__action {\n  margin-top: 32px;\n  width: 100%;\n}\n\n.whatsapp-modal__action .Polaris-ButtonGroup__Item:first-child {\n  margin-left: 8px;\n}\n\n.whatsapp-modal__action button {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20p;\n}\n\n/*VerticalTab*/\n.BC_VerticalTab_Wrapper {\n  display: flex;\n}\n\n.BC_VerticalTab_Wrapper .tab-items {\n  border-right: 1px solid #e1e3e5;\n  padding: 20px 0 20px 8px;\n  width: 200px;\n  flex-shrink: 0;\n}\n\n.BC_VerticalTab_Wrapper .tab-children {\n  padding: 20px;\n  flex-grow: 1;\n  max-width: calc(100% - 200px);\n}\n\n.BC_VerticalTab_Wrapper .tab-selected {\n  color: #347c84 !important;\n  background-color: #f6f6f7;\n  border-right: 2px solid #347c84;\n  font-weight: 600 !important;\n  border-radius: 4px 0 0 4px;\n}\n\n.BC_VerticalTab_Wrapper .tab-item {\n  margin-right: 5px;\n  padding: 12px 8px 12px 8px;\n  font-weight: 400;\n  color: #202223;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.BC_VerticalTab_Wrapper .tab-item:hover {\n  background-color: #f1f2f3;\n}\n\n.BC_VerticalTab_Wrapper .tab-item .tab-name {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.BC_VerticalTab_Wrapper .tab-item .Polaris-Badge {\n  margin-left: 4px;\n}\n\n/*VerticalTab*/\n\n/*StandardSearch*/\n.BC-Page__StandardSearch .Polaris-Page {\n  max-width: 1104px;\n}\n\n.BC-Page__StandardSearch .Polaris-Header-Title__SubTitle {\n  color: #202223;\n}\n\n.BC-Page__StandardSearch .Polaris-Page-Header,\n.BC-Page__StandardSearch\n  .Polaris-Page\n  > div\n  > .Polaris-Layout\n  > .Polaris-Layout__Section\n  > .BC-Page\n  > .Polaris-Card\n  > .Polaris-Card__Section,\n.BC-Page__AdvancedSearch\n  .Polaris-Page\n  .Polaris-Layout\n  > .Polaris-Layout__Section\n  > .Polaris-Card\n  > .Polaris-Card__Section {\n  padding: 0;\n}\n\n.BC-Page__StandardSearch .tab-children .Polaris-Header-Title {\n  font-size: 20px;\n}\n\n.BC-Page__StandardSearch .Children-Card__Section {\n  position: relative;\n  overflow: visible;\n}\n\n.BC-Page__StandardSearch .Polaris-Page {\n  padding: 0;\n}\n\n.BC-Page__StandardSearch .StandardSearch__Content {\n  margin-top: 0px !important;\n}\n\n.BC-Page__StandardSearch > .Polaris-Page > .Polaris-Page-Header {\n  margin-top: 2.5rem;\n}\n\n.BC-Page__StandardSearch .upgradeThemeBanner .image {\n  max-height: 116px;\n  width: 100%;\n}\n\n.BC-Page__StandardSearch .upgradeThemeBanner .image img {\n  max-height: 116px;\n  max-width: 240px;\n}\n\n.upgradeThemeBanner .pfs-banner-content ul {\n  padding-left: 20px;\n  margin: 0;\n}\n\n.tryNewVersionSearch {\n  margin-bottom: 24px;\n}\n\n.tryNewVersionSearch .pfs-banner-content {\n  width: 85% !important;\n  padding-bottom: unset !important;\n}\n\n.tryNewVersionSearch .pfs-banner-detail {\n  gap: unset;\n}\n\n.tryNewVersionSearch .image {\n  max-width: 240px;\n}\n\n.tryNewVersionSearch .image img {\n  max-width: 240px;\n  max-height: 152px;\n}\n\n/*StandardSearch*/\n\n/*StandardSearch - SearchResultPage*/\n\n/*StandardSearch - InCollectionSettings*/\n.searchResultPageInfo .image {\n  max-height: 112px;\n}\n\n.searchSettingProcessingBanner {\n  padding: 16px !important;\n}\n\n.searchSettingProcessingBanner .pfs-banner-content {\n  padding: unset !important;\n}\n\n.searchSettingProcessingBanner .pfs-banner-detail {\n  margin-top: unset;\n}\n\n.searchSettingProcessingBanner .pfs-banner-icon {\n  height: 20px;\n}\n\n/*StandardSearch - InCollectionSettings*/\n.BC-Page__StandardSearch\n  .BC-Page__InCollectionSettings\n  .BC-Container__Notifications\n  > *:first-child {\n  margin-top: 1rem;\n}\n\n.BC-Page__StandardSearch .BC-Page__InCollectionSettings .Children-Card__Section {\n  margin-top: 2.5rem !important;\n  padding: 8px 20px;\n}\n\n.BC-Page__InCollectionSettings .pfs-app-banner .image {\n  max-height: 100px;\n}\n\n.BC-Page__InCollectionSettings .Polaris-Layout {\n  margin-top: 1rem;\n}\n\n/*StandardSearch - InCollectionSettings*/\n\n/*StandardSearch - RelevanceSettings*/\n.BC-Page__StandardSearch .BC-Page__SearchSettings .Children-Card__Section {\n  margin-top: 0 !important;\n}\n\n.BC-Page__StandardSearch .BC-Page__SearchSettings .Polaris-Tabs__Wrapper .Polaris-Tabs {\n  margin-left: 20px;\n}\n\n.BC-Page__StandardSearch .BC-Page__SearchSettings .Polaris-Tabs__Panel .tab-content,\n.BC-Page__StandardSearch .BC-Page__SearchPageDisplay .Polaris-Tabs__Panel .tab-content {\n  padding-top: 1px;\n  margin-top: 10px;\n}\n\n.BC-Page__StandardSearch .BC-Page__SearchSettings .Polaris-Tabs__Wrapper,\n.BC-Page__StandardSearch .BC-Page__SearchPageDisplay .Polaris-Tabs__Wrapper {\n  margin-left: -20px;\n  margin-right: -20px;\n  margin-bottom: 10px;\n}\n\n.BC-Page__StandardSearch .BC-Page__SearchSettings .Polaris-PageActions,\n.BC-Page__StandardSearch .BC-Page__SearchPageDisplay .Polaris-PageActions {\n  border-top: none;\n}\n\n.BC-Page__StandardSearch .BC-Page__SearchSettings .BC-DataTable__SearchSettings {\n  margin-left: 0;\n  margin-right: 0;\n  border: 1px solid var(--p-divider);\n  border-radius: 8px;\n}\n\n.relevanceSettingInfo .image {\n  max-height: 112px;\n}\n\n.sync-v2-wrapper .Polaris-Layout__Section {\n  margin-top: 1.5rem;\n}\n\n.sync-v2-wrapper .Polaris-Layout__Section .syncInfoBanner {\n  margin-top: 0;\n}\n\n/* check if notification was dismisss */\n.sync-v2-wrapper .Polaris-Layout__Section:has(.BC-Container__Notifications):not(:has(div > div)) {\n  margin-top: 0;\n}\n\n.sync-v2-wrapper .sync-v2-wrapper-flex {\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n}\n\n.sync-v2-wrapper .sync-status {\n  width: 320px;\n  position: relative;\n  height: auto;\n}\n\n.sync-v2-wrapper .sync-status .Polaris-Card {\n  height: 100%;\n}\n\n.sync-v2-wrapper .sync-status .Polaris-Card .Polaris-Card__Section,\n.sync-v2-wrapper .manual-sync .Polaris-Card .Polaris-Card__Section {\n  min-height: 236px;\n}\n\n.sync-v2-wrapper .sync-status .Polaris-Card .Polaris-Card__Section {\n  display: flex;\n  align-items: flex-start;\n}\n\n.sync-v2-wrapper .sync-status:has(.content-center) .Polaris-Card .Polaris-Card__Section {\n  display: block;\n  align-items: center;\n  position: relative;\n}\n\n.sync-v2-wrapper .sync-status .content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  position: relative;\n  z-index: 2;\n  margin-top: 20%;\n  width: 72%;\n}\n\n.sync-v2-wrapper .sync-status .content-v4 {\n  width: 100%;\n  margin-top: 16px !important;\n}\n\n.sync-v2-wrapper .sync-status .detail-sync-status {\n  margin-bottom: 20px;\n}\n\n.sync-v2-wrapper .sync-status .detail-sync-status > div:first-child {\n  width: calc(100% - 70px);\n}\n\n.sync-v2-wrapper .sync-status .detail-sync-status > p:last-child {\n  color: #2c6ecb;\n  text-decoration: underline;\n}\n\n.sync-v2-wrapper .sync-status .detail-sync-status > p:last-child:hover {\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.sync-v2-wrapper .sync-status img {\n  position: absolute;\n  right: 0;\n}\n\n.sync-v2-wrapper .sync-status:has(.content-center) .content > div:not(:last-child) {\n  width: calc(100% - 70px);\n}\n\n.sync-v2-wrapper .sync-status .Polaris-Card__Section {\n  position: relative;\n}\n\n.sync-v2-wrapper .sync-status .Polaris-Card__Section img.bg {\n  position: absolute;\n  right: 0;\n  z-index: 1;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.sync-v2-wrapper .sync-status img.loading {\n  animation: rotation 8s infinite linear;\n}\n\n.sync-v2-wrapper .sync-status img.loading2 {\n  animation: rotation 2s infinite linear;\n}\n\n.sync-v2-wrapper .sync-status .content .text-value {\n  color: #008060;\n  font-weight: 600;\n}\n\n.sync-v2-wrapper .sync-status .content .edit-schedule {\n  text-decoration: underline;\n  color: var(--p-interactive);\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.sync-v2-wrapper .sync-status .content .progress-sync {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.sync-v2-wrapper .sync-status .content .progress-sync .label {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.sync-v2-wrapper .sync-status .content .progress-sync .Polaris-ProgressBar {\n  height: 16px;\n}\n\n.sync-v2-wrapper\n  .sync-status\n  .content\n  .progress-sync\n  .Polaris-ProgressBar\n  .Polaris-ProgressBar__Indicator {\n  background-color: #008060;\n}\n\n.sync-v2-wrapper\n  .sync-status\n  .content\n  .progress-sync.wait-retry\n  .Polaris-ProgressBar\n  .Polaris-ProgressBar__Indicator {\n  background-color: #6d7175;\n}\n\n.sync-v2-wrapper .sync-status .content .progress-sync .Polaris-ProgressBar__Label {\n  display: none;\n}\n\n.sync-v2-wrapper .sync-status .content .progress-sync .label-process {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n}\n\n.sync-v2-wrapper .manual-sync {\n  width: 592px;\n}\n\n.sync-v2-wrapper .manual-sync .Polaris-Card {\n  height: 100%;\n}\n\n@media screen and (min-width: 1024px) {\n  .BC-Page__Sync .Polaris-Page {\n    max-width: 58.5rem;\n    padding: 0;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .sync-v2-wrapper .sync-status {\n    width: 34.18%;\n  }\n\n  .sync-v2-wrapper .manual-sync {\n    width: 63.25%;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .sync-v2-wrapper .sync-v2-wrapper-flex {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .sync-v2-wrapper .sync-status,\n  .sync-v2-wrapper .manual-sync {\n    width: 100%;\n  }\n}\n\n.sync-v2-wrapper .manual-sync .description {\n  color: #6d7175;\n  margin-top: 10px;\n  margin-bottom: 20px;\n}\n\n.sync-v2-wrapper .manual-sync .action {\n  display: flex;\n  gap: 15px;\n}\n\n.sync-v2-wrapper .sync-history .Polaris-DataTable thead tr th {\n  padding: 1rem 1.125rem;\n}\n\n.sync-v2-wrapper .sync-history .Polaris-DataTable tbody tr th {\n  padding: 1.125rem 1rem;\n}\n\n.sync-v2-wrapper .sync-history .Polaris-DataTable tbody tr td:last-child span {\n  font-size: 12px !important;\n}\n\n.sync-v2-wrapper .sync-history-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.sync-v2-wrapper .sync-history-header .action {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.sync-v2-wrapper .sync-history-header .action .Polaris-Button {\n  width: 160px;\n}\n\n.sync-v2-wrapper .sync-history-header .action .Polaris-Button .Polaris-Button__Content {\n  justify-content: space-between;\n}\n\n.sync-history-trigger-popover .Polaris-ActionList__Actions {\n  min-width: 170px !important;\n}\n\n.sync-v2-wrapper .syncInfoBanner {\n  border: 1px solid #95c9b4;\n  background: #f7fdfc !important;\n}\n\n.sync-v2-wrapper .sync-collections-priority {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.sync-v2-wrapper .sync-collections-priority .table {\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n}\n\n.sync-v2-wrapper .sync-collections-priority .table .table-header .row {\n  border-top: 0 !important;\n}\n\n.sync-v2-wrapper .sync-collections-priority .table .table-body {\n}\n\n.sync-v2-wrapper .sync-collections-priority .table .row {\n  display: flex;\n  border-top: 1px solid #e1e3e5;\n  padding: 10px 14px;\n  align-items: center;\n  gap: 20px;\n}\n\n.sync-v2-wrapper .sync-collections-priority .has-collection-delete-border,\n.sync-v2-wrapper .sync-collections-priority .has-collection-blank-border {\n  position: relative;\n}\n\n.sync-v2-wrapper\n  .sync-collections-priority\n  .has-collection-delete-border\n  .SelectCollection\n  [class*='css-'][class*='-control'],\n.sync-v2-wrapper\n  .sync-collections-priority\n  .has-collection-blank-border\n  .SelectCollection\n  [class*='css-'][class*='-control'] {\n  border: 1px solid #d82c0d;\n  border-radius: 6px;\n  background-color: #fff4f4;\n}\n\n.sync-v2-wrapper\n  .sync-collections-priority\n  .has-collection-blank-border\n  .SelectCollection\n  [class*='css-'][class*='-control'] {\n  border: 1px solid #1f5199;\n  border-radius: 6px;\n  background-color: var(--p-surface-selected);\n}\n\n.sync-v2-wrapper .sync-collections-priority .has-collection-delete-border .tooltip,\n.sync-v2-wrapper .sync-collections-priority .has-collection-blank-border .tooltip {\n  position: absolute;\n  max-width: 268px;\n  box-shadow: 0px 2px 10px 0px #0000001a;\n  background: white;\n  padding: 10px;\n  border-radius: 4px;\n  right: 0;\n  bottom: 50px;\n  z-index: 2;\n  opacity: 0;\n}\n\n.sync-v2-wrapper .sync-collections-priority .has-collection-delete-border:hover .tooltip,\n.sync-v2-wrapper .sync-collections-priority .has-collection-blank-border:hover .tooltip {\n  opacity: 1;\n}\n\n.sync-v2-wrapper .sync-collections-priority .table .row .item:first-child {\n  flex: 1;\n}\n\n.sync-v2-wrapper .sync-collections-priority .table .row .item:last-child {\n  width: 50px;\n  display: flex;\n  justify-content: center;\n}\n\n.sync-v2-wrapper .sync-collections-priority .table .row.action {\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 20px;\n}\n\n.sync-v2-wrapper .sync-collections-priority .table .row .add {\n  cursor: pointer;\n  color: #1f5199;\n}\n\n.sync-v2-wrapper .sync-collections-priority .table .row .add:hover {\n  text-decoration: underline;\n}\n\n.sync-v2-wrapper .sync-collections-priority .table .row .add.disabled {\n  color: #bdc1cc;\n  cursor: not-allowed;\n  text-decoration: none;\n}\n\n.sync-v2-wrapper .sync-collections-priority .table .Polaris-Button {\n  width: 28px;\n  height: 28px;\n  min-width: 28px;\n  min-height: 28px;\n  padding: 0;\n}\n\n.sync-v2-wrapper .sync-collections-priority .note a {\n  color: #2c6ecb;\n  text-decoration: none;\n}\n\n.sync-v2-wrapper .sync-schedule form {\n  max-width: 600px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.sync-v2-wrapper .sync-schedule .sync-select .default-text-style {\n  font-weight: 600 !important;\n}\n\n.sync-v2-wrapper .sync-schedule .sync-schedule-time .default-text-style {\n  font-weight: 400 !important;\n}\n\n.sync-v2-wrapper .sync-schedule .BC-Select--is-disabled .BC-Select__value-container--has-value div {\n  color: hsl(0, 0%, 60%) !important;\n}\n\n.sync-v2-wrapper .sync-schedule form .sync-schedule-time {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.sync-v2-wrapper .sync-schedule form .sync-schedule-time .item {\n  width: 50%;\n}\n\n.sync-v2-wrapper .sync-schedule form .sync-schedule-action {\n  display: flex;\n  gap: 10px;\n}\n\n.BC-Page__StandardSearch .BC-Page__SearchPageDisplay .BC-DataTable__SearchTerm {\n  margin-top: 16px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-DataTable__Product\n  .Polaris-DataTable__Cell:nth-child(4),\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-DataTable__SearchTerm\n  .Polaris-DataTable__Cell:nth-child(3) {\n  width: 50px;\n  text-align: center;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-DataTable__Product\n  .Polaris-DataTable__Cell:nth-child(4)\n  .Polaris-Button,\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-DataTable__SearchTerm\n  .Polaris-DataTable__Cell:nth-child(3)\n  .Polaris-Button {\n  width: 30px;\n  min-width: unset;\n  padding: 0;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-DataTable__Product\n  .Polaris-DataTable__Cell:nth-child(4)\n  .Polaris-Button\n  .Polaris-Button__Icon,\n.BC-Page__StandardSearch\n  .BC-Page__SearchPageDisplay\n  .BC-DataTable__SearchTerm\n  .Polaris-DataTable__Cell:nth-child(3)\n  .Polaris-Button\n  .Polaris-Button__Icon {\n  display: flex;\n}\n\n/*StandardSearch - RelevanceSettings*/\n\n/*StandardSearch - ManualSynonym*/\n.BC-Page__StandardSearch .BC-Page__Synonym {\n  margin-bottom: 20px;\n}\n\n.BC-Page__StandardSearch .BC-Page__Synonym .banner-unlock-addon .action-locked {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  font-weight: 500;\n}\n\n.BC-Page__StandardSearch .BC-Page__Synonym .introduce-ai-synonym {\n  box-shadow: none;\n  border-radius: 8px;\n  border: 1px solid var(--border-divider, #e1e3e5);\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-Page__StandardSearch .BC-Page__Synonym .introduce-ai-synonym > div:first-child {\n  display: flex;\n  gap: 8px;\n}\n\n.BC-Page__StandardSearch .BC-Page__Synonym .introduce-ai-synonym > div:last-child {\n  color: #2c6ecb;\n}\n\n.BC-Page__StandardSearch .BC-Page__Synonym .introduce-ai-synonym > div:last-child:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.manualSynonymInfos .image {\n  max-height: 152px;\n}\n\n/*StandardSearch - ManualSynonym*/\n\n/*StandardSearch - Stop Words*/\n.BC-Page__StandardSearch .BC-Page.BC-Page__StopWords .Polaris-Card {\n  box-shadow: none;\n}\n\n.BC-Page__StandardSearch .BC-Page.BC-Page__StopWords .Polaris-Card__Section {\n  padding: var(--p-space-5);\n  border: 1px solid var(--p-divider);\n}\n\n.BC-Page__StandardSearch .BC-Page.BC-Page__StopWords .BC-stop-words-list-wrapper {\n  width: 100%;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page.BC-Page__StopWords\n  .BC-stop-words-list-wrapper\n  .Polaris-Card__Section:last-child {\n  border-top: 0;\n}\n\n.BC-Page__StandardSearch .BC-Page.BC-Page__StopWords .Polaris-PageActions {\n  border-top: 0;\n}\n\n.BC-Page__StandardSearch .BC-Page__Redirect .BC__Search-header,\n.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .BC__Search-header,\n.BC-Page__StandardSearch .BC-Page__StopWords .BC__Search-header {\n  display: flex;\n  justify-content: space-between;\n  height: 15px;\n  align-items: center;\n}\n\n.BC-Page__StandardSearch .BC-Page__StopWords .BC__StopWords-Search .Polaris-TextField {\n  height: 30px;\n}\n\n.BC-Page__StandardSearch .BC__StopWords-Add .Polaris-Stack .Polaris-Stack__Item:first-child {\n  flex: 0 0 211px;\n}\n\n.BC-Page__StopWords .pfs-app-banner .image {\n  max-height: 116px;\n}\n\n.BC-Page__StandardSearch .BC-Page__StopWords .BC-Page__Title--Help {\n  margin-bottom: 0;\n}\n\n/*StandardSearch - Redirects*/\n.BC-Page__StandardSearch .BC-Page__Redirect .Polaris-Card .Polaris-Card__Section:nth-child(2) {\n  padding-top: 0;\n  border-top: none;\n}\n\n.BC-Page__StandardSearch .BC-Page.BC-Page__Redirect .Polaris-Card {\n  box-shadow: none;\n}\n\n.BC-Page__StandardSearch .BC-Page.BC-Page__Redirect .Polaris-Card__Section {\n  padding: var(--p-space-5);\n  border: 1px solid var(--p-divider);\n  margin: 0 -1px;\n}\n\n.BC-Page__StandardSearch .BC-Page__Redirect-New .Polaris-Card__Section {\n  padding-bottom: 0 !important;\n}\n\n.BC-Page__StandardSearch .BC-Page.BC-Page__Redirect .Polaris-PageActions {\n  border-top: 0;\n}\n\n.BC-Page__StandardSearch .BC-Page__Redirect .actionsGroup {\n  position: static;\n  margin-left: auto;\n}\n\n.BC-Page__StandardSearch .BC-Page__Redirect-New .addMoreSuggestion {\n  border: 1px solid var(--p-divider);\n  border-top: none;\n  border-bottom-left-radius: var(--p-border-radius-2);\n  border-bottom-right-radius: var(--p-border-radius-2);\n  margin: 0 -1px;\n}\n\n.BC-Page__StandardSearch .BC-Page__Redirect-New .Polaris-DataTable__Table thead th {\n  padding-top: 0;\n  padding-bottom: var(--p-space-5);\n}\n\n.BC-Page__StandardSearch .BC-Page__Redirect .search .Polaris-TextField {\n  height: 30px;\n}\n\n.BC-Page__StandardSearch .BC-Page__Redirect .list-header .Polaris-Stack__Item:nth-child(2) {\n  width: 50%;\n}\n\n.BC-Page__StandardSearch .BC-Page__Redirect .Polaris-DataTable {\n  margin: 0 -20px;\n}\n\n.BC-Page__StandardSearch .BC-Page__Redirect .newRedirect .Polaris-DataTable__Cell:first-child,\n.BC-Page__StandardSearch .BC-Page__Redirect .editRedirect .Polaris-DataTable__Cell:nth-child(2) {\n  width: 340px;\n  padding-right: 0;\n  padding-left: 16px;\n}\n\n.BC-Page__StandardSearch .BC-Page__Redirect .newRedirect .Polaris-DataTable__Cell:nth-child(2),\n.BC-Page__StandardSearch .BC-Page__Redirect .editRedirect .Polaris-DataTable__Cell:nth-child(3) {\n  padding-right: 0;\n  padding-left: 16px;\n  width: 456px;\n}\n\n.BC-Page__StandardSearch .BC-Page__Redirect .newRedirect .Polaris-DataTable__Cell:last-child,\n.BC-Page__StandardSearch .BC-Page__Redirect .editRedirect .Polaris-DataTable__Cell:last-child {\n  width: 68px;\n  padding-right: 16px;\n  padding-left: 16px;\n}\n\n.redirectsInfos .image {\n  max-height: 172px;\n}\n\n/*StandardSearch - Redirects*/\n\n/*StandardSearch - Suggestion dictionary*/\n.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .search .Polaris-TextField {\n  height: 30px;\n}\n\n.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .search {\n  width: 55%;\n  max-width: 424px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__SuggestionDictionary\n  .Polaris-Card\n  .Polaris-Card__Section:nth-child(2) {\n  padding-top: 0;\n  border-top: none;\n}\n\n.BC-Page__StandardSearch .BC-Page.BC-Page__SuggestionDictionary .Polaris-Card {\n  box-shadow: none;\n}\n\n.BC-Page__StandardSearch .BC-Page.BC-Page__SuggestionDictionary .Polaris-Card__Section {\n  padding: var(--p-space-5);\n  border: 1px solid var(--p-divider);\n}\n\n.BC-Page__StandardSearch .BC-Page.BC-Page__SuggestionDictionary .Polaris-Card__Header {\n  padding-top: 12px;\n  margin: 0 -20px;\n  padding-left: 36px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page.BC-Page__SuggestionDictionary\n  .Polaris-Card__Header\n  .Polaris-Heading {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page.BC-Page__SuggestionDictionary\n  .Polaris-Card__Header\n  .Polaris-Stack__Item {\n  margin: 0;\n}\n\n.BC-Page__StandardSearch .BC-Page.BC-Page__SuggestionDictionary .Polaris-PageActions {\n  border-top: 0;\n}\n\n.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .actionsGroup {\n  position: static;\n  margin-left: auto;\n}\n\n.BC-Page__SuggestionDictionary .Polaris-Stack {\n  align-items: center;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__SuggestionDictionary\n  .suggestion-list\n  .Polaris-Card\n  .Polaris-DataTable {\n  margin: 0 -20px;\n}\n\n.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .suggestion-list .display-title {\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n\n.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .suggestion-list .checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__SuggestionDictionary\n  .suggestion-list\n  .checkbox-label\n  .Polaris-Icon {\n  width: 12px;\n  height: 12px;\n}\n\n.BC-Page__StandardSearch\n  .BC-Page__NewSuggestionDictionary\n  .new-suggestion-wrap\n  .Polaris-DataTable__Table {\n  border-bottom: 1px solid var(--p-divider);\n}\n\n.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .new-suggestion-wrap {\n  border: 1px solid var(--p-divider);\n  border-radius: var(--p-border-radius-2);\n}\n\n.suggestionDictionaryInfos .image {\n  max-height: 132px;\n}\n\n.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .BC-Page__Title--Help {\n  margin-bottom: 0;\n}\n\n/*StandardSearch - Suggestion dictionary*/\n\n/*StandardSearch - ISW */\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .premium-iws-card {\n  border: 1px solid #e1b878;\n  background: #fff5ea;\n}\n\n.instantSearchWidgetInfo .image {\n  max-height: 132px;\n}\n\n.iswWithResultTabCustomBanner {\n  background-image: url('https://cdn.boostcommerce.io/assets/banners/background-banner-custom.png');\n  background-repeat: no-repeat;\n  background-position-y: bottom;\n}\n\n.iswWithResultTabCustomBanner .image img {\n  max-height: 116px;\n}\n\n/*StandardSearch - ISW*/\n\n/*AdvanceSearch - AI Synonym*/\n.synonym-filter-popover .select-entity {\n  padding-top: 10px;\n  padding-bottom: 15px;\n  border-bottom: 0.1rem solid var(--p-divider);\n}\n\n.synonym-filter-popover .action {\n  margin-top: 15px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.synonym-filter-popover .radio-group {\n  padding-top: 10px;\n  padding-bottom: 20px;\n}\n\n.synonym-filter-popover {\n  padding: 20px;\n}\n\n.aiSynonymInfos .image {\n  max-height: 136px;\n}\n\n.BC-Page__AdvancedSearch .tab-children .Polaris-Page-Header__Row {\n  display: flex;\n}\n\n.BC-Page__AdvancedSearch .tab-children .BC-Page__Title--Help,\n.BC-Page__StandardSearch .tab-children .BC-Page__Title--Help {\n  margin-bottom: 0;\n}\n\n.BC-Page__AdvancedSearch_General .ai-status {\n  margin-top: 16px;\n}\n\n.ai-search-update-status-warning ul li::marker {\n  font-size: 0.7rem;\n}\n\n.ai-search-update-status-warning a {\n  text-decoration: none;\n}\n\n.table-disabled {\n  pointer-events: none;\n  /* Disable all interactions */\n  opacity: 0.5;\n  /* Optional: Add opacity to show it's disabled */\n}\n\n.BC-Page__AdvancedSearch_General .toggle-status {\n  border: 1px solid var(--border-divider, #e1e3e5);\n  border-radius: 8px;\n  box-shadow: none;\n  padding: 20px;\n  display: flex;\n  margin-top: 16px;\n  margin-bottom: 20px;\n}\n\n.premium-lock-advanced-search {\n  width: 100%;\n  height: auto;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 24px;\n}\n\n.premium-lock-advanced-search .Polaris-Badge {\n  background: rgba(255, 48, 0, 0.1);\n  border-radius: 1000px;\n  padding: 4px 10px;\n  margin-bottom: 6px;\n  align-items: center;\n  text-align: center;\n}\n\n.premium-lock-advanced-search .Polaris-Badge span {\n  display: flex;\n  justify-content: space-between;\n  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  align-items: center;\n  text-align: center;\n  font-size: 12px;\n  gap: 2px;\n}\n\n.premium-lock-advanced-search .heading {\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 32px;\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.premium-lock-advanced-search .feature-list {\n  margin-top: 24px;\n}\n\n.premium-lock-advanced-search .feature-list .BC-Carousel .carousel-cards {\n  gap: 24px;\n}\n\n.premium-lock-advanced-search .feature-search-card {\n  width: 332px;\n  border-radius: 4px;\n  min-height: 200px;\n  padding-bottom: 20px;\n}\n\n.premium-lock-advanced-search .feature-search-card img {\n  max-width: 332px;\n  max-height: 200px;\n}\n\n.premium-lock-advanced-search .feature-search-card .content > div {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n  margin-top: 16px;\n}\n\n.premium-lock-advanced-search .feature-search-card .content > p {\n  margin-top: 4px;\n}\n\n.premium-lock-advanced-search .carousel-controls {\n  justify-content: center;\n}\n\n.premium-lock-advanced-search .carousel-controls .carousel-pagination > div {\n  background: #d2d5d8;\n}\n\n.premium-lock-advanced-search .carousel-controls .carousel-pagination--active > div {\n  background: #575959 !important;\n}\n\n.premium-lock-advanced-search .carousel-controls .carousel-pagination > div {\n  width: 8px;\n  height: 8px;\n}\n\n.premium-lock-advanced-search .BC-Carousel .carousel-controls button {\n  padding: 4px;\n}\n\n.premium-lock-advanced-search .feature-list .BC-Carousel .carousel-cards {\n}\n\n/*AdvanceSearch - AI Synonym*/\n\n.BC-Page__AdvancedSearch .Polaris-Header-Title__SubTitle {\n  color: #202223;\n}\n\n.page-title-wrapper {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.BC-Page__AdvancedSearch .page-title-wrapper {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.BC-Page__AdvancedSearch .page-title-wrapper .Polaris-Badge {\n  background: #ffebd3;\n  border-radius: 1000px;\n  background: rgba(255, 48, 0, 0.1);\n  padding: 4px 10px;\n}\n\n.BC-Page__AdvancedSearch .page-title-wrapper .Polaris-Badge > span {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.BC-Page__AdvancedSearch .page-title-wrapper .Polaris-Badge > span span {\n  text-align: center;\n  font-weight: 600;\n}\n\n.BC-Page__AdvancedSearch .layout-wrapper > .Polaris-Layout {\n  margin-top: 0;\n}\n\n.BC-Page__AdvancedSearch .BC-Container__Notifications .BC-Search__WarningBannerUpgrade {\n  margin-top: 0;\n  margin-bottom: 24px;\n}\n\n.BC-Page__StandardSearch\n  > .Polaris-Page\n  > div:not(.Polaris-Page-Header)\n  > .Polaris-Layout\n  > .Polaris-Layout__Section:first-child,\n.BC-Page__AdvancedSearch .layout-wrapper > .Polaris-Layout > .Polaris-Layout__Section:first-child {\n  margin-top: 24px !important;\n}\n\n.BC-Page__AdvancedSearch\n  .layout-wrapper\n  > .Polaris-Layout\n  .Polaris-Layout__Section:not(:first-child) {\n  margin-top: 0;\n}\n\n.BC-Page.AdvanceSearch__Content .incoming {\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 240px;\n}\n\n.BC-Page.AdvanceSearch__Content .incoming p {\n  font-size: 20px;\n  line-height: 28px;\n}\n\n/* AdvanceSearch - Semantic */\n.BC-Page .BC-Page__Semantic {\n  position: relative;\n  min-height: 550px;\n}\n\n.BC-Page .BC-Page__Semantic .Polaris-Layout {\n  margin-top: 16px;\n}\n\n.advance-feature-layout-disable {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  margin: auto;\n  min-height: 250px;\n}\n\n.advance-feature-layout-disable p:first-child {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.advance-feature-layout-disable p:last-child {\n  color: rgba(109, 113, 117, 1);\n  font-size: 14px;\n  margin-top: 8px;\n}\n\n.advance-feature-layout-disable .Polaris-Link {\n  text-decoration: none;\n}\n\n.advance-feature-layout-disable .Polaris-Icon {\n  margin: unset;\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.BC-Page .BC-Page__Semantic .enable-semantic-search {\n  height: 60px;\n  padding: 20px;\n  border-radius: 8px;\n  border: 1px solid #e1e3e5;\n  margin-top: 16px;\n}\n\n.BC-Page .BC-Page__Semantic .BC-Container__Notifications {\n  margin-bottom: -8px;\n}\n\n.BC-Page .BC-Page__Semantic .BC-Container__Notifications .Polaris-Banner__Content {\n  padding: 0;\n}\n\n.BC-Page .BC-Page__Semantic .semantic-setting {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.BC-Page .BC-Page__Semantic .semantic-setting .content {\n  width: 50%;\n  display: inline-grid;\n  gap: 4px;\n}\n\n.BC-Page .BC-Page__Semantic .title {\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.BC-Page .BC-Page__Semantic .semantic-setting .setting-weight {\n  width: 50%;\n}\n\n.BC-Page .BC-Page__Semantic .semantic-setting .Polaris-RangeSlider-SingleThumb__OutputBubble {\n  width: 350px;\n}\n\n.BC-Page .BC-Page__Semantic .semantic-setting .Polaris-RangeSlider-SingleThumb__OutputText {\n  text-transform: none;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.BC-Page .BC-Page__Semantic .semantic-simulator .content {\n  margin-top: 20px;\n  margin-bottom: 16px;\n  display: inline-grid;\n  gap: 4px;\n}\n\n.BC-Page .BC-Page__Semantic .semantic-simulator .product-list {\n  margin-top: 16px;\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.BC-Page .BC-Page__Semantic .semantic-simulator .product-list .with-semantic,\n.BC-Page .BC-Page__Semantic .semantic-simulator .product-list .without-semantic {\n  width: 50%;\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n}\n\n.BC-Page .BC-Page__Semantic .semantic-simulator .product-list .header {\n  padding: 12px 16px 12px 16px;\n  border-bottom: 1px solid #e1e3e5;\n  display: flex;\n  justify-content: space-between;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n.BC-Page .BC-Page__Semantic .semantic-simulator .product-list .with-semantic .header {\n  background-color: #fff5ea;\n}\n\n.BC-Page .BC-Page__Semantic .semantic-simulator .product-list .without-semantic .header {\n  background-color: #e1e3e5;\n}\n\n.BC-Page .BC-Page__Semantic .semantic-simulator .product-list .BC-Component-ProductList {\n  padding: 8px;\n  max-height: 480px;\n  overflow: auto;\n}\n\n.BC-Page .BC-Page__Semantic .divider {\n  margin-top: 20px !important;\n}\n\n.Polaris-Frame-Toast {\n  font-size: 16px;\n}\n\n/* AdvanceSearch - Semantic */\n\n/* AdvanceSearch - Product performance ranking */\n.BC-Page__ProductPerformanceRanking .Polaris-Layout__Section .Polaris-Card {\n  padding: 20px;\n  box-shadow: none;\n  border-radius: 8px;\n  border: 1px solid var(--border-divider, #e1e3e5);\n}\n\n.BC-Page__ProductPerformanceRanking .settings-infos {\n  display: grid;\n  gap: 12px;\n}\n\n.BC-Page__ProductPerformanceRanking .settings-infos .metric > span {\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.BC-Page__ProductPerformanceRanking .settings-infos .note {\n  margin-top: -4px;\n}\n\n.BC-Page__ProductPerformanceRanking .settings-infos .Polaris-Label__Text {\n  font-weight: 600;\n}\n\n.BC-Page__ProductPerformanceRanking .metric .content {\n  color: rgba(109, 113, 117, 1);\n  margin-top: 4px;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box {\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 8px;\n  height: 162px;\n  margin-top: 15px;\n  position: relative;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box .metric-box-content {\n  padding: 16px;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box.metric-box-high {\n  width: 41%;\n  background-color: #f5fffd;\n  border-color: #b6eadd;\n  margin-right: 15px;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box.metric-box-medium {\n  width: 28%;\n  background-color: #f0f7ff;\n  border-color: #b9d7f8;\n  margin-right: 7.5px;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box.metric-box-low {\n  width: 28%;\n  background-color: #fafafb;\n  border-color: #e1e3e5;\n  margin-left: 7.5px;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box-text {\n  border-radius: 6px;\n  display: inline-flex;\n  align-items: center;\n  text-align: center;\n  gap: 4px;\n  height: 100%;\n  padding: 2px 8px 2px 6px;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box-text.metric-box-text-high {\n  background-color: #dafbf3;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box-text.metric-box-text-medium {\n  background-color: #e4f7fa;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box-text.metric-box-text-low {\n  background-color: #edeeef;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box-text .metric-box-text-level-high {\n  color: #008060;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box-text .metric-box-text-level-medium {\n  color: #2c6ecb;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box-text .metric-box-text-level-low {\n  color: #6d7175;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box-description {\n  color: #6d7175;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box-description-high {\n  width: 70%;\n  bottom: 15px;\n  position: absolute;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box-description-medium {\n  padding-right: 10px;\n  bottom: 15px;\n  position: absolute;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box-description-low {\n  padding-right: 10px;\n  bottom: 15px;\n  position: absolute;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box-image-high {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box-image-medium {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n}\n\n.BC-Page__ProductPerformanceRanking .metric-box-image-low {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n}\n\n.BC-Page__ProductPerformanceRanking .weight-dot-high {\n  background: #007f5f;\n}\n\n.BC-Page__ProductPerformanceRanking .weight-dot-medium {\n  background: #2c6ecb;\n}\n\n.BC-Page__ProductPerformanceRanking .weight-dot-low {\n  background: #5c5f62;\n}\n\n.BC-Page__ProductPerformanceRanking .weight-dot {\n  border-radius: 50%;\n  height: 8px;\n  width: 8px;\n}\n\n.BC-Page__ProductPerformanceRanking .settings-infos .default-text-style > span:first-child {\n  font-weight: 600 !important;\n  line-height: 20px;\n}\n\n.BC-Page__ProductPerformanceRanking .settings-infos .default-text-style > span:first-child {\n  font-weight: 600 !important;\n  line-height: 20px;\n}\n\n.BC-Page__ProductPerformanceRanking .test-your-search {\n  display: flex;\n  position: relative;\n  padding: 16px 20px;\n  gap: 6px;\n  align-items: center;\n  background-color: #f2fbfd;\n  border-radius: 8px;\n}\n\n.BC-Page__ProductPerformanceRanking .test-your-search .wave-background-img {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n\n.BC-Page__ProductPerformanceRanking .test-your-search a {\n  color: #2c6ecb;\n  margin-right: 4px;\n  text-decoration: none;\n}\n\n.BC-Page__ProductPerformanceRanking .test-your-search .Polaris-Icon {\n  margin-left: 2px;\n}\n\n.BC-Page__ProductPerformanceRanking .product-preview {\n  margin-top: 20px;\n}\n\n.BC-Page__ProductPerformanceRanking .product-preview .content > span {\n  font-size: 16px;\n  margin-bottom: 4px;\n}\n\n.BC-Page__ProductPerformanceRanking .product-preview > div:not(:first-child) {\n  margin-top: 16px;\n}\n\n.BC-Page__ProductPerformanceRanking .BC-Component-ProductList .no-product {\n  color: rgba(109, 113, 117, 1);\n  padding: 16px;\n}\n\n/* End: AdvanceSearch - Product performance ranking */\n\n#menu-search-advanced-search .Polaris-Badge--statusWarning {\n  background-color: #ffebd3;\n  font-size: 12px;\n}\n\n#menu-search-advanced-search .Polaris-ActionList__Suffix {\n  margin-left: 4px;\n  position: relative;\n  top: 1px;\n}\n\n/* BFCM2023 css */\nbody:has(.BFCM23) #menu-tool-subscription {\n  background: -webkit-linear-gradient(left, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);\n  background: -o-linear-gradient(right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);\n  background: -moz-linear-gradient(right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);\n  background: linear-gradient(to right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\nbody:has(.BFCM23) #menu-tool-subscription .Polaris-Badge.Polaris-Badge--statusWarning {\n  color: white;\n  font-weight: bold;\n  font-size: 12px;\n  background: -webkit-linear-gradient(left, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);\n  background: -o-linear-gradient(right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);\n  background: -moz-linear-gradient(right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);\n  background: linear-gradient(to right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);\n  -webkit-text-fill-color: snow;\n}\n\n.BC-Subscription__DashboardV3--BFCM23 {\n  position: relative;\n}\n\n.BC-Subscription__DashboardV3--BFCM23 .Polaris-Card {\n  background: -webkit-linear-gradient(right, #d9e8ff, #ffffff, #ffeefc);\n  background: -o-linear-gradient(left, #d9e8ff, #ffffff, #ffeefc);\n  background: -moz-linear-gradient(left, #d9e8ff, #ffffff, #ffeefc);\n  background: linear-gradient(to left, #d9e8ff, #ffffff, #ffeefc);\n}\n\n.BC-Subscription__DashboardV3--BFCM23 .t-sale {\n  position: absolute;\n  right: 10px;\n  top: -10px;\n  z-index: 1;\n  width: 116px;\n}\n\n.BC-Subscription__DashboardV3--BFCM23 .t-semi {\n  position: absolute;\n  width: 18px;\n  height: 36px;\n  top: 55%;\n  z-index: 1;\n  background: rgba(246, 246, 247, 1);\n  box-shadow: inset 0 0 2px 0 #c7c7c7;\n}\n\n.BC-Subscription__DashboardV3--BFCM23 .t-semi:after {\n  position: absolute;\n  width: 18px;\n  height: 36px;\n  top: 0;\n  z-index: 2;\n  background: rgba(246, 246, 247, 1);\n  content: '';\n  display: block;\n}\n\n.BC-Subscription__DashboardV3--BFCM23 .t-left {\n  border-radius: 0 18px 18px 0;\n  left: 0;\n}\n\n.BC-Subscription__DashboardV3--BFCM23 .t-right {\n  border-radius: 18px 0px 0 18px;\n  right: 0;\n}\n\n.BC-Subscription__DashboardV3--BFCM23 .t-left::after {\n  border-radius: 0 18px 18px 0;\n  left: -2px;\n}\n\n.BC-Subscription__DashboardV3--BFCM23 .t-right::after {\n  border-radius: 18px 0px 0 18px;\n  right: -2px;\n}\n\n.BC-Subscription__DashboardV3--BFCM23 .t-line {\n  position: absolute;\n  width: calc(100% - 36px);\n  height: 1px;\n  border-bottom: 1px dashed rgba(225, 227, 229, 1);\n  top: calc(55% + 18px);\n  left: 50%;\n  z-index: 1;\n  transform: translateX(-50%);\n}\n\n.BC-Subscription__DashboardV3--BFCM23 .Polaris-Button.Polaris-Button--primary,\n.bfcm23-plan .Polaris-Button.Polaris-Button--primary {\n  background: -webkit-linear-gradient(left, #ff00e6, #3f00c6, #224fda, #00aaf2, #00e4e4);\n  background: -o-linear-gradient(right, #ff00e6, #3f00c6, #224fda, #00aaf2, #00e4e4);\n  background: -moz-linear-gradient(right, #ff00e6, #3f00c6, #224fda, #00aaf2, #00e4e4);\n  background: linear-gradient(to right, #ff00e6, #3f00c6, #224fda, #00aaf2, #00e4e4);\n  -webkit-text-fill-color: snow;\n}\n\n.BC-Subscription__DashboardV3--BFCM23 .Polaris-Button.Polaris-Button--primary:hover,\n.bfcm23-plan .Polaris-Button.Polaris-Button--primary:hover {\n  background: -webkit-linear-gradient(left, #3f00c6, #3716cb, #00aaf2, #ff00e6);\n  background: -o-linear-gradient(right, #3f00c6, #3716cb, #00aaf2, #ff00e6);\n  background: -moz-linear-gradient(right, #3f00c6, #3716cb, #00aaf2, #ff00e6);\n  background: linear-gradient(to right, #3f00c6, #3716cb, #00aaf2, #ff00e6);\n  -webkit-text-fill-color: snow;\n}\n\n.BC-Subscription__DashboardV3--BFCM23 .Polaris-Button.Polaris-Button--primary .Polaris-Button__Text,\n.bfcm23-plan .Polaris-Button.Polaris-Button--primary .Polaris-Button__Text {\n  display: flex;\n  align-items: center;\n}\n\n/* Css for banner dashboard */\n.BC-CampaignCarousel__DashboardV3\n  .BC-Carousel\n  .carousel-item:has(.banner-bfcm23):has(.banner-plan) {\n  background-image: url('https://cdn.boostcommerce.io/assets/common/BFCM-2023-banner-plan.png');\n}\n\n.BC-CampaignCarousel__DashboardV3\n  .BC-Carousel\n  .carousel-item:has(.banner-bfcm23):has(.banner-analytic) {\n  background-image: url('https://cdn.boostcommerce.io/assets/common/BFCM-2023-banner-analytic.png');\n}\n\n.BC-CampaignCarousel__DashboardV3 .BC-Carousel .carousel-item .banner-bfcm23 {\n  /* This will make the div clickable */\n  width: 100%;\n  height: 100%;\n}\n\n.packages div div:has(.bfcm23-package) {\n  padding-top: 70px;\n}\n\n.packages .Polaris-Card:has(.bfcm23-package) {\n  position: relative;\n  padding-top: 50px !important;\n}\n\n.packages .Polaris-Card:has(.bfcm23-package) .most-popular {\n  top: 25px !important;\n  z-index: 5;\n}\n\n/* Start: New pricing for expire/exceed */\n.packages.packages--expire-exceed div .Polaris-Card {\n  border: 1px solid var(--border-subdued, #c9cccf);\n  box-shadow: none;\n  border-radius: 8px !important;\n}\n\n.packages.packages--expire-exceed div div .Polaris-Card .package-tag {\n  height: 20px;\n  padding: 10px;\n  border-radius: 20px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #ffffff;\n  position: absolute;\n  top: -10px;\n  left: 33%;\n}\n\n.packages.packages--expire-exceed div .Polaris-Card:nth-child(2) {\n  border: 1px solid var(--border-subdued, #c9cccf);\n  box-shadow: none;\n  background: white;\n}\n\n.packages.packages--expire-exceed div .Polaris-Card:nth-child(2) .package-action .Polaris-Button {\n  color: #008060;\n}\n\n.packages.packages--expire-exceed div div .Polaris-Card .package-tag.most-popular {\n  background: #008060;\n}\n\n.packages.packages--expire-exceed div div .Polaris-Card .package-tag.current-plan {\n  border: 1px solid #008060;\n  background: white;\n  color: #008060;\n}\n\n.packages.packages--expire-exceed div div .Polaris-Card .package-tag.recommended {\n  background: #008060;\n}\n\n.packages.packages--expire-exceed\n  div\n  .Polaris-Card\n  .package-action\n  .Polaris-Button.Polaris-Button--primary {\n  color: white;\n  background: #008060;\n}\n\n.packages.packages--expire-exceed\n  div\n  .Polaris-Card\n  .package-action\n  .Polaris-Button.Polaris-Button--primary:hover {\n  background: var(--pc-button-color-hover);\n  color: var(--pc-button-text);\n}\n\n.packages.packages--expire-exceed\n  div\n  .Polaris-Card\n  .package-action\n  .Polaris-Button.Polaris-Button--disabled {\n  background: white;\n  color: var(--p-text-disabled);\n  border-color: var(--border-subdued, #c9cccf);\n}\n\n.packages.packages--expire-exceed\n  div\n  .Polaris-Card\n  .package-action\n  .Polaris-Button.Polaris-Button--primary.Polaris-Button--disabled {\n  background: var(--p-action-primary-disabled);\n  color: var(--p-text-disabled);\n  border-color: var(--p-action-primary-disabled);\n}\n\n.packages.packages--expire-exceed div .Polaris-Card {\n  border-radius: 8px;\n}\n\n.packages.packages--expire-exceed div .Polaris-Card:has(.highlight),\n.BC-Page__SubscriptionV3-Package\n  .packages.packages--expire-exceed\n  div\n  .Polaris-Card:has(.highlight) {\n  background: #f1f8f5;\n  border: 1px solid #008060;\n  border-radius: 8px;\n}\n\n.packages.packages--expire-exceed\n  div\n  .Polaris-Card:not(:nth-child(2))\n  .package-action\n  .Polaris-Button--primary:hover {\n  background: var(--pc-button-color-hover) !important;\n}\n\n.compare-action {\n  display: flex;\n  background: #fffbf3;\n  border-radius: 8px;\n  padding: 12px 20px;\n  margin-top: 20px;\n  justify-content: space-between;\n}\n\n.compare-action .text {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 6px;\n}\n\n.compare-action .Polaris-Button {\n  background: #ffc96b;\n}\n\n.compare-action .Polaris-Button:hover {\n  background: #ffd96b;\n}\n\n.packages.packages--expire-exceed > div > p span {\n  text-decoration: none;\n}\n\n.BC-Page__SubscriptionV3 .DidYouKnowBannerExceeded {\n  border: 1px solid #95c9b4;\n  background: #f7fdfc;\n}\n\n.BC-Page__SubscriptionV3 .DidYouKnowBannerExceeded .image {\n  margin-top: -20px;\n  margin-bottom: -30px;\n}\n\n/* End: New pricing for expire/exceed */\n.bfcm23-package {\n  position: absolute;\n  top: -32px;\n  left: -1px;\n  z-index: 3;\n  width: calc(100% + 2px);\n  height: 36px;\n  margin-top: 0px !important;\n}\n\n.bfcm23-package .text-discount {\n  width: 100%;\n  background: -webkit-linear-gradient(left, #ff00e6, #3f00c6, #00aaf2, #00e4e4);\n  background: -o-linear-gradient(right, #ff00e6, #3f00c6, #00aaf2, #00e4e4);\n  background: -moz-linear-gradient(right, #ff00e6, #3f00c6, #00aaf2, #00e4e4);\n  background: linear-gradient(to right, #ff00e6, #3f00c6, #00aaf2, #00e4e4);\n  color: white;\n  border-radius: 4px 4px 0 0;\n  height: 36px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n}\n\n.billing-title-code-bfcm23 {\n  background: -webkit-linear-gradient(left, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);\n  background: -o-linear-gradient(right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);\n  background: -moz-linear-gradient(right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);\n  background: linear-gradient(to right, #ff00e6, #3f00c6, #3716cb, #00aaf2, #00e4e4);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin-top: -5px;\n}\n\n.addon-card-preview .react-multi-carousel-item .Polaris-Card:has(.bfcm23-add-on-highlight) {\n  background: -webkit-linear-gradient(\n    right,\n    rgba(217, 232, 255, 0.51),\n    rgba(255, 255, 255, 0.62),\n    rgba(255, 238, 252, 1)\n  );\n  background: -o-linear-gradient(\n    left,\n    rgba(217, 232, 255, 0.51),\n    rgba(255, 255, 255, 0.62),\n    rgba(255, 238, 252, 1)\n  );\n  background: -moz-linear-gradient(\n    left,\n    rgba(217, 232, 255, 0.51),\n    rgba(255, 255, 255, 0.62),\n    rgba(255, 238, 252, 1)\n  );\n  background: linear-gradient(\n    to left,\n    rgba(217, 232, 255, 0.51),\n    rgba(255, 255, 255, 0.62),\n    rgba(255, 238, 252, 1)\n  );\n}\n\n.addon-card-preview\n  .react-multi-carousel-item\n  .Polaris-Card:has(.bfcm23-add-on-highlight)\n  .bfcm23-add-on-highlight {\n  position: relative;\n}\n\n.addon-card-preview\n  .react-multi-carousel-item\n  .Polaris-Card:has(.bfcm23-add-on-highlight)\n  .bfcm23-add-on-highlight\n  .offer-50 {\n  position: absolute;\n  top: -25px;\n  right: -30px;\n  z-index: 11;\n}\n\n.addon-card-preview\n  .react-multi-carousel-item\n  .Polaris-Card:has(.bfcm23-add-on-highlight)\n  .bfcm23-add-on-highlight\n  .Polaris-Button {\n  background: linear-gradient(to right, #ff00e6, #3f00c6, #224fda, #00aaf2, #00e4e4);\n  -webkit-text-fill-color: snow;\n}\n\n.addon-card-preview\n  .react-multi-carousel-item\n  .Polaris-Card:has(.bfcm23-add-on-highlight)\n  .bfcm23-add-on-highlight\n  .Polaris-Button:hover {\n  background: -webkit-linear-gradient(left, #3f00c6, #3716cb, #00aaf2, #ff00e6);\n  background: -o-linear-gradient(right, #3f00c6, #3716cb, #00aaf2, #ff00e6);\n  background: -moz-linear-gradient(right, #3f00c6, #3716cb, #00aaf2, #ff00e6);\n  background: linear-gradient(to right, #3f00c6, #3716cb, #00aaf2, #ff00e6);\n  -webkit-text-fill-color: snow;\n}\n\n.addon-card-preview\n  .react-multi-carousel-item\n  .Polaris-Card:has(.bfcm23-add-on-highlight)\n  .bfcm23-add-on-highlight\n  .Polaris-Button\n  .Polaris-Button__Text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.review-addon-modal .addon-billing .discount-code-info .discount-applied .code.bfcm23,\n.review-package-modal .package-billing .discount-code-info .discount-applied .code.bfcm23 {\n  background: none;\n  border: 0;\n}\n\n.review-addon-modal .addon-billing .discount-code-info .discount-applied .code.bfcm23 > div,\n.review-package-modal .package-billing .discount-code-info .discount-applied .code.bfcm23 > div {\n  display: flex;\n  align-items: center;\n}\n\n.review-addon-modal\n  .addon-billing\n  .discount-code-info\n  .discount-applied\n  .code\n  .Polaris-Button--iconOnly,\n.review-package-modal\n  .package-billing\n  .discount-code-info\n  .discount-applied\n  .code\n  .Polaris-Button--iconOnly {\n  position: static;\n}\n\n.review-addon-modal\n  .addon-billing\n  .discount-code-info\n  .discount-applied\n  .code.bfcm23\n  .Polaris-TextStyle--variationStrong,\n.review-package-modal\n  .package-billing\n  .discount-code-info\n  .discount-applied\n  .code.bfcm23\n  .Polaris-TextStyle--variationStrong {\n  color: #008060;\n  margin-right: 0;\n}\n\n.review-package-modal\n  .review-package\n  .Polaris-ChoiceList__ChoiceItem:has(input[aria-checked='true']) {\n  border: 1px solid #2c6ecb;\n}\n\n.review-package-modal .package-option {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.review-package-modal .package-option .Polaris-Choice {\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #c9cccf;\n}\n\n.review-package-modal .package-option .Polaris-Choice:has(input:checked) {\n  border: 1px solid #007f5f;\n}\n\n.review-package-modal .package-option .Polaris-Choice .Polaris-Choice__Control {\n  margin-right: 0;\n}\n\n.review-addon-modal:has(.review-addon-v2) {\n  width: 980px;\n  min-height: unset;\n}\n\n.review-addon-modal .review-addon-v2 {\n  width: 640px;\n  gap: 15px;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  border-right: 1px solid #e1e3e5;\n}\n\n.review-addon-modal .review-addon-v2 .heading {\n  height: 48px;\n  position: relative;\n}\n\n.review-addon-modal .review-addon-v2 .heading .title {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.review-addon-modal .review-addon-v2 .heading .detail-wrap {\n  width: auto;\n  display: inline-block;\n}\n\n.review-addon-modal .review-addon-v2 .heading .detail {\n  margin-top: 5px;\n  display: flex;\n  gap: 8px;\n  width: auto;\n  cursor: pointer;\n  color: #6d7175;\n  font-size: 12px;\n}\n\n.review-addon-modal .review-addon-v2 .heading .download {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-radius: 16px;\n  font-size: 12px;\n  background: #f6f6f7;\n}\n\n.review-addon-modal .review-addon-v2 .block {\n  padding: 10px 15px;\n  background: #f6f6f7;\n  border-radius: 8px;\n}\n\n.review-addon-modal .review-addon-v2 .block .title {\n  margin: 5px 0 10px 0;\n}\n\n.review-addon-modal .review-addon-v2 .block .list-addon-ui {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  grid-auto-rows: auto;\n  gap: 10px;\n}\n\n.review-addon-modal .review-addon-v2 .block .list-addon-ui > div {\n  display: flex;\n  justify-content: flex-start;\n  gap: 4px;\n  text-align: left;\n}\n\n.review-addon-modal .review-addon-v2 .block .list-addon-ui.has-2-col {\n  grid-template-rows: repeat(2, auto);\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.review-addon-modal .review-addon-v2 .block .list-addon-ui.has-3-col {\n  grid-template-rows: auto auto;\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.review-addon-modal .review-addon-v2 .block .list-addon-ui.has-1-col {\n  grid-template-rows: auto auto;\n  grid-template-columns: repeat(1, 1fr);\n}\n\n.review-addon-modal .review-addon-v2 .slide {\n  height: 200px;\n  position: relative;\n}\n\n.review-addon-modal .review-addon-v2 .slide ul.carousel-cards {\n  margin: 0;\n}\n\n.review-addon-modal .review-addon-v2 .slide ul.carousel-cards li {\n  width: 100%;\n}\n\n.review-addon-modal .review-addon-v2 .slide .slide-bg {\n  height: 200px;\n  position: relative;\n  background: linear-gradient(to right, #cff1ff, #fff0f9);\n  border-radius: 12px;\n}\n\n.review-addon-modal .review-addon-v2 .slide .slide-bg .title {\n  font-weight: 600;\n  font-size: 20px;\n  position: absolute;\n  top: 50px;\n  left: 30px;\n}\n\n.review-addon-modal .review-addon-v2 .slide .slide-bg .des {\n  font-weight: 400;\n  font-size: 14px;\n  position: absolute;\n  top: 80px;\n  left: 30px;\n  max-width: 294px;\n}\n\n.review-addon-modal .review-addon-v2 .slide .slide-bg .img {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.review-addon-modal .review-addon-v2 .slide .carousel-controls {\n  position: absolute;\n  bottom: 8px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.review-addon-modal .review-addon-v2 .slide .carousel-controls .carousel-btn {\n  display: none;\n}\n\n.review-addon-modal .review-addon-v2 .slide .carousel-controls .carousel-pagination {\n  padding: 4px;\n}\n\n.review-addon-modal .review-addon-v2 .slide .carousel-controls .carousel-pagination div {\n  border-radius: 50% !important;\n  display: block;\n  width: 8px;\n  height: 8px;\n  background: #d2d5d8;\n}\n\n.review-addon-modal\n  .review-addon-v2\n  .slide\n  .carousel-controls\n  .carousel-pagination.carousel-pagination--active\n  div {\n  border-radius: 50% !important;\n  display: block;\n  width: 8px;\n  height: 8px;\n  background: #575959 !important;\n}\n\n.review-addon-modal .review-addon-v2 .slide .slide-controls .btn-next,\n.review-addon-modal .review-addon-v2 .slide .slide-controls .btn-prev {\n  width: 28px;\n  display: none;\n}\n\n.review-addon-modal .review-addon-v2 .slide .slide-controls .btn-next > span {\n  top: 50%;\n  transform: translateY(-50%);\n  position: absolute;\n  margin-top: 0;\n}\n\n.review-addon-modal .review-addon-v2 .slide .slide-controls .btn-prev > span {\n  top: 50%;\n  transform: translateY(-50%);\n  position: absolute;\n  margin-top: 0;\n  left: 4px;\n}\n\n.review-addon-modal .review-addon-v2 .slide:hover .btn-next,\n.review-addon-modal .review-addon-v2 .slide:hover .btn-prev {\n  display: block;\n}\n\n.review-addon-modal .review-addon-v2 .slide:hover .hover::before {\n  display: block;\n  width: 24px;\n  height: 100%;\n  left: 0;\n  content: '';\n  position: absolute;\n  background: linear-gradient(to right, #ffffff, #cff1ff);\n  opacity: 0.65;\n}\n\n.review-addon-modal .review-addon-v2 .slide .carousel-item:hover .hover::after {\n  display: block;\n  width: 24px;\n  height: 100%;\n  right: 0;\n  content: '';\n  position: absolute;\n  background: linear-gradient(to right, #fff0f9, #ffffff);\n  opacity: 0.75;\n}\n\n/* BFCM2023 css end*/\n\n.BC-Component-ProductList .product {\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  border-radius: 8px;\n  gap: 14px;\n}\n\n.BC-Component-ProductList .no-product {\n  display: flex;\n  padding: 8px;\n  border-radius: 8px;\n  min-height: 270px;\n}\n\n.BC-Component-ProductList .product:hover {\n  background-color: #f6f6f7;\n  cursor: pointer;\n}\n\n.BC-Component-ProductList .product:hover .hover-view {\n  display: flex;\n}\n\n.BC-Component-ProductList .product:hover .product-info .product-title {\n  text-decoration: underline;\n}\n\n.BC-Component-ProductList .product .product-no {\n  min-width: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.BC-Component-ProductList .product .product-ranking {\n  border-radius: 4px;\n  border: 1px solid var(--Banner-Border-color-new-border, #babfc3);\n  background: var(--Banner-Background-color-new-bg, #fafafa);\n  display: flex;\n  width: 48px;\n  min-width: 48px;\n  height: 40px;\n  padding: 6px 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n}\n\n.BC-Component-ProductList .product .product-ranking-up {\n  border: 1px solid var(--Banner-Border-color-success-border, #95c9b4);\n  background: var(--Banner-Background-color-success-bg, #f7fdfc);\n  color: #008060;\n}\n\n.BC-Component-ProductList .product .product-ranking-up .Polaris-Icon svg {\n  fill: #008060;\n}\n\n.BC-Component-ProductList .product .product-ranking .Polaris-Icon {\n  min-width: 12px;\n  min-height: 12px;\n  width: 12px;\n  height: 12px;\n  margin: 1px 2px;\n}\n\n.BC-Component-ProductList .product .product-ranking-down .Polaris-Icon svg {\n  fill: #d72c0d;\n}\n\n.BC-Component-ProductList .product .product-ranking-down {\n  border: 1px solid var(--Banner-Border-color-critical-border, #e0b3b2);\n  background: var(--Banner-Background-color-critical-bg, #fff4f4);\n  color: #d72c0d;\n}\n\n.BC-Component-ProductList .product .product-image {\n  border: 1px solid #c9cccf;\n  border-radius: 4px;\n  width: 48px;\n  height: 48px;\n  min-width: 48px;\n  display: flex;\n  justify-content: center;\n}\n\n.BC-Component-ProductList .product .product-image img {\n  width: auto;\n  height: auto;\n  max-height: 100%;\n  max-width: 100%;\n}\n\n.BC-Component-ProductPrice .price-compare {\n  color: #8c9196;\n  margin-left: 5px;\n}\n\n.BC-Component-ProductPrice .price-sale {\n  color: #d72c0d;\n}\n\n.BC-Component-ProductList .product .product-info {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.BC-Component-ProductList .product:not(:first-child) .product-info {\n  padding: 8px;\n}\n\n.BC-Component-ProductList .load-more {\n  padding: 8px;\n  display: flex;\n  justify-content: center;\n}\n\n.BC-Component-ProductList .product .hover-view {\n  min-width: 42px;\n  margin-left: auto;\n  display: none;\n}\n\n.BC-Component-ProductDetail {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.BC-Component-ProductDetail .product-image {\n  width: 35%;\n}\n\n.BC-Component-ProductDetail .product-image img {\n  width: 100%;\n  height: auto;\n}\n\n.BC-Component-ProductDetail .product-info {\n  width: 65%;\n}\n\n.BC-Component-ProductDetail .product-info .product-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #222222;\n  margin-bottom: 5px;\n}\n\n.BC-Component-ProductDetail .product-info .product-vendor {\n  font-size: 12px;\n  color: #6d7175;\n  margin-bottom: 5px;\n}\n\n.BC-Component-ProductDetail .product-info .product-data {\n  margin-top: 20px;\n}\n\n.BC-Component-ProductDetail .product-info .product-data .field-name {\n  font-weight: 600;\n}\n\n.BC-Component-ProductDetail .product-info .product-data .field-value {\n  color: #6d7175;\n  margin-top: 8px;\n}\n\n.BC-Component-ProductDetail .product-info .product-data .field-value .Polaris-Badge {\n  margin-right: 8px;\n  margin-bottom: 8px;\n  font-size: 12px;\n}\n\n.BC-Component-ProductDetail .product-info .product-data .field-value:has(.Polaris-Badge) {\n  margin-bottom: -8px;\n}\n\n/* Lucky draw: START */\n.lucky-modal-container {\n  min-height: 600px;\n}\n\n.lucky-modal-container .close {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  z-index: 9;\n  cursor: pointer;\n}\n\n.lucky-modal-container .ReactTypeformEmbed {\n  border-radius: 8px;\n}\n\nbody:has(.lucky-modal-container) .Polaris-Modal-Section {\n  padding: 0;\n}\n\n/* Lucky draw: END */\n\n/*Search Engine Control start*/\n.BC-Page__SearchControl .Polaris-Page {\n  max-width: 1152px;\n}\n\n.BC-Page__SearchControl .layout-wrapper {\n  margin-top: 20px;\n}\n\n.BC-Page__SearchControl .BC-GuideBanner {\n  margin-top: 24px !important;\n}\n\n.BC-Container__Translation .BC-GuideBanner {\n  margin-top: 0 !important;\n}\n\n.SearchControl__Content table {\n  border: 1px solid var(--p-divider);\n  border-radius: 8px;\n  margin-top: 20px;\n}\n\n.BC-Page__SearchControl .Polaris-Layout__Section:first-child {\n  margin-top: 0;\n}\n\n.BC-Page__SearchControl .Polaris-Layout__Section:not(:first-child) {\n  margin-top: 24px;\n}\n\n.SearchControl__Content table thead td {\n  font-weight: 600;\n}\n\n.SearchControl__Content table tbody td {\n  padding: 16px;\n}\n\n.SearchControl__Content .table-features .feature-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.SearchControl__Content .table-features .feature-wrapper .Polaris-Badge > span {\n  display: flex;\n  align-items: center;\n  grid-gap: 4px;\n  gap: 4px;\n  font-size: 12px;\n}\n\n.SearchControl__Content .table-features .action .settings-icon .Polaris-Icon,\n.SearchControl__Content .table-features .action img {\n  width: 16px;\n  height: 16px;\n}\n\n.SearchControl__Content .table-features .action .unlock-button {\n  display: flex;\n  gap: 4px;\n  border: 1px solid #e1b878;\n  border-radius: 4px;\n  padding: 4px 10px;\n  cursor: pointer;\n}\n\n.SearchControl__Content .table-features .action .unlock-button-disabled {\n  background: #f7f3ef !important;\n  border: 1px solid #d1d1d1;\n  color: gray !important;\n  cursor: unset;\n}\n\n.SearchControl__Content .table-features .action .unlock-button-disabled .Polaris-Icon svg {\n  fill: var(--p-icon);\n}\n\n.SearchControl__Content .table-features .action .unlock-button .Polaris-Icon {\n  height: 20px;\n  width: 20px;\n}\n\n.SearchControl__Content .table-features .action .wrap-icon {\n  width: 28px;\n  height: 28px;\n  border: 1px solid #c9cccf;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.SearchControl__Content .table-features .action .wrap-icon:first-child {\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n\n.SearchControl__Content .table-features .action .wrap-icon:nth-child(2) {\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n  border-left: none;\n}\n\n.SearchControl__Content .table-features .action .wrap-icon-disabled .Polaris-Icon__Svg {\n  fill: #babec3;\n}\n\n.SearchControl__Content .table-features .wrap-icon-disabled img {\n  filter: invert(77%) sepia(5%) saturate(229%) hue-rotate(173deg) brightness(101%) contrast(85%);\n}\n\n.SearchControl__Content .table-features .Polaris-Badge--statusNew .Polaris-Badge-Pip {\n  background-color: #6d7175;\n}\n\n.SearchControl__Content .table-features .Polaris-Badge--statusNew {\n  background-color: #f1f2f3;\n}\n\n.SearchControl__Content .table-features .type-wrapper .Polaris-Badge {\n  border-radius: 2px;\n}\n\n.SearchControl__Content .table-features .Polaris-Badge {\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.control-lock-tooltip .Polaris-Icon {\n  margin: unset;\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.control-lock-tooltip .Polaris-Link {\n  text-decoration: none;\n}\n\n.Search-Control-Table tbody .Polaris-DataTable__TableRow:hover {\n  background: rgba(246, 246, 247, 1);\n  cursor: pointer;\n}\n\n.Search-Control-Table tbody .group-heading:hover,\n.Search-Control-Table .group-heading {\n  color: rgba(109, 113, 117, 1);\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  background: rgba(250, 251, 251, 1);\n}\n\n.Search-Control-Table .group-heading td {\n  padding: 12px 16px !important;\n}\n\n.Search-Control-Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:first-child {\n  width: 35%;\n}\n\n.Search-Control-Table tbody .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:first-child {\n  padding: unset;\n}\n\n.Search-Control-Table .Polaris-DataTable__TableRow .type-wrapper {\n  color: rgba(32, 34, 35, 1);\n}\n\n.Search-Control-Table tbody .Polaris-DataTable__TableRow .feature-wrapper {\n  padding: 16px 16px 16px 32px;\n}\n\n.Search-Control-Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:nth-child(2) {\n  width: 28%;\n}\n\n.Search-Control-Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:nth-child(3) {\n  width: 18%;\n}\n\n.Search-Control-Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:nth-child(4) {\n  text-align: center;\n}\n\n.BC-Page__Synonym .Polaris-Header-Title .Polaris-Badge {\n  font-size: 10px;\n  line-height: 14px;\n  margin-left: 4px;\n}\n\n.BC-Page__Synonym .Polaris-Header-Title .Polaris-Badge > span {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC_VerticalTab_Wrapper .badge-ai .Polaris-Badge,\n.BC-Page__Synonym .Polaris-Header-Title .Polaris-Badge,\n.SearchControl__Content .table-features .feature-wrapper .Polaris-Badge {\n  background: rgba(255, 48, 0, 0.1);\n}\n\n.BC_VerticalTab_Wrapper .badge-ai .Polaris-Badge > span,\n.BC-Page__Synonym .Polaris-Header-Title .Polaris-Badge > span,\n.SearchControl__Content .table-features .feature-wrapper .Polaris-Badge > span {\n  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: 600;\n}\n\n.search-control-lock-banner {\n  position: relative;\n  border-radius: 8px;\n  width: 100%;\n  padding: 20px;\n  border: 1px solid var(--Banner-Border-color-warning-border, #e1b878);\n  background: var(--Banner-Background-color-warning-bg, #fffbf3);\n}\n\n.search-control-lock-banner > .Polaris-Button {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n}\n\n.search-control-lock-banner .title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.search-control-lock-banner .body {\n  display: flex;\n  gap: 36px;\n}\n\n.search-control-lock-banner .content {\n  display: grid;\n  gap: 20px;\n  margin-top: 4px;\n  margin-bottom: 16px;\n}\n\n/*Search Engine Control end*/\n\n/*Enhance AI Search Banner start*/\n.enhance-ai-search-banner .Polaris-Banner__ContentWrapper .Polaris-Banner__Heading {\n  display: flex;\n}\n\n.enhance-ai-search-banner .Polaris-Banner__ContentWrapper .Polaris-Banner__Heading:before {\n  content: url('https://cdn.boostcommerce.io/assets/subscription-v3/rocket.png');\n  margin-right: 6px;\n}\n\n.enhance-ai-search-banner .Polaris-Banner__Ribbon {\n  display: none;\n}\n\n.enhance-ai-search-banner .Polaris-Banner__Button {\n  border: 0;\n  background: #ffc96b !important;\n  box-shadow: 0px -1px 0px 0px #00000033 inset;\n}\n\n.BC-Analytic--RecommendedFeatures .action-locked,\n.enhance-ai-search-banner .action-locked {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  font-weight: 500;\n}\n\n.enhance-ai-search-banner .banner-content {\n  display: flex;\n}\n\n.enhance-ai-search-banner .banner-content img {\n  width: 240px;\n  height: 132px;\n}\n\n.enhance-ai-search-banner .Polaris-Banner__Actions {\n  margin-top: -20px;\n}\n\n.enhance-ai-search-banner .Polaris-Banner__Actions .Polaris-Banner__SecondaryAction {\n  text-decoration: underline;\n}\n\n.enhance-ai-search-banner .Polaris-Banner__Actions .Polaris-Banner__SecondaryAction:hover,\n.enhance-ai-search-banner\n  .Polaris-Banner__Actions\n  .Polaris-Banner__SecondaryAction:hover\n  > .Polaris-Banner__Text {\n  text-decoration: none;\n}\n\n.enhance-ai-search-banner .Polaris-Banner {\n  --pc-banner-background: #fffbf3;\n  --pc-banner-border: #e1b878;\n  border: 1px solid #e1b878;\n}\n\n.enhance-ai-search-banner .Polaris-Banner--hasDismiss {\n  padding-right: var(--p-space-5);\n}\n\n.enhance-ai-search-banner .Polaris-Banner--hasDismiss .Polaris-Banner__Dismiss {\n  right: 20px;\n}\n\n.enhance-ai-search-banner-disabled .Polaris-Banner__Button {\n  border: 1px solid #d1d1d1 !important;\n  background: #f7f3ef !important;\n  box-shadow: none;\n}\n\n.enhance-ai-search-banner .banner-content .description > ul {\n  padding-left: 20px;\n  margin-top: 2px;\n}\n\n@media (min-width: 1095px) {\n  .enhance-ai-search-banner .banner-content .description {\n    height: 120px !important;\n  }\n}\n\n@media (max-width: 1094px) {\n  .enhance-ai-search-banner .banner-content .description {\n    min-height: 130px !important;\n  }\n}\n\n@media (max-width: 943px) {\n  .enhance-ai-search-banner .banner-content .description {\n    min-height: 140px !important;\n  }\n}\n\n@media (max-width: 849px) {\n  .enhance-ai-search-banner .banner-content .description {\n    min-height: 190px !important;\n  }\n}\n\n@media (max-width: 782px) {\n  .enhance-ai-search-banner .banner-content .description {\n    min-height: 220px !important;\n  }\n\n  .enhance-ai-search-banner .Polaris-Banner__Actions {\n    margin-top: 0px;\n  }\n}\n\n/*Enhance AI Search Banner end*/\n\n/* START: Year end review in app popup */\n.PFS-YEP-Popup-Container .Polaris-Backdrop {\n  z-index: 529;\n}\n\ndiv > :has(.TermAndCondition) + .Polaris-Backdrop {\n  z-index: 519;\n  background: rgba(0, 0, 0, 0.7);\n}\n\ndiv:has(.TermAndCondition) {\n  z-index: 520;\n}\n\n.PFS-YEP-Popup-Container .Polaris-Modal-Dialog__Container {\n  z-index: 530;\n}\n\n.PFS-YEP-Popup-Container .Polaris-Modal-Dialog__Modal {\n  min-width: 816px !important;\n  max-width: 816px !important;\n}\n\n.PFS-YEP-Popup {\n  position: relative;\n  width: 816px;\n  height: 530px;\n  overflow: hidden;\n}\n\n.PFS-YEP-Popup map {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.PFS-YEP-Popup img {\n  width: 816px;\n  height: 532px;\n}\n\n.PFS-YEP-Popup .closeBtn {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n}\n\n.BC-Component__SearchGuideTour {\n  color: #6d7175;\n}\n\n.BC-Component__SearchGuideTour .Trigger {\n  display: flex;\n  cursor: pointer;\n}\n\n.BC-Component__SearchGuideTour .hidden {\n  display: none;\n  visibility: hidden;\n}\n\n.GuideTour__Step .Step__Gif img {\n  width: 380px;\n  height: 220px;\n  border-radius: 8px 8px 0 0;\n}\n\n.GuideTour__Step .Step__Content {\n  padding: 16px 20px;\n}\n\n.Step__Content .Heading {\n  font-size: 20px;\n  line-height: 28px;\n  font-weight: 400;\n\n  color: #202223;\n}\n\n.Step__Content .Description {\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 400;\n\n  color: #6d7175;\n}\n\n.GuideTour__Step .Step__Navigation {\n  border-top: 1px solid #e1e3e5;\n\n  padding: 16px 20px;\n}\n\n.Step__Navigation .Navigation__Container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.Step__Navigation .Navigation__Container p {\n  color: #6d7175;\n}\n\n.BC-Component__SearchWelcomePopup {\n  position: relative;\n  width: 620px;\n}\n\n.BC-Component__SearchWelcomePopup .SearchWelcomePopup__Banner img {\n  width: 100%;\n}\n\n.SearchWelcomePopup__Close {\n  position: absolute;\n  right: 24px;\n  top: 24px;\n\n  cursor: pointer;\n}\n\n.BC-Component__SearchWelcomePopup .SearchWelcomePopup__Content {\n  padding: 24px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  color: #202223;\n}\n\n.SearchWelcomePopup__Content .title {\n  font-size: 20px;\n  line-height: 28px;\n  font-weight: 400;\n}\n\n.SearchWelcomePopup__Content .description {\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 400;\n}\n\n/* New guide on dashboard */\n\n.BC-QuickStartGuideV2__DashboardV3 .GuideMenu .GuideMenu__Activator {\n  cursor: pointer;\n  border-radius: 4px;\n  padding: 2px;\n}\n\n.BC-QuickStartGuideV2__DashboardV3 .GuideMenu .GuideMenu__Activator:hover {\n  background-color: #f6f6f7;\n}\n\n.BC-QuickStartGuideV2__DashboardV3 .heading {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-QuickStartGuideV2__DashboardV3 .description-progress-percent {\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 15px;\n  gap: 20px;\n}\n\n.BC-QuickStartGuideV2__DashboardV3 .description-progress-percent .description {\n  flex-grow: 1;\n}\n\n.BC-QuickStartGuideV2__DashboardV3 .description-progress-percent .progress {\n  width: 210px;\n}\n\n.BC-QuickStartGuideV2__DashboardV3 .description-progress-percent .percent {\n  width: unset;\n  text-align: right;\n}\n\n.BC-QuickStartGuideV2__DashboardV3.V4 .Polaris-Card__Section {\n  padding: 0;\n}\n\n.BC-QuickStartGuideV2__DashboardV3.V4 .GuideHeader {\n  display: flex;\n  justify-content: flex-start;\n  gap: 10px;\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.BC-QuickStartGuideV2__DashboardV3.V4 .GuideHeader,\n.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2List,\n.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2Dismiss {\n  padding: var(--p-space-5);\n}\n\n.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2List,\n.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2Dismiss {\n  margin-top: 0;\n}\n\n.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2Item {\n  background: #fafbfb;\n  border: 0;\n}\n\n.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2Item.open {\n  background: #fafbfb;\n}\n\n.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2Item.open .GuideV2ItemStep.open {\n  background: #f1f8f5;\n}\n\n.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2Item .GuideV2Item__Activator:hover,\n.BC-QuickStartGuideV2__DashboardV3.V4\n  .GuideV2Item.open\n  .GuideV2ItemStep\n  .GuideV2ItemStep__Activator:hover {\n  background: #f1f8f5;\n}\n\n.BC-QuickStartGuideV2__DashboardV3.V4 .GuideV2Done {\n  padding: 0 20px 20px 20px;\n}\n\n.BC-SyncHookStatus__DashboardV3.V4 .progress-status {\n  margin-top: 0;\n}\n\n.BC-SyncHookStatus__DashboardV3.V4 .progress-label {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 6px;\n}\n\n.BC-SyncHookStatus__DashboardV3.V4 .Polaris-Link,\n.BC-ChangeLogs__Dashboard.V4 .Polaris-Link {\n  text-decoration: none;\n}\n\n.BC-HelpAndSupport__DashboardV3.V4 .Polaris-Card__Section,\n.BC-ResourceCenter__DashboardV3.V4 .Polaris-Card__Section,\n.BC-ChangeLogs__Dashboard.V4 .Polaris-Card__Section {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.BC-HelpAndSupport__DashboardV3__HelpCenter .Polaris-Card__Section .Polaris-Button__Text {\n  gap: 6px;\n}\n\n.BC-HelpAndSupport__DashboardV3__HelpCenter .schedule-demo {\n  margin-bottom: 6px;\n  margin-top: 6px;\n}\n\n.BC-HelpAndSupport__DashboardV3__HelpCenter .schedule-demo .Polaris-Button {\n  width: 100%;\n}\n\n.BC-HelpAndSupport__DashboardV3__HelpCenter .action-help {\n  display: flex;\n  gap: 16px;\n}\n\n.BC-HelpAndSupport__DashboardV3.V4 .action,\n.BC-ResourceCenter__DashboardV3.V4 .action {\n  display: flex;\n  justify-content: 'space-between';\n  margin-top: '10px';\n  gap: 10px;\n}\n\n.BC-RecommendedApps__DashboardV3.V4 .Polaris-Card__Section {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.BC-CrossSellUpSell__DashboardV3.V4 .action .Polaris-Link {\n  text-decoration: none;\n}\n\n.BC-CrossSellUpSell__DashboardV3.V4 .card {\n  text-decoration: none;\n  padding: 12px 16px 12px 16px;\n  background: #fafbfb;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-height: unset;\n}\n\n.BC-CrossSellUpSell__DashboardV3.V4 .card:hover {\n  background: var(--p-action-secondary-hovered);\n}\n\n.BC-CrossSellUpSell__DashboardV3.V4 .card .head {\n  display: flex;\n  gap: 4px;\n  font-size: 14px;\n  align-items: center;\n  color: #202223;\n  font-weight: 600;\n}\n\n.BC-CrossSellUpSell__DashboardV3.V4 .card .icon {\n  background: #f1f8f5;\n  padding: 8px;\n  border-radius: 8px;\n  width: 34px;\n  height: 34px;\n}\n\n.BC-CrossSellUpSell__DashboardV3.V4 .card .btn {\n  font-weight: 400;\n  font-size: 14px;\n  color: #2c6ecb;\n}\n\n.BC-CrossSellUpSell__DashboardV3.V4 .card .btn:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.BC-CrossSellUpSell__DashboardV3.V4 .card.store {\n  background: #f1f8f5;\n}\n\n.BC-CrossSellUpSell__DashboardV3.V4 .card.store .icon {\n  background: #00a47c;\n}\n\n.BC-CrossSellUpSell__DashboardV3.V4 .card.store:hover {\n  background: #e5fbf2;\n}\n\n.GuideV2List {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  overflow: hidden;\n  margin-top: 20px;\n}\n\n.GuideV2List.Collapsing {\n  animation-name: collapsing;\n  animation-duration: 1s;\n}\n\n.BC-PlanSubscription__DashboardV3 .Polaris-Card__Section {\n  padding: 0;\n}\n\n.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3,\n.BC-PlanSubscription__DashboardV3 .BC-CrossSellUpSell__DashboardV3 {\n  padding: var(--p-space-5);\n}\n\n.BC-PlanSubscription__DashboardV3 .BC-CrossSellUpSell__DashboardV3 {\n  border-top: 1px solid #e1e3e5;\n}\n\n.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3 .subscribe__action {\n  position: unset;\n}\n\n.BC-PlanSubscription__DashboardV3\n  .BC-Subscription__DashboardV3\n  .subscribe-bolton__action\n  .Polaris-Button {\n  min-width: 116px;\n}\n\n.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3 .subscribe__bottom {\n  display: flex;\n}\n\n.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3 .subscribe__bottom > p {\n  flex-grow: 1;\n}\n\n.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3 .current-package {\n  gap: 8px;\n  display: inline-flex;\n  margin-bottom: 5px;\n}\n\n.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3 .current-package .Polaris-Badge {\n  border-radius: 8px;\n  padding: 2px 8px;\n  height: 20px;\n}\n\n.BC-PlanSubscription__DashboardV3\n  .BC-Subscription__DashboardV3\n  .current-package\n  .Polaris-Badge\n  > span {\n  font-weight: 500;\n}\n\n.BC-PlanSubscription__DashboardV3\n  .BC-Subscription__DashboardV3\n  .current-package\n  .Polaris-Badge--statusCritical\n  span {\n  color: #8e1f0b;\n}\n\n.BC-PlanSubscription__DashboardV3\n  .BC-Subscription__DashboardV3\n  .current-package\n  .Polaris-Badge--statusSucces {\n  background-color: #cdfee1;\n  color: #0c5132;\n}\n\n.BC-PlanSubscription__DashboardV3\n  .BC-Subscription__DashboardV3\n  .current-package\n  .Polaris-Badge--statusWarning {\n  background-color: #ffea8a;\n  color: #4f4700;\n}\n\n.BC-PlanSubscription__DashboardV3\n  .BC-Subscription__DashboardV3\n  .subscribe__bottom\n  .subscribe__action {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3.has-coupon {\n  background: linear-gradient(\n    271.85deg,\n    rgba(244, 187, 64, 0.1) 9.09%,\n    rgba(255, 102, 167, 0.06) 94.53%\n  );\n}\n\n.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3 .subscription-freemium-title {\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: 0px;\n  padding-bottom: 0.75rem;\n}\n\n.BC-PlanSubscription__DashboardV3 .BC-Subscription__DashboardV3 .text-color {\n  background: linear-gradient(90deg, #ff4151 22.71%, #ff9300 37.95%);\n  background-clip: content-box;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.BC-PlanSubscription__DashboardV3\n  .BC-Subscription__DashboardV3.has-coupon\n  .subscribe__action\n  button {\n  background: linear-gradient(179.82deg, #fb5f4b 5.79%, #fe384f 99.05%);\n}\n\n.BC-BoostInsightsHub__DashboardV3 .BC-Carousel .carousel-item > div,\n.BC-BoostInsightsHub__DashboardV3 .BC-Carousel .carousel-item > div .card {\n  height: 100%;\n}\n\n.BC-BoostInsightsHub__DashboardV3 .BC-Carousel .carousel-cards {\n  grid-gap: 12px;\n}\n\n.BC-BoostInsightsHub__DashboardV3 .BC-Carousel .carousel-item {\n  width: calc((100% - calc(12px * 2)) / 3);\n  height: 254px;\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.BC-BoostInsightsHub__DashboardV3 .BC-Carousel .card:hover {\n  cursor: pointer;\n  box-shadow: var(--p-shadow-card);\n  background: var(--p-action-secondary-hovered);\n}\n\n.BC-BoostInsightsHub__DashboardV3 .BC-Carousel .card .img {\n  width: 100%;\n  height: 166px;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.BC-BoostInsightsHub__DashboardV3 .BC-Carousel .card .img img {\n  width: 100%;\n  object-fit: contain;\n}\n\n.BC-BoostInsightsHub__DashboardV3 .BC-Carousel .card .title {\n  padding: 14px;\n  padding-top: 10px;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 20px;\n  height: 70px;\n}\n\n.BC-BoostInsightsHub__DashboardV3 .Polaris-Link {\n  text-decoration: none;\n  color: rgb(32, 34, 35);\n  padding: 4px 16px;\n}\n\n.BC-BoostInsightsHub__DashboardV3 .Polaris-Link {\n  text-decoration: none;\n  color: rgb(32, 34, 35);\n  padding: 8px 16px;\n  outline: none;\n}\n\n.BC-BoostInsightsHub__DashboardV3__Action {\n  margin-top: 8px;\n}\n\n.BC-BoostInsightsHub__DashboardV3 .BC-BoostInsightsHub__DashboardV3__Action .Polaris-Button {\n  padding: 0;\n}\n\n.BC-RecommendedApps__DashboardV3.V4 .item {\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 288px;\n  padding: 16px;\n  background: #fafbfb;\n  border-radius: 4px;\n  gap: 10px;\n  align-items: center;\n}\n\n.BC-RecommendedApps__DashboardV3.V4 .item:hover {\n  background: var(--p-action-secondary-hovered);\n}\n\n.BC-RecommendedApps__DashboardV3.V4 .item .icon {\n  width: 40px;\n  height: 40px;\n  width: 40px;\n}\n\n.BC-RecommendedApps__DashboardV3.V4 .item .title {\n  font-weight: 600;\n  font-size: 14px;\n  color: #202223;\n  flex-grow: 1;\n  max-width: calc(100% - 50px);\n  height: 40px;\n}\n\n.BC-RecommendedApps__DashboardV3.V4 .item img,\n.BC-RecommendedApps__DashboardV3.V4 .item .title {\n  cursor: pointer;\n}\n\n.BC-RecommendedApps__DashboardV3.V4 .item .description {\n  font-weight: 400;\n  font-size: 14px;\n  color: #6d7175;\n  width: 100%;\n}\n\n@keyframes collapsing {\n  0% {\n    height: 100px;\n    opacity: 1;\n    margin-top: 20px;\n  }\n\n  100% {\n    height: 0;\n    opacity: 0;\n    margin-top: 0;\n  }\n}\n\n.GuideV2Item {\n  border-radius: 8px;\n  border: 1px solid #e1e3e5;\n  position: relative;\n}\n\n.GuideV2Item .GuideV2Item__Close {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  background: white;\n  z-index: 9;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.GuideV2Item .GuideV2Item__Close:hover {\n  background-color: #f6f6f7;\n}\n\n.GuideV2Item .GuideV2Item__Activator {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  gap: 10px;\n  justify-content: space-between;\n  border-radius: 8px;\n}\n\n.GuideV2Item .GuideV2Item__Activator:hover {\n  background-color: #f6f6f7;\n  cursor: pointer;\n}\n\n.GuideV2Item .GuideV2Item__Activator .icon {\n  width: 20px;\n}\n\n.GuideV2Item .GuideV2Item__Activator .title {\n  flex-grow: 1;\n  font-weight: normal;\n  font-size: 16px;\n}\n\n.GuideV2Item .GuideV2Item__Activator .complete {\n  width: 100px;\n}\n\n.GuideV2Item .GuideV2Item__Activator .collapse {\n  width: 20px;\n}\n\n.GuideV2Item .GuideV2Item__Container {\n  padding: 15px;\n  padding-top: 2px;\n  padding-left: 30px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.GuideV2Item .GuideV2Item__Advanced {\n  border-top: 1px solid #e1e3e5;\n  padding-top: 15px;\n  margin-top: 15px;\n}\n\n.GuideV2Item .GuideV2Item__Advanced .GuideV2Item__Advanced--Screen {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.GuideV2Item .GuideV2Item__Advanced .GuideV2Item__Advanced--Screen .title {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  font-weight: bold;\n}\n\n.GuideV2Item .GuideV2Item__Advanced .GuideV2Item__Advanced--Screen .action {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.GuideV2Item .GuideV2Item__Advanced .GuideV2Item__Advanced--Screen .action .Polaris-Button {\n  color: #008060;\n  border: 1px solid #98c6cd;\n}\n\n.GuideV2Item .GuideV2Item__Survey {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.GuideV2Item .GuideV2Item__Survey .item {\n  padding-left: 10px;\n}\n\n.GuideV2Item .GuideV2Item__Survey .item.action {\n  padding-left: 10px;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.GuideV2Item .GuideV2Item__Survey .item.action span {\n  cursor: pointer;\n}\n\n.GuideV2ItemStep {\n  border-radius: 8px;\n}\n\n.GuideV2ItemStep:not(:has(.Polaris-Collapsible--isFullyClosed)) {\n  background-color: #f1f2f3;\n}\n\n.GuideV2ItemStep .GuideV2ItemStep__Activator {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 5px 10px;\n  border-radius: 8px;\n}\n\n.GuideV2ItemStep:not(:has(.Polaris-Collapsible--isFullyClosed)) .GuideV2ItemStep__Activator .title {\n  font-weight: bold;\n}\n\n.GuideV2ItemStep .GuideV2ItemStep__Activator:not(.title-preview):hover {\n  background-color: #f6f6f7;\n  cursor: pointer;\n}\n\n.GuideV2ItemStep .GuideV2ItemStep__Activator.title-preview {\n  padding-top: 10px;\n}\n\n.GuideV2ItemStep .GuideV2ItemStep__Container {\n  padding-left: 40px;\n}\n\n.GuideV2ItemStep .GuideV2ItemStep__Container .container {\n  padding: 5px 10px 10px 0;\n}\n\n.GuideV2ItemStep .GuideV2ItemStep__Container .container .container__flex {\n  display: flex;\n  justify-content: space-between;\n}\n\n@media screen and (max-width: 480px) {\n  .GuideV2ItemStep .GuideV2ItemStep__Container .container .container__flex {\n    flex-direction: column;\n  }\n}\n\n.GuideV2ItemStep .GuideV2ItemStep__Container .container .container__flex .left {\n  gap: 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.GuideV2ItemStep .GuideV2ItemStep__Container .container .container__flex .left .description {\n  color: #6d7175;\n}\n\n.GuideV2ItemStep .GuideV2ItemStep__Container .container .container__flex .left .action {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 40px;\n}\n\n.GuideV2ItemStep .GuideV2ItemStep__Container .container .container__flex .img {\n  margin-top: -8px;\n}\n\n.GuideV2Dismiss {\n  margin-top: 20px;\n  color: #6d7175;\n  cursor: pointer;\n}\n\n.GuideV2Done {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 0 0px 0;\n}\n\n.GuideV2Done .GuideV2Done__text {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* End: New guide on dashboard */\n\n/* Start Region: Test your Search */\n.BC-TestYourSearch-Card {\n  min-height: 594px;\n  width: 77%;\n  padding: 24px 32px 32px 32px;\n  border-radius: 8px;\n  background: var(--Surface-Default, #fff);\n  margin: 24px auto 48px auto;\n}\n\n.BC-TestYourSearch-Card .BC-Page__Title--Help {\n  margin-bottom: unset;\n}\n\n.BC-TestYourSearch-Card .Polaris-DataTable__ScrollContainer {\n  scrollbar-width: thin;\n}\n\n.BC-Page__ProductPerformanceRanking\n  .product-compare\n  .product-list\n  .Polaris-DataTable__ScrollContainer::-webkit-scrollbar,\n.BC-TestYourSearch-Card\n  .product-compare\n  .product-list\n  .Polaris-DataTable__ScrollContainer::-webkit-scrollbar {\n  width: 4px;\n  max-width: 4px;\n}\n\n.BC-TestYourSearch-Card > div:not(:first-child) {\n  margin-top: 24px;\n}\n\n.BC-TestYourSearch-Card .text-field-query {\n  display: grid;\n  gap: 8px;\n}\n\n.BC-TestYourSearch-Card .text-field-query .Polaris-Connected input {\n  font-size: 15px;\n}\n\n.BC-TestYourSearch-Card .text-field-query > div:first-child {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.BC-TestYourSearch-Card .text-field-query .Polaris-TextStyle--variationStrong {\n  font-weight: 700;\n}\n\n.BC-TestYourSearch-Card .text-field-query > div:first-child p {\n  font-size: 15px;\n}\n\n.BC-TestYourSearch-Card .text-field-query .query-fields {\n  display: flex;\n  gap: 12px;\n}\n\n.BC-TestYourSearch-Card .text-field-query .query-fields > div:last-child {\n  width: 25%;\n  min-width: 200px;\n}\n\n.BC-TestYourSearch-Card .text-field-query .query-fields > div:first-child {\n  width: 100%;\n}\n\n.BC-TestYourSearch-Card .text-field-query .query-fields .Polaris-Button__Text,\n.BC-TestYourSearch-Card .text-field-query .query-fields .Polaris-Button__Content,\n.BC-TestYourSearch-Card .text-field-query .query-fields .Polaris-Button {\n  width: 100%;\n}\n\n.BC-TestYourSearch-Card .text-field-query .query-fields .Polaris-Button .Polaris-Icon {\n  margin: 0;\n}\n\n.TestYourSearch_Table {\n  border-radius: 8px;\n  border: 1px solid var(--Border-Divider, #e1e3e5);\n  background: var(--Surface-Default, #fff);\n}\n\n.BC-TestYourSearch-Card .test-your-search-divider {\n  background: #e1e3e5;\n  height: 1px;\n  width: 100%;\n}\n\n.BC-TestYourSearch-Card .product-preview .header-product-preview {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.BC-TestYourSearch-Card .product-preview .pagination .icon {\n  border: 1px solid #c9cccf;\n  border-radius: 6px;\n  width: 24px;\n  height: 24px;\n  padding: 4px;\n}\n\n.BC-TestYourSearch-Card .product-preview .pagination .icon:not(:last-child) {\n  margin-right: 6px;\n}\n\n.BC-TestYourSearch-Card .product-preview .pagination .disabled {\n  background-color: #edeeef;\n  opacity: 0.5;\n}\n\n.BC-TestYourSearch-Card .product-preview .pagination .item {\n  min-width: 24px;\n  padding: 2px;\n  text-align: center;\n  border: 1px solid #c9cccf;\n  border-radius: 6px;\n  margin-right: 6px;\n  font-weight: 400;\n  font-size: 0.875rem;\n  height: 24px;\n}\n\n.BC-TestYourSearch-Card .product-preview .pagination .selected {\n  background-color: #202123;\n  color: #fff;\n}\n\n.BC-TestYourSearch-Card .product-preview .pagination .link {\n  cursor: pointer;\n}\n\n.BC-TestYourSearch-Card .product-preview .pagination .point {\n  border: none;\n}\n\n.BC-TestYourSearch-Card .product-preview .content {\n  font-size: 1.25rem;\n  padding-top: 1.25rem;\n}\n\n.BC-TestYourSearch-Card .product-preview .productList .productRow {\n  display: inline-flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.BC-TestYourSearch-Card .product-preview .productList .productItem {\n  position: relative !important;\n}\n\n.BC-TestYourSearch-Card .product-preview .productList .productItem {\n  min-width: 100px;\n  max-width: 130px;\n}\n\n.BC-TestYourSearch-Card .product-preview .productList .bannerItem {\n  min-width: 130px;\n}\n\n.BC-TestYourSearch-Card .product-preview .productList .bannerItem .Polaris-Thumbnail {\n  width: 100%;\n  height: 100%;\n  border: unset;\n}\n\n.BC-TestYourSearch-Card .product-preview .productList .bannerItem:hover {\n  cursor: pointer;\n}\n\n.BC-TestYourSearch-Card .product-preview .productList .bannerItem .Polaris-Thumbnail img {\n  margin: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.BC-TestYourSearch-Card .product-preview .productList .productRow:not(:last-child) .productItem {\n  margin-bottom: 24px;\n}\n\n.BC-TestYourSearch-Card .product-preview .productList .productItem .noImage {\n  width: 100%;\n}\n\n.BC-TestYourSearch-Card .product-preview .productList .productItem .image {\n  width: auto;\n  height: auto;\n  max-height: 188px;\n  max-width: 100%;\n}\n\n.BC-TestYourSearch-Card .product-preview .productList .productItem .title {\n  font-size: 14px;\n  line-height: 20px;\n  height: 45px;\n  margin: 8px 0px;\n  display: inline-block;\n  -webkit-line-clamp: 2;\n  display: -webkit-box;\n  line-height: 1.65;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.BC-TestYourSearch-Card .product-preview .productList .productItem .priceMin {\n  color: #d72c0d;\n}\n\n.BC-TestYourSearch-Card .product-preview .productList .productItem .comparedAtPrice {\n  color: #8c9196;\n  text-decoration: line-through;\n}\n\n.BC-TestYourSearch-Card .product-preview .productRow .productItem .product-image .mask-view > span {\n  position: absolute;\n  bottom: 40%;\n  right: 0;\n  left: 0;\n  text-align: center;\n}\n\n.BC-TestYourSearch-Card .product-preview .productList .productItem .image {\n  width: auto;\n  height: auto;\n  max-height: 193px;\n  max-width: 100%;\n}\n\n.BC-TestYourSearch-Card .product-preview .productList .productItem .priceMin {\n  color: #d72c0d;\n}\n\n.BC-TestYourSearch-Card\n  .product-preview\n  .productRow\n  .productItem\n  .product-image\n  .mask-view\n  .Polaris-Icon {\n  width: 1.5625rem;\n  height: 1.5625rem;\n  fill: #fff;\n}\n\n.BC-Page__TestYourSearch .pagination {\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n\n.BC-TestYourSearch-Card .TestYourSearch_Table .Polaris-DataTable__Cell--header {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 15px;\n  color: #6d7175;\n  padding: 10px 16px;\n}\n\n.BC-TestYourSearch-Card .product-preview .productRow .productItem .product-image--no-image {\n  background-color: #f4f6f8;\n}\n\n.BC-TestYourSearch-Card\n  .TestYourSearch_Table\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image,\n.BC-TestYourSearch-Card .product-preview .productRow .productItem .product-image {\n  position: relative;\n  height: 188px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.BC-TestYourSearch-Card\n  .TestYourSearch_Table\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image\n  a,\n.BC-TestYourSearch-Card .product-preview .productRow .productItem .product-image .mask-view {\n  display: none;\n}\n\n.BC-TestYourSearch-Card\n  .TestYourSearch_Table\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image:hover\n  a,\n.BC-TestYourSearch-Card .product-preview .productRow .productItem .product-image:hover .mask-view {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));\n  cursor: pointer;\n}\n\n.BC-TestYourSearch-Card\n  .TestYourSearch_Table\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image\n  a\n  > span,\n.BC-TestYourSearch-Card .product-preview .productRow .productItem .product-image .mask-view > span {\n  position: absolute;\n  bottom: 40%;\n  right: 0;\n  left: 0;\n  text-align: center;\n}\n\n.BC-TestYourSearch-Card\n  .TestYourSearch_Table\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image\n  a\n  .Polaris-Icon,\n.BC-TestYourSearch-Card\n  .product-preview\n  .productRow\n  .productItem\n  .product-image\n  .mask-view\n  .Polaris-Icon {\n  width: 1.5625rem;\n  height: 1.5625rem;\n}\n\n.BC-TestYourSearch-Card\n  .TestYourSearch_Table\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image\n  a\n  .Polaris-Icon,\n.BC-TestYourSearch-Card\n  .product-preview\n  .productRow\n  .productItem\n  .product-image\n  .mask-view\n  .Polaris-Icon {\n  fill: white;\n}\n\n.BC-TestYourSearch-Card\n  .TestYourSearch_Table\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image\n  a\n  .view-product,\n.BC-TestYourSearch-Card\n  .product-preview\n  .productRow\n  .productItem\n  .product-image\n  .mask-view\n  .view-product {\n  margin-top: 0.5rem;\n  color: white !important;\n  font-weight: 500 !important;\n}\n\n.BC-TestYourSearch-Card .TestYourSearch_Table .Polaris-Product-Tooltip-TooltipOverlay__Content {\n  width: 10.8rem;\n  padding: 1.25rem;\n}\n\n.BC-TestYourSearch-Card\n  .TestYourSearch_Table\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  label {\n  margin-top: 0.5rem;\n  display: block;\n}\n\n.TestYourSearch_Table .consequence-detail {\n  display: flex;\n  gap: 8px;\n}\n\n.TestYourSearch_Table .consequence-detail:not(:first-child) {\n  margin-top: 8px;\n}\n\n.TestYourSearch_Table .consequence-detail .Polaris-Icon {\n  border-radius: 4px;\n  border: 1px solid var(--Border-Subdued, #c9cccf);\n  width: 20px;\n  height: 20px;\n  min-width: 20px;\n  padding: 4px;\n  margin: 0;\n  display: flex;\n}\n\n.TestYourSearch_Table .consequence-detail .Polaris-Icon svg {\n  width: 12px;\n  height: 12px;\n}\n\n.TestYourSearch_Table .Polaris-DataTable__TableRow td {\n  padding: 10px 16px;\n  white-space: unset;\n}\n\n.TestYourSearch_Table .Polaris-DataTable__TableRow--merchandising td,\n.TestYourSearch_Table .Polaris-DataTable__TableRow--category td {\n  width: 100%;\n  vertical-align: text-top;\n}\n\n.TestYourSearch_Table--close {\n  border: unset;\n}\n\n.TestYourSearch_Table tr td:first-child {\n  width: 15%;\n}\n\n.TestYourSearch_Table .Polaris-DataTable__TableRow td:first-child {\n  width: 15%;\n}\n\n.TestYourSearch_Table .Polaris-DataTable__TableRow td:nth-child(2) {\n  width: 26%;\n}\n\n.TestYourSearch_Table .Polaris-DataTable__TableRow td:nth-child(3) {\n  width: 55%;\n}\n\n.BC-TestYourSearch-Card .product-preview .no-result a,\n.TestYourSearch_Table .Polaris-DataTable__TableRow td a {\n  color: #2c6ecb;\n}\n\n.TestYourSearch_Table .category {\n  display: flex;\n  padding: 2px 8px;\n  align-items: center;\n  gap: 4px;\n  border-radius: 10px;\n  width: fit-content;\n}\n\n.TestYourSearch_Table .category-search {\n  background: #e2f1ea;\n}\n\n.TestYourSearch_Table .category-merchandising {\n  background: #fdf3c8;\n}\n\n.TestYourSearch_Table .description-collapse:hover {\n  cursor: pointer;\n}\n\n.TestYourSearch_Table .description-collapse {\n  text-align: left;\n  width: 100%;\n  padding: 12px 16px !important;\n  background: #ebf9fc;\n  border-top-right-radius: 8px;\n  border-top-left-radius: 8px;\n}\n\n.TestYourSearch_Table .description-close {\n  border: 1px solid var(--Border-Highlight-Subdued, #98c6cd);\n  border-radius: 8px;\n}\n\n.TestYourSearch_Table .description-collapse {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 48px;\n}\n\n.TestYourSearch_Table .description-collapse > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.TestYourSearch_Table .description-collapse .collapse {\n  color: #2c6ecb;\n}\n\n.TestYourSearch_Table .Polaris-DataTable__Cell--action .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n  margin: 0px;\n}\n\n.TestYourSearch_Table .Polaris-Button--plain.Polaris-Button--iconOnly svg {\n  fill: #8c9196;\n}\n\n.TestYourSearch_Table .Polaris-DataTable__Cell--action .Polaris-Button:hover svg {\n  fill: #44474a;\n}\n\n.TestYourSearch_Table tr .search-item {\n  display: flex;\n  gap: 12px;\n}\n\n.TestYourSearch_Table tr .search-item > p:nth-child(2) > p {\n  text-align: center;\n  width: 100%;\n  min-width: 27px;\n}\n\n.TestYourSearch_Table tr .search-item:not(:first-child) {\n  margin-top: 4px;\n}\n\n.TestYourSearch_Table tr .synonyms > p {\n  display: flex;\n  gap: 4px;\n}\n\n.TestYourSearch_Table tr .search-item > p > p {\n  align-items: center;\n  display: flex;\n  height: 24px;\n}\n\n.TestYourSearch_Table tr .search-item > p > p:not(:first-child) {\n  margin-top: 4px;\n}\n\n.TestYourSearch_Table tr .synonyms .synonym-item {\n  border-radius: 4px;\n  background: #f4f6f8;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  /* 133.333% */\n  padding: 4px 8px;\n  color: var(--Text-Subdued, #6d7175);\n}\n\n.TestYourSearch_Table tbody .Polaris-DataTable__TableRow:hover td:not(:first-child) {\n  background-color: #f6f6f7;\n  border-bottom-left-radius: 4px;\n  border-top-left-radius: 4px;\n}\n\n.TestYourSearch_Table tbody .Polaris-DataTable__TableRow--outline td {\n  padding: 6px;\n  border-top: var(--p-border-divider);\n}\n\n.TestYourSearch_Table tbody tr:hover td:not(:first-child) .synonym-item {\n  background: #e0e6eb;\n  color: var(--Text-Subdued, #6d7175);\n}\n\n.TestYourSearch_Table .Polaris-Badge {\n  width: 32px;\n  height: 20px;\n  border-radius: 1000px;\n  background: #ffebd3;\n  padding: 4px 10px;\n}\n\n.TestYourSearch_Table .Polaris-Badge span {\n  height: 12px;\n}\n\n.BC-TestYourSearch-Card .product-compare .product-list {\n  display: flex;\n  margin-top: 16px;\n  margin-right: 16px;\n  justify-content: space-between;\n  gap: 24px;\n}\n\n.BC-Page__ProductPerformanceRanking .product-compare .product-list {\n  display: flex;\n  margin-top: 16px;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.BC-Page__ProductPerformanceRanking .Polaris-Layout,\n.BC-Page__Redirect .Polaris-Layout,\n.BC-Page__SuggestionDictionary .Polaris-Layout {\n  margin-top: 16px;\n}\n\n.BC-Page__ProductPerformanceRanking\n  .product-compare\n  .product-list\n  .Polaris-DataTable__ScrollContainer,\n.BC-TestYourSearch-Card .product-compare .product-list .Polaris-DataTable__ScrollContainer {\n  max-height: 556px;\n}\n\n.BC-Page__ProductPerformanceRanking .product-compare .product-list > div,\n.BC-TestYourSearch-Card .product-compare .product-list > div {\n  width: 50%;\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n}\n\n.BC-Page__ProductPerformanceRanking .product-compare .product-list .header,\n.BC-TestYourSearch-Card .product-compare .product-list .header {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e1e3e5;\n  display: flex;\n  justify-content: space-between;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n.BC-Page__ProductPerformanceRanking .product-compare .product-list .with-ranking .header,\n.BC-TestYourSearch-Card .product-compare .product-list .with-ranking .header {\n  background-color: #fff5ea;\n}\n\n.BC-Page__ProductPerformanceRanking .product-compare .product-list .without-ranking .header,\n.BC-TestYourSearch-Card .product-compare .product-list .without-ranking .header {\n  background-color: #f1f2f3;\n}\n\n.BC-Page__ProductPerformanceRanking .product,\n.BC-TestYourSearch-Card .BC-Component-ProductList .product {\n  padding: 4px 8px;\n}\n\n.BC-Page__ProductPerformanceRanking .product:first-child,\n.BC-TestYourSearch-Card .BC-Component-ProductList .product:first-child {\n  padding: 18px 8px 10px;\n  background-color: unset;\n  cursor: unset;\n  gap: 8px;\n}\n\n.BC-TestYourSearch-Card .BC-Component-ProductList .load-more {\n  padding: 10px;\n  font-size: 16px;\n  margin-bottom: 16px;\n}\n\n.BC-TestYourSearch-Card .header-product-preview > div > span {\n  height: 30px;\n}\n\n.BC-TestYourSearch-Card .header-product-preview .toggle {\n  height: 30px;\n  display: flex;\n  align-items: center;\n}\n\n.BC-TestYourSearch-Card .product-preview {\n  margin-top: 24px !important;\n}\n\n.BC-TestYourSearch-Card .header-product-preview {\n  margin-bottom: 24px;\n}\n\n.BC-TestYourSearch-Card .premium-lock-banner {\n  display: flex;\n  padding: 14px 20px;\n  justify-content: space-between;\n  align-items: center;\n  background: var(--Banner-Background-color-warning-bg, #fffbf3);\n}\n\n.BC-TestYourSearch-Card .premium-lock-banner .detail {\n  display: flex;\n}\n\n.BC-TestYourSearch-Card .premium-lock-banner .detail img {\n  margin-right: 0.5rem;\n}\n\n/* End-Region: Test your Search */\n\n.render-status-block {\n  gap: 6px;\n  display: flex;\n  flex-direction: column;\n}\n\n.render-status-block .b-icon.running img {\n  position: static;\n  animation: rotation 8s infinite linear;\n}\n\n.render-status-block .b-percent {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.render-status-block .b-progress-bar .Polaris-ProgressBar {\n  height: 16px;\n  margin-top: 6px;\n  margin-bottom: 6px;\n}\n\n.render-status-block .b-progress-bar .Polaris-ProgressBar .Polaris-ProgressBar__Label {\n  display: none;\n}\n\n.render-status-block .b-progress-bar .Polaris-ProgressBar .Polaris-ProgressBar__Indicator {\n  background-color: #008060;\n}\n\n.render-status-block\n  .b-progress-bar.wait-retry\n  .Polaris-ProgressBar\n  .Polaris-ProgressBar__Indicator {\n  background-color: #6d7175;\n}\n\n.render-status-block .b-partical {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n}\n\n.Polaris-Tooltip-TooltipOverlay:has(.tooltip-long-sync) {\n  margin-left: 250px;\n}\n\n.Polaris-Tooltip-TooltipOverlay__Content:has(.tooltip-long-sync) {\n  width: 246px !important;\n}\n\n.BC-Sync__Content .Polaris-Badge > span {\n  display: flex;\n  align-items: center;\n}\n\n.BC-Sync__Content .status-icon {\n  width: 8px !important;\n  height: 8px !important;\n  margin-right: 5px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n/* SSR code-editor */\n.disabled-editor {\n  pointer-events: none;\n}\n\n.BC-Page__AccountDetail .account-wrapper .item {\n  display: flex;\n  gap: 20px;\n  padding: 25px 0;\n}\n\n.BC-Page__AppPreferences .app-preferences-list .item {\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.BC-Page__AppPreferences .app-preferences-list .item:last-child {\n  border-bottom: 0;\n}\n\n@media (max-width: 639px) {\n  .BC-Page__AccountDetail .account-wrapper .item {\n    flex-direction: column;\n    padding: 15px;\n  }\n}\n\n.BC-Page__AccountDetail .account-wrapper .item .title {\n  margin-bottom: 15px;\n}\n\n.BC-Page__AccountDetail .account-wrapper .item .title,\n.BC-Page__AccountDetail .account-wrapper .item .default-text-style {\n  font-weight: 600 !important;\n  font-size: 14px;\n}\n\n.BC-Page__AccountDetail .account-wrapper .item .left .description {\n  width: 304px;\n  color: #6d7175;\n}\n\n.BC-Page__AccountDetail .account-wrapper .item .right {\n  flex: 1;\n}\n\n.BC-Page__AccountDetail .account-wrapper .item .right .Polaris-Card {\n  padding: 25px;\n}\n\n.BC-Page__AccountDetail .Polaris-Card .watermark-status {\n  display: flex;\n}\n\n.BC-Page__AccountDetail .watermark-status .Polaris-Badge {\n  background: rgba(255, 242, 217, 1);\n  padding: 2px 4px 2px 4px;\n  border-radius: 4px;\n  color: rgba(255, 51, 69, 1);\n  font-weight: 600;\n  margin-left: 6px;\n}\n\n.BC-Page__AccountDetail .watermark-status .Polaris-Badge > span:last-child {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.BC-Page__AccountDetail .watermark-card .guide {\n  margin-top: 8px;\n  color: rgba(109, 113, 117, 1);\n}\n\n.watermark-status--disabled > div > span:first-child,\n.watermark-status--disabled label {\n  opacity: 0.5 !important;\n}\n\n.BC-Page__AccountDetail .account-wrapper .item .right .item-preferences {\n  gap: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.BC-Page__AccountDetail .account-wrapper .item .right .guide {\n  margin-bottom: 10px;\n}\n\n.BC-Page__AccountDetail .account-wrapper .item .right .guide .Polaris-Link {\n  display: inline-flex;\n}\n\n.BC-Page__AccountDetail .account-wrapper .item .right .guide .Polaris-Icon {\n  width: 1rem;\n  height: 1rem;\n}\n\n.BC-Page__AccountDetail .Polaris-Banner--statusWarning {\n  background: #fff5ea;\n  border-color: #e1b878;\n  padding: 12px 20px;\n  margin-bottom: 16px;\n}\n\n.BC-Page__AccountDetail .Polaris-Banner--statusWarning .Polaris-Banner__Ribbon {\n  display: none;\n}\n\n.BC-Page__AccountDetail .Polaris-Banner--statusWarning .Polaris-Link {\n  color: #2c6ecb !important;\n}\n\n.BC-Page__AccountDetail .warning-back-to-v3 .Polaris-Banner--statusWarning {\n  margin-bottom: 0;\n  margin-top: 16px;\n}\n\n.BC-Page__Integration .third-party-wrapper {\n  margin-top: 16px;\n}\n\n.BC-Page__ThirdPartyIntegration .third-party-wrapper .comming-soon,\n.BC-Page__Integration .third-party-wrapper .comming-soon {\n  display: grid;\n  place-items: center;\n  min-height: 400px;\n}\n\n.BC-Page__ThirdPartyIntegration .third-party-wrapper .comming-soon .content,\n.BC-Page__Integration .third-party-wrapper .comming-soon .content {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  max-width: 512px;\n  gap: 20px;\n  text-align: center;\n}\n\n.BC-Page__ThirdPartyIntegration .third-party-wrapper .comming-soon .content .title,\n.BC-Page__Integration .third-party-wrapper .comming-soon .content .title {\n  font-weight: 600;\n  font-size: 20px;\n}\n\n.BC-Page__ThirdPartyIntegration .third-party-wrapper .comming-soon .content .description,\n.BC-Page__Integration .third-party-wrapper .comming-soon .content .description {\n  font-weight: 400;\n  font-size: 14px;\n}\n\n@media (max-width: 639px) {\n  .BC-Page__ThirdPartyIntegration .third-party-wrapper,\n  .BC-Page__Integration .third-party-wrapper {\n    flex-direction: column;\n    padding: 15px;\n  }\n}\n\n.Polaris-Modal-Dialog:has(.video-upgraded) iframe {\n  border: 0;\n  border-radius: 8px;\n}\n\n.BC-Page__AccountDetail .Polaris-PageActions {\n  border-top: 0;\n}\n\n.BC-Page__AccountDetail .Polaris-InlineError__Icon {\n  display: block;\n}\n\n.Polaris-Button:has(.dont-show-again) {\n  padding-left: 10px;\n}\n\n.Polaris-Modal-Footer:has(.dont-show-again) .Polaris-Stack {\n  justify-content: space-between;\n}\n\n.Polaris-Modal-Footer:has(.dont-show-again) .Polaris-Stack__Item.Polaris-Stack__Item--fill {\n  display: none;\n}\n\n.Polaris-Modal-Footer:has(.dont-show-again) .Polaris-Stack > .Polaris-Stack__Item {\n  margin-left: 0;\n}\n\n.Polaris-Modal-Footer:has(.dont-show-again) .Polaris-Stack .Polaris-Stack__Item {\n  width: 100%;\n}\n\n.Polaris-Modal-Footer:has(.dont-show-again)\n  .Polaris-Stack\n  .Polaris-Stack__Item\n  .Polaris-ButtonGroup__Item:has(.dont-show-again) {\n  flex-grow: 1;\n}\n\n.Polaris-Modal-Footer:has(.dont-show-again)\n  .Polaris-ButtonGroup__Item:has(.dont-show-again)\n  .Polaris-Button {\n  border: 0;\n  background: none;\n  box-shadow: none;\n}\n\n.Polaris-Modal-Footer:has(.dont-show-again)\n  .Polaris-ButtonGroup__Item:has(.dont-show-again)\n  .Polaris-Button:hover {\n  background: none;\n}\n\n.BC-Page__AccountDetail .account-wrapper .item .Polaris-Button {\n  min-width: 150px;\n}\n\n.BC-Page__AccountDetail .account-wrapper .item.turbo-banner {\n  background: #190738;\n  padding: 20px 32px 20px 32px;\n  border-radius: var(--p-border-radius-2);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.BC-Page__AccountDetail .account-wrapper .item.turbo-banner img {\n  max-width: calc(100% - 180px);\n}\n\n@media (max-width: 766px) {\n  .BC-Page__AccountDetail .account-wrapper .item.turbo-banner {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .BC-Page__AccountDetail .account-wrapper .item.turbo-banner img {\n    max-width: 100%;\n  }\n}\n\n.BC-Page__AccountDetail .account-wrapper .item.turbo-banner .Polaris-Button {\n  background: linear-gradient(91.21deg, #c830e1 1.04%, #fe4a25 131.05%);\n  box-shadow: 0px 5.45px 32.71px 0px rgba(235, 69, 38, 0.4);\n  color: rgba(255, 255, 255, 1);\n  font-weight: 500;\n  font-size: 14px;\n  border: 0;\n}\n\n.BC-Page__AccountDetail .account-wrapper .item.turbo-banner .Polaris-Button:hover {\n  background: linear-gradient(91.21deg, #920da7 1.04%, #ce2907 131.05%);\n  box-shadow: 0px 15.23px 91.35px 0px rgba(235, 69, 38, 0.4);\n}\n\n/* SubscriptionV4 */\n.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4,\n.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 {\n  border-radius: 4px;\n  display: grid !important;\n  gap: 0;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-1 {\n  display: flex;\n  justify-content: center;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-2,\n.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4.cols-2 {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-3,\n.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4.cols-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-4,\n.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4.cols-4 {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.BC-Page__SubscriptionV3.V4 .packages div div .Polaris-Card,\n.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 .Polaris-Card {\n  width: unset;\n  border-radius: 0;\n  box-shadow: unset;\n  border: 1px solid #e1e3e5;\n  text-align: left;\n  padding: 32px 12px 20px 12px;\n  min-width: 200px;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages div div .Polaris-Card:last-child,\n.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 .Polaris-Card:last-child {\n  border-right: 1px solid #e1e3e5;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-2 .Polaris-Card,\n.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4.cols-2 .Polaris-Card {\n  padding: 24px 32px 20px 32px;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-3 .Polaris-Card,\n.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4.cols-3 .Polaris-Card {\n  padding: 32px 18px 20px 18px;\n}\n\n.BC-Page__SubscriptionV3 .packages div .Polaris-Card:nth-child(2),\n.BC-Page__SubscriptionV3-Package .packages div .Polaris-Card:nth-child(2) {\n  background: unset;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4 .Polaris-Card:has(.essential),\n.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 .Polaris-Card.package-suggest-card {\n  border: 1.5px solid #008060;\n  background: #f1f8f5;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4 .Polaris-Card:first-child,\n.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 .Polaris-Card:first-child {\n  border-radius: 4px 0 0 4px;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4 .Polaris-Card:last-child,\n.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 .Polaris-Card:last-child {\n  border-radius: 0 4px 4px 0;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4 .Polaris-Card .tag,\n.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 .Polaris-Card .tag {\n  right: 0;\n  left: unset;\n  top: 0;\n  border-radius: 0px 0px 0px 4px;\n  position: absolute;\n  font-weight: 600;\n  font-size: 12;\n  background: #edeeef;\n  padding: 2px 12px 2px 12px;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4 .Polaris-Card:has(.essential) .tag,\n.BC-Page__SubscriptionV3-Package.V4\n  .packages\n  .ListPackageV4\n  .Polaris-Card.package-suggest-card\n  .tag {\n  background: #008060;\n  color: white;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages .ListPackageV4 .Polaris-Card .Polaris-Button,\n.BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 .Polaris-Card .Polaris-Button {\n  width: 100%;\n}\n\n.BC-Page__SubscriptionV3.V4 .permonth,\n.BC-Page__SubscriptionV3-Package.V4 .permonth {\n  font-weight: 600;\n  font-size: 12px;\n  color: #6d7175;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .package-name,\n.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .price,\n.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .select-product,\n.BC-Page__SubscriptionV3-Package.V4 .packages div .Polaris-Card .package-name,\n.BC-Page__SubscriptionV3-Package.V4 .packages div .Polaris-Card .price,\n.BC-Page__SubscriptionV3-Package.V4 .packages div .Polaris-Card .select-product {\n  text-align: left;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .select-product,\n.BC-Page__SubscriptionV3-Package.V4 .packages div .Polaris-Card .select-product {\n  justify-content: flex-start;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .package-action .Polaris-Button,\n.BC-Page__SubscriptionV3-Package.V4 .packages div .Polaris-Card .package-action .Polaris-Button {\n  height: 36px;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages:has(.cols-2) div .Polaris-Card .Polaris-Select,\n.BC-Page__SubscriptionV3-Package.V4 .packages:has(.cols-2) div .Polaris-Card .Polaris-Select {\n  width: 200px;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages:has(.cols-3) div .Polaris-Card .Polaris-Select,\n.BC-Page__SubscriptionV3-Package.V4 .packages:has(.cols-3) div .Polaris-Card .Polaris-Select {\n  width: 165px;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages:has(.cols-4) div .Polaris-Card .Polaris-Select,\n.BC-Page__SubscriptionV3-Package.V4 .packages:has(.cols-4) div .Polaris-Card .Polaris-Select {\n  width: 130px;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .select-product > div {\n  width: unset;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .package-name {\n  height: 35px;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .select-product,\n.BC-Page__SubscriptionV3-Package.V4 .packages div .Polaris-Card .select-product {\n  height: 50px;\n  display: flex;\n  align-items: center;\n}\n\n.BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card .left {\n  padding: 20px 20px 20px 32px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card .left .Polaris-Heading {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card .left .label {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card .left .list-feature {\n  font-weight: 400;\n  font-size: 14px;\n  gap: 6px;\n  display: flex;\n  flex-direction: column;\n}\n\n.BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card .left .list-feature img {\n  margin-right: 10px;\n}\n\n.BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card .right img {\n  width: 540px;\n  height: 330px;\n}\n\n/* Customization service */\n.BC-Page__SubscriptionV3 .SmartStylingBanner .Polaris-Card {\n  display: flex;\n}\n\n.BC-Page__SubscriptionV3 .SmartStylingBanner .Polaris-Card .left img {\n  width: 490px;\n  height: 100%;\n}\n\n.BC-Page__SubscriptionV3 .SmartStylingBanner .Polaris-Card .right {\n  padding: 48px 98px 48px 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 24px;\n}\n\n.BC-Page__SubscriptionV3 .SmartStylingBanner .Polaris-Badge {\n  color: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);\n  background: #ff30001a;\n}\n\n.BC-Page__SubscriptionV3 .SmartStylingBanner .Polaris-Badge > span {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.BC-Page__SubscriptionV3 .SmartStylingBanner .Polaris-Card .Polaris-Heading {\n  font-size: 20px;\n  margin-top: 8px;\n}\n\n.BC-Page__SubscriptionV3 .SmartStylingBanner .action-list .Polaris-Button--plain {\n  padding: 6px;\n  margin-left: 8px;\n}\n\n.BC-Page__SubscriptionV3 .SmartStylingBanner .action-list > p {\n  color: #6d7175;\n  font-style: italic;\n  margin-top: 4px;\n}\n\n.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner {\n  background-image: url('https://cdn.boostcommerce.io/assets/campaigns/turbo-campaign-banner.png');\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  padding: 24px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__title {\n  text-shadow: 0px 5.452px 32.712px rgba(235, 69, 38, 0.4);\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n  margin-bottom: 4px;\n  color: #fff;\n}\n\n.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__desc {\n  color: #fff;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__desc .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__desc .Polaris-Icon__Svg {\n  fill: #fff !important;\n}\n\n.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__code {\n  font-weight: 700;\n  line-height: 150%;\n  background: linear-gradient(91deg, #c830e1 1.04%, #fe4a25 131.05%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__saving {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n  background: linear-gradient(91deg, #c830e1 1.04%, #fe4a25 131.05%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__saving-semibold {\n  font-weight: 600;\n  line-height: 150%;\n  background: linear-gradient(91deg, #c830e1 1.04%, #fe4a25 131.05%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__advanced-features {\n  margin-top: 12px;\n  display: flex;\n  align-items: center;\n}\n\n.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__advanced-features .advanced-features__item {\n  padding-right: 14px;\n  margin-right: 14px;\n  border-right: 1px solid rgba(255, 255, 255, 0.2);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  column-gap: 6px;\n}\n\n.BC-Page__SubscriptionV3\n  .former-upgrade-turbo__banner__advanced-features\n  .advanced-features__item:last-child {\n  padding-right: 0;\n  margin-right: 0;\n  border-right: 0;\n}\n\n.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__actions {\n  display: flex;\n  column-gap: 10px;\n  margin-top: 20px;\n}\n\n.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__actions .Polaris-Button:first-child {\n  background: linear-gradient(91.21deg, #c830e1 1.04%, #fe4a25 131.05%);\n  box-shadow: 0px 5.45px 32.71px 0px #eb452666;\n  border: none;\n}\n\n.BC-Page__SubscriptionV3\n  .former-upgrade-turbo__banner__actions\n  .Polaris-Button:first-child\n  .Polaris-Button__Content {\n  color: #fff;\n  font-weight: 600;\n}\n\n.BC-Page__SubscriptionV3 .former-upgrade-turbo__banner__actions .Polaris-Button:last-child {\n  border: 1px solid #ffffff;\n  box-shadow: 0px 1px 0px 0px #0000000d;\n  background-color: transparent;\n}\n\n.BC-Page__SubscriptionV3\n  .former-upgrade-turbo__banner__actions\n  .Polaris-Button:last-child\n  .Polaris-Button__Content {\n  color: #fff;\n  font-weight: 500;\n}\n\n/* enterprise request modal */\n.pfs-enterprise-request-modal {\n  display: grid;\n  gap: 20px;\n}\n\n.pfs-enterprise-request-modal .row-2,\n.pfs-enterprise-request-modal .checkbox-list {\n  display: flex;\n  width: 100%;\n  gap: 20px;\n}\n\n.pfs-enterprise-request-modal .row-2 > div {\n  width: 100%;\n}\n\n.pfs-enterprise-request-modal .row > p {\n  margin-bottom: 8px;\n}\n\n.pfs-enterprise-request-modal .default-text-style {\n  font-weight: 400 !important;\n}\n\n.Polaris-Modal-Dialog__Modal:has(.pfs-enterprise-request-modal) {\n  max-width: 672px;\n}\n\n/* end - enterprise request modal */\n\n.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Card {\n  padding: 16px 20px 16px 20px;\n}\n\n.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Card .header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Card .slide {\n  padding-bottom: 40px;\n}\n\n.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Card .slide .carousel-item {\n  width: calc(50% - 10px);\n  padding: 20px;\n  border-radius: 8px;\n  background: #fafbfb;\n}\n\n.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Card .slide .carousel-item .name {\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Card .slide .carousel-item .date {\n  font-weight: 400;\n  font-size: 14px;\n  color: #6d7175;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Card .slide .carousel-item .content {\n  font-weight: 400;\n  font-size: 14px;\n  color: #292929;\n}\n\n.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Card .slide .carousel-item .head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.BC-Page__SubscriptionV3.V4 .PlanV4 {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-Page__SubscriptionV3-Package.V4 .packages span,\n.BC-Page__SubscriptionV3.V4 .ReviewBlock .Polaris-Link,\n.BC-Page__SubscriptionV3.V4 .PlanV4 .Polaris-Link {\n  text-decoration: none;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages > div {\n  min-height: unset;\n}\n\n.BC-Page__SubscriptionV3.V4 .packages div .Polaris-Card .advances-package .advance-line,\n.BC-Page__SubscriptionV3-Package.V4 .packages div .Polaris-Card .advances-package .advance-line {\n  gap: 4px;\n}\n\n.BC-Page__SubscriptionV3-Package.V4 .planStatus .Polaris-Card {\n  box-shadow: none;\n  border: 1px solid #dfe3e8;\n}\n\n@media (max-width: 639px) {\n  .BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-2,\n  .BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4.cols-2 {\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  .BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-3,\n  .BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4.cols-3 {\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  .BC-Page__SubscriptionV3.V4 .packages .ListPackageV4.cols-4,\n  .BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4.cols-4 {\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  .BC-Page__SubscriptionV3.V4 .packages div div .Polaris-Card,\n  .BC-Page__SubscriptionV3-Package.V4 .packages .ListPackageV4 .Polaris-Card {\n    border: 1px solid #e1e3e5;\n    border-radius: 0 !important;\n    min-height: unset !important;\n    padding: 20px 32px;\n  }\n}\n\n.Polaris-Modal-Dialog__Modal:has(.DowngradeInfoModal) {\n  max-width: 680px;\n}\n\n.Polaris-Modal-Dialog__Modal:has(.DowngradeInfoModal) .Polaris-Modal-Header {\n  border-bottom: 0;\n  padding-bottom: 0;\n}\n\n.DowngradeInfoModal {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.DowngradeInfoModal .block {\n  flex: 1;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.DowngradeInfoModal .block .header {\n  padding: 8px 20px 8px 20px;\n}\n\n.DowngradeInfoModal .block.left {\n  border: 1.5px solid #008060;\n}\n\n.DowngradeInfoModal .block.left .header {\n  background: #008060;\n  color: white;\n}\n\n.DowngradeInfoModal .block.right {\n  border: 1.5px solid #e1e3e5;\n}\n\n.DowngradeInfoModal .block.right .header {\n  background: #e1e3e5;\n}\n\n.DowngradeInfoModal .block .content {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  flex: 1;\n  padding: 20px;\n}\n\n.DowngradeInfoModal .block .title {\n  font-weight: 600;\n  font-size: 28px;\n}\n\n.DowngradeInfoModal .block .features,\n.DowngradeInfoModal .block .feature,\n.DowngradeInfoModal .block .feature .item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.DowngradeInfoModal .block .feature .item > div {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.DowngradeInfoModal .block .feature p {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n@media (max-width: 639px) {\n  .BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card {\n    flex-direction: column;\n  }\n\n  .BC-Page__SubscriptionV3.V4 .EnterpriseBlock .Polaris-Card .right img {\n    width: 100%;\n    height: auto;\n  }\n}\n\n/* END: SubscriptionV4 */\n\n/* Suspense Fallback UI */\n.BC-Fallback {\n  height: 800px;\n}\n\n.BC-Fallback__Header {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 40px;\n  padding-bottom: 20px;\n}\n\n.BC-Fallback__Header .Polaris-SkeletonDisplayText__DisplayText:first-child {\n  width: 200px;\n  max-width: 200px;\n}\n\n.BC-Fallback__Header .Polaris-SkeletonDisplayText__DisplayText:last-child {\n  width: 120px;\n}\n\n/* END: Suspense Fallback UI */\n\n/* For some waiting page loading: Charge/Finalize */\n.BC-AppLoadingPage {\n  margin-top: 25%;\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.BC-AppLoadingPage--fullScreen {\n  margin-top: 0;\n  height: 100vh;\n  justify-content: center;\n}\n\n.BC-AppLoadingPage .Polaris-Heading {\n  margin-top: 12px;\n  font-size: 28px;\n}\n\n.BC-AppLoadingPage > p {\n  color: #6d7175;\n}\n\n/* ===== Pricing Update – Post-Charge (isExtraFeeCharged) UI ===== */\n\n/* Scroll anchor for \"Learn why.\" link in the charged banner */\n.BC-PricingUpdate_ScrollAnchor {\n  display: block;\n  position: relative;\n  top: -80px;\n  visibility: hidden;\n  pointer-events: none;\n}\n\n/* Green success banner: match the same spacing as the warning banner */\n.BC-Page__SubscriptionV5 .Polaris-Banner--statusSuccess {\n  padding: 5px 16px;\n  align-items: center;\n  margin-top: 40px;\n}\n\n/* When Upcoming price change column is hidden (isExtraFeeCharged=true),\n   let the Current plan block fill the full card width */\n.BC-SubscriptionV5_BillingInformation--PricingUpdate > div:only-child {\n  width: 100%;\n}\n\n/* END: Pricing Update – Post-Charge */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
